// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"h6n7n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CommentSection", ()=>CommentSection);
var _jsxRuntime = require("react/jsx-runtime");
var _bluesky = require("../../lib/bluesky");
var _reactQuery = require("@tanstack/react-query");
var _comment = require("./Comment");
var _commentCTA = require("./CommentCTA");
var _commentControl = require("./CommentControl");
var _react = require("react");
"use client";
function sortByLikes(p1, p2) {
    return (p2.post.likeCount ?? 0) - (p1.post.likeCount ?? 0);
}
function sortByDate(p1, p2) {
    return (_bluesky.getPostDate(p1.post.record) ?? new Date()).getTime() - (_bluesky.getPostDate(p2.post.record) ?? new Date()).getTime();
}
function CommentSection({ bskyPostId }) {
    const [commentSort, setCommentSort] = (0, _react.useState)("top");
    const uri = _bluesky.buildBlueskyURI({
        postId: bskyPostId,
        identifier: "micahcantor.bsky.social"
    });
    const repliesQuery = (0, _reactQuery.useQuery)({
        queryKey: [
            "replies"
        ],
        queryFn: ()=>_bluesky.getPostReplies(uri)
    });
    const Container = ({ children })=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-row items-center justify-between pb-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            id: "comments",
                            className: "text-xl font-semibold",
                            children: "Comments"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commentControl.CommentControl), {
                            sort: commentSort,
                            onSortChange: setCommentSort
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commentCTA.CommentCTA), {
                            bskyPostId: bskyPostId
                        }),
                        children
                    ]
                })
            ]
        });
    };
    if (repliesQuery.isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Container, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-4 h-4 border-2 border-slate-300 dark:border-slate-600 border-t-slate-500 dark:border-t-slate-400 rounded-full animate-spin"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: "Loading comments..."
                })
            ]
        })
    });
    if (repliesQuery.error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Container, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
            className: "text-sm text-red-500",
            children: [
                "Error: ",
                repliesQuery.error.message
            ]
        })
    });
    if (!repliesQuery.data || repliesQuery.data.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Container, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "text-slate-700 dark:text-slate-300",
            children: "No comments yet."
        })
    });
    const sortedReplies = [
        ...repliesQuery.data
    ].sort((p1, p2)=>{
        if (commentSort === "top") return sortByLikes(p1, p2);
        else if (commentSort === "newest") return sortByDate(p2, p1);
        else return sortByDate(p1, p2);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Container, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "flex flex-col gap-4",
            children: sortedReplies.map((reply)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comment.Comment), {
                    comment: reply,
                    depth: 0
                }, reply.post.uri))
        })
    });
}

},{"react/jsx-runtime":"fjRB4","../../lib/bluesky":"kP1JS","@tanstack/react-query":"6wNSF","./Comment":"1W5BW","./CommentCTA":"1WlVG","./CommentControl":"gArlo","react":"4i8qR","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"kP1JS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildBlueskyURI", ()=>buildBlueskyURI);
parcelHelpers.export(exports, "getPostData", ()=>getPostData);
parcelHelpers.export(exports, "getPostReplies", ()=>getPostReplies);
parcelHelpers.export(exports, "getPostRecord", ()=>getPostRecord);
parcelHelpers.export(exports, "getPostText", ()=>getPostText);
parcelHelpers.export(exports, "getPostDate", ()=>getPostDate);
var _api = require("@bluesky-social/api");
function buildBlueskyURI({ postId, identifier }) {
    return `at://${identifier}/app.bsky.feed.post/${postId}`;
}
const agent = new (0, _api.Agent)({
    service: "https://public.api.bsky.app"
});
async function getPostData(uri) {
    const response = await agent.getPostThread({
        uri
    });
    if (!response.success) throw new Error("Failed to get post thread");
    if (!(0, _api.AppBskyFeedDefs).isThreadViewPost(response.data.thread)) throw new Error("Post is not a thread");
    return response.data;
}
async function getPostReplies(uri) {
    const { thread, threadgate } = await getPostData(uri);
    const hiddenReplies = new Set(threadgate?.record?.hiddenReplies ?? []);
    const replies = (thread.replies ?? []).filter((reply)=>{
        return (0, _api.AppBskyFeedDefs).isThreadViewPost(reply) && !hiddenReplies.has(reply.post.uri);
    });
    return replies;
}
function getPostRecord(record) {
    if ((0, _api.AppBskyFeedPost).isRecord(record)) return record;
}
function getPostText(record) {
    const postRecord = getPostRecord(record);
    return postRecord?.text ?? "";
}
function getPostDate(record) {
    const postRecord = getPostRecord(record);
    if (postRecord) return new Date(postRecord.createdAt);
}

},{"@bluesky-social/api":"4a5dq","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"4a5dq":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.lexicons = exports.default = exports.BskyAgent = exports.CredentialSession = exports.AtpAgent = exports.Agent = exports.LABELS = exports.DEFAULT_LABEL_SETTINGS = exports.asPredicate = exports.schemas = exports.parseLanguage = exports.stringifyLex = exports.lexToJson = exports.jsonToLex = exports.jsonStringToLex = exports.BlobRef = exports.AtUri = void 0;
const lexicon_1 = require("4b5404bd27436458");
const lexicons_1 = require("e9050dd1b12af565");
var syntax_1 = require("d8062e6f6aaa97ac");
Object.defineProperty(exports, "AtUri", {
    enumerable: true,
    get: function() {
        return syntax_1.AtUri;
    }
});
var lexicon_2 = require("4b5404bd27436458");
Object.defineProperty(exports, "BlobRef", {
    enumerable: true,
    get: function() {
        return lexicon_2.BlobRef;
    }
});
Object.defineProperty(exports, "jsonStringToLex", {
    enumerable: true,
    get: function() {
        return lexicon_2.jsonStringToLex;
    }
});
Object.defineProperty(exports, "jsonToLex", {
    enumerable: true,
    get: function() {
        return lexicon_2.jsonToLex;
    }
});
Object.defineProperty(exports, "lexToJson", {
    enumerable: true,
    get: function() {
        return lexicon_2.lexToJson;
    }
});
Object.defineProperty(exports, "stringifyLex", {
    enumerable: true,
    get: function() {
        return lexicon_2.stringifyLex;
    }
});
var common_web_1 = require("3d0ff0558556014b");
Object.defineProperty(exports, "parseLanguage", {
    enumerable: true,
    get: function() {
        return common_web_1.parseLanguage;
    }
});
__exportStar(require("a28537bea46406f9"), exports);
__exportStar(require("a8204f5bda325d33"), exports);
__exportStar(require("3b2fa2cd50d1fa73"), exports);
__exportStar(require("e91016dc2e1cf810"), exports);
var lexicons_2 = require("e9050dd1b12af565");
Object.defineProperty(exports, "schemas", {
    enumerable: true,
    get: function() {
        return lexicons_2.schemas;
    }
});
var util_1 = require("b3aa4cb171da0808");
Object.defineProperty(exports, "asPredicate", {
    enumerable: true,
    get: function() {
        return util_1.asPredicate;
    }
});
__exportStar(require("60558066e93e296d"), exports);
__exportStar(require("917c097c0c96f21b"), exports);
__exportStar(require("419e2df15b212785"), exports);
__exportStar(require("96c65887afcfef47"), exports);
__exportStar(require("9c68163ca53000ed"), exports);
__exportStar(require("c1534c6defdab52d"), exports);
__exportStar(require("b39a294f265fb04f"), exports);
var labels_1 = require("936ff95c3bad45e6");
Object.defineProperty(exports, "DEFAULT_LABEL_SETTINGS", {
    enumerable: true,
    get: function() {
        return labels_1.DEFAULT_LABEL_SETTINGS;
    }
});
Object.defineProperty(exports, "LABELS", {
    enumerable: true,
    get: function() {
        return labels_1.LABELS;
    }
});
var agent_1 = require("23717e342e69808");
Object.defineProperty(exports, "Agent", {
    enumerable: true,
    get: function() {
        return agent_1.Agent;
    }
});
var atp_agent_1 = require("ad191f8b216f6859");
Object.defineProperty(exports, "AtpAgent", {
    enumerable: true,
    get: function() {
        return atp_agent_1.AtpAgent;
    }
});
var atp_agent_2 = require("ad191f8b216f6859");
Object.defineProperty(exports, "CredentialSession", {
    enumerable: true,
    get: function() {
        return atp_agent_2.CredentialSession;
    }
});
var bsky_agent_1 = require("40bdd739bf7c63e2");
Object.defineProperty(exports, "BskyAgent", {
    enumerable: true,
    get: function() {
        return bsky_agent_1.BskyAgent;
    }
});
var atp_agent_3 = require("ad191f8b216f6859");
/** @deprecated */ Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return atp_agent_3.AtpAgent;
    }
});
// Expose a copy to prevent alteration of the internal Lexicon instance used by
// the AtpBaseClient class.
exports.lexicons = new lexicon_1.Lexicons(lexicons_1.lexicons);

},{"4b5404bd27436458":"aBnF9","e9050dd1b12af565":"4ClhN","d8062e6f6aaa97ac":"dBffO","3d0ff0558556014b":"jDe1t","a28537bea46406f9":"cODXL","a8204f5bda325d33":"8d2D9","3b2fa2cd50d1fa73":"eeUEr","e91016dc2e1cf810":"a8Anh","b3aa4cb171da0808":"45ZSh","60558066e93e296d":"8Pawe","917c097c0c96f21b":"6BAaP","419e2df15b212785":"i9wVR","96c65887afcfef47":"8ZpS2","9c68163ca53000ed":"4z6F1","c1534c6defdab52d":"9DYVM","b39a294f265fb04f":"1Zxkt","936ff95c3bad45e6":"8B59F","23717e342e69808":"fw3SJ","ad191f8b216f6859":"aIvB3","40bdd739bf7c63e2":"9wJoT"}],"aBnF9":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("8f03905c4247ae89"), exports);
__exportStar(require("1e1216ce13a193b6"), exports);
__exportStar(require("98f0ef8a9fc9c248"), exports);
__exportStar(require("a204ece2c5c1437e"), exports);

},{"8f03905c4247ae89":"gxvCL","1e1216ce13a193b6":"8VTD8","98f0ef8a9fc9c248":"1Sm2X","a204ece2c5c1437e":"hkNaH"}],"gxvCL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LexiconDefNotFoundError = exports.InvalidLexiconError = exports.ValidationError = exports.lexiconDoc = exports.lexUserType = exports.lexRecord = exports.lexXrpcSubscription = exports.lexXrpcProcedure = exports.lexXrpcQuery = exports.lexXrpcError = exports.lexXrpcSubscriptionMessage = exports.lexXrpcBody = exports.lexXrpcParameters = exports.lexPermissionSet = exports.lexObject = exports.lexToken = exports.lexPrimitiveArray = exports.lexArray = exports.lexBlob = exports.lexRefVariant = exports.lexRefUnion = exports.lexRef = exports.lexIpldType = exports.lexCidLink = exports.lexBytes = exports.lexPrimitive = exports.lexUnknown = exports.lexString = exports.lexStringFormat = exports.lexInteger = exports.lexBoolean = exports.lexLang = exports.languageSchema = void 0;
exports.isValidLexiconDoc = isValidLexiconDoc;
exports.isObj = isObj;
exports.isDiscriminatedObject = isDiscriminatedObject;
exports.parseLexiconDoc = parseLexiconDoc;
const zod_1 = require("4a0985ad6b3ca922");
const common_web_1 = require("6b8c5b104530a3c");
const syntax_1 = require("618295b4fe8f8068");
const util_1 = require("550c7e2b081a643");
exports.languageSchema = zod_1.z.string().refine(common_web_1.validateLanguage, 'Invalid BCP47 language tag');
exports.lexLang = zod_1.z.record(exports.languageSchema, zod_1.z.string().optional());
// primitives
// =
exports.lexBoolean = zod_1.z.object({
    type: zod_1.z.literal('boolean'),
    description: zod_1.z.string().optional(),
    default: zod_1.z.boolean().optional(),
    const: zod_1.z.boolean().optional()
});
exports.lexInteger = zod_1.z.object({
    type: zod_1.z.literal('integer'),
    description: zod_1.z.string().optional(),
    default: zod_1.z.number().int().optional(),
    minimum: zod_1.z.number().int().optional(),
    maximum: zod_1.z.number().int().optional(),
    enum: zod_1.z.number().int().array().optional(),
    const: zod_1.z.number().int().optional()
});
exports.lexStringFormat = zod_1.z.enum([
    'datetime',
    'uri',
    'at-uri',
    'did',
    'handle',
    'at-identifier',
    'nsid',
    'cid',
    'language',
    'tid',
    'record-key'
]);
exports.lexString = zod_1.z.object({
    type: zod_1.z.literal('string'),
    format: exports.lexStringFormat.optional(),
    description: zod_1.z.string().optional(),
    default: zod_1.z.string().optional(),
    minLength: zod_1.z.number().int().optional(),
    maxLength: zod_1.z.number().int().optional(),
    minGraphemes: zod_1.z.number().int().optional(),
    maxGraphemes: zod_1.z.number().int().optional(),
    enum: zod_1.z.string().array().optional(),
    const: zod_1.z.string().optional(),
    knownValues: zod_1.z.string().array().optional()
});
exports.lexUnknown = zod_1.z.object({
    type: zod_1.z.literal('unknown'),
    description: zod_1.z.string().optional()
});
exports.lexPrimitive = zod_1.z.discriminatedUnion('type', [
    exports.lexBoolean,
    exports.lexInteger,
    exports.lexString,
    exports.lexUnknown
]);
// ipld types
// =
exports.lexBytes = zod_1.z.object({
    type: zod_1.z.literal('bytes'),
    description: zod_1.z.string().optional(),
    maxLength: zod_1.z.number().optional(),
    minLength: zod_1.z.number().optional()
});
exports.lexCidLink = zod_1.z.object({
    type: zod_1.z.literal('cid-link'),
    description: zod_1.z.string().optional()
});
exports.lexIpldType = zod_1.z.discriminatedUnion('type', [
    exports.lexBytes,
    exports.lexCidLink
]);
// references
// =
exports.lexRef = zod_1.z.object({
    type: zod_1.z.literal('ref'),
    description: zod_1.z.string().optional(),
    ref: zod_1.z.string()
});
exports.lexRefUnion = zod_1.z.object({
    type: zod_1.z.literal('union'),
    description: zod_1.z.string().optional(),
    refs: zod_1.z.string().array(),
    closed: zod_1.z.boolean().optional()
});
exports.lexRefVariant = zod_1.z.discriminatedUnion('type', [
    exports.lexRef,
    exports.lexRefUnion
]);
// blobs
// =
exports.lexBlob = zod_1.z.object({
    type: zod_1.z.literal('blob'),
    description: zod_1.z.string().optional(),
    accept: zod_1.z.string().array().optional(),
    maxSize: zod_1.z.number().optional()
});
// complex types
// =
exports.lexArray = zod_1.z.object({
    type: zod_1.z.literal('array'),
    description: zod_1.z.string().optional(),
    items: zod_1.z.discriminatedUnion('type', [
        // lexPrimitive
        exports.lexBoolean,
        exports.lexInteger,
        exports.lexString,
        exports.lexUnknown,
        // lexIpldType
        exports.lexBytes,
        exports.lexCidLink,
        // lexRefVariant
        exports.lexRef,
        exports.lexRefUnion,
        // other
        exports.lexBlob
    ]),
    minLength: zod_1.z.number().int().optional(),
    maxLength: zod_1.z.number().int().optional()
});
exports.lexPrimitiveArray = exports.lexArray.merge(zod_1.z.object({
    items: exports.lexPrimitive
}));
exports.lexToken = zod_1.z.object({
    type: zod_1.z.literal('token'),
    description: zod_1.z.string().optional()
});
exports.lexObject = zod_1.z.object({
    type: zod_1.z.literal('object'),
    description: zod_1.z.string().optional(),
    required: zod_1.z.string().array().optional(),
    nullable: zod_1.z.string().array().optional(),
    properties: zod_1.z.record(zod_1.z.string(), zod_1.z.discriminatedUnion('type', [
        exports.lexArray,
        // lexPrimitive
        exports.lexBoolean,
        exports.lexInteger,
        exports.lexString,
        exports.lexUnknown,
        // lexIpldType
        exports.lexBytes,
        exports.lexCidLink,
        // lexRefVariant
        exports.lexRef,
        exports.lexRefUnion,
        // other
        exports.lexBlob
    ]))
}).superRefine(util_1.requiredPropertiesRefinement);
// permissions
// =
const lexPermission = zod_1.z.intersection(zod_1.z.object({
    type: zod_1.z.literal('permission'),
    resource: zod_1.z.string().nonempty()
}), zod_1.z.record(zod_1.z.string(), zod_1.z.union([
    zod_1.z.array(zod_1.z.union([
        zod_1.z.string(),
        zod_1.z.number().int(),
        zod_1.z.boolean()
    ])),
    zod_1.z.boolean(),
    zod_1.z.number().int(),
    zod_1.z.string()
]).optional()));
exports.lexPermissionSet = zod_1.z.object({
    type: zod_1.z.literal('permission-set'),
    description: zod_1.z.string().optional(),
    title: zod_1.z.string().optional(),
    'title:lang': exports.lexLang.optional(),
    detail: zod_1.z.string().optional(),
    'detail:lang': exports.lexLang.optional(),
    permissions: zod_1.z.array(lexPermission)
});
// xrpc
// =
exports.lexXrpcParameters = zod_1.z.object({
    type: zod_1.z.literal('params'),
    description: zod_1.z.string().optional(),
    required: zod_1.z.string().array().optional(),
    properties: zod_1.z.record(zod_1.z.string(), zod_1.z.discriminatedUnion('type', [
        exports.lexPrimitiveArray,
        // lexPrimitive
        exports.lexBoolean,
        exports.lexInteger,
        exports.lexString,
        exports.lexUnknown
    ]))
}).superRefine(util_1.requiredPropertiesRefinement);
exports.lexXrpcBody = zod_1.z.object({
    description: zod_1.z.string().optional(),
    encoding: zod_1.z.string(),
    // @NOTE using discriminatedUnion with a refined schema requires zod >= 4
    schema: zod_1.z.union([
        exports.lexRefVariant,
        exports.lexObject
    ]).optional()
});
exports.lexXrpcSubscriptionMessage = zod_1.z.object({
    description: zod_1.z.string().optional(),
    // @NOTE using discriminatedUnion with a refined schema requires zod >= 4
    schema: zod_1.z.union([
        exports.lexRefVariant,
        exports.lexObject
    ]).optional()
});
exports.lexXrpcError = zod_1.z.object({
    name: zod_1.z.string(),
    description: zod_1.z.string().optional()
});
exports.lexXrpcQuery = zod_1.z.object({
    type: zod_1.z.literal('query'),
    description: zod_1.z.string().optional(),
    parameters: exports.lexXrpcParameters.optional(),
    output: exports.lexXrpcBody.optional(),
    errors: exports.lexXrpcError.array().optional()
});
exports.lexXrpcProcedure = zod_1.z.object({
    type: zod_1.z.literal('procedure'),
    description: zod_1.z.string().optional(),
    parameters: exports.lexXrpcParameters.optional(),
    input: exports.lexXrpcBody.optional(),
    output: exports.lexXrpcBody.optional(),
    errors: exports.lexXrpcError.array().optional()
});
exports.lexXrpcSubscription = zod_1.z.object({
    type: zod_1.z.literal('subscription'),
    description: zod_1.z.string().optional(),
    parameters: exports.lexXrpcParameters.optional(),
    message: exports.lexXrpcSubscriptionMessage.optional(),
    errors: exports.lexXrpcError.array().optional()
});
// database
// =
exports.lexRecord = zod_1.z.object({
    type: zod_1.z.literal('record'),
    description: zod_1.z.string().optional(),
    key: zod_1.z.string().optional(),
    record: exports.lexObject
});
// core
// =
// We need to use `z.custom` here because
// lexXrpcProperty and lexObject are refined
// `z.union` would work, but it's too slow
// see #915 for details
exports.lexUserType = zod_1.z.custom((val)=>{
    if (!val || typeof val !== 'object') return;
    if (val['type'] === undefined) return;
    switch(val['type']){
        case 'record':
            return exports.lexRecord.parse(val);
        case 'permission-set':
            return exports.lexPermissionSet.parse(val);
        case 'query':
            return exports.lexXrpcQuery.parse(val);
        case 'procedure':
            return exports.lexXrpcProcedure.parse(val);
        case 'subscription':
            return exports.lexXrpcSubscription.parse(val);
        case 'blob':
            return exports.lexBlob.parse(val);
        case 'array':
            return exports.lexArray.parse(val);
        case 'token':
            return exports.lexToken.parse(val);
        case 'object':
            return exports.lexObject.parse(val);
        case 'boolean':
            return exports.lexBoolean.parse(val);
        case 'integer':
            return exports.lexInteger.parse(val);
        case 'string':
            return exports.lexString.parse(val);
        case 'bytes':
            return exports.lexBytes.parse(val);
        case 'cid-link':
            return exports.lexCidLink.parse(val);
        case 'unknown':
            return exports.lexUnknown.parse(val);
    }
}, (val)=>{
    if (!val || typeof val !== 'object') return {
        message: 'Must be an object',
        fatal: true
    };
    if (val['type'] === undefined) return {
        message: 'Must have a type',
        fatal: true
    };
    if (typeof val['type'] !== 'string') return {
        message: 'Type property must be a string',
        fatal: true
    };
    return {
        message: `Invalid type: ${val['type']} must be one of: record, query, procedure, subscription, blob, array, token, object, boolean, integer, string, bytes, cid-link, unknown`,
        fatal: true
    };
});
exports.lexiconDoc = zod_1.z.object({
    lexicon: zod_1.z.literal(1),
    id: zod_1.z.string().refine(syntax_1.isValidNsid, {
        message: 'Must be a valid NSID'
    }),
    revision: zod_1.z.number().optional(),
    description: zod_1.z.string().optional(),
    defs: zod_1.z.record(zod_1.z.string(), exports.lexUserType)
}).refine((doc)=>{
    for (const [defId, def] of Object.entries(doc.defs)){
        if (defId !== 'main' && (def.type === 'record' || def.type === 'permission-set' || def.type === 'procedure' || def.type === 'query' || def.type === 'subscription')) return false;
    }
    return true;
}, {
    message: `Records, permission sets, procedures, queries, and subscriptions must be the main definition.`
});
// helpers
// =
function isValidLexiconDoc(v) {
    return exports.lexiconDoc.safeParse(v).success;
}
function isObj(v) {
    return v != null && typeof v === 'object';
}
function isDiscriminatedObject(v) {
    return isObj(v) && '$type' in v && typeof v.$type === 'string';
}
function parseLexiconDoc(v) {
    exports.lexiconDoc.parse(v);
    return v;
}
class ValidationError extends Error {
}
exports.ValidationError = ValidationError;
class InvalidLexiconError extends Error {
}
exports.InvalidLexiconError = InvalidLexiconError;
class LexiconDefNotFoundError extends Error {
}
exports.LexiconDefNotFoundError = LexiconDefNotFoundError;

},{"4a0985ad6b3ca922":"h1sGN","6b8c5b104530a3c":"jDe1t","618295b4fe8f8068":"dBffO","550c7e2b081a643":"50xw2"}],"h1sGN":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.z = void 0;
const z = __importStar(require("1318d7cec7e76b1e"));
exports.z = z;
__exportStar(require("1318d7cec7e76b1e"), exports);
exports.default = z;

},{"1318d7cec7e76b1e":"h3PzZ"}],"h3PzZ":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("9e84c8ba845b29d8"), exports);
__exportStar(require("a07f33053c0f7208"), exports);
__exportStar(require("ab8d72d5ce71dff6"), exports);
__exportStar(require("cdad013a00fbd277"), exports);
__exportStar(require("ebf1d980348c8273"), exports);
__exportStar(require("9d0592daaf422821"), exports);

},{"9e84c8ba845b29d8":"6x8la","a07f33053c0f7208":"b7zBc","ab8d72d5ce71dff6":"iS2Pg","cdad013a00fbd277":"4rU90","ebf1d980348c8273":"cLzQF","9d0592daaf422821":"lqKz3"}],"6x8la":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultErrorMap = void 0;
exports.setErrorMap = setErrorMap;
exports.getErrorMap = getErrorMap;
const en_js_1 = __importDefault(require("79de06205492efd6"));
exports.defaultErrorMap = en_js_1.default;
let overrideErrorMap = en_js_1.default;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

},{"79de06205492efd6":"aIVOz"}],"aIVOz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const ZodError_js_1 = require("b92fca6cb4748f34");
const util_js_1 = require("1b5f358f82e9e94c");
const errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case ZodError_js_1.ZodIssueCode.invalid_type:
            if (issue.received === util_js_1.ZodParsedType.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util_js_1.util.jsonStringifyReplacer)}`;
            break;
        case ZodError_js_1.ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util_js_1.util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util_js_1.util.joinValues(issue.options)}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util_js_1.util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else util_js_1.util.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case ZodError_js_1.ZodIssueCode.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case ZodError_js_1.ZodIssueCode.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case ZodError_js_1.ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodError_js_1.ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodError_js_1.ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util_js_1.util.assertNever(issue);
    }
    return {
        message
    };
};
exports.default = errorMap;

},{"b92fca6cb4748f34":"lqKz3","1b5f358f82e9e94c":"4rU90"}],"lqKz3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ZodError = exports.quotelessJson = exports.ZodIssueCode = void 0;
const util_js_1 = require("94f6c8157e9782bf");
exports.ZodIssueCode = util_js_1.util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const quotelessJson = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
exports.quotelessJson = quotelessJson;
class ZodError extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util_js_1.util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors,
            fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
exports.ZodError = ZodError;
ZodError.create = (issues)=>{
    const error = new ZodError(issues);
    return error;
};

},{"94f6c8157e9782bf":"4rU90"}],"4rU90":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getParsedType = exports.ZodParsedType = exports.objectUtil = exports.util = void 0;
var util;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})(util || (exports.util = util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})(objectUtil || (exports.objectUtil = objectUtil = {}));
exports.ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return exports.ZodParsedType.undefined;
        case "string":
            return exports.ZodParsedType.string;
        case "number":
            return Number.isNaN(data) ? exports.ZodParsedType.nan : exports.ZodParsedType.number;
        case "boolean":
            return exports.ZodParsedType.boolean;
        case "function":
            return exports.ZodParsedType.function;
        case "bigint":
            return exports.ZodParsedType.bigint;
        case "symbol":
            return exports.ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return exports.ZodParsedType.array;
            if (data === null) return exports.ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return exports.ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return exports.ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return exports.ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return exports.ZodParsedType.date;
            return exports.ZodParsedType.object;
        default:
            return exports.ZodParsedType.unknown;
    }
};
exports.getParsedType = getParsedType;

},{}],"b7zBc":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAsync = exports.isValid = exports.isDirty = exports.isAborted = exports.OK = exports.DIRTY = exports.INVALID = exports.ParseStatus = exports.EMPTY_PATH = exports.makeIssue = void 0;
exports.addIssueToContext = addIssueToContext;
const errors_js_1 = require("99a40461662c4d1c");
const en_js_1 = __importDefault(require("50f1681dacc0e561"));
const makeIssue = (params)=>{
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
exports.makeIssue = makeIssue;
exports.EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = (0, errors_js_1.getErrorMap)();
    const issue = (0, exports.makeIssue)({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === en_js_1.default ? undefined : en_js_1.default
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return exports.INVALID;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key, value } = pair;
            if (key.status === "aborted") return exports.INVALID;
            if (value.status === "aborted") return exports.INVALID;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
exports.ParseStatus = ParseStatus;
exports.INVALID = Object.freeze({
    status: "aborted"
});
const DIRTY = (value)=>({
        status: "dirty",
        value
    });
exports.DIRTY = DIRTY;
const OK = (value)=>({
        status: "valid",
        value
    });
exports.OK = OK;
const isAborted = (x)=>x.status === "aborted";
exports.isAborted = isAborted;
const isDirty = (x)=>x.status === "dirty";
exports.isDirty = isDirty;
const isValid = (x)=>x.status === "valid";
exports.isValid = isValid;
const isAsync = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
exports.isAsync = isAsync;

},{"99a40461662c4d1c":"6x8la","50f1681dacc0e561":"aIVOz"}],"iS2Pg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"cLzQF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.discriminatedUnion = exports.date = exports.boolean = exports.bigint = exports.array = exports.any = exports.coerce = exports.ZodFirstPartyTypeKind = exports.late = exports.ZodSchema = exports.Schema = exports.ZodReadonly = exports.ZodPipeline = exports.ZodBranded = exports.BRAND = exports.ZodNaN = exports.ZodCatch = exports.ZodDefault = exports.ZodNullable = exports.ZodOptional = exports.ZodTransformer = exports.ZodEffects = exports.ZodPromise = exports.ZodNativeEnum = exports.ZodEnum = exports.ZodLiteral = exports.ZodLazy = exports.ZodFunction = exports.ZodSet = exports.ZodMap = exports.ZodRecord = exports.ZodTuple = exports.ZodIntersection = exports.ZodDiscriminatedUnion = exports.ZodUnion = exports.ZodObject = exports.ZodArray = exports.ZodVoid = exports.ZodNever = exports.ZodUnknown = exports.ZodAny = exports.ZodNull = exports.ZodUndefined = exports.ZodSymbol = exports.ZodDate = exports.ZodBoolean = exports.ZodBigInt = exports.ZodNumber = exports.ZodString = exports.ZodType = void 0;
exports.NEVER = exports.void = exports.unknown = exports.union = exports.undefined = exports.tuple = exports.transformer = exports.symbol = exports.string = exports.strictObject = exports.set = exports.record = exports.promise = exports.preprocess = exports.pipeline = exports.ostring = exports.optional = exports.onumber = exports.oboolean = exports.object = exports.number = exports.nullable = exports.null = exports.never = exports.nativeEnum = exports.nan = exports.map = exports.literal = exports.lazy = exports.intersection = exports.instanceof = exports.function = exports.enum = exports.effect = void 0;
exports.datetimeRegex = datetimeRegex;
exports.custom = custom;
const ZodError_js_1 = require("9f6fc678def65a8c");
const errors_js_1 = require("f893d560676cd309");
const errorUtil_js_1 = require("aad717275921d7c0");
const parseUtil_js_1 = require("59c310c9b9dce45a");
const util_js_1 = require("d9c8e7e8fe1b40f3");
class ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result)=>{
    if ((0, parseUtil_js_1.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new ZodError_js_1.ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description
    };
    const customMap = (iss, ctx)=>{
        const { message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description
    };
}
class ZodType {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, util_js_1.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, util_js_1.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new parseUtil_js_1.ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, util_js_1.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, parseUtil_js_1.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        const result = this._parseSync({
            data,
            path: ctx.path,
            parent: ctx
        });
        return handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data,
                path: [],
                parent: ctx
            });
            return (0, parseUtil_js_1.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data,
            path: [],
            parent: ctx
        }).then((result)=>(0, parseUtil_js_1.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, parseUtil_js_1.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: ZodError_js_1.ZodIssueCode.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
exports.ZodType = ZodType;
exports.Schema = ZodType;
exports.ZodSchema = ZodType;
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
function isValidJWT(jwt, alg) {
    if (!jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function isValidCidr(ip, version) {
    if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) return true;
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.string,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const status = new parseUtil_js_1.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "email",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    validation: "url",
                    code: ZodError_js_1.ZodIssueCode.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation,
            code: ZodError_js_1.ZodIssueCode.invalid_string,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, errorUtil_js_1.errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
exports.ZodString = ZodString;
ZodString.create = (params)=>{
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class ZodNumber extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.number,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        let ctx = undefined;
        const status = new parseUtil_js_1.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!util_js_1.util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil_js_1.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil_js_1.errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && util_js_1.util.isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
exports.ZodNumber = ZodNumber;
ZodNumber.create = (params)=>{
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodBigInt extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new parseUtil_js_1.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, parseUtil_js_1.addIssueToContext)(ctx, {
            code: ZodError_js_1.ZodIssueCode.invalid_type,
            expected: util_js_1.ZodParsedType.bigint,
            received: ctx.parsedType
        });
        return parseUtil_js_1.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil_js_1.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
exports.ZodBigInt = ZodBigInt;
ZodBigInt.create = (params)=>{
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.boolean,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodBoolean = ZodBoolean;
ZodBoolean.create = (params)=>{
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.date,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_date
            });
            return parseUtil_js_1.INVALID;
        }
        const status = new parseUtil_js_1.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
exports.ZodDate = ZodDate;
ZodDate.create = (params)=>{
    return new ZodDate({
        checks: [],
        coerce: params?.coerce || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params)
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.symbol,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodSymbol = ZodSymbol;
ZodSymbol.create = (params)=>{
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params)
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.undefined,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodUndefined = ZodUndefined;
ZodUndefined.create = (params)=>{
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params)
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.null,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodNull = ZodNull;
ZodNull.create = (params)=>{
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params)
    });
};
class ZodAny extends ZodType {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodAny = ZodAny;
ZodAny.create = (params)=>{
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params)
    });
};
class ZodUnknown extends ZodType {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodUnknown = ZodUnknown;
ZodUnknown.create = (params)=>{
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params)
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, parseUtil_js_1.addIssueToContext)(ctx, {
            code: ZodError_js_1.ZodIssueCode.invalid_type,
            expected: util_js_1.ZodParsedType.never,
            received: ctx.parsedType
        });
        return parseUtil_js_1.INVALID;
    }
}
exports.ZodNever = ZodNever;
ZodNever.create = (params)=>{
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params)
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.void,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodVoid = ZodVoid;
ZodVoid.create = (params)=>{
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params)
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== util_js_1.ZodParsedType.array) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.array,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: tooBig ? ZodError_js_1.ZodIssueCode.too_big : ZodError_js_1.ZodIssueCode.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return parseUtil_js_1.ParseStatus.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return parseUtil_js_1.ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: {
                value: minLength,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: {
                value: len,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
exports.ZodArray = ZodArray;
ZodArray.create = (schema, params)=>{
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params)
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof ZodArray) return new ZodArray({
        ...schema._def,
        type: deepPartialify(schema.element)
    });
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map((item)=>deepPartialify(item)));
    else return schema;
}
class ZodObject extends ZodType {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = util_js_1.util.objectKeys(shape);
        this._cached = {
            shape,
            keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key,
                    value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return parseUtil_js_1.ParseStatus.mergeObjectSync(status, syncPairs);
        });
        else return parseUtil_js_1.ParseStatus.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil_js_1.errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: errorUtil_js_1.errorUtil.errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of util_js_1.util.objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of util_js_1.util.objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of util_js_1.util.objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of util_js_1.util.objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof ZodOptional)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return createZodEnum(util_js_1.util.objectKeys(this.shape));
    }
}
exports.ZodObject = ZodObject;
ZodObject.create = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.strictCreate = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.lazycreate = (shape, params)=>{
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new ZodError_js_1.ZodError(result.ctx.common.issues));
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union,
                unionErrors
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new ZodError_js_1.ZodError(issues));
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union,
                unionErrors
            });
            return parseUtil_js_1.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
exports.ZodUnion = ZodUnion;
ZodUnion.create = (types, params)=>{
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type)=>{
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return util_js_1.util.objectValues(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else if (type instanceof ZodOptional) return [
        undefined,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodNullable) return [
        null,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodBranded) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodReadonly) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodCatch) return getDiscriminator(type._def.innerType);
    else return [];
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.object) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params)
        });
    }
}
exports.ZodDiscriminatedUnion = ZodDiscriminatedUnion;
function mergeValues(a, b) {
    const aType = (0, util_js_1.getParsedType)(a);
    const bType = (0, util_js_1.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === util_js_1.ZodParsedType.object && bType === util_js_1.ZodParsedType.object) {
        const bKeys = util_js_1.util.objectKeys(b);
        const sharedKeys = util_js_1.util.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === util_js_1.ZodParsedType.array && bType === util_js_1.ZodParsedType.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === util_js_1.ZodParsedType.date && bType === util_js_1.ZodParsedType.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, parseUtil_js_1.isAborted)(parsedLeft) || (0, parseUtil_js_1.isAborted)(parsedRight)) return parseUtil_js_1.INVALID;
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.invalid_intersection_types
                });
                return parseUtil_js_1.INVALID;
            }
            if ((0, parseUtil_js_1.isDirty)(parsedLeft) || (0, parseUtil_js_1.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
exports.ZodIntersection = ZodIntersection;
ZodIntersection.create = (left, right, params)=>{
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params)
    });
};
// type ZodTupleItems = [ZodTypeAny, ...ZodTypeAny[]];
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.array) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.array,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return parseUtil_js_1.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return parseUtil_js_1.ParseStatus.mergeArray(status, results);
        });
        else return parseUtil_js_1.ParseStatus.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest
        });
    }
}
exports.ZodTuple = ZodTuple;
ZodTuple.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params)
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.object) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return parseUtil_js_1.ParseStatus.mergeObjectAsync(status, pairs);
        else return parseUtil_js_1.ParseStatus.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) return new ZodRecord({
            keyType: first,
            valueType: second,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(third)
        });
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second)
        });
    }
}
exports.ZodRecord = ZodRecord;
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.map) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.map,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return parseUtil_js_1.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return parseUtil_js_1.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
exports.ZodMap = ZodMap;
ZodMap.create = (keyType, valueType, params)=>{
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params)
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.set) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.set,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return parseUtil_js_1.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: {
                value: minSize,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
exports.ZodSet = ZodSet;
ZodSet.create = (valueType, params)=>{
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params)
    });
};
class ZodFunction extends ZodType {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.function) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.function,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, parseUtil_js_1.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, errors_js_1.getErrorMap)(),
                    errors_js_1.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodError_js_1.ZodIssueCode.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, parseUtil_js_1.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, errors_js_1.getErrorMap)(),
                    errors_js_1.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodError_js_1.ZodIssueCode.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, parseUtil_js_1.OK)(async function(...args) {
                const error = new ZodError_js_1.ZodError([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, parseUtil_js_1.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new ZodError_js_1.ZodError([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new ZodError_js_1.ZodError([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create())
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params)
        });
    }
}
exports.ZodFunction = ZodFunction;
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
exports.ZodLazy = ZodLazy;
ZodLazy.create = (getter, params)=>{
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params)
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_literal,
                expected: this._def.value
            });
            return parseUtil_js_1.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
exports.ZodLiteral = ZodLiteral;
ZodLiteral.create = (value, params)=>{
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params)
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params)
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                expected: util_js_1.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodError_js_1.ZodIssueCode.invalid_type
            });
            return parseUtil_js_1.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
exports.ZodEnum = ZodEnum;
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util_js_1.util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.string && ctx.parsedType !== util_js_1.ZodParsedType.number) {
            const expectedValues = util_js_1.util.objectValues(nativeEnumValues);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                expected: util_js_1.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodError_js_1.ZodIssueCode.invalid_type
            });
            return parseUtil_js_1.INVALID;
        }
        if (!this._cache) this._cache = new Set(util_js_1.util.getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = util_js_1.util.objectValues(nativeEnumValues);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
exports.ZodNativeEnum = ZodNativeEnum;
ZodNativeEnum.create = (values, params)=>{
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params)
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.promise && ctx.common.async === false) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.promise,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const promisified = ctx.parsedType === util_js_1.ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, parseUtil_js_1.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
exports.ZodPromise = ZodPromise;
ZodPromise.create = (schema, params)=>{
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params)
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, parseUtil_js_1.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return parseUtil_js_1.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return parseUtil_js_1.INVALID;
                if (result.status === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                if (status.value === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return parseUtil_js_1.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return parseUtil_js_1.INVALID;
                if (result.status === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                if (status.value === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return parseUtil_js_1.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return parseUtil_js_1.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, parseUtil_js_1.isValid)(base)) return parseUtil_js_1.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, parseUtil_js_1.isValid)(base)) return parseUtil_js_1.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        util_js_1.util.assertNever(effect);
    }
}
exports.ZodEffects = ZodEffects;
exports.ZodTransformer = ZodEffects;
ZodEffects.create = (schema, effect, params)=>{
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params)
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params)=>{
    return new ZodEffects({
        schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params)
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === util_js_1.ZodParsedType.undefined) return (0, parseUtil_js_1.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodOptional = ZodOptional;
ZodOptional.create = (type, params)=>{
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params)
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === util_js_1.ZodParsedType.null) return (0, parseUtil_js_1.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodNullable = ZodNullable;
ZodNullable.create = (type, params)=>{
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params)
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === util_js_1.ZodParsedType.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
exports.ZodDefault = ZodDefault;
ZodDefault.create = (type, params)=>{
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...processCreateParams(params)
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, parseUtil_js_1.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new ZodError_js_1.ZodError(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new ZodError_js_1.ZodError(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
exports.ZodCatch = ZodCatch;
ZodCatch.create = (type, params)=>{
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...processCreateParams(params)
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.nan,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
exports.ZodNaN = ZodNaN;
ZodNaN.create = (params)=>{
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params)
    });
};
exports.BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
exports.ZodBranded = ZodBranded;
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return parseUtil_js_1.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, parseUtil_js_1.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return parseUtil_js_1.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline
        });
    }
}
exports.ZodPipeline = ZodPipeline;
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, parseUtil_js_1.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, parseUtil_js_1.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodReadonly = ZodReadonly;
ZodReadonly.create = (type, params)=>{
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function custom(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return ZodAny.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return ZodAny.create();
}
exports.late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (exports.ZodFirstPartyTypeKind = ZodFirstPartyTypeKind = {}));
// requires TS 4.4+
class Class {
    constructor(..._){}
}
const instanceOfType = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>custom((data)=>data instanceof cls, params);
exports.instanceof = instanceOfType;
const stringType = ZodString.create;
exports.string = stringType;
const numberType = ZodNumber.create;
exports.number = numberType;
const nanType = ZodNaN.create;
exports.nan = nanType;
const bigIntType = ZodBigInt.create;
exports.bigint = bigIntType;
const booleanType = ZodBoolean.create;
exports.boolean = booleanType;
const dateType = ZodDate.create;
exports.date = dateType;
const symbolType = ZodSymbol.create;
exports.symbol = symbolType;
const undefinedType = ZodUndefined.create;
exports.undefined = undefinedType;
const nullType = ZodNull.create;
exports.null = nullType;
const anyType = ZodAny.create;
exports.any = anyType;
const unknownType = ZodUnknown.create;
exports.unknown = unknownType;
const neverType = ZodNever.create;
exports.never = neverType;
const voidType = ZodVoid.create;
exports.void = voidType;
const arrayType = ZodArray.create;
exports.array = arrayType;
const objectType = ZodObject.create;
exports.object = objectType;
const strictObjectType = ZodObject.strictCreate;
exports.strictObject = strictObjectType;
const unionType = ZodUnion.create;
exports.union = unionType;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
exports.discriminatedUnion = discriminatedUnionType;
const intersectionType = ZodIntersection.create;
exports.intersection = intersectionType;
const tupleType = ZodTuple.create;
exports.tuple = tupleType;
const recordType = ZodRecord.create;
exports.record = recordType;
const mapType = ZodMap.create;
exports.map = mapType;
const setType = ZodSet.create;
exports.set = setType;
const functionType = ZodFunction.create;
exports.function = functionType;
const lazyType = ZodLazy.create;
exports.lazy = lazyType;
const literalType = ZodLiteral.create;
exports.literal = literalType;
const enumType = ZodEnum.create;
exports.enum = enumType;
const nativeEnumType = ZodNativeEnum.create;
exports.nativeEnum = nativeEnumType;
const promiseType = ZodPromise.create;
exports.promise = promiseType;
const effectsType = ZodEffects.create;
exports.effect = effectsType;
exports.transformer = effectsType;
const optionalType = ZodOptional.create;
exports.optional = optionalType;
const nullableType = ZodNullable.create;
exports.nullable = nullableType;
const preprocessType = ZodEffects.createWithPreprocess;
exports.preprocess = preprocessType;
const pipelineType = ZodPipeline.create;
exports.pipeline = pipelineType;
const ostring = ()=>stringType().optional();
exports.ostring = ostring;
const onumber = ()=>numberType().optional();
exports.onumber = onumber;
const oboolean = ()=>booleanType().optional();
exports.oboolean = oboolean;
exports.coerce = {
    string: (arg)=>ZodString.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>ZodNumber.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>ZodBoolean.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>ZodBigInt.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>ZodDate.create({
            ...arg,
            coerce: true
        })
};
exports.NEVER = parseUtil_js_1.INVALID;

},{"9f6fc678def65a8c":"lqKz3","f893d560676cd309":"6x8la","aad717275921d7c0":"b7eeT","59c310c9b9dce45a":"b7zBc","d9c8e7e8fe1b40f3":"4rU90"}],"b7eeT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.errorUtil = void 0;
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})(errorUtil || (exports.errorUtil = errorUtil = {}));

},{}],"jDe1t":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
        }
        __setModuleDefault(result, mod);
        return result;
    };
}();
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.util = exports.check = void 0;
exports.check = __importStar(require("70366cdf805dd592"));
exports.util = __importStar(require("6f06ae2f96e924b9"));
__exportStar(require("f6d84f03183005aa"), exports);
__exportStar(require("45e3ee87839b5563"), exports);
__exportStar(require("6f06ae2f96e924b9"), exports);
__exportStar(require("8d71b45e2113da6f"), exports);
__exportStar(require("e189a745b8aef5d2"), exports);
__exportStar(require("55195d410b3f917f"), exports);
__exportStar(require("ed91d54d623a03d7"), exports);
__exportStar(require("d6495e5a75358e4c"), exports);
__exportStar(require("a99937a21b1e9267"), exports);
__exportStar(require("949c688ec491e625"), exports);

},{"70366cdf805dd592":"halIj","6f06ae2f96e924b9":"KdxI6","f6d84f03183005aa":"7bq8Y","45e3ee87839b5563":"5vdbl","8d71b45e2113da6f":"cjKZE","e189a745b8aef5d2":"2rTRk","55195d410b3f917f":"3H2GM","ed91d54d623a03d7":"bamCJ","d6495e5a75358e4c":"47Kxk","a99937a21b1e9267":"hkD7w","949c688ec491e625":"gcs2R"}],"halIj":[function(require,module,exports,__globalThis) {
"use strict";
// Explicitly not using "zod" types here to avoid mismatching types due to
// version differences.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isObject = exports.assure = exports.create = exports.is = void 0;
const is = (obj, def)=>{
    return def.safeParse(obj).success;
};
exports.is = is;
const create = (def)=>(v)=>def.safeParse(v).success;
exports.create = create;
const assure = (def, obj)=>{
    return def.parse(obj);
};
exports.assure = assure;
const isObject = (obj)=>{
    return typeof obj === 'object' && obj !== null;
};
exports.isObject = isObject;

},{}],"KdxI6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseIntWithFallback = exports.dedupeStrs = exports.range = exports.chunkArray = exports.errHasMsg = exports.isErrnoException = exports.asyncFilter = exports.s32decode = exports.s32encode = exports.streamToBuffer = exports.flattenUint8Arrays = exports.bailableWait = exports.wait = exports.jitter = exports.noUndefinedVals = void 0;
exports.aggregateErrors = aggregateErrors;
exports.omit = omit;
const noUndefinedVals = (obj)=>{
    Object.keys(obj).forEach((k)=>{
        if (obj[k] === undefined) delete obj[k];
    });
    return obj;
};
exports.noUndefinedVals = noUndefinedVals;
function aggregateErrors(errors, message) {
    if (errors.length === 1) return errors[0] instanceof Error ? errors[0] : new Error(message ?? stringifyError(errors[0]), {
        cause: errors[0]
    });
    else return new AggregateError(errors, message ?? `Multiple errors: ${errors.map(stringifyError).join('\n')}`);
}
function stringifyError(reason) {
    if (reason instanceof Error) return reason.message;
    return String(reason);
}
function omit(src, rejectedKeys) {
    // Hot path
    if (!src) return src;
    const dst = {};
    const srcKeys = Object.keys(src);
    for(let i = 0; i < srcKeys.length; i++){
        const key = srcKeys[i];
        if (!rejectedKeys.includes(key)) dst[key] = src[key];
    }
    return dst;
}
const jitter = (maxMs)=>{
    return Math.round((Math.random() - 0.5) * maxMs * 2);
};
exports.jitter = jitter;
const wait = (ms)=>{
    return new Promise((res)=>setTimeout(res, ms));
};
exports.wait = wait;
const bailableWait = (ms)=>{
    let bail;
    const waitPromise = new Promise((res)=>{
        const timeout = setTimeout(res, ms);
        bail = ()=>{
            clearTimeout(timeout);
            res();
        };
    });
    return {
        bail,
        wait: ()=>waitPromise
    };
};
exports.bailableWait = bailableWait;
const flattenUint8Arrays = (arrs)=>{
    const length = arrs.reduce((acc, cur)=>{
        return acc + cur.length;
    }, 0);
    const flattened = new Uint8Array(length);
    let offset = 0;
    arrs.forEach((arr)=>{
        flattened.set(arr, offset);
        offset += arr.length;
    });
    return flattened;
};
exports.flattenUint8Arrays = flattenUint8Arrays;
const streamToBuffer = async (stream)=>{
    const arrays = [];
    for await (const chunk of stream)arrays.push(chunk);
    return (0, exports.flattenUint8Arrays)(arrays);
};
exports.streamToBuffer = streamToBuffer;
const S32_CHAR = '234567abcdefghijklmnopqrstuvwxyz';
const s32encode = (i)=>{
    let s = '';
    while(i){
        const c = i % 32;
        i = Math.floor(i / 32);
        s = S32_CHAR.charAt(c) + s;
    }
    return s;
};
exports.s32encode = s32encode;
const s32decode = (s)=>{
    let i = 0;
    for (const c of s)i = i * 32 + S32_CHAR.indexOf(c);
    return i;
};
exports.s32decode = s32decode;
const asyncFilter = async (arr, fn)=>{
    const results = await Promise.all(arr.map((t)=>fn(t)));
    return arr.filter((_, i)=>results[i]);
};
exports.asyncFilter = asyncFilter;
const isErrnoException = (err)=>{
    return !!err && err['code'];
};
exports.isErrnoException = isErrnoException;
const errHasMsg = (err, msg)=>{
    return !!err && typeof err === 'object' && err['message'] === msg;
};
exports.errHasMsg = errHasMsg;
const chunkArray = (arr, chunkSize)=>{
    return arr.reduce((acc, cur, i)=>{
        const chunkI = Math.floor(i / chunkSize);
        if (!acc[chunkI]) acc[chunkI] = [];
        acc[chunkI].push(cur);
        return acc;
    }, []);
};
exports.chunkArray = chunkArray;
const range = (num)=>{
    const nums = [];
    for(let i = 0; i < num; i++)nums.push(i);
    return nums;
};
exports.range = range;
const dedupeStrs = (strs)=>{
    return [
        ...new Set(strs)
    ];
};
exports.dedupeStrs = dedupeStrs;
const parseIntWithFallback = (value, fallback)=>{
    const parsed = parseInt(value || '', 10);
    return isNaN(parsed) ? fallback : parsed;
};
exports.parseIntWithFallback = parseIntWithFallback;

},{}],"7bq8Y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDefined = void 0;
exports.keyBy = keyBy;
function keyBy(arr, key) {
    return arr.reduce((acc, cur)=>{
        acc.set(cur[key], cur);
        return acc;
    }, new Map());
}
const mapDefined = (arr, fn)=>{
    const output = [];
    for (const item of arr){
        const val = fn(item);
        if (val !== undefined) output.push(val);
    }
    return output;
};
exports.mapDefined = mapDefined;

},{}],"5vdbl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AsyncBufferFullError = exports.AsyncBuffer = exports.allComplete = exports.createDeferrables = exports.createDeferrable = exports.readFromGenerator = void 0;
exports.allFulfilled = allFulfilled;
exports.handleAllSettledErrors = handleAllSettledErrors;
exports.isRejectedResult = isRejectedResult;
exports.isFulfilledResult = isFulfilledResult;
const util_1 = require("40753e201aa988f4");
// reads values from a generator into a list
// breaks when isDone signals `true` AND `waitFor` completes OR when a max length is reached
// NOTE: does not signal generator to close. it *will* continue to produce values
const readFromGenerator = async (gen, isDone, waitFor = Promise.resolve(), maxLength = Number.MAX_SAFE_INTEGER)=>{
    const evts = [];
    let bail;
    let hasBroke = false;
    const awaitDone = async ()=>{
        if (await isDone(evts.at(-1))) return true;
        const bailable = (0, util_1.bailableWait)(20);
        await bailable.wait();
        bail = bailable.bail;
        if (hasBroke) return false;
        return await awaitDone();
    };
    const breakOn = new Promise((resolve)=>{
        waitFor.then(()=>{
            awaitDone().then(()=>resolve());
        });
    });
    try {
        while(evts.length < maxLength){
            const maybeEvt = await Promise.race([
                gen.next(),
                breakOn
            ]);
            if (!maybeEvt) break;
            const evt = maybeEvt;
            if (evt.done) break;
            evts.push(evt.value);
        }
    } finally{
        hasBroke = true;
        bail && bail();
    }
    return evts;
};
exports.readFromGenerator = readFromGenerator;
const createDeferrable = ()=>{
    let resolve;
    const promise = new Promise((res)=>{
        resolve = ()=>res();
    });
    return {
        resolve,
        complete: promise
    };
};
exports.createDeferrable = createDeferrable;
const createDeferrables = (count)=>{
    const list = [];
    for(let i = 0; i < count; i++)list.push((0, exports.createDeferrable)());
    return list;
};
exports.createDeferrables = createDeferrables;
const allComplete = async (deferrables)=>{
    await Promise.all(deferrables.map((d)=>d.complete));
};
exports.allComplete = allComplete;
class AsyncBuffer {
    constructor(maxSize){
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: maxSize
        });
        Object.defineProperty(this, "buffer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "promise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resolve", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "closed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "toThrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Initializing to satisfy types/build, immediately reset by resetPromise()
        this.promise = Promise.resolve();
        this.resolve = ()=>null;
        this.resetPromise();
    }
    get curr() {
        return this.buffer;
    }
    get size() {
        return this.buffer.length;
    }
    get isClosed() {
        return this.closed;
    }
    resetPromise() {
        this.promise = new Promise((r)=>this.resolve = r);
    }
    push(item) {
        this.buffer.push(item);
        this.resolve();
    }
    pushMany(items) {
        items.forEach((i)=>this.buffer.push(i));
        this.resolve();
    }
    async *events() {
        while(true){
            if (this.closed && this.buffer.length === 0) {
                if (this.toThrow) throw this.toThrow;
                else return;
            }
            await this.promise;
            if (this.toThrow) throw this.toThrow;
            if (this.maxSize && this.size > this.maxSize) throw new AsyncBufferFullError(this.maxSize);
            const [first, ...rest] = this.buffer;
            if (first) {
                this.buffer = rest;
                yield first;
            } else this.resetPromise();
        }
    }
    throw(err) {
        this.toThrow = err;
        this.closed = true;
        this.resolve();
    }
    close() {
        this.closed = true;
        this.resolve();
    }
}
exports.AsyncBuffer = AsyncBuffer;
class AsyncBufferFullError extends Error {
    constructor(maxSize){
        super(`ReachedMaxBufferSize: ${maxSize}`);
    }
}
exports.AsyncBufferFullError = AsyncBufferFullError;
function allFulfilled(promises) {
    return Promise.allSettled(promises).then(handleAllSettledErrors);
}
function handleAllSettledErrors(results) {
    if (results.every(isFulfilledResult)) return results.map(extractValue);
    const errors = results.filter(isRejectedResult).map(extractReason);
    throw (0, util_1.aggregateErrors)(errors);
}
function isRejectedResult(result) {
    return result.status === 'rejected';
}
function extractReason(result) {
    return result.reason;
}
function isFulfilledResult(result) {
    return result.status === 'fulfilled';
}
function extractValue(result) {
    return result.value;
}

},{"40753e201aa988f4":"KdxI6"}],"cjKZE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TID = void 0;
const util_1 = require("5fb470e330541741");
const TID_LEN = 13;
let lastTimestamp = 0;
let timestampCount = 0;
let clockid = null;
function dedash(str) {
    return str.replaceAll('-', '');
}
class TID {
    constructor(str){
        Object.defineProperty(this, "str", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const noDashes = dedash(str);
        if (noDashes.length !== TID_LEN) throw new Error(`Poorly formatted TID: ${noDashes.length} length`);
        this.str = noDashes;
    }
    static next(prev) {
        // javascript does not have microsecond precision
        // instead, we append a counter to the timestamp to indicate if multiple timestamps were created within the same millisecond
        // take max of current time & last timestamp to prevent tids moving backwards if system clock drifts backwards
        const time = Math.max(Date.now(), lastTimestamp);
        if (time === lastTimestamp) timestampCount++;
        lastTimestamp = time;
        const timestamp = time * 1000 + timestampCount;
        // the bottom 32 clock ids can be randomized & are not guaranteed to be collision resistant
        // we use the same clockid for all tids coming from this machine
        if (clockid === null) clockid = Math.floor(Math.random() * 32);
        const tid = TID.fromTime(timestamp, clockid);
        if (!prev || tid.newerThan(prev)) return tid;
        return TID.fromTime(prev.timestamp() + 1, clockid);
    }
    static nextStr(prev) {
        return TID.next(prev ? new TID(prev) : undefined).toString();
    }
    static fromTime(timestamp, clockid) {
        // base32 encode with encoding variant sort (s32)
        const str = `${(0, util_1.s32encode)(timestamp)}${(0, util_1.s32encode)(clockid).padStart(2, '2')}`;
        return new TID(str);
    }
    static fromStr(str) {
        return new TID(str);
    }
    static oldestFirst(a, b) {
        return a.compareTo(b);
    }
    static newestFirst(a, b) {
        return b.compareTo(a);
    }
    static is(str) {
        return dedash(str).length === TID_LEN;
    }
    timestamp() {
        return (0, util_1.s32decode)(this.str.slice(0, 11));
    }
    clockid() {
        return (0, util_1.s32decode)(this.str.slice(11, 13));
    }
    formatted() {
        const str = this.toString();
        return `${str.slice(0, 4)}-${str.slice(4, 7)}-${str.slice(7, 11)}-${str.slice(11, 13)}`;
    }
    toString() {
        return this.str;
    }
    // newer > older
    compareTo(other) {
        if (this.str > other.str) return 1;
        if (this.str < other.str) return -1;
        return 0;
    }
    equals(other) {
        return this.str === other.str;
    }
    newerThan(other) {
        return this.compareTo(other) > 0;
    }
    olderThan(other) {
        return this.compareTo(other) < 0;
    }
}
exports.TID = TID;

},{"5fb470e330541741":"KdxI6"}],"2rTRk":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
        }
        __setModuleDefault(result, mod);
        return result;
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ipldEquals = exports.ipldToJson = exports.jsonToIpld = void 0;
const cid_1 = require("e40beb3479ffe39a");
const ui8 = __importStar(require("9c7e031d39faf232"));
// @NOTE avoiding use of check.is() here only because it makes
// these implementations slow, and they often live in hot paths.
const jsonToIpld = (val)=>{
    // walk arrays
    if (Array.isArray(val)) return val.map((item)=>(0, exports.jsonToIpld)(item));
    // objects
    if (val && typeof val === 'object') {
        // check for dag json values
        if (typeof val['$link'] === 'string' && Object.keys(val).length === 1) return cid_1.CID.parse(val['$link']);
        if (typeof val['$bytes'] === 'string' && Object.keys(val).length === 1) return ui8.fromString(val['$bytes'], 'base64');
        // walk plain objects
        const toReturn = {};
        for (const key of Object.keys(val))toReturn[key] = (0, exports.jsonToIpld)(val[key]);
        return toReturn;
    }
    // pass through
    return val;
};
exports.jsonToIpld = jsonToIpld;
const ipldToJson = (val)=>{
    // walk arrays
    if (Array.isArray(val)) return val.map((item)=>(0, exports.ipldToJson)(item));
    // objects
    if (val && typeof val === 'object') {
        // convert bytes
        if (val instanceof Uint8Array) return {
            $bytes: ui8.toString(val, 'base64')
        };
        // convert cids
        if (cid_1.CID.asCID(val)) return {
            $link: val.toString()
        };
        // walk plain objects
        const toReturn = {};
        for (const key of Object.keys(val))toReturn[key] = (0, exports.ipldToJson)(val[key]);
        return toReturn;
    }
    // pass through
    return val;
};
exports.ipldToJson = ipldToJson;
const ipldEquals = (a, b)=>{
    // walk arrays
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!(0, exports.ipldEquals)(a[i], b[i])) return false;
        }
        return true;
    }
    // objects
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        // check bytes
        if (a instanceof Uint8Array && b instanceof Uint8Array) return ui8.equals(a, b);
        // check cids
        if (cid_1.CID.asCID(a) && cid_1.CID.asCID(b)) return cid_1.CID.asCID(a)?.equals(cid_1.CID.asCID(b));
        // walk plain objects
        if (Object.keys(a).length !== Object.keys(b).length) return false;
        for (const key of Object.keys(a)){
            if (!(0, exports.ipldEquals)(a[key], b[key])) return false;
        }
        return true;
    }
    return a === b;
};
exports.ipldEquals = ipldEquals;

},{"e40beb3479ffe39a":"7UJVD","9c7e031d39faf232":"fQvn8"}],"7UJVD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CID", ()=>CID);
var _varintJs = require("./varint.js");
var _digestJs = require("./hashes/digest.js");
var _base58Js = require("./bases/base58.js");
var _base32Js = require("./bases/base32.js");
var _bytesJs = require("./bytes.js");
class CID {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: hidden,
            byteLength: hidden,
            code: readonly,
            version: readonly,
            multihash: readonly,
            bytes: readonly,
            _baseCache: hidden,
            asCID: hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code, multihash } = this;
                    if (code !== DAG_PB_CODE) throw new Error('Cannot convert a non dag-pb CID to CIDv0');
                    if (multihash.code !== SHA_256_CODE) throw new Error('Cannot convert non sha2-256 multihash CID to CIDv0');
                    return CID.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code, digest } = this.multihash;
                    const multihash = _digestJs.create(code, digest);
                    return CID.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && _digestJs.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes, version, _baseCache } = this;
        switch(version){
            case 0:
                return toStringV0(bytes, _baseCache, base || (0, _base58Js.base58btc).encoder);
            default:
                return toStringV1(bytes, _baseCache, base || (0, _base32Js.base32).encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return 'CID';
    }
    [Symbol.for('nodejs.util.inspect.custom')]() {
        return 'CID(' + this.toString() + ')';
    }
    static isCID(value) {
        deprecate(/^0\.0/, IS_CID_DEPRECATION);
        return !!(value && (value[cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error('Deprecated, use .toString()');
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error('Deprecated .buffer property, use .bytes to get Uint8Array instead');
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof CID) return value;
        else if (value != null && value.asCID === value) {
            const { version, code, multihash, bytes } = value;
            return new CID(version, code, multihash, bytes || encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[cidSymbol] === true) {
            const { version, multihash, code } = value;
            const digest = _digestJs.decode(multihash);
            return CID.create(version, code, digest);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== 'number') throw new Error('String codecs are no longer supported');
        switch(version){
            case 0:
                if (code !== DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${DAG_PB_CODE}) block encoding`);
                else return new CID(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = encodeCID(version, code, digest.bytes);
                    return new CID(version, code, digest, bytes);
                }
            default:
                throw new Error('Invalid version');
        }
    }
    static createV0(digest) {
        return CID.create(0, DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return CID.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = CID.decodeFirst(bytes);
        if (remainder.length) throw new Error('Incorrect length');
        return cid;
    }
    static decodeFirst(bytes) {
        const specs = CID.inspectBytes(bytes);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = (0, _bytesJs.coerce)(bytes.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error('Incorrect length');
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest = new _digestJs.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? CID.createV0(digest) : CID.createV1(specs.codec, digest);
        return [
            cid,
            bytes.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = _varintJs.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version,
            codec,
            multihashCode,
            digestSize,
            multihashSize,
            size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = parseCIDtoBytes(source, base);
        const cid = CID.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case 'Q':
            {
                const decoder = base || (0, _base58Js.base58btc);
                return [
                    (0, _base58Js.base58btc).prefix,
                    decoder.decode(`${(0, _base58Js.base58btc).prefix}${source}`)
                ];
            }
        case (0, _base58Js.base58btc).prefix:
            {
                const decoder = base || (0, _base58Js.base58btc);
                return [
                    (0, _base58Js.base58btc).prefix,
                    decoder.decode(source)
                ];
            }
        case (0, _base32Js.base32).prefix:
            {
                const decoder = base || (0, _base32Js.base32);
                return [
                    (0, _base32Js.base32).prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error('To parse non base32 or base58btc encoded CID multibase decoder must be provided');
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const toStringV0 = (bytes, cache, base)=>{
    const { prefix } = base;
    if (prefix !== (0, _base58Js.base58btc).prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const toStringV1 = (bytes, cache, base)=>{
    const { prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const DAG_PB_CODE = 112;
const SHA_256_CODE = 18;
const encodeCID = (version, code, multihash)=>{
    const codeOffset = _varintJs.encodingLength(version);
    const hashOffset = codeOffset + _varintJs.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    _varintJs.encodeTo(version, bytes, 0);
    _varintJs.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const cidSymbol = Symbol.for('@ipld/js-cid/CID');
const readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const version = '0.0.0-dev';
const deprecate = (range, message)=>{
    if (range.test(version)) console.warn(message);
    else throw new Error(message);
};
const IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;

},{"./varint.js":"ffyXm","./hashes/digest.js":"YEs1c","./bases/base58.js":"da7vB","./bases/base32.js":"5bbdh","./bytes.js":"6peFg","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"ffyXm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "encodeTo", ()=>encodeTo);
parcelHelpers.export(exports, "encodingLength", ()=>encodingLength);
var _varintJs = require("../vendor/varint.js");
var _varintJsDefault = parcelHelpers.interopDefault(_varintJs);
const decode = (data, offset = 0)=>{
    const code = (0, _varintJsDefault.default).decode(data, offset);
    return [
        code,
        (0, _varintJsDefault.default).decode.bytes
    ];
};
const encodeTo = (int, target, offset = 0)=>{
    (0, _varintJsDefault.default).encode(int, target, offset);
    return target;
};
const encodingLength = (int)=>{
    return (0, _varintJsDefault.default).encodingLength(int);
};

},{"../vendor/varint.js":"a5ULq","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"a5ULq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var encode_1 = encode;
var MSB = 128, REST = 127, MSBALL = ~REST, INT = Math.pow(2, 31);
function encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= INT){
        out[offset++] = num & 255 | MSB;
        num /= 128;
    }
    while(num & MSBALL){
        out[offset++] = num & 255 | MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    encode.bytes = offset - oldOffset + 1;
    return out;
}
var decode = read;
var MSB$1 = 128, REST$1 = 127;
function read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            read.bytes = 0;
            throw new RangeError('Could not decode varint');
        }
        b = buf[counter++];
        res += shift < 28 ? (b & REST$1) << shift : (b & REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= MSB$1);
    read.bytes = counter - offset;
    return res;
}
var N1 = Math.pow(2, 7);
var N2 = Math.pow(2, 14);
var N3 = Math.pow(2, 21);
var N4 = Math.pow(2, 28);
var N5 = Math.pow(2, 35);
var N6 = Math.pow(2, 42);
var N7 = Math.pow(2, 49);
var N8 = Math.pow(2, 56);
var N9 = Math.pow(2, 63);
var length = function(value) {
    return value < N1 ? 1 : value < N2 ? 2 : value < N3 ? 3 : value < N4 ? 4 : value < N5 ? 5 : value < N6 ? 6 : value < N7 ? 7 : value < N8 ? 8 : value < N9 ? 9 : 10;
};
var varint = {
    encode: encode_1,
    decode: decode,
    encodingLength: length
};
var _brrp_varint = varint;
exports.default = _brrp_varint;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"YEs1c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "equals", ()=>equals);
parcelHelpers.export(exports, "Digest", ()=>Digest);
var _bytesJs = require("../bytes.js");
var _varintJs = require("../varint.js");
const create = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = _varintJs.encodingLength(code);
    const digestOffset = sizeOffset + _varintJs.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    _varintJs.encodeTo(code, bytes, 0);
    _varintJs.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new Digest(code, size, digest, bytes);
};
const decode = (multihash)=>{
    const bytes = (0, _bytesJs.coerce)(multihash);
    const [code, sizeOffset] = _varintJs.decode(bytes);
    const [size, digestOffset] = _varintJs.decode(bytes.subarray(sizeOffset));
    const digest = bytes.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error('Incorrect length');
    return new Digest(code, size, digest, bytes);
};
const equals = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && (0, _bytesJs.equals)(a.bytes, b.bytes);
};
class Digest {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}

},{"../bytes.js":"6peFg","../varint.js":"ffyXm","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"6peFg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equals", ()=>equals);
parcelHelpers.export(exports, "coerce", ()=>coerce);
parcelHelpers.export(exports, "isBinary", ()=>isBinary);
parcelHelpers.export(exports, "fromHex", ()=>fromHex);
parcelHelpers.export(exports, "toHex", ()=>toHex);
parcelHelpers.export(exports, "fromString", ()=>fromString);
parcelHelpers.export(exports, "toString", ()=>toString);
parcelHelpers.export(exports, "empty", ()=>empty);
const empty = new Uint8Array(0);
const toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, '0'), '');
const fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : empty;
};
const equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === 'Uint8Array') return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error('Unknown type, must be binary type');
};
const isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const fromString = (str)=>new TextEncoder().encode(str);
const toString = (b)=>new TextDecoder().decode(b);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"da7vB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base58btc", ()=>base58btc);
parcelHelpers.export(exports, "base58flickr", ()=>base58flickr);
var _baseJs = require("./base.js");
const base58btc = (0, _baseJs.baseX)({
    name: 'base58btc',
    prefix: 'z',
    alphabet: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
});
const base58flickr = (0, _baseJs.baseX)({
    name: 'base58flickr',
    prefix: 'Z',
    alphabet: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'
});

},{"./base.js":"hPS4B","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"hPS4B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "or", ()=>or);
parcelHelpers.export(exports, "Codec", ()=>Codec);
parcelHelpers.export(exports, "from", ()=>from);
parcelHelpers.export(exports, "baseX", ()=>baseX);
parcelHelpers.export(exports, "rfc4648", ()=>rfc4648);
var _baseXJs = require("../../vendor/base-x.js");
var _baseXJsDefault = parcelHelpers.interopDefault(_baseXJs);
var _bytesJs = require("../bytes.js");
class Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error('Unknown type, must be binary type');
    }
}
class Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error('Invalid prefix character');
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === 'string') {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error('Can only multibase decode strings');
    }
    or(decoder) {
        return or(this, decoder);
    }
}
class ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const or = (left, right)=>new ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new Encoder(name, prefix, baseEncode);
        this.decoder = new Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const from = ({ name, prefix, encode, decode })=>new Codec(name, prefix, encode, decode);
const baseX = ({ prefix, name, alphabet })=>{
    const { encode, decode } = (0, _baseXJsDefault.default)(alphabet, name);
    return from({
        prefix,
        name,
        encode,
        decode: (text)=>(0, _bytesJs.coerce)(decode(text))
    });
};
const decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === '=')--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError('Unexpected end of data');
    return out;
};
const encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === '=';
    const mask = (1 << bitsPerChar) - 1;
    let out = '';
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += '=';
    return out;
};
const rfc4648 = ({ name, prefix, bitsPerChar, alphabet })=>{
    return from({
        prefix,
        name,
        encode (input) {
            return encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return decode(input, alphabet, bitsPerChar, name);
        }
    });
};

},{"../../vendor/base-x.js":"aANAW","../bytes.js":"6peFg","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"aANAW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError('Alphabet too long');
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + ' is ambiguous');
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError('Expected Uint8Array');
        if (source.length === 0) return '';
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== 'string') throw new TypeError('Expected String');
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === ' ') return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error('Non-zero carry');
            length = i;
            psz++;
        }
        if (source[psz] === ' ') return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var src = base;
var _brrp__multiformats_scope_baseX = src;
exports.default = _brrp__multiformats_scope_baseX;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"5bbdh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base32", ()=>base32);
parcelHelpers.export(exports, "base32upper", ()=>base32upper);
parcelHelpers.export(exports, "base32pad", ()=>base32pad);
parcelHelpers.export(exports, "base32padupper", ()=>base32padupper);
parcelHelpers.export(exports, "base32hex", ()=>base32hex);
parcelHelpers.export(exports, "base32hexupper", ()=>base32hexupper);
parcelHelpers.export(exports, "base32hexpad", ()=>base32hexpad);
parcelHelpers.export(exports, "base32hexpadupper", ()=>base32hexpadupper);
parcelHelpers.export(exports, "base32z", ()=>base32z);
var _baseJs = require("./base.js");
const base32 = (0, _baseJs.rfc4648)({
    prefix: 'b',
    name: 'base32',
    alphabet: 'abcdefghijklmnopqrstuvwxyz234567',
    bitsPerChar: 5
});
const base32upper = (0, _baseJs.rfc4648)({
    prefix: 'B',
    name: 'base32upper',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567',
    bitsPerChar: 5
});
const base32pad = (0, _baseJs.rfc4648)({
    prefix: 'c',
    name: 'base32pad',
    alphabet: 'abcdefghijklmnopqrstuvwxyz234567=',
    bitsPerChar: 5
});
const base32padupper = (0, _baseJs.rfc4648)({
    prefix: 'C',
    name: 'base32padupper',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=',
    bitsPerChar: 5
});
const base32hex = (0, _baseJs.rfc4648)({
    prefix: 'v',
    name: 'base32hex',
    alphabet: '0123456789abcdefghijklmnopqrstuv',
    bitsPerChar: 5
});
const base32hexupper = (0, _baseJs.rfc4648)({
    prefix: 'V',
    name: 'base32hexupper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV',
    bitsPerChar: 5
});
const base32hexpad = (0, _baseJs.rfc4648)({
    prefix: 't',
    name: 'base32hexpad',
    alphabet: '0123456789abcdefghijklmnopqrstuv=',
    bitsPerChar: 5
});
const base32hexpadupper = (0, _baseJs.rfc4648)({
    prefix: 'T',
    name: 'base32hexpadupper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV=',
    bitsPerChar: 5
});
const base32z = (0, _baseJs.rfc4648)({
    prefix: 'h',
    name: 'base32z',
    alphabet: 'ybndrfg8ejkmcpqxot1uwisza345h769',
    bitsPerChar: 5
});

},{"./base.js":"hPS4B","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"fQvn8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compare", ()=>(0, _compareJs.compare));
parcelHelpers.export(exports, "concat", ()=>(0, _concatJs.concat));
parcelHelpers.export(exports, "equals", ()=>(0, _equalsJs.equals));
parcelHelpers.export(exports, "fromString", ()=>(0, _fromStringJs.fromString));
parcelHelpers.export(exports, "toString", ()=>(0, _toStringJs.toString));
parcelHelpers.export(exports, "xor", ()=>(0, _xorJs.xor));
var _compareJs = require("./compare.js");
var _concatJs = require("./concat.js");
var _equalsJs = require("./equals.js");
var _fromStringJs = require("./from-string.js");
var _toStringJs = require("./to-string.js");
var _xorJs = require("./xor.js");

},{"./compare.js":"cPJeB","./concat.js":"74KcL","./equals.js":"kgCVL","./from-string.js":"2KibS","./to-string.js":"1hwJh","./xor.js":"gcTsz","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"cPJeB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compare", ()=>compare);
function compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"74KcL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
function concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = new Uint8Array(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"kgCVL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equals", ()=>equals);
function equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"2KibS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromString", ()=>fromString);
var _basesJs = require("./util/bases.js");
var _basesJsDefault = parcelHelpers.interopDefault(_basesJs);
function fromString(string, encoding = 'utf8') {
    const base = (0, _basesJsDefault.default)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    return base.decoder.decode(`${base.prefix}${string}`);
}

},{"./util/bases.js":"iEZvU","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"iEZvU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basics = require("multiformats/basics");
function createCodec(name, prefix, encode, decode) {
    return {
        name,
        prefix,
        encoder: {
            name,
            prefix,
            encode
        },
        decoder: {
            decode
        }
    };
}
const string = createCodec('utf8', 'u', (buf)=>{
    const decoder = new TextDecoder('utf8');
    return 'u' + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const ascii = createCodec('ascii', 'a', (buf)=>{
    let string = 'a';
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const BASES = {
    utf8: string,
    'utf-8': string,
    hex: (0, _basics.bases).base16,
    latin1: ascii,
    ascii: ascii,
    binary: ascii,
    ...(0, _basics.bases)
};
exports.default = BASES;

},{"multiformats/basics":"d1Vbt","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"d1Vbt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CID", ()=>(0, _indexJs.CID));
parcelHelpers.export(exports, "hasher", ()=>(0, _indexJs.hasher));
parcelHelpers.export(exports, "digest", ()=>(0, _indexJs.digest));
parcelHelpers.export(exports, "varint", ()=>(0, _indexJs.varint));
parcelHelpers.export(exports, "bytes", ()=>(0, _indexJs.bytes));
parcelHelpers.export(exports, "hashes", ()=>hashes);
parcelHelpers.export(exports, "bases", ()=>bases);
parcelHelpers.export(exports, "codecs", ()=>codecs);
var _identityJs = require("./bases/identity.js");
var _base2Js = require("./bases/base2.js");
var _base8Js = require("./bases/base8.js");
var _base10Js = require("./bases/base10.js");
var _base16Js = require("./bases/base16.js");
var _base32Js = require("./bases/base32.js");
var _base36Js = require("./bases/base36.js");
var _base58Js = require("./bases/base58.js");
var _base64Js = require("./bases/base64.js");
var _base256EmojiJs = require("./bases/base256emoji.js");
var _sha2Js = require("./hashes/sha2.js");
var _identityJs1 = require("./hashes/identity.js");
var _rawJs = require("./codecs/raw.js");
var _jsonJs = require("./codecs/json.js");
var _indexJs = require("./index.js");
const bases = {
    ..._identityJs,
    ..._base2Js,
    ..._base8Js,
    ..._base10Js,
    ..._base16Js,
    ..._base32Js,
    ..._base36Js,
    ..._base58Js,
    ..._base64Js,
    ..._base256EmojiJs
};
const hashes = {
    ..._sha2Js,
    ..._identityJs1
};
const codecs = {
    raw: _rawJs,
    json: _jsonJs
};

},{"./bases/identity.js":"aVDtd","./bases/base2.js":"asmKn","./bases/base8.js":"6I8FA","./bases/base10.js":"7DvQ6","./bases/base16.js":"irSuj","./bases/base32.js":"5bbdh","./bases/base36.js":"5nKX8","./bases/base58.js":"da7vB","./bases/base64.js":"lhOWL","./bases/base256emoji.js":"6Cl9b","./hashes/sha2.js":"joiXl","./hashes/identity.js":"efGyy","./codecs/raw.js":"9gRPq","./codecs/json.js":"9vlxr","./index.js":"83M4S","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"aVDtd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
var _baseJs = require("./base.js");
var _bytesJs = require("../bytes.js");
const identity = (0, _baseJs.from)({
    prefix: '\0',
    name: 'identity',
    encode: (buf)=>(0, _bytesJs.toString)(buf),
    decode: (str)=>(0, _bytesJs.fromString)(str)
});

},{"./base.js":"hPS4B","../bytes.js":"6peFg","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"asmKn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base2", ()=>base2);
var _baseJs = require("./base.js");
const base2 = (0, _baseJs.rfc4648)({
    prefix: '0',
    name: 'base2',
    alphabet: '01',
    bitsPerChar: 1
});

},{"./base.js":"hPS4B","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"6I8FA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base8", ()=>base8);
var _baseJs = require("./base.js");
const base8 = (0, _baseJs.rfc4648)({
    prefix: '7',
    name: 'base8',
    alphabet: '01234567',
    bitsPerChar: 3
});

},{"./base.js":"hPS4B","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"7DvQ6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base10", ()=>base10);
var _baseJs = require("./base.js");
const base10 = (0, _baseJs.baseX)({
    prefix: '9',
    name: 'base10',
    alphabet: '0123456789'
});

},{"./base.js":"hPS4B","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"irSuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base16", ()=>base16);
parcelHelpers.export(exports, "base16upper", ()=>base16upper);
var _baseJs = require("./base.js");
const base16 = (0, _baseJs.rfc4648)({
    prefix: 'f',
    name: 'base16',
    alphabet: '0123456789abcdef',
    bitsPerChar: 4
});
const base16upper = (0, _baseJs.rfc4648)({
    prefix: 'F',
    name: 'base16upper',
    alphabet: '0123456789ABCDEF',
    bitsPerChar: 4
});

},{"./base.js":"hPS4B","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"5nKX8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base36", ()=>base36);
parcelHelpers.export(exports, "base36upper", ()=>base36upper);
var _baseJs = require("./base.js");
const base36 = (0, _baseJs.baseX)({
    prefix: 'k',
    name: 'base36',
    alphabet: '0123456789abcdefghijklmnopqrstuvwxyz'
});
const base36upper = (0, _baseJs.baseX)({
    prefix: 'K',
    name: 'base36upper',
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
});

},{"./base.js":"hPS4B","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"lhOWL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base64", ()=>base64);
parcelHelpers.export(exports, "base64pad", ()=>base64pad);
parcelHelpers.export(exports, "base64url", ()=>base64url);
parcelHelpers.export(exports, "base64urlpad", ()=>base64urlpad);
var _baseJs = require("./base.js");
const base64 = (0, _baseJs.rfc4648)({
    prefix: 'm',
    name: 'base64',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
    bitsPerChar: 6
});
const base64pad = (0, _baseJs.rfc4648)({
    prefix: 'M',
    name: 'base64pad',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    bitsPerChar: 6
});
const base64url = (0, _baseJs.rfc4648)({
    prefix: 'u',
    name: 'base64url',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
    bitsPerChar: 6
});
const base64urlpad = (0, _baseJs.rfc4648)({
    prefix: 'U',
    name: 'base64urlpad',
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=',
    bitsPerChar: 6
});

},{"./base.js":"hPS4B","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"6Cl9b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base256emoji", ()=>base256emoji);
var _baseJs = require("./base.js");
const alphabet = Array.from('\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42');
const alphabetBytesToChars = alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const alphabetCharsToBytes = alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function encode(data) {
    return data.reduce((p, c)=>{
        p += alphabetBytesToChars[c];
        return p;
    }, '');
}
function decode(str) {
    const byts = [];
    for (const char of str){
        const byt = alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const base256emoji = (0, _baseJs.from)({
    prefix: '\uD83D\uDE80',
    name: 'base256emoji',
    encode,
    decode
});

},{"./base.js":"hPS4B","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"joiXl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sha256", ()=>sha256);
parcelHelpers.export(exports, "sha512", ()=>sha512);
var _hasherJs = require("./hasher.js");
const sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const sha256 = (0, _hasherJs.from)({
    name: 'sha2-256',
    code: 18,
    encode: sha('SHA-256')
});
const sha512 = (0, _hasherJs.from)({
    name: 'sha2-512',
    code: 19,
    encode: sha('SHA-512')
});

},{"./hasher.js":"917po","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"917po":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
parcelHelpers.export(exports, "Hasher", ()=>Hasher);
var _digestJs = require("./digest.js");
const from = ({ name, code, encode })=>new Hasher(name, code, encode);
class Hasher {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? _digestJs.create(this.code, result) : result.then((digest)=>_digestJs.create(this.code, digest));
        } else throw Error('Unknown type, must be binary type');
    }
}

},{"./digest.js":"YEs1c","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"efGyy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
var _bytesJs = require("../bytes.js");
var _digestJs = require("./digest.js");
const code = 0;
const name = 'identity';
const encode = (0, _bytesJs.coerce);
const digest = (input)=>_digestJs.create(code, encode(input));
const identity = {
    code,
    name,
    encode,
    digest
};

},{"../bytes.js":"6peFg","./digest.js":"YEs1c","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"9gRPq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "name", ()=>name);
parcelHelpers.export(exports, "code", ()=>code);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
var _bytesJs = require("../bytes.js");
const name = 'raw';
const code = 85;
const encode = (node)=>(0, _bytesJs.coerce)(node);
const decode = (data)=>(0, _bytesJs.coerce)(data);

},{"../bytes.js":"6peFg","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"9vlxr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "name", ()=>name);
parcelHelpers.export(exports, "code", ()=>code);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();
const name = 'json';
const code = 512;
const encode = (node)=>textEncoder.encode(JSON.stringify(node));
const decode = (data)=>JSON.parse(textDecoder.decode(data));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"83M4S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CID", ()=>(0, _cidJs.CID));
parcelHelpers.export(exports, "hasher", ()=>_hasherJs);
parcelHelpers.export(exports, "digest", ()=>_digestJs);
parcelHelpers.export(exports, "varint", ()=>_varintJs);
parcelHelpers.export(exports, "bytes", ()=>_bytesJs);
var _cidJs = require("./cid.js");
var _varintJs = require("./varint.js");
var _bytesJs = require("./bytes.js");
var _hasherJs = require("./hashes/hasher.js");
var _digestJs = require("./hashes/digest.js");

},{"./cid.js":"7UJVD","./varint.js":"ffyXm","./bytes.js":"6peFg","./hashes/hasher.js":"917po","./hashes/digest.js":"YEs1c","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"1hwJh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toString", ()=>toString);
var _basesJs = require("./util/bases.js");
var _basesJsDefault = parcelHelpers.interopDefault(_basesJs);
function toString(array, encoding = 'utf8') {
    const base = (0, _basesJsDefault.default)[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    return base.encoder.encode(array).substring(1);
}

},{"./util/bases.js":"iEZvU","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"gcTsz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xor", ()=>xor);
function xor(a, b) {
    if (a.length !== b.length) throw new Error('Inputs should have the same length');
    const result = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"3H2GM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.retry = retry;
exports.createRetryable = createRetryable;
exports.backoffMs = backoffMs;
const util_1 = require("79de7658c3d9183c");
async function retry(fn, opts = {}) {
    const { maxRetries = 3, retryable = ()=>true, getWaitMs = backoffMs } = opts;
    let retries = 0;
    let doneError;
    while(!doneError)try {
        return await fn();
    } catch (err) {
        const waitMs = getWaitMs(retries);
        const willRetry = retries < maxRetries && waitMs !== null && retryable(err);
        if (willRetry) {
            retries += 1;
            if (waitMs !== 0) await (0, util_1.wait)(waitMs);
        } else doneError = err;
    }
    throw doneError;
}
function createRetryable(retryable) {
    return async (fn, opts)=>retry(fn, {
            ...opts,
            retryable
        });
}
// Waits exponential backoff with max and jitter: ~100, ~200, ~400, ~800, ~1000, ~1000, ...
function backoffMs(n, multiplier = 100, max = 1000) {
    const exponentialMs = Math.pow(2, n) * multiplier;
    const ms = Math.min(exponentialMs, max);
    return jitter(ms);
}
// Adds randomness +/-15% of value
function jitter(value) {
    const delta = value * 0.15;
    return value + randomRange(-delta, delta);
}
function randomRange(from, to) {
    const rand = Math.random() * (to - from);
    return rand + from;
}

},{"79de7658c3d9183c":"KdxI6"}],"bamCJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.def = exports.schema = void 0;
const cid_1 = require("e8d77a2713bdcf8d");
const zod_1 = require("8cf814047f0eb91e");
const cidSchema = zod_1.z.unknown().transform((obj, ctx)=>{
    const cid = cid_1.CID.asCID(obj);
    if (cid == null) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Not a valid CID'
        });
        return zod_1.z.NEVER;
    }
    return cid;
});
const carHeader = zod_1.z.object({
    version: zod_1.z.literal(1),
    roots: zod_1.z.array(cidSchema)
});
exports.schema = {
    cid: cidSchema,
    carHeader,
    bytes: zod_1.z.instanceof(Uint8Array),
    string: zod_1.z.string(),
    array: zod_1.z.array(zod_1.z.unknown()),
    map: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    unknown: zod_1.z.unknown()
};
exports.def = {
    cid: {
        name: 'cid',
        schema: exports.schema.cid
    },
    carHeader: {
        name: 'CAR header',
        schema: exports.schema.carHeader
    },
    bytes: {
        name: 'bytes',
        schema: exports.schema.bytes
    },
    string: {
        name: 'string',
        schema: exports.schema.string
    },
    map: {
        name: 'map',
        schema: exports.schema.map
    },
    unknown: {
        name: 'unknown',
        schema: exports.schema.unknown
    }
};

},{"e8d77a2713bdcf8d":"7UJVD","8cf814047f0eb91e":"et8te"}],"et8te":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.z = void 0;
const z = __importStar(require("67ca2ba4a9c6f2c9"));
exports.z = z;
__exportStar(require("67ca2ba4a9c6f2c9"), exports);
exports.default = z;

},{"67ca2ba4a9c6f2c9":"f0wnw"}],"f0wnw":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("6a56108980266b"), exports);
__exportStar(require("e5b559b7a3521e82"), exports);
__exportStar(require("fc5e3a6d01cc2cdf"), exports);
__exportStar(require("a3b75cffab3dad41"), exports);
__exportStar(require("6f20eac1c3b28ad7"), exports);
__exportStar(require("baaf8d60848ef2b5"), exports);

},{"6a56108980266b":"lgaCg","e5b559b7a3521e82":"7yRV5","fc5e3a6d01cc2cdf":"6X97u","a3b75cffab3dad41":"17YkJ","6f20eac1c3b28ad7":"i1DAv","baaf8d60848ef2b5":"cNSIG"}],"lgaCg":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultErrorMap = void 0;
exports.setErrorMap = setErrorMap;
exports.getErrorMap = getErrorMap;
const en_js_1 = __importDefault(require("bba47bb831823eb5"));
exports.defaultErrorMap = en_js_1.default;
let overrideErrorMap = en_js_1.default;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

},{"bba47bb831823eb5":"eQGzS"}],"eQGzS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const ZodError_js_1 = require("10541966443151ec");
const util_js_1 = require("3b0fc61f94102c19");
const errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case ZodError_js_1.ZodIssueCode.invalid_type:
            if (issue.received === util_js_1.ZodParsedType.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util_js_1.util.jsonStringifyReplacer)}`;
            break;
        case ZodError_js_1.ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util_js_1.util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util_js_1.util.joinValues(issue.options)}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util_js_1.util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else util_js_1.util.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case ZodError_js_1.ZodIssueCode.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case ZodError_js_1.ZodIssueCode.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case ZodError_js_1.ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodError_js_1.ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodError_js_1.ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util_js_1.util.assertNever(issue);
    }
    return {
        message
    };
};
exports.default = errorMap;

},{"10541966443151ec":"cNSIG","3b0fc61f94102c19":"17YkJ"}],"cNSIG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ZodError = exports.quotelessJson = exports.ZodIssueCode = void 0;
const util_js_1 = require("caab1391b7b873b7");
exports.ZodIssueCode = util_js_1.util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const quotelessJson = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
exports.quotelessJson = quotelessJson;
class ZodError extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util_js_1.util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors,
            fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
exports.ZodError = ZodError;
ZodError.create = (issues)=>{
    const error = new ZodError(issues);
    return error;
};

},{"caab1391b7b873b7":"17YkJ"}],"17YkJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getParsedType = exports.ZodParsedType = exports.objectUtil = exports.util = void 0;
var util;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})(util || (exports.util = util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})(objectUtil || (exports.objectUtil = objectUtil = {}));
exports.ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return exports.ZodParsedType.undefined;
        case "string":
            return exports.ZodParsedType.string;
        case "number":
            return Number.isNaN(data) ? exports.ZodParsedType.nan : exports.ZodParsedType.number;
        case "boolean":
            return exports.ZodParsedType.boolean;
        case "function":
            return exports.ZodParsedType.function;
        case "bigint":
            return exports.ZodParsedType.bigint;
        case "symbol":
            return exports.ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return exports.ZodParsedType.array;
            if (data === null) return exports.ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return exports.ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return exports.ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return exports.ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return exports.ZodParsedType.date;
            return exports.ZodParsedType.object;
        default:
            return exports.ZodParsedType.unknown;
    }
};
exports.getParsedType = getParsedType;

},{}],"7yRV5":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAsync = exports.isValid = exports.isDirty = exports.isAborted = exports.OK = exports.DIRTY = exports.INVALID = exports.ParseStatus = exports.EMPTY_PATH = exports.makeIssue = void 0;
exports.addIssueToContext = addIssueToContext;
const errors_js_1 = require("3134345107335d1");
const en_js_1 = __importDefault(require("8c1d0c366478d626"));
const makeIssue = (params)=>{
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
exports.makeIssue = makeIssue;
exports.EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = (0, errors_js_1.getErrorMap)();
    const issue = (0, exports.makeIssue)({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === en_js_1.default ? undefined : en_js_1.default
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return exports.INVALID;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key, value } = pair;
            if (key.status === "aborted") return exports.INVALID;
            if (value.status === "aborted") return exports.INVALID;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
exports.ParseStatus = ParseStatus;
exports.INVALID = Object.freeze({
    status: "aborted"
});
const DIRTY = (value)=>({
        status: "dirty",
        value
    });
exports.DIRTY = DIRTY;
const OK = (value)=>({
        status: "valid",
        value
    });
exports.OK = OK;
const isAborted = (x)=>x.status === "aborted";
exports.isAborted = isAborted;
const isDirty = (x)=>x.status === "dirty";
exports.isDirty = isDirty;
const isValid = (x)=>x.status === "valid";
exports.isValid = isValid;
const isAsync = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
exports.isAsync = isAsync;

},{"3134345107335d1":"lgaCg","8c1d0c366478d626":"eQGzS"}],"6X97u":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"i1DAv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.discriminatedUnion = exports.date = exports.boolean = exports.bigint = exports.array = exports.any = exports.coerce = exports.ZodFirstPartyTypeKind = exports.late = exports.ZodSchema = exports.Schema = exports.ZodReadonly = exports.ZodPipeline = exports.ZodBranded = exports.BRAND = exports.ZodNaN = exports.ZodCatch = exports.ZodDefault = exports.ZodNullable = exports.ZodOptional = exports.ZodTransformer = exports.ZodEffects = exports.ZodPromise = exports.ZodNativeEnum = exports.ZodEnum = exports.ZodLiteral = exports.ZodLazy = exports.ZodFunction = exports.ZodSet = exports.ZodMap = exports.ZodRecord = exports.ZodTuple = exports.ZodIntersection = exports.ZodDiscriminatedUnion = exports.ZodUnion = exports.ZodObject = exports.ZodArray = exports.ZodVoid = exports.ZodNever = exports.ZodUnknown = exports.ZodAny = exports.ZodNull = exports.ZodUndefined = exports.ZodSymbol = exports.ZodDate = exports.ZodBoolean = exports.ZodBigInt = exports.ZodNumber = exports.ZodString = exports.ZodType = void 0;
exports.NEVER = exports.void = exports.unknown = exports.union = exports.undefined = exports.tuple = exports.transformer = exports.symbol = exports.string = exports.strictObject = exports.set = exports.record = exports.promise = exports.preprocess = exports.pipeline = exports.ostring = exports.optional = exports.onumber = exports.oboolean = exports.object = exports.number = exports.nullable = exports.null = exports.never = exports.nativeEnum = exports.nan = exports.map = exports.literal = exports.lazy = exports.intersection = exports.instanceof = exports.function = exports.enum = exports.effect = void 0;
exports.datetimeRegex = datetimeRegex;
exports.custom = custom;
const ZodError_js_1 = require("9f99e7f611031e00");
const errors_js_1 = require("2eb7d0c99f112498");
const errorUtil_js_1 = require("4ad097a777f8b065");
const parseUtil_js_1 = require("3ba8294f86dc472");
const util_js_1 = require("ca92ed557ffe3357");
class ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result)=>{
    if ((0, parseUtil_js_1.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new ZodError_js_1.ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description
    };
    const customMap = (iss, ctx)=>{
        const { message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description
    };
}
class ZodType {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, util_js_1.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, util_js_1.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new parseUtil_js_1.ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, util_js_1.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, parseUtil_js_1.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        const result = this._parseSync({
            data,
            path: ctx.path,
            parent: ctx
        });
        return handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data,
                path: [],
                parent: ctx
            });
            return (0, parseUtil_js_1.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data,
            path: [],
            parent: ctx
        }).then((result)=>(0, parseUtil_js_1.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, parseUtil_js_1.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: ZodError_js_1.ZodIssueCode.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
exports.ZodType = ZodType;
exports.Schema = ZodType;
exports.ZodSchema = ZodType;
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
function isValidJWT(jwt, alg) {
    if (!jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function isValidCidr(ip, version) {
    if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) return true;
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.string,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const status = new parseUtil_js_1.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "email",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    validation: "url",
                    code: ZodError_js_1.ZodIssueCode.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation,
            code: ZodError_js_1.ZodIssueCode.invalid_string,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, errorUtil_js_1.errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
exports.ZodString = ZodString;
ZodString.create = (params)=>{
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class ZodNumber extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.number,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        let ctx = undefined;
        const status = new parseUtil_js_1.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!util_js_1.util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil_js_1.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil_js_1.errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && util_js_1.util.isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
exports.ZodNumber = ZodNumber;
ZodNumber.create = (params)=>{
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodBigInt extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new parseUtil_js_1.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, parseUtil_js_1.addIssueToContext)(ctx, {
            code: ZodError_js_1.ZodIssueCode.invalid_type,
            expected: util_js_1.ZodParsedType.bigint,
            received: ctx.parsedType
        });
        return parseUtil_js_1.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil_js_1.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
exports.ZodBigInt = ZodBigInt;
ZodBigInt.create = (params)=>{
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.boolean,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodBoolean = ZodBoolean;
ZodBoolean.create = (params)=>{
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.date,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_date
            });
            return parseUtil_js_1.INVALID;
        }
        const status = new parseUtil_js_1.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
exports.ZodDate = ZodDate;
ZodDate.create = (params)=>{
    return new ZodDate({
        checks: [],
        coerce: params?.coerce || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params)
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.symbol,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodSymbol = ZodSymbol;
ZodSymbol.create = (params)=>{
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params)
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.undefined,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodUndefined = ZodUndefined;
ZodUndefined.create = (params)=>{
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params)
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.null,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodNull = ZodNull;
ZodNull.create = (params)=>{
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params)
    });
};
class ZodAny extends ZodType {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodAny = ZodAny;
ZodAny.create = (params)=>{
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params)
    });
};
class ZodUnknown extends ZodType {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodUnknown = ZodUnknown;
ZodUnknown.create = (params)=>{
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params)
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, parseUtil_js_1.addIssueToContext)(ctx, {
            code: ZodError_js_1.ZodIssueCode.invalid_type,
            expected: util_js_1.ZodParsedType.never,
            received: ctx.parsedType
        });
        return parseUtil_js_1.INVALID;
    }
}
exports.ZodNever = ZodNever;
ZodNever.create = (params)=>{
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params)
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.void,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodVoid = ZodVoid;
ZodVoid.create = (params)=>{
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params)
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== util_js_1.ZodParsedType.array) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.array,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: tooBig ? ZodError_js_1.ZodIssueCode.too_big : ZodError_js_1.ZodIssueCode.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return parseUtil_js_1.ParseStatus.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return parseUtil_js_1.ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: {
                value: minLength,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: {
                value: len,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
exports.ZodArray = ZodArray;
ZodArray.create = (schema, params)=>{
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params)
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof ZodArray) return new ZodArray({
        ...schema._def,
        type: deepPartialify(schema.element)
    });
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map((item)=>deepPartialify(item)));
    else return schema;
}
class ZodObject extends ZodType {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = util_js_1.util.objectKeys(shape);
        this._cached = {
            shape,
            keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key,
                    value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return parseUtil_js_1.ParseStatus.mergeObjectSync(status, syncPairs);
        });
        else return parseUtil_js_1.ParseStatus.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil_js_1.errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: errorUtil_js_1.errorUtil.errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of util_js_1.util.objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of util_js_1.util.objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of util_js_1.util.objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of util_js_1.util.objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof ZodOptional)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return createZodEnum(util_js_1.util.objectKeys(this.shape));
    }
}
exports.ZodObject = ZodObject;
ZodObject.create = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.strictCreate = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.lazycreate = (shape, params)=>{
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new ZodError_js_1.ZodError(result.ctx.common.issues));
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union,
                unionErrors
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new ZodError_js_1.ZodError(issues));
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union,
                unionErrors
            });
            return parseUtil_js_1.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
exports.ZodUnion = ZodUnion;
ZodUnion.create = (types, params)=>{
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type)=>{
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return util_js_1.util.objectValues(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else if (type instanceof ZodOptional) return [
        undefined,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodNullable) return [
        null,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodBranded) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodReadonly) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodCatch) return getDiscriminator(type._def.innerType);
    else return [];
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.object) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params)
        });
    }
}
exports.ZodDiscriminatedUnion = ZodDiscriminatedUnion;
function mergeValues(a, b) {
    const aType = (0, util_js_1.getParsedType)(a);
    const bType = (0, util_js_1.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === util_js_1.ZodParsedType.object && bType === util_js_1.ZodParsedType.object) {
        const bKeys = util_js_1.util.objectKeys(b);
        const sharedKeys = util_js_1.util.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === util_js_1.ZodParsedType.array && bType === util_js_1.ZodParsedType.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === util_js_1.ZodParsedType.date && bType === util_js_1.ZodParsedType.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, parseUtil_js_1.isAborted)(parsedLeft) || (0, parseUtil_js_1.isAborted)(parsedRight)) return parseUtil_js_1.INVALID;
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.invalid_intersection_types
                });
                return parseUtil_js_1.INVALID;
            }
            if ((0, parseUtil_js_1.isDirty)(parsedLeft) || (0, parseUtil_js_1.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
exports.ZodIntersection = ZodIntersection;
ZodIntersection.create = (left, right, params)=>{
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params)
    });
};
// type ZodTupleItems = [ZodTypeAny, ...ZodTypeAny[]];
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.array) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.array,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return parseUtil_js_1.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return parseUtil_js_1.ParseStatus.mergeArray(status, results);
        });
        else return parseUtil_js_1.ParseStatus.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest
        });
    }
}
exports.ZodTuple = ZodTuple;
ZodTuple.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params)
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.object) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return parseUtil_js_1.ParseStatus.mergeObjectAsync(status, pairs);
        else return parseUtil_js_1.ParseStatus.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) return new ZodRecord({
            keyType: first,
            valueType: second,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(third)
        });
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second)
        });
    }
}
exports.ZodRecord = ZodRecord;
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.map) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.map,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return parseUtil_js_1.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return parseUtil_js_1.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
exports.ZodMap = ZodMap;
ZodMap.create = (keyType, valueType, params)=>{
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params)
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.set) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.set,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return parseUtil_js_1.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: {
                value: minSize,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
exports.ZodSet = ZodSet;
ZodSet.create = (valueType, params)=>{
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params)
    });
};
class ZodFunction extends ZodType {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.function) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.function,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, parseUtil_js_1.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, errors_js_1.getErrorMap)(),
                    errors_js_1.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodError_js_1.ZodIssueCode.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, parseUtil_js_1.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, errors_js_1.getErrorMap)(),
                    errors_js_1.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodError_js_1.ZodIssueCode.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, parseUtil_js_1.OK)(async function(...args) {
                const error = new ZodError_js_1.ZodError([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, parseUtil_js_1.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new ZodError_js_1.ZodError([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new ZodError_js_1.ZodError([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create())
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params)
        });
    }
}
exports.ZodFunction = ZodFunction;
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
exports.ZodLazy = ZodLazy;
ZodLazy.create = (getter, params)=>{
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params)
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_literal,
                expected: this._def.value
            });
            return parseUtil_js_1.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
exports.ZodLiteral = ZodLiteral;
ZodLiteral.create = (value, params)=>{
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params)
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params)
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                expected: util_js_1.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodError_js_1.ZodIssueCode.invalid_type
            });
            return parseUtil_js_1.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
exports.ZodEnum = ZodEnum;
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util_js_1.util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.string && ctx.parsedType !== util_js_1.ZodParsedType.number) {
            const expectedValues = util_js_1.util.objectValues(nativeEnumValues);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                expected: util_js_1.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodError_js_1.ZodIssueCode.invalid_type
            });
            return parseUtil_js_1.INVALID;
        }
        if (!this._cache) this._cache = new Set(util_js_1.util.getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = util_js_1.util.objectValues(nativeEnumValues);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
exports.ZodNativeEnum = ZodNativeEnum;
ZodNativeEnum.create = (values, params)=>{
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params)
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.promise && ctx.common.async === false) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.promise,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const promisified = ctx.parsedType === util_js_1.ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, parseUtil_js_1.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
exports.ZodPromise = ZodPromise;
ZodPromise.create = (schema, params)=>{
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params)
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, parseUtil_js_1.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return parseUtil_js_1.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return parseUtil_js_1.INVALID;
                if (result.status === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                if (status.value === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return parseUtil_js_1.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return parseUtil_js_1.INVALID;
                if (result.status === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                if (status.value === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return parseUtil_js_1.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return parseUtil_js_1.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, parseUtil_js_1.isValid)(base)) return parseUtil_js_1.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, parseUtil_js_1.isValid)(base)) return parseUtil_js_1.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        util_js_1.util.assertNever(effect);
    }
}
exports.ZodEffects = ZodEffects;
exports.ZodTransformer = ZodEffects;
ZodEffects.create = (schema, effect, params)=>{
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params)
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params)=>{
    return new ZodEffects({
        schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params)
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === util_js_1.ZodParsedType.undefined) return (0, parseUtil_js_1.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodOptional = ZodOptional;
ZodOptional.create = (type, params)=>{
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params)
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === util_js_1.ZodParsedType.null) return (0, parseUtil_js_1.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodNullable = ZodNullable;
ZodNullable.create = (type, params)=>{
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params)
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === util_js_1.ZodParsedType.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
exports.ZodDefault = ZodDefault;
ZodDefault.create = (type, params)=>{
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...processCreateParams(params)
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, parseUtil_js_1.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new ZodError_js_1.ZodError(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new ZodError_js_1.ZodError(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
exports.ZodCatch = ZodCatch;
ZodCatch.create = (type, params)=>{
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...processCreateParams(params)
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.nan,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
exports.ZodNaN = ZodNaN;
ZodNaN.create = (params)=>{
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params)
    });
};
exports.BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
exports.ZodBranded = ZodBranded;
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return parseUtil_js_1.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, parseUtil_js_1.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return parseUtil_js_1.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline
        });
    }
}
exports.ZodPipeline = ZodPipeline;
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, parseUtil_js_1.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, parseUtil_js_1.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodReadonly = ZodReadonly;
ZodReadonly.create = (type, params)=>{
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function custom(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return ZodAny.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return ZodAny.create();
}
exports.late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (exports.ZodFirstPartyTypeKind = ZodFirstPartyTypeKind = {}));
// requires TS 4.4+
class Class {
    constructor(..._){}
}
const instanceOfType = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>custom((data)=>data instanceof cls, params);
exports.instanceof = instanceOfType;
const stringType = ZodString.create;
exports.string = stringType;
const numberType = ZodNumber.create;
exports.number = numberType;
const nanType = ZodNaN.create;
exports.nan = nanType;
const bigIntType = ZodBigInt.create;
exports.bigint = bigIntType;
const booleanType = ZodBoolean.create;
exports.boolean = booleanType;
const dateType = ZodDate.create;
exports.date = dateType;
const symbolType = ZodSymbol.create;
exports.symbol = symbolType;
const undefinedType = ZodUndefined.create;
exports.undefined = undefinedType;
const nullType = ZodNull.create;
exports.null = nullType;
const anyType = ZodAny.create;
exports.any = anyType;
const unknownType = ZodUnknown.create;
exports.unknown = unknownType;
const neverType = ZodNever.create;
exports.never = neverType;
const voidType = ZodVoid.create;
exports.void = voidType;
const arrayType = ZodArray.create;
exports.array = arrayType;
const objectType = ZodObject.create;
exports.object = objectType;
const strictObjectType = ZodObject.strictCreate;
exports.strictObject = strictObjectType;
const unionType = ZodUnion.create;
exports.union = unionType;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
exports.discriminatedUnion = discriminatedUnionType;
const intersectionType = ZodIntersection.create;
exports.intersection = intersectionType;
const tupleType = ZodTuple.create;
exports.tuple = tupleType;
const recordType = ZodRecord.create;
exports.record = recordType;
const mapType = ZodMap.create;
exports.map = mapType;
const setType = ZodSet.create;
exports.set = setType;
const functionType = ZodFunction.create;
exports.function = functionType;
const lazyType = ZodLazy.create;
exports.lazy = lazyType;
const literalType = ZodLiteral.create;
exports.literal = literalType;
const enumType = ZodEnum.create;
exports.enum = enumType;
const nativeEnumType = ZodNativeEnum.create;
exports.nativeEnum = nativeEnumType;
const promiseType = ZodPromise.create;
exports.promise = promiseType;
const effectsType = ZodEffects.create;
exports.effect = effectsType;
exports.transformer = effectsType;
const optionalType = ZodOptional.create;
exports.optional = optionalType;
const nullableType = ZodNullable.create;
exports.nullable = nullableType;
const preprocessType = ZodEffects.createWithPreprocess;
exports.preprocess = preprocessType;
const pipelineType = ZodPipeline.create;
exports.pipeline = pipelineType;
const ostring = ()=>stringType().optional();
exports.ostring = ostring;
const onumber = ()=>numberType().optional();
exports.onumber = onumber;
const oboolean = ()=>booleanType().optional();
exports.oboolean = oboolean;
exports.coerce = {
    string: (arg)=>ZodString.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>ZodNumber.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>ZodBoolean.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>ZodBigInt.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>ZodDate.create({
            ...arg,
            coerce: true
        })
};
exports.NEVER = parseUtil_js_1.INVALID;

},{"9f99e7f611031e00":"cNSIG","2eb7d0c99f112498":"lgaCg","4ad097a777f8b065":"8CAjF","3ba8294f86dc472":"7yRV5","ca92ed557ffe3357":"17YkJ"}],"8CAjF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.errorUtil = void 0;
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})(errorUtil || (exports.errorUtil = errorUtil = {}));

},{}],"47Kxk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addHoursToDate = exports.lessThanAgoMs = exports.DAY = exports.HOUR = exports.MINUTE = exports.SECOND = void 0;
exports.SECOND = 1000;
exports.MINUTE = exports.SECOND * 60;
exports.HOUR = exports.MINUTE * 60;
exports.DAY = exports.HOUR * 24;
const lessThanAgoMs = (time, range)=>{
    return Date.now() < time.getTime() + range;
};
exports.lessThanAgoMs = lessThanAgoMs;
const addHoursToDate = (hours, startingDate)=>{
    // When date is passed, clone before calling `setHours()` so that we are not mutating the original date
    const currentDate = startingDate ? new Date(startingDate) : new Date();
    currentDate.setHours(currentDate.getHours() + hours);
    return currentDate;
};
exports.addHoursToDate = addHoursToDate;

},{}],"hkD7w":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
        }
        __setModuleDefault(result, mod);
        return result;
    };
}();
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateLanguage = exports.parseLanguage = exports.b64UrlToUtf8 = exports.utf8ToB64Url = exports.graphemeLen = exports.utf8Len = void 0;
const graphemer_1 = __importDefault(require("c5087e7f8d518616"));
const ui8 = __importStar(require("e080ed2579202f93"));
// counts the number of bytes in a utf8 string
const utf8Len = (str)=>{
    return new TextEncoder().encode(str).byteLength;
};
exports.utf8Len = utf8Len;
// counts the number of graphemes (user-displayed characters) in a string
const graphemeLen = (str)=>{
    const splitter = new graphemer_1.default();
    return splitter.countGraphemes(str);
};
exports.graphemeLen = graphemeLen;
const utf8ToB64Url = (utf8)=>{
    return ui8.toString(ui8.fromString(utf8, 'utf8'), 'base64url');
};
exports.utf8ToB64Url = utf8ToB64Url;
const b64UrlToUtf8 = (b64)=>{
    return ui8.toString(ui8.fromString(b64, 'base64url'), 'utf8');
};
exports.b64UrlToUtf8 = b64UrlToUtf8;
const parseLanguage = (langTag)=>{
    const parsed = langTag.match(bcp47Regexp);
    if (!parsed?.groups) return null;
    const parts = parsed.groups;
    return {
        grandfathered: parts.grandfathered,
        language: parts.language,
        extlang: parts.extlang,
        script: parts.script,
        region: parts.region,
        variant: parts.variant,
        extension: parts.extension,
        privateUse: parts.privateUseA || parts.privateUseB
    };
};
exports.parseLanguage = parseLanguage;
const validateLanguage = (langTag)=>{
    return bcp47Regexp.test(langTag);
};
exports.validateLanguage = validateLanguage;
// Validates well-formed BCP 47 syntax: https://www.rfc-editor.org/rfc/rfc5646.html#section-2.1
const bcp47Regexp = /^((?<grandfathered>(en-GB-oed|i-ami|i-bnn|i-default|i-enochian|i-hak|i-klingon|i-lux|i-mingo|i-navajo|i-pwn|i-tao|i-tay|i-tsu|sgn-BE-FR|sgn-BE-NL|sgn-CH-DE)|(art-lojban|cel-gaulish|no-bok|no-nyn|zh-guoyu|zh-hakka|zh-min|zh-min-nan|zh-xiang))|((?<language>([A-Za-z]{2,3}(-(?<extlang>[A-Za-z]{3}(-[A-Za-z]{3}){0,2}))?)|[A-Za-z]{4}|[A-Za-z]{5,8})(-(?<script>[A-Za-z]{4}))?(-(?<region>[A-Za-z]{2}|[0-9]{3}))?(-(?<variant>[A-Za-z0-9]{5,8}|[0-9][A-Za-z0-9]{3}))*(-(?<extension>[0-9A-WY-Za-wy-z](-[A-Za-z0-9]{2,8})+))*(-(?<privateUseA>x(-[A-Za-z0-9]{1,8})+))?)|(?<privateUseB>x(-[A-Za-z0-9]{1,8})+))$/;

},{"c5087e7f8d518616":"jkUNX","e080ed2579202f93":"fQvn8"}],"jkUNX":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
const Graphemer_1 = __importDefault(require("704bc5d352163c90"));
exports.default = Graphemer_1.default;

},{"704bc5d352163c90":"aBLtA"}],"aBLtA":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
const boundaries_1 = require("c66f707714d0a681");
const GraphemerHelper_1 = __importDefault(require("cf456655d60f0dc1"));
const GraphemerIterator_1 = __importDefault(require("4da0ff3200da4614"));
class Graphemer {
    /**
     * Returns the next grapheme break in the string after the given index
     * @param string {string}
     * @param index {number}
     * @returns {number}
     */ static nextBreak(string, index) {
        if (index === undefined) index = 0;
        if (index < 0) return 0;
        if (index >= string.length - 1) return string.length;
        const prevCP = GraphemerHelper_1.default.codePointAt(string, index);
        const prev = Graphemer.getGraphemeBreakProperty(prevCP);
        const prevEmoji = Graphemer.getEmojiProperty(prevCP);
        const mid = [];
        const midEmoji = [];
        for(let i = index + 1; i < string.length; i++){
            // check for already processed low surrogates
            if (GraphemerHelper_1.default.isSurrogate(string, i - 1)) continue;
            const nextCP = GraphemerHelper_1.default.codePointAt(string, i);
            const next = Graphemer.getGraphemeBreakProperty(nextCP);
            const nextEmoji = Graphemer.getEmojiProperty(nextCP);
            if (GraphemerHelper_1.default.shouldBreak(prev, mid, next, prevEmoji, midEmoji, nextEmoji)) return i;
            mid.push(next);
            midEmoji.push(nextEmoji);
        }
        return string.length;
    }
    /**
     * Breaks the given string into an array of grapheme clusters
     * @param str {string}
     * @returns {string[]}
     */ splitGraphemes(str) {
        const res = [];
        let index = 0;
        let brk;
        while((brk = Graphemer.nextBreak(str, index)) < str.length){
            res.push(str.slice(index, brk));
            index = brk;
        }
        if (index < str.length) res.push(str.slice(index));
        return res;
    }
    /**
     * Returns an iterator of grapheme clusters in the given string
     * @param str {string}
     * @returns {GraphemerIterator}
     */ iterateGraphemes(str) {
        return new GraphemerIterator_1.default(str, Graphemer.nextBreak);
    }
    /**
     * Returns the number of grapheme clusters in the given string
     * @param str {string}
     * @returns {number}
     */ countGraphemes(str) {
        let count = 0;
        let index = 0;
        let brk;
        while((brk = Graphemer.nextBreak(str, index)) < str.length){
            index = brk;
            count++;
        }
        if (index < str.length) count++;
        return count;
    }
    /**
     * Given a Unicode code point, determines this symbol's grapheme break property
     * @param code {number} Unicode code point
     * @returns {number}
     */ static getGraphemeBreakProperty(code) {
        // Grapheme break property taken from:
        // https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakProperty.txt
        // and generated by
        // node ./scripts/generate-grapheme-break.js
        if (code < 0xbf09) {
            if (code < 0xac54) {
                if (code < 0x102d) {
                    if (code < 0xb02) {
                        if (code < 0x93b) {
                            if (code < 0x6df) {
                                if (code < 0x5bf) {
                                    if (code < 0x7f) {
                                        if (code < 0xb) {
                                            if (code < 0xa) {
                                                // Cc  [10] <control-0000>..<control-0009>
                                                if (0x0 <= code && code <= 0x9) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                            } else {
                                                // Cc       <control-000A>
                                                if (0xa === code) return boundaries_1.CLUSTER_BREAK.LF;
                                            }
                                        } else {
                                            if (code < 0xd) {
                                                // Cc   [2] <control-000B>..<control-000C>
                                                if (0xb <= code && code <= 0xc) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                            } else if (code < 0xe) {
                                                // Cc       <control-000D>
                                                if (0xd === code) return boundaries_1.CLUSTER_BREAK.CR;
                                            } else {
                                                // Cc  [18] <control-000E>..<control-001F>
                                                if (0xe <= code && code <= 0x1f) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                            }
                                        }
                                    } else if (code < 0x300) {
                                        if (code < 0xad) {
                                            // Cc  [33] <control-007F>..<control-009F>
                                            if (0x7f <= code && code <= 0x9f) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                        } else {
                                            // Cf       SOFT HYPHEN
                                            if (0xad === code) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                        }
                                    } else {
                                        if (code < 0x483) {
                                            // Mn [112] COMBINING GRAVE ACCENT..COMBINING LATIN SMALL LETTER X
                                            if (0x300 <= code && code <= 0x36f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x591) {
                                            // Mn   [5] COMBINING CYRILLIC TITLO..COMBINING CYRILLIC POKRYTIE
                                            // Me   [2] COMBINING CYRILLIC HUNDRED THOUSANDS SIGN..COMBINING CYRILLIC MILLIONS SIGN
                                            if (0x483 <= code && code <= 0x489) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn  [45] HEBREW ACCENT ETNAHTA..HEBREW POINT METEG
                                            if (0x591 <= code && code <= 0x5bd) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else {
                                    if (code < 0x610) {
                                        if (code < 0x5c4) {
                                            if (code < 0x5c1) {
                                                // Mn       HEBREW POINT RAFE
                                                if (0x5bf === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mn   [2] HEBREW POINT SHIN DOT..HEBREW POINT SIN DOT
                                                if (0x5c1 <= code && code <= 0x5c2) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else {
                                            if (code < 0x5c7) {
                                                // Mn   [2] HEBREW MARK UPPER DOT..HEBREW MARK LOWER DOT
                                                if (0x5c4 <= code && code <= 0x5c5) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else if (code < 0x600) {
                                                // Mn       HEBREW POINT QAMATS QATAN
                                                if (0x5c7 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Cf   [6] ARABIC NUMBER SIGN..ARABIC NUMBER MARK ABOVE
                                                if (0x600 <= code && code <= 0x605) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                            }
                                        }
                                    } else if (code < 0x670) {
                                        if (code < 0x61c) {
                                            // Mn  [11] ARABIC SIGN SALLALLAHOU ALAYHE WASSALLAM..ARABIC SMALL KASRA
                                            if (0x610 <= code && code <= 0x61a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x64b) {
                                            // Cf       ARABIC LETTER MARK
                                            if (0x61c === code) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                        } else {
                                            // Mn  [21] ARABIC FATHATAN..ARABIC WAVY HAMZA BELOW
                                            if (0x64b <= code && code <= 0x65f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x6d6) {
                                            // Mn       ARABIC LETTER SUPERSCRIPT ALEF
                                            if (0x670 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x6dd) {
                                            // Mn   [7] ARABIC SMALL HIGH LIGATURE SAD WITH LAM WITH ALEF MAKSURA..ARABIC SMALL HIGH SEEN
                                            if (0x6d6 <= code && code <= 0x6dc) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Cf       ARABIC END OF AYAH
                                            if (0x6dd === code) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                        }
                                    }
                                }
                            } else {
                                if (code < 0x81b) {
                                    if (code < 0x730) {
                                        if (code < 0x6ea) {
                                            if (code < 0x6e7) {
                                                // Mn   [6] ARABIC SMALL HIGH ROUNDED ZERO..ARABIC SMALL HIGH MADDA
                                                if (0x6df <= code && code <= 0x6e4) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mn   [2] ARABIC SMALL HIGH YEH..ARABIC SMALL HIGH NOON
                                                if (0x6e7 <= code && code <= 0x6e8) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else if (code < 0x70f) {
                                            // Mn   [4] ARABIC EMPTY CENTRE LOW STOP..ARABIC SMALL LOW MEEM
                                            if (0x6ea <= code && code <= 0x6ed) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Cf       SYRIAC ABBREVIATION MARK
                                            if (0x70f === code) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                            // Mn       SYRIAC LETTER SUPERSCRIPT ALAPH
                                            if (0x711 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else if (code < 0x7eb) {
                                        if (code < 0x7a6) {
                                            // Mn  [27] SYRIAC PTHAHA ABOVE..SYRIAC BARREKH
                                            if (0x730 <= code && code <= 0x74a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn  [11] THAANA ABAFILI..THAANA SUKUN
                                            if (0x7a6 <= code && code <= 0x7b0) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x7fd) {
                                            // Mn   [9] NKO COMBINING SHORT HIGH TONE..NKO COMBINING DOUBLE DOT ABOVE
                                            if (0x7eb <= code && code <= 0x7f3) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x816) {
                                            // Mn       NKO DANTAYALAN
                                            if (0x7fd === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [4] SAMARITAN MARK IN..SAMARITAN MARK DAGESH
                                            if (0x816 <= code && code <= 0x819) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0x898) {
                                    if (code < 0x829) {
                                        if (code < 0x825) {
                                            // Mn   [9] SAMARITAN MARK EPENTHETIC YUT..SAMARITAN VOWEL SIGN A
                                            if (0x81b <= code && code <= 0x823) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [3] SAMARITAN VOWEL SIGN SHORT A..SAMARITAN VOWEL SIGN U
                                            if (0x825 <= code && code <= 0x827) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x859) {
                                            // Mn   [5] SAMARITAN VOWEL SIGN LONG I..SAMARITAN MARK NEQUDAA
                                            if (0x829 <= code && code <= 0x82d) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x890) {
                                            // Mn   [3] MANDAIC AFFRICATION MARK..MANDAIC GEMINATION MARK
                                            if (0x859 <= code && code <= 0x85b) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Cf   [2] ARABIC POUND MARK ABOVE..ARABIC PIASTRE MARK ABOVE
                                            if (0x890 <= code && code <= 0x891) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                        }
                                    }
                                } else {
                                    if (code < 0x8e3) {
                                        if (code < 0x8ca) {
                                            // Mn   [8] ARABIC SMALL HIGH WORD AL-JUZ..ARABIC HALF MADDA OVER MADDA
                                            if (0x898 <= code && code <= 0x89f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x8e2) {
                                            // Mn  [24] ARABIC SMALL HIGH FARSI YEH..ARABIC SMALL HIGH SIGN SAFHA
                                            if (0x8ca <= code && code <= 0x8e1) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Cf       ARABIC DISPUTED END OF AYAH
                                            if (0x8e2 === code) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                        }
                                    } else if (code < 0x903) {
                                        // Mn  [32] ARABIC TURNED DAMMA BELOW..DEVANAGARI SIGN ANUSVARA
                                        if (0x8e3 <= code && code <= 0x902) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc       DEVANAGARI SIGN VISARGA
                                        if (0x903 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        // Mn       DEVANAGARI VOWEL SIGN OE
                                        if (0x93a === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            }
                        } else {
                            if (code < 0xa01) {
                                if (code < 0x982) {
                                    if (code < 0x94d) {
                                        if (code < 0x93e) {
                                            // Mc       DEVANAGARI VOWEL SIGN OOE
                                            if (0x93b === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                            // Mn       DEVANAGARI SIGN NUKTA
                                            if (0x93c === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            if (code < 0x941) {
                                                // Mc   [3] DEVANAGARI VOWEL SIGN AA..DEVANAGARI VOWEL SIGN II
                                                if (0x93e <= code && code <= 0x940) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (code < 0x949) {
                                                // Mn   [8] DEVANAGARI VOWEL SIGN U..DEVANAGARI VOWEL SIGN AI
                                                if (0x941 <= code && code <= 0x948) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mc   [4] DEVANAGARI VOWEL SIGN CANDRA O..DEVANAGARI VOWEL SIGN AU
                                                if (0x949 <= code && code <= 0x94c) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                            }
                                        }
                                    } else if (code < 0x951) {
                                        if (code < 0x94e) {
                                            // Mn       DEVANAGARI SIGN VIRAMA
                                            if (0x94d === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [2] DEVANAGARI VOWEL SIGN PRISHTHAMATRA E..DEVANAGARI VOWEL SIGN AW
                                            if (0x94e <= code && code <= 0x94f) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else {
                                        if (code < 0x962) {
                                            // Mn   [7] DEVANAGARI STRESS SIGN UDATTA..DEVANAGARI VOWEL SIGN UUE
                                            if (0x951 <= code && code <= 0x957) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x981) {
                                            // Mn   [2] DEVANAGARI VOWEL SIGN VOCALIC L..DEVANAGARI VOWEL SIGN VOCALIC LL
                                            if (0x962 <= code && code <= 0x963) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn       BENGALI SIGN CANDRABINDU
                                            if (0x981 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else {
                                    if (code < 0x9c7) {
                                        if (code < 0x9be) {
                                            if (code < 0x9bc) {
                                                // Mc   [2] BENGALI SIGN ANUSVARA..BENGALI SIGN VISARGA
                                                if (0x982 <= code && code <= 0x983) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                            } else {
                                                // Mn       BENGALI SIGN NUKTA
                                                if (0x9bc === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else {
                                            if (code < 0x9bf) {
                                                // Mc       BENGALI VOWEL SIGN AA
                                                if (0x9be === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else if (code < 0x9c1) {
                                                // Mc   [2] BENGALI VOWEL SIGN I..BENGALI VOWEL SIGN II
                                                if (0x9bf <= code && code <= 0x9c0) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                            } else {
                                                // Mn   [4] BENGALI VOWEL SIGN U..BENGALI VOWEL SIGN VOCALIC RR
                                                if (0x9c1 <= code && code <= 0x9c4) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            }
                                        }
                                    } else if (code < 0x9d7) {
                                        if (code < 0x9cb) {
                                            // Mc   [2] BENGALI VOWEL SIGN E..BENGALI VOWEL SIGN AI
                                            if (0x9c7 <= code && code <= 0x9c8) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0x9cd) {
                                            // Mc   [2] BENGALI VOWEL SIGN O..BENGALI VOWEL SIGN AU
                                            if (0x9cb <= code && code <= 0x9cc) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn       BENGALI SIGN VIRAMA
                                            if (0x9cd === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x9e2) {
                                            // Mc       BENGALI AU LENGTH MARK
                                            if (0x9d7 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x9fe) {
                                            // Mn   [2] BENGALI VOWEL SIGN VOCALIC L..BENGALI VOWEL SIGN VOCALIC LL
                                            if (0x9e2 <= code && code <= 0x9e3) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn       BENGALI SANDHI MARK
                                            if (0x9fe === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                }
                            } else if (code < 0xa83) {
                                if (code < 0xa47) {
                                    if (code < 0xa3c) {
                                        if (code < 0xa03) {
                                            // Mn   [2] GURMUKHI SIGN ADAK BINDI..GURMUKHI SIGN BINDI
                                            if (0xa01 <= code && code <= 0xa02) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       GURMUKHI SIGN VISARGA
                                            if (0xa03 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else {
                                        if (code < 0xa3e) {
                                            // Mn       GURMUKHI SIGN NUKTA
                                            if (0xa3c === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0xa41) {
                                            // Mc   [3] GURMUKHI VOWEL SIGN AA..GURMUKHI VOWEL SIGN II
                                            if (0xa3e <= code && code <= 0xa40) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [2] GURMUKHI VOWEL SIGN U..GURMUKHI VOWEL SIGN UU
                                            if (0xa41 <= code && code <= 0xa42) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0xa70) {
                                    if (code < 0xa4b) {
                                        // Mn   [2] GURMUKHI VOWEL SIGN EE..GURMUKHI VOWEL SIGN AI
                                        if (0xa47 <= code && code <= 0xa48) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xa51) {
                                        // Mn   [3] GURMUKHI VOWEL SIGN OO..GURMUKHI SIGN VIRAMA
                                        if (0xa4b <= code && code <= 0xa4d) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       GURMUKHI SIGN UDAAT
                                        if (0xa51 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xa75) {
                                        // Mn   [2] GURMUKHI TIPPI..GURMUKHI ADDAK
                                        if (0xa70 <= code && code <= 0xa71) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xa81) {
                                        // Mn       GURMUKHI SIGN YAKASH
                                        if (0xa75 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] GUJARATI SIGN CANDRABINDU..GUJARATI SIGN ANUSVARA
                                        if (0xa81 <= code && code <= 0xa82) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0xac9) {
                                    if (code < 0xabe) {
                                        // Mc       GUJARATI SIGN VISARGA
                                        if (0xa83 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        // Mn       GUJARATI SIGN NUKTA
                                        if (0xabc === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (code < 0xac1) {
                                            // Mc   [3] GUJARATI VOWEL SIGN AA..GUJARATI VOWEL SIGN II
                                            if (0xabe <= code && code <= 0xac0) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0xac7) {
                                            // Mn   [5] GUJARATI VOWEL SIGN U..GUJARATI VOWEL SIGN CANDRA E
                                            if (0xac1 <= code && code <= 0xac5) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [2] GUJARATI VOWEL SIGN E..GUJARATI VOWEL SIGN AI
                                            if (0xac7 <= code && code <= 0xac8) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0xae2) {
                                    if (code < 0xacb) {
                                        // Mc       GUJARATI VOWEL SIGN CANDRA O
                                        if (0xac9 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xacd) {
                                        // Mc   [2] GUJARATI VOWEL SIGN O..GUJARATI VOWEL SIGN AU
                                        if (0xacb <= code && code <= 0xacc) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       GUJARATI SIGN VIRAMA
                                        if (0xacd === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xafa) {
                                        // Mn   [2] GUJARATI VOWEL SIGN VOCALIC L..GUJARATI VOWEL SIGN VOCALIC LL
                                        if (0xae2 <= code && code <= 0xae3) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xb01) {
                                        // Mn   [6] GUJARATI SIGN SUKUN..GUJARATI SIGN TWO-CIRCLE NUKTA ABOVE
                                        if (0xafa <= code && code <= 0xaff) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       ORIYA SIGN CANDRABINDU
                                        if (0xb01 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            }
                        }
                    } else if (code < 0xcf3) {
                        if (code < 0xc04) {
                            if (code < 0xb82) {
                                if (code < 0xb47) {
                                    if (code < 0xb3e) {
                                        if (code < 0xb3c) {
                                            // Mc   [2] ORIYA SIGN ANUSVARA..ORIYA SIGN VISARGA
                                            if (0xb02 <= code && code <= 0xb03) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn       ORIYA SIGN NUKTA
                                            if (0xb3c === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0xb40) {
                                            // Mc       ORIYA VOWEL SIGN AA
                                            // Mn       ORIYA VOWEL SIGN I
                                            if (0xb3e <= code && code <= 0xb3f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0xb41) {
                                            // Mc       ORIYA VOWEL SIGN II
                                            if (0xb40 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [4] ORIYA VOWEL SIGN U..ORIYA VOWEL SIGN VOCALIC RR
                                            if (0xb41 <= code && code <= 0xb44) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0xb4d) {
                                    if (code < 0xb4b) {
                                        // Mc   [2] ORIYA VOWEL SIGN E..ORIYA VOWEL SIGN AI
                                        if (0xb47 <= code && code <= 0xb48) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mc   [2] ORIYA VOWEL SIGN O..ORIYA VOWEL SIGN AU
                                        if (0xb4b <= code && code <= 0xb4c) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0xb55) {
                                        // Mn       ORIYA SIGN VIRAMA
                                        if (0xb4d === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xb62) {
                                        // Mn   [2] ORIYA SIGN OVERLINE..ORIYA AI LENGTH MARK
                                        // Mc       ORIYA AU LENGTH MARK
                                        if (0xb55 <= code && code <= 0xb57) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] ORIYA VOWEL SIGN VOCALIC L..ORIYA VOWEL SIGN VOCALIC LL
                                        if (0xb62 <= code && code <= 0xb63) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0xbc6) {
                                    if (code < 0xbbf) {
                                        // Mn       TAMIL SIGN ANUSVARA
                                        if (0xb82 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        // Mc       TAMIL VOWEL SIGN AA
                                        if (0xbbe === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (code < 0xbc0) {
                                            // Mc       TAMIL VOWEL SIGN I
                                            if (0xbbf === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0xbc1) {
                                            // Mn       TAMIL VOWEL SIGN II
                                            if (0xbc0 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [2] TAMIL VOWEL SIGN U..TAMIL VOWEL SIGN UU
                                            if (0xbc1 <= code && code <= 0xbc2) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                } else if (code < 0xbd7) {
                                    if (code < 0xbca) {
                                        // Mc   [3] TAMIL VOWEL SIGN E..TAMIL VOWEL SIGN AI
                                        if (0xbc6 <= code && code <= 0xbc8) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xbcd) {
                                        // Mc   [3] TAMIL VOWEL SIGN O..TAMIL VOWEL SIGN AU
                                        if (0xbca <= code && code <= 0xbcc) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       TAMIL SIGN VIRAMA
                                        if (0xbcd === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xc00) {
                                        // Mc       TAMIL AU LENGTH MARK
                                        if (0xbd7 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xc01) {
                                        // Mn       TELUGU SIGN COMBINING CANDRABINDU ABOVE
                                        if (0xc00 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [3] TELUGU SIGN CANDRABINDU..TELUGU SIGN VISARGA
                                        if (0xc01 <= code && code <= 0xc03) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            }
                        } else if (code < 0xcbe) {
                            if (code < 0xc4a) {
                                if (code < 0xc3e) {
                                    // Mn       TELUGU SIGN COMBINING ANUSVARA ABOVE
                                    if (0xc04 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    // Mn       TELUGU SIGN NUKTA
                                    if (0xc3c === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (code < 0xc41) {
                                        // Mn   [3] TELUGU VOWEL SIGN AA..TELUGU VOWEL SIGN II
                                        if (0xc3e <= code && code <= 0xc40) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xc46) {
                                        // Mc   [4] TELUGU VOWEL SIGN U..TELUGU VOWEL SIGN VOCALIC RR
                                        if (0xc41 <= code && code <= 0xc44) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [3] TELUGU VOWEL SIGN E..TELUGU VOWEL SIGN AI
                                        if (0xc46 <= code && code <= 0xc48) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0xc81) {
                                if (code < 0xc55) {
                                    // Mn   [4] TELUGU VOWEL SIGN O..TELUGU SIGN VIRAMA
                                    if (0xc4a <= code && code <= 0xc4d) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xc62) {
                                    // Mn   [2] TELUGU LENGTH MARK..TELUGU AI LENGTH MARK
                                    if (0xc55 <= code && code <= 0xc56) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [2] TELUGU VOWEL SIGN VOCALIC L..TELUGU VOWEL SIGN VOCALIC LL
                                    if (0xc62 <= code && code <= 0xc63) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0xc82) {
                                    // Mn       KANNADA SIGN CANDRABINDU
                                    if (0xc81 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xcbc) {
                                    // Mc   [2] KANNADA SIGN ANUSVARA..KANNADA SIGN VISARGA
                                    if (0xc82 <= code && code <= 0xc83) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       KANNADA SIGN NUKTA
                                    if (0xcbc === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0xcc6) {
                                if (code < 0xcc0) {
                                    // Mc       KANNADA VOWEL SIGN AA
                                    if (0xcbe === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       KANNADA VOWEL SIGN I
                                    if (0xcbf === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (code < 0xcc2) {
                                        // Mc   [2] KANNADA VOWEL SIGN II..KANNADA VOWEL SIGN U
                                        if (0xcc0 <= code && code <= 0xcc1) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xcc3) {
                                        // Mc       KANNADA VOWEL SIGN UU
                                        if (0xcc2 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] KANNADA VOWEL SIGN VOCALIC R..KANNADA VOWEL SIGN VOCALIC RR
                                        if (0xcc3 <= code && code <= 0xcc4) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else if (code < 0xccc) {
                                if (code < 0xcc7) {
                                    // Mn       KANNADA VOWEL SIGN E
                                    if (0xcc6 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xcca) {
                                    // Mc   [2] KANNADA VOWEL SIGN EE..KANNADA VOWEL SIGN AI
                                    if (0xcc7 <= code && code <= 0xcc8) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mc   [2] KANNADA VOWEL SIGN O..KANNADA VOWEL SIGN OO
                                    if (0xcca <= code && code <= 0xccb) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0xcd5) {
                                    // Mn   [2] KANNADA VOWEL SIGN AU..KANNADA SIGN VIRAMA
                                    if (0xccc <= code && code <= 0xccd) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xce2) {
                                    // Mc   [2] KANNADA LENGTH MARK..KANNADA AI LENGTH MARK
                                    if (0xcd5 <= code && code <= 0xcd6) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [2] KANNADA VOWEL SIGN VOCALIC L..KANNADA VOWEL SIGN VOCALIC LL
                                    if (0xce2 <= code && code <= 0xce3) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    } else {
                        if (code < 0xddf) {
                            if (code < 0xd4e) {
                                if (code < 0xd3f) {
                                    if (code < 0xd02) {
                                        if (code < 0xd00) {
                                            // Mc       KANNADA SIGN COMBINING ANUSVARA ABOVE RIGHT
                                            if (0xcf3 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [2] MALAYALAM SIGN COMBINING ANUSVARA ABOVE..MALAYALAM SIGN CANDRABINDU
                                            if (0xd00 <= code && code <= 0xd01) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0xd3b) {
                                            // Mc   [2] MALAYALAM SIGN ANUSVARA..MALAYALAM SIGN VISARGA
                                            if (0xd02 <= code && code <= 0xd03) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0xd3e) {
                                            // Mn   [2] MALAYALAM SIGN VERTICAL BAR VIRAMA..MALAYALAM SIGN CIRCULAR VIRAMA
                                            if (0xd3b <= code && code <= 0xd3c) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       MALAYALAM VOWEL SIGN AA
                                            if (0xd3e === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0xd46) {
                                    if (code < 0xd41) {
                                        // Mc   [2] MALAYALAM VOWEL SIGN I..MALAYALAM VOWEL SIGN II
                                        if (0xd3f <= code && code <= 0xd40) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [4] MALAYALAM VOWEL SIGN U..MALAYALAM VOWEL SIGN VOCALIC RR
                                        if (0xd41 <= code && code <= 0xd44) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xd4a) {
                                        // Mc   [3] MALAYALAM VOWEL SIGN E..MALAYALAM VOWEL SIGN AI
                                        if (0xd46 <= code && code <= 0xd48) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xd4d) {
                                        // Mc   [3] MALAYALAM VOWEL SIGN O..MALAYALAM VOWEL SIGN AU
                                        if (0xd4a <= code && code <= 0xd4c) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       MALAYALAM SIGN VIRAMA
                                        if (0xd4d === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0xdca) {
                                    if (code < 0xd62) {
                                        // Lo       MALAYALAM LETTER DOT REPH
                                        if (0xd4e === code) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                        // Mc       MALAYALAM AU LENGTH MARK
                                        if (0xd57 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (code < 0xd81) {
                                            // Mn   [2] MALAYALAM VOWEL SIGN VOCALIC L..MALAYALAM VOWEL SIGN VOCALIC LL
                                            if (0xd62 <= code && code <= 0xd63) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0xd82) {
                                            // Mn       SINHALA SIGN CANDRABINDU
                                            if (0xd81 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [2] SINHALA SIGN ANUSVARAYA..SINHALA SIGN VISARGAYA
                                            if (0xd82 <= code && code <= 0xd83) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                } else if (code < 0xdd2) {
                                    if (code < 0xdcf) {
                                        // Mn       SINHALA SIGN AL-LAKUNA
                                        if (0xdca === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xdd0) {
                                        // Mc       SINHALA VOWEL SIGN AELA-PILLA
                                        if (0xdcf === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] SINHALA VOWEL SIGN KETTI AEDA-PILLA..SINHALA VOWEL SIGN DIGA AEDA-PILLA
                                        if (0xdd0 <= code && code <= 0xdd1) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0xdd6) {
                                        // Mn   [3] SINHALA VOWEL SIGN KETTI IS-PILLA..SINHALA VOWEL SIGN KETTI PAA-PILLA
                                        if (0xdd2 <= code && code <= 0xdd4) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xdd8) {
                                        // Mn       SINHALA VOWEL SIGN DIGA PAA-PILLA
                                        if (0xdd6 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [7] SINHALA VOWEL SIGN GAETTA-PILLA..SINHALA VOWEL SIGN KOMBUVA HAA GAYANUKITTA
                                        if (0xdd8 <= code && code <= 0xdde) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            }
                        } else if (code < 0xf35) {
                            if (code < 0xe47) {
                                if (code < 0xe31) {
                                    if (code < 0xdf2) {
                                        // Mc       SINHALA VOWEL SIGN GAYANUKITTA
                                        if (0xddf === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] SINHALA VOWEL SIGN DIGA GAETTA-PILLA..SINHALA VOWEL SIGN DIGA GAYANUKITTA
                                        if (0xdf2 <= code && code <= 0xdf3) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0xe33) {
                                        // Mn       THAI CHARACTER MAI HAN-AKAT
                                        if (0xe31 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xe34) {
                                        // Lo       THAI CHARACTER SARA AM
                                        if (0xe33 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [7] THAI CHARACTER SARA I..THAI CHARACTER PHINTHU
                                        if (0xe34 <= code && code <= 0xe3a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0xeb4) {
                                if (code < 0xeb1) {
                                    // Mn   [8] THAI CHARACTER MAITAIKHU..THAI CHARACTER YAMAKKAN
                                    if (0xe47 <= code && code <= 0xe4e) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       LAO VOWEL SIGN MAI KAN
                                    if (0xeb1 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    // Lo       LAO VOWEL SIGN AM
                                    if (0xeb3 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0xec8) {
                                    // Mn   [9] LAO VOWEL SIGN I..LAO SEMIVOWEL SIGN LO
                                    if (0xeb4 <= code && code <= 0xebc) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xf18) {
                                    // Mn   [7] LAO TONE MAI EK..LAO YAMAKKAN
                                    if (0xec8 <= code && code <= 0xece) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [2] TIBETAN ASTROLOGICAL SIGN -KHYUD PA..TIBETAN ASTROLOGICAL SIGN SDONG TSHUGS
                                    if (0xf18 <= code && code <= 0xf19) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0xf7f) {
                                if (code < 0xf39) {
                                    // Mn       TIBETAN MARK NGAS BZUNG NYI ZLA
                                    if (0xf35 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    // Mn       TIBETAN MARK NGAS BZUNG SGOR RTAGS
                                    if (0xf37 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (code < 0xf3e) {
                                        // Mn       TIBETAN MARK TSA -PHRU
                                        if (0xf39 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xf71) {
                                        // Mc   [2] TIBETAN SIGN YAR TSHES..TIBETAN SIGN MAR TSHES
                                        if (0xf3e <= code && code <= 0xf3f) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn  [14] TIBETAN VOWEL SIGN AA..TIBETAN SIGN RJES SU NGA RO
                                        if (0xf71 <= code && code <= 0xf7e) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0xf8d) {
                                if (code < 0xf80) {
                                    // Mc       TIBETAN SIGN RNAM BCAD
                                    if (0xf7f === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0xf86) {
                                    // Mn   [5] TIBETAN VOWEL SIGN REVERSED I..TIBETAN MARK HALANTA
                                    if (0xf80 <= code && code <= 0xf84) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [2] TIBETAN SIGN LCI RTAGS..TIBETAN SIGN YANG RTAGS
                                    if (0xf86 <= code && code <= 0xf87) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0xf99) {
                                    // Mn  [11] TIBETAN SUBJOINED SIGN LCE TSA CAN..TIBETAN SUBJOINED LETTER JA
                                    if (0xf8d <= code && code <= 0xf97) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xfc6) {
                                    // Mn  [36] TIBETAN SUBJOINED LETTER NYA..TIBETAN SUBJOINED LETTER FIXED-FORM RA
                                    if (0xf99 <= code && code <= 0xfbc) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       TIBETAN SYMBOL PADMA GDAN
                                    if (0xfc6 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    }
                } else {
                    if (code < 0x1c24) {
                        if (code < 0x1930) {
                            if (code < 0x1732) {
                                if (code < 0x1082) {
                                    if (code < 0x103d) {
                                        if (code < 0x1032) {
                                            if (code < 0x1031) {
                                                // Mn   [4] MYANMAR VOWEL SIGN I..MYANMAR VOWEL SIGN UU
                                                if (0x102d <= code && code <= 0x1030) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mc       MYANMAR VOWEL SIGN E
                                                if (0x1031 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                            }
                                        } else {
                                            if (code < 0x1039) {
                                                // Mn   [6] MYANMAR VOWEL SIGN AI..MYANMAR SIGN DOT BELOW
                                                if (0x1032 <= code && code <= 0x1037) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else if (code < 0x103b) {
                                                // Mn   [2] MYANMAR SIGN VIRAMA..MYANMAR SIGN ASAT
                                                if (0x1039 <= code && code <= 0x103a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mc   [2] MYANMAR CONSONANT SIGN MEDIAL YA..MYANMAR CONSONANT SIGN MEDIAL RA
                                                if (0x103b <= code && code <= 0x103c) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                            }
                                        }
                                    } else if (code < 0x1058) {
                                        if (code < 0x1056) {
                                            // Mn   [2] MYANMAR CONSONANT SIGN MEDIAL WA..MYANMAR CONSONANT SIGN MEDIAL HA
                                            if (0x103d <= code && code <= 0x103e) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [2] MYANMAR VOWEL SIGN VOCALIC R..MYANMAR VOWEL SIGN VOCALIC RR
                                            if (0x1056 <= code && code <= 0x1057) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else {
                                        if (code < 0x105e) {
                                            // Mn   [2] MYANMAR VOWEL SIGN VOCALIC L..MYANMAR VOWEL SIGN VOCALIC LL
                                            if (0x1058 <= code && code <= 0x1059) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x1071) {
                                            // Mn   [3] MYANMAR CONSONANT SIGN MON MEDIAL NA..MYANMAR CONSONANT SIGN MON MEDIAL LA
                                            if (0x105e <= code && code <= 0x1060) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [4] MYANMAR VOWEL SIGN GEBA KAREN I..MYANMAR VOWEL SIGN KAYAH EE
                                            if (0x1071 <= code && code <= 0x1074) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else {
                                    if (code < 0x1100) {
                                        if (code < 0x1085) {
                                            // Mn       MYANMAR CONSONANT SIGN SHAN MEDIAL WA
                                            if (0x1082 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            // Mc       MYANMAR VOWEL SIGN SHAN E
                                            if (0x1084 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0x108d) {
                                            // Mn   [2] MYANMAR VOWEL SIGN SHAN E ABOVE..MYANMAR VOWEL SIGN SHAN FINAL Y
                                            if (0x1085 <= code && code <= 0x1086) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn       MYANMAR SIGN SHAN COUNCIL EMPHATIC TONE
                                            if (0x108d === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            // Mn       MYANMAR VOWEL SIGN AITON AI
                                            if (0x109d === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else if (code < 0x135d) {
                                        if (code < 0x1160) {
                                            // Lo  [96] HANGUL CHOSEONG KIYEOK..HANGUL CHOSEONG FILLER
                                            if (0x1100 <= code && code <= 0x115f) return boundaries_1.CLUSTER_BREAK.L;
                                        } else if (code < 0x11a8) {
                                            // Lo  [72] HANGUL JUNGSEONG FILLER..HANGUL JUNGSEONG O-YAE
                                            if (0x1160 <= code && code <= 0x11a7) return boundaries_1.CLUSTER_BREAK.V;
                                        } else {
                                            // Lo  [88] HANGUL JONGSEONG KIYEOK..HANGUL JONGSEONG SSANGNIEUN
                                            if (0x11a8 <= code && code <= 0x11ff) return boundaries_1.CLUSTER_BREAK.T;
                                        }
                                    } else {
                                        if (code < 0x1712) {
                                            // Mn   [3] ETHIOPIC COMBINING GEMINATION AND VOWEL LENGTH MARK..ETHIOPIC COMBINING GEMINATION MARK
                                            if (0x135d <= code && code <= 0x135f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x1715) {
                                            // Mn   [3] TAGALOG VOWEL SIGN I..TAGALOG SIGN VIRAMA
                                            if (0x1712 <= code && code <= 0x1714) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       TAGALOG SIGN PAMUDPOD
                                            if (0x1715 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                }
                            } else if (code < 0x17c9) {
                                if (code < 0x17b6) {
                                    if (code < 0x1752) {
                                        if (code < 0x1734) {
                                            // Mn   [2] HANUNOO VOWEL SIGN I..HANUNOO VOWEL SIGN U
                                            if (0x1732 <= code && code <= 0x1733) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       HANUNOO SIGN PAMUDPOD
                                            if (0x1734 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else {
                                        if (code < 0x1772) {
                                            // Mn   [2] BUHID VOWEL SIGN I..BUHID VOWEL SIGN U
                                            if (0x1752 <= code && code <= 0x1753) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x17b4) {
                                            // Mn   [2] TAGBANWA VOWEL SIGN I..TAGBANWA VOWEL SIGN U
                                            if (0x1772 <= code && code <= 0x1773) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [2] KHMER VOWEL INHERENT AQ..KHMER VOWEL INHERENT AA
                                            if (0x17b4 <= code && code <= 0x17b5) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0x17be) {
                                    if (code < 0x17b7) {
                                        // Mc       KHMER VOWEL SIGN AA
                                        if (0x17b6 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [7] KHMER VOWEL SIGN I..KHMER VOWEL SIGN UA
                                        if (0x17b7 <= code && code <= 0x17bd) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x17c6) {
                                        // Mc   [8] KHMER VOWEL SIGN OE..KHMER VOWEL SIGN AU
                                        if (0x17be <= code && code <= 0x17c5) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x17c7) {
                                        // Mn       KHMER SIGN NIKAHIT
                                        if (0x17c6 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] KHMER SIGN REAHMUK..KHMER SIGN YUUKALEAPINTU
                                        if (0x17c7 <= code && code <= 0x17c8) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else {
                                if (code < 0x1885) {
                                    if (code < 0x180b) {
                                        if (code < 0x17dd) {
                                            // Mn  [11] KHMER SIGN MUUSIKATOAN..KHMER SIGN BATHAMASAT
                                            if (0x17c9 <= code && code <= 0x17d3) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn       KHMER SIGN ATTHACAN
                                            if (0x17dd === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else if (code < 0x180e) {
                                        // Mn   [3] MONGOLIAN FREE VARIATION SELECTOR ONE..MONGOLIAN FREE VARIATION SELECTOR THREE
                                        if (0x180b <= code && code <= 0x180d) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Cf       MONGOLIAN VOWEL SEPARATOR
                                        if (0x180e === code) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                        // Mn       MONGOLIAN FREE VARIATION SELECTOR FOUR
                                        if (0x180f === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0x1923) {
                                    if (code < 0x18a9) {
                                        // Mn   [2] MONGOLIAN LETTER ALI GALI BALUDA..MONGOLIAN LETTER ALI GALI THREE BALUDA
                                        if (0x1885 <= code && code <= 0x1886) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x1920) {
                                        // Mn       MONGOLIAN LETTER ALI GALI DAGALGA
                                        if (0x18a9 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [3] LIMBU VOWEL SIGN A..LIMBU VOWEL SIGN U
                                        if (0x1920 <= code && code <= 0x1922) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x1927) {
                                        // Mc   [4] LIMBU VOWEL SIGN EE..LIMBU VOWEL SIGN AU
                                        if (0x1923 <= code && code <= 0x1926) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x1929) {
                                        // Mn   [2] LIMBU VOWEL SIGN E..LIMBU VOWEL SIGN O
                                        if (0x1927 <= code && code <= 0x1928) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [3] LIMBU SUBJOINED LETTER YA..LIMBU SUBJOINED LETTER WA
                                        if (0x1929 <= code && code <= 0x192b) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            }
                        } else {
                            if (code < 0x1b3b) {
                                if (code < 0x1a58) {
                                    if (code < 0x1a19) {
                                        if (code < 0x1933) {
                                            if (code < 0x1932) {
                                                // Mc   [2] LIMBU SMALL LETTER KA..LIMBU SMALL LETTER NGA
                                                if (0x1930 <= code && code <= 0x1931) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                            } else {
                                                // Mn       LIMBU SMALL LETTER ANUSVARA
                                                if (0x1932 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else {
                                            if (code < 0x1939) {
                                                // Mc   [6] LIMBU SMALL LETTER TA..LIMBU SMALL LETTER LA
                                                if (0x1933 <= code && code <= 0x1938) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                            } else if (code < 0x1a17) {
                                                // Mn   [3] LIMBU SIGN MUKPHRENG..LIMBU SIGN SA-I
                                                if (0x1939 <= code && code <= 0x193b) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mn   [2] BUGINESE VOWEL SIGN I..BUGINESE VOWEL SIGN U
                                                if (0x1a17 <= code && code <= 0x1a18) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            }
                                        }
                                    } else {
                                        if (code < 0x1a55) {
                                            if (code < 0x1a1b) {
                                                // Mc   [2] BUGINESE VOWEL SIGN E..BUGINESE VOWEL SIGN O
                                                if (0x1a19 <= code && code <= 0x1a1a) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                            } else {
                                                // Mn       BUGINESE VOWEL SIGN AE
                                                if (0x1a1b === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else if (code < 0x1a56) {
                                            // Mc       TAI THAM CONSONANT SIGN MEDIAL RA
                                            if (0x1a55 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn       TAI THAM CONSONANT SIGN MEDIAL LA
                                            if (0x1a56 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            // Mc       TAI THAM CONSONANT SIGN LA TANG LAI
                                            if (0x1a57 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                } else {
                                    if (code < 0x1a73) {
                                        if (code < 0x1a62) {
                                            if (code < 0x1a60) {
                                                // Mn   [7] TAI THAM SIGN MAI KANG LAI..TAI THAM CONSONANT SIGN SA
                                                if (0x1a58 <= code && code <= 0x1a5e) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mn       TAI THAM SIGN SAKOT
                                                if (0x1a60 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            }
                                        } else {
                                            if (code < 0x1a65) {
                                                // Mn       TAI THAM VOWEL SIGN MAI SAT
                                                if (0x1a62 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else if (code < 0x1a6d) {
                                                // Mn   [8] TAI THAM VOWEL SIGN I..TAI THAM VOWEL SIGN OA BELOW
                                                if (0x1a65 <= code && code <= 0x1a6c) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                            } else {
                                                // Mc   [6] TAI THAM VOWEL SIGN OY..TAI THAM VOWEL SIGN THAM AI
                                                if (0x1a6d <= code && code <= 0x1a72) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                            }
                                        }
                                    } else if (code < 0x1b00) {
                                        if (code < 0x1a7f) {
                                            // Mn  [10] TAI THAM VOWEL SIGN OA ABOVE..TAI THAM SIGN KHUEN-LUE KARAN
                                            if (0x1a73 <= code && code <= 0x1a7c) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x1ab0) {
                                            // Mn       TAI THAM COMBINING CRYPTOGRAMMIC DOT
                                            if (0x1a7f === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn  [14] COMBINING DOUBLED CIRCUMFLEX ACCENT..COMBINING PARENTHESES BELOW
                                            // Me       COMBINING PARENTHESES OVERLAY
                                            // Mn  [16] COMBINING LATIN SMALL LETTER W BELOW..COMBINING LATIN SMALL LETTER INSULAR T
                                            if (0x1ab0 <= code && code <= 0x1ace) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x1b04) {
                                            // Mn   [4] BALINESE SIGN ULU RICEM..BALINESE SIGN SURANG
                                            if (0x1b00 <= code && code <= 0x1b03) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x1b34) {
                                            // Mc       BALINESE SIGN BISAH
                                            if (0x1b04 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn       BALINESE SIGN REREKAN
                                            // Mc       BALINESE VOWEL SIGN TEDUNG
                                            // Mn   [5] BALINESE VOWEL SIGN ULU..BALINESE VOWEL SIGN RA REPA
                                            if (0x1b34 <= code && code <= 0x1b3a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                }
                            } else if (code < 0x1ba8) {
                                if (code < 0x1b6b) {
                                    if (code < 0x1b3d) {
                                        // Mc       BALINESE VOWEL SIGN RA REPA TEDUNG
                                        if (0x1b3b === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        // Mn       BALINESE VOWEL SIGN LA LENGA
                                        if (0x1b3c === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        if (code < 0x1b42) {
                                            // Mc   [5] BALINESE VOWEL SIGN LA LENGA TEDUNG..BALINESE VOWEL SIGN TALING REPA TEDUNG
                                            if (0x1b3d <= code && code <= 0x1b41) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0x1b43) {
                                            // Mn       BALINESE VOWEL SIGN PEPET
                                            if (0x1b42 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [2] BALINESE VOWEL SIGN PEPET TEDUNG..BALINESE ADEG ADEG
                                            if (0x1b43 <= code && code <= 0x1b44) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                } else if (code < 0x1ba1) {
                                    if (code < 0x1b80) {
                                        // Mn   [9] BALINESE MUSICAL SYMBOL COMBINING TEGEH..BALINESE MUSICAL SYMBOL COMBINING GONG
                                        if (0x1b6b <= code && code <= 0x1b73) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x1b82) {
                                        // Mn   [2] SUNDANESE SIGN PANYECEK..SUNDANESE SIGN PANGLAYAR
                                        if (0x1b80 <= code && code <= 0x1b81) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc       SUNDANESE SIGN PANGWISAD
                                        if (0x1b82 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0x1ba2) {
                                        // Mc       SUNDANESE CONSONANT SIGN PAMINGKAL
                                        if (0x1ba1 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x1ba6) {
                                        // Mn   [4] SUNDANESE CONSONANT SIGN PANYAKRA..SUNDANESE VOWEL SIGN PANYUKU
                                        if (0x1ba2 <= code && code <= 0x1ba5) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] SUNDANESE VOWEL SIGN PANAELAENG..SUNDANESE VOWEL SIGN PANOLONG
                                        if (0x1ba6 <= code && code <= 0x1ba7) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else {
                                if (code < 0x1be8) {
                                    if (code < 0x1bab) {
                                        if (code < 0x1baa) {
                                            // Mn   [2] SUNDANESE VOWEL SIGN PAMEPET..SUNDANESE VOWEL SIGN PANEULEUNG
                                            if (0x1ba8 <= code && code <= 0x1ba9) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       SUNDANESE SIGN PAMAAEH
                                            if (0x1baa === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else if (code < 0x1be6) {
                                        // Mn   [3] SUNDANESE SIGN VIRAMA..SUNDANESE CONSONANT SIGN PASANGAN WA
                                        if (0x1bab <= code && code <= 0x1bad) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       BATAK SIGN TOMPI
                                        if (0x1be6 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        // Mc       BATAK VOWEL SIGN E
                                        if (0x1be7 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else if (code < 0x1bee) {
                                    if (code < 0x1bea) {
                                        // Mn   [2] BATAK VOWEL SIGN PAKPAK E..BATAK VOWEL SIGN EE
                                        if (0x1be8 <= code && code <= 0x1be9) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x1bed) {
                                        // Mc   [3] BATAK VOWEL SIGN I..BATAK VOWEL SIGN O
                                        if (0x1bea <= code && code <= 0x1bec) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       BATAK VOWEL SIGN KARO O
                                        if (0x1bed === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x1bef) {
                                        // Mc       BATAK VOWEL SIGN U
                                        if (0x1bee === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x1bf2) {
                                        // Mn   [3] BATAK VOWEL SIGN U FOR SIMALUNGUN SA..BATAK CONSONANT SIGN H
                                        if (0x1bef <= code && code <= 0x1bf1) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] BATAK PANGOLAT..BATAK PANONGONAN
                                        if (0x1bf2 <= code && code <= 0x1bf3) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            }
                        }
                    } else if (code < 0xa952) {
                        if (code < 0x2d7f) {
                            if (code < 0x1cf7) {
                                if (code < 0x1cd4) {
                                    if (code < 0x1c34) {
                                        if (code < 0x1c2c) {
                                            // Mc   [8] LEPCHA SUBJOINED LETTER YA..LEPCHA VOWEL SIGN UU
                                            if (0x1c24 <= code && code <= 0x1c2b) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [8] LEPCHA VOWEL SIGN E..LEPCHA CONSONANT SIGN T
                                            if (0x1c2c <= code && code <= 0x1c33) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x1c36) {
                                            // Mc   [2] LEPCHA CONSONANT SIGN NYIN-DO..LEPCHA CONSONANT SIGN KANG
                                            if (0x1c34 <= code && code <= 0x1c35) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0x1cd0) {
                                            // Mn   [2] LEPCHA SIGN RAN..LEPCHA SIGN NUKTA
                                            if (0x1c36 <= code && code <= 0x1c37) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mn   [3] VEDIC TONE KARSHANA..VEDIC TONE PRENKHA
                                            if (0x1cd0 <= code && code <= 0x1cd2) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else {
                                    if (code < 0x1ce2) {
                                        if (code < 0x1ce1) {
                                            // Mn  [13] VEDIC SIGN YAJURVEDIC MIDLINE SVARITA..VEDIC TONE RIGVEDIC KASHMIRI INDEPENDENT SVARITA
                                            if (0x1cd4 <= code && code <= 0x1ce0) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       VEDIC TONE ATHARVAVEDIC INDEPENDENT SVARITA
                                            if (0x1ce1 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else if (code < 0x1ced) {
                                        // Mn   [7] VEDIC SIGN VISARGA SVARITA..VEDIC SIGN VISARGA ANUDATTA WITH TAIL
                                        if (0x1ce2 <= code && code <= 0x1ce8) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       VEDIC SIGN TIRYAK
                                        if (0x1ced === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        // Mn       VEDIC TONE CANDRA ABOVE
                                        if (0x1cf4 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0x200d) {
                                    if (code < 0x1dc0) {
                                        if (code < 0x1cf8) {
                                            // Mc       VEDIC SIGN ATIKRAMA
                                            if (0x1cf7 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [2] VEDIC TONE RING ABOVE..VEDIC TONE DOUBLE RING ABOVE
                                            if (0x1cf8 <= code && code <= 0x1cf9) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else if (code < 0x200b) {
                                        // Mn  [64] COMBINING DOTTED GRAVE ACCENT..COMBINING RIGHT ARROWHEAD AND DOWN ARROWHEAD BELOW
                                        if (0x1dc0 <= code && code <= 0x1dff) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Cf       ZERO WIDTH SPACE
                                        if (0x200b === code) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                        // Cf       ZERO WIDTH NON-JOINER
                                        if (0x200c === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0x2060) {
                                    if (code < 0x200e) {
                                        // Cf       ZERO WIDTH JOINER
                                        if (0x200d === code) return boundaries_1.CLUSTER_BREAK.ZWJ;
                                    } else if (code < 0x2028) {
                                        // Cf   [2] LEFT-TO-RIGHT MARK..RIGHT-TO-LEFT MARK
                                        if (0x200e <= code && code <= 0x200f) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                    } else {
                                        // Zl       LINE SEPARATOR
                                        // Zp       PARAGRAPH SEPARATOR
                                        // Cf   [5] LEFT-TO-RIGHT EMBEDDING..RIGHT-TO-LEFT OVERRIDE
                                        if (0x2028 <= code && code <= 0x202e) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                    }
                                } else {
                                    if (code < 0x20d0) {
                                        // Cf   [5] WORD JOINER..INVISIBLE PLUS
                                        // Cn       <reserved-2065>
                                        // Cf  [10] LEFT-TO-RIGHT ISOLATE..NOMINAL DIGIT SHAPES
                                        if (0x2060 <= code && code <= 0x206f) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                    } else if (code < 0x2cef) {
                                        // Mn  [13] COMBINING LEFT HARPOON ABOVE..COMBINING FOUR DOTS ABOVE
                                        // Me   [4] COMBINING ENCLOSING CIRCLE..COMBINING ENCLOSING CIRCLE BACKSLASH
                                        // Mn       COMBINING LEFT RIGHT ARROW ABOVE
                                        // Me   [3] COMBINING ENCLOSING SCREEN..COMBINING ENCLOSING UPWARD POINTING TRIANGLE
                                        // Mn  [12] COMBINING REVERSE SOLIDUS OVERLAY..COMBINING ASTERISK ABOVE
                                        if (0x20d0 <= code && code <= 0x20f0) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [3] COPTIC COMBINING NI ABOVE..COPTIC COMBINING SPIRITUS LENIS
                                        if (0x2cef <= code && code <= 0x2cf1) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            }
                        } else if (code < 0xa823) {
                            if (code < 0xa674) {
                                if (code < 0x302a) {
                                    if (code < 0x2de0) {
                                        // Mn       TIFINAGH CONSONANT JOINER
                                        if (0x2d7f === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn  [32] COMBINING CYRILLIC LETTER BE..COMBINING CYRILLIC LETTER IOTIFIED BIG YUS
                                        if (0x2de0 <= code && code <= 0x2dff) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x3099) {
                                        // Mn   [4] IDEOGRAPHIC LEVEL TONE MARK..IDEOGRAPHIC ENTERING TONE MARK
                                        // Mc   [2] HANGUL SINGLE DOT TONE MARK..HANGUL DOUBLE DOT TONE MARK
                                        if (0x302a <= code && code <= 0x302f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xa66f) {
                                        // Mn   [2] COMBINING KATAKANA-HIRAGANA VOICED SOUND MARK..COMBINING KATAKANA-HIRAGANA SEMI-VOICED SOUND MARK
                                        if (0x3099 <= code && code <= 0x309a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       COMBINING CYRILLIC VZMET
                                        // Me   [3] COMBINING CYRILLIC TEN MILLIONS SIGN..COMBINING CYRILLIC THOUSAND MILLIONS SIGN
                                        if (0xa66f <= code && code <= 0xa672) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0xa802) {
                                    if (code < 0xa69e) {
                                        // Mn  [10] COMBINING CYRILLIC LETTER UKRAINIAN IE..COMBINING CYRILLIC PAYEROK
                                        if (0xa674 <= code && code <= 0xa67d) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0xa6f0) {
                                        // Mn   [2] COMBINING CYRILLIC LETTER EF..COMBINING CYRILLIC LETTER IOTIFIED E
                                        if (0xa69e <= code && code <= 0xa69f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] BAMUM COMBINING MARK KOQNDON..BAMUM COMBINING MARK TUKWENTIS
                                        if (0xa6f0 <= code && code <= 0xa6f1) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0xa806) {
                                    // Mn       SYLOTI NAGRI SIGN DVISVARA
                                    if (0xa802 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       SYLOTI NAGRI SIGN HASANTA
                                    if (0xa806 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    // Mn       SYLOTI NAGRI SIGN ANUSVARA
                                    if (0xa80b === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0xa8b4) {
                                if (code < 0xa827) {
                                    if (code < 0xa825) {
                                        // Mc   [2] SYLOTI NAGRI VOWEL SIGN A..SYLOTI NAGRI VOWEL SIGN I
                                        if (0xa823 <= code && code <= 0xa824) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] SYLOTI NAGRI VOWEL SIGN U..SYLOTI NAGRI VOWEL SIGN E
                                        if (0xa825 <= code && code <= 0xa826) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xa82c) {
                                        // Mc       SYLOTI NAGRI VOWEL SIGN OO
                                        if (0xa827 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xa880) {
                                        // Mn       SYLOTI NAGRI SIGN ALTERNATE HASANTA
                                        if (0xa82c === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] SAURASHTRA SIGN ANUSVARA..SAURASHTRA SIGN VISARGA
                                        if (0xa880 <= code && code <= 0xa881) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else if (code < 0xa8ff) {
                                if (code < 0xa8c4) {
                                    // Mc  [16] SAURASHTRA CONSONANT SIGN HAARU..SAURASHTRA VOWEL SIGN AU
                                    if (0xa8b4 <= code && code <= 0xa8c3) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0xa8e0) {
                                    // Mn   [2] SAURASHTRA SIGN VIRAMA..SAURASHTRA SIGN CANDRABINDU
                                    if (0xa8c4 <= code && code <= 0xa8c5) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn  [18] COMBINING DEVANAGARI DIGIT ZERO..COMBINING DEVANAGARI SIGN AVAGRAHA
                                    if (0xa8e0 <= code && code <= 0xa8f1) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0xa926) {
                                    // Mn       DEVANAGARI VOWEL SIGN AY
                                    if (0xa8ff === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xa947) {
                                    // Mn   [8] KAYAH LI VOWEL UE..KAYAH LI TONE CALYA PLOPHU
                                    if (0xa926 <= code && code <= 0xa92d) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn  [11] REJANG VOWEL SIGN I..REJANG CONSONANT SIGN R
                                    if (0xa947 <= code && code <= 0xa951) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    } else {
                        if (code < 0xaab2) {
                            if (code < 0xa9e5) {
                                if (code < 0xa9b4) {
                                    if (code < 0xa980) {
                                        if (code < 0xa960) {
                                            // Mc   [2] REJANG CONSONANT SIGN H..REJANG VIRAMA
                                            if (0xa952 <= code && code <= 0xa953) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Lo  [29] HANGUL CHOSEONG TIKEUT-MIEUM..HANGUL CHOSEONG SSANGYEORINHIEUH
                                            if (0xa960 <= code && code <= 0xa97c) return boundaries_1.CLUSTER_BREAK.L;
                                        }
                                    } else if (code < 0xa983) {
                                        // Mn   [3] JAVANESE SIGN PANYANGGA..JAVANESE SIGN LAYAR
                                        if (0xa980 <= code && code <= 0xa982) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc       JAVANESE SIGN WIGNYAN
                                        if (0xa983 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        // Mn       JAVANESE SIGN CECAK TELU
                                        if (0xa9b3 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0xa9ba) {
                                    if (code < 0xa9b6) {
                                        // Mc   [2] JAVANESE VOWEL SIGN TARUNG..JAVANESE VOWEL SIGN TOLONG
                                        if (0xa9b4 <= code && code <= 0xa9b5) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [4] JAVANESE VOWEL SIGN WULU..JAVANESE VOWEL SIGN SUKU MENDUT
                                        if (0xa9b6 <= code && code <= 0xa9b9) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xa9bc) {
                                        // Mc   [2] JAVANESE VOWEL SIGN TALING..JAVANESE VOWEL SIGN DIRGA MURE
                                        if (0xa9ba <= code && code <= 0xa9bb) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xa9be) {
                                        // Mn   [2] JAVANESE VOWEL SIGN PEPET..JAVANESE CONSONANT SIGN KERET
                                        if (0xa9bc <= code && code <= 0xa9bd) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [3] JAVANESE CONSONANT SIGN PENGKAL..JAVANESE PANGKON
                                        if (0xa9be <= code && code <= 0xa9c0) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else if (code < 0xaa35) {
                                if (code < 0xaa2f) {
                                    if (code < 0xaa29) {
                                        // Mn       MYANMAR SIGN SHAN SAW
                                        if (0xa9e5 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [6] CHAM VOWEL SIGN AA..CHAM VOWEL SIGN OE
                                        if (0xaa29 <= code && code <= 0xaa2e) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0xaa31) {
                                        // Mc   [2] CHAM VOWEL SIGN O..CHAM VOWEL SIGN AI
                                        if (0xaa2f <= code && code <= 0xaa30) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0xaa33) {
                                        // Mn   [2] CHAM VOWEL SIGN AU..CHAM VOWEL SIGN UE
                                        if (0xaa31 <= code && code <= 0xaa32) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [2] CHAM CONSONANT SIGN YA..CHAM CONSONANT SIGN RA
                                        if (0xaa33 <= code && code <= 0xaa34) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else {
                                if (code < 0xaa4d) {
                                    if (code < 0xaa43) {
                                        // Mn   [2] CHAM CONSONANT SIGN LA..CHAM CONSONANT SIGN WA
                                        if (0xaa35 <= code && code <= 0xaa36) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       CHAM CONSONANT SIGN FINAL NG
                                        if (0xaa43 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        // Mn       CHAM CONSONANT SIGN FINAL M
                                        if (0xaa4c === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0xaa7c) {
                                    // Mc       CHAM CONSONANT SIGN FINAL H
                                    if (0xaa4d === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       MYANMAR SIGN TAI LAING TONE-2
                                    if (0xaa7c === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    // Mn       TAI VIET MAI KANG
                                    if (0xaab0 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0xabe6) {
                            if (code < 0xaaec) {
                                if (code < 0xaabe) {
                                    if (code < 0xaab7) {
                                        // Mn   [3] TAI VIET VOWEL I..TAI VIET VOWEL U
                                        if (0xaab2 <= code && code <= 0xaab4) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] TAI VIET MAI KHIT..TAI VIET VOWEL IA
                                        if (0xaab7 <= code && code <= 0xaab8) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0xaac1) {
                                    // Mn   [2] TAI VIET VOWEL AM..TAI VIET TONE MAI EK
                                    if (0xaabe <= code && code <= 0xaabf) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       TAI VIET TONE MAI THO
                                    if (0xaac1 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    // Mc       MEETEI MAYEK VOWEL SIGN II
                                    if (0xaaeb === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else if (code < 0xaaf6) {
                                if (code < 0xaaee) {
                                    // Mn   [2] MEETEI MAYEK VOWEL SIGN UU..MEETEI MAYEK VOWEL SIGN AAI
                                    if (0xaaec <= code && code <= 0xaaed) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xaaf5) {
                                    // Mc   [2] MEETEI MAYEK VOWEL SIGN AU..MEETEI MAYEK VOWEL SIGN AAU
                                    if (0xaaee <= code && code <= 0xaaef) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mc       MEETEI MAYEK VOWEL SIGN VISARGA
                                    if (0xaaf5 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0xabe3) {
                                    // Mn       MEETEI MAYEK VIRAMA
                                    if (0xaaf6 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xabe5) {
                                    // Mc   [2] MEETEI MAYEK VOWEL SIGN ONAP..MEETEI MAYEK VOWEL SIGN INAP
                                    if (0xabe3 <= code && code <= 0xabe4) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       MEETEI MAYEK VOWEL SIGN ANAP
                                    if (0xabe5 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0xac00) {
                                if (code < 0xabe9) {
                                    if (code < 0xabe8) {
                                        // Mc   [2] MEETEI MAYEK VOWEL SIGN YENAP..MEETEI MAYEK VOWEL SIGN SOUNAP
                                        if (0xabe6 <= code && code <= 0xabe7) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       MEETEI MAYEK VOWEL SIGN UNAP
                                        if (0xabe8 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0xabec) {
                                    // Mc   [2] MEETEI MAYEK VOWEL SIGN CHEINAP..MEETEI MAYEK VOWEL SIGN NUNG
                                    if (0xabe9 <= code && code <= 0xabea) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mc       MEETEI MAYEK LUM IYEK
                                    if (0xabec === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       MEETEI MAYEK APUN IYEK
                                    if (0xabed === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else if (code < 0xac1d) {
                                if (code < 0xac01) {
                                    // Lo       HANGUL SYLLABLE GA
                                    if (0xac00 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xac1c) {
                                    // Lo  [27] HANGUL SYLLABLE GAG..HANGUL SYLLABLE GAH
                                    if (0xac01 <= code && code <= 0xac1b) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE GAE
                                    if (0xac1c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xac38) {
                                    // Lo  [27] HANGUL SYLLABLE GAEG..HANGUL SYLLABLE GAEH
                                    if (0xac1d <= code && code <= 0xac37) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xac39) {
                                    // Lo       HANGUL SYLLABLE GYA
                                    if (0xac38 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE GYAG..HANGUL SYLLABLE GYAH
                                    if (0xac39 <= code && code <= 0xac53) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    }
                }
            } else if (code < 0xb5a1) {
                if (code < 0xb0ed) {
                    if (code < 0xaea0) {
                        if (code < 0xad6d) {
                            if (code < 0xace0) {
                                if (code < 0xac8d) {
                                    if (code < 0xac70) {
                                        if (code < 0xac55) {
                                            // Lo       HANGUL SYLLABLE GYAE
                                            if (0xac54 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE GYAEG..HANGUL SYLLABLE GYAEH
                                            if (0xac55 <= code && code <= 0xac6f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xac71) {
                                            // Lo       HANGUL SYLLABLE GEO
                                            if (0xac70 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xac8c) {
                                            // Lo  [27] HANGUL SYLLABLE GEOG..HANGUL SYLLABLE GEOH
                                            if (0xac71 <= code && code <= 0xac8b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE GE
                                            if (0xac8c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xaca9) {
                                    if (code < 0xaca8) {
                                        // Lo  [27] HANGUL SYLLABLE GEG..HANGUL SYLLABLE GEH
                                        if (0xac8d <= code && code <= 0xaca7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GYEO
                                        if (0xaca8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xacc4) {
                                        // Lo  [27] HANGUL SYLLABLE GYEOG..HANGUL SYLLABLE GYEOH
                                        if (0xaca9 <= code && code <= 0xacc3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xacc5) {
                                        // Lo       HANGUL SYLLABLE GYE
                                        if (0xacc4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GYEG..HANGUL SYLLABLE GYEH
                                        if (0xacc5 <= code && code <= 0xacdf) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xad19) {
                                    if (code < 0xacfc) {
                                        if (code < 0xace1) {
                                            // Lo       HANGUL SYLLABLE GO
                                            if (0xace0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE GOG..HANGUL SYLLABLE GOH
                                            if (0xace1 <= code && code <= 0xacfb) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xacfd) {
                                            // Lo       HANGUL SYLLABLE GWA
                                            if (0xacfc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xad18) {
                                            // Lo  [27] HANGUL SYLLABLE GWAG..HANGUL SYLLABLE GWAH
                                            if (0xacfd <= code && code <= 0xad17) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE GWAE
                                            if (0xad18 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xad50) {
                                    if (code < 0xad34) {
                                        // Lo  [27] HANGUL SYLLABLE GWAEG..HANGUL SYLLABLE GWAEH
                                        if (0xad19 <= code && code <= 0xad33) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xad35) {
                                        // Lo       HANGUL SYLLABLE GOE
                                        if (0xad34 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GOEG..HANGUL SYLLABLE GOEH
                                        if (0xad35 <= code && code <= 0xad4f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xad51) {
                                        // Lo       HANGUL SYLLABLE GYO
                                        if (0xad50 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xad6c) {
                                        // Lo  [27] HANGUL SYLLABLE GYOG..HANGUL SYLLABLE GYOH
                                        if (0xad51 <= code && code <= 0xad6b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GU
                                        if (0xad6c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xadf9) {
                            if (code < 0xadc0) {
                                if (code < 0xad89) {
                                    if (code < 0xad88) {
                                        // Lo  [27] HANGUL SYLLABLE GUG..HANGUL SYLLABLE GUH
                                        if (0xad6d <= code && code <= 0xad87) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GWEO
                                        if (0xad88 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xada4) {
                                        // Lo  [27] HANGUL SYLLABLE GWEOG..HANGUL SYLLABLE GWEOH
                                        if (0xad89 <= code && code <= 0xada3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xada5) {
                                        // Lo       HANGUL SYLLABLE GWE
                                        if (0xada4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GWEG..HANGUL SYLLABLE GWEH
                                        if (0xada5 <= code && code <= 0xadbf) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xaddc) {
                                if (code < 0xadc1) {
                                    // Lo       HANGUL SYLLABLE GWI
                                    if (0xadc0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE GWIG..HANGUL SYLLABLE GWIH
                                    if (0xadc1 <= code && code <= 0xaddb) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xaddd) {
                                    // Lo       HANGUL SYLLABLE GYU
                                    if (0xaddc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xadf8) {
                                    // Lo  [27] HANGUL SYLLABLE GYUG..HANGUL SYLLABLE GYUH
                                    if (0xaddd <= code && code <= 0xadf7) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE GEU
                                    if (0xadf8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xae4c) {
                                if (code < 0xae15) {
                                    if (code < 0xae14) {
                                        // Lo  [27] HANGUL SYLLABLE GEUG..HANGUL SYLLABLE GEUH
                                        if (0xadf9 <= code && code <= 0xae13) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GYI
                                        if (0xae14 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xae30) {
                                        // Lo  [27] HANGUL SYLLABLE GYIG..HANGUL SYLLABLE GYIH
                                        if (0xae15 <= code && code <= 0xae2f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xae31) {
                                        // Lo       HANGUL SYLLABLE GI
                                        if (0xae30 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GIG..HANGUL SYLLABLE GIH
                                        if (0xae31 <= code && code <= 0xae4b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xae69) {
                                if (code < 0xae4d) {
                                    // Lo       HANGUL SYLLABLE GGA
                                    if (0xae4c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xae68) {
                                    // Lo  [27] HANGUL SYLLABLE GGAG..HANGUL SYLLABLE GGAH
                                    if (0xae4d <= code && code <= 0xae67) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE GGAE
                                    if (0xae68 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xae84) {
                                    // Lo  [27] HANGUL SYLLABLE GGAEG..HANGUL SYLLABLE GGAEH
                                    if (0xae69 <= code && code <= 0xae83) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xae85) {
                                    // Lo       HANGUL SYLLABLE GGYA
                                    if (0xae84 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE GGYAG..HANGUL SYLLABLE GGYAH
                                    if (0xae85 <= code && code <= 0xae9f) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else {
                        if (code < 0xafb9) {
                            if (code < 0xaf2c) {
                                if (code < 0xaed9) {
                                    if (code < 0xaebc) {
                                        if (code < 0xaea1) {
                                            // Lo       HANGUL SYLLABLE GGYAE
                                            if (0xaea0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE GGYAEG..HANGUL SYLLABLE GGYAEH
                                            if (0xaea1 <= code && code <= 0xaebb) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xaebd) {
                                            // Lo       HANGUL SYLLABLE GGEO
                                            if (0xaebc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xaed8) {
                                            // Lo  [27] HANGUL SYLLABLE GGEOG..HANGUL SYLLABLE GGEOH
                                            if (0xaebd <= code && code <= 0xaed7) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE GGE
                                            if (0xaed8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xaef5) {
                                    if (code < 0xaef4) {
                                        // Lo  [27] HANGUL SYLLABLE GGEG..HANGUL SYLLABLE GGEH
                                        if (0xaed9 <= code && code <= 0xaef3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GGYEO
                                        if (0xaef4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xaf10) {
                                        // Lo  [27] HANGUL SYLLABLE GGYEOG..HANGUL SYLLABLE GGYEOH
                                        if (0xaef5 <= code && code <= 0xaf0f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xaf11) {
                                        // Lo       HANGUL SYLLABLE GGYE
                                        if (0xaf10 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GGYEG..HANGUL SYLLABLE GGYEH
                                        if (0xaf11 <= code && code <= 0xaf2b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xaf65) {
                                    if (code < 0xaf48) {
                                        if (code < 0xaf2d) {
                                            // Lo       HANGUL SYLLABLE GGO
                                            if (0xaf2c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE GGOG..HANGUL SYLLABLE GGOH
                                            if (0xaf2d <= code && code <= 0xaf47) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xaf49) {
                                            // Lo       HANGUL SYLLABLE GGWA
                                            if (0xaf48 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xaf64) {
                                            // Lo  [27] HANGUL SYLLABLE GGWAG..HANGUL SYLLABLE GGWAH
                                            if (0xaf49 <= code && code <= 0xaf63) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE GGWAE
                                            if (0xaf64 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xaf9c) {
                                    if (code < 0xaf80) {
                                        // Lo  [27] HANGUL SYLLABLE GGWAEG..HANGUL SYLLABLE GGWAEH
                                        if (0xaf65 <= code && code <= 0xaf7f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xaf81) {
                                        // Lo       HANGUL SYLLABLE GGOE
                                        if (0xaf80 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GGOEG..HANGUL SYLLABLE GGOEH
                                        if (0xaf81 <= code && code <= 0xaf9b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xaf9d) {
                                        // Lo       HANGUL SYLLABLE GGYO
                                        if (0xaf9c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xafb8) {
                                        // Lo  [27] HANGUL SYLLABLE GGYOG..HANGUL SYLLABLE GGYOH
                                        if (0xaf9d <= code && code <= 0xafb7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GGU
                                        if (0xafb8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xb060) {
                            if (code < 0xb00c) {
                                if (code < 0xafd5) {
                                    if (code < 0xafd4) {
                                        // Lo  [27] HANGUL SYLLABLE GGUG..HANGUL SYLLABLE GGUH
                                        if (0xafb9 <= code && code <= 0xafd3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE GGWEO
                                        if (0xafd4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xaff0) {
                                        // Lo  [27] HANGUL SYLLABLE GGWEOG..HANGUL SYLLABLE GGWEOH
                                        if (0xafd5 <= code && code <= 0xafef) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xaff1) {
                                        // Lo       HANGUL SYLLABLE GGWE
                                        if (0xaff0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GGWEG..HANGUL SYLLABLE GGWEH
                                        if (0xaff1 <= code && code <= 0xb00b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xb029) {
                                if (code < 0xb00d) {
                                    // Lo       HANGUL SYLLABLE GGWI
                                    if (0xb00c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xb028) {
                                    // Lo  [27] HANGUL SYLLABLE GGWIG..HANGUL SYLLABLE GGWIH
                                    if (0xb00d <= code && code <= 0xb027) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE GGYU
                                    if (0xb028 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb044) {
                                    // Lo  [27] HANGUL SYLLABLE GGYUG..HANGUL SYLLABLE GGYUH
                                    if (0xb029 <= code && code <= 0xb043) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb045) {
                                    // Lo       HANGUL SYLLABLE GGEU
                                    if (0xb044 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE GGEUG..HANGUL SYLLABLE GGEUH
                                    if (0xb045 <= code && code <= 0xb05f) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xb099) {
                                if (code < 0xb07c) {
                                    if (code < 0xb061) {
                                        // Lo       HANGUL SYLLABLE GGYI
                                        if (0xb060 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE GGYIG..HANGUL SYLLABLE GGYIH
                                        if (0xb061 <= code && code <= 0xb07b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb07d) {
                                        // Lo       HANGUL SYLLABLE GGI
                                        if (0xb07c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb098) {
                                        // Lo  [27] HANGUL SYLLABLE GGIG..HANGUL SYLLABLE GGIH
                                        if (0xb07d <= code && code <= 0xb097) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE NA
                                        if (0xb098 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xb0d0) {
                                if (code < 0xb0b4) {
                                    // Lo  [27] HANGUL SYLLABLE NAG..HANGUL SYLLABLE NAH
                                    if (0xb099 <= code && code <= 0xb0b3) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb0b5) {
                                    // Lo       HANGUL SYLLABLE NAE
                                    if (0xb0b4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE NAEG..HANGUL SYLLABLE NAEH
                                    if (0xb0b5 <= code && code <= 0xb0cf) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb0d1) {
                                    // Lo       HANGUL SYLLABLE NYA
                                    if (0xb0d0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xb0ec) {
                                    // Lo  [27] HANGUL SYLLABLE NYAG..HANGUL SYLLABLE NYAH
                                    if (0xb0d1 <= code && code <= 0xb0eb) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE NYAE
                                    if (0xb0ec === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    }
                } else if (code < 0xb354) {
                    if (code < 0xb220) {
                        if (code < 0xb179) {
                            if (code < 0xb140) {
                                if (code < 0xb109) {
                                    if (code < 0xb108) {
                                        // Lo  [27] HANGUL SYLLABLE NYAEG..HANGUL SYLLABLE NYAEH
                                        if (0xb0ed <= code && code <= 0xb107) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE NEO
                                        if (0xb108 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb124) {
                                        // Lo  [27] HANGUL SYLLABLE NEOG..HANGUL SYLLABLE NEOH
                                        if (0xb109 <= code && code <= 0xb123) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb125) {
                                        // Lo       HANGUL SYLLABLE NE
                                        if (0xb124 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE NEG..HANGUL SYLLABLE NEH
                                        if (0xb125 <= code && code <= 0xb13f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xb15c) {
                                if (code < 0xb141) {
                                    // Lo       HANGUL SYLLABLE NYEO
                                    if (0xb140 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE NYEOG..HANGUL SYLLABLE NYEOH
                                    if (0xb141 <= code && code <= 0xb15b) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb15d) {
                                    // Lo       HANGUL SYLLABLE NYE
                                    if (0xb15c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xb178) {
                                    // Lo  [27] HANGUL SYLLABLE NYEG..HANGUL SYLLABLE NYEH
                                    if (0xb15d <= code && code <= 0xb177) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE NO
                                    if (0xb178 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xb1cc) {
                                if (code < 0xb195) {
                                    if (code < 0xb194) {
                                        // Lo  [27] HANGUL SYLLABLE NOG..HANGUL SYLLABLE NOH
                                        if (0xb179 <= code && code <= 0xb193) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE NWA
                                        if (0xb194 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb1b0) {
                                        // Lo  [27] HANGUL SYLLABLE NWAG..HANGUL SYLLABLE NWAH
                                        if (0xb195 <= code && code <= 0xb1af) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb1b1) {
                                        // Lo       HANGUL SYLLABLE NWAE
                                        if (0xb1b0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE NWAEG..HANGUL SYLLABLE NWAEH
                                        if (0xb1b1 <= code && code <= 0xb1cb) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xb1e9) {
                                if (code < 0xb1cd) {
                                    // Lo       HANGUL SYLLABLE NOE
                                    if (0xb1cc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xb1e8) {
                                    // Lo  [27] HANGUL SYLLABLE NOEG..HANGUL SYLLABLE NOEH
                                    if (0xb1cd <= code && code <= 0xb1e7) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE NYO
                                    if (0xb1e8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb204) {
                                    // Lo  [27] HANGUL SYLLABLE NYOG..HANGUL SYLLABLE NYOH
                                    if (0xb1e9 <= code && code <= 0xb203) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb205) {
                                    // Lo       HANGUL SYLLABLE NU
                                    if (0xb204 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE NUG..HANGUL SYLLABLE NUH
                                    if (0xb205 <= code && code <= 0xb21f) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else if (code < 0xb2ad) {
                        if (code < 0xb259) {
                            if (code < 0xb23c) {
                                if (code < 0xb221) {
                                    // Lo       HANGUL SYLLABLE NWEO
                                    if (0xb220 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE NWEOG..HANGUL SYLLABLE NWEOH
                                    if (0xb221 <= code && code <= 0xb23b) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb23d) {
                                    // Lo       HANGUL SYLLABLE NWE
                                    if (0xb23c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xb258) {
                                    // Lo  [27] HANGUL SYLLABLE NWEG..HANGUL SYLLABLE NWEH
                                    if (0xb23d <= code && code <= 0xb257) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE NWI
                                    if (0xb258 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else if (code < 0xb290) {
                            if (code < 0xb274) {
                                // Lo  [27] HANGUL SYLLABLE NWIG..HANGUL SYLLABLE NWIH
                                if (0xb259 <= code && code <= 0xb273) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else if (code < 0xb275) {
                                // Lo       HANGUL SYLLABLE NYU
                                if (0xb274 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE NYUG..HANGUL SYLLABLE NYUH
                                if (0xb275 <= code && code <= 0xb28f) return boundaries_1.CLUSTER_BREAK.LVT;
                            }
                        } else {
                            if (code < 0xb291) {
                                // Lo       HANGUL SYLLABLE NEU
                                if (0xb290 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else if (code < 0xb2ac) {
                                // Lo  [27] HANGUL SYLLABLE NEUG..HANGUL SYLLABLE NEUH
                                if (0xb291 <= code && code <= 0xb2ab) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE NYI
                                if (0xb2ac === code) return boundaries_1.CLUSTER_BREAK.LV;
                            }
                        }
                    } else {
                        if (code < 0xb300) {
                            if (code < 0xb2c9) {
                                if (code < 0xb2c8) {
                                    // Lo  [27] HANGUL SYLLABLE NYIG..HANGUL SYLLABLE NYIH
                                    if (0xb2ad <= code && code <= 0xb2c7) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE NI
                                    if (0xb2c8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb2e4) {
                                    // Lo  [27] HANGUL SYLLABLE NIG..HANGUL SYLLABLE NIH
                                    if (0xb2c9 <= code && code <= 0xb2e3) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb2e5) {
                                    // Lo       HANGUL SYLLABLE DA
                                    if (0xb2e4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DAG..HANGUL SYLLABLE DAH
                                    if (0xb2e5 <= code && code <= 0xb2ff) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else if (code < 0xb31d) {
                            if (code < 0xb301) {
                                // Lo       HANGUL SYLLABLE DAE
                                if (0xb300 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else if (code < 0xb31c) {
                                // Lo  [27] HANGUL SYLLABLE DAEG..HANGUL SYLLABLE DAEH
                                if (0xb301 <= code && code <= 0xb31b) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE DYA
                                if (0xb31c === code) return boundaries_1.CLUSTER_BREAK.LV;
                            }
                        } else {
                            if (code < 0xb338) {
                                // Lo  [27] HANGUL SYLLABLE DYAG..HANGUL SYLLABLE DYAH
                                if (0xb31d <= code && code <= 0xb337) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else if (code < 0xb339) {
                                // Lo       HANGUL SYLLABLE DYAE
                                if (0xb338 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE DYAEG..HANGUL SYLLABLE DYAEH
                                if (0xb339 <= code && code <= 0xb353) return boundaries_1.CLUSTER_BREAK.LVT;
                            }
                        }
                    }
                } else {
                    if (code < 0xb46d) {
                        if (code < 0xb3e0) {
                            if (code < 0xb38d) {
                                if (code < 0xb370) {
                                    if (code < 0xb355) {
                                        // Lo       HANGUL SYLLABLE DEO
                                        if (0xb354 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE DEOG..HANGUL SYLLABLE DEOH
                                        if (0xb355 <= code && code <= 0xb36f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb371) {
                                        // Lo       HANGUL SYLLABLE DE
                                        if (0xb370 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb38c) {
                                        // Lo  [27] HANGUL SYLLABLE DEG..HANGUL SYLLABLE DEH
                                        if (0xb371 <= code && code <= 0xb38b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE DYEO
                                        if (0xb38c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xb3a9) {
                                if (code < 0xb3a8) {
                                    // Lo  [27] HANGUL SYLLABLE DYEOG..HANGUL SYLLABLE DYEOH
                                    if (0xb38d <= code && code <= 0xb3a7) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE DYE
                                    if (0xb3a8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb3c4) {
                                    // Lo  [27] HANGUL SYLLABLE DYEG..HANGUL SYLLABLE DYEH
                                    if (0xb3a9 <= code && code <= 0xb3c3) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb3c5) {
                                    // Lo       HANGUL SYLLABLE DO
                                    if (0xb3c4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DOG..HANGUL SYLLABLE DOH
                                    if (0xb3c5 <= code && code <= 0xb3df) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xb419) {
                                if (code < 0xb3fc) {
                                    if (code < 0xb3e1) {
                                        // Lo       HANGUL SYLLABLE DWA
                                        if (0xb3e0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE DWAG..HANGUL SYLLABLE DWAH
                                        if (0xb3e1 <= code && code <= 0xb3fb) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb3fd) {
                                        // Lo       HANGUL SYLLABLE DWAE
                                        if (0xb3fc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb418) {
                                        // Lo  [27] HANGUL SYLLABLE DWAEG..HANGUL SYLLABLE DWAEH
                                        if (0xb3fd <= code && code <= 0xb417) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE DOE
                                        if (0xb418 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xb450) {
                                if (code < 0xb434) {
                                    // Lo  [27] HANGUL SYLLABLE DOEG..HANGUL SYLLABLE DOEH
                                    if (0xb419 <= code && code <= 0xb433) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb435) {
                                    // Lo       HANGUL SYLLABLE DYO
                                    if (0xb434 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DYOG..HANGUL SYLLABLE DYOH
                                    if (0xb435 <= code && code <= 0xb44f) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb451) {
                                    // Lo       HANGUL SYLLABLE DU
                                    if (0xb450 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xb46c) {
                                    // Lo  [27] HANGUL SYLLABLE DUG..HANGUL SYLLABLE DUH
                                    if (0xb451 <= code && code <= 0xb46b) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE DWEO
                                    if (0xb46c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    } else if (code < 0xb514) {
                        if (code < 0xb4c0) {
                            if (code < 0xb489) {
                                if (code < 0xb488) {
                                    // Lo  [27] HANGUL SYLLABLE DWEOG..HANGUL SYLLABLE DWEOH
                                    if (0xb46d <= code && code <= 0xb487) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE DWE
                                    if (0xb488 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb4a4) {
                                    // Lo  [27] HANGUL SYLLABLE DWEG..HANGUL SYLLABLE DWEH
                                    if (0xb489 <= code && code <= 0xb4a3) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb4a5) {
                                    // Lo       HANGUL SYLLABLE DWI
                                    if (0xb4a4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DWIG..HANGUL SYLLABLE DWIH
                                    if (0xb4a5 <= code && code <= 0xb4bf) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else if (code < 0xb4dd) {
                            if (code < 0xb4c1) {
                                // Lo       HANGUL SYLLABLE DYU
                                if (0xb4c0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else if (code < 0xb4dc) {
                                // Lo  [27] HANGUL SYLLABLE DYUG..HANGUL SYLLABLE DYUH
                                if (0xb4c1 <= code && code <= 0xb4db) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE DEU
                                if (0xb4dc === code) return boundaries_1.CLUSTER_BREAK.LV;
                            }
                        } else {
                            if (code < 0xb4f8) {
                                // Lo  [27] HANGUL SYLLABLE DEUG..HANGUL SYLLABLE DEUH
                                if (0xb4dd <= code && code <= 0xb4f7) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else if (code < 0xb4f9) {
                                // Lo       HANGUL SYLLABLE DYI
                                if (0xb4f8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE DYIG..HANGUL SYLLABLE DYIH
                                if (0xb4f9 <= code && code <= 0xb513) return boundaries_1.CLUSTER_BREAK.LVT;
                            }
                        }
                    } else {
                        if (code < 0xb54d) {
                            if (code < 0xb530) {
                                if (code < 0xb515) {
                                    // Lo       HANGUL SYLLABLE DI
                                    if (0xb514 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DIG..HANGUL SYLLABLE DIH
                                    if (0xb515 <= code && code <= 0xb52f) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb531) {
                                    // Lo       HANGUL SYLLABLE DDA
                                    if (0xb530 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xb54c) {
                                    // Lo  [27] HANGUL SYLLABLE DDAG..HANGUL SYLLABLE DDAH
                                    if (0xb531 <= code && code <= 0xb54b) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE DDAE
                                    if (0xb54c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else if (code < 0xb584) {
                            if (code < 0xb568) {
                                // Lo  [27] HANGUL SYLLABLE DDAEG..HANGUL SYLLABLE DDAEH
                                if (0xb54d <= code && code <= 0xb567) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else if (code < 0xb569) {
                                // Lo       HANGUL SYLLABLE DDYA
                                if (0xb568 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE DDYAG..HANGUL SYLLABLE DDYAH
                                if (0xb569 <= code && code <= 0xb583) return boundaries_1.CLUSTER_BREAK.LVT;
                            }
                        } else {
                            if (code < 0xb585) {
                                // Lo       HANGUL SYLLABLE DDYAE
                                if (0xb584 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else if (code < 0xb5a0) {
                                // Lo  [27] HANGUL SYLLABLE DDYAEG..HANGUL SYLLABLE DDYAEH
                                if (0xb585 <= code && code <= 0xb59f) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE DDEO
                                if (0xb5a0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            }
                        }
                    }
                }
            } else {
                if (code < 0xba55) {
                    if (code < 0xb808) {
                        if (code < 0xb6d4) {
                            if (code < 0xb62d) {
                                if (code < 0xb5f4) {
                                    if (code < 0xb5bd) {
                                        if (code < 0xb5bc) {
                                            // Lo  [27] HANGUL SYLLABLE DDEOG..HANGUL SYLLABLE DDEOH
                                            if (0xb5a1 <= code && code <= 0xb5bb) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE DDE
                                            if (0xb5bc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xb5d8) {
                                            // Lo  [27] HANGUL SYLLABLE DDEG..HANGUL SYLLABLE DDEH
                                            if (0xb5bd <= code && code <= 0xb5d7) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xb5d9) {
                                            // Lo       HANGUL SYLLABLE DDYEO
                                            if (0xb5d8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE DDYEOG..HANGUL SYLLABLE DDYEOH
                                            if (0xb5d9 <= code && code <= 0xb5f3) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xb610) {
                                    if (code < 0xb5f5) {
                                        // Lo       HANGUL SYLLABLE DDYE
                                        if (0xb5f4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE DDYEG..HANGUL SYLLABLE DDYEH
                                        if (0xb5f5 <= code && code <= 0xb60f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb611) {
                                        // Lo       HANGUL SYLLABLE DDO
                                        if (0xb610 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb62c) {
                                        // Lo  [27] HANGUL SYLLABLE DDOG..HANGUL SYLLABLE DDOH
                                        if (0xb611 <= code && code <= 0xb62b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE DDWA
                                        if (0xb62c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else {
                                if (code < 0xb680) {
                                    if (code < 0xb649) {
                                        if (code < 0xb648) {
                                            // Lo  [27] HANGUL SYLLABLE DDWAG..HANGUL SYLLABLE DDWAH
                                            if (0xb62d <= code && code <= 0xb647) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE DDWAE
                                            if (0xb648 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xb664) {
                                            // Lo  [27] HANGUL SYLLABLE DDWAEG..HANGUL SYLLABLE DDWAEH
                                            if (0xb649 <= code && code <= 0xb663) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xb665) {
                                            // Lo       HANGUL SYLLABLE DDOE
                                            if (0xb664 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE DDOEG..HANGUL SYLLABLE DDOEH
                                            if (0xb665 <= code && code <= 0xb67f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xb69d) {
                                    if (code < 0xb681) {
                                        // Lo       HANGUL SYLLABLE DDYO
                                        if (0xb680 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb69c) {
                                        // Lo  [27] HANGUL SYLLABLE DDYOG..HANGUL SYLLABLE DDYOH
                                        if (0xb681 <= code && code <= 0xb69b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE DDU
                                        if (0xb69c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb6b8) {
                                        // Lo  [27] HANGUL SYLLABLE DDUG..HANGUL SYLLABLE DDUH
                                        if (0xb69d <= code && code <= 0xb6b7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb6b9) {
                                        // Lo       HANGUL SYLLABLE DDWEO
                                        if (0xb6b8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE DDWEOG..HANGUL SYLLABLE DDWEOH
                                        if (0xb6b9 <= code && code <= 0xb6d3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            }
                        } else if (code < 0xb761) {
                            if (code < 0xb70d) {
                                if (code < 0xb6f0) {
                                    if (code < 0xb6d5) {
                                        // Lo       HANGUL SYLLABLE DDWE
                                        if (0xb6d4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE DDWEG..HANGUL SYLLABLE DDWEH
                                        if (0xb6d5 <= code && code <= 0xb6ef) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb6f1) {
                                        // Lo       HANGUL SYLLABLE DDWI
                                        if (0xb6f0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb70c) {
                                        // Lo  [27] HANGUL SYLLABLE DDWIG..HANGUL SYLLABLE DDWIH
                                        if (0xb6f1 <= code && code <= 0xb70b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE DDYU
                                        if (0xb70c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xb744) {
                                if (code < 0xb728) {
                                    // Lo  [27] HANGUL SYLLABLE DDYUG..HANGUL SYLLABLE DDYUH
                                    if (0xb70d <= code && code <= 0xb727) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb729) {
                                    // Lo       HANGUL SYLLABLE DDEU
                                    if (0xb728 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE DDEUG..HANGUL SYLLABLE DDEUH
                                    if (0xb729 <= code && code <= 0xb743) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xb745) {
                                    // Lo       HANGUL SYLLABLE DDYI
                                    if (0xb744 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xb760) {
                                    // Lo  [27] HANGUL SYLLABLE DDYIG..HANGUL SYLLABLE DDYIH
                                    if (0xb745 <= code && code <= 0xb75f) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE DDI
                                    if (0xb760 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xb7b4) {
                                if (code < 0xb77d) {
                                    if (code < 0xb77c) {
                                        // Lo  [27] HANGUL SYLLABLE DDIG..HANGUL SYLLABLE DDIH
                                        if (0xb761 <= code && code <= 0xb77b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE RA
                                        if (0xb77c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb798) {
                                        // Lo  [27] HANGUL SYLLABLE RAG..HANGUL SYLLABLE RAH
                                        if (0xb77d <= code && code <= 0xb797) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb799) {
                                        // Lo       HANGUL SYLLABLE RAE
                                        if (0xb798 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE RAEG..HANGUL SYLLABLE RAEH
                                        if (0xb799 <= code && code <= 0xb7b3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xb7d1) {
                                if (code < 0xb7b5) {
                                    // Lo       HANGUL SYLLABLE RYA
                                    if (0xb7b4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xb7d0) {
                                    // Lo  [27] HANGUL SYLLABLE RYAG..HANGUL SYLLABLE RYAH
                                    if (0xb7b5 <= code && code <= 0xb7cf) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE RYAE
                                    if (0xb7d0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb7ec) {
                                    // Lo  [27] HANGUL SYLLABLE RYAEG..HANGUL SYLLABLE RYAEH
                                    if (0xb7d1 <= code && code <= 0xb7eb) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb7ed) {
                                    // Lo       HANGUL SYLLABLE REO
                                    if (0xb7ec === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE REOG..HANGUL SYLLABLE REOH
                                    if (0xb7ed <= code && code <= 0xb807) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else {
                        if (code < 0xb921) {
                            if (code < 0xb894) {
                                if (code < 0xb841) {
                                    if (code < 0xb824) {
                                        if (code < 0xb809) {
                                            // Lo       HANGUL SYLLABLE RE
                                            if (0xb808 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE REG..HANGUL SYLLABLE REH
                                            if (0xb809 <= code && code <= 0xb823) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xb825) {
                                            // Lo       HANGUL SYLLABLE RYEO
                                            if (0xb824 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xb840) {
                                            // Lo  [27] HANGUL SYLLABLE RYEOG..HANGUL SYLLABLE RYEOH
                                            if (0xb825 <= code && code <= 0xb83f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE RYE
                                            if (0xb840 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xb85d) {
                                    if (code < 0xb85c) {
                                        // Lo  [27] HANGUL SYLLABLE RYEG..HANGUL SYLLABLE RYEH
                                        if (0xb841 <= code && code <= 0xb85b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE RO
                                        if (0xb85c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb878) {
                                        // Lo  [27] HANGUL SYLLABLE ROG..HANGUL SYLLABLE ROH
                                        if (0xb85d <= code && code <= 0xb877) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb879) {
                                        // Lo       HANGUL SYLLABLE RWA
                                        if (0xb878 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE RWAG..HANGUL SYLLABLE RWAH
                                        if (0xb879 <= code && code <= 0xb893) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xb8cd) {
                                    if (code < 0xb8b0) {
                                        if (code < 0xb895) {
                                            // Lo       HANGUL SYLLABLE RWAE
                                            if (0xb894 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE RWAEG..HANGUL SYLLABLE RWAEH
                                            if (0xb895 <= code && code <= 0xb8af) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xb8b1) {
                                            // Lo       HANGUL SYLLABLE ROE
                                            if (0xb8b0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xb8cc) {
                                            // Lo  [27] HANGUL SYLLABLE ROEG..HANGUL SYLLABLE ROEH
                                            if (0xb8b1 <= code && code <= 0xb8cb) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE RYO
                                            if (0xb8cc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xb904) {
                                    if (code < 0xb8e8) {
                                        // Lo  [27] HANGUL SYLLABLE RYOG..HANGUL SYLLABLE RYOH
                                        if (0xb8cd <= code && code <= 0xb8e7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb8e9) {
                                        // Lo       HANGUL SYLLABLE RU
                                        if (0xb8e8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE RUG..HANGUL SYLLABLE RUH
                                        if (0xb8e9 <= code && code <= 0xb903) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb905) {
                                        // Lo       HANGUL SYLLABLE RWEO
                                        if (0xb904 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xb920) {
                                        // Lo  [27] HANGUL SYLLABLE RWEOG..HANGUL SYLLABLE RWEOH
                                        if (0xb905 <= code && code <= 0xb91f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE RWE
                                        if (0xb920 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xb9c8) {
                            if (code < 0xb974) {
                                if (code < 0xb93d) {
                                    if (code < 0xb93c) {
                                        // Lo  [27] HANGUL SYLLABLE RWEG..HANGUL SYLLABLE RWEH
                                        if (0xb921 <= code && code <= 0xb93b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE RWI
                                        if (0xb93c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xb958) {
                                        // Lo  [27] HANGUL SYLLABLE RWIG..HANGUL SYLLABLE RWIH
                                        if (0xb93d <= code && code <= 0xb957) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xb959) {
                                        // Lo       HANGUL SYLLABLE RYU
                                        if (0xb958 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE RYUG..HANGUL SYLLABLE RYUH
                                        if (0xb959 <= code && code <= 0xb973) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xb991) {
                                if (code < 0xb975) {
                                    // Lo       HANGUL SYLLABLE REU
                                    if (0xb974 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xb990) {
                                    // Lo  [27] HANGUL SYLLABLE REUG..HANGUL SYLLABLE REUH
                                    if (0xb975 <= code && code <= 0xb98f) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE RYI
                                    if (0xb990 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xb9ac) {
                                    // Lo  [27] HANGUL SYLLABLE RYIG..HANGUL SYLLABLE RYIH
                                    if (0xb991 <= code && code <= 0xb9ab) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xb9ad) {
                                    // Lo       HANGUL SYLLABLE RI
                                    if (0xb9ac === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE RIG..HANGUL SYLLABLE RIH
                                    if (0xb9ad <= code && code <= 0xb9c7) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xba01) {
                                if (code < 0xb9e4) {
                                    if (code < 0xb9c9) {
                                        // Lo       HANGUL SYLLABLE MA
                                        if (0xb9c8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE MAG..HANGUL SYLLABLE MAH
                                        if (0xb9c9 <= code && code <= 0xb9e3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xb9e5) {
                                        // Lo       HANGUL SYLLABLE MAE
                                        if (0xb9e4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xba00) {
                                        // Lo  [27] HANGUL SYLLABLE MAEG..HANGUL SYLLABLE MAEH
                                        if (0xb9e5 <= code && code <= 0xb9ff) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE MYA
                                        if (0xba00 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xba38) {
                                if (code < 0xba1c) {
                                    // Lo  [27] HANGUL SYLLABLE MYAG..HANGUL SYLLABLE MYAH
                                    if (0xba01 <= code && code <= 0xba1b) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xba1d) {
                                    // Lo       HANGUL SYLLABLE MYAE
                                    if (0xba1c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE MYAEG..HANGUL SYLLABLE MYAEH
                                    if (0xba1d <= code && code <= 0xba37) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xba39) {
                                    // Lo       HANGUL SYLLABLE MEO
                                    if (0xba38 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xba54) {
                                    // Lo  [27] HANGUL SYLLABLE MEOG..HANGUL SYLLABLE MEOH
                                    if (0xba39 <= code && code <= 0xba53) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE ME
                                    if (0xba54 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    }
                } else if (code < 0xbcbc) {
                    if (code < 0xbb88) {
                        if (code < 0xbae1) {
                            if (code < 0xbaa8) {
                                if (code < 0xba71) {
                                    if (code < 0xba70) {
                                        // Lo  [27] HANGUL SYLLABLE MEG..HANGUL SYLLABLE MEH
                                        if (0xba55 <= code && code <= 0xba6f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE MYEO
                                        if (0xba70 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xba8c) {
                                        // Lo  [27] HANGUL SYLLABLE MYEOG..HANGUL SYLLABLE MYEOH
                                        if (0xba71 <= code && code <= 0xba8b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xba8d) {
                                        // Lo       HANGUL SYLLABLE MYE
                                        if (0xba8c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE MYEG..HANGUL SYLLABLE MYEH
                                        if (0xba8d <= code && code <= 0xbaa7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xbac4) {
                                if (code < 0xbaa9) {
                                    // Lo       HANGUL SYLLABLE MO
                                    if (0xbaa8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE MOG..HANGUL SYLLABLE MOH
                                    if (0xbaa9 <= code && code <= 0xbac3) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xbac5) {
                                    // Lo       HANGUL SYLLABLE MWA
                                    if (0xbac4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xbae0) {
                                    // Lo  [27] HANGUL SYLLABLE MWAG..HANGUL SYLLABLE MWAH
                                    if (0xbac5 <= code && code <= 0xbadf) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE MWAE
                                    if (0xbae0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xbb34) {
                                if (code < 0xbafd) {
                                    if (code < 0xbafc) {
                                        // Lo  [27] HANGUL SYLLABLE MWAEG..HANGUL SYLLABLE MWAEH
                                        if (0xbae1 <= code && code <= 0xbafb) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE MOE
                                        if (0xbafc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xbb18) {
                                        // Lo  [27] HANGUL SYLLABLE MOEG..HANGUL SYLLABLE MOEH
                                        if (0xbafd <= code && code <= 0xbb17) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xbb19) {
                                        // Lo       HANGUL SYLLABLE MYO
                                        if (0xbb18 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE MYOG..HANGUL SYLLABLE MYOH
                                        if (0xbb19 <= code && code <= 0xbb33) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xbb51) {
                                if (code < 0xbb35) {
                                    // Lo       HANGUL SYLLABLE MU
                                    if (0xbb34 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xbb50) {
                                    // Lo  [27] HANGUL SYLLABLE MUG..HANGUL SYLLABLE MUH
                                    if (0xbb35 <= code && code <= 0xbb4f) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE MWEO
                                    if (0xbb50 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xbb6c) {
                                    // Lo  [27] HANGUL SYLLABLE MWEOG..HANGUL SYLLABLE MWEOH
                                    if (0xbb51 <= code && code <= 0xbb6b) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xbb6d) {
                                    // Lo       HANGUL SYLLABLE MWE
                                    if (0xbb6c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE MWEG..HANGUL SYLLABLE MWEH
                                    if (0xbb6d <= code && code <= 0xbb87) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else if (code < 0xbc15) {
                        if (code < 0xbbc1) {
                            if (code < 0xbba4) {
                                if (code < 0xbb89) {
                                    // Lo       HANGUL SYLLABLE MWI
                                    if (0xbb88 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE MWIG..HANGUL SYLLABLE MWIH
                                    if (0xbb89 <= code && code <= 0xbba3) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xbba5) {
                                    // Lo       HANGUL SYLLABLE MYU
                                    if (0xbba4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xbbc0) {
                                    // Lo  [27] HANGUL SYLLABLE MYUG..HANGUL SYLLABLE MYUH
                                    if (0xbba5 <= code && code <= 0xbbbf) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE MEU
                                    if (0xbbc0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else if (code < 0xbbf8) {
                            if (code < 0xbbdc) {
                                // Lo  [27] HANGUL SYLLABLE MEUG..HANGUL SYLLABLE MEUH
                                if (0xbbc1 <= code && code <= 0xbbdb) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else if (code < 0xbbdd) {
                                // Lo       HANGUL SYLLABLE MYI
                                if (0xbbdc === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE MYIG..HANGUL SYLLABLE MYIH
                                if (0xbbdd <= code && code <= 0xbbf7) return boundaries_1.CLUSTER_BREAK.LVT;
                            }
                        } else {
                            if (code < 0xbbf9) {
                                // Lo       HANGUL SYLLABLE MI
                                if (0xbbf8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else if (code < 0xbc14) {
                                // Lo  [27] HANGUL SYLLABLE MIG..HANGUL SYLLABLE MIH
                                if (0xbbf9 <= code && code <= 0xbc13) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE BA
                                if (0xbc14 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            }
                        }
                    } else {
                        if (code < 0xbc68) {
                            if (code < 0xbc31) {
                                if (code < 0xbc30) {
                                    // Lo  [27] HANGUL SYLLABLE BAG..HANGUL SYLLABLE BAH
                                    if (0xbc15 <= code && code <= 0xbc2f) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE BAE
                                    if (0xbc30 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xbc4c) {
                                    // Lo  [27] HANGUL SYLLABLE BAEG..HANGUL SYLLABLE BAEH
                                    if (0xbc31 <= code && code <= 0xbc4b) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xbc4d) {
                                    // Lo       HANGUL SYLLABLE BYA
                                    if (0xbc4c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE BYAG..HANGUL SYLLABLE BYAH
                                    if (0xbc4d <= code && code <= 0xbc67) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else if (code < 0xbc85) {
                            if (code < 0xbc69) {
                                // Lo       HANGUL SYLLABLE BYAE
                                if (0xbc68 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else if (code < 0xbc84) {
                                // Lo  [27] HANGUL SYLLABLE BYAEG..HANGUL SYLLABLE BYAEH
                                if (0xbc69 <= code && code <= 0xbc83) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE BEO
                                if (0xbc84 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            }
                        } else {
                            if (code < 0xbca0) {
                                // Lo  [27] HANGUL SYLLABLE BEOG..HANGUL SYLLABLE BEOH
                                if (0xbc85 <= code && code <= 0xbc9f) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else if (code < 0xbca1) {
                                // Lo       HANGUL SYLLABLE BE
                                if (0xbca0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE BEG..HANGUL SYLLABLE BEH
                                if (0xbca1 <= code && code <= 0xbcbb) return boundaries_1.CLUSTER_BREAK.LVT;
                            }
                        }
                    }
                } else {
                    if (code < 0xbdd5) {
                        if (code < 0xbd48) {
                            if (code < 0xbcf5) {
                                if (code < 0xbcd8) {
                                    if (code < 0xbcbd) {
                                        // Lo       HANGUL SYLLABLE BYEO
                                        if (0xbcbc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE BYEOG..HANGUL SYLLABLE BYEOH
                                        if (0xbcbd <= code && code <= 0xbcd7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xbcd9) {
                                        // Lo       HANGUL SYLLABLE BYE
                                        if (0xbcd8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xbcf4) {
                                        // Lo  [27] HANGUL SYLLABLE BYEG..HANGUL SYLLABLE BYEH
                                        if (0xbcd9 <= code && code <= 0xbcf3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE BO
                                        if (0xbcf4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xbd11) {
                                if (code < 0xbd10) {
                                    // Lo  [27] HANGUL SYLLABLE BOG..HANGUL SYLLABLE BOH
                                    if (0xbcf5 <= code && code <= 0xbd0f) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE BWA
                                    if (0xbd10 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xbd2c) {
                                    // Lo  [27] HANGUL SYLLABLE BWAG..HANGUL SYLLABLE BWAH
                                    if (0xbd11 <= code && code <= 0xbd2b) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xbd2d) {
                                    // Lo       HANGUL SYLLABLE BWAE
                                    if (0xbd2c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE BWAEG..HANGUL SYLLABLE BWAEH
                                    if (0xbd2d <= code && code <= 0xbd47) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xbd81) {
                                if (code < 0xbd64) {
                                    if (code < 0xbd49) {
                                        // Lo       HANGUL SYLLABLE BOE
                                        if (0xbd48 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE BOEG..HANGUL SYLLABLE BOEH
                                        if (0xbd49 <= code && code <= 0xbd63) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xbd65) {
                                        // Lo       HANGUL SYLLABLE BYO
                                        if (0xbd64 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xbd80) {
                                        // Lo  [27] HANGUL SYLLABLE BYOG..HANGUL SYLLABLE BYOH
                                        if (0xbd65 <= code && code <= 0xbd7f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE BU
                                        if (0xbd80 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xbdb8) {
                                if (code < 0xbd9c) {
                                    // Lo  [27] HANGUL SYLLABLE BUG..HANGUL SYLLABLE BUH
                                    if (0xbd81 <= code && code <= 0xbd9b) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xbd9d) {
                                    // Lo       HANGUL SYLLABLE BWEO
                                    if (0xbd9c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE BWEOG..HANGUL SYLLABLE BWEOH
                                    if (0xbd9d <= code && code <= 0xbdb7) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xbdb9) {
                                    // Lo       HANGUL SYLLABLE BWE
                                    if (0xbdb8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xbdd4) {
                                    // Lo  [27] HANGUL SYLLABLE BWEG..HANGUL SYLLABLE BWEH
                                    if (0xbdb9 <= code && code <= 0xbdd3) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE BWI
                                    if (0xbdd4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    } else if (code < 0xbe7c) {
                        if (code < 0xbe28) {
                            if (code < 0xbdf1) {
                                if (code < 0xbdf0) {
                                    // Lo  [27] HANGUL SYLLABLE BWIG..HANGUL SYLLABLE BWIH
                                    if (0xbdd5 <= code && code <= 0xbdef) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE BYU
                                    if (0xbdf0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xbe0c) {
                                    // Lo  [27] HANGUL SYLLABLE BYUG..HANGUL SYLLABLE BYUH
                                    if (0xbdf1 <= code && code <= 0xbe0b) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xbe0d) {
                                    // Lo       HANGUL SYLLABLE BEU
                                    if (0xbe0c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE BEUG..HANGUL SYLLABLE BEUH
                                    if (0xbe0d <= code && code <= 0xbe27) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else if (code < 0xbe45) {
                            if (code < 0xbe29) {
                                // Lo       HANGUL SYLLABLE BYI
                                if (0xbe28 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else if (code < 0xbe44) {
                                // Lo  [27] HANGUL SYLLABLE BYIG..HANGUL SYLLABLE BYIH
                                if (0xbe29 <= code && code <= 0xbe43) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE BI
                                if (0xbe44 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            }
                        } else {
                            if (code < 0xbe60) {
                                // Lo  [27] HANGUL SYLLABLE BIG..HANGUL SYLLABLE BIH
                                if (0xbe45 <= code && code <= 0xbe5f) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else if (code < 0xbe61) {
                                // Lo       HANGUL SYLLABLE BBA
                                if (0xbe60 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE BBAG..HANGUL SYLLABLE BBAH
                                if (0xbe61 <= code && code <= 0xbe7b) return boundaries_1.CLUSTER_BREAK.LVT;
                            }
                        }
                    } else {
                        if (code < 0xbeb5) {
                            if (code < 0xbe98) {
                                if (code < 0xbe7d) {
                                    // Lo       HANGUL SYLLABLE BBAE
                                    if (0xbe7c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE BBAEG..HANGUL SYLLABLE BBAEH
                                    if (0xbe7d <= code && code <= 0xbe97) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xbe99) {
                                    // Lo       HANGUL SYLLABLE BBYA
                                    if (0xbe98 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xbeb4) {
                                    // Lo  [27] HANGUL SYLLABLE BBYAG..HANGUL SYLLABLE BBYAH
                                    if (0xbe99 <= code && code <= 0xbeb3) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE BBYAE
                                    if (0xbeb4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else if (code < 0xbeec) {
                            if (code < 0xbed0) {
                                // Lo  [27] HANGUL SYLLABLE BBYAEG..HANGUL SYLLABLE BBYAEH
                                if (0xbeb5 <= code && code <= 0xbecf) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else if (code < 0xbed1) {
                                // Lo       HANGUL SYLLABLE BBEO
                                if (0xbed0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else {
                                // Lo  [27] HANGUL SYLLABLE BBEOG..HANGUL SYLLABLE BBEOH
                                if (0xbed1 <= code && code <= 0xbeeb) return boundaries_1.CLUSTER_BREAK.LVT;
                            }
                        } else {
                            if (code < 0xbeed) {
                                // Lo       HANGUL SYLLABLE BBE
                                if (0xbeec === code) return boundaries_1.CLUSTER_BREAK.LV;
                            } else if (code < 0xbf08) {
                                // Lo  [27] HANGUL SYLLABLE BBEG..HANGUL SYLLABLE BBEH
                                if (0xbeed <= code && code <= 0xbf07) return boundaries_1.CLUSTER_BREAK.LVT;
                            } else {
                                // Lo       HANGUL SYLLABLE BBYEO
                                if (0xbf08 === code) return boundaries_1.CLUSTER_BREAK.LV;
                            }
                        }
                    }
                }
            }
        } else {
            if (code < 0xd1d8) {
                if (code < 0xc870) {
                    if (code < 0xc3bc) {
                        if (code < 0xc155) {
                            if (code < 0xc03c) {
                                if (code < 0xbf95) {
                                    if (code < 0xbf5c) {
                                        if (code < 0xbf25) {
                                            if (code < 0xbf24) {
                                                // Lo  [27] HANGUL SYLLABLE BBYEOG..HANGUL SYLLABLE BBYEOH
                                                if (0xbf09 <= code && code <= 0xbf23) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE BBYE
                                                if (0xbf24 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xbf40) {
                                                // Lo  [27] HANGUL SYLLABLE BBYEG..HANGUL SYLLABLE BBYEH
                                                if (0xbf25 <= code && code <= 0xbf3f) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xbf41) {
                                                // Lo       HANGUL SYLLABLE BBO
                                                if (0xbf40 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE BBOG..HANGUL SYLLABLE BBOH
                                                if (0xbf41 <= code && code <= 0xbf5b) return boundaries_1.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xbf78) {
                                        if (code < 0xbf5d) {
                                            // Lo       HANGUL SYLLABLE BBWA
                                            if (0xbf5c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE BBWAG..HANGUL SYLLABLE BBWAH
                                            if (0xbf5d <= code && code <= 0xbf77) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xbf79) {
                                            // Lo       HANGUL SYLLABLE BBWAE
                                            if (0xbf78 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xbf94) {
                                            // Lo  [27] HANGUL SYLLABLE BBWAEG..HANGUL SYLLABLE BBWAEH
                                            if (0xbf79 <= code && code <= 0xbf93) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE BBOE
                                            if (0xbf94 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else {
                                    if (code < 0xbfe8) {
                                        if (code < 0xbfb1) {
                                            if (code < 0xbfb0) {
                                                // Lo  [27] HANGUL SYLLABLE BBOEG..HANGUL SYLLABLE BBOEH
                                                if (0xbf95 <= code && code <= 0xbfaf) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE BBYO
                                                if (0xbfb0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xbfcc) {
                                                // Lo  [27] HANGUL SYLLABLE BBYOG..HANGUL SYLLABLE BBYOH
                                                if (0xbfb1 <= code && code <= 0xbfcb) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xbfcd) {
                                                // Lo       HANGUL SYLLABLE BBU
                                                if (0xbfcc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE BBUG..HANGUL SYLLABLE BBUH
                                                if (0xbfcd <= code && code <= 0xbfe7) return boundaries_1.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xc005) {
                                        if (code < 0xbfe9) {
                                            // Lo       HANGUL SYLLABLE BBWEO
                                            if (0xbfe8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc004) {
                                            // Lo  [27] HANGUL SYLLABLE BBWEOG..HANGUL SYLLABLE BBWEOH
                                            if (0xbfe9 <= code && code <= 0xc003) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE BBWE
                                            if (0xc004 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc020) {
                                            // Lo  [27] HANGUL SYLLABLE BBWEG..HANGUL SYLLABLE BBWEH
                                            if (0xc005 <= code && code <= 0xc01f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc021) {
                                            // Lo       HANGUL SYLLABLE BBWI
                                            if (0xc020 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE BBWIG..HANGUL SYLLABLE BBWIH
                                            if (0xc021 <= code && code <= 0xc03b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                }
                            } else if (code < 0xc0c8) {
                                if (code < 0xc075) {
                                    if (code < 0xc058) {
                                        if (code < 0xc03d) {
                                            // Lo       HANGUL SYLLABLE BBYU
                                            if (0xc03c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE BBYUG..HANGUL SYLLABLE BBYUH
                                            if (0xc03d <= code && code <= 0xc057) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc059) {
                                            // Lo       HANGUL SYLLABLE BBEU
                                            if (0xc058 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc074) {
                                            // Lo  [27] HANGUL SYLLABLE BBEUG..HANGUL SYLLABLE BBEUH
                                            if (0xc059 <= code && code <= 0xc073) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE BBYI
                                            if (0xc074 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xc091) {
                                    if (code < 0xc090) {
                                        // Lo  [27] HANGUL SYLLABLE BBYIG..HANGUL SYLLABLE BBYIH
                                        if (0xc075 <= code && code <= 0xc08f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE BBI
                                        if (0xc090 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc0ac) {
                                        // Lo  [27] HANGUL SYLLABLE BBIG..HANGUL SYLLABLE BBIH
                                        if (0xc091 <= code && code <= 0xc0ab) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc0ad) {
                                        // Lo       HANGUL SYLLABLE SA
                                        if (0xc0ac === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SAG..HANGUL SYLLABLE SAH
                                        if (0xc0ad <= code && code <= 0xc0c7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xc101) {
                                    if (code < 0xc0e4) {
                                        if (code < 0xc0c9) {
                                            // Lo       HANGUL SYLLABLE SAE
                                            if (0xc0c8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SAEG..HANGUL SYLLABLE SAEH
                                            if (0xc0c9 <= code && code <= 0xc0e3) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc0e5) {
                                            // Lo       HANGUL SYLLABLE SYA
                                            if (0xc0e4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc100) {
                                            // Lo  [27] HANGUL SYLLABLE SYAG..HANGUL SYLLABLE SYAH
                                            if (0xc0e5 <= code && code <= 0xc0ff) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SYAE
                                            if (0xc100 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xc138) {
                                    if (code < 0xc11c) {
                                        // Lo  [27] HANGUL SYLLABLE SYAEG..HANGUL SYLLABLE SYAEH
                                        if (0xc101 <= code && code <= 0xc11b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc11d) {
                                        // Lo       HANGUL SYLLABLE SEO
                                        if (0xc11c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SEOG..HANGUL SYLLABLE SEOH
                                        if (0xc11d <= code && code <= 0xc137) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc139) {
                                        // Lo       HANGUL SYLLABLE SE
                                        if (0xc138 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc154) {
                                        // Lo  [27] HANGUL SYLLABLE SEG..HANGUL SYLLABLE SEH
                                        if (0xc139 <= code && code <= 0xc153) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SYEO
                                        if (0xc154 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else {
                            if (code < 0xc288) {
                                if (code < 0xc1e1) {
                                    if (code < 0xc1a8) {
                                        if (code < 0xc171) {
                                            if (code < 0xc170) {
                                                // Lo  [27] HANGUL SYLLABLE SYEOG..HANGUL SYLLABLE SYEOH
                                                if (0xc155 <= code && code <= 0xc16f) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE SYE
                                                if (0xc170 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xc18c) {
                                                // Lo  [27] HANGUL SYLLABLE SYEG..HANGUL SYLLABLE SYEH
                                                if (0xc171 <= code && code <= 0xc18b) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xc18d) {
                                                // Lo       HANGUL SYLLABLE SO
                                                if (0xc18c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE SOG..HANGUL SYLLABLE SOH
                                                if (0xc18d <= code && code <= 0xc1a7) return boundaries_1.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xc1c4) {
                                        if (code < 0xc1a9) {
                                            // Lo       HANGUL SYLLABLE SWA
                                            if (0xc1a8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SWAG..HANGUL SYLLABLE SWAH
                                            if (0xc1a9 <= code && code <= 0xc1c3) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc1c5) {
                                            // Lo       HANGUL SYLLABLE SWAE
                                            if (0xc1c4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc1e0) {
                                            // Lo  [27] HANGUL SYLLABLE SWAEG..HANGUL SYLLABLE SWAEH
                                            if (0xc1c5 <= code && code <= 0xc1df) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SOE
                                            if (0xc1e0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else {
                                    if (code < 0xc234) {
                                        if (code < 0xc1fd) {
                                            if (code < 0xc1fc) {
                                                // Lo  [27] HANGUL SYLLABLE SOEG..HANGUL SYLLABLE SOEH
                                                if (0xc1e1 <= code && code <= 0xc1fb) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE SYO
                                                if (0xc1fc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xc218) {
                                                // Lo  [27] HANGUL SYLLABLE SYOG..HANGUL SYLLABLE SYOH
                                                if (0xc1fd <= code && code <= 0xc217) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xc219) {
                                                // Lo       HANGUL SYLLABLE SU
                                                if (0xc218 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE SUG..HANGUL SYLLABLE SUH
                                                if (0xc219 <= code && code <= 0xc233) return boundaries_1.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xc251) {
                                        if (code < 0xc235) {
                                            // Lo       HANGUL SYLLABLE SWEO
                                            if (0xc234 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc250) {
                                            // Lo  [27] HANGUL SYLLABLE SWEOG..HANGUL SYLLABLE SWEOH
                                            if (0xc235 <= code && code <= 0xc24f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SWE
                                            if (0xc250 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc26c) {
                                            // Lo  [27] HANGUL SYLLABLE SWEG..HANGUL SYLLABLE SWEH
                                            if (0xc251 <= code && code <= 0xc26b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc26d) {
                                            // Lo       HANGUL SYLLABLE SWI
                                            if (0xc26c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SWIG..HANGUL SYLLABLE SWIH
                                            if (0xc26d <= code && code <= 0xc287) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                }
                            } else if (code < 0xc315) {
                                if (code < 0xc2c1) {
                                    if (code < 0xc2a4) {
                                        if (code < 0xc289) {
                                            // Lo       HANGUL SYLLABLE SYU
                                            if (0xc288 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SYUG..HANGUL SYLLABLE SYUH
                                            if (0xc289 <= code && code <= 0xc2a3) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc2a5) {
                                            // Lo       HANGUL SYLLABLE SEU
                                            if (0xc2a4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc2c0) {
                                            // Lo  [27] HANGUL SYLLABLE SEUG..HANGUL SYLLABLE SEUH
                                            if (0xc2a5 <= code && code <= 0xc2bf) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SYI
                                            if (0xc2c0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xc2f8) {
                                    if (code < 0xc2dc) {
                                        // Lo  [27] HANGUL SYLLABLE SYIG..HANGUL SYLLABLE SYIH
                                        if (0xc2c1 <= code && code <= 0xc2db) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc2dd) {
                                        // Lo       HANGUL SYLLABLE SI
                                        if (0xc2dc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SIG..HANGUL SYLLABLE SIH
                                        if (0xc2dd <= code && code <= 0xc2f7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc2f9) {
                                        // Lo       HANGUL SYLLABLE SSA
                                        if (0xc2f8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc314) {
                                        // Lo  [27] HANGUL SYLLABLE SSAG..HANGUL SYLLABLE SSAH
                                        if (0xc2f9 <= code && code <= 0xc313) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SSAE
                                        if (0xc314 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else {
                                if (code < 0xc368) {
                                    if (code < 0xc331) {
                                        if (code < 0xc330) {
                                            // Lo  [27] HANGUL SYLLABLE SSAEG..HANGUL SYLLABLE SSAEH
                                            if (0xc315 <= code && code <= 0xc32f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SSYA
                                            if (0xc330 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc34c) {
                                            // Lo  [27] HANGUL SYLLABLE SSYAG..HANGUL SYLLABLE SSYAH
                                            if (0xc331 <= code && code <= 0xc34b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc34d) {
                                            // Lo       HANGUL SYLLABLE SSYAE
                                            if (0xc34c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SSYAEG..HANGUL SYLLABLE SSYAEH
                                            if (0xc34d <= code && code <= 0xc367) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xc385) {
                                    if (code < 0xc369) {
                                        // Lo       HANGUL SYLLABLE SSEO
                                        if (0xc368 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc384) {
                                        // Lo  [27] HANGUL SYLLABLE SSEOG..HANGUL SYLLABLE SSEOH
                                        if (0xc369 <= code && code <= 0xc383) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SSE
                                        if (0xc384 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc3a0) {
                                        // Lo  [27] HANGUL SYLLABLE SSEG..HANGUL SYLLABLE SSEH
                                        if (0xc385 <= code && code <= 0xc39f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc3a1) {
                                        // Lo       HANGUL SYLLABLE SSYEO
                                        if (0xc3a0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SSYEOG..HANGUL SYLLABLE SSYEOH
                                        if (0xc3a1 <= code && code <= 0xc3bb) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            }
                        }
                    } else if (code < 0xc609) {
                        if (code < 0xc4d5) {
                            if (code < 0xc448) {
                                if (code < 0xc3f5) {
                                    if (code < 0xc3d8) {
                                        if (code < 0xc3bd) {
                                            // Lo       HANGUL SYLLABLE SSYE
                                            if (0xc3bc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SSYEG..HANGUL SYLLABLE SSYEH
                                            if (0xc3bd <= code && code <= 0xc3d7) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc3d9) {
                                            // Lo       HANGUL SYLLABLE SSO
                                            if (0xc3d8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc3f4) {
                                            // Lo  [27] HANGUL SYLLABLE SSOG..HANGUL SYLLABLE SSOH
                                            if (0xc3d9 <= code && code <= 0xc3f3) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SSWA
                                            if (0xc3f4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xc411) {
                                    if (code < 0xc410) {
                                        // Lo  [27] HANGUL SYLLABLE SSWAG..HANGUL SYLLABLE SSWAH
                                        if (0xc3f5 <= code && code <= 0xc40f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SSWAE
                                        if (0xc410 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc42c) {
                                        // Lo  [27] HANGUL SYLLABLE SSWAEG..HANGUL SYLLABLE SSWAEH
                                        if (0xc411 <= code && code <= 0xc42b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc42d) {
                                        // Lo       HANGUL SYLLABLE SSOE
                                        if (0xc42c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SSOEG..HANGUL SYLLABLE SSOEH
                                        if (0xc42d <= code && code <= 0xc447) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xc481) {
                                    if (code < 0xc464) {
                                        if (code < 0xc449) {
                                            // Lo       HANGUL SYLLABLE SSYO
                                            if (0xc448 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE SSYOG..HANGUL SYLLABLE SSYOH
                                            if (0xc449 <= code && code <= 0xc463) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc465) {
                                            // Lo       HANGUL SYLLABLE SSU
                                            if (0xc464 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc480) {
                                            // Lo  [27] HANGUL SYLLABLE SSUG..HANGUL SYLLABLE SSUH
                                            if (0xc465 <= code && code <= 0xc47f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE SSWEO
                                            if (0xc480 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xc4b8) {
                                    if (code < 0xc49c) {
                                        // Lo  [27] HANGUL SYLLABLE SSWEOG..HANGUL SYLLABLE SSWEOH
                                        if (0xc481 <= code && code <= 0xc49b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc49d) {
                                        // Lo       HANGUL SYLLABLE SSWE
                                        if (0xc49c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SSWEG..HANGUL SYLLABLE SSWEH
                                        if (0xc49d <= code && code <= 0xc4b7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc4b9) {
                                        // Lo       HANGUL SYLLABLE SSWI
                                        if (0xc4b8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc4d4) {
                                        // Lo  [27] HANGUL SYLLABLE SSWIG..HANGUL SYLLABLE SSWIH
                                        if (0xc4b9 <= code && code <= 0xc4d3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SSYU
                                        if (0xc4d4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xc57c) {
                            if (code < 0xc528) {
                                if (code < 0xc4f1) {
                                    if (code < 0xc4f0) {
                                        // Lo  [27] HANGUL SYLLABLE SSYUG..HANGUL SYLLABLE SSYUH
                                        if (0xc4d5 <= code && code <= 0xc4ef) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE SSEU
                                        if (0xc4f0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc50c) {
                                        // Lo  [27] HANGUL SYLLABLE SSEUG..HANGUL SYLLABLE SSEUH
                                        if (0xc4f1 <= code && code <= 0xc50b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc50d) {
                                        // Lo       HANGUL SYLLABLE SSYI
                                        if (0xc50c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE SSYIG..HANGUL SYLLABLE SSYIH
                                        if (0xc50d <= code && code <= 0xc527) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xc545) {
                                if (code < 0xc529) {
                                    // Lo       HANGUL SYLLABLE SSI
                                    if (0xc528 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xc544) {
                                    // Lo  [27] HANGUL SYLLABLE SSIG..HANGUL SYLLABLE SSIH
                                    if (0xc529 <= code && code <= 0xc543) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE A
                                    if (0xc544 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xc560) {
                                    // Lo  [27] HANGUL SYLLABLE AG..HANGUL SYLLABLE AH
                                    if (0xc545 <= code && code <= 0xc55f) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xc561) {
                                    // Lo       HANGUL SYLLABLE AE
                                    if (0xc560 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE AEG..HANGUL SYLLABLE AEH
                                    if (0xc561 <= code && code <= 0xc57b) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xc5b5) {
                                if (code < 0xc598) {
                                    if (code < 0xc57d) {
                                        // Lo       HANGUL SYLLABLE YA
                                        if (0xc57c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE YAG..HANGUL SYLLABLE YAH
                                        if (0xc57d <= code && code <= 0xc597) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc599) {
                                        // Lo       HANGUL SYLLABLE YAE
                                        if (0xc598 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc5b4) {
                                        // Lo  [27] HANGUL SYLLABLE YAEG..HANGUL SYLLABLE YAEH
                                        if (0xc599 <= code && code <= 0xc5b3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE EO
                                        if (0xc5b4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xc5ec) {
                                if (code < 0xc5d0) {
                                    // Lo  [27] HANGUL SYLLABLE EOG..HANGUL SYLLABLE EOH
                                    if (0xc5b5 <= code && code <= 0xc5cf) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xc5d1) {
                                    // Lo       HANGUL SYLLABLE E
                                    if (0xc5d0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE EG..HANGUL SYLLABLE EH
                                    if (0xc5d1 <= code && code <= 0xc5eb) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xc5ed) {
                                    // Lo       HANGUL SYLLABLE YEO
                                    if (0xc5ec === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xc608) {
                                    // Lo  [27] HANGUL SYLLABLE YEOG..HANGUL SYLLABLE YEOH
                                    if (0xc5ed <= code && code <= 0xc607) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE YE
                                    if (0xc608 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    } else {
                        if (code < 0xc73c) {
                            if (code < 0xc695) {
                                if (code < 0xc65c) {
                                    if (code < 0xc625) {
                                        if (code < 0xc624) {
                                            // Lo  [27] HANGUL SYLLABLE YEG..HANGUL SYLLABLE YEH
                                            if (0xc609 <= code && code <= 0xc623) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE O
                                            if (0xc624 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc640) {
                                            // Lo  [27] HANGUL SYLLABLE OG..HANGUL SYLLABLE OH
                                            if (0xc625 <= code && code <= 0xc63f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc641) {
                                            // Lo       HANGUL SYLLABLE WA
                                            if (0xc640 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE WAG..HANGUL SYLLABLE WAH
                                            if (0xc641 <= code && code <= 0xc65b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xc678) {
                                    if (code < 0xc65d) {
                                        // Lo       HANGUL SYLLABLE WAE
                                        if (0xc65c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE WAEG..HANGUL SYLLABLE WAEH
                                        if (0xc65d <= code && code <= 0xc677) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc679) {
                                        // Lo       HANGUL SYLLABLE OE
                                        if (0xc678 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc694) {
                                        // Lo  [27] HANGUL SYLLABLE OEG..HANGUL SYLLABLE OEH
                                        if (0xc679 <= code && code <= 0xc693) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE YO
                                        if (0xc694 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else {
                                if (code < 0xc6e8) {
                                    if (code < 0xc6b1) {
                                        if (code < 0xc6b0) {
                                            // Lo  [27] HANGUL SYLLABLE YOG..HANGUL SYLLABLE YOH
                                            if (0xc695 <= code && code <= 0xc6af) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE U
                                            if (0xc6b0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc6cc) {
                                            // Lo  [27] HANGUL SYLLABLE UG..HANGUL SYLLABLE UH
                                            if (0xc6b1 <= code && code <= 0xc6cb) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc6cd) {
                                            // Lo       HANGUL SYLLABLE WEO
                                            if (0xc6cc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE WEOG..HANGUL SYLLABLE WEOH
                                            if (0xc6cd <= code && code <= 0xc6e7) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xc705) {
                                    if (code < 0xc6e9) {
                                        // Lo       HANGUL SYLLABLE WE
                                        if (0xc6e8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc704) {
                                        // Lo  [27] HANGUL SYLLABLE WEG..HANGUL SYLLABLE WEH
                                        if (0xc6e9 <= code && code <= 0xc703) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE WI
                                        if (0xc704 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc720) {
                                        // Lo  [27] HANGUL SYLLABLE WIG..HANGUL SYLLABLE WIH
                                        if (0xc705 <= code && code <= 0xc71f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc721) {
                                        // Lo       HANGUL SYLLABLE YU
                                        if (0xc720 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE YUG..HANGUL SYLLABLE YUH
                                        if (0xc721 <= code && code <= 0xc73b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            }
                        } else if (code < 0xc7c9) {
                            if (code < 0xc775) {
                                if (code < 0xc758) {
                                    if (code < 0xc73d) {
                                        // Lo       HANGUL SYLLABLE EU
                                        if (0xc73c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE EUG..HANGUL SYLLABLE EUH
                                        if (0xc73d <= code && code <= 0xc757) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xc759) {
                                        // Lo       HANGUL SYLLABLE YI
                                        if (0xc758 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc774) {
                                        // Lo  [27] HANGUL SYLLABLE YIG..HANGUL SYLLABLE YIH
                                        if (0xc759 <= code && code <= 0xc773) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE I
                                        if (0xc774 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xc7ac) {
                                if (code < 0xc790) {
                                    // Lo  [27] HANGUL SYLLABLE IG..HANGUL SYLLABLE IH
                                    if (0xc775 <= code && code <= 0xc78f) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xc791) {
                                    // Lo       HANGUL SYLLABLE JA
                                    if (0xc790 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE JAG..HANGUL SYLLABLE JAH
                                    if (0xc791 <= code && code <= 0xc7ab) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xc7ad) {
                                    // Lo       HANGUL SYLLABLE JAE
                                    if (0xc7ac === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xc7c8) {
                                    // Lo  [27] HANGUL SYLLABLE JAEG..HANGUL SYLLABLE JAEH
                                    if (0xc7ad <= code && code <= 0xc7c7) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE JYA
                                    if (0xc7c8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xc81c) {
                                if (code < 0xc7e5) {
                                    if (code < 0xc7e4) {
                                        // Lo  [27] HANGUL SYLLABLE JYAG..HANGUL SYLLABLE JYAH
                                        if (0xc7c9 <= code && code <= 0xc7e3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE JYAE
                                        if (0xc7e4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xc800) {
                                        // Lo  [27] HANGUL SYLLABLE JYAEG..HANGUL SYLLABLE JYAEH
                                        if (0xc7e5 <= code && code <= 0xc7ff) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xc801) {
                                        // Lo       HANGUL SYLLABLE JEO
                                        if (0xc800 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE JEOG..HANGUL SYLLABLE JEOH
                                        if (0xc801 <= code && code <= 0xc81b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xc839) {
                                if (code < 0xc81d) {
                                    // Lo       HANGUL SYLLABLE JE
                                    if (0xc81c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xc838) {
                                    // Lo  [27] HANGUL SYLLABLE JEG..HANGUL SYLLABLE JEH
                                    if (0xc81d <= code && code <= 0xc837) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE JYEO
                                    if (0xc838 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xc854) {
                                    // Lo  [27] HANGUL SYLLABLE JYEOG..HANGUL SYLLABLE JYEOH
                                    if (0xc839 <= code && code <= 0xc853) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xc855) {
                                    // Lo       HANGUL SYLLABLE JYE
                                    if (0xc854 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE JYEG..HANGUL SYLLABLE JYEH
                                    if (0xc855 <= code && code <= 0xc86f) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    }
                } else {
                    if (code < 0xcd24) {
                        if (code < 0xcabd) {
                            if (code < 0xc989) {
                                if (code < 0xc8fc) {
                                    if (code < 0xc8a9) {
                                        if (code < 0xc88c) {
                                            if (code < 0xc871) {
                                                // Lo       HANGUL SYLLABLE JO
                                                if (0xc870 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE JOG..HANGUL SYLLABLE JOH
                                                if (0xc871 <= code && code <= 0xc88b) return boundaries_1.CLUSTER_BREAK.LVT;
                                            }
                                        } else {
                                            if (code < 0xc88d) {
                                                // Lo       HANGUL SYLLABLE JWA
                                                if (0xc88c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            } else if (code < 0xc8a8) {
                                                // Lo  [27] HANGUL SYLLABLE JWAG..HANGUL SYLLABLE JWAH
                                                if (0xc88d <= code && code <= 0xc8a7) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE JWAE
                                                if (0xc8a8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            }
                                        }
                                    } else if (code < 0xc8c5) {
                                        if (code < 0xc8c4) {
                                            // Lo  [27] HANGUL SYLLABLE JWAEG..HANGUL SYLLABLE JWAEH
                                            if (0xc8a9 <= code && code <= 0xc8c3) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JOE
                                            if (0xc8c4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc8e0) {
                                            // Lo  [27] HANGUL SYLLABLE JOEG..HANGUL SYLLABLE JOEH
                                            if (0xc8c5 <= code && code <= 0xc8df) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc8e1) {
                                            // Lo       HANGUL SYLLABLE JYO
                                            if (0xc8e0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JYOG..HANGUL SYLLABLE JYOH
                                            if (0xc8e1 <= code && code <= 0xc8fb) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else {
                                    if (code < 0xc935) {
                                        if (code < 0xc918) {
                                            if (code < 0xc8fd) {
                                                // Lo       HANGUL SYLLABLE JU
                                                if (0xc8fc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE JUG..HANGUL SYLLABLE JUH
                                                if (0xc8fd <= code && code <= 0xc917) return boundaries_1.CLUSTER_BREAK.LVT;
                                            }
                                        } else {
                                            if (code < 0xc919) {
                                                // Lo       HANGUL SYLLABLE JWEO
                                                if (0xc918 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            } else if (code < 0xc934) {
                                                // Lo  [27] HANGUL SYLLABLE JWEOG..HANGUL SYLLABLE JWEOH
                                                if (0xc919 <= code && code <= 0xc933) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE JWE
                                                if (0xc934 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            }
                                        }
                                    } else if (code < 0xc96c) {
                                        if (code < 0xc950) {
                                            // Lo  [27] HANGUL SYLLABLE JWEG..HANGUL SYLLABLE JWEH
                                            if (0xc935 <= code && code <= 0xc94f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc951) {
                                            // Lo       HANGUL SYLLABLE JWI
                                            if (0xc950 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JWIG..HANGUL SYLLABLE JWIH
                                            if (0xc951 <= code && code <= 0xc96b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xc96d) {
                                            // Lo       HANGUL SYLLABLE JYU
                                            if (0xc96c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xc988) {
                                            // Lo  [27] HANGUL SYLLABLE JYUG..HANGUL SYLLABLE JYUH
                                            if (0xc96d <= code && code <= 0xc987) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JEU
                                            if (0xc988 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                }
                            } else if (code < 0xca30) {
                                if (code < 0xc9dc) {
                                    if (code < 0xc9a5) {
                                        if (code < 0xc9a4) {
                                            // Lo  [27] HANGUL SYLLABLE JEUG..HANGUL SYLLABLE JEUH
                                            if (0xc989 <= code && code <= 0xc9a3) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JYI
                                            if (0xc9a4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xc9c0) {
                                            // Lo  [27] HANGUL SYLLABLE JYIG..HANGUL SYLLABLE JYIH
                                            if (0xc9a5 <= code && code <= 0xc9bf) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xc9c1) {
                                            // Lo       HANGUL SYLLABLE JI
                                            if (0xc9c0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JIG..HANGUL SYLLABLE JIH
                                            if (0xc9c1 <= code && code <= 0xc9db) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xc9f9) {
                                    if (code < 0xc9dd) {
                                        // Lo       HANGUL SYLLABLE JJA
                                        if (0xc9dc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xc9f8) {
                                        // Lo  [27] HANGUL SYLLABLE JJAG..HANGUL SYLLABLE JJAH
                                        if (0xc9dd <= code && code <= 0xc9f7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE JJAE
                                        if (0xc9f8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xca14) {
                                        // Lo  [27] HANGUL SYLLABLE JJAEG..HANGUL SYLLABLE JJAEH
                                        if (0xc9f9 <= code && code <= 0xca13) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xca15) {
                                        // Lo       HANGUL SYLLABLE JJYA
                                        if (0xca14 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE JJYAG..HANGUL SYLLABLE JJYAH
                                        if (0xca15 <= code && code <= 0xca2f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xca69) {
                                    if (code < 0xca4c) {
                                        if (code < 0xca31) {
                                            // Lo       HANGUL SYLLABLE JJYAE
                                            if (0xca30 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JJYAEG..HANGUL SYLLABLE JJYAEH
                                            if (0xca31 <= code && code <= 0xca4b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xca4d) {
                                            // Lo       HANGUL SYLLABLE JJEO
                                            if (0xca4c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xca68) {
                                            // Lo  [27] HANGUL SYLLABLE JJEOG..HANGUL SYLLABLE JJEOH
                                            if (0xca4d <= code && code <= 0xca67) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JJE
                                            if (0xca68 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xcaa0) {
                                    if (code < 0xca84) {
                                        // Lo  [27] HANGUL SYLLABLE JJEG..HANGUL SYLLABLE JJEH
                                        if (0xca69 <= code && code <= 0xca83) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xca85) {
                                        // Lo       HANGUL SYLLABLE JJYEO
                                        if (0xca84 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE JJYEOG..HANGUL SYLLABLE JJYEOH
                                        if (0xca85 <= code && code <= 0xca9f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xcaa1) {
                                        // Lo       HANGUL SYLLABLE JJYE
                                        if (0xcaa0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xcabc) {
                                        // Lo  [27] HANGUL SYLLABLE JJYEG..HANGUL SYLLABLE JJYEH
                                        if (0xcaa1 <= code && code <= 0xcabb) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE JJO
                                        if (0xcabc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else {
                            if (code < 0xcbf0) {
                                if (code < 0xcb49) {
                                    if (code < 0xcb10) {
                                        if (code < 0xcad9) {
                                            if (code < 0xcad8) {
                                                // Lo  [27] HANGUL SYLLABLE JJOG..HANGUL SYLLABLE JJOH
                                                if (0xcabd <= code && code <= 0xcad7) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE JJWA
                                                if (0xcad8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xcaf4) {
                                                // Lo  [27] HANGUL SYLLABLE JJWAG..HANGUL SYLLABLE JJWAH
                                                if (0xcad9 <= code && code <= 0xcaf3) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xcaf5) {
                                                // Lo       HANGUL SYLLABLE JJWAE
                                                if (0xcaf4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE JJWAEG..HANGUL SYLLABLE JJWAEH
                                                if (0xcaf5 <= code && code <= 0xcb0f) return boundaries_1.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xcb2c) {
                                        if (code < 0xcb11) {
                                            // Lo       HANGUL SYLLABLE JJOE
                                            if (0xcb10 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JJOEG..HANGUL SYLLABLE JJOEH
                                            if (0xcb11 <= code && code <= 0xcb2b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xcb2d) {
                                            // Lo       HANGUL SYLLABLE JJYO
                                            if (0xcb2c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xcb48) {
                                            // Lo  [27] HANGUL SYLLABLE JJYOG..HANGUL SYLLABLE JJYOH
                                            if (0xcb2d <= code && code <= 0xcb47) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JJU
                                            if (0xcb48 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else {
                                    if (code < 0xcb9c) {
                                        if (code < 0xcb65) {
                                            if (code < 0xcb64) {
                                                // Lo  [27] HANGUL SYLLABLE JJUG..HANGUL SYLLABLE JJUH
                                                if (0xcb49 <= code && code <= 0xcb63) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else {
                                                // Lo       HANGUL SYLLABLE JJWEO
                                                if (0xcb64 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            }
                                        } else {
                                            if (code < 0xcb80) {
                                                // Lo  [27] HANGUL SYLLABLE JJWEOG..HANGUL SYLLABLE JJWEOH
                                                if (0xcb65 <= code && code <= 0xcb7f) return boundaries_1.CLUSTER_BREAK.LVT;
                                            } else if (code < 0xcb81) {
                                                // Lo       HANGUL SYLLABLE JJWE
                                                if (0xcb80 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                            } else {
                                                // Lo  [27] HANGUL SYLLABLE JJWEG..HANGUL SYLLABLE JJWEH
                                                if (0xcb81 <= code && code <= 0xcb9b) return boundaries_1.CLUSTER_BREAK.LVT;
                                            }
                                        }
                                    } else if (code < 0xcbb9) {
                                        if (code < 0xcb9d) {
                                            // Lo       HANGUL SYLLABLE JJWI
                                            if (0xcb9c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xcbb8) {
                                            // Lo  [27] HANGUL SYLLABLE JJWIG..HANGUL SYLLABLE JJWIH
                                            if (0xcb9d <= code && code <= 0xcbb7) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE JJYU
                                            if (0xcbb8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xcbd4) {
                                            // Lo  [27] HANGUL SYLLABLE JJYUG..HANGUL SYLLABLE JJYUH
                                            if (0xcbb9 <= code && code <= 0xcbd3) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xcbd5) {
                                            // Lo       HANGUL SYLLABLE JJEU
                                            if (0xcbd4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JJEUG..HANGUL SYLLABLE JJEUH
                                            if (0xcbd5 <= code && code <= 0xcbef) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                }
                            } else if (code < 0xcc7d) {
                                if (code < 0xcc29) {
                                    if (code < 0xcc0c) {
                                        if (code < 0xcbf1) {
                                            // Lo       HANGUL SYLLABLE JJYI
                                            if (0xcbf0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE JJYIG..HANGUL SYLLABLE JJYIH
                                            if (0xcbf1 <= code && code <= 0xcc0b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xcc0d) {
                                            // Lo       HANGUL SYLLABLE JJI
                                            if (0xcc0c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xcc28) {
                                            // Lo  [27] HANGUL SYLLABLE JJIG..HANGUL SYLLABLE JJIH
                                            if (0xcc0d <= code && code <= 0xcc27) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE CA
                                            if (0xcc28 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xcc60) {
                                    if (code < 0xcc44) {
                                        // Lo  [27] HANGUL SYLLABLE CAG..HANGUL SYLLABLE CAH
                                        if (0xcc29 <= code && code <= 0xcc43) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xcc45) {
                                        // Lo       HANGUL SYLLABLE CAE
                                        if (0xcc44 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE CAEG..HANGUL SYLLABLE CAEH
                                        if (0xcc45 <= code && code <= 0xcc5f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xcc61) {
                                        // Lo       HANGUL SYLLABLE CYA
                                        if (0xcc60 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xcc7c) {
                                        // Lo  [27] HANGUL SYLLABLE CYAG..HANGUL SYLLABLE CYAH
                                        if (0xcc61 <= code && code <= 0xcc7b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE CYAE
                                        if (0xcc7c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else {
                                if (code < 0xccd0) {
                                    if (code < 0xcc99) {
                                        if (code < 0xcc98) {
                                            // Lo  [27] HANGUL SYLLABLE CYAEG..HANGUL SYLLABLE CYAEH
                                            if (0xcc7d <= code && code <= 0xcc97) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE CEO
                                            if (0xcc98 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xccb4) {
                                            // Lo  [27] HANGUL SYLLABLE CEOG..HANGUL SYLLABLE CEOH
                                            if (0xcc99 <= code && code <= 0xccb3) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xccb5) {
                                            // Lo       HANGUL SYLLABLE CE
                                            if (0xccb4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE CEG..HANGUL SYLLABLE CEH
                                            if (0xccb5 <= code && code <= 0xcccf) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xcced) {
                                    if (code < 0xccd1) {
                                        // Lo       HANGUL SYLLABLE CYEO
                                        if (0xccd0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xccec) {
                                        // Lo  [27] HANGUL SYLLABLE CYEOG..HANGUL SYLLABLE CYEOH
                                        if (0xccd1 <= code && code <= 0xcceb) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE CYE
                                        if (0xccec === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xcd08) {
                                        // Lo  [27] HANGUL SYLLABLE CYEG..HANGUL SYLLABLE CYEH
                                        if (0xcced <= code && code <= 0xcd07) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xcd09) {
                                        // Lo       HANGUL SYLLABLE CO
                                        if (0xcd08 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE COG..HANGUL SYLLABLE COH
                                        if (0xcd09 <= code && code <= 0xcd23) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            }
                        }
                    } else if (code < 0xcf71) {
                        if (code < 0xce3d) {
                            if (code < 0xcdb0) {
                                if (code < 0xcd5d) {
                                    if (code < 0xcd40) {
                                        if (code < 0xcd25) {
                                            // Lo       HANGUL SYLLABLE CWA
                                            if (0xcd24 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE CWAG..HANGUL SYLLABLE CWAH
                                            if (0xcd25 <= code && code <= 0xcd3f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xcd41) {
                                            // Lo       HANGUL SYLLABLE CWAE
                                            if (0xcd40 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xcd5c) {
                                            // Lo  [27] HANGUL SYLLABLE CWAEG..HANGUL SYLLABLE CWAEH
                                            if (0xcd41 <= code && code <= 0xcd5b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE COE
                                            if (0xcd5c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xcd79) {
                                    if (code < 0xcd78) {
                                        // Lo  [27] HANGUL SYLLABLE COEG..HANGUL SYLLABLE COEH
                                        if (0xcd5d <= code && code <= 0xcd77) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE CYO
                                        if (0xcd78 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xcd94) {
                                        // Lo  [27] HANGUL SYLLABLE CYOG..HANGUL SYLLABLE CYOH
                                        if (0xcd79 <= code && code <= 0xcd93) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xcd95) {
                                        // Lo       HANGUL SYLLABLE CU
                                        if (0xcd94 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE CUG..HANGUL SYLLABLE CUH
                                        if (0xcd95 <= code && code <= 0xcdaf) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xcde9) {
                                    if (code < 0xcdcc) {
                                        if (code < 0xcdb1) {
                                            // Lo       HANGUL SYLLABLE CWEO
                                            if (0xcdb0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE CWEOG..HANGUL SYLLABLE CWEOH
                                            if (0xcdb1 <= code && code <= 0xcdcb) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xcdcd) {
                                            // Lo       HANGUL SYLLABLE CWE
                                            if (0xcdcc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xcde8) {
                                            // Lo  [27] HANGUL SYLLABLE CWEG..HANGUL SYLLABLE CWEH
                                            if (0xcdcd <= code && code <= 0xcde7) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE CWI
                                            if (0xcde8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xce20) {
                                    if (code < 0xce04) {
                                        // Lo  [27] HANGUL SYLLABLE CWIG..HANGUL SYLLABLE CWIH
                                        if (0xcde9 <= code && code <= 0xce03) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xce05) {
                                        // Lo       HANGUL SYLLABLE CYU
                                        if (0xce04 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE CYUG..HANGUL SYLLABLE CYUH
                                        if (0xce05 <= code && code <= 0xce1f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xce21) {
                                        // Lo       HANGUL SYLLABLE CEU
                                        if (0xce20 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xce3c) {
                                        // Lo  [27] HANGUL SYLLABLE CEUG..HANGUL SYLLABLE CEUH
                                        if (0xce21 <= code && code <= 0xce3b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE CYI
                                        if (0xce3c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xcee4) {
                            if (code < 0xce90) {
                                if (code < 0xce59) {
                                    if (code < 0xce58) {
                                        // Lo  [27] HANGUL SYLLABLE CYIG..HANGUL SYLLABLE CYIH
                                        if (0xce3d <= code && code <= 0xce57) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE CI
                                        if (0xce58 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xce74) {
                                        // Lo  [27] HANGUL SYLLABLE CIG..HANGUL SYLLABLE CIH
                                        if (0xce59 <= code && code <= 0xce73) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xce75) {
                                        // Lo       HANGUL SYLLABLE KA
                                        if (0xce74 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE KAG..HANGUL SYLLABLE KAH
                                        if (0xce75 <= code && code <= 0xce8f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xcead) {
                                if (code < 0xce91) {
                                    // Lo       HANGUL SYLLABLE KAE
                                    if (0xce90 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xceac) {
                                    // Lo  [27] HANGUL SYLLABLE KAEG..HANGUL SYLLABLE KAEH
                                    if (0xce91 <= code && code <= 0xceab) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE KYA
                                    if (0xceac === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xcec8) {
                                    // Lo  [27] HANGUL SYLLABLE KYAG..HANGUL SYLLABLE KYAH
                                    if (0xcead <= code && code <= 0xcec7) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xcec9) {
                                    // Lo       HANGUL SYLLABLE KYAE
                                    if (0xcec8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE KYAEG..HANGUL SYLLABLE KYAEH
                                    if (0xcec9 <= code && code <= 0xcee3) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xcf1d) {
                                if (code < 0xcf00) {
                                    if (code < 0xcee5) {
                                        // Lo       HANGUL SYLLABLE KEO
                                        if (0xcee4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE KEOG..HANGUL SYLLABLE KEOH
                                        if (0xcee5 <= code && code <= 0xceff) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xcf01) {
                                        // Lo       HANGUL SYLLABLE KE
                                        if (0xcf00 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xcf1c) {
                                        // Lo  [27] HANGUL SYLLABLE KEG..HANGUL SYLLABLE KEH
                                        if (0xcf01 <= code && code <= 0xcf1b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE KYEO
                                        if (0xcf1c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xcf54) {
                                if (code < 0xcf38) {
                                    // Lo  [27] HANGUL SYLLABLE KYEOG..HANGUL SYLLABLE KYEOH
                                    if (0xcf1d <= code && code <= 0xcf37) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xcf39) {
                                    // Lo       HANGUL SYLLABLE KYE
                                    if (0xcf38 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE KYEG..HANGUL SYLLABLE KYEH
                                    if (0xcf39 <= code && code <= 0xcf53) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xcf55) {
                                    // Lo       HANGUL SYLLABLE KO
                                    if (0xcf54 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xcf70) {
                                    // Lo  [27] HANGUL SYLLABLE KOG..HANGUL SYLLABLE KOH
                                    if (0xcf55 <= code && code <= 0xcf6f) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE KWA
                                    if (0xcf70 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    } else {
                        if (code < 0xd0a4) {
                            if (code < 0xcffd) {
                                if (code < 0xcfc4) {
                                    if (code < 0xcf8d) {
                                        if (code < 0xcf8c) {
                                            // Lo  [27] HANGUL SYLLABLE KWAG..HANGUL SYLLABLE KWAH
                                            if (0xcf71 <= code && code <= 0xcf8b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE KWAE
                                            if (0xcf8c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xcfa8) {
                                            // Lo  [27] HANGUL SYLLABLE KWAEG..HANGUL SYLLABLE KWAEH
                                            if (0xcf8d <= code && code <= 0xcfa7) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xcfa9) {
                                            // Lo       HANGUL SYLLABLE KOE
                                            if (0xcfa8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE KOEG..HANGUL SYLLABLE KOEH
                                            if (0xcfa9 <= code && code <= 0xcfc3) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xcfe0) {
                                    if (code < 0xcfc5) {
                                        // Lo       HANGUL SYLLABLE KYO
                                        if (0xcfc4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE KYOG..HANGUL SYLLABLE KYOH
                                        if (0xcfc5 <= code && code <= 0xcfdf) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xcfe1) {
                                        // Lo       HANGUL SYLLABLE KU
                                        if (0xcfe0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xcffc) {
                                        // Lo  [27] HANGUL SYLLABLE KUG..HANGUL SYLLABLE KUH
                                        if (0xcfe1 <= code && code <= 0xcffb) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE KWEO
                                        if (0xcffc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else {
                                if (code < 0xd050) {
                                    if (code < 0xd019) {
                                        if (code < 0xd018) {
                                            // Lo  [27] HANGUL SYLLABLE KWEOG..HANGUL SYLLABLE KWEOH
                                            if (0xcffd <= code && code <= 0xd017) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE KWE
                                            if (0xd018 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    } else {
                                        if (code < 0xd034) {
                                            // Lo  [27] HANGUL SYLLABLE KWEG..HANGUL SYLLABLE KWEH
                                            if (0xd019 <= code && code <= 0xd033) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else if (code < 0xd035) {
                                            // Lo       HANGUL SYLLABLE KWI
                                            if (0xd034 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE KWIG..HANGUL SYLLABLE KWIH
                                            if (0xd035 <= code && code <= 0xd04f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    }
                                } else if (code < 0xd06d) {
                                    if (code < 0xd051) {
                                        // Lo       HANGUL SYLLABLE KYU
                                        if (0xd050 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xd06c) {
                                        // Lo  [27] HANGUL SYLLABLE KYUG..HANGUL SYLLABLE KYUH
                                        if (0xd051 <= code && code <= 0xd06b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE KEU
                                        if (0xd06c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd088) {
                                        // Lo  [27] HANGUL SYLLABLE KEUG..HANGUL SYLLABLE KEUH
                                        if (0xd06d <= code && code <= 0xd087) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd089) {
                                        // Lo       HANGUL SYLLABLE KYI
                                        if (0xd088 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE KYIG..HANGUL SYLLABLE KYIH
                                        if (0xd089 <= code && code <= 0xd0a3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            }
                        } else if (code < 0xd131) {
                            if (code < 0xd0dd) {
                                if (code < 0xd0c0) {
                                    if (code < 0xd0a5) {
                                        // Lo       HANGUL SYLLABLE KI
                                        if (0xd0a4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE KIG..HANGUL SYLLABLE KIH
                                        if (0xd0a5 <= code && code <= 0xd0bf) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xd0c1) {
                                        // Lo       HANGUL SYLLABLE TA
                                        if (0xd0c0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xd0dc) {
                                        // Lo  [27] HANGUL SYLLABLE TAG..HANGUL SYLLABLE TAH
                                        if (0xd0c1 <= code && code <= 0xd0db) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE TAE
                                        if (0xd0dc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xd114) {
                                if (code < 0xd0f8) {
                                    // Lo  [27] HANGUL SYLLABLE TAEG..HANGUL SYLLABLE TAEH
                                    if (0xd0dd <= code && code <= 0xd0f7) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd0f9) {
                                    // Lo       HANGUL SYLLABLE TYA
                                    if (0xd0f8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE TYAG..HANGUL SYLLABLE TYAH
                                    if (0xd0f9 <= code && code <= 0xd113) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xd115) {
                                    // Lo       HANGUL SYLLABLE TYAE
                                    if (0xd114 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xd130) {
                                    // Lo  [27] HANGUL SYLLABLE TYAEG..HANGUL SYLLABLE TYAEH
                                    if (0xd115 <= code && code <= 0xd12f) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE TEO
                                    if (0xd130 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xd184) {
                                if (code < 0xd14d) {
                                    if (code < 0xd14c) {
                                        // Lo  [27] HANGUL SYLLABLE TEOG..HANGUL SYLLABLE TEOH
                                        if (0xd131 <= code && code <= 0xd14b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE TE
                                        if (0xd14c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd168) {
                                        // Lo  [27] HANGUL SYLLABLE TEG..HANGUL SYLLABLE TEH
                                        if (0xd14d <= code && code <= 0xd167) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd169) {
                                        // Lo       HANGUL SYLLABLE TYEO
                                        if (0xd168 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE TYEOG..HANGUL SYLLABLE TYEOH
                                        if (0xd169 <= code && code <= 0xd183) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd1a1) {
                                if (code < 0xd185) {
                                    // Lo       HANGUL SYLLABLE TYE
                                    if (0xd184 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xd1a0) {
                                    // Lo  [27] HANGUL SYLLABLE TYEG..HANGUL SYLLABLE TYEH
                                    if (0xd185 <= code && code <= 0xd19f) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE TO
                                    if (0xd1a0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xd1bc) {
                                    // Lo  [27] HANGUL SYLLABLE TOG..HANGUL SYLLABLE TOH
                                    if (0xd1a1 <= code && code <= 0xd1bb) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd1bd) {
                                    // Lo       HANGUL SYLLABLE TWA
                                    if (0xd1bc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE TWAG..HANGUL SYLLABLE TWAH
                                    if (0xd1bd <= code && code <= 0xd1d7) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    }
                }
            } else if (code < 0x1133b) {
                if (code < 0xd671) {
                    if (code < 0xd424) {
                        if (code < 0xd2f1) {
                            if (code < 0xd264) {
                                if (code < 0xd211) {
                                    if (code < 0xd1f4) {
                                        if (code < 0xd1d9) {
                                            // Lo       HANGUL SYLLABLE TWAE
                                            if (0xd1d8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE TWAEG..HANGUL SYLLABLE TWAEH
                                            if (0xd1d9 <= code && code <= 0xd1f3) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xd1f5) {
                                            // Lo       HANGUL SYLLABLE TOE
                                            if (0xd1f4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xd210) {
                                            // Lo  [27] HANGUL SYLLABLE TOEG..HANGUL SYLLABLE TOEH
                                            if (0xd1f5 <= code && code <= 0xd20f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE TYO
                                            if (0xd210 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xd22d) {
                                    if (code < 0xd22c) {
                                        // Lo  [27] HANGUL SYLLABLE TYOG..HANGUL SYLLABLE TYOH
                                        if (0xd211 <= code && code <= 0xd22b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE TU
                                        if (0xd22c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd248) {
                                        // Lo  [27] HANGUL SYLLABLE TUG..HANGUL SYLLABLE TUH
                                        if (0xd22d <= code && code <= 0xd247) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd249) {
                                        // Lo       HANGUL SYLLABLE TWEO
                                        if (0xd248 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE TWEOG..HANGUL SYLLABLE TWEOH
                                        if (0xd249 <= code && code <= 0xd263) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xd29d) {
                                    if (code < 0xd280) {
                                        if (code < 0xd265) {
                                            // Lo       HANGUL SYLLABLE TWE
                                            if (0xd264 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE TWEG..HANGUL SYLLABLE TWEH
                                            if (0xd265 <= code && code <= 0xd27f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xd281) {
                                            // Lo       HANGUL SYLLABLE TWI
                                            if (0xd280 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xd29c) {
                                            // Lo  [27] HANGUL SYLLABLE TWIG..HANGUL SYLLABLE TWIH
                                            if (0xd281 <= code && code <= 0xd29b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE TYU
                                            if (0xd29c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xd2d4) {
                                    if (code < 0xd2b8) {
                                        // Lo  [27] HANGUL SYLLABLE TYUG..HANGUL SYLLABLE TYUH
                                        if (0xd29d <= code && code <= 0xd2b7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd2b9) {
                                        // Lo       HANGUL SYLLABLE TEU
                                        if (0xd2b8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE TEUG..HANGUL SYLLABLE TEUH
                                        if (0xd2b9 <= code && code <= 0xd2d3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xd2d5) {
                                        // Lo       HANGUL SYLLABLE TYI
                                        if (0xd2d4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xd2f0) {
                                        // Lo  [27] HANGUL SYLLABLE TYIG..HANGUL SYLLABLE TYIH
                                        if (0xd2d5 <= code && code <= 0xd2ef) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE TI
                                        if (0xd2f0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xd37d) {
                            if (code < 0xd344) {
                                if (code < 0xd30d) {
                                    if (code < 0xd30c) {
                                        // Lo  [27] HANGUL SYLLABLE TIG..HANGUL SYLLABLE TIH
                                        if (0xd2f1 <= code && code <= 0xd30b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE PA
                                        if (0xd30c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd328) {
                                        // Lo  [27] HANGUL SYLLABLE PAG..HANGUL SYLLABLE PAH
                                        if (0xd30d <= code && code <= 0xd327) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd329) {
                                        // Lo       HANGUL SYLLABLE PAE
                                        if (0xd328 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE PAEG..HANGUL SYLLABLE PAEH
                                        if (0xd329 <= code && code <= 0xd343) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd360) {
                                if (code < 0xd345) {
                                    // Lo       HANGUL SYLLABLE PYA
                                    if (0xd344 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE PYAG..HANGUL SYLLABLE PYAH
                                    if (0xd345 <= code && code <= 0xd35f) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xd361) {
                                    // Lo       HANGUL SYLLABLE PYAE
                                    if (0xd360 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xd37c) {
                                    // Lo  [27] HANGUL SYLLABLE PYAEG..HANGUL SYLLABLE PYAEH
                                    if (0xd361 <= code && code <= 0xd37b) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE PEO
                                    if (0xd37c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xd3d0) {
                                if (code < 0xd399) {
                                    if (code < 0xd398) {
                                        // Lo  [27] HANGUL SYLLABLE PEOG..HANGUL SYLLABLE PEOH
                                        if (0xd37d <= code && code <= 0xd397) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE PE
                                        if (0xd398 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd3b4) {
                                        // Lo  [27] HANGUL SYLLABLE PEG..HANGUL SYLLABLE PEH
                                        if (0xd399 <= code && code <= 0xd3b3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd3b5) {
                                        // Lo       HANGUL SYLLABLE PYEO
                                        if (0xd3b4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE PYEOG..HANGUL SYLLABLE PYEOH
                                        if (0xd3b5 <= code && code <= 0xd3cf) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd3ed) {
                                if (code < 0xd3d1) {
                                    // Lo       HANGUL SYLLABLE PYE
                                    if (0xd3d0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xd3ec) {
                                    // Lo  [27] HANGUL SYLLABLE PYEG..HANGUL SYLLABLE PYEH
                                    if (0xd3d1 <= code && code <= 0xd3eb) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE PO
                                    if (0xd3ec === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xd408) {
                                    // Lo  [27] HANGUL SYLLABLE POG..HANGUL SYLLABLE POH
                                    if (0xd3ed <= code && code <= 0xd407) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd409) {
                                    // Lo       HANGUL SYLLABLE PWA
                                    if (0xd408 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE PWAG..HANGUL SYLLABLE PWAH
                                    if (0xd409 <= code && code <= 0xd423) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else {
                        if (code < 0xd53d) {
                            if (code < 0xd4b0) {
                                if (code < 0xd45d) {
                                    if (code < 0xd440) {
                                        if (code < 0xd425) {
                                            // Lo       HANGUL SYLLABLE PWAE
                                            if (0xd424 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE PWAEG..HANGUL SYLLABLE PWAEH
                                            if (0xd425 <= code && code <= 0xd43f) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xd441) {
                                            // Lo       HANGUL SYLLABLE POE
                                            if (0xd440 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xd45c) {
                                            // Lo  [27] HANGUL SYLLABLE POEG..HANGUL SYLLABLE POEH
                                            if (0xd441 <= code && code <= 0xd45b) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE PYO
                                            if (0xd45c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xd479) {
                                    if (code < 0xd478) {
                                        // Lo  [27] HANGUL SYLLABLE PYOG..HANGUL SYLLABLE PYOH
                                        if (0xd45d <= code && code <= 0xd477) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE PU
                                        if (0xd478 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd494) {
                                        // Lo  [27] HANGUL SYLLABLE PUG..HANGUL SYLLABLE PUH
                                        if (0xd479 <= code && code <= 0xd493) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd495) {
                                        // Lo       HANGUL SYLLABLE PWEO
                                        if (0xd494 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE PWEOG..HANGUL SYLLABLE PWEOH
                                        if (0xd495 <= code && code <= 0xd4af) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else {
                                if (code < 0xd4e9) {
                                    if (code < 0xd4cc) {
                                        if (code < 0xd4b1) {
                                            // Lo       HANGUL SYLLABLE PWE
                                            if (0xd4b0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else {
                                            // Lo  [27] HANGUL SYLLABLE PWEG..HANGUL SYLLABLE PWEH
                                            if (0xd4b1 <= code && code <= 0xd4cb) return boundaries_1.CLUSTER_BREAK.LVT;
                                        }
                                    } else {
                                        if (code < 0xd4cd) {
                                            // Lo       HANGUL SYLLABLE PWI
                                            if (0xd4cc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        } else if (code < 0xd4e8) {
                                            // Lo  [27] HANGUL SYLLABLE PWIG..HANGUL SYLLABLE PWIH
                                            if (0xd4cd <= code && code <= 0xd4e7) return boundaries_1.CLUSTER_BREAK.LVT;
                                        } else {
                                            // Lo       HANGUL SYLLABLE PYU
                                            if (0xd4e8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                        }
                                    }
                                } else if (code < 0xd520) {
                                    if (code < 0xd504) {
                                        // Lo  [27] HANGUL SYLLABLE PYUG..HANGUL SYLLABLE PYUH
                                        if (0xd4e9 <= code && code <= 0xd503) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd505) {
                                        // Lo       HANGUL SYLLABLE PEU
                                        if (0xd504 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE PEUG..HANGUL SYLLABLE PEUH
                                        if (0xd505 <= code && code <= 0xd51f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xd521) {
                                        // Lo       HANGUL SYLLABLE PYI
                                        if (0xd520 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xd53c) {
                                        // Lo  [27] HANGUL SYLLABLE PYIG..HANGUL SYLLABLE PYIH
                                        if (0xd521 <= code && code <= 0xd53b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE PI
                                        if (0xd53c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            }
                        } else if (code < 0xd5e4) {
                            if (code < 0xd590) {
                                if (code < 0xd559) {
                                    if (code < 0xd558) {
                                        // Lo  [27] HANGUL SYLLABLE PIG..HANGUL SYLLABLE PIH
                                        if (0xd53d <= code && code <= 0xd557) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE HA
                                        if (0xd558 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd574) {
                                        // Lo  [27] HANGUL SYLLABLE HAG..HANGUL SYLLABLE HAH
                                        if (0xd559 <= code && code <= 0xd573) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd575) {
                                        // Lo       HANGUL SYLLABLE HAE
                                        if (0xd574 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE HAEG..HANGUL SYLLABLE HAEH
                                        if (0xd575 <= code && code <= 0xd58f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd5ad) {
                                if (code < 0xd591) {
                                    // Lo       HANGUL SYLLABLE HYA
                                    if (0xd590 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xd5ac) {
                                    // Lo  [27] HANGUL SYLLABLE HYAG..HANGUL SYLLABLE HYAH
                                    if (0xd591 <= code && code <= 0xd5ab) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE HYAE
                                    if (0xd5ac === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xd5c8) {
                                    // Lo  [27] HANGUL SYLLABLE HYAEG..HANGUL SYLLABLE HYAEH
                                    if (0xd5ad <= code && code <= 0xd5c7) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd5c9) {
                                    // Lo       HANGUL SYLLABLE HEO
                                    if (0xd5c8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE HEOG..HANGUL SYLLABLE HEOH
                                    if (0xd5c9 <= code && code <= 0xd5e3) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        } else {
                            if (code < 0xd61d) {
                                if (code < 0xd600) {
                                    if (code < 0xd5e5) {
                                        // Lo       HANGUL SYLLABLE HE
                                        if (0xd5e4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE HEG..HANGUL SYLLABLE HEH
                                        if (0xd5e5 <= code && code <= 0xd5ff) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                } else {
                                    if (code < 0xd601) {
                                        // Lo       HANGUL SYLLABLE HYEO
                                        if (0xd600 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else if (code < 0xd61c) {
                                        // Lo  [27] HANGUL SYLLABLE HYEOG..HANGUL SYLLABLE HYEOH
                                        if (0xd601 <= code && code <= 0xd61b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE HYE
                                        if (0xd61c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                }
                            } else if (code < 0xd654) {
                                if (code < 0xd638) {
                                    // Lo  [27] HANGUL SYLLABLE HYEG..HANGUL SYLLABLE HYEH
                                    if (0xd61d <= code && code <= 0xd637) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd639) {
                                    // Lo       HANGUL SYLLABLE HO
                                    if (0xd638 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE HOG..HANGUL SYLLABLE HOH
                                    if (0xd639 <= code && code <= 0xd653) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xd655) {
                                    // Lo       HANGUL SYLLABLE HWA
                                    if (0xd654 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xd670) {
                                    // Lo  [27] HANGUL SYLLABLE HWAG..HANGUL SYLLABLE HWAH
                                    if (0xd655 <= code && code <= 0xd66f) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE HWAE
                                    if (0xd670 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        }
                    }
                } else if (code < 0x11000) {
                    if (code < 0xd7b0) {
                        if (code < 0xd6fd) {
                            if (code < 0xd6c4) {
                                if (code < 0xd68d) {
                                    if (code < 0xd68c) {
                                        // Lo  [27] HANGUL SYLLABLE HWAEG..HANGUL SYLLABLE HWAEH
                                        if (0xd671 <= code && code <= 0xd68b) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE HOE
                                        if (0xd68c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd6a8) {
                                        // Lo  [27] HANGUL SYLLABLE HOEG..HANGUL SYLLABLE HOEH
                                        if (0xd68d <= code && code <= 0xd6a7) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd6a9) {
                                        // Lo       HANGUL SYLLABLE HYO
                                        if (0xd6a8 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE HYOG..HANGUL SYLLABLE HYOH
                                        if (0xd6a9 <= code && code <= 0xd6c3) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd6e0) {
                                if (code < 0xd6c5) {
                                    // Lo       HANGUL SYLLABLE HU
                                    if (0xd6c4 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE HUG..HANGUL SYLLABLE HUH
                                    if (0xd6c5 <= code && code <= 0xd6df) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            } else {
                                if (code < 0xd6e1) {
                                    // Lo       HANGUL SYLLABLE HWEO
                                    if (0xd6e0 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xd6fc) {
                                    // Lo  [27] HANGUL SYLLABLE HWEOG..HANGUL SYLLABLE HWEOH
                                    if (0xd6e1 <= code && code <= 0xd6fb) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE HWE
                                    if (0xd6fc === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            }
                        } else {
                            if (code < 0xd750) {
                                if (code < 0xd719) {
                                    if (code < 0xd718) {
                                        // Lo  [27] HANGUL SYLLABLE HWEG..HANGUL SYLLABLE HWEH
                                        if (0xd6fd <= code && code <= 0xd717) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else {
                                        // Lo       HANGUL SYLLABLE HWI
                                        if (0xd718 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    }
                                } else {
                                    if (code < 0xd734) {
                                        // Lo  [27] HANGUL SYLLABLE HWIG..HANGUL SYLLABLE HWIH
                                        if (0xd719 <= code && code <= 0xd733) return boundaries_1.CLUSTER_BREAK.LVT;
                                    } else if (code < 0xd735) {
                                        // Lo       HANGUL SYLLABLE HYU
                                        if (0xd734 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                    } else {
                                        // Lo  [27] HANGUL SYLLABLE HYUG..HANGUL SYLLABLE HYUH
                                        if (0xd735 <= code && code <= 0xd74f) return boundaries_1.CLUSTER_BREAK.LVT;
                                    }
                                }
                            } else if (code < 0xd76d) {
                                if (code < 0xd751) {
                                    // Lo       HANGUL SYLLABLE HEU
                                    if (0xd750 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else if (code < 0xd76c) {
                                    // Lo  [27] HANGUL SYLLABLE HEUG..HANGUL SYLLABLE HEUH
                                    if (0xd751 <= code && code <= 0xd76b) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else {
                                    // Lo       HANGUL SYLLABLE HYI
                                    if (0xd76c === code) return boundaries_1.CLUSTER_BREAK.LV;
                                }
                            } else {
                                if (code < 0xd788) {
                                    // Lo  [27] HANGUL SYLLABLE HYIG..HANGUL SYLLABLE HYIH
                                    if (0xd76d <= code && code <= 0xd787) return boundaries_1.CLUSTER_BREAK.LVT;
                                } else if (code < 0xd789) {
                                    // Lo       HANGUL SYLLABLE HI
                                    if (0xd788 === code) return boundaries_1.CLUSTER_BREAK.LV;
                                } else {
                                    // Lo  [27] HANGUL SYLLABLE HIG..HANGUL SYLLABLE HIH
                                    if (0xd789 <= code && code <= 0xd7a3) return boundaries_1.CLUSTER_BREAK.LVT;
                                }
                            }
                        }
                    } else if (code < 0x10a01) {
                        if (code < 0xfeff) {
                            if (code < 0xfb1e) {
                                if (code < 0xd7cb) {
                                    // Lo  [23] HANGUL JUNGSEONG O-YEO..HANGUL JUNGSEONG ARAEA-E
                                    if (0xd7b0 <= code && code <= 0xd7c6) return boundaries_1.CLUSTER_BREAK.V;
                                } else {
                                    // Lo  [49] HANGUL JONGSEONG NIEUN-RIEUL..HANGUL JONGSEONG PHIEUPH-THIEUTH
                                    if (0xd7cb <= code && code <= 0xd7fb) return boundaries_1.CLUSTER_BREAK.T;
                                }
                            } else {
                                if (code < 0xfe00) {
                                    // Mn       HEBREW POINT JUDEO-SPANISH VARIKA
                                    if (0xfb1e === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0xfe20) {
                                    // Mn  [16] VARIATION SELECTOR-1..VARIATION SELECTOR-16
                                    if (0xfe00 <= code && code <= 0xfe0f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn  [16] COMBINING LIGATURE LEFT HALF..COMBINING CYRILLIC TITLO RIGHT HALF
                                    if (0xfe20 <= code && code <= 0xfe2f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0x101fd) {
                            if (code < 0xff9e) {
                                // Cf       ZERO WIDTH NO-BREAK SPACE
                                if (0xfeff === code) return boundaries_1.CLUSTER_BREAK.CONTROL;
                            } else if (code < 0xfff0) {
                                // Lm   [2] HALFWIDTH KATAKANA VOICED SOUND MARK..HALFWIDTH KATAKANA SEMI-VOICED SOUND MARK
                                if (0xff9e <= code && code <= 0xff9f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Cn   [9] <reserved-FFF0>..<reserved-FFF8>
                                // Cf   [3] INTERLINEAR ANNOTATION ANCHOR..INTERLINEAR ANNOTATION TERMINATOR
                                if (0xfff0 <= code && code <= 0xfffb) return boundaries_1.CLUSTER_BREAK.CONTROL;
                            }
                        } else {
                            if (code < 0x102e0) {
                                // Mn       PHAISTOS DISC SIGN COMBINING OBLIQUE STROKE
                                if (0x101fd === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x10376) {
                                // Mn       COPTIC EPACT THOUSANDS MARK
                                if (0x102e0 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn   [5] COMBINING OLD PERMIC LETTER AN..COMBINING OLD PERMIC LETTER SII
                                if (0x10376 <= code && code <= 0x1037a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        }
                    } else {
                        if (code < 0x10ae5) {
                            if (code < 0x10a0c) {
                                if (code < 0x10a05) {
                                    // Mn   [3] KHAROSHTHI VOWEL SIGN I..KHAROSHTHI VOWEL SIGN VOCALIC R
                                    if (0x10a01 <= code && code <= 0x10a03) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [2] KHAROSHTHI VOWEL SIGN E..KHAROSHTHI VOWEL SIGN O
                                    if (0x10a05 <= code && code <= 0x10a06) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x10a38) {
                                    // Mn   [4] KHAROSHTHI VOWEL LENGTH MARK..KHAROSHTHI SIGN VISARGA
                                    if (0x10a0c <= code && code <= 0x10a0f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x10a3f) {
                                    // Mn   [3] KHAROSHTHI SIGN BAR ABOVE..KHAROSHTHI SIGN DOT BELOW
                                    if (0x10a38 <= code && code <= 0x10a3a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       KHAROSHTHI VIRAMA
                                    if (0x10a3f === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0x10efd) {
                            if (code < 0x10d24) {
                                // Mn   [2] MANICHAEAN ABBREVIATION MARK ABOVE..MANICHAEAN ABBREVIATION MARK BELOW
                                if (0x10ae5 <= code && code <= 0x10ae6) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x10eab) {
                                // Mn   [4] HANIFI ROHINGYA SIGN HARBAHAY..HANIFI ROHINGYA SIGN TASSI
                                if (0x10d24 <= code && code <= 0x10d27) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn   [2] YEZIDI COMBINING HAMZA MARK..YEZIDI COMBINING MADDA MARK
                                if (0x10eab <= code && code <= 0x10eac) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        } else {
                            if (code < 0x10f46) {
                                // Mn   [3] ARABIC SMALL LOW WORD SAKTA..ARABIC SMALL LOW WORD MADDA
                                if (0x10efd <= code && code <= 0x10eff) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x10f82) {
                                // Mn  [11] SOGDIAN COMBINING DOT BELOW..SOGDIAN COMBINING STROKE BELOW
                                if (0x10f46 <= code && code <= 0x10f50) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn   [4] OLD UYGHUR COMBINING DOT ABOVE..OLD UYGHUR COMBINING TWO DOTS BELOW
                                if (0x10f82 <= code && code <= 0x10f85) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        }
                    }
                } else {
                    if (code < 0x11180) {
                        if (code < 0x110b7) {
                            if (code < 0x11073) {
                                if (code < 0x11002) {
                                    // Mc       BRAHMI SIGN CANDRABINDU
                                    if (0x11000 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       BRAHMI SIGN ANUSVARA
                                    if (0x11001 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (code < 0x11038) {
                                        // Mc       BRAHMI SIGN VISARGA
                                        if (0x11002 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x11070) {
                                        // Mn  [15] BRAHMI VOWEL SIGN AA..BRAHMI VIRAMA
                                        if (0x11038 <= code && code <= 0x11046) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn       BRAHMI SIGN OLD TAMIL VIRAMA
                                        if (0x11070 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x11082) {
                                if (code < 0x1107f) {
                                    // Mn   [2] BRAHMI VOWEL SIGN OLD TAMIL SHORT E..BRAHMI VOWEL SIGN OLD TAMIL SHORT O
                                    if (0x11073 <= code && code <= 0x11074) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [3] BRAHMI NUMBER JOINER..KAITHI SIGN ANUSVARA
                                    if (0x1107f <= code && code <= 0x11081) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x110b0) {
                                    // Mc       KAITHI SIGN VISARGA
                                    if (0x11082 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0x110b3) {
                                    // Mc   [3] KAITHI VOWEL SIGN AA..KAITHI VOWEL SIGN II
                                    if (0x110b0 <= code && code <= 0x110b2) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn   [4] KAITHI VOWEL SIGN U..KAITHI VOWEL SIGN AI
                                    if (0x110b3 <= code && code <= 0x110b6) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0x11100) {
                                if (code < 0x110bd) {
                                    if (code < 0x110b9) {
                                        // Mc   [2] KAITHI VOWEL SIGN O..KAITHI VOWEL SIGN AU
                                        if (0x110b7 <= code && code <= 0x110b8) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] KAITHI SIGN VIRAMA..KAITHI SIGN NUKTA
                                        if (0x110b9 <= code && code <= 0x110ba) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0x110c2) {
                                    // Cf       KAITHI NUMBER SIGN
                                    if (0x110bd === code) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                } else {
                                    // Mn       KAITHI VOWEL SIGN VOCALIC R
                                    if (0x110c2 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    // Cf       KAITHI NUMBER SIGN ABOVE
                                    if (0x110cd === code) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                }
                            } else if (code < 0x1112d) {
                                if (code < 0x11127) {
                                    // Mn   [3] CHAKMA SIGN CANDRABINDU..CHAKMA SIGN VISARGA
                                    if (0x11100 <= code && code <= 0x11102) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1112c) {
                                    // Mn   [5] CHAKMA VOWEL SIGN A..CHAKMA VOWEL SIGN UU
                                    if (0x11127 <= code && code <= 0x1112b) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc       CHAKMA VOWEL SIGN E
                                    if (0x1112c === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0x11145) {
                                    // Mn   [8] CHAKMA VOWEL SIGN AI..CHAKMA MAAYYAA
                                    if (0x1112d <= code && code <= 0x11134) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x11173) {
                                    // Mc   [2] CHAKMA VOWEL SIGN AA..CHAKMA VOWEL SIGN EI
                                    if (0x11145 <= code && code <= 0x11146) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       MAHAJANI SIGN NUKTA
                                    if (0x11173 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    } else if (code < 0x11232) {
                        if (code < 0x111c2) {
                            if (code < 0x111b3) {
                                if (code < 0x11182) {
                                    // Mn   [2] SHARADA SIGN CANDRABINDU..SHARADA SIGN ANUSVARA
                                    if (0x11180 <= code && code <= 0x11181) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc       SHARADA SIGN VISARGA
                                    if (0x11182 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0x111b6) {
                                    // Mc   [3] SHARADA VOWEL SIGN AA..SHARADA VOWEL SIGN II
                                    if (0x111b3 <= code && code <= 0x111b5) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0x111bf) {
                                    // Mn   [9] SHARADA VOWEL SIGN U..SHARADA VOWEL SIGN O
                                    if (0x111b6 <= code && code <= 0x111be) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [2] SHARADA VOWEL SIGN AU..SHARADA SIGN VIRAMA
                                    if (0x111bf <= code && code <= 0x111c0) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            }
                        } else if (code < 0x111cf) {
                            if (code < 0x111c9) {
                                // Lo   [2] SHARADA SIGN JIHVAMULIYA..SHARADA SIGN UPADHMANIYA
                                if (0x111c2 <= code && code <= 0x111c3) return boundaries_1.CLUSTER_BREAK.PREPEND;
                            } else if (code < 0x111ce) {
                                // Mn   [4] SHARADA SANDHI MARK..SHARADA EXTRA SHORT VOWEL MARK
                                if (0x111c9 <= code && code <= 0x111cc) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mc       SHARADA VOWEL SIGN PRISHTHAMATRA E
                                if (0x111ce === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                            }
                        } else {
                            if (code < 0x1122c) {
                                // Mn       SHARADA SIGN INVERTED CANDRABINDU
                                if (0x111cf === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x1122f) {
                                // Mc   [3] KHOJKI VOWEL SIGN AA..KHOJKI VOWEL SIGN II
                                if (0x1122c <= code && code <= 0x1122e) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                            } else {
                                // Mn   [3] KHOJKI VOWEL SIGN U..KHOJKI VOWEL SIGN AI
                                if (0x1122f <= code && code <= 0x11231) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        }
                    } else {
                        if (code < 0x11241) {
                            if (code < 0x11235) {
                                if (code < 0x11234) {
                                    // Mc   [2] KHOJKI VOWEL SIGN O..KHOJKI VOWEL SIGN AU
                                    if (0x11232 <= code && code <= 0x11233) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       KHOJKI SIGN ANUSVARA
                                    if (0x11234 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x11236) {
                                    // Mc       KHOJKI SIGN VIRAMA
                                    if (0x11235 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0x1123e) {
                                    // Mn   [2] KHOJKI SIGN NUKTA..KHOJKI SIGN SHADDA
                                    if (0x11236 <= code && code <= 0x11237) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       KHOJKI SIGN SUKUN
                                    if (0x1123e === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0x112e3) {
                            if (code < 0x112df) {
                                // Mn       KHOJKI VOWEL SIGN VOCALIC R
                                if (0x11241 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x112e0) {
                                // Mn       KHUDAWADI SIGN ANUSVARA
                                if (0x112df === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mc   [3] KHUDAWADI VOWEL SIGN AA..KHUDAWADI VOWEL SIGN II
                                if (0x112e0 <= code && code <= 0x112e2) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                            }
                        } else {
                            if (code < 0x11300) {
                                // Mn   [8] KHUDAWADI VOWEL SIGN U..KHUDAWADI SIGN VIRAMA
                                if (0x112e3 <= code && code <= 0x112ea) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x11302) {
                                // Mn   [2] GRANTHA SIGN COMBINING ANUSVARA ABOVE..GRANTHA SIGN CANDRABINDU
                                if (0x11300 <= code && code <= 0x11301) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mc   [2] GRANTHA SIGN ANUSVARA..GRANTHA SIGN VISARGA
                                if (0x11302 <= code && code <= 0x11303) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                            }
                        }
                    }
                }
            } else {
                if (code < 0x11a97) {
                    if (code < 0x116ab) {
                        if (code < 0x114b9) {
                            if (code < 0x11370) {
                                if (code < 0x11347) {
                                    if (code < 0x1133f) {
                                        if (code < 0x1133e) {
                                            // Mn   [2] COMBINING BINDU BELOW..GRANTHA SIGN NUKTA
                                            if (0x1133b <= code && code <= 0x1133c) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc       GRANTHA VOWEL SIGN AA
                                            if (0x1133e === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    } else {
                                        if (code < 0x11340) {
                                            // Mc       GRANTHA VOWEL SIGN I
                                            if (0x1133f === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else if (code < 0x11341) {
                                            // Mn       GRANTHA VOWEL SIGN II
                                            if (0x11340 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [4] GRANTHA VOWEL SIGN U..GRANTHA VOWEL SIGN VOCALIC RR
                                            if (0x11341 <= code && code <= 0x11344) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    }
                                } else if (code < 0x11357) {
                                    if (code < 0x1134b) {
                                        // Mc   [2] GRANTHA VOWEL SIGN EE..GRANTHA VOWEL SIGN AI
                                        if (0x11347 <= code && code <= 0x11348) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mc   [3] GRANTHA VOWEL SIGN OO..GRANTHA SIGN VIRAMA
                                        if (0x1134b <= code && code <= 0x1134d) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0x11362) {
                                        // Mc       GRANTHA AU LENGTH MARK
                                        if (0x11357 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x11366) {
                                        // Mc   [2] GRANTHA VOWEL SIGN VOCALIC L..GRANTHA VOWEL SIGN VOCALIC LL
                                        if (0x11362 <= code && code <= 0x11363) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [7] COMBINING GRANTHA DIGIT ZERO..COMBINING GRANTHA DIGIT SIX
                                        if (0x11366 <= code && code <= 0x1136c) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0x11445) {
                                    if (code < 0x11438) {
                                        if (code < 0x11435) {
                                            // Mn   [5] COMBINING GRANTHA LETTER A..COMBINING GRANTHA LETTER PA
                                            if (0x11370 <= code && code <= 0x11374) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else {
                                            // Mc   [3] NEWA VOWEL SIGN AA..NEWA VOWEL SIGN II
                                            if (0x11435 <= code && code <= 0x11437) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        }
                                    } else {
                                        if (code < 0x11440) {
                                            // Mn   [8] NEWA VOWEL SIGN U..NEWA VOWEL SIGN AI
                                            if (0x11438 <= code && code <= 0x1143f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x11442) {
                                            // Mc   [2] NEWA VOWEL SIGN O..NEWA VOWEL SIGN AU
                                            if (0x11440 <= code && code <= 0x11441) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [3] NEWA SIGN VIRAMA..NEWA SIGN ANUSVARA
                                            if (0x11442 <= code && code <= 0x11444) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0x114b0) {
                                    if (code < 0x11446) {
                                        // Mc       NEWA SIGN VISARGA
                                        if (0x11445 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn       NEWA SIGN NUKTA
                                        if (0x11446 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        // Mn       NEWA SANDHI MARK
                                        if (0x1145e === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x114b1) {
                                        // Mc       TIRHUTA VOWEL SIGN AA
                                        if (0x114b0 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x114b3) {
                                        // Mc   [2] TIRHUTA VOWEL SIGN I..TIRHUTA VOWEL SIGN II
                                        if (0x114b1 <= code && code <= 0x114b2) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [6] TIRHUTA VOWEL SIGN U..TIRHUTA VOWEL SIGN VOCALIC LL
                                        if (0x114b3 <= code && code <= 0x114b8) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            }
                        } else if (code < 0x115b8) {
                            if (code < 0x114bf) {
                                if (code < 0x114bb) {
                                    // Mc       TIRHUTA VOWEL SIGN E
                                    if (0x114b9 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       TIRHUTA VOWEL SIGN SHORT E
                                    if (0x114ba === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x114bd) {
                                    // Mc   [2] TIRHUTA VOWEL SIGN AI..TIRHUTA VOWEL SIGN O
                                    if (0x114bb <= code && code <= 0x114bc) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mc       TIRHUTA VOWEL SIGN SHORT O
                                    if (0x114bd === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    // Mc       TIRHUTA VOWEL SIGN AU
                                    if (0x114be === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else if (code < 0x115af) {
                                if (code < 0x114c1) {
                                    // Mn   [2] TIRHUTA SIGN CANDRABINDU..TIRHUTA SIGN ANUSVARA
                                    if (0x114bf <= code && code <= 0x114c0) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x114c2) {
                                    // Mc       TIRHUTA SIGN VISARGA
                                    if (0x114c1 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn   [2] TIRHUTA SIGN VIRAMA..TIRHUTA SIGN NUKTA
                                    if (0x114c2 <= code && code <= 0x114c3) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x115b0) {
                                    // Mc       SIDDHAM VOWEL SIGN AA
                                    if (0x115af === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x115b2) {
                                    // Mc   [2] SIDDHAM VOWEL SIGN I..SIDDHAM VOWEL SIGN II
                                    if (0x115b0 <= code && code <= 0x115b1) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn   [4] SIDDHAM VOWEL SIGN U..SIDDHAM VOWEL SIGN VOCALIC RR
                                    if (0x115b2 <= code && code <= 0x115b5) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0x11630) {
                                if (code < 0x115be) {
                                    if (code < 0x115bc) {
                                        // Mc   [4] SIDDHAM VOWEL SIGN E..SIDDHAM VOWEL SIGN AU
                                        if (0x115b8 <= code && code <= 0x115bb) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] SIDDHAM SIGN CANDRABINDU..SIDDHAM SIGN ANUSVARA
                                        if (0x115bc <= code && code <= 0x115bd) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x115bf) {
                                        // Mc       SIDDHAM SIGN VISARGA
                                        if (0x115be === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x115dc) {
                                        // Mn   [2] SIDDHAM SIGN VIRAMA..SIDDHAM SIGN NUKTA
                                        if (0x115bf <= code && code <= 0x115c0) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] SIDDHAM VOWEL SIGN ALTERNATE U..SIDDHAM VOWEL SIGN ALTERNATE UU
                                        if (0x115dc <= code && code <= 0x115dd) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x1163d) {
                                if (code < 0x11633) {
                                    // Mc   [3] MODI VOWEL SIGN AA..MODI VOWEL SIGN II
                                    if (0x11630 <= code && code <= 0x11632) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0x1163b) {
                                    // Mn   [8] MODI VOWEL SIGN U..MODI VOWEL SIGN AI
                                    if (0x11633 <= code && code <= 0x1163a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [2] MODI VOWEL SIGN O..MODI VOWEL SIGN AU
                                    if (0x1163b <= code && code <= 0x1163c) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0x1163e) {
                                    // Mn       MODI SIGN ANUSVARA
                                    if (0x1163d === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1163f) {
                                    // Mc       MODI SIGN VISARGA
                                    if (0x1163e === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn   [2] MODI SIGN VIRAMA..MODI SIGN ARDHACANDRA
                                    if (0x1163f <= code && code <= 0x11640) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    } else {
                        if (code < 0x1193f) {
                            if (code < 0x11727) {
                                if (code < 0x116b6) {
                                    if (code < 0x116ad) {
                                        // Mn       TAKRI SIGN ANUSVARA
                                        if (0x116ab === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        // Mc       TAKRI SIGN VISARGA
                                        if (0x116ac === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        if (code < 0x116ae) {
                                            // Mn       TAKRI VOWEL SIGN AA
                                            if (0x116ad === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        } else if (code < 0x116b0) {
                                            // Mc   [2] TAKRI VOWEL SIGN I..TAKRI VOWEL SIGN II
                                            if (0x116ae <= code && code <= 0x116af) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                        } else {
                                            // Mn   [6] TAKRI VOWEL SIGN U..TAKRI VOWEL SIGN AU
                                            if (0x116b0 <= code && code <= 0x116b5) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                        }
                                    }
                                } else if (code < 0x1171d) {
                                    // Mc       TAKRI SIGN VIRAMA
                                    if (0x116b6 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       TAKRI SIGN NUKTA
                                    if (0x116b7 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    if (code < 0x11722) {
                                        // Mn   [3] AHOM CONSONANT SIGN MEDIAL LA..AHOM CONSONANT SIGN MEDIAL LIGATING RA
                                        if (0x1171d <= code && code <= 0x1171f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x11726) {
                                        // Mn   [4] AHOM VOWEL SIGN I..AHOM VOWEL SIGN UU
                                        if (0x11722 <= code && code <= 0x11725) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc       AHOM VOWEL SIGN E
                                        if (0x11726 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                }
                            } else if (code < 0x11930) {
                                if (code < 0x1182f) {
                                    if (code < 0x1182c) {
                                        // Mn   [5] AHOM VOWEL SIGN AW..AHOM SIGN KILLER
                                        if (0x11727 <= code && code <= 0x1172b) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc   [3] DOGRA VOWEL SIGN AA..DOGRA VOWEL SIGN II
                                        if (0x1182c <= code && code <= 0x1182e) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0x11838) {
                                        // Mn   [9] DOGRA VOWEL SIGN U..DOGRA SIGN ANUSVARA
                                        if (0x1182f <= code && code <= 0x11837) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x11839) {
                                        // Mc       DOGRA SIGN VISARGA
                                        if (0x11838 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] DOGRA SIGN VIRAMA..DOGRA SIGN NUKTA
                                        if (0x11839 <= code && code <= 0x1183a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0x1193b) {
                                    if (code < 0x11931) {
                                        // Mc       DIVES AKURU VOWEL SIGN AA
                                        if (0x11930 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x11937) {
                                        // Mc   [5] DIVES AKURU VOWEL SIGN I..DIVES AKURU VOWEL SIGN E
                                        if (0x11931 <= code && code <= 0x11935) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mc   [2] DIVES AKURU VOWEL SIGN AI..DIVES AKURU VOWEL SIGN O
                                        if (0x11937 <= code && code <= 0x11938) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else if (code < 0x1193d) {
                                    // Mn   [2] DIVES AKURU SIGN ANUSVARA..DIVES AKURU SIGN CANDRABINDU
                                    if (0x1193b <= code && code <= 0x1193c) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc       DIVES AKURU SIGN HALANTA
                                    if (0x1193d === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       DIVES AKURU VIRAMA
                                    if (0x1193e === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0x11a01) {
                            if (code < 0x119d1) {
                                if (code < 0x11941) {
                                    // Lo       DIVES AKURU PREFIXED NASAL SIGN
                                    if (0x1193f === code) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                    // Mc       DIVES AKURU MEDIAL YA
                                    if (0x11940 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else if (code < 0x11942) {
                                    // Lo       DIVES AKURU INITIAL RA
                                    if (0x11941 === code) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                } else {
                                    // Mc       DIVES AKURU MEDIAL RA
                                    if (0x11942 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    // Mn       DIVES AKURU SIGN NUKTA
                                    if (0x11943 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x119dc) {
                                    if (code < 0x119d4) {
                                        // Mc   [3] NANDINAGARI VOWEL SIGN AA..NANDINAGARI VOWEL SIGN II
                                        if (0x119d1 <= code && code <= 0x119d3) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x119da) {
                                        // Mn   [4] NANDINAGARI VOWEL SIGN U..NANDINAGARI VOWEL SIGN VOCALIC RR
                                        if (0x119d4 <= code && code <= 0x119d7) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [2] NANDINAGARI VOWEL SIGN E..NANDINAGARI VOWEL SIGN AI
                                        if (0x119da <= code && code <= 0x119db) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0x119e0) {
                                    // Mc   [4] NANDINAGARI VOWEL SIGN O..NANDINAGARI SIGN VISARGA
                                    if (0x119dc <= code && code <= 0x119df) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn       NANDINAGARI SIGN VIRAMA
                                    if (0x119e0 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    // Mc       NANDINAGARI VOWEL SIGN PRISHTHAMATRA E
                                    if (0x119e4 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            }
                        } else {
                            if (code < 0x11a47) {
                                if (code < 0x11a39) {
                                    if (code < 0x11a33) {
                                        // Mn  [10] ZANABAZAR SQUARE VOWEL SIGN I..ZANABAZAR SQUARE VOWEL LENGTH MARK
                                        if (0x11a01 <= code && code <= 0x11a0a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [6] ZANABAZAR SQUARE FINAL CONSONANT MARK..ZANABAZAR SQUARE SIGN ANUSVARA
                                        if (0x11a33 <= code && code <= 0x11a38) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x11a3a) {
                                        // Mc       ZANABAZAR SQUARE SIGN VISARGA
                                        if (0x11a39 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x11a3b) {
                                        // Lo       ZANABAZAR SQUARE CLUSTER-INITIAL LETTER RA
                                        if (0x11a3a === code) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                    } else {
                                        // Mn   [4] ZANABAZAR SQUARE CLUSTER-FINAL LETTER YA..ZANABAZAR SQUARE CLUSTER-FINAL LETTER VA
                                        if (0x11a3b <= code && code <= 0x11a3e) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x11a59) {
                                if (code < 0x11a51) {
                                    // Mn       ZANABAZAR SQUARE SUBJOINER
                                    if (0x11a47 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x11a57) {
                                    // Mn   [6] SOYOMBO VOWEL SIGN I..SOYOMBO VOWEL SIGN OE
                                    if (0x11a51 <= code && code <= 0x11a56) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [2] SOYOMBO VOWEL SIGN AI..SOYOMBO VOWEL SIGN AU
                                    if (0x11a57 <= code && code <= 0x11a58) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else {
                                if (code < 0x11a84) {
                                    // Mn   [3] SOYOMBO VOWEL SIGN VOCALIC R..SOYOMBO VOWEL LENGTH MARK
                                    if (0x11a59 <= code && code <= 0x11a5b) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x11a8a) {
                                    // Lo   [6] SOYOMBO SIGN JIHVAMULIYA..SOYOMBO CLUSTER-INITIAL LETTER SA
                                    if (0x11a84 <= code && code <= 0x11a89) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                } else {
                                    // Mn  [13] SOYOMBO FINAL CONSONANT SIGN G..SOYOMBO SIGN ANUSVARA
                                    if (0x11a8a <= code && code <= 0x11a96) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    }
                } else if (code < 0x16f51) {
                    if (code < 0x11d90) {
                        if (code < 0x11cb1) {
                            if (code < 0x11c3e) {
                                if (code < 0x11c2f) {
                                    if (code < 0x11a98) {
                                        // Mc       SOYOMBO SIGN VISARGA
                                        if (0x11a97 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] SOYOMBO GEMINATION MARK..SOYOMBO SUBJOINER
                                        if (0x11a98 <= code && code <= 0x11a99) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x11c30) {
                                        // Mc       BHAIKSUKI VOWEL SIGN AA
                                        if (0x11c2f === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x11c38) {
                                        // Mn   [7] BHAIKSUKI VOWEL SIGN I..BHAIKSUKI VOWEL SIGN VOCALIC L
                                        if (0x11c30 <= code && code <= 0x11c36) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [6] BHAIKSUKI VOWEL SIGN E..BHAIKSUKI SIGN ANUSVARA
                                        if (0x11c38 <= code && code <= 0x11c3d) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x11c92) {
                                // Mc       BHAIKSUKI SIGN VISARGA
                                if (0x11c3e === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                // Mn       BHAIKSUKI SIGN VIRAMA
                                if (0x11c3f === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                if (code < 0x11ca9) {
                                    // Mn  [22] MARCHEN SUBJOINED LETTER KA..MARCHEN SUBJOINED LETTER ZA
                                    if (0x11c92 <= code && code <= 0x11ca7) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x11caa) {
                                    // Mc       MARCHEN SUBJOINED LETTER YA
                                    if (0x11ca9 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                } else {
                                    // Mn   [7] MARCHEN SUBJOINED LETTER RA..MARCHEN VOWEL SIGN AA
                                    if (0x11caa <= code && code <= 0x11cb0) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else {
                            if (code < 0x11d3a) {
                                if (code < 0x11cb4) {
                                    if (code < 0x11cb2) {
                                        // Mc       MARCHEN VOWEL SIGN I
                                        if (0x11cb1 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] MARCHEN VOWEL SIGN U..MARCHEN VOWEL SIGN E
                                        if (0x11cb2 <= code && code <= 0x11cb3) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x11cb5) {
                                        // Mc       MARCHEN VOWEL SIGN O
                                        if (0x11cb4 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else if (code < 0x11d31) {
                                        // Mn   [2] MARCHEN SIGN ANUSVARA..MARCHEN SIGN CANDRABINDU
                                        if (0x11cb5 <= code && code <= 0x11cb6) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mn   [6] MASARAM GONDI VOWEL SIGN AA..MASARAM GONDI VOWEL SIGN VOCALIC R
                                        if (0x11d31 <= code && code <= 0x11d36) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x11d46) {
                                if (code < 0x11d3c) {
                                    // Mn       MASARAM GONDI VOWEL SIGN E
                                    if (0x11d3a === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x11d3f) {
                                    // Mn   [2] MASARAM GONDI VOWEL SIGN AI..MASARAM GONDI VOWEL SIGN O
                                    if (0x11d3c <= code && code <= 0x11d3d) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [7] MASARAM GONDI VOWEL SIGN AU..MASARAM GONDI VIRAMA
                                    if (0x11d3f <= code && code <= 0x11d45) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x11d47) {
                                    // Lo       MASARAM GONDI REPHA
                                    if (0x11d46 === code) return boundaries_1.CLUSTER_BREAK.PREPEND;
                                } else if (code < 0x11d8a) {
                                    // Mn       MASARAM GONDI RA-KARA
                                    if (0x11d47 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [5] GUNJALA GONDI VOWEL SIGN AA..GUNJALA GONDI VOWEL SIGN UU
                                    if (0x11d8a <= code && code <= 0x11d8e) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            }
                        }
                    } else if (code < 0x11f36) {
                        if (code < 0x11ef3) {
                            if (code < 0x11d95) {
                                if (code < 0x11d93) {
                                    // Mn   [2] GUNJALA GONDI VOWEL SIGN EE..GUNJALA GONDI VOWEL SIGN AI
                                    if (0x11d90 <= code && code <= 0x11d91) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [2] GUNJALA GONDI VOWEL SIGN OO..GUNJALA GONDI VOWEL SIGN AU
                                    if (0x11d93 <= code && code <= 0x11d94) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else if (code < 0x11d96) {
                                // Mn       GUNJALA GONDI SIGN ANUSVARA
                                if (0x11d95 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mc       GUNJALA GONDI SIGN VISARGA
                                if (0x11d96 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                // Mn       GUNJALA GONDI VIRAMA
                                if (0x11d97 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (code < 0x11f02) {
                            if (code < 0x11ef5) {
                                // Mn   [2] MAKASAR VOWEL SIGN I..MAKASAR VOWEL SIGN U
                                if (0x11ef3 <= code && code <= 0x11ef4) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x11f00) {
                                // Mc   [2] MAKASAR VOWEL SIGN E..MAKASAR VOWEL SIGN O
                                if (0x11ef5 <= code && code <= 0x11ef6) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                            } else {
                                // Mn   [2] KAWI SIGN CANDRABINDU..KAWI SIGN ANUSVARA
                                if (0x11f00 <= code && code <= 0x11f01) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        } else {
                            if (code < 0x11f03) {
                                // Lo       KAWI SIGN REPHA
                                if (0x11f02 === code) return boundaries_1.CLUSTER_BREAK.PREPEND;
                            } else if (code < 0x11f34) {
                                // Mc       KAWI SIGN VISARGA
                                if (0x11f03 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                            } else {
                                // Mc   [2] KAWI VOWEL SIGN AA..KAWI VOWEL SIGN ALTERNATE AA
                                if (0x11f34 <= code && code <= 0x11f35) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                            }
                        }
                    } else {
                        if (code < 0x13430) {
                            if (code < 0x11f40) {
                                if (code < 0x11f3e) {
                                    // Mn   [5] KAWI VOWEL SIGN I..KAWI VOWEL SIGN VOCALIC R
                                    if (0x11f36 <= code && code <= 0x11f3a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc   [2] KAWI VOWEL SIGN E..KAWI VOWEL SIGN AI
                                    if (0x11f3e <= code && code <= 0x11f3f) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            } else if (code < 0x11f41) {
                                // Mn       KAWI VOWEL SIGN EU
                                if (0x11f40 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mc       KAWI SIGN KILLER
                                if (0x11f41 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                // Mn       KAWI CONJOINER
                                if (0x11f42 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        } else if (code < 0x16af0) {
                            if (code < 0x13440) {
                                // Cf  [16] EGYPTIAN HIEROGLYPH VERTICAL JOINER..EGYPTIAN HIEROGLYPH END WALLED ENCLOSURE
                                if (0x13430 <= code && code <= 0x1343f) return boundaries_1.CLUSTER_BREAK.CONTROL;
                            } else if (code < 0x13447) {
                                // Mn       EGYPTIAN HIEROGLYPH MIRROR HORIZONTALLY
                                if (0x13440 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn  [15] EGYPTIAN HIEROGLYPH MODIFIER DAMAGED AT TOP START..EGYPTIAN HIEROGLYPH MODIFIER DAMAGED
                                if (0x13447 <= code && code <= 0x13455) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        } else {
                            if (code < 0x16b30) {
                                // Mn   [5] BASSA VAH COMBINING HIGH TONE..BASSA VAH COMBINING HIGH-LOW TONE
                                if (0x16af0 <= code && code <= 0x16af4) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x16f4f) {
                                // Mn   [7] PAHAWH HMONG MARK CIM TUB..PAHAWH HMONG MARK CIM TAUM
                                if (0x16b30 <= code && code <= 0x16b36) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn       MIAO SIGN CONSONANT MODIFIER BAR
                                if (0x16f4f === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        }
                    }
                } else {
                    if (code < 0x1da84) {
                        if (code < 0x1d167) {
                            if (code < 0x1bca0) {
                                if (code < 0x16fe4) {
                                    if (code < 0x16f8f) {
                                        // Mc  [55] MIAO SIGN ASPIRATION..MIAO VOWEL SIGN UI
                                        if (0x16f51 <= code && code <= 0x16f87) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [4] MIAO TONE RIGHT..MIAO TONE BELOW
                                        if (0x16f8f <= code && code <= 0x16f92) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else {
                                    if (code < 0x16ff0) {
                                        // Mn       KHITAN SMALL SCRIPT FILLER
                                        if (0x16fe4 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x1bc9d) {
                                        // Mc   [2] VIETNAMESE ALTERNATE READING MARK CA..VIETNAMESE ALTERNATE READING MARK NHAY
                                        if (0x16ff0 <= code && code <= 0x16ff1) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    } else {
                                        // Mn   [2] DUPLOYAN THICK LETTER SELECTOR..DUPLOYAN DOUBLE MARK
                                        if (0x1bc9d <= code && code <= 0x1bc9e) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else {
                                if (code < 0x1cf30) {
                                    if (code < 0x1cf00) {
                                        // Cf   [4] SHORTHAND FORMAT LETTER OVERLAP..SHORTHAND FORMAT UP STEP
                                        if (0x1bca0 <= code && code <= 0x1bca3) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                    } else {
                                        // Mn  [46] ZNAMENNY COMBINING MARK GORAZDO NIZKO S KRYZHEM ON LEFT..ZNAMENNY COMBINING MARK KRYZH ON LEFT
                                        if (0x1cf00 <= code && code <= 0x1cf2d) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                } else if (code < 0x1d165) {
                                    // Mn  [23] ZNAMENNY COMBINING TONAL RANGE MARK MRACHNO..ZNAMENNY PRIZNAK MODIFIER ROG
                                    if (0x1cf30 <= code && code <= 0x1cf46) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mc       MUSICAL SYMBOL COMBINING STEM
                                    if (0x1d165 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    // Mc       MUSICAL SYMBOL COMBINING SPRECHGESANG STEM
                                    if (0x1d166 === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                }
                            }
                        } else {
                            if (code < 0x1d185) {
                                if (code < 0x1d16e) {
                                    if (code < 0x1d16d) {
                                        // Mn   [3] MUSICAL SYMBOL COMBINING TREMOLO-1..MUSICAL SYMBOL COMBINING TREMOLO-3
                                        if (0x1d167 <= code && code <= 0x1d169) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else {
                                        // Mc       MUSICAL SYMBOL COMBINING AUGMENTATION DOT
                                        if (0x1d16d === code) return boundaries_1.CLUSTER_BREAK.SPACINGMARK;
                                    }
                                } else {
                                    if (code < 0x1d173) {
                                        // Mc   [5] MUSICAL SYMBOL COMBINING FLAG-1..MUSICAL SYMBOL COMBINING FLAG-5
                                        if (0x1d16e <= code && code <= 0x1d172) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    } else if (code < 0x1d17b) {
                                        // Cf   [8] MUSICAL SYMBOL BEGIN BEAM..MUSICAL SYMBOL END PHRASE
                                        if (0x1d173 <= code && code <= 0x1d17a) return boundaries_1.CLUSTER_BREAK.CONTROL;
                                    } else {
                                        // Mn   [8] MUSICAL SYMBOL COMBINING ACCENT..MUSICAL SYMBOL COMBINING LOURE
                                        if (0x1d17b <= code && code <= 0x1d182) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                    }
                                }
                            } else if (code < 0x1da00) {
                                if (code < 0x1d1aa) {
                                    // Mn   [7] MUSICAL SYMBOL COMBINING DOIT..MUSICAL SYMBOL COMBINING TRIPLE TONGUE
                                    if (0x1d185 <= code && code <= 0x1d18b) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1d242) {
                                    // Mn   [4] MUSICAL SYMBOL COMBINING DOWN BOW..MUSICAL SYMBOL COMBINING SNAP PIZZICATO
                                    if (0x1d1aa <= code && code <= 0x1d1ad) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [3] COMBINING GREEK MUSICAL TRISEME..COMBINING GREEK MUSICAL PENTASEME
                                    if (0x1d242 <= code && code <= 0x1d244) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x1da3b) {
                                    // Mn  [55] SIGNWRITING HEAD RIM..SIGNWRITING AIR SUCKING IN
                                    if (0x1da00 <= code && code <= 0x1da36) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1da75) {
                                    // Mn  [50] SIGNWRITING MOUTH CLOSED NEUTRAL..SIGNWRITING EXCITEMENT
                                    if (0x1da3b <= code && code <= 0x1da6c) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn       SIGNWRITING UPPER BODY TILTING FROM HIP JOINTS
                                    if (0x1da75 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        }
                    } else if (code < 0x1e2ec) {
                        if (code < 0x1e01b) {
                            if (code < 0x1daa1) {
                                if (code < 0x1da9b) {
                                    // Mn       SIGNWRITING LOCATION HEAD NECK
                                    if (0x1da84 === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [5] SIGNWRITING FILL MODIFIER-2..SIGNWRITING FILL MODIFIER-6
                                    if (0x1da9b <= code && code <= 0x1da9f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x1e000) {
                                    // Mn  [15] SIGNWRITING ROTATION MODIFIER-2..SIGNWRITING ROTATION MODIFIER-16
                                    if (0x1daa1 <= code && code <= 0x1daaf) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1e008) {
                                    // Mn   [7] COMBINING GLAGOLITIC LETTER AZU..COMBINING GLAGOLITIC LETTER ZHIVETE
                                    if (0x1e000 <= code && code <= 0x1e006) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn  [17] COMBINING GLAGOLITIC LETTER ZEMLJA..COMBINING GLAGOLITIC LETTER HERU
                                    if (0x1e008 <= code && code <= 0x1e018) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            }
                        } else if (code < 0x1e08f) {
                            if (code < 0x1e023) {
                                // Mn   [7] COMBINING GLAGOLITIC LETTER SHTA..COMBINING GLAGOLITIC LETTER YATI
                                if (0x1e01b <= code && code <= 0x1e021) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x1e026) {
                                // Mn   [2] COMBINING GLAGOLITIC LETTER YU..COMBINING GLAGOLITIC LETTER SMALL YUS
                                if (0x1e023 <= code && code <= 0x1e024) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn   [5] COMBINING GLAGOLITIC LETTER YO..COMBINING GLAGOLITIC LETTER FITA
                                if (0x1e026 <= code && code <= 0x1e02a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        } else {
                            if (code < 0x1e130) {
                                // Mn       COMBINING CYRILLIC SMALL LETTER BYELORUSSIAN-UKRAINIAN I
                                if (0x1e08f === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0x1e2ae) {
                                // Mn   [7] NYIAKENG PUACHUE HMONG TONE-B..NYIAKENG PUACHUE HMONG TONE-D
                                if (0x1e130 <= code && code <= 0x1e136) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Mn       TOTO SIGN RISING TONE
                                if (0x1e2ae === code) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        }
                    } else {
                        if (code < 0x1f3fb) {
                            if (code < 0x1e8d0) {
                                if (code < 0x1e4ec) {
                                    // Mn   [4] WANCHO TONE TUP..WANCHO TONE KOINI
                                    if (0x1e2ec <= code && code <= 0x1e2ef) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // Mn   [4] NAG MUNDARI SIGN MUHOR..NAG MUNDARI SIGN SUTUH
                                    if (0x1e4ec <= code && code <= 0x1e4ef) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                }
                            } else {
                                if (code < 0x1e944) {
                                    // Mn   [7] MENDE KIKAKUI COMBINING NUMBER TEENS..MENDE KIKAKUI COMBINING NUMBER MILLIONS
                                    if (0x1e8d0 <= code && code <= 0x1e8d6) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else if (code < 0x1f1e6) {
                                    // Mn   [7] ADLAM ALIF LENGTHENER..ADLAM NUKTA
                                    if (0x1e944 <= code && code <= 0x1e94a) return boundaries_1.CLUSTER_BREAK.EXTEND;
                                } else {
                                    // So  [26] REGIONAL INDICATOR SYMBOL LETTER A..REGIONAL INDICATOR SYMBOL LETTER Z
                                    if (0x1f1e6 <= code && code <= 0x1f1ff) return boundaries_1.CLUSTER_BREAK.REGIONAL_INDICATOR;
                                }
                            }
                        } else if (code < 0xe0080) {
                            if (code < 0xe0000) {
                                // Sk   [5] EMOJI MODIFIER FITZPATRICK TYPE-1-2..EMOJI MODIFIER FITZPATRICK TYPE-6
                                if (0x1f3fb <= code && code <= 0x1f3ff) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else if (code < 0xe0020) {
                                // Cn       <reserved-E0000>
                                // Cf       LANGUAGE TAG
                                // Cn  [30] <reserved-E0002>..<reserved-E001F>
                                if (0xe0000 <= code && code <= 0xe001f) return boundaries_1.CLUSTER_BREAK.CONTROL;
                            } else {
                                // Cf  [96] TAG SPACE..CANCEL TAG
                                if (0xe0020 <= code && code <= 0xe007f) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            }
                        } else {
                            if (code < 0xe0100) {
                                // Cn [128] <reserved-E0080>..<reserved-E00FF>
                                if (0xe0080 <= code && code <= 0xe00ff) return boundaries_1.CLUSTER_BREAK.CONTROL;
                            } else if (code < 0xe01f0) {
                                // Mn [240] VARIATION SELECTOR-17..VARIATION SELECTOR-256
                                if (0xe0100 <= code && code <= 0xe01ef) return boundaries_1.CLUSTER_BREAK.EXTEND;
                            } else {
                                // Cn [3600] <reserved-E01F0>..<reserved-E0FFF>
                                if (0xe01f0 <= code && code <= 0xe0fff) return boundaries_1.CLUSTER_BREAK.CONTROL;
                            }
                        }
                    }
                }
            }
        }
        // unlisted code points are treated as a break property of "Other"
        return boundaries_1.CLUSTER_BREAK.OTHER;
    }
    /**
     * Given a Unicode code point, returns if symbol is an extended pictographic or some other break
     * @param code {number} Unicode code point
     * @returns {number}
     */ static getEmojiProperty(code) {
        // emoji property taken from:
        // https://www.unicode.org/Public/UCD/latest/ucd/emoji/emoji-data.txt
        // and generated by
        // node ./scripts/generate-emoji-extended-pictographic.js
        if (code < 0x27b0) {
            if (code < 0x2600) {
                if (code < 0x2328) {
                    if (code < 0x2122) {
                        if (code < 0x203c) {
                            // E0.6   [1] (©️)       copyright
                            if (0xa9 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            // E0.6   [1] (®️)       registered
                            if (0xae === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [1] (‼️)       double exclamation mark
                            if (0x203c === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            // E0.6   [1] (⁉️)       exclamation question mark
                            if (0x2049 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    } else if (code < 0x2194) {
                        // E0.6   [1] (™️)       trade mark
                        if (0x2122 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        // E0.6   [1] (ℹ️)       information
                        if (0x2139 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else {
                        if (code < 0x21a9) {
                            // E0.6   [6] (↔️..↙️)    left-right arrow..down-left arrow
                            if (0x2194 <= code && code <= 0x2199) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x231a) {
                            // E0.6   [2] (↩️..↪️)    right arrow curving left..left arrow curving right
                            if (0x21a9 <= code && code <= 0x21aa) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [2] (⌚..⌛)    watch..hourglass done
                            if (0x231a <= code && code <= 0x231b) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                } else {
                    if (code < 0x24c2) {
                        if (code < 0x23cf) {
                            // E1.0   [1] (⌨️)       keyboard
                            if (0x2328 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            // E0.0   [1] (⎈)       HELM SYMBOL
                            if (0x2388 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            if (code < 0x23e9) {
                                // E1.0   [1] (⏏️)       eject button
                                if (0x23cf === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            } else if (code < 0x23f8) {
                                // E0.6   [4] (⏩..⏬)    fast-forward button..fast down button
                                // E0.7   [2] (⏭️..⏮️)    next track button..last track button
                                // E1.0   [1] (⏯️)       play or pause button
                                // E0.6   [1] (⏰)       alarm clock
                                // E1.0   [2] (⏱️..⏲️)    stopwatch..timer clock
                                // E0.6   [1] (⏳)       hourglass not done
                                if (0x23e9 <= code && code <= 0x23f3) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            } else {
                                // E0.7   [3] (⏸️..⏺️)    pause button..record button
                                if (0x23f8 <= code && code <= 0x23fa) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            }
                        }
                    } else if (code < 0x25b6) {
                        if (code < 0x25aa) {
                            // E0.6   [1] (Ⓜ️)       circled M
                            if (0x24c2 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [2] (▪️..▫️)    black small square..white small square
                            if (0x25aa <= code && code <= 0x25ab) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x25c0) {
                            // E0.6   [1] (▶️)       play button
                            if (0x25b6 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x25fb) {
                            // E0.6   [1] (◀️)       reverse button
                            if (0x25c0 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [4] (◻️..◾)    white medium square..black medium-small square
                            if (0x25fb <= code && code <= 0x25fe) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                }
            } else if (code < 0x2733) {
                if (code < 0x2714) {
                    if (code < 0x2614) {
                        if (code < 0x2607) {
                            // E0.6   [2] (☀️..☁️)    sun..cloud
                            // E0.7   [2] (☂️..☃️)    umbrella..snowman
                            // E1.0   [1] (☄️)       comet
                            // E0.0   [1] (★)       BLACK STAR
                            if (0x2600 <= code && code <= 0x2605) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.0   [7] (☇..☍)    LIGHTNING..OPPOSITION
                            // E0.6   [1] (☎️)       telephone
                            // E0.0   [2] (☏..☐)    WHITE TELEPHONE..BALLOT BOX
                            // E0.6   [1] (☑️)       check box with check
                            // E0.0   [1] (☒)       BALLOT BOX WITH X
                            if (0x2607 <= code && code <= 0x2612) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x2690) {
                            // E0.6   [2] (☔..☕)    umbrella with rain drops..hot beverage
                            // E0.0   [2] (☖..☗)    WHITE SHOGI PIECE..BLACK SHOGI PIECE
                            // E1.0   [1] (☘️)       shamrock
                            // E0.0   [4] (☙..☜)    REVERSED ROTATED FLORAL HEART BULLET..WHITE LEFT POINTING INDEX
                            // E0.6   [1] (☝️)       index pointing up
                            // E0.0   [2] (☞..☟)    WHITE RIGHT POINTING INDEX..WHITE DOWN POINTING INDEX
                            // E1.0   [1] (☠️)       skull and crossbones
                            // E0.0   [1] (☡)       CAUTION SIGN
                            // E1.0   [2] (☢️..☣️)    radioactive..biohazard
                            // E0.0   [2] (☤..☥)    CADUCEUS..ANKH
                            // E1.0   [1] (☦️)       orthodox cross
                            // E0.0   [3] (☧..☩)    CHI RHO..CROSS OF JERUSALEM
                            // E0.7   [1] (☪️)       star and crescent
                            // E0.0   [3] (☫..☭)    FARSI SYMBOL..HAMMER AND SICKLE
                            // E1.0   [1] (☮️)       peace symbol
                            // E0.7   [1] (☯️)       yin yang
                            // E0.0   [8] (☰..☷)    TRIGRAM FOR HEAVEN..TRIGRAM FOR EARTH
                            // E0.7   [2] (☸️..☹️)    wheel of dharma..frowning face
                            // E0.6   [1] (☺️)       smiling face
                            // E0.0   [5] (☻..☿)    BLACK SMILING FACE..MERCURY
                            // E4.0   [1] (♀️)       female sign
                            // E0.0   [1] (♁)       EARTH
                            // E4.0   [1] (♂️)       male sign
                            // E0.0   [5] (♃..♇)    JUPITER..PLUTO
                            // E0.6  [12] (♈..♓)    Aries..Pisces
                            // E0.0  [11] (♔..♞)    WHITE CHESS KING..BLACK CHESS KNIGHT
                            // E11.0  [1] (♟️)       chess pawn
                            // E0.6   [1] (♠️)       spade suit
                            // E0.0   [2] (♡..♢)    WHITE HEART SUIT..WHITE DIAMOND SUIT
                            // E0.6   [1] (♣️)       club suit
                            // E0.0   [1] (♤)       WHITE SPADE SUIT
                            // E0.6   [2] (♥️..♦️)    heart suit..diamond suit
                            // E0.0   [1] (♧)       WHITE CLUB SUIT
                            // E0.6   [1] (♨️)       hot springs
                            // E0.0  [18] (♩..♺)    QUARTER NOTE..RECYCLING SYMBOL FOR GENERIC MATERIALS
                            // E0.6   [1] (♻️)       recycling symbol
                            // E0.0   [2] (♼..♽)    RECYCLED PAPER SYMBOL..PARTIALLY-RECYCLED PAPER SYMBOL
                            // E11.0  [1] (♾️)       infinity
                            // E0.6   [1] (♿)       wheelchair symbol
                            // E0.0   [6] (⚀..⚅)    DIE FACE-1..DIE FACE-6
                            if (0x2614 <= code && code <= 0x2685) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x2708) {
                            // E0.0   [2] (⚐..⚑)    WHITE FLAG..BLACK FLAG
                            // E1.0   [1] (⚒️)       hammer and pick
                            // E0.6   [1] (⚓)       anchor
                            // E1.0   [1] (⚔️)       crossed swords
                            // E4.0   [1] (⚕️)       medical symbol
                            // E1.0   [2] (⚖️..⚗️)    balance scale..alembic
                            // E0.0   [1] (⚘)       FLOWER
                            // E1.0   [1] (⚙️)       gear
                            // E0.0   [1] (⚚)       STAFF OF HERMES
                            // E1.0   [2] (⚛️..⚜️)    atom symbol..fleur-de-lis
                            // E0.0   [3] (⚝..⚟)    OUTLINED WHITE STAR..THREE LINES CONVERGING LEFT
                            // E0.6   [2] (⚠️..⚡)    warning..high voltage
                            // E0.0   [5] (⚢..⚦)    DOUBLED FEMALE SIGN..MALE WITH STROKE SIGN
                            // E13.0  [1] (⚧️)       transgender symbol
                            // E0.0   [2] (⚨..⚩)    VERTICAL MALE WITH STROKE SIGN..HORIZONTAL MALE WITH STROKE SIGN
                            // E0.6   [2] (⚪..⚫)    white circle..black circle
                            // E0.0   [4] (⚬..⚯)    MEDIUM SMALL WHITE CIRCLE..UNMARRIED PARTNERSHIP SYMBOL
                            // E1.0   [2] (⚰️..⚱️)    coffin..funeral urn
                            // E0.0  [11] (⚲..⚼)    NEUTER..SESQUIQUADRATE
                            // E0.6   [2] (⚽..⚾)    soccer ball..baseball
                            // E0.0   [5] (⚿..⛃)    SQUARED KEY..BLACK DRAUGHTS KING
                            // E0.6   [2] (⛄..⛅)    snowman without snow..sun behind cloud
                            // E0.0   [2] (⛆..⛇)    RAIN..BLACK SNOWMAN
                            // E0.7   [1] (⛈️)       cloud with lightning and rain
                            // E0.0   [5] (⛉..⛍)    TURNED WHITE SHOGI PIECE..DISABLED CAR
                            // E0.6   [1] (⛎)       Ophiuchus
                            // E0.7   [1] (⛏️)       pick
                            // E0.0   [1] (⛐)       CAR SLIDING
                            // E0.7   [1] (⛑️)       rescue worker’s helmet
                            // E0.0   [1] (⛒)       CIRCLED CROSSING LANES
                            // E0.7   [1] (⛓️)       chains
                            // E0.6   [1] (⛔)       no entry
                            // E0.0  [20] (⛕..⛨)    ALTERNATE ONE-WAY LEFT WAY TRAFFIC..BLACK CROSS ON SHIELD
                            // E0.7   [1] (⛩️)       shinto shrine
                            // E0.6   [1] (⛪)       church
                            // E0.0   [5] (⛫..⛯)    CASTLE..MAP SYMBOL FOR LIGHTHOUSE
                            // E0.7   [2] (⛰️..⛱️)    mountain..umbrella on ground
                            // E0.6   [2] (⛲..⛳)    fountain..flag in hole
                            // E0.7   [1] (⛴️)       ferry
                            // E0.6   [1] (⛵)       sailboat
                            // E0.0   [1] (⛶)       SQUARE FOUR CORNERS
                            // E0.7   [3] (⛷️..⛹️)    skier..person bouncing ball
                            // E0.6   [1] (⛺)       tent
                            // E0.0   [2] (⛻..⛼)    JAPANESE BANK SYMBOL..HEADSTONE GRAVEYARD SYMBOL
                            // E0.6   [1] (⛽)       fuel pump
                            // E0.0   [4] (⛾..✁)    CUP ON BLACK SQUARE..UPPER BLADE SCISSORS
                            // E0.6   [1] (✂️)       scissors
                            // E0.0   [2] (✃..✄)    LOWER BLADE SCISSORS..WHITE SCISSORS
                            // E0.6   [1] (✅)       check mark button
                            if (0x2690 <= code && code <= 0x2705) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [5] (✈️..✌️)    airplane..victory hand
                            // E0.7   [1] (✍️)       writing hand
                            // E0.0   [1] (✎)       LOWER RIGHT PENCIL
                            // E0.6   [1] (✏️)       pencil
                            // E0.0   [2] (✐..✑)    UPPER RIGHT PENCIL..WHITE NIB
                            // E0.6   [1] (✒️)       black nib
                            if (0x2708 <= code && code <= 0x2712) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                } else {
                    if (code < 0x271d) {
                        // E0.6   [1] (✔️)       check mark
                        if (0x2714 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        // E0.6   [1] (✖️)       multiply
                        if (0x2716 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else if (code < 0x2721) {
                        // E0.7   [1] (✝️)       latin cross
                        if (0x271d === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.7   [1] (✡️)       star of David
                        if (0x2721 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        // E0.6   [1] (✨)       sparkles
                        if (0x2728 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    }
                }
            } else {
                if (code < 0x2753) {
                    if (code < 0x2747) {
                        if (code < 0x2744) {
                            // E0.6   [2] (✳️..✴️)    eight-spoked asterisk..eight-pointed star
                            if (0x2733 <= code && code <= 0x2734) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [1] (❄️)       snowflake
                            if (0x2744 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    } else if (code < 0x274c) {
                        // E0.6   [1] (❇️)       sparkle
                        if (0x2747 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.6   [1] (❌)       cross mark
                        if (0x274c === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        // E0.6   [1] (❎)       cross mark button
                        if (0x274e === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    }
                } else if (code < 0x2763) {
                    if (code < 0x2757) {
                        // E0.6   [3] (❓..❕)    red question mark..white exclamation mark
                        if (0x2753 <= code && code <= 0x2755) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.6   [1] (❗)       red exclamation mark
                        if (0x2757 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    }
                } else {
                    if (code < 0x2795) {
                        // E1.0   [1] (❣️)       heart exclamation
                        // E0.6   [1] (❤️)       red heart
                        // E0.0   [3] (❥..❧)    ROTATED HEAVY BLACK HEART BULLET..ROTATED FLORAL HEART BULLET
                        if (0x2763 <= code && code <= 0x2767) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else if (code < 0x27a1) {
                        // E0.6   [3] (➕..➗)    plus..divide
                        if (0x2795 <= code && code <= 0x2797) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.6   [1] (➡️)       right arrow
                        if (0x27a1 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    }
                }
            }
        } else {
            if (code < 0x1f201) {
                if (code < 0x3297) {
                    if (code < 0x2b1b) {
                        if (code < 0x2934) {
                            // E0.6   [1] (➰)       curly loop
                            if (0x27b0 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            // E1.0   [1] (➿)       double curly loop
                            if (0x27bf === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x2b05) {
                            // E0.6   [2] (⤴️..⤵️)    right arrow curving up..right arrow curving down
                            if (0x2934 <= code && code <= 0x2935) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [3] (⬅️..⬇️)    left arrow..down arrow
                            if (0x2b05 <= code && code <= 0x2b07) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x2b55) {
                            if (code < 0x2b50) {
                                // E0.6   [2] (⬛..⬜)    black large square..white large square
                                if (0x2b1b <= code && code <= 0x2b1c) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            } else {
                                // E0.6   [1] (⭐)       star
                                if (0x2b50 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            }
                        } else if (code < 0x3030) {
                            // E0.6   [1] (⭕)       hollow red circle
                            if (0x2b55 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [1] (〰️)       wavy dash
                            if (0x3030 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            // E0.6   [1] (〽️)       part alternation mark
                            if (0x303d === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                } else {
                    if (code < 0x1f16c) {
                        if (code < 0x1f000) {
                            // E0.6   [1] (㊗️)       Japanese “congratulations” button
                            if (0x3297 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            // E0.6   [1] (㊙️)       Japanese “secret” button
                            if (0x3299 === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            if (code < 0x1f10d) {
                                // E0.0   [4] (🀀..🀃)    MAHJONG TILE EAST WIND..MAHJONG TILE NORTH WIND
                                // E0.6   [1] (🀄)       mahjong red dragon
                                // E0.0 [202] (🀅..🃎)    MAHJONG TILE GREEN DRAGON..PLAYING CARD KING OF DIAMONDS
                                // E0.6   [1] (🃏)       joker
                                // E0.0  [48] (🃐..🃿)    <reserved-1F0D0>..<reserved-1F0FF>
                                if (0x1f000 <= code && code <= 0x1f0ff) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            } else if (code < 0x1f12f) {
                                // E0.0   [3] (🄍..🄏)    CIRCLED ZERO WITH SLASH..CIRCLED DOLLAR SIGN WITH OVERLAID BACKSLASH
                                if (0x1f10d <= code && code <= 0x1f10f) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            } else {
                                // E0.0   [1] (🄯)       COPYLEFT SYMBOL
                                if (0x1f12f === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                            }
                        }
                    } else if (code < 0x1f18e) {
                        if (code < 0x1f17e) {
                            // E0.0   [4] (🅬..🅯)    RAISED MR SIGN..CIRCLED HUMAN FIGURE
                            // E0.6   [2] (🅰️..🅱️)    A button (blood type)..B button (blood type)
                            if (0x1f16c <= code && code <= 0x1f171) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [2] (🅾️..🅿️)    O button (blood type)..P button
                            if (0x1f17e <= code && code <= 0x1f17f) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x1f191) {
                            // E0.6   [1] (🆎)       AB button (blood type)
                            if (0x1f18e === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x1f1ad) {
                            // E0.6  [10] (🆑..🆚)    CL button..VS button
                            if (0x1f191 <= code && code <= 0x1f19a) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.0  [57] (🆭..🇥)    MASK WORK SYMBOL..<reserved-1F1E5>
                            if (0x1f1ad <= code && code <= 0x1f1e5) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                }
            } else if (code < 0x1f7d5) {
                if (code < 0x1f249) {
                    if (code < 0x1f22f) {
                        if (code < 0x1f21a) {
                            // E0.6   [2] (🈁..🈂️)    Japanese “here” button..Japanese “service charge” button
                            // E0.0  [13] (🈃..🈏)    <reserved-1F203>..<reserved-1F20F>
                            if (0x1f201 <= code && code <= 0x1f20f) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.6   [1] (🈚)       Japanese “free of charge” button
                            if (0x1f21a === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x1f232) {
                            // E0.6   [1] (🈯)       Japanese “reserved” button
                            if (0x1f22f === code) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x1f23c) {
                            // E0.6   [9] (🈲..🈺)    Japanese “prohibited” button..Japanese “open for business” button
                            if (0x1f232 <= code && code <= 0x1f23a) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.0   [4] (🈼..🈿)    <reserved-1F23C>..<reserved-1F23F>
                            if (0x1f23c <= code && code <= 0x1f23f) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                } else if (code < 0x1f546) {
                    if (code < 0x1f400) {
                        // E0.0   [7] (🉉..🉏)    <reserved-1F249>..<reserved-1F24F>
                        // E0.6   [2] (🉐..🉑)    Japanese “bargain” button..Japanese “acceptable” button
                        // E0.0 [174] (🉒..🋿)    <reserved-1F252>..<reserved-1F2FF>
                        // E0.6  [13] (🌀..🌌)    cyclone..milky way
                        // E0.7   [2] (🌍..🌎)    globe showing Europe-Africa..globe showing Americas
                        // E0.6   [1] (🌏)       globe showing Asia-Australia
                        // E1.0   [1] (🌐)       globe with meridians
                        // E0.6   [1] (🌑)       new moon
                        // E1.0   [1] (🌒)       waxing crescent moon
                        // E0.6   [3] (🌓..🌕)    first quarter moon..full moon
                        // E1.0   [3] (🌖..🌘)    waning gibbous moon..waning crescent moon
                        // E0.6   [1] (🌙)       crescent moon
                        // E1.0   [1] (🌚)       new moon face
                        // E0.6   [1] (🌛)       first quarter moon face
                        // E0.7   [1] (🌜)       last quarter moon face
                        // E1.0   [2] (🌝..🌞)    full moon face..sun with face
                        // E0.6   [2] (🌟..🌠)    glowing star..shooting star
                        // E0.7   [1] (🌡️)       thermometer
                        // E0.0   [2] (🌢..🌣)    BLACK DROPLET..WHITE SUN
                        // E0.7   [9] (🌤️..🌬️)    sun behind small cloud..wind face
                        // E1.0   [3] (🌭..🌯)    hot dog..burrito
                        // E0.6   [2] (🌰..🌱)    chestnut..seedling
                        // E1.0   [2] (🌲..🌳)    evergreen tree..deciduous tree
                        // E0.6   [2] (🌴..🌵)    palm tree..cactus
                        // E0.7   [1] (🌶️)       hot pepper
                        // E0.6  [20] (🌷..🍊)    tulip..tangerine
                        // E1.0   [1] (🍋)       lemon
                        // E0.6   [4] (🍌..🍏)    banana..green apple
                        // E1.0   [1] (🍐)       pear
                        // E0.6  [43] (🍑..🍻)    peach..clinking beer mugs
                        // E1.0   [1] (🍼)       baby bottle
                        // E0.7   [1] (🍽️)       fork and knife with plate
                        // E1.0   [2] (🍾..🍿)    bottle with popping cork..popcorn
                        // E0.6  [20] (🎀..🎓)    ribbon..graduation cap
                        // E0.0   [2] (🎔..🎕)    HEART WITH TIP ON THE LEFT..BOUQUET OF FLOWERS
                        // E0.7   [2] (🎖️..🎗️)    military medal..reminder ribbon
                        // E0.0   [1] (🎘)       MUSICAL KEYBOARD WITH JACKS
                        // E0.7   [3] (🎙️..🎛️)    studio microphone..control knobs
                        // E0.0   [2] (🎜..🎝)    BEAMED ASCENDING MUSICAL NOTES..BEAMED DESCENDING MUSICAL NOTES
                        // E0.7   [2] (🎞️..🎟️)    film frames..admission tickets
                        // E0.6  [37] (🎠..🏄)    carousel horse..person surfing
                        // E1.0   [1] (🏅)       sports medal
                        // E0.6   [1] (🏆)       trophy
                        // E1.0   [1] (🏇)       horse racing
                        // E0.6   [1] (🏈)       american football
                        // E1.0   [1] (🏉)       rugby football
                        // E0.6   [1] (🏊)       person swimming
                        // E0.7   [4] (🏋️..🏎️)    person lifting weights..racing car
                        // E1.0   [5] (🏏..🏓)    cricket game..ping pong
                        // E0.7  [12] (🏔️..🏟️)    snow-capped mountain..stadium
                        // E0.6   [4] (🏠..🏣)    house..Japanese post office
                        // E1.0   [1] (🏤)       post office
                        // E0.6  [12] (🏥..🏰)    hospital..castle
                        // E0.0   [2] (🏱..🏲)    WHITE PENNANT..BLACK PENNANT
                        // E0.7   [1] (🏳️)       white flag
                        // E1.0   [1] (🏴)       black flag
                        // E0.7   [1] (🏵️)       rosette
                        // E0.0   [1] (🏶)       BLACK ROSETTE
                        // E0.7   [1] (🏷️)       label
                        // E1.0   [3] (🏸..🏺)    badminton..amphora
                        if (0x1f249 <= code && code <= 0x1f3fa) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E1.0   [8] (🐀..🐇)    rat..rabbit
                        // E0.7   [1] (🐈)       cat
                        // E1.0   [3] (🐉..🐋)    dragon..whale
                        // E0.6   [3] (🐌..🐎)    snail..horse
                        // E1.0   [2] (🐏..🐐)    ram..goat
                        // E0.6   [2] (🐑..🐒)    ewe..monkey
                        // E1.0   [1] (🐓)       rooster
                        // E0.6   [1] (🐔)       chicken
                        // E0.7   [1] (🐕)       dog
                        // E1.0   [1] (🐖)       pig
                        // E0.6  [19] (🐗..🐩)    boar..poodle
                        // E1.0   [1] (🐪)       camel
                        // E0.6  [20] (🐫..🐾)    two-hump camel..paw prints
                        // E0.7   [1] (🐿️)       chipmunk
                        // E0.6   [1] (👀)       eyes
                        // E0.7   [1] (👁️)       eye
                        // E0.6  [35] (👂..👤)    ear..bust in silhouette
                        // E1.0   [1] (👥)       busts in silhouette
                        // E0.6   [6] (👦..👫)    boy..woman and man holding hands
                        // E1.0   [2] (👬..👭)    men holding hands..women holding hands
                        // E0.6  [63] (👮..💬)    police officer..speech balloon
                        // E1.0   [1] (💭)       thought balloon
                        // E0.6   [8] (💮..💵)    white flower..dollar banknote
                        // E1.0   [2] (💶..💷)    euro banknote..pound banknote
                        // E0.6  [52] (💸..📫)    money with wings..closed mailbox with raised flag
                        // E0.7   [2] (📬..📭)    open mailbox with raised flag..open mailbox with lowered flag
                        // E0.6   [1] (📮)       postbox
                        // E1.0   [1] (📯)       postal horn
                        // E0.6   [5] (📰..📴)    newspaper..mobile phone off
                        // E1.0   [1] (📵)       no mobile phones
                        // E0.6   [2] (📶..📷)    antenna bars..camera
                        // E1.0   [1] (📸)       camera with flash
                        // E0.6   [4] (📹..📼)    video camera..videocassette
                        // E0.7   [1] (📽️)       film projector
                        // E0.0   [1] (📾)       PORTABLE STEREO
                        // E1.0   [4] (📿..🔂)    prayer beads..repeat single button
                        // E0.6   [1] (🔃)       clockwise vertical arrows
                        // E1.0   [4] (🔄..🔇)    counterclockwise arrows button..muted speaker
                        // E0.7   [1] (🔈)       speaker low volume
                        // E1.0   [1] (🔉)       speaker medium volume
                        // E0.6  [11] (🔊..🔔)    speaker high volume..bell
                        // E1.0   [1] (🔕)       bell with slash
                        // E0.6  [22] (🔖..🔫)    bookmark..water pistol
                        // E1.0   [2] (🔬..🔭)    microscope..telescope
                        // E0.6  [16] (🔮..🔽)    crystal ball..downwards button
                        if (0x1f400 <= code && code <= 0x1f53d) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    }
                } else {
                    if (code < 0x1f680) {
                        // E0.0   [3] (🕆..🕈)    WHITE LATIN CROSS..CELTIC CROSS
                        // E0.7   [2] (🕉️..🕊️)    om..dove
                        // E1.0   [4] (🕋..🕎)    kaaba..menorah
                        // E0.0   [1] (🕏)       BOWL OF HYGIEIA
                        // E0.6  [12] (🕐..🕛)    one o’clock..twelve o’clock
                        // E0.7  [12] (🕜..🕧)    one-thirty..twelve-thirty
                        // E0.0   [7] (🕨..🕮)    RIGHT SPEAKER..BOOK
                        // E0.7   [2] (🕯️..🕰️)    candle..mantelpiece clock
                        // E0.0   [2] (🕱..🕲)    BLACK SKULL AND CROSSBONES..NO PIRACY
                        // E0.7   [7] (🕳️..🕹️)    hole..joystick
                        // E3.0   [1] (🕺)       man dancing
                        // E0.0  [12] (🕻..🖆)    LEFT HAND TELEPHONE RECEIVER..PEN OVER STAMPED ENVELOPE
                        // E0.7   [1] (🖇️)       linked paperclips
                        // E0.0   [2] (🖈..🖉)    BLACK PUSHPIN..LOWER LEFT PENCIL
                        // E0.7   [4] (🖊️..🖍️)    pen..crayon
                        // E0.0   [2] (🖎..🖏)    LEFT WRITING HAND..TURNED OK HAND SIGN
                        // E0.7   [1] (🖐️)       hand with fingers splayed
                        // E0.0   [4] (🖑..🖔)    REVERSED RAISED HAND WITH FINGERS SPLAYED..REVERSED VICTORY HAND
                        // E1.0   [2] (🖕..🖖)    middle finger..vulcan salute
                        // E0.0  [13] (🖗..🖣)    WHITE DOWN POINTING LEFT HAND INDEX..BLACK DOWN POINTING BACKHAND INDEX
                        // E3.0   [1] (🖤)       black heart
                        // E0.7   [1] (🖥️)       desktop computer
                        // E0.0   [2] (🖦..🖧)    KEYBOARD AND MOUSE..THREE NETWORKED COMPUTERS
                        // E0.7   [1] (🖨️)       printer
                        // E0.0   [8] (🖩..🖰)    POCKET CALCULATOR..TWO BUTTON MOUSE
                        // E0.7   [2] (🖱️..🖲️)    computer mouse..trackball
                        // E0.0   [9] (🖳..🖻)    OLD PERSONAL COMPUTER..DOCUMENT WITH PICTURE
                        // E0.7   [1] (🖼️)       framed picture
                        // E0.0   [5] (🖽..🗁)    FRAME WITH TILES..OPEN FOLDER
                        // E0.7   [3] (🗂️..🗄️)    card index dividers..file cabinet
                        // E0.0  [12] (🗅..🗐)    EMPTY NOTE..PAGES
                        // E0.7   [3] (🗑️..🗓️)    wastebasket..spiral calendar
                        // E0.0   [8] (🗔..🗛)    DESKTOP WINDOW..DECREASE FONT SIZE SYMBOL
                        // E0.7   [3] (🗜️..🗞️)    clamp..rolled-up newspaper
                        // E0.0   [2] (🗟..🗠)    PAGE WITH CIRCLED TEXT..STOCK CHART
                        // E0.7   [1] (🗡️)       dagger
                        // E0.0   [1] (🗢)       LIPS
                        // E0.7   [1] (🗣️)       speaking head
                        // E0.0   [4] (🗤..🗧)    THREE RAYS ABOVE..THREE RAYS RIGHT
                        // E2.0   [1] (🗨️)       left speech bubble
                        // E0.0   [6] (🗩..🗮)    RIGHT SPEECH BUBBLE..LEFT ANGER BUBBLE
                        // E0.7   [1] (🗯️)       right anger bubble
                        // E0.0   [3] (🗰..🗲)    MOOD BUBBLE..LIGHTNING MOOD
                        // E0.7   [1] (🗳️)       ballot box with ballot
                        // E0.0   [6] (🗴..🗹)    BALLOT SCRIPT X..BALLOT BOX WITH BOLD CHECK
                        // E0.7   [1] (🗺️)       world map
                        // E0.6   [5] (🗻..🗿)    mount fuji..moai
                        // E1.0   [1] (😀)       grinning face
                        // E0.6   [6] (😁..😆)    beaming face with smiling eyes..grinning squinting face
                        // E1.0   [2] (😇..😈)    smiling face with halo..smiling face with horns
                        // E0.6   [5] (😉..😍)    winking face..smiling face with heart-eyes
                        // E1.0   [1] (😎)       smiling face with sunglasses
                        // E0.6   [1] (😏)       smirking face
                        // E0.7   [1] (😐)       neutral face
                        // E1.0   [1] (😑)       expressionless face
                        // E0.6   [3] (😒..😔)    unamused face..pensive face
                        // E1.0   [1] (😕)       confused face
                        // E0.6   [1] (😖)       confounded face
                        // E1.0   [1] (😗)       kissing face
                        // E0.6   [1] (😘)       face blowing a kiss
                        // E1.0   [1] (😙)       kissing face with smiling eyes
                        // E0.6   [1] (😚)       kissing face with closed eyes
                        // E1.0   [1] (😛)       face with tongue
                        // E0.6   [3] (😜..😞)    winking face with tongue..disappointed face
                        // E1.0   [1] (😟)       worried face
                        // E0.6   [6] (😠..😥)    angry face..sad but relieved face
                        // E1.0   [2] (😦..😧)    frowning face with open mouth..anguished face
                        // E0.6   [4] (😨..😫)    fearful face..tired face
                        // E1.0   [1] (😬)       grimacing face
                        // E0.6   [1] (😭)       loudly crying face
                        // E1.0   [2] (😮..😯)    face with open mouth..hushed face
                        // E0.6   [4] (😰..😳)    anxious face with sweat..flushed face
                        // E1.0   [1] (😴)       sleeping face
                        // E0.6   [1] (😵)       face with crossed-out eyes
                        // E1.0   [1] (😶)       face without mouth
                        // E0.6  [10] (😷..🙀)    face with medical mask..weary cat
                        // E1.0   [4] (🙁..🙄)    slightly frowning face..face with rolling eyes
                        // E0.6  [11] (🙅..🙏)    person gesturing NO..folded hands
                        if (0x1f546 <= code && code <= 0x1f64f) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else if (code < 0x1f774) {
                        // E0.6   [1] (🚀)       rocket
                        // E1.0   [2] (🚁..🚂)    helicopter..locomotive
                        // E0.6   [3] (🚃..🚅)    railway car..bullet train
                        // E1.0   [1] (🚆)       train
                        // E0.6   [1] (🚇)       metro
                        // E1.0   [1] (🚈)       light rail
                        // E0.6   [1] (🚉)       station
                        // E1.0   [2] (🚊..🚋)    tram..tram car
                        // E0.6   [1] (🚌)       bus
                        // E0.7   [1] (🚍)       oncoming bus
                        // E1.0   [1] (🚎)       trolleybus
                        // E0.6   [1] (🚏)       bus stop
                        // E1.0   [1] (🚐)       minibus
                        // E0.6   [3] (🚑..🚓)    ambulance..police car
                        // E0.7   [1] (🚔)       oncoming police car
                        // E0.6   [1] (🚕)       taxi
                        // E1.0   [1] (🚖)       oncoming taxi
                        // E0.6   [1] (🚗)       automobile
                        // E0.7   [1] (🚘)       oncoming automobile
                        // E0.6   [2] (🚙..🚚)    sport utility vehicle..delivery truck
                        // E1.0   [7] (🚛..🚡)    articulated lorry..aerial tramway
                        // E0.6   [1] (🚢)       ship
                        // E1.0   [1] (🚣)       person rowing boat
                        // E0.6   [2] (🚤..🚥)    speedboat..horizontal traffic light
                        // E1.0   [1] (🚦)       vertical traffic light
                        // E0.6   [7] (🚧..🚭)    construction..no smoking
                        // E1.0   [4] (🚮..🚱)    litter in bin sign..non-potable water
                        // E0.6   [1] (🚲)       bicycle
                        // E1.0   [3] (🚳..🚵)    no bicycles..person mountain biking
                        // E0.6   [1] (🚶)       person walking
                        // E1.0   [2] (🚷..🚸)    no pedestrians..children crossing
                        // E0.6   [6] (🚹..🚾)    men’s room..water closet
                        // E1.0   [1] (🚿)       shower
                        // E0.6   [1] (🛀)       person taking bath
                        // E1.0   [5] (🛁..🛅)    bathtub..left luggage
                        // E0.0   [5] (🛆..🛊)    TRIANGLE WITH ROUNDED CORNERS..GIRLS SYMBOL
                        // E0.7   [1] (🛋️)       couch and lamp
                        // E1.0   [1] (🛌)       person in bed
                        // E0.7   [3] (🛍️..🛏️)    shopping bags..bed
                        // E1.0   [1] (🛐)       place of worship
                        // E3.0   [2] (🛑..🛒)    stop sign..shopping cart
                        // E0.0   [2] (🛓..🛔)    STUPA..PAGODA
                        // E12.0  [1] (🛕)       hindu temple
                        // E13.0  [2] (🛖..🛗)    hut..elevator
                        // E0.0   [4] (🛘..🛛)    <reserved-1F6D8>..<reserved-1F6DB>
                        // E15.0  [1] (🛜)       wireless
                        // E14.0  [3] (🛝..🛟)    playground slide..ring buoy
                        // E0.7   [6] (🛠️..🛥️)    hammer and wrench..motor boat
                        // E0.0   [3] (🛦..🛨)    UP-POINTING MILITARY AIRPLANE..UP-POINTING SMALL AIRPLANE
                        // E0.7   [1] (🛩️)       small airplane
                        // E0.0   [1] (🛪)       NORTHEAST-POINTING AIRPLANE
                        // E1.0   [2] (🛫..🛬)    airplane departure..airplane arrival
                        // E0.0   [3] (🛭..🛯)    <reserved-1F6ED>..<reserved-1F6EF>
                        // E0.7   [1] (🛰️)       satellite
                        // E0.0   [2] (🛱..🛲)    ONCOMING FIRE ENGINE..DIESEL LOCOMOTIVE
                        // E0.7   [1] (🛳️)       passenger ship
                        // E3.0   [3] (🛴..🛶)    kick scooter..canoe
                        // E5.0   [2] (🛷..🛸)    sled..flying saucer
                        // E11.0  [1] (🛹)       skateboard
                        // E12.0  [1] (🛺)       auto rickshaw
                        // E13.0  [2] (🛻..🛼)    pickup truck..roller skate
                        // E0.0   [3] (🛽..🛿)    <reserved-1F6FD>..<reserved-1F6FF>
                        if (0x1f680 <= code && code <= 0x1f6ff) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.0  [12] (🝴..🝿)    LOT OF FORTUNE..ORCUS
                        if (0x1f774 <= code && code <= 0x1f77f) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    }
                }
            } else {
                if (code < 0x1f8ae) {
                    if (code < 0x1f848) {
                        if (code < 0x1f80c) {
                            // E0.0  [11] (🟕..🟟)    CIRCLED TRIANGLE..<reserved-1F7DF>
                            // E12.0 [12] (🟠..🟫)    orange circle..brown square
                            // E0.0   [4] (🟬..🟯)    <reserved-1F7EC>..<reserved-1F7EF>
                            // E14.0  [1] (🟰)       heavy equals sign
                            // E0.0  [15] (🟱..🟿)    <reserved-1F7F1>..<reserved-1F7FF>
                            if (0x1f7d5 <= code && code <= 0x1f7ff) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.0   [4] (🠌..🠏)    <reserved-1F80C>..<reserved-1F80F>
                            if (0x1f80c <= code && code <= 0x1f80f) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    } else {
                        if (code < 0x1f85a) {
                            // E0.0   [8] (🡈..🡏)    <reserved-1F848>..<reserved-1F84F>
                            if (0x1f848 <= code && code <= 0x1f84f) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else if (code < 0x1f888) {
                            // E0.0   [6] (🡚..🡟)    <reserved-1F85A>..<reserved-1F85F>
                            if (0x1f85a <= code && code <= 0x1f85f) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        } else {
                            // E0.0   [8] (🢈..🢏)    <reserved-1F888>..<reserved-1F88F>
                            if (0x1f888 <= code && code <= 0x1f88f) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                        }
                    }
                } else if (code < 0x1f93c) {
                    if (code < 0x1f90c) {
                        // E0.0  [82] (🢮..🣿)    <reserved-1F8AE>..<reserved-1F8FF>
                        if (0x1f8ae <= code && code <= 0x1f8ff) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E13.0  [1] (🤌)       pinched fingers
                        // E12.0  [3] (🤍..🤏)    white heart..pinching hand
                        // E1.0   [9] (🤐..🤘)    zipper-mouth face..sign of the horns
                        // E3.0   [6] (🤙..🤞)    call me hand..crossed fingers
                        // E5.0   [1] (🤟)       love-you gesture
                        // E3.0   [8] (🤠..🤧)    cowboy hat face..sneezing face
                        // E5.0   [8] (🤨..🤯)    face with raised eyebrow..exploding head
                        // E3.0   [1] (🤰)       pregnant woman
                        // E5.0   [2] (🤱..🤲)    breast-feeding..palms up together
                        // E3.0   [8] (🤳..🤺)    selfie..person fencing
                        if (0x1f90c <= code && code <= 0x1f93a) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    }
                } else {
                    if (code < 0x1f947) {
                        // E3.0   [3] (🤼..🤾)    people wrestling..person playing handball
                        // E12.0  [1] (🤿)       diving mask
                        // E3.0   [6] (🥀..🥅)    wilted flower..goal net
                        if (0x1f93c <= code && code <= 0x1f945) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else if (code < 0x1fc00) {
                        // E3.0   [5] (🥇..🥋)    1st place medal..martial arts uniform
                        // E5.0   [1] (🥌)       curling stone
                        // E11.0  [3] (🥍..🥏)    lacrosse..flying disc
                        // E3.0  [15] (🥐..🥞)    croissant..pancakes
                        // E5.0  [13] (🥟..🥫)    dumpling..canned food
                        // E11.0  [5] (🥬..🥰)    leafy green..smiling face with hearts
                        // E12.0  [1] (🥱)       yawning face
                        // E13.0  [1] (🥲)       smiling face with tear
                        // E11.0  [4] (🥳..🥶)    partying face..cold face
                        // E13.0  [2] (🥷..🥸)    ninja..disguised face
                        // E14.0  [1] (🥹)       face holding back tears
                        // E11.0  [1] (🥺)       pleading face
                        // E12.0  [1] (🥻)       sari
                        // E11.0  [4] (🥼..🥿)    lab coat..flat shoe
                        // E1.0   [5] (🦀..🦄)    crab..unicorn
                        // E3.0  [13] (🦅..🦑)    eagle..squid
                        // E5.0   [6] (🦒..🦗)    giraffe..cricket
                        // E11.0 [11] (🦘..🦢)    kangaroo..swan
                        // E13.0  [2] (🦣..🦤)    mammoth..dodo
                        // E12.0  [6] (🦥..🦪)    sloth..oyster
                        // E13.0  [3] (🦫..🦭)    beaver..seal
                        // E12.0  [2] (🦮..🦯)    guide dog..white cane
                        // E11.0 [10] (🦰..🦹)    red hair..supervillain
                        // E12.0  [6] (🦺..🦿)    safety vest..mechanical leg
                        // E1.0   [1] (🧀)       cheese wedge
                        // E11.0  [2] (🧁..🧂)    cupcake..salt
                        // E12.0  [8] (🧃..🧊)    beverage box..ice
                        // E13.0  [1] (🧋)       bubble tea
                        // E14.0  [1] (🧌)       troll
                        // E12.0  [3] (🧍..🧏)    person standing..deaf person
                        // E5.0  [23] (🧐..🧦)    face with monocle..socks
                        // E11.0 [25] (🧧..🧿)    red envelope..nazar amulet
                        // E0.0 [112] (🨀..🩯)    NEUTRAL CHESS KING..<reserved-1FA6F>
                        // E12.0  [4] (🩰..🩳)    ballet shoes..shorts
                        // E13.0  [1] (🩴)       thong sandal
                        // E15.0  [3] (🩵..🩷)    light blue heart..pink heart
                        // E12.0  [3] (🩸..🩺)    drop of blood..stethoscope
                        // E14.0  [2] (🩻..🩼)    x-ray..crutch
                        // E0.0   [3] (🩽..🩿)    <reserved-1FA7D>..<reserved-1FA7F>
                        // E12.0  [3] (🪀..🪂)    yo-yo..parachute
                        // E13.0  [4] (🪃..🪆)    boomerang..nesting dolls
                        // E15.0  [2] (🪇..🪈)    maracas..flute
                        // E0.0   [7] (🪉..🪏)    <reserved-1FA89>..<reserved-1FA8F>
                        // E12.0  [6] (🪐..🪕)    ringed planet..banjo
                        // E13.0 [19] (🪖..🪨)    military helmet..rock
                        // E14.0  [4] (🪩..🪬)    mirror ball..hamsa
                        // E15.0  [3] (🪭..🪯)    folding hand fan..khanda
                        // E13.0  [7] (🪰..🪶)    fly..feather
                        // E14.0  [4] (🪷..🪺)    lotus..nest with eggs
                        // E15.0  [3] (🪻..🪽)    hyacinth..wing
                        // E0.0   [1] (🪾)       <reserved-1FABE>
                        // E15.0  [1] (🪿)       goose
                        // E13.0  [3] (🫀..🫂)    anatomical heart..people hugging
                        // E14.0  [3] (🫃..🫅)    pregnant man..person with crown
                        // E0.0   [8] (🫆..🫍)    <reserved-1FAC6>..<reserved-1FACD>
                        // E15.0  [2] (🫎..🫏)    moose..donkey
                        // E13.0  [7] (🫐..🫖)    blueberries..teapot
                        // E14.0  [3] (🫗..🫙)    pouring liquid..jar
                        // E15.0  [2] (🫚..🫛)    ginger root..pea pod
                        // E0.0   [4] (🫜..🫟)    <reserved-1FADC>..<reserved-1FADF>
                        // E14.0  [8] (🫠..🫧)    melting face..bubbles
                        // E15.0  [1] (🫨)       shaking face
                        // E0.0   [7] (🫩..🫯)    <reserved-1FAE9>..<reserved-1FAEF>
                        // E14.0  [7] (🫰..🫶)    hand with index finger and thumb crossed..heart hands
                        // E15.0  [2] (🫷..🫸)    leftwards pushing hand..rightwards pushing hand
                        // E0.0   [7] (🫹..🫿)    <reserved-1FAF9>..<reserved-1FAFF>
                        if (0x1f947 <= code && code <= 0x1faff) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    } else {
                        // E0.0[1022] (🰀..🿽)    <reserved-1FC00>..<reserved-1FFFD>
                        if (0x1fc00 <= code && code <= 0x1fffd) return boundaries_1.EXTENDED_PICTOGRAPHIC;
                    }
                }
            }
        }
        // unlisted code points are treated as a break property of "Other"
        return boundaries_1.CLUSTER_BREAK.OTHER;
    }
}
exports.default = Graphemer;

},{"c66f707714d0a681":"hBn76","cf456655d60f0dc1":"iy8EB","4da0ff3200da4614":"epUJi"}],"hBn76":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * The Grapheme_Cluster_Break property value
 * @see https://www.unicode.org/reports/tr29/#Default_Grapheme_Cluster_Table
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EXTENDED_PICTOGRAPHIC = exports.CLUSTER_BREAK = void 0;
var CLUSTER_BREAK;
(function(CLUSTER_BREAK) {
    CLUSTER_BREAK[CLUSTER_BREAK["CR"] = 0] = "CR";
    CLUSTER_BREAK[CLUSTER_BREAK["LF"] = 1] = "LF";
    CLUSTER_BREAK[CLUSTER_BREAK["CONTROL"] = 2] = "CONTROL";
    CLUSTER_BREAK[CLUSTER_BREAK["EXTEND"] = 3] = "EXTEND";
    CLUSTER_BREAK[CLUSTER_BREAK["REGIONAL_INDICATOR"] = 4] = "REGIONAL_INDICATOR";
    CLUSTER_BREAK[CLUSTER_BREAK["SPACINGMARK"] = 5] = "SPACINGMARK";
    CLUSTER_BREAK[CLUSTER_BREAK["L"] = 6] = "L";
    CLUSTER_BREAK[CLUSTER_BREAK["V"] = 7] = "V";
    CLUSTER_BREAK[CLUSTER_BREAK["T"] = 8] = "T";
    CLUSTER_BREAK[CLUSTER_BREAK["LV"] = 9] = "LV";
    CLUSTER_BREAK[CLUSTER_BREAK["LVT"] = 10] = "LVT";
    CLUSTER_BREAK[CLUSTER_BREAK["OTHER"] = 11] = "OTHER";
    CLUSTER_BREAK[CLUSTER_BREAK["PREPEND"] = 12] = "PREPEND";
    CLUSTER_BREAK[CLUSTER_BREAK["E_BASE"] = 13] = "E_BASE";
    CLUSTER_BREAK[CLUSTER_BREAK["E_MODIFIER"] = 14] = "E_MODIFIER";
    CLUSTER_BREAK[CLUSTER_BREAK["ZWJ"] = 15] = "ZWJ";
    CLUSTER_BREAK[CLUSTER_BREAK["GLUE_AFTER_ZWJ"] = 16] = "GLUE_AFTER_ZWJ";
    CLUSTER_BREAK[CLUSTER_BREAK["E_BASE_GAZ"] = 17] = "E_BASE_GAZ";
})(CLUSTER_BREAK = exports.CLUSTER_BREAK || (exports.CLUSTER_BREAK = {}));
/**
 * The Emoji character property is an extension of UCD but shares the same namespace and structure
 * @see http://www.unicode.org/reports/tr51/tr51-14.html#Emoji_Properties_and_Data_Files
 *
 * Here we model Extended_Pictograhpic only to implement UAX #29 GB11
 * \p{Extended_Pictographic} Extend* ZWJ	×	\p{Extended_Pictographic}
 *
 * The Emoji character property should not be mixed with Grapheme_Cluster_Break since they are not exclusive
 */ exports.EXTENDED_PICTOGRAPHIC = 101;

},{}],"iy8EB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const boundaries_1 = require("97baa04773ad09d4");
// BreakTypes
// @type {BreakType}
const NotBreak = 0;
const BreakStart = 1;
const Break = 2;
const BreakLastRegional = 3;
const BreakPenultimateRegional = 4;
class GraphemerHelper {
    /**
     * Check if the the character at the position {pos} of the string is surrogate
     * @param str {string}
     * @param pos {number}
     * @returns {boolean}
     */ static isSurrogate(str, pos) {
        return 0xd800 <= str.charCodeAt(pos) && str.charCodeAt(pos) <= 0xdbff && 0xdc00 <= str.charCodeAt(pos + 1) && str.charCodeAt(pos + 1) <= 0xdfff;
    }
    /**
     * The String.prototype.codePointAt polyfill
     * Private function, gets a Unicode code point from a JavaScript UTF-16 string
     * handling surrogate pairs appropriately
     * @param str {string}
     * @param idx {number}
     * @returns {number}
     */ static codePointAt(str, idx) {
        if (idx === undefined) idx = 0;
        const code = str.charCodeAt(idx);
        // if a high surrogate
        if (0xd800 <= code && code <= 0xdbff && idx < str.length - 1) {
            const hi = code;
            const low = str.charCodeAt(idx + 1);
            if (0xdc00 <= low && low <= 0xdfff) return (hi - 0xd800) * 0x400 + (low - 0xdc00) + 0x10000;
            return hi;
        }
        // if a low surrogate
        if (0xdc00 <= code && code <= 0xdfff && idx >= 1) {
            const hi = str.charCodeAt(idx - 1);
            const low = code;
            if (0xd800 <= hi && hi <= 0xdbff) return (hi - 0xd800) * 0x400 + (low - 0xdc00) + 0x10000;
            return low;
        }
        // just return the char if an unmatched surrogate half or a
        // single-char codepoint
        return code;
    }
    //
    /**
     * Private function, returns whether a break is allowed between the two given grapheme breaking classes
     * Implemented the UAX #29 3.1.1 Grapheme Cluster Boundary Rules on extended grapheme clusters
     * @param start {number}
     * @param mid {Array<number>}
     * @param end {number}
     * @param startEmoji {number}
     * @param midEmoji {Array<number>}
     * @param endEmoji {number}
     * @returns {number}
     */ static shouldBreak(start, mid, end, startEmoji, midEmoji, endEmoji) {
        const all = [
            start
        ].concat(mid).concat([
            end
        ]);
        const allEmoji = [
            startEmoji
        ].concat(midEmoji).concat([
            endEmoji
        ]);
        const previous = all[all.length - 2];
        const next = end;
        const nextEmoji = endEmoji;
        // Lookahead terminator for:
        // GB12. ^ (RI RI)* RI ? RI
        // GB13. [^RI] (RI RI)* RI ? RI
        const rIIndex = all.lastIndexOf(boundaries_1.CLUSTER_BREAK.REGIONAL_INDICATOR);
        if (rIIndex > 0 && all.slice(1, rIIndex).every(function(c) {
            return c === boundaries_1.CLUSTER_BREAK.REGIONAL_INDICATOR;
        }) && [
            boundaries_1.CLUSTER_BREAK.PREPEND,
            boundaries_1.CLUSTER_BREAK.REGIONAL_INDICATOR
        ].indexOf(previous) === -1) {
            if (all.filter(function(c) {
                return c === boundaries_1.CLUSTER_BREAK.REGIONAL_INDICATOR;
            }).length % 2 === 1) return BreakLastRegional;
            else return BreakPenultimateRegional;
        }
        // GB3. CR × LF
        if (previous === boundaries_1.CLUSTER_BREAK.CR && next === boundaries_1.CLUSTER_BREAK.LF) return NotBreak;
        else if (previous === boundaries_1.CLUSTER_BREAK.CONTROL || previous === boundaries_1.CLUSTER_BREAK.CR || previous === boundaries_1.CLUSTER_BREAK.LF) return BreakStart;
        else if (next === boundaries_1.CLUSTER_BREAK.CONTROL || next === boundaries_1.CLUSTER_BREAK.CR || next === boundaries_1.CLUSTER_BREAK.LF) return BreakStart;
        else if (previous === boundaries_1.CLUSTER_BREAK.L && (next === boundaries_1.CLUSTER_BREAK.L || next === boundaries_1.CLUSTER_BREAK.V || next === boundaries_1.CLUSTER_BREAK.LV || next === boundaries_1.CLUSTER_BREAK.LVT)) return NotBreak;
        else if ((previous === boundaries_1.CLUSTER_BREAK.LV || previous === boundaries_1.CLUSTER_BREAK.V) && (next === boundaries_1.CLUSTER_BREAK.V || next === boundaries_1.CLUSTER_BREAK.T)) return NotBreak;
        else if ((previous === boundaries_1.CLUSTER_BREAK.LVT || previous === boundaries_1.CLUSTER_BREAK.T) && next === boundaries_1.CLUSTER_BREAK.T) return NotBreak;
        else if (next === boundaries_1.CLUSTER_BREAK.EXTEND || next === boundaries_1.CLUSTER_BREAK.ZWJ) return NotBreak;
        else if (next === boundaries_1.CLUSTER_BREAK.SPACINGMARK) return NotBreak;
        else if (previous === boundaries_1.CLUSTER_BREAK.PREPEND) return NotBreak;
        // GB11. \p{Extended_Pictographic} Extend* ZWJ × \p{Extended_Pictographic}
        const previousNonExtendIndex = allEmoji.slice(0, -1).lastIndexOf(boundaries_1.EXTENDED_PICTOGRAPHIC);
        if (previousNonExtendIndex !== -1 && allEmoji[previousNonExtendIndex] === boundaries_1.EXTENDED_PICTOGRAPHIC && all.slice(previousNonExtendIndex + 1, -2).every(function(c) {
            return c === boundaries_1.CLUSTER_BREAK.EXTEND;
        }) && previous === boundaries_1.CLUSTER_BREAK.ZWJ && nextEmoji === boundaries_1.EXTENDED_PICTOGRAPHIC) return NotBreak;
        // GB12. ^ (RI RI)* RI × RI
        // GB13. [^RI] (RI RI)* RI × RI
        if (mid.indexOf(boundaries_1.CLUSTER_BREAK.REGIONAL_INDICATOR) !== -1) return Break;
        if (previous === boundaries_1.CLUSTER_BREAK.REGIONAL_INDICATOR && next === boundaries_1.CLUSTER_BREAK.REGIONAL_INDICATOR) return NotBreak;
        // GB999. Any ? Any
        return BreakStart;
    }
}
exports.default = GraphemerHelper;

},{"97baa04773ad09d4":"hBn76"}],"epUJi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * GraphemerIterator
 *
 * Takes a string and a "BreakHandler" method during initialisation
 * and creates an iterable object that returns individual graphemes.
 *
 * @param str {string}
 * @return GraphemerIterator
 */ class GraphemerIterator {
    constructor(str, nextBreak){
        this._index = 0;
        this._str = str;
        this._nextBreak = nextBreak;
    }
    [Symbol.iterator]() {
        return this;
    }
    next() {
        let brk;
        if ((brk = this._nextBreak(this._str, this._index)) < this._str.length) {
            const value = this._str.slice(this._index, brk);
            this._index = brk;
            return {
                value: value,
                done: false
            };
        }
        if (this._index < this._str.length) {
            const value = this._str.slice(this._index);
            this._index = this._str.length;
            return {
                value: value,
                done: false
            };
        }
        return {
            value: undefined,
            done: true
        };
    }
}
exports.default = GraphemerIterator;

},{}],"gcs2R":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.didDocument = exports.getServiceEndpoint = exports.getNotifEndpoint = exports.getFeedGenEndpoint = exports.getPdsEndpoint = exports.getSigningDidKey = exports.getVerificationMaterial = exports.getSigningKey = exports.getHandle = exports.getDid = exports.isValidDidDoc = void 0;
const zod_1 = require("7cfd24025513832d");
// Parsing atproto data
// --------
const isValidDidDoc = (doc)=>{
    return exports.didDocument.safeParse(doc).success;
};
exports.isValidDidDoc = isValidDidDoc;
const getDid = (doc)=>{
    const id = doc.id;
    if (typeof id !== 'string') throw new Error('No `id` on document');
    return id;
};
exports.getDid = getDid;
const getHandle = (doc)=>{
    const aka = doc.alsoKnownAs;
    if (aka) for(let i = 0; i < aka.length; i++){
        const alias = aka[i];
        if (alias.startsWith('at://')) // strip off "at://" prefix
        return alias.slice(5);
    }
    return undefined;
};
exports.getHandle = getHandle;
// @NOTE we parse to type/publicKeyMultibase to avoid the dependency on @bluesky-social/crypto
const getSigningKey = (doc)=>{
    return (0, exports.getVerificationMaterial)(doc, 'atproto');
};
exports.getSigningKey = getSigningKey;
const getVerificationMaterial = (doc, keyId)=>{
    // /!\ Hot path
    const key = findItemById(doc, 'verificationMethod', `#${keyId}`);
    if (!key) return undefined;
    if (!key.publicKeyMultibase) return undefined;
    return {
        type: key.type,
        publicKeyMultibase: key.publicKeyMultibase
    };
};
exports.getVerificationMaterial = getVerificationMaterial;
const getSigningDidKey = (doc)=>{
    const parsed = (0, exports.getSigningKey)(doc);
    if (!parsed) return;
    return `did:key:${parsed.publicKeyMultibase}`;
};
exports.getSigningDidKey = getSigningDidKey;
const getPdsEndpoint = (doc)=>{
    return (0, exports.getServiceEndpoint)(doc, {
        id: '#atproto_pds',
        type: 'AtprotoPersonalDataServer'
    });
};
exports.getPdsEndpoint = getPdsEndpoint;
const getFeedGenEndpoint = (doc)=>{
    return (0, exports.getServiceEndpoint)(doc, {
        id: '#bsky_fg',
        type: 'BskyFeedGenerator'
    });
};
exports.getFeedGenEndpoint = getFeedGenEndpoint;
const getNotifEndpoint = (doc)=>{
    return (0, exports.getServiceEndpoint)(doc, {
        id: '#bsky_notif',
        type: 'BskyNotificationService'
    });
};
exports.getNotifEndpoint = getNotifEndpoint;
const getServiceEndpoint = (doc, opts)=>{
    // /!\ Hot path
    const service = findItemById(doc, 'service', opts.id);
    if (!service) return undefined;
    if (opts.type && service.type !== opts.type) return undefined;
    if (typeof service.serviceEndpoint !== 'string') return undefined;
    return validateUrl(service.serviceEndpoint);
};
exports.getServiceEndpoint = getServiceEndpoint;
function findItemById(doc, type, id) {
    // /!\ Hot path
    const items = doc[type];
    if (items) for(let i = 0; i < items.length; i++){
        const item = items[i];
        const itemId = item.id;
        if (itemId[0] === '#' ? itemId === id : itemId.length === doc.id.length + id.length && itemId[doc.id.length] === '#' && itemId.endsWith(id) && itemId.startsWith(doc.id) // <== We could probably skip this check
        ) return item;
    }
    return undefined;
}
// Check protocol and hostname to prevent potential SSRF
const validateUrl = (urlStr)=>{
    if (!urlStr.startsWith('http://') && !urlStr.startsWith('https://')) return undefined;
    if (!canParseUrl(urlStr)) return undefined;
    return urlStr;
};
const canParseUrl = URL.canParse ?? // URL.canParse is not available in Node.js < 18.17.0
((urlStr)=>{
    try {
        new URL(urlStr);
        return true;
    } catch  {
        return false;
    }
});
// Types
// --------
const verificationMethod = zod_1.z.object({
    id: zod_1.z.string(),
    type: zod_1.z.string(),
    controller: zod_1.z.string(),
    publicKeyMultibase: zod_1.z.string().optional()
});
const service = zod_1.z.object({
    id: zod_1.z.string(),
    type: zod_1.z.string(),
    serviceEndpoint: zod_1.z.union([
        zod_1.z.string(),
        zod_1.z.record(zod_1.z.unknown())
    ])
});
exports.didDocument = zod_1.z.object({
    id: zod_1.z.string(),
    alsoKnownAs: zod_1.z.array(zod_1.z.string()).optional(),
    verificationMethod: zod_1.z.array(verificationMethod).optional(),
    service: zod_1.z.array(service).optional()
});

},{"7cfd24025513832d":"et8te"}],"dBffO":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("9221b203349f9177"), exports);
__exportStar(require("6a911c9be7293657"), exports);
__exportStar(require("b1ee3d430d125700"), exports);
__exportStar(require("ce13a6ab90289e8c"), exports);
__exportStar(require("dbc4041ceddc7745"), exports);
__exportStar(require("d1663dfb938ca7d3"), exports);
__exportStar(require("42bcb038738cd46f"), exports);

},{"9221b203349f9177":"cpsuK","6a911c9be7293657":"9J6qD","b1ee3d430d125700":"1BDzc","ce13a6ab90289e8c":"7ZtNC","dbc4041ceddc7745":"gUq0K","d1663dfb938ca7d3":"7phNQ","42bcb038738cd46f":"gzTbL"}],"cpsuK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisallowedDomainError = exports.UnsupportedDomainError = exports.ReservedHandleError = exports.InvalidHandleError = exports.isValidTld = exports.isValidHandle = exports.normalizeAndEnsureValidHandle = exports.normalizeHandle = exports.ensureValidHandleRegex = exports.ensureValidHandle = exports.DISALLOWED_TLDS = exports.INVALID_HANDLE = void 0;
exports.INVALID_HANDLE = 'handle.invalid';
// Currently these are registration-time restrictions, not protocol-level
// restrictions. We have a couple accounts in the wild that we need to clean up
// before hard-disallow.
// See also: https://en.wikipedia.org/wiki/Top-level_domain#Reserved_domains
exports.DISALLOWED_TLDS = [
    '.local',
    '.arpa',
    '.invalid',
    '.localhost',
    '.internal',
    '.example',
    '.alt',
    // policy could concievably change on ".onion" some day
    '.onion'
];
// Handle constraints, in English:
//  - must be a possible domain name
//    - RFC-1035 is commonly referenced, but has been updated. eg, RFC-3696,
//      section 2. and RFC-3986, section 3. can now have leading numbers (eg,
//      4chan.org)
//    - "labels" (sub-names) are made of ASCII letters, digits, hyphens
//    - can not start or end with a hyphen
//    - TLD (last component) should not start with a digit
//    - can't end with a hyphen (can end with digit)
//    - each segment must be between 1 and 63 characters (not including any periods)
//    - overall length can't be more than 253 characters
//    - separated by (ASCII) periods; does not start or end with period
//    - case insensitive
//    - domains (handles) are equal if they are the same lower-case
//    - punycode allowed for internationalization
//  - no whitespace, null bytes, joining chars, etc
//  - does not validate whether domain or TLD exists, or is a reserved or
//    special TLD (eg, .onion or .local)
//  - does not validate punycode
const ensureValidHandle = (handle)=>{
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9.-]*$/.test(handle)) throw new InvalidHandleError('Disallowed characters in handle (ASCII letters, digits, dashes, periods only)');
    if (handle.length > 253) throw new InvalidHandleError('Handle is too long (253 chars max)');
    const labels = handle.split('.');
    if (labels.length < 2) throw new InvalidHandleError('Handle domain needs at least two parts');
    for(let i = 0; i < labels.length; i++){
        const l = labels[i];
        if (l.length < 1) throw new InvalidHandleError('Handle parts can not be empty');
        if (l.length > 63) throw new InvalidHandleError('Handle part too long (max 63 chars)');
        if (l.endsWith('-') || l.startsWith('-')) throw new InvalidHandleError('Handle parts can not start or end with hyphens');
        if (i + 1 === labels.length && !/^[a-zA-Z]/.test(l)) throw new InvalidHandleError('Handle final component (TLD) must start with ASCII letter');
    }
};
exports.ensureValidHandle = ensureValidHandle;
// simple regex translation of above constraints
const ensureValidHandleRegex = (handle)=>{
    if (!/^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/.test(handle)) throw new InvalidHandleError("Handle didn't validate via regex");
    if (handle.length > 253) throw new InvalidHandleError('Handle is too long (253 chars max)');
};
exports.ensureValidHandleRegex = ensureValidHandleRegex;
const normalizeHandle = (handle)=>{
    return handle.toLowerCase();
};
exports.normalizeHandle = normalizeHandle;
const normalizeAndEnsureValidHandle = (handle)=>{
    const normalized = (0, exports.normalizeHandle)(handle);
    (0, exports.ensureValidHandle)(normalized);
    return normalized;
};
exports.normalizeAndEnsureValidHandle = normalizeAndEnsureValidHandle;
const isValidHandle = (handle)=>{
    try {
        (0, exports.ensureValidHandle)(handle);
    } catch (err) {
        if (err instanceof InvalidHandleError) return false;
        throw err;
    }
    return true;
};
exports.isValidHandle = isValidHandle;
const isValidTld = (handle)=>{
    return !exports.DISALLOWED_TLDS.some((domain)=>handle.endsWith(domain));
};
exports.isValidTld = isValidTld;
class InvalidHandleError extends Error {
}
exports.InvalidHandleError = InvalidHandleError;
/** @deprecated Never used */ class ReservedHandleError extends Error {
}
exports.ReservedHandleError = ReservedHandleError;
/** @deprecated Never used */ class UnsupportedDomainError extends Error {
}
exports.UnsupportedDomainError = UnsupportedDomainError;
/** @deprecated Never used */ class DisallowedDomainError extends Error {
}
exports.DisallowedDomainError = DisallowedDomainError;

},{}],"9J6qD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidDidError = exports.ensureValidDidRegex = exports.ensureValidDid = void 0;
// Human-readable constraints:
//   - valid W3C DID (https://www.w3.org/TR/did-core/#did-syntax)
//      - entire URI is ASCII: [a-zA-Z0-9._:%-]
//      - always starts "did:" (lower-case)
//      - method name is one or more lower-case letters, followed by ":"
//      - remaining identifier can have any of the above chars, but can not end in ":"
//      - it seems that a bunch of ":" can be included, and don't need spaces between
//      - "%" is used only for "percent encoding" and must be followed by two hex characters (and thus can't end in "%")
//      - query ("?") and fragment ("#") stuff is defined for "DID URIs", but not as part of identifier itself
//      - "The current specification does not take a position on the maximum length of a DID"
//   - in current atproto, only allowing did:plc and did:web. But not *forcing* this at lexicon layer
//   - hard length limit of 8KBytes
//   - not going to validate "percent encoding" here
const ensureValidDid = (did)=>{
    if (!did.startsWith('did:')) throw new InvalidDidError('DID requires "did:" prefix');
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9._:%-]*$/.test(did)) throw new InvalidDidError('Disallowed characters in DID (ASCII letters, digits, and a couple other characters only)');
    const { length, 1: method } = did.split(':');
    if (length < 3) throw new InvalidDidError('DID requires prefix, method, and method-specific content');
    if (!/^[a-z]+$/.test(method)) throw new InvalidDidError('DID method must be lower-case letters');
    if (did.endsWith(':') || did.endsWith('%')) throw new InvalidDidError('DID can not end with ":" or "%"');
    if (did.length > 2048) throw new InvalidDidError('DID is too long (2048 chars max)');
};
exports.ensureValidDid = ensureValidDid;
const ensureValidDidRegex = (did)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints
    if (!/^did:[a-z]+:[a-zA-Z0-9._:%-]*[a-zA-Z0-9._-]$/.test(did)) throw new InvalidDidError("DID didn't validate via regex");
    if (did.length > 2048) throw new InvalidDidError('DID is too long (2048 chars max)');
};
exports.ensureValidDidRegex = ensureValidDidRegex;
class InvalidDidError extends Error {
}
exports.InvalidDidError = InvalidDidError;

},{}],"1BDzc":[function(require,module,exports,__globalThis) {
"use strict";
/*
Grammar:

alpha     = "a" / "b" / "c" / "d" / "e" / "f" / "g" / "h" / "i" / "j" / "k" / "l" / "m" / "n" / "o" / "p" / "q" / "r" / "s" / "t" / "u" / "v" / "w" / "x" / "y" / "z" / "A" / "B" / "C" / "D" / "E" / "F" / "G" / "H" / "I" / "J" / "K" / "L" / "M" / "N" / "O" / "P" / "Q" / "R" / "S" / "T" / "U" / "V" / "W" / "X" / "Y" / "Z"
number    = "1" / "2" / "3" / "4" / "5" / "6" / "7" / "8" / "9" / "0"
delim     = "."
segment   = alpha *( alpha / number / "-" )
authority = segment *( delim segment )
name      = alpha *( alpha / number )
nsid      = authority delim name

*/ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidNsidError = exports.NSID = void 0;
exports.ensureValidNsid = ensureValidNsid;
exports.parseNsid = parseNsid;
exports.isValidNsid = isValidNsid;
exports.validateNsid = validateNsid;
exports.ensureValidNsidRegex = ensureValidNsidRegex;
exports.validateNsidRegex = validateNsidRegex;
class NSID {
    static parse(input) {
        return new NSID(input);
    }
    static create(authority, name) {
        const input = [
            ...authority.split('.').reverse(),
            name
        ].join('.');
        return new NSID(input);
    }
    static isValid(nsid) {
        return isValidNsid(nsid);
    }
    static from(input) {
        if (input instanceof NSID) // No need to clone, NSID is immutable
        return input;
        if (Array.isArray(input)) return new NSID(input.join('.'));
        return new NSID(String(input));
    }
    constructor(nsid){
        Object.defineProperty(this, "segments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.segments = parseNsid(nsid);
    }
    get authority() {
        return this.segments.slice(0, this.segments.length - 1).reverse().join('.');
    }
    get name() {
        return this.segments.at(this.segments.length - 1);
    }
    toString() {
        return this.segments.join('.');
    }
}
exports.NSID = NSID;
function ensureValidNsid(nsid) {
    const result = validateNsid(nsid);
    if (!result.success) throw new InvalidNsidError(result.message);
}
function parseNsid(nsid) {
    const result = validateNsid(nsid);
    if (!result.success) throw new InvalidNsidError(result.message);
    return result.value;
}
function isValidNsid(nsid) {
    // Since the regex version is more performant for valid NSIDs, we use it when
    // we don't care about error details.
    return validateNsidRegex(nsid).success;
}
// Human readable constraints on NSID:
// - a valid domain in reversed notation
// - followed by an additional period-separated name, which is camel-case letters
function validateNsid(input) {
    if (input.length > 317) return {
        success: false,
        message: 'NSID is too long (317 chars max)'
    };
    if (hasDisallowedCharacters(input)) return {
        success: false,
        message: 'Disallowed characters in NSID (ASCII letters, digits, dashes, periods only)'
    };
    const segments = input.split('.');
    if (segments.length < 3) return {
        success: false,
        message: 'NSID needs at least three parts'
    };
    for (const l of segments){
        if (l.length < 1) return {
            success: false,
            message: 'NSID parts can not be empty'
        };
        if (l.length > 63) return {
            success: false,
            message: 'NSID part too long (max 63 chars)'
        };
        if (startsWithHyphen(l) || endsWithHyphen(l)) return {
            success: false,
            message: 'NSID parts can not start or end with hyphen'
        };
    }
    if (startsWithNumber(segments[0])) return {
        success: false,
        message: 'NSID first part may not start with a digit'
    };
    if (!isValidIdentifier(segments[segments.length - 1])) return {
        success: false,
        message: 'NSID name part must be only letters and digits (and no leading digit)'
    };
    return {
        success: true,
        value: segments
    };
}
function hasDisallowedCharacters(v) {
    return !/^[a-zA-Z0-9.-]*$/.test(v);
}
function startsWithNumber(v) {
    const charCode = v.charCodeAt(0);
    return charCode >= 48 && charCode <= 57;
}
function startsWithHyphen(v) {
    return v.charCodeAt(0) === 45; /* - */ 
}
function endsWithHyphen(v) {
    return v.charCodeAt(v.length - 1) === 45; /* - */ 
}
function isValidIdentifier(v) {
    // Note, since we already know that "v" only contains [a-zA-Z0-9-], we can
    // simplify the following regex by checking only the first char and presence
    // of "-".
    // return /^[a-zA-Z][a-zA-Z0-9]*$/.test(v)
    return !startsWithNumber(v) && !v.includes('-');
}
/**
 * @deprecated Use {@link ensureValidNsid} if you care about error details,
 * {@link parseNsid}/{@link NSID.parse} if you need the parsed segments, or
 * {@link isValidNsid} if you just want a boolean.
 */ function ensureValidNsidRegex(nsid) {
    const result = validateNsidRegex(nsid);
    if (!result.success) throw new InvalidNsidError(result.message);
}
/**
 * Regexp based validation that behaves identically to the previous code but
 * provides less detailed error messages (while being 20% to 50% faster).
 */ function validateNsidRegex(value) {
    if (value.length > 317) return {
        success: false,
        message: 'NSID is too long (317 chars max)'
    };
    if (!/^[a-zA-Z](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?:\.[a-zA-Z](?:[a-zA-Z0-9]{0,62})?)$/.test(value)) return {
        success: false,
        message: "NSID didn't validate via regex"
    };
    return {
        success: true,
        value
    };
}
class InvalidNsidError extends Error {
}
exports.InvalidNsidError = InvalidNsidError;

},{}],"7ZtNC":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AtUri = exports.ATP_URI_REGEX = void 0;
__exportStar(require("93540ba32d792c8d"), exports);
exports.ATP_URI_REGEX = // proto-    --did--------------   --name----------------   --path----   --query--   --hash--
/^(at:\/\/)?((?:did:[a-z0-9:%-]+)|(?:[a-z0-9][a-z0-9.:-]*))(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
//                       --path-----   --query--  --hash--
const RELATIVE_REGEX = /^(\/[^?#\s]*)?(\?[^#\s]+)?(#[^\s]+)?$/i;
class AtUri {
    constructor(uri, base){
        Object.defineProperty(this, "hash", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "host", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pathname", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "searchParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        let parsed;
        if (base) {
            parsed = parse(base);
            if (!parsed) throw new Error(`Invalid at uri: ${base}`);
            const relativep = parseRelative(uri);
            if (!relativep) throw new Error(`Invalid path: ${uri}`);
            Object.assign(parsed, relativep);
        } else {
            parsed = parse(uri);
            if (!parsed) throw new Error(`Invalid at uri: ${uri}`);
        }
        this.hash = parsed.hash;
        this.host = parsed.host;
        this.pathname = parsed.pathname;
        this.searchParams = parsed.searchParams;
    }
    static make(handleOrDid, collection, rkey) {
        let str = handleOrDid;
        if (collection) str += '/' + collection;
        if (rkey) str += '/' + rkey;
        return new AtUri(str);
    }
    get protocol() {
        return 'at:';
    }
    get origin() {
        return `at://${this.host}`;
    }
    get hostname() {
        return this.host;
    }
    set hostname(v) {
        this.host = v;
    }
    get search() {
        return this.searchParams.toString();
    }
    set search(v) {
        this.searchParams = new URLSearchParams(v);
    }
    get collection() {
        return this.pathname.split('/').filter(Boolean)[0] || '';
    }
    set collection(v) {
        const parts = this.pathname.split('/').filter(Boolean);
        parts[0] = v;
        this.pathname = parts.join('/');
    }
    get rkey() {
        return this.pathname.split('/').filter(Boolean)[1] || '';
    }
    set rkey(v) {
        const parts = this.pathname.split('/').filter(Boolean);
        if (!parts[0]) parts[0] = 'undefined';
        parts[1] = v;
        this.pathname = parts.join('/');
    }
    get href() {
        return this.toString();
    }
    toString() {
        let path = this.pathname || '/';
        if (!path.startsWith('/')) path = `/${path}`;
        let qs = this.searchParams.toString();
        if (qs && !qs.startsWith('?')) qs = `?${qs}`;
        let hash = this.hash;
        if (hash && !hash.startsWith('#')) hash = `#${hash}`;
        return `at://${this.host}${path}${qs}${hash}`;
    }
}
exports.AtUri = AtUri;
function parse(str) {
    const match = exports.ATP_URI_REGEX.exec(str);
    if (match) return {
        hash: match[5] || '',
        host: match[2] || '',
        pathname: match[3] || '',
        searchParams: new URLSearchParams(match[4] || '')
    };
    return undefined;
}
function parseRelative(str) {
    const match = RELATIVE_REGEX.exec(str);
    if (match) return {
        hash: match[3] || '',
        pathname: match[1] || '',
        searchParams: new URLSearchParams(match[2] || '')
    };
    return undefined;
}

},{"93540ba32d792c8d":"iEtpa"}],"iEtpa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ensureValidAtUriRegex = exports.ensureValidAtUri = void 0;
const did_1 = require("ec82acc606ee2d9f");
const handle_1 = require("b551fda29521de7e");
const nsid_1 = require("ebbf7de3433c8378");
// Human-readable constraints on ATURI:
//   - following regular URLs, a 8KByte hard total length limit
//   - follows ATURI docs on website
//      - all ASCII characters, no whitespace. non-ASCII could be URL-encoded
//      - starts "at://"
//      - "authority" is a valid DID or a valid handle
//      - optionally, follow "authority" with "/" and valid NSID as start of path
//      - optionally, if NSID given, follow that with "/" and rkey
//      - rkey path component can include URL-encoded ("percent encoded"), or:
//          ALPHA / DIGIT / "-" / "." / "_" / "~" / ":" / "@" / "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
//          [a-zA-Z0-9._~:@!$&'\(\)*+,;=-]
//      - rkey must have at least one char
//      - regardless of path component, a fragment can follow  as "#" and then a JSON pointer (RFC-6901)
const ensureValidAtUri = (uri)=>{
    // JSON pointer is pretty different from rest of URI, so split that out first
    const uriParts = uri.split('#');
    if (uriParts.length > 2) throw new Error('ATURI can have at most one "#", separating fragment out');
    const fragmentPart = uriParts[1] || null;
    uri = uriParts[0];
    // check that all chars are boring ASCII
    if (!/^[a-zA-Z0-9._~:@!$&')(*+,;=%/-]*$/.test(uri)) throw new Error('Disallowed characters in ATURI (ASCII)');
    const parts = uri.split('/');
    if (parts.length >= 3 && (parts[0] !== 'at:' || parts[1].length !== 0)) throw new Error('ATURI must start with "at://"');
    if (parts.length < 3) throw new Error('ATURI requires at least method and authority sections');
    try {
        if (parts[2].startsWith('did:')) (0, did_1.ensureValidDid)(parts[2]);
        else (0, handle_1.ensureValidHandle)(parts[2]);
    } catch  {
        throw new Error('ATURI authority must be a valid handle or DID');
    }
    if (parts.length >= 4) {
        if (parts[3].length === 0) throw new Error('ATURI can not have a slash after authority without a path segment');
        if (!(0, nsid_1.isValidNsid)(parts[3])) throw new Error('ATURI requires first path segment (if supplied) to be valid NSID');
    }
    if (parts.length >= 5) {
        if (parts[4].length === 0) throw new Error('ATURI can not have a slash after collection, unless record key is provided');
    // would validate rkey here, but there are basically no constraints!
    }
    if (parts.length >= 6) throw new Error('ATURI path can have at most two parts, and no trailing slash');
    if (uriParts.length >= 2 && fragmentPart == null) throw new Error('ATURI fragment must be non-empty and start with slash');
    if (fragmentPart != null) {
        if (fragmentPart.length === 0 || fragmentPart[0] !== '/') throw new Error('ATURI fragment must be non-empty and start with slash');
        // NOTE: enforcing *some* checks here for sanity. Eg, at least no whitespace
        if (!/^\/[a-zA-Z0-9._~:@!$&')(*+,;=%[\]/-]*$/.test(fragmentPart)) throw new Error('Disallowed characters in ATURI fragment (ASCII)');
    }
    if (uri.length > 8192) throw new Error('ATURI is far too long');
};
exports.ensureValidAtUri = ensureValidAtUri;
const ensureValidAtUriRegex = (uri)=>{
    // simple regex to enforce most constraints via just regex and length.
    // hand wrote this regex based on above constraints. whew!
    const aturiRegex = /^at:\/\/(?<authority>[a-zA-Z0-9._:%-]+)(\/(?<collection>[a-zA-Z0-9-.]+)(\/(?<rkey>[a-zA-Z0-9._~:@!$&%')(*+,;=-]+))?)?(#(?<fragment>\/[a-zA-Z0-9._~:@!$&%')(*+,;=\-[\]/\\]*))?$/;
    const rm = uri.match(aturiRegex);
    if (!rm || !rm.groups) throw new Error("ATURI didn't validate via regex");
    const groups = rm.groups;
    try {
        (0, handle_1.ensureValidHandleRegex)(groups.authority);
    } catch  {
        try {
            (0, did_1.ensureValidDidRegex)(groups.authority);
        } catch  {
            throw new Error('ATURI authority must be a valid handle or DID');
        }
    }
    if (groups.collection && !(0, nsid_1.isValidNsid)(groups.collection)) throw new Error('ATURI collection path segment must be a valid NSID');
    if (uri.length > 8192) throw new Error('ATURI is far too long');
};
exports.ensureValidAtUriRegex = ensureValidAtUriRegex;

},{"ec82acc606ee2d9f":"9J6qD","b551fda29521de7e":"cpsuK","ebbf7de3433c8378":"1BDzc"}],"gUq0K":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidTidError = exports.isValidTid = exports.ensureValidTid = void 0;
const TID_LENGTH = 13;
const TID_REGEX = /^[234567abcdefghij][234567abcdefghijklmnopqrstuvwxyz]{12}$/;
const ensureValidTid = (tid)=>{
    if (tid.length !== TID_LENGTH) throw new InvalidTidError(`TID must be ${TID_LENGTH} characters`);
    // simple regex to enforce most constraints via just regex and length.
    if (!TID_REGEX.test(tid)) throw new InvalidTidError('TID syntax not valid (regex)');
};
exports.ensureValidTid = ensureValidTid;
const isValidTid = (tid)=>{
    return tid.length === TID_LENGTH && TID_REGEX.test(tid);
};
exports.isValidTid = isValidTid;
class InvalidTidError extends Error {
}
exports.InvalidTidError = InvalidTidError;

},{}],"7phNQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidRecordKeyError = exports.isValidRecordKey = exports.ensureValidRecordKey = void 0;
const ensureValidRecordKey = (rkey)=>{
    if (rkey.length > 512 || rkey.length < 1) throw new InvalidRecordKeyError('record key must be 1 to 512 characters');
    // simple regex to enforce most constraints via just regex and length.
    if (!/^[a-zA-Z0-9_~.:-]{1,512}$/.test(rkey)) throw new InvalidRecordKeyError('record key syntax not valid (regex)');
    if (rkey === '.' || rkey === '..') throw new InvalidRecordKeyError('record key can not be "." or ".."');
};
exports.ensureValidRecordKey = ensureValidRecordKey;
const isValidRecordKey = (rkey)=>{
    try {
        (0, exports.ensureValidRecordKey)(rkey);
    } catch (err) {
        if (err instanceof InvalidRecordKeyError) return false;
        throw err;
    }
    return true;
};
exports.isValidRecordKey = isValidRecordKey;
class InvalidRecordKeyError extends Error {
}
exports.InvalidRecordKeyError = InvalidRecordKeyError;

},{}],"gzTbL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidDatetimeError = exports.normalizeDatetimeAlways = exports.normalizeDatetime = exports.isValidDatetime = exports.ensureValidDatetime = void 0;
/* Validates datetime string against atproto Lexicon 'datetime' format.
 * Syntax is described at: https://atproto.com/specs/lexicon#datetime
 */ const ensureValidDatetime = (dtStr)=>{
    const date = new Date(dtStr);
    // must parse as ISO 8601; this also verifies semantics like month is not 13 or 00
    if (isNaN(date.getTime())) throw new InvalidDatetimeError('datetime did not parse as ISO 8601');
    if (date.toISOString().startsWith('-')) throw new InvalidDatetimeError('datetime normalized to a negative time');
    // regex and other checks for RFC-3339
    if (!/^[0-9]{4}-[01][0-9]-[0-3][0-9]T[0-2][0-9]:[0-6][0-9]:[0-6][0-9](.[0-9]{1,20})?(Z|([+-][0-2][0-9]:[0-5][0-9]))$/.test(dtStr)) throw new InvalidDatetimeError("datetime didn't validate via regex");
    if (dtStr.length > 64) throw new InvalidDatetimeError('datetime is too long (64 chars max)');
    if (dtStr.endsWith('-00:00')) throw new InvalidDatetimeError('datetime can not use "-00:00" for UTC timezone');
    if (dtStr.startsWith('000')) throw new InvalidDatetimeError('datetime so close to year zero not allowed');
};
exports.ensureValidDatetime = ensureValidDatetime;
/* Same logic as ensureValidDatetime(), but returns a boolean instead of throwing an exception.
 */ const isValidDatetime = (dtStr)=>{
    try {
        (0, exports.ensureValidDatetime)(dtStr);
    } catch (err) {
        if (err instanceof InvalidDatetimeError) return false;
        throw err;
    }
    return true;
};
exports.isValidDatetime = isValidDatetime;
/* Takes a flexible datetime string and normalizes representation.
 *
 * This function will work with any valid atproto datetime (eg, anything which isValidDatetime() is true for). It *additionally* is more flexible about accepting datetimes that don't comply to RFC 3339, or are missing timezone information, and normalizing them to a valid datetime.
 *
 * One use-case is a consistent, sortable string. Another is to work with older invalid createdAt datetimes.
 *
 * Successful output will be a valid atproto datetime with millisecond precision (3 sub-second digits) and UTC timezone with trailing 'Z' syntax. Throws `InvalidDatetimeError` if the input string could not be parsed as a datetime, even with permissive parsing.
 *
 * Expected output format: YYYY-MM-DDTHH:mm:ss.sssZ
 */ const normalizeDatetime = (dtStr)=>{
    if ((0, exports.isValidDatetime)(dtStr)) {
        const outStr = new Date(dtStr).toISOString();
        if ((0, exports.isValidDatetime)(outStr)) return outStr;
    }
    // check if this permissive datetime is missing a timezone
    if (!/.*(([+-]\d\d:?\d\d)|[a-zA-Z])$/.test(dtStr)) {
        const date = new Date(dtStr + 'Z');
        if (!isNaN(date.getTime())) {
            const tzStr = date.toISOString();
            if ((0, exports.isValidDatetime)(tzStr)) return tzStr;
        }
    }
    // finally try parsing as simple datetime
    const date = new Date(dtStr);
    if (isNaN(date.getTime())) throw new InvalidDatetimeError('datetime did not parse as any timestamp format');
    const isoStr = date.toISOString();
    if ((0, exports.isValidDatetime)(isoStr)) return isoStr;
    else throw new InvalidDatetimeError('datetime normalized to invalid timestamp string');
};
exports.normalizeDatetime = normalizeDatetime;
/* Variant of normalizeDatetime() which always returns a valid datetime strings.
 *
 * If a InvalidDatetimeError is encountered, returns the UNIX epoch time as a UTC datetime (1970-01-01T00:00:00.000Z).
 */ const normalizeDatetimeAlways = (dtStr)=>{
    try {
        return (0, exports.normalizeDatetime)(dtStr);
    } catch (err) {
        if (err instanceof InvalidDatetimeError) return new Date(0).toISOString();
        throw err;
    }
};
exports.normalizeDatetimeAlways = normalizeDatetimeAlways;
/* Indicates a datetime string did not pass full atproto Lexicon datetime string format checks.
 */ class InvalidDatetimeError extends Error {
}
exports.InvalidDatetimeError = InvalidDatetimeError;

},{}],"50xw2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toLexUri = toLexUri;
exports.requiredPropertiesRefinement = requiredPropertiesRefinement;
const zod_1 = require("ae8ab09fcc63658b");
function toLexUri(str, baseUri) {
    if (str.split('#').length > 2) throw new Error('Uri can only have one hash segment');
    if (str.startsWith('lex:')) return str;
    if (str.startsWith('#')) {
        if (!baseUri) throw new Error(`Unable to resolve uri without anchor: ${str}`);
        return `${baseUri}${str}`;
    }
    return `lex:${str}`;
}
function requiredPropertiesRefinement(object, ctx) {
    // Required fields check
    if (object.required === undefined) return;
    if (!Array.isArray(object.required)) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.invalid_type,
            received: typeof object.required,
            expected: 'array'
        });
        return;
    }
    if (object.properties === undefined) {
        if (object.required.length > 0) ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: `Required fields defined but no properties defined`
        });
        return;
    }
    for (const field of object.required)if (object.properties[field] === undefined) ctx.addIssue({
        code: zod_1.z.ZodIssueCode.custom,
        message: `Required field "${field}" not defined`
    });
}

},{"ae8ab09fcc63658b":"h1sGN"}],"8VTD8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Lexicons = void 0;
const types_1 = require("c14dc33eb7c00ac7");
const util_1 = require("a558f7b1d129778");
const validation_1 = require("32b0b48e4aeb6b65");
const complex_1 = require("1422055c3579fcf9");
/**
 * A collection of compiled lexicons.
 */ class Lexicons {
    constructor(docs){
        Object.defineProperty(this, "docs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "defs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        if (docs) for (const doc of docs)this.add(doc);
    }
    /**
     * @example clone a lexicon:
     * ```ts
     * const clone = new Lexicons(originalLexicon)
     * ```
     *
     * @example get docs array:
     * ```ts
     * const docs = Array.from(lexicons)
     * ```
     */ [Symbol.iterator]() {
        return this.docs.values();
    }
    /**
     * Add a lexicon doc.
     */ add(doc) {
        const uri = (0, util_1.toLexUri)(doc.id);
        if (this.docs.has(uri)) throw new Error(`${uri} has already been registered`);
        // WARNING
        // mutates the object
        // -prf
        resolveRefUris(doc, uri);
        this.docs.set(uri, doc);
        for (const [defUri, def] of iterDefs(doc))this.defs.set(defUri, def);
    }
    /**
     * Remove a lexicon doc.
     */ remove(uri) {
        uri = (0, util_1.toLexUri)(uri);
        const doc = this.docs.get(uri);
        if (!doc) throw new Error(`Unable to remove "${uri}": does not exist`);
        for (const [defUri, _def] of iterDefs(doc))this.defs.delete(defUri);
        this.docs.delete(uri);
    }
    /**
     * Get a lexicon doc.
     */ get(uri) {
        uri = (0, util_1.toLexUri)(uri);
        return this.docs.get(uri);
    }
    /**
     * Get a definition.
     */ getDef(uri) {
        uri = (0, util_1.toLexUri)(uri);
        return this.defs.get(uri);
    }
    getDefOrThrow(uri, types) {
        const def = this.getDef(uri);
        if (!def) throw new types_1.LexiconDefNotFoundError(`Lexicon not found: ${uri}`);
        if (types && !types.includes(def.type)) throw new types_1.InvalidLexiconError(`Not a ${types.join(' or ')} lexicon: ${uri}`);
        return def;
    }
    /**
     * Validate a record or object.
     */ validate(lexUri, value) {
        if (!(0, types_1.isObj)(value)) throw new types_1.ValidationError(`Value must be an object`);
        const lexUriNormalized = (0, util_1.toLexUri)(lexUri);
        const def = this.getDefOrThrow(lexUriNormalized, [
            'record',
            'object'
        ]);
        if (def.type === 'record') return (0, complex_1.object)(this, 'Record', def.record, value);
        else if (def.type === 'object') return (0, complex_1.object)(this, 'Object', def, value);
        else // shouldn't happen
        throw new types_1.InvalidLexiconError('Definition must be a record or object');
    }
    /**
     * Validate a record and throw on any error.
     */ assertValidRecord(lexUri, value) {
        if (!(0, types_1.isObj)(value)) throw new types_1.ValidationError(`Record must be an object`);
        if (!('$type' in value)) throw new types_1.ValidationError(`Record/$type must be a string`);
        const { $type } = value;
        if (typeof $type !== 'string') throw new types_1.ValidationError(`Record/$type must be a string`);
        const lexUriNormalized = (0, util_1.toLexUri)(lexUri);
        if ((0, util_1.toLexUri)($type) !== lexUriNormalized) throw new types_1.ValidationError(`Invalid $type: must be ${lexUriNormalized}, got ${$type}`);
        const def = this.getDefOrThrow(lexUriNormalized, [
            'record'
        ]);
        return (0, validation_1.assertValidRecord)(this, def, value);
    }
    /**
     * Validate xrpc query params and throw on any error.
     */ assertValidXrpcParams(lexUri, value) {
        lexUri = (0, util_1.toLexUri)(lexUri);
        const def = this.getDefOrThrow(lexUri, [
            'query',
            'procedure',
            'subscription'
        ]);
        return (0, validation_1.assertValidXrpcParams)(this, def, value);
    }
    /**
     * Validate xrpc input body and throw on any error.
     */ assertValidXrpcInput(lexUri, value) {
        lexUri = (0, util_1.toLexUri)(lexUri);
        const def = this.getDefOrThrow(lexUri, [
            'procedure'
        ]);
        return (0, validation_1.assertValidXrpcInput)(this, def, value);
    }
    /**
     * Validate xrpc output body and throw on any error.
     */ assertValidXrpcOutput(lexUri, value) {
        lexUri = (0, util_1.toLexUri)(lexUri);
        const def = this.getDefOrThrow(lexUri, [
            'query',
            'procedure'
        ]);
        return (0, validation_1.assertValidXrpcOutput)(this, def, value);
    }
    /**
     * Validate xrpc subscription message and throw on any error.
     */ assertValidXrpcMessage(lexUri, value) {
        lexUri = (0, util_1.toLexUri)(lexUri);
        const def = this.getDefOrThrow(lexUri, [
            'subscription'
        ]);
        return (0, validation_1.assertValidXrpcMessage)(this, def, value);
    }
    /**
     * Resolve a lex uri given a ref
     */ resolveLexUri(lexUri, ref) {
        lexUri = (0, util_1.toLexUri)(lexUri);
        return (0, util_1.toLexUri)(ref, lexUri);
    }
}
exports.Lexicons = Lexicons;
function* iterDefs(doc) {
    for(const defId in doc.defs){
        yield [
            `lex:${doc.id}#${defId}`,
            doc.defs[defId]
        ];
        if (defId === 'main') yield [
            `lex:${doc.id}`,
            doc.defs[defId]
        ];
    }
}
// WARNING
// this method mutates objects
// -prf
function resolveRefUris(obj, baseUri) {
    for(const k in obj){
        if (obj.type === 'ref') obj.ref = (0, util_1.toLexUri)(obj.ref, baseUri);
        else if (obj.type === 'union') obj.refs = obj.refs.map((ref)=>(0, util_1.toLexUri)(ref, baseUri));
        else if (Array.isArray(obj[k])) obj[k] = obj[k].map((item)=>{
            if (typeof item === 'string') return item.startsWith('#') ? (0, util_1.toLexUri)(item, baseUri) : item;
            else if (item && typeof item === 'object') return resolveRefUris(item, baseUri);
            return item;
        });
        else if (obj[k] && typeof obj[k] === 'object') obj[k] = resolveRefUris(obj[k], baseUri);
    }
    return obj;
}

},{"c14dc33eb7c00ac7":"gxvCL","a558f7b1d129778":"50xw2","32b0b48e4aeb6b65":"25YGi","1422055c3579fcf9":"1EMiu"}],"25YGi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.assertValidRecord = assertValidRecord;
exports.assertValidXrpcParams = assertValidXrpcParams;
exports.assertValidXrpcInput = assertValidXrpcInput;
exports.assertValidXrpcOutput = assertValidXrpcOutput;
exports.assertValidXrpcMessage = assertValidXrpcMessage;
const complex_1 = require("eaf80f10f93c2ea1");
const xrpc_1 = require("4fa0ede9de38d695");
function assertValidRecord(lexicons, def, value) {
    const res = (0, complex_1.object)(lexicons, 'Record', def.record, value);
    if (!res.success) throw res.error;
    return res.value;
}
function assertValidXrpcParams(lexicons, def, value) {
    if (def.parameters) {
        const res = (0, xrpc_1.params)(lexicons, 'Params', def.parameters, value);
        if (!res.success) throw res.error;
        return res.value;
    }
}
function assertValidXrpcInput(lexicons, def, value) {
    if (def.input?.schema) // loop: all input schema definitions
    return assertValidOneOf(lexicons, 'Input', def.input.schema, value, true);
}
function assertValidXrpcOutput(lexicons, def, value) {
    if (def.output?.schema) // loop: all output schema definitions
    return assertValidOneOf(lexicons, 'Output', def.output.schema, value, true);
}
function assertValidXrpcMessage(lexicons, def, value) {
    if (def.message?.schema) // loop: all output schema definitions
    return assertValidOneOf(lexicons, 'Message', def.message.schema, value, true);
}
function assertValidOneOf(lexicons, path, def, value, mustBeObj = false) {
    const res = (0, complex_1.validateOneOf)(lexicons, path, def, value, mustBeObj);
    if (!res.success) throw res.error;
    return res.value;
}

},{"eaf80f10f93c2ea1":"1EMiu","4fa0ede9de38d695":"3wun7"}],"1EMiu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validate = validate;
exports.array = array;
exports.object = object;
exports.validateOneOf = validateOneOf;
const types_1 = require("5ee1e932a40c9bf6");
const util_1 = require("481377c8ee15be6c");
const blob_1 = require("e2ac68c584b1c027");
const primitives_1 = require("e8cd7843c97b8f45");
function validate(lexicons, path, def, value) {
    switch(def.type){
        case 'object':
            return object(lexicons, path, def, value);
        case 'array':
            return array(lexicons, path, def, value);
        case 'blob':
            return (0, blob_1.blob)(lexicons, path, def, value);
        default:
            return (0, primitives_1.validate)(lexicons, path, def, value);
    }
}
function array(lexicons, path, def, value) {
    // type
    if (!Array.isArray(value)) return {
        success: false,
        error: new types_1.ValidationError(`${path} must be an array`)
    };
    // maxLength
    if (typeof def.maxLength === 'number') {
        if (value.length > def.maxLength) return {
            success: false,
            error: new types_1.ValidationError(`${path} must not have more than ${def.maxLength} elements`)
        };
    }
    // minLength
    if (typeof def.minLength === 'number') {
        if (value.length < def.minLength) return {
            success: false,
            error: new types_1.ValidationError(`${path} must not have fewer than ${def.minLength} elements`)
        };
    }
    // items
    const itemsDef = def.items;
    for(let i = 0; i < value.length; i++){
        const itemValue = value[i];
        const itemPath = `${path}/${i}`;
        const res = validateOneOf(lexicons, itemPath, itemsDef, itemValue);
        if (!res.success) return res;
    }
    return {
        success: true,
        value
    };
}
function object(lexicons, path, def, value) {
    // type
    if (!(0, types_1.isObj)(value)) return {
        success: false,
        error: new types_1.ValidationError(`${path} must be an object`)
    };
    // properties
    let resultValue = value;
    if ('properties' in def && def.properties != null) for(const key in def.properties){
        const keyValue = value[key];
        if (keyValue === null && def.nullable?.includes(key)) continue;
        const propDef = def.properties[key];
        if (keyValue === undefined && !def.required?.includes(key)) {
            // Fast path for non-required undefined props.
            if (propDef.type === 'integer' || propDef.type === 'boolean' || propDef.type === 'string') {
                if (propDef.default === undefined) continue;
            } else continue;
        }
        const propPath = `${path}/${key}`;
        const validated = validateOneOf(lexicons, propPath, propDef, keyValue);
        const propValue = validated.success ? validated.value : keyValue;
        // Return error for bad validation, giving required rule precedence
        if (propValue === undefined) {
            if (def.required?.includes(key)) return {
                success: false,
                error: new types_1.ValidationError(`${path} must have the property "${key}"`)
            };
        } else {
            if (!validated.success) return validated;
        }
        // Adjust value based on e.g. applied defaults, cloning shallowly if there was a changed value
        if (propValue !== keyValue) {
            if (resultValue === value) // Lazy shallow clone
            resultValue = {
                ...value
            };
            resultValue[key] = propValue;
        }
    }
    return {
        success: true,
        value: resultValue
    };
}
function validateOneOf(lexicons, path, def, value, mustBeObj = false) {
    let concreteDef;
    if (def.type === 'union') {
        if (!(0, types_1.isDiscriminatedObject)(value)) return {
            success: false,
            error: new types_1.ValidationError(`${path} must be an object which includes the "$type" property`)
        };
        if (!refsContainType(def.refs, value.$type)) {
            if (def.closed) return {
                success: false,
                error: new types_1.ValidationError(`${path} $type must be one of ${def.refs.join(', ')}`)
            };
            return {
                success: true,
                value
            };
        } else concreteDef = lexicons.getDefOrThrow(value.$type);
    } else if (def.type === 'ref') concreteDef = lexicons.getDefOrThrow(def.ref);
    else concreteDef = def;
    return mustBeObj ? object(lexicons, path, concreteDef, value) : validate(lexicons, path, concreteDef, value);
}
// to avoid bugs like #0189 this needs to handle both
// explicit and implicit #main
const refsContainType = (refs, type)=>{
    const lexUri = (0, util_1.toLexUri)(type);
    if (refs.includes(lexUri)) return true;
    if (lexUri.endsWith('#main')) return refs.includes(lexUri.slice(0, -5));
    else return !lexUri.includes('#') && refs.includes(`${lexUri}#main`);
};

},{"5ee1e932a40c9bf6":"gxvCL","481377c8ee15be6c":"50xw2","e2ac68c584b1c027":"dIZCh","e8cd7843c97b8f45":"iPyKo"}],"dIZCh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.blob = blob;
const blob_refs_1 = require("1ed2b76b6a663d71");
const types_1 = require("3c0b70897e191547");
function blob(lexicons, path, def, value) {
    // check
    if (!value || !(value instanceof blob_refs_1.BlobRef)) return {
        success: false,
        error: new types_1.ValidationError(`${path} should be a blob ref`)
    };
    return {
        success: true,
        value
    };
}

},{"1ed2b76b6a663d71":"1Sm2X","3c0b70897e191547":"gxvCL"}],"1Sm2X":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BlobRef = exports.jsonBlobRef = exports.untypedJsonBlobRef = exports.typedJsonBlobRef = void 0;
const cid_1 = require("e3e236e1cc4e6382");
const zod_1 = require("f531a2b64137ce40");
const common_web_1 = require("5938830a603bd164");
exports.typedJsonBlobRef = zod_1.z.object({
    $type: zod_1.z.literal('blob'),
    ref: common_web_1.schema.cid,
    mimeType: zod_1.z.string(),
    size: zod_1.z.number()
}).strict();
exports.untypedJsonBlobRef = zod_1.z.object({
    cid: zod_1.z.string(),
    mimeType: zod_1.z.string()
}).strict();
exports.jsonBlobRef = zod_1.z.union([
    exports.typedJsonBlobRef,
    exports.untypedJsonBlobRef
]);
class BlobRef {
    constructor(ref, mimeType, size, original){
        Object.defineProperty(this, "ref", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ref
        });
        Object.defineProperty(this, "mimeType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: mimeType
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: size
        });
        Object.defineProperty(this, "original", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.original = original ?? {
            $type: 'blob',
            ref,
            mimeType,
            size
        };
    }
    static asBlobRef(obj) {
        if (common_web_1.check.is(obj, exports.jsonBlobRef)) return BlobRef.fromJsonRef(obj);
        return null;
    }
    static fromJsonRef(json) {
        if (common_web_1.check.is(json, exports.typedJsonBlobRef)) return new BlobRef(json.ref, json.mimeType, json.size);
        else return new BlobRef(cid_1.CID.parse(json.cid), json.mimeType, -1, json);
    }
    ipld() {
        return {
            $type: 'blob',
            ref: this.ref,
            mimeType: this.mimeType,
            size: this.size
        };
    }
    toJSON() {
        return (0, common_web_1.ipldToJson)(this.ipld());
    }
}
exports.BlobRef = BlobRef;

},{"e3e236e1cc4e6382":"7UJVD","f531a2b64137ce40":"h1sGN","5938830a603bd164":"jDe1t"}],"iPyKo":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
        }
        __setModuleDefault(result, mod);
        return result;
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validate = validate;
const cid_1 = require("895f8a26aeb61b55");
const common_web_1 = require("3a4c22b0754d3e83");
const types_1 = require("5b5a8b00c4c22def");
const formats = __importStar(require("a2b62fabba1e0fd6"));
function validate(lexicons, path, def, value) {
    switch(def.type){
        case 'boolean':
            return boolean(lexicons, path, def, value);
        case 'integer':
            return integer(lexicons, path, def, value);
        case 'string':
            return string(lexicons, path, def, value);
        case 'bytes':
            return bytes(lexicons, path, def, value);
        case 'cid-link':
            return cidLink(lexicons, path, def, value);
        case 'unknown':
            return unknown(lexicons, path, def, value);
        default:
            return {
                success: false,
                error: new types_1.ValidationError(`Unexpected lexicon type: ${def.type}`)
            };
    }
}
function boolean(lexicons, path, def, value) {
    def;
    // type
    const type = typeof value;
    if (type === 'undefined') {
        if (typeof def.default === 'boolean') return {
            success: true,
            value: def.default
        };
        return {
            success: false,
            error: new types_1.ValidationError(`${path} must be a boolean`)
        };
    } else if (type !== 'boolean') return {
        success: false,
        error: new types_1.ValidationError(`${path} must be a boolean`)
    };
    // const
    if (typeof def.const === 'boolean') {
        if (value !== def.const) return {
            success: false,
            error: new types_1.ValidationError(`${path} must be ${def.const}`)
        };
    }
    return {
        success: true,
        value
    };
}
function integer(lexicons, path, def, value) {
    def;
    // type
    const type = typeof value;
    if (type === 'undefined') {
        if (typeof def.default === 'number') return {
            success: true,
            value: def.default
        };
        return {
            success: false,
            error: new types_1.ValidationError(`${path} must be an integer`)
        };
    } else if (!Number.isInteger(value)) return {
        success: false,
        error: new types_1.ValidationError(`${path} must be an integer`)
    };
    // const
    if (typeof def.const === 'number') {
        if (value !== def.const) return {
            success: false,
            error: new types_1.ValidationError(`${path} must be ${def.const}`)
        };
    }
    // enum
    if (Array.isArray(def.enum)) {
        if (!def.enum.includes(value)) return {
            success: false,
            error: new types_1.ValidationError(`${path} must be one of (${def.enum.join('|')})`)
        };
    }
    // maximum
    if (typeof def.maximum === 'number') {
        if (value > def.maximum) return {
            success: false,
            error: new types_1.ValidationError(`${path} can not be greater than ${def.maximum}`)
        };
    }
    // minimum
    if (typeof def.minimum === 'number') {
        if (value < def.minimum) return {
            success: false,
            error: new types_1.ValidationError(`${path} can not be less than ${def.minimum}`)
        };
    }
    return {
        success: true,
        value
    };
}
function string(lexicons, path, def, value) {
    def;
    // type
    if (typeof value === 'undefined') {
        if (typeof def.default === 'string') return {
            success: true,
            value: def.default
        };
        return {
            success: false,
            error: new types_1.ValidationError(`${path} must be a string`)
        };
    } else if (typeof value !== 'string') return {
        success: false,
        error: new types_1.ValidationError(`${path} must be a string`)
    };
    // const
    if (typeof def.const === 'string') {
        if (value !== def.const) return {
            success: false,
            error: new types_1.ValidationError(`${path} must be ${def.const}`)
        };
    }
    // enum
    if (Array.isArray(def.enum)) {
        if (!def.enum.includes(value)) return {
            success: false,
            error: new types_1.ValidationError(`${path} must be one of (${def.enum.join('|')})`)
        };
    }
    // maxLength and minLength
    if (typeof def.minLength === 'number' || typeof def.maxLength === 'number') {
        // If the JavaScript string length * 3 is below the maximum limit,
        // its UTF8 length (which <= .length * 3) will also be below.
        if (typeof def.minLength === 'number' && value.length * 3 < def.minLength) return {
            success: false,
            error: new types_1.ValidationError(`${path} must not be shorter than ${def.minLength} characters`)
        };
        // If the JavaScript string length * 3 is within the maximum limit,
        // its UTF8 length (which <= .length * 3) will also be within.
        // When there's no minimal length, this lets us skip the UTF8 length check.
        let canSkipUtf8LenChecks = false;
        if (typeof def.minLength === 'undefined' && typeof def.maxLength === 'number' && value.length * 3 <= def.maxLength) canSkipUtf8LenChecks = true;
        if (!canSkipUtf8LenChecks) {
            const len = (0, common_web_1.utf8Len)(value);
            if (typeof def.maxLength === 'number') {
                if (len > def.maxLength) return {
                    success: false,
                    error: new types_1.ValidationError(`${path} must not be longer than ${def.maxLength} characters`)
                };
            }
            if (typeof def.minLength === 'number') {
                if (len < def.minLength) return {
                    success: false,
                    error: new types_1.ValidationError(`${path} must not be shorter than ${def.minLength} characters`)
                };
            }
        }
    }
    // maxGraphemes and minGraphemes
    if (typeof def.maxGraphemes === 'number' || typeof def.minGraphemes === 'number') {
        let needsMaxGraphemesCheck = false;
        let needsMinGraphemesCheck = false;
        if (typeof def.maxGraphemes === 'number') {
            if (value.length <= def.maxGraphemes) // If the JavaScript string length (UTF-16) is within the maximum limit,
            // its grapheme length (which <= .length) will also be within.
            needsMaxGraphemesCheck = false;
            else needsMaxGraphemesCheck = true;
        }
        if (typeof def.minGraphemes === 'number') {
            if (value.length < def.minGraphemes) // If the JavaScript string length (UTF-16) is below the minimal limit,
            // its grapheme length (which <= .length) will also be below.
            // Fail early.
            return {
                success: false,
                error: new types_1.ValidationError(`${path} must not be shorter than ${def.minGraphemes} graphemes`)
            };
            else needsMinGraphemesCheck = true;
        }
        if (needsMaxGraphemesCheck || needsMinGraphemesCheck) {
            const len = (0, common_web_1.graphemeLen)(value);
            if (typeof def.maxGraphemes === 'number') {
                if (len > def.maxGraphemes) return {
                    success: false,
                    error: new types_1.ValidationError(`${path} must not be longer than ${def.maxGraphemes} graphemes`)
                };
            }
            if (typeof def.minGraphemes === 'number') {
                if (len < def.minGraphemes) return {
                    success: false,
                    error: new types_1.ValidationError(`${path} must not be shorter than ${def.minGraphemes} graphemes`)
                };
            }
        }
    }
    if (typeof def.format === 'string') switch(def.format){
        case 'datetime':
            return formats.datetime(path, value);
        case 'uri':
            return formats.uri(path, value);
        case 'at-uri':
            return formats.atUri(path, value);
        case 'did':
            return formats.did(path, value);
        case 'handle':
            return formats.handle(path, value);
        case 'at-identifier':
            return formats.atIdentifier(path, value);
        case 'nsid':
            return formats.nsid(path, value);
        case 'cid':
            return formats.cid(path, value);
        case 'language':
            return formats.language(path, value);
        case 'tid':
            return formats.tid(path, value);
        case 'record-key':
            return formats.recordKey(path, value);
    }
    return {
        success: true,
        value
    };
}
function bytes(lexicons, path, def, value) {
    def;
    if (!value || !(value instanceof Uint8Array)) return {
        success: false,
        error: new types_1.ValidationError(`${path} must be a byte array`)
    };
    // maxLength
    if (typeof def.maxLength === 'number') {
        if (value.byteLength > def.maxLength) return {
            success: false,
            error: new types_1.ValidationError(`${path} must not be larger than ${def.maxLength} bytes`)
        };
    }
    // minLength
    if (typeof def.minLength === 'number') {
        if (value.byteLength < def.minLength) return {
            success: false,
            error: new types_1.ValidationError(`${path} must not be smaller than ${def.minLength} bytes`)
        };
    }
    return {
        success: true,
        value
    };
}
function cidLink(lexicons, path, def, value) {
    if (cid_1.CID.asCID(value) === null) return {
        success: false,
        error: new types_1.ValidationError(`${path} must be a CID`)
    };
    return {
        success: true,
        value
    };
}
function unknown(lexicons, path, def, value) {
    // type
    if (!value || typeof value !== 'object') return {
        success: false,
        error: new types_1.ValidationError(`${path} must be an object`)
    };
    return {
        success: true,
        value
    };
}

},{"895f8a26aeb61b55":"7UJVD","3a4c22b0754d3e83":"jDe1t","5b5a8b00c4c22def":"gxvCL","a2b62fabba1e0fd6":"hke3s"}],"hke3s":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.datetime = datetime;
exports.uri = uri;
exports.atUri = atUri;
exports.did = did;
exports.handle = handle;
exports.atIdentifier = atIdentifier;
exports.nsid = nsid;
exports.cid = cid;
exports.language = language;
exports.tid = tid;
exports.recordKey = recordKey;
const iso_datestring_validator_1 = require("adb93254b428a2f2");
const cid_1 = require("4f8f4be09f871892");
const common_web_1 = require("4ae27c8e0cf407b3");
const syntax_1 = require("dfec76d7cb2649c");
const types_1 = require("498de0ad05cd2");
function datetime(path, value) {
    try {
        if (!(0, iso_datestring_validator_1.isValidISODateString)(value)) throw new Error();
    } catch  {
        return {
            success: false,
            error: new types_1.ValidationError(`${path} must be an valid atproto datetime (both RFC-3339 and ISO-8601)`)
        };
    }
    return {
        success: true,
        value
    };
}
function uri(path, value) {
    const isUri = value.match(/^\w+:(?:\/\/)?[^\s/][^\s]*$/) !== null;
    if (!isUri) return {
        success: false,
        error: new types_1.ValidationError(`${path} must be a uri`)
    };
    return {
        success: true,
        value
    };
}
function atUri(path, value) {
    try {
        (0, syntax_1.ensureValidAtUri)(value);
    } catch  {
        return {
            success: false,
            error: new types_1.ValidationError(`${path} must be a valid at-uri`)
        };
    }
    return {
        success: true,
        value
    };
}
function did(path, value) {
    try {
        (0, syntax_1.ensureValidDid)(value);
    } catch  {
        return {
            success: false,
            error: new types_1.ValidationError(`${path} must be a valid did`)
        };
    }
    return {
        success: true,
        value
    };
}
function handle(path, value) {
    try {
        (0, syntax_1.ensureValidHandle)(value);
    } catch  {
        return {
            success: false,
            error: new types_1.ValidationError(`${path} must be a valid handle`)
        };
    }
    return {
        success: true,
        value
    };
}
function atIdentifier(path, value) {
    // We can discriminate based on the "did:" prefix
    if (value.startsWith('did:')) {
        const didResult = did(path, value);
        if (didResult.success) return didResult;
    } else {
        const handleResult = handle(path, value);
        if (handleResult.success) return handleResult;
    }
    return {
        success: false,
        error: new types_1.ValidationError(`${path} must be a valid did or a handle`)
    };
}
function nsid(path, value) {
    if ((0, syntax_1.isValidNsid)(value)) return {
        success: true,
        value
    };
    else return {
        success: false,
        error: new types_1.ValidationError(`${path} must be a valid nsid`)
    };
}
function cid(path, value) {
    try {
        cid_1.CID.parse(value);
    } catch  {
        return {
            success: false,
            error: new types_1.ValidationError(`${path} must be a cid string`)
        };
    }
    return {
        success: true,
        value
    };
}
// The language format validates well-formed BCP 47 language tags: https://www.rfc-editor.org/info/bcp47
function language(path, value) {
    if ((0, common_web_1.validateLanguage)(value)) return {
        success: true,
        value
    };
    return {
        success: false,
        error: new types_1.ValidationError(`${path} must be a well-formed BCP 47 language tag`)
    };
}
function tid(path, value) {
    if ((0, syntax_1.isValidTid)(value)) return {
        success: true,
        value
    };
    return {
        success: false,
        error: new types_1.ValidationError(`${path} must be a valid TID`)
    };
}
function recordKey(path, value) {
    try {
        (0, syntax_1.ensureValidRecordKey)(value);
    } catch  {
        return {
            success: false,
            error: new types_1.ValidationError(`${path} must be a valid Record Key`)
        };
    }
    return {
        success: true,
        value
    };
}

},{"adb93254b428a2f2":"hg62o","4f8f4be09f871892":"7UJVD","4ae27c8e0cf407b3":"jDe1t","dfec76d7cb2649c":"dBffO","498de0ad05cd2":"gxvCL"}],"hg62o":[function(require,module,exports,__globalThis) {
(()=>{
    "use strict";
    var e = {
        d: (t, r)=>{
            for(var n in r)e.o(r, n) && !e.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: r[n]
            });
        },
        o: (e, t)=>Object.prototype.hasOwnProperty.call(e, t),
        r: (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }
    }, t = {};
    function r(e, t) {
        return void 0 === t && (t = "-"), new RegExp("^(?!0{4}" + t + "0{2}" + t + "0{2})((?=[0-9]{4}" + t + "(((0[^2])|1[0-2])|02(?=" + t + "(([0-1][0-9])|2[0-8])))" + t + "[0-9]{2})|(?=((([13579][26])|([2468][048])|(0[48]))0{2})|([0-9]{2}((((0|[2468])[48])|[2468][048])|([13579][26])))" + t + "02" + t + "29))([0-9]{4})" + t + "(?!((0[469])|11)" + t + "31)((0[1,3-9]|1[0-2])|(02(?!" + t + "3)))" + t + "(0[1-9]|[1-2][0-9]|3[0-1])$").test(e);
    }
    function n(e) {
        var t = /\D/.exec(e);
        return t ? t[0] : "";
    }
    function i(e, t, r) {
        void 0 === t && (t = ":"), void 0 === r && (r = !1);
        var i = new RegExp("^([0-1]|2(?=([0-3])|4" + t + "00))[0-9]" + t + "[0-5][0-9](" + t + "([0-5]|6(?=0))[0-9])?(.[0-9]{1,9})?$");
        if (!r || !/[Z+\-]/.test(e)) return i.test(e);
        if (/Z$/.test(e)) return i.test(e.replace("Z", ""));
        var o = e.includes("+"), a = e.split(/[+-]/), u = a[0], d = a[1];
        return i.test(u) && function(e, t, r) {
            return void 0 === r && (r = ":"), new RegExp(t ? "^(0(?!(2" + r + "4)|0" + r + "3)|1(?=([0-1]|2(?=" + r + "[04])|[34](?=" + r + "0))))([03469](?=" + r + "[03])|[17](?=" + r + "0)|2(?=" + r + "[04])|5(?=" + r + "[034])|8(?=" + r + "[04]))" + r + "([03](?=0)|4(?=5))[05]$" : "^(0(?=[^0])|1(?=[0-2]))([39](?=" + r + "[03])|[0-24-8](?=" + r + "00))" + r + "[03]0$").test(e);
        }(d, o, n(d));
    }
    function o(e) {
        var t = e.split("T"), o = t[0], a = t[1], u = r(o, n(o));
        if (!a) return !1;
        var d, s = (d = a.match(/([^Z+\-\d])(?=\d+\1)/), Array.isArray(d) ? d[0] : "");
        return u && i(a, s, !0);
    }
    function a(e, t) {
        return void 0 === t && (t = "-"), new RegExp("^[0-9]{4}" + t + "(0(?=[^0])|1(?=[0-2]))[0-9]$").test(e);
    }
    e.r(t), e.d(t, {
        isValidDate: ()=>r,
        isValidISODateString: ()=>o,
        isValidTime: ()=>i,
        isValidYearMonth: ()=>a
    });
    var u = exports;
    for(var d in t)u[d] = t[d];
    t.__esModule && Object.defineProperty(u, "__esModule", {
        value: !0
    });
})();

},{}],"3wun7":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
        }
        __setModuleDefault(result, mod);
        return result;
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.params = params;
const types_1 = require("26ed93e130469408");
const complex_1 = require("643c51d729bf764d");
const PrimitiveValidators = __importStar(require("3206aad9d72c2ead"));
function params(lexicons, path, def, val) {
    // type
    const value = val && typeof val === 'object' ? val : {};
    const requiredProps = new Set(def.required ?? []);
    // properties
    let resultValue = value;
    if (typeof def.properties === 'object') for(const key in def.properties){
        const propDef = def.properties[key];
        const validated = propDef.type === 'array' ? (0, complex_1.array)(lexicons, key, propDef, value[key]) : PrimitiveValidators.validate(lexicons, key, propDef, value[key]);
        const propValue = validated.success ? validated.value : value[key];
        const propIsUndefined = typeof propValue === 'undefined';
        // Return error for bad validation, giving required rule precedence
        if (propIsUndefined && requiredProps.has(key)) return {
            success: false,
            error: new types_1.ValidationError(`${path} must have the property "${key}"`)
        };
        else if (!propIsUndefined && !validated.success) return validated;
        // Adjust value based on e.g. applied defaults, cloning shallowly if there was a changed value
        if (propValue !== value[key]) {
            if (resultValue === value) // Lazy shallow clone
            resultValue = {
                ...value
            };
            resultValue[key] = propValue;
        }
    }
    return {
        success: true,
        value: resultValue
    };
}

},{"26ed93e130469408":"gxvCL","643c51d729bf764d":"1EMiu","3206aad9d72c2ead":"iPyKo"}],"hkNaH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.jsonStringToLex = exports.jsonToLex = exports.stringifyLex = exports.lexToJson = exports.ipldToLex = exports.lexToIpld = void 0;
const cid_1 = require("c58548401484207d");
const common_web_1 = require("95ed3e8448994260");
const blob_refs_1 = require("d77d79b3b2b33496");
// @NOTE avoiding use of check.is() here only because it makes
// these implementations slow, and they often live in hot paths.
const lexToIpld = (val)=>{
    // walk arrays
    if (Array.isArray(val)) return val.map((item)=>(0, exports.lexToIpld)(item));
    // objects
    if (val && typeof val === 'object') {
        // convert blobs, leaving the original encoding so that we don't change CIDs on re-encode
        if (val instanceof blob_refs_1.BlobRef) return val.original;
        // retain cids & bytes
        if (cid_1.CID.asCID(val) || val instanceof Uint8Array) return val;
        // walk plain objects
        const toReturn = {};
        for (const key of Object.keys(val))toReturn[key] = (0, exports.lexToIpld)(val[key]);
        return toReturn;
    }
    // pass through
    return val;
};
exports.lexToIpld = lexToIpld;
const ipldToLex = (val)=>{
    // map arrays
    if (Array.isArray(val)) return val.map((item)=>(0, exports.ipldToLex)(item));
    // objects
    if (val && typeof val === 'object') {
        // convert blobs, using hints to avoid expensive is() check
        if ((val['$type'] === 'blob' || typeof val['cid'] === 'string' && typeof val['mimeType'] === 'string') && common_web_1.check.is(val, blob_refs_1.jsonBlobRef)) return blob_refs_1.BlobRef.fromJsonRef(val);
        // retain cids, bytes
        if (cid_1.CID.asCID(val) || val instanceof Uint8Array) return val;
        // map plain objects
        const toReturn = {};
        for (const key of Object.keys(val))toReturn[key] = (0, exports.ipldToLex)(val[key]);
        return toReturn;
    }
    // pass through
    return val;
};
exports.ipldToLex = ipldToLex;
const lexToJson = (val)=>{
    return (0, common_web_1.ipldToJson)((0, exports.lexToIpld)(val));
};
exports.lexToJson = lexToJson;
const stringifyLex = (val)=>{
    return JSON.stringify((0, exports.lexToJson)(val));
};
exports.stringifyLex = stringifyLex;
const jsonToLex = (val)=>{
    return (0, exports.ipldToLex)((0, common_web_1.jsonToIpld)(val));
};
exports.jsonToLex = jsonToLex;
const jsonStringToLex = (val)=>{
    return (0, exports.jsonToLex)(JSON.parse(val));
};
exports.jsonStringToLex = jsonStringToLex;

},{"c58548401484207d":"7UJVD","95ed3e8448994260":"jDe1t","d77d79b3b2b33496":"1Sm2X"}],"4ClhN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ids = exports.lexicons = exports.schemas = exports.schemaDict = void 0;
exports.validate = validate;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const lexicon_1 = require("e3bc5e4d947f7c7a");
const util_js_1 = require("a8e3287ef4cff6dd");
exports.schemaDict = {
    AppBskyActorDefs: {
        lexicon: 1,
        id: 'app.bsky.actor.defs',
        defs: {
            profileViewBasic: {
                type: 'object',
                required: [
                    'did',
                    'handle'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    displayName: {
                        type: 'string',
                        maxGraphemes: 64,
                        maxLength: 640
                    },
                    pronouns: {
                        type: 'string'
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    associated: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileAssociated'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#viewerState'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    verification: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#verificationState'
                    },
                    status: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#statusView'
                    }
                }
            },
            profileView: {
                type: 'object',
                required: [
                    'did',
                    'handle'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    displayName: {
                        type: 'string',
                        maxGraphemes: 64,
                        maxLength: 640
                    },
                    pronouns: {
                        type: 'string'
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 256,
                        maxLength: 2560
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    associated: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileAssociated'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#viewerState'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    verification: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#verificationState'
                    },
                    status: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#statusView'
                    }
                }
            },
            profileViewDetailed: {
                type: 'object',
                required: [
                    'did',
                    'handle'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    displayName: {
                        type: 'string',
                        maxGraphemes: 64,
                        maxLength: 640
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 256,
                        maxLength: 2560
                    },
                    pronouns: {
                        type: 'string'
                    },
                    website: {
                        type: 'string',
                        format: 'uri'
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    banner: {
                        type: 'string',
                        format: 'uri'
                    },
                    followersCount: {
                        type: 'integer'
                    },
                    followsCount: {
                        type: 'integer'
                    },
                    postsCount: {
                        type: 'integer'
                    },
                    associated: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileAssociated'
                    },
                    joinedViaStarterPack: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#starterPackViewBasic'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#viewerState'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    pinnedPost: {
                        type: 'ref',
                        ref: 'lex:com.atproto.repo.strongRef'
                    },
                    verification: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#verificationState'
                    },
                    status: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#statusView'
                    }
                }
            },
            profileAssociated: {
                type: 'object',
                properties: {
                    lists: {
                        type: 'integer'
                    },
                    feedgens: {
                        type: 'integer'
                    },
                    starterPacks: {
                        type: 'integer'
                    },
                    labeler: {
                        type: 'boolean'
                    },
                    chat: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileAssociatedChat'
                    },
                    activitySubscription: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileAssociatedActivitySubscription'
                    }
                }
            },
            profileAssociatedChat: {
                type: 'object',
                required: [
                    'allowIncoming'
                ],
                properties: {
                    allowIncoming: {
                        type: 'string',
                        knownValues: [
                            'all',
                            'none',
                            'following'
                        ]
                    }
                }
            },
            profileAssociatedActivitySubscription: {
                type: 'object',
                required: [
                    'allowSubscriptions'
                ],
                properties: {
                    allowSubscriptions: {
                        type: 'string',
                        knownValues: [
                            'followers',
                            'mutuals',
                            'none'
                        ]
                    }
                }
            },
            viewerState: {
                type: 'object',
                description: "Metadata about the requesting account's relationship with the subject account. Only has meaningful content for authed requests.",
                properties: {
                    muted: {
                        type: 'boolean'
                    },
                    mutedByList: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listViewBasic'
                    },
                    blockedBy: {
                        type: 'boolean'
                    },
                    blocking: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    blockingByList: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listViewBasic'
                    },
                    following: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    followedBy: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    knownFollowers: {
                        description: 'This property is present only in selected cases, as an optimization.',
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#knownFollowers'
                    },
                    activitySubscription: {
                        description: 'This property is present only in selected cases, as an optimization.',
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#activitySubscription'
                    }
                }
            },
            knownFollowers: {
                type: 'object',
                description: "The subject's followers whom you also follow",
                required: [
                    'count',
                    'followers'
                ],
                properties: {
                    count: {
                        type: 'integer'
                    },
                    followers: {
                        type: 'array',
                        minLength: 0,
                        maxLength: 5,
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                        }
                    }
                }
            },
            verificationState: {
                type: 'object',
                description: 'Represents the verification information about the user this object is attached to.',
                required: [
                    'verifications',
                    'verifiedStatus',
                    'trustedVerifierStatus'
                ],
                properties: {
                    verifications: {
                        type: 'array',
                        description: 'All verifications issued by trusted verifiers on behalf of this user. Verifications by untrusted verifiers are not included.',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#verificationView'
                        }
                    },
                    verifiedStatus: {
                        type: 'string',
                        description: "The user's status as a verified account.",
                        knownValues: [
                            'valid',
                            'invalid',
                            'none'
                        ]
                    },
                    trustedVerifierStatus: {
                        type: 'string',
                        description: "The user's status as a trusted verifier.",
                        knownValues: [
                            'valid',
                            'invalid',
                            'none'
                        ]
                    }
                }
            },
            verificationView: {
                type: 'object',
                description: 'An individual verification for an associated subject.',
                required: [
                    'issuer',
                    'uri',
                    'isValid',
                    'createdAt'
                ],
                properties: {
                    issuer: {
                        type: 'string',
                        description: 'The user who issued this verification.',
                        format: 'did'
                    },
                    uri: {
                        type: 'string',
                        description: 'The AT-URI of the verification record.',
                        format: 'at-uri'
                    },
                    isValid: {
                        type: 'boolean',
                        description: 'True if the verification passes validation, otherwise false.'
                    },
                    createdAt: {
                        type: 'string',
                        description: 'Timestamp when the verification was created.',
                        format: 'datetime'
                    }
                }
            },
            preferences: {
                type: 'array',
                items: {
                    type: 'union',
                    refs: [
                        'lex:app.bsky.actor.defs#adultContentPref',
                        'lex:app.bsky.actor.defs#contentLabelPref',
                        'lex:app.bsky.actor.defs#savedFeedsPref',
                        'lex:app.bsky.actor.defs#savedFeedsPrefV2',
                        'lex:app.bsky.actor.defs#personalDetailsPref',
                        'lex:app.bsky.actor.defs#feedViewPref',
                        'lex:app.bsky.actor.defs#threadViewPref',
                        'lex:app.bsky.actor.defs#interestsPref',
                        'lex:app.bsky.actor.defs#mutedWordsPref',
                        'lex:app.bsky.actor.defs#hiddenPostsPref',
                        'lex:app.bsky.actor.defs#bskyAppStatePref',
                        'lex:app.bsky.actor.defs#labelersPref',
                        'lex:app.bsky.actor.defs#postInteractionSettingsPref',
                        'lex:app.bsky.actor.defs#verificationPrefs'
                    ]
                }
            },
            adultContentPref: {
                type: 'object',
                required: [
                    'enabled'
                ],
                properties: {
                    enabled: {
                        type: 'boolean',
                        default: false
                    }
                }
            },
            contentLabelPref: {
                type: 'object',
                required: [
                    'label',
                    'visibility'
                ],
                properties: {
                    labelerDid: {
                        type: 'string',
                        description: 'Which labeler does this preference apply to? If undefined, applies globally.',
                        format: 'did'
                    },
                    label: {
                        type: 'string'
                    },
                    visibility: {
                        type: 'string',
                        knownValues: [
                            'ignore',
                            'show',
                            'warn',
                            'hide'
                        ]
                    }
                }
            },
            savedFeed: {
                type: 'object',
                required: [
                    'id',
                    'type',
                    'value',
                    'pinned'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    type: {
                        type: 'string',
                        knownValues: [
                            'feed',
                            'list',
                            'timeline'
                        ]
                    },
                    value: {
                        type: 'string'
                    },
                    pinned: {
                        type: 'boolean'
                    }
                }
            },
            savedFeedsPrefV2: {
                type: 'object',
                required: [
                    'items'
                ],
                properties: {
                    items: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#savedFeed'
                        }
                    }
                }
            },
            savedFeedsPref: {
                type: 'object',
                required: [
                    'pinned',
                    'saved'
                ],
                properties: {
                    pinned: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'at-uri'
                        }
                    },
                    saved: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'at-uri'
                        }
                    },
                    timelineIndex: {
                        type: 'integer'
                    }
                }
            },
            personalDetailsPref: {
                type: 'object',
                properties: {
                    birthDate: {
                        type: 'string',
                        format: 'datetime',
                        description: 'The birth date of account owner.'
                    }
                }
            },
            feedViewPref: {
                type: 'object',
                required: [
                    'feed'
                ],
                properties: {
                    feed: {
                        type: 'string',
                        description: 'The URI of the feed, or an identifier which describes the feed.'
                    },
                    hideReplies: {
                        type: 'boolean',
                        description: 'Hide replies in the feed.'
                    },
                    hideRepliesByUnfollowed: {
                        type: 'boolean',
                        description: 'Hide replies in the feed if they are not by followed users.',
                        default: true
                    },
                    hideRepliesByLikeCount: {
                        type: 'integer',
                        description: 'Hide replies in the feed if they do not have this number of likes.'
                    },
                    hideReposts: {
                        type: 'boolean',
                        description: 'Hide reposts in the feed.'
                    },
                    hideQuotePosts: {
                        type: 'boolean',
                        description: 'Hide quote posts in the feed.'
                    }
                }
            },
            threadViewPref: {
                type: 'object',
                properties: {
                    sort: {
                        type: 'string',
                        description: 'Sorting mode for threads.',
                        knownValues: [
                            'oldest',
                            'newest',
                            'most-likes',
                            'random',
                            'hotness'
                        ]
                    },
                    prioritizeFollowedUsers: {
                        type: 'boolean',
                        description: 'Show followed users at the top of all replies.'
                    }
                }
            },
            interestsPref: {
                type: 'object',
                required: [
                    'tags'
                ],
                properties: {
                    tags: {
                        type: 'array',
                        maxLength: 100,
                        items: {
                            type: 'string',
                            maxLength: 640,
                            maxGraphemes: 64
                        },
                        description: "A list of tags which describe the account owner's interests gathered during onboarding."
                    }
                }
            },
            mutedWordTarget: {
                type: 'string',
                knownValues: [
                    'content',
                    'tag'
                ],
                maxLength: 640,
                maxGraphemes: 64
            },
            mutedWord: {
                type: 'object',
                description: 'A word that the account owner has muted.',
                required: [
                    'value',
                    'targets'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    value: {
                        type: 'string',
                        description: 'The muted word itself.',
                        maxLength: 10000,
                        maxGraphemes: 1000
                    },
                    targets: {
                        type: 'array',
                        description: 'The intended targets of the muted word.',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#mutedWordTarget'
                        }
                    },
                    actorTarget: {
                        type: 'string',
                        description: 'Groups of users to apply the muted word to. If undefined, applies to all users.',
                        knownValues: [
                            'all',
                            'exclude-following'
                        ],
                        default: 'all'
                    },
                    expiresAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'The date and time at which the muted word will expire and no longer be applied.'
                    }
                }
            },
            mutedWordsPref: {
                type: 'object',
                required: [
                    'items'
                ],
                properties: {
                    items: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#mutedWord'
                        },
                        description: 'A list of words the account owner has muted.'
                    }
                }
            },
            hiddenPostsPref: {
                type: 'object',
                required: [
                    'items'
                ],
                properties: {
                    items: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'at-uri'
                        },
                        description: 'A list of URIs of posts the account owner has hidden.'
                    }
                }
            },
            labelersPref: {
                type: 'object',
                required: [
                    'labelers'
                ],
                properties: {
                    labelers: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#labelerPrefItem'
                        }
                    }
                }
            },
            labelerPrefItem: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            bskyAppStatePref: {
                description: "A grab bag of state that's specific to the bsky.app program. Third-party apps shouldn't use this.",
                type: 'object',
                properties: {
                    activeProgressGuide: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#bskyAppProgressGuide'
                    },
                    queuedNudges: {
                        description: 'An array of tokens which identify nudges (modals, popups, tours, highlight dots) that should be shown to the user.',
                        type: 'array',
                        maxLength: 1000,
                        items: {
                            type: 'string',
                            maxLength: 100
                        }
                    },
                    nuxs: {
                        description: 'Storage for NUXs the user has encountered.',
                        type: 'array',
                        maxLength: 100,
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#nux'
                        }
                    }
                }
            },
            bskyAppProgressGuide: {
                description: 'If set, an active progress guide. Once completed, can be set to undefined. Should have unspecced fields tracking progress.',
                type: 'object',
                required: [
                    'guide'
                ],
                properties: {
                    guide: {
                        type: 'string',
                        maxLength: 100
                    }
                }
            },
            nux: {
                type: 'object',
                description: 'A new user experiences (NUX) storage object',
                required: [
                    'id',
                    'completed'
                ],
                properties: {
                    id: {
                        type: 'string',
                        maxLength: 100
                    },
                    completed: {
                        type: 'boolean',
                        default: false
                    },
                    data: {
                        description: 'Arbitrary data for the NUX. The structure is defined by the NUX itself. Limited to 300 characters.',
                        type: 'string',
                        maxLength: 3000,
                        maxGraphemes: 300
                    },
                    expiresAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'The date and time at which the NUX will expire and should be considered completed.'
                    }
                }
            },
            verificationPrefs: {
                type: 'object',
                description: 'Preferences for how verified accounts appear in the app.',
                required: [],
                properties: {
                    hideBadges: {
                        description: 'Hide the blue check badges for verified accounts and trusted verifiers.',
                        type: 'boolean',
                        default: false
                    }
                }
            },
            postInteractionSettingsPref: {
                type: 'object',
                description: 'Default post interaction settings for the account. These values should be applied as default values when creating new posts. These refs should mirror the threadgate and postgate records exactly.',
                required: [],
                properties: {
                    threadgateAllowRules: {
                        description: 'Matches threadgate record. List of rules defining who can reply to this users posts. If value is an empty array, no one can reply. If value is undefined, anyone can reply.',
                        type: 'array',
                        maxLength: 5,
                        items: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.feed.threadgate#mentionRule',
                                'lex:app.bsky.feed.threadgate#followerRule',
                                'lex:app.bsky.feed.threadgate#followingRule',
                                'lex:app.bsky.feed.threadgate#listRule'
                            ]
                        }
                    },
                    postgateEmbeddingRules: {
                        description: 'Matches postgate record. List of rules defining who can embed this users posts. If value is an empty array or is undefined, no particular rules apply and anyone can embed.',
                        type: 'array',
                        maxLength: 5,
                        items: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.feed.postgate#disableRule'
                            ]
                        }
                    }
                }
            },
            statusView: {
                type: 'object',
                required: [
                    'status',
                    'record'
                ],
                properties: {
                    status: {
                        type: 'string',
                        description: 'The status for the account.',
                        knownValues: [
                            'app.bsky.actor.status#live'
                        ]
                    },
                    record: {
                        type: 'unknown'
                    },
                    embed: {
                        type: 'union',
                        description: 'An optional embed associated with the status.',
                        refs: [
                            'lex:app.bsky.embed.external#view'
                        ]
                    },
                    expiresAt: {
                        type: 'string',
                        description: 'The date when this status will expire. The application might choose to no longer return the status after expiration.',
                        format: 'datetime'
                    },
                    isActive: {
                        type: 'boolean',
                        description: 'True if the status is not expired, false if it is expired. Only present if expiration was set.'
                    }
                }
            }
        }
    },
    AppBskyActorGetPreferences: {
        lexicon: 1,
        id: 'app.bsky.actor.getPreferences',
        defs: {
            main: {
                type: 'query',
                description: 'Get private preferences attached to the current account. Expected use is synchronization between multiple devices, and import/export during account migration. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {}
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'preferences'
                        ],
                        properties: {
                            preferences: {
                                type: 'ref',
                                ref: 'lex:app.bsky.actor.defs#preferences'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorGetProfile: {
        lexicon: 1,
        id: 'app.bsky.actor.getProfile',
        defs: {
            main: {
                type: 'query',
                description: 'Get detailed profile view of an actor. Does not require auth, but contains relevant metadata with auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Handle or DID of account to fetch profile of.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewDetailed'
                    }
                }
            }
        }
    },
    AppBskyActorGetProfiles: {
        lexicon: 1,
        id: 'app.bsky.actor.getProfiles',
        defs: {
            main: {
                type: 'query',
                description: 'Get detailed profile views of multiple actors.',
                parameters: {
                    type: 'params',
                    required: [
                        'actors'
                    ],
                    properties: {
                        actors: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'at-identifier'
                            },
                            maxLength: 25
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'profiles'
                        ],
                        properties: {
                            profiles: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileViewDetailed'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorGetSuggestions: {
        lexicon: 1,
        id: 'app.bsky.actor.getSuggestions',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of suggested actors. Expected use is discovery of accounts to follow during new account onboarding.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actors'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            actors: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            },
                            recId: {
                                type: 'integer',
                                description: 'Snowflake for this recommendation, use when submitting recommendation events.'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorProfile: {
        lexicon: 1,
        id: 'app.bsky.actor.profile',
        defs: {
            main: {
                type: 'record',
                description: 'A declaration of a Bluesky account profile.',
                key: 'literal:self',
                record: {
                    type: 'object',
                    properties: {
                        displayName: {
                            type: 'string',
                            maxGraphemes: 64,
                            maxLength: 640
                        },
                        description: {
                            type: 'string',
                            description: 'Free-form profile description text.',
                            maxGraphemes: 256,
                            maxLength: 2560
                        },
                        pronouns: {
                            type: 'string',
                            description: 'Free-form pronouns text.',
                            maxGraphemes: 20,
                            maxLength: 200
                        },
                        website: {
                            type: 'string',
                            format: 'uri'
                        },
                        avatar: {
                            type: 'blob',
                            description: "Small image to be displayed next to posts from account. AKA, 'profile picture'",
                            accept: [
                                'image/png',
                                'image/jpeg'
                            ],
                            maxSize: 1000000
                        },
                        banner: {
                            type: 'blob',
                            description: 'Larger horizontal image to display behind profile view.',
                            accept: [
                                'image/png',
                                'image/jpeg'
                            ],
                            maxSize: 1000000
                        },
                        labels: {
                            type: 'union',
                            description: 'Self-label values, specific to the Bluesky application, on the overall account.',
                            refs: [
                                'lex:com.atproto.label.defs#selfLabels'
                            ]
                        },
                        joinedViaStarterPack: {
                            type: 'ref',
                            ref: 'lex:com.atproto.repo.strongRef'
                        },
                        pinnedPost: {
                            type: 'ref',
                            ref: 'lex:com.atproto.repo.strongRef'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyActorPutPreferences: {
        lexicon: 1,
        id: 'app.bsky.actor.putPreferences',
        defs: {
            main: {
                type: 'procedure',
                description: 'Set the private preferences attached to the account.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'preferences'
                        ],
                        properties: {
                            preferences: {
                                type: 'ref',
                                ref: 'lex:app.bsky.actor.defs#preferences'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorSearchActors: {
        lexicon: 1,
        id: 'app.bsky.actor.searchActors',
        defs: {
            main: {
                type: 'query',
                description: 'Find actors (profiles) matching search criteria. Does not require auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        term: {
                            type: 'string',
                            description: "DEPRECATED: use 'q' instead."
                        },
                        q: {
                            type: 'string',
                            description: 'Search query string. Syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actors'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            actors: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorSearchActorsTypeahead: {
        lexicon: 1,
        id: 'app.bsky.actor.searchActorsTypeahead',
        defs: {
            main: {
                type: 'query',
                description: 'Find actor suggestions for a prefix search term. Expected use is for auto-completion during text field entry. Does not require auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        term: {
                            type: 'string',
                            description: "DEPRECATED: use 'q' instead."
                        },
                        q: {
                            type: 'string',
                            description: 'Search query prefix; not a full query string.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actors'
                        ],
                        properties: {
                            actors: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyActorStatus: {
        lexicon: 1,
        id: 'app.bsky.actor.status',
        defs: {
            main: {
                type: 'record',
                description: 'A declaration of a Bluesky account status.',
                key: 'literal:self',
                record: {
                    type: 'object',
                    required: [
                        'status',
                        'createdAt'
                    ],
                    properties: {
                        status: {
                            type: 'string',
                            description: 'The status for the account.',
                            knownValues: [
                                'app.bsky.actor.status#live'
                            ]
                        },
                        embed: {
                            type: 'union',
                            description: 'An optional embed associated with the status.',
                            refs: [
                                'lex:app.bsky.embed.external'
                            ]
                        },
                        durationMinutes: {
                            type: 'integer',
                            description: 'The duration of the status in minutes. Applications can choose to impose minimum and maximum limits.',
                            minimum: 1
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            },
            live: {
                type: 'token',
                description: 'Advertises an account as currently offering live content.'
            }
        }
    },
    AppBskyBookmarkCreateBookmark: {
        lexicon: 1,
        id: 'app.bsky.bookmark.createBookmark',
        defs: {
            main: {
                type: 'procedure',
                description: 'Creates a private bookmark for the specified record. Currently, only `app.bsky.feed.post` records are supported. Requires authentication.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'cid'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'UnsupportedCollection',
                        description: 'The URI to be bookmarked is for an unsupported collection.'
                    }
                ]
            }
        }
    },
    AppBskyBookmarkDefs: {
        lexicon: 1,
        id: 'app.bsky.bookmark.defs',
        defs: {
            bookmark: {
                description: 'Object used to store bookmark data in stash.',
                type: 'object',
                required: [
                    'subject'
                ],
                properties: {
                    subject: {
                        description: 'A strong ref to the record to be bookmarked. Currently, only `app.bsky.feed.post` records are supported.',
                        type: 'ref',
                        ref: 'lex:com.atproto.repo.strongRef'
                    }
                }
            },
            bookmarkView: {
                type: 'object',
                required: [
                    'subject',
                    'item'
                ],
                properties: {
                    subject: {
                        description: 'A strong ref to the bookmarked record.',
                        type: 'ref',
                        ref: 'lex:com.atproto.repo.strongRef'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    item: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.feed.defs#blockedPost',
                            'lex:app.bsky.feed.defs#notFoundPost',
                            'lex:app.bsky.feed.defs#postView'
                        ]
                    }
                }
            }
        }
    },
    AppBskyBookmarkDeleteBookmark: {
        lexicon: 1,
        id: 'app.bsky.bookmark.deleteBookmark',
        defs: {
            main: {
                type: 'procedure',
                description: 'Deletes a private bookmark for the specified record. Currently, only `app.bsky.feed.post` records are supported. Requires authentication.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'UnsupportedCollection',
                        description: 'The URI to be bookmarked is for an unsupported collection.'
                    }
                ]
            }
        }
    },
    AppBskyBookmarkGetBookmarks: {
        lexicon: 1,
        id: 'app.bsky.bookmark.getBookmarks',
        defs: {
            main: {
                type: 'query',
                description: 'Gets views of records bookmarked by the authenticated user. Requires authentication.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'bookmarks'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            bookmarks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.bookmark.defs#bookmarkView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyEmbedDefs: {
        lexicon: 1,
        id: 'app.bsky.embed.defs',
        defs: {
            aspectRatio: {
                type: 'object',
                description: 'width:height represents an aspect ratio. It may be approximate, and may not correspond to absolute dimensions in any given unit.',
                required: [
                    'width',
                    'height'
                ],
                properties: {
                    width: {
                        type: 'integer',
                        minimum: 1
                    },
                    height: {
                        type: 'integer',
                        minimum: 1
                    }
                }
            }
        }
    },
    AppBskyEmbedExternal: {
        lexicon: 1,
        id: 'app.bsky.embed.external',
        defs: {
            main: {
                type: 'object',
                description: "A representation of some externally linked content (eg, a URL and 'card'), embedded in a Bluesky record (eg, a post).",
                required: [
                    'external'
                ],
                properties: {
                    external: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.external#external'
                    }
                }
            },
            external: {
                type: 'object',
                required: [
                    'uri',
                    'title',
                    'description'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'uri'
                    },
                    title: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    thumb: {
                        type: 'blob',
                        accept: [
                            'image/*'
                        ],
                        maxSize: 1000000
                    }
                }
            },
            view: {
                type: 'object',
                required: [
                    'external'
                ],
                properties: {
                    external: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.external#viewExternal'
                    }
                }
            },
            viewExternal: {
                type: 'object',
                required: [
                    'uri',
                    'title',
                    'description'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'uri'
                    },
                    title: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    thumb: {
                        type: 'string',
                        format: 'uri'
                    }
                }
            }
        }
    },
    AppBskyEmbedImages: {
        lexicon: 1,
        id: 'app.bsky.embed.images',
        description: 'A set of images embedded in a Bluesky record (eg, a post).',
        defs: {
            main: {
                type: 'object',
                required: [
                    'images'
                ],
                properties: {
                    images: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.embed.images#image'
                        },
                        maxLength: 4
                    }
                }
            },
            image: {
                type: 'object',
                required: [
                    'image',
                    'alt'
                ],
                properties: {
                    image: {
                        type: 'blob',
                        accept: [
                            'image/*'
                        ],
                        maxSize: 1000000
                    },
                    alt: {
                        type: 'string',
                        description: 'Alt text description of the image, for accessibility.'
                    },
                    aspectRatio: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.defs#aspectRatio'
                    }
                }
            },
            view: {
                type: 'object',
                required: [
                    'images'
                ],
                properties: {
                    images: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.embed.images#viewImage'
                        },
                        maxLength: 4
                    }
                }
            },
            viewImage: {
                type: 'object',
                required: [
                    'thumb',
                    'fullsize',
                    'alt'
                ],
                properties: {
                    thumb: {
                        type: 'string',
                        format: 'uri',
                        description: 'Fully-qualified URL where a thumbnail of the image can be fetched. For example, CDN location provided by the App View.'
                    },
                    fullsize: {
                        type: 'string',
                        format: 'uri',
                        description: 'Fully-qualified URL where a large version of the image can be fetched. May or may not be the exact original blob. For example, CDN location provided by the App View.'
                    },
                    alt: {
                        type: 'string',
                        description: 'Alt text description of the image, for accessibility.'
                    },
                    aspectRatio: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.defs#aspectRatio'
                    }
                }
            }
        }
    },
    AppBskyEmbedRecord: {
        lexicon: 1,
        id: 'app.bsky.embed.record',
        description: 'A representation of a record embedded in a Bluesky record (eg, a post). For example, a quote-post, or sharing a feed generator record.',
        defs: {
            main: {
                type: 'object',
                required: [
                    'record'
                ],
                properties: {
                    record: {
                        type: 'ref',
                        ref: 'lex:com.atproto.repo.strongRef'
                    }
                }
            },
            view: {
                type: 'object',
                required: [
                    'record'
                ],
                properties: {
                    record: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.record#viewRecord',
                            'lex:app.bsky.embed.record#viewNotFound',
                            'lex:app.bsky.embed.record#viewBlocked',
                            'lex:app.bsky.embed.record#viewDetached',
                            'lex:app.bsky.feed.defs#generatorView',
                            'lex:app.bsky.graph.defs#listView',
                            'lex:app.bsky.labeler.defs#labelerView',
                            'lex:app.bsky.graph.defs#starterPackViewBasic'
                        ]
                    }
                }
            },
            viewRecord: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'author',
                    'value',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    author: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                    },
                    value: {
                        type: 'unknown',
                        description: 'The record data itself.'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    replyCount: {
                        type: 'integer'
                    },
                    repostCount: {
                        type: 'integer'
                    },
                    likeCount: {
                        type: 'integer'
                    },
                    quoteCount: {
                        type: 'integer'
                    },
                    embeds: {
                        type: 'array',
                        items: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.embed.images#view',
                                'lex:app.bsky.embed.video#view',
                                'lex:app.bsky.embed.external#view',
                                'lex:app.bsky.embed.record#view',
                                'lex:app.bsky.embed.recordWithMedia#view'
                            ]
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            viewNotFound: {
                type: 'object',
                required: [
                    'uri',
                    'notFound'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    notFound: {
                        type: 'boolean',
                        const: true
                    }
                }
            },
            viewBlocked: {
                type: 'object',
                required: [
                    'uri',
                    'blocked',
                    'author'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    blocked: {
                        type: 'boolean',
                        const: true
                    },
                    author: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#blockedAuthor'
                    }
                }
            },
            viewDetached: {
                type: 'object',
                required: [
                    'uri',
                    'detached'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    detached: {
                        type: 'boolean',
                        const: true
                    }
                }
            }
        }
    },
    AppBskyEmbedRecordWithMedia: {
        lexicon: 1,
        id: 'app.bsky.embed.recordWithMedia',
        description: 'A representation of a record embedded in a Bluesky record (eg, a post), alongside other compatible embeds. For example, a quote post and image, or a quote post and external URL card.',
        defs: {
            main: {
                type: 'object',
                required: [
                    'record',
                    'media'
                ],
                properties: {
                    record: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.record'
                    },
                    media: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.images',
                            'lex:app.bsky.embed.video',
                            'lex:app.bsky.embed.external'
                        ]
                    }
                }
            },
            view: {
                type: 'object',
                required: [
                    'record',
                    'media'
                ],
                properties: {
                    record: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.record#view'
                    },
                    media: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.images#view',
                            'lex:app.bsky.embed.video#view',
                            'lex:app.bsky.embed.external#view'
                        ]
                    }
                }
            }
        }
    },
    AppBskyEmbedVideo: {
        lexicon: 1,
        id: 'app.bsky.embed.video',
        description: 'A video embedded in a Bluesky record (eg, a post).',
        defs: {
            main: {
                type: 'object',
                required: [
                    'video'
                ],
                properties: {
                    video: {
                        type: 'blob',
                        description: 'The mp4 video file. May be up to 100mb, formerly limited to 50mb.',
                        accept: [
                            'video/mp4'
                        ],
                        maxSize: 100000000
                    },
                    captions: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.embed.video#caption'
                        },
                        maxLength: 20
                    },
                    alt: {
                        type: 'string',
                        description: 'Alt text description of the video, for accessibility.',
                        maxGraphemes: 1000,
                        maxLength: 10000
                    },
                    aspectRatio: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.defs#aspectRatio'
                    }
                }
            },
            caption: {
                type: 'object',
                required: [
                    'lang',
                    'file'
                ],
                properties: {
                    lang: {
                        type: 'string',
                        format: 'language'
                    },
                    file: {
                        type: 'blob',
                        accept: [
                            'text/vtt'
                        ],
                        maxSize: 20000
                    }
                }
            },
            view: {
                type: 'object',
                required: [
                    'cid',
                    'playlist'
                ],
                properties: {
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    playlist: {
                        type: 'string',
                        format: 'uri'
                    },
                    thumbnail: {
                        type: 'string',
                        format: 'uri'
                    },
                    alt: {
                        type: 'string',
                        maxGraphemes: 1000,
                        maxLength: 10000
                    },
                    aspectRatio: {
                        type: 'ref',
                        ref: 'lex:app.bsky.embed.defs#aspectRatio'
                    }
                }
            }
        }
    },
    AppBskyFeedDefs: {
        lexicon: 1,
        id: 'app.bsky.feed.defs',
        defs: {
            postView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'author',
                    'record',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    author: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                    },
                    record: {
                        type: 'unknown'
                    },
                    embed: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.images#view',
                            'lex:app.bsky.embed.video#view',
                            'lex:app.bsky.embed.external#view',
                            'lex:app.bsky.embed.record#view',
                            'lex:app.bsky.embed.recordWithMedia#view'
                        ]
                    },
                    bookmarkCount: {
                        type: 'integer'
                    },
                    replyCount: {
                        type: 'integer'
                    },
                    repostCount: {
                        type: 'integer'
                    },
                    likeCount: {
                        type: 'integer'
                    },
                    quoteCount: {
                        type: 'integer'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#viewerState'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    threadgate: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#threadgateView'
                    }
                }
            },
            viewerState: {
                type: 'object',
                description: "Metadata about the requesting account's relationship with the subject content. Only has meaningful content for authed requests.",
                properties: {
                    repost: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    like: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    bookmarked: {
                        type: 'boolean'
                    },
                    threadMuted: {
                        type: 'boolean'
                    },
                    replyDisabled: {
                        type: 'boolean'
                    },
                    embeddingDisabled: {
                        type: 'boolean'
                    },
                    pinned: {
                        type: 'boolean'
                    }
                }
            },
            threadContext: {
                type: 'object',
                description: 'Metadata about this post within the context of the thread it is in.',
                properties: {
                    rootAuthorLike: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            feedViewPost: {
                type: 'object',
                required: [
                    'post'
                ],
                properties: {
                    post: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#postView'
                    },
                    reply: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#replyRef'
                    },
                    reason: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.feed.defs#reasonRepost',
                            'lex:app.bsky.feed.defs#reasonPin'
                        ]
                    },
                    feedContext: {
                        type: 'string',
                        description: 'Context provided by feed generator that may be passed back alongside interactions.',
                        maxLength: 2000
                    },
                    reqId: {
                        type: 'string',
                        description: 'Unique identifier per request that may be passed back alongside interactions.',
                        maxLength: 100
                    }
                }
            },
            replyRef: {
                type: 'object',
                required: [
                    'root',
                    'parent'
                ],
                properties: {
                    root: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.feed.defs#postView',
                            'lex:app.bsky.feed.defs#notFoundPost',
                            'lex:app.bsky.feed.defs#blockedPost'
                        ]
                    },
                    parent: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.feed.defs#postView',
                            'lex:app.bsky.feed.defs#notFoundPost',
                            'lex:app.bsky.feed.defs#blockedPost'
                        ]
                    },
                    grandparentAuthor: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic',
                        description: 'When parent is a reply to another post, this is the author of that post.'
                    }
                }
            },
            reasonRepost: {
                type: 'object',
                required: [
                    'by',
                    'indexedAt'
                ],
                properties: {
                    by: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                    },
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            reasonPin: {
                type: 'object',
                properties: {}
            },
            threadViewPost: {
                type: 'object',
                required: [
                    'post'
                ],
                properties: {
                    post: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#postView'
                    },
                    parent: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.feed.defs#threadViewPost',
                            'lex:app.bsky.feed.defs#notFoundPost',
                            'lex:app.bsky.feed.defs#blockedPost'
                        ]
                    },
                    replies: {
                        type: 'array',
                        items: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.feed.defs#threadViewPost',
                                'lex:app.bsky.feed.defs#notFoundPost',
                                'lex:app.bsky.feed.defs#blockedPost'
                            ]
                        }
                    },
                    threadContext: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#threadContext'
                    }
                }
            },
            notFoundPost: {
                type: 'object',
                required: [
                    'uri',
                    'notFound'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    notFound: {
                        type: 'boolean',
                        const: true
                    }
                }
            },
            blockedPost: {
                type: 'object',
                required: [
                    'uri',
                    'blocked',
                    'author'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    blocked: {
                        type: 'boolean',
                        const: true
                    },
                    author: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#blockedAuthor'
                    }
                }
            },
            blockedAuthor: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#viewerState'
                    }
                }
            },
            generatorView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'did',
                    'creator',
                    'displayName',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    },
                    displayName: {
                        type: 'string'
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 300,
                        maxLength: 3000
                    },
                    descriptionFacets: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.richtext.facet'
                        }
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    likeCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    acceptsInteractions: {
                        type: 'boolean'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#generatorViewerState'
                    },
                    contentMode: {
                        type: 'string',
                        knownValues: [
                            'app.bsky.feed.defs#contentModeUnspecified',
                            'app.bsky.feed.defs#contentModeVideo'
                        ]
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            generatorViewerState: {
                type: 'object',
                properties: {
                    like: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            skeletonFeedPost: {
                type: 'object',
                required: [
                    'post'
                ],
                properties: {
                    post: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    reason: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.feed.defs#skeletonReasonRepost',
                            'lex:app.bsky.feed.defs#skeletonReasonPin'
                        ]
                    },
                    feedContext: {
                        type: 'string',
                        description: 'Context that will be passed through to client and may be passed to feed generator back alongside interactions.',
                        maxLength: 2000
                    }
                }
            },
            skeletonReasonRepost: {
                type: 'object',
                required: [
                    'repost'
                ],
                properties: {
                    repost: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            skeletonReasonPin: {
                type: 'object',
                properties: {}
            },
            threadgateView: {
                type: 'object',
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    record: {
                        type: 'unknown'
                    },
                    lists: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.graph.defs#listViewBasic'
                        }
                    }
                }
            },
            interaction: {
                type: 'object',
                properties: {
                    item: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    event: {
                        type: 'string',
                        knownValues: [
                            'app.bsky.feed.defs#requestLess',
                            'app.bsky.feed.defs#requestMore',
                            'app.bsky.feed.defs#clickthroughItem',
                            'app.bsky.feed.defs#clickthroughAuthor',
                            'app.bsky.feed.defs#clickthroughReposter',
                            'app.bsky.feed.defs#clickthroughEmbed',
                            'app.bsky.feed.defs#interactionSeen',
                            'app.bsky.feed.defs#interactionLike',
                            'app.bsky.feed.defs#interactionRepost',
                            'app.bsky.feed.defs#interactionReply',
                            'app.bsky.feed.defs#interactionQuote',
                            'app.bsky.feed.defs#interactionShare'
                        ]
                    },
                    feedContext: {
                        type: 'string',
                        description: 'Context on a feed item that was originally supplied by the feed generator on getFeedSkeleton.',
                        maxLength: 2000
                    },
                    reqId: {
                        type: 'string',
                        description: 'Unique identifier per request that may be passed back alongside interactions.',
                        maxLength: 100
                    }
                }
            },
            requestLess: {
                type: 'token',
                description: 'Request that less content like the given feed item be shown in the feed'
            },
            requestMore: {
                type: 'token',
                description: 'Request that more content like the given feed item be shown in the feed'
            },
            clickthroughItem: {
                type: 'token',
                description: 'User clicked through to the feed item'
            },
            clickthroughAuthor: {
                type: 'token',
                description: 'User clicked through to the author of the feed item'
            },
            clickthroughReposter: {
                type: 'token',
                description: 'User clicked through to the reposter of the feed item'
            },
            clickthroughEmbed: {
                type: 'token',
                description: 'User clicked through to the embedded content of the feed item'
            },
            contentModeUnspecified: {
                type: 'token',
                description: 'Declares the feed generator returns any types of posts.'
            },
            contentModeVideo: {
                type: 'token',
                description: 'Declares the feed generator returns posts containing app.bsky.embed.video embeds.'
            },
            interactionSeen: {
                type: 'token',
                description: 'Feed item was seen by user'
            },
            interactionLike: {
                type: 'token',
                description: 'User liked the feed item'
            },
            interactionRepost: {
                type: 'token',
                description: 'User reposted the feed item'
            },
            interactionReply: {
                type: 'token',
                description: 'User replied to the feed item'
            },
            interactionQuote: {
                type: 'token',
                description: 'User quoted the feed item'
            },
            interactionShare: {
                type: 'token',
                description: 'User shared the feed item'
            }
        }
    },
    AppBskyFeedDescribeFeedGenerator: {
        lexicon: 1,
        id: 'app.bsky.feed.describeFeedGenerator',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about a feed generator, including policies and offered feed URIs. Does not require auth; implemented by Feed Generator services (not App View).',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'feeds'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.describeFeedGenerator#feed'
                                }
                            },
                            links: {
                                type: 'ref',
                                ref: 'lex:app.bsky.feed.describeFeedGenerator#links'
                            }
                        }
                    }
                }
            },
            feed: {
                type: 'object',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            links: {
                type: 'object',
                properties: {
                    privacyPolicy: {
                        type: 'string'
                    },
                    termsOfService: {
                        type: 'string'
                    }
                }
            }
        }
    },
    AppBskyFeedGenerator: {
        lexicon: 1,
        id: 'app.bsky.feed.generator',
        defs: {
            main: {
                type: 'record',
                description: 'Record declaring of the existence of a feed generator, and containing metadata about it. The record can exist in any repository.',
                key: 'any',
                record: {
                    type: 'object',
                    required: [
                        'did',
                        'displayName',
                        'createdAt'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        },
                        displayName: {
                            type: 'string',
                            maxGraphemes: 24,
                            maxLength: 240
                        },
                        description: {
                            type: 'string',
                            maxGraphemes: 300,
                            maxLength: 3000
                        },
                        descriptionFacets: {
                            type: 'array',
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.richtext.facet'
                            }
                        },
                        avatar: {
                            type: 'blob',
                            accept: [
                                'image/png',
                                'image/jpeg'
                            ],
                            maxSize: 1000000
                        },
                        acceptsInteractions: {
                            type: 'boolean',
                            description: 'Declaration that a feed accepts feedback interactions from a client through app.bsky.feed.sendInteractions'
                        },
                        labels: {
                            type: 'union',
                            description: 'Self-label values',
                            refs: [
                                'lex:com.atproto.label.defs#selfLabels'
                            ]
                        },
                        contentMode: {
                            type: 'string',
                            knownValues: [
                                'app.bsky.feed.defs#contentModeUnspecified',
                                'app.bsky.feed.defs#contentModeVideo'
                            ]
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetActorFeeds: {
        lexicon: 1,
        id: 'app.bsky.feed.getActorFeeds',
        defs: {
            main: {
                type: 'query',
                description: "Get a list of feeds (feed generator records) created by the actor (in the actor's repo).",
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feeds'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#generatorView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetActorLikes: {
        lexicon: 1,
        id: 'app.bsky.feed.getActorLikes',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of posts liked by an actor. Requires auth, actor must be the requesting account.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#feedViewPost'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BlockedActor'
                    },
                    {
                        name: 'BlockedByActor'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetAuthorFeed: {
        lexicon: 1,
        id: 'app.bsky.feed.getAuthorFeed',
        defs: {
            main: {
                type: 'query',
                description: "Get a view of an actor's 'author feed' (post and reposts by the author). Does not require auth.",
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        filter: {
                            type: 'string',
                            description: 'Combinations of post/repost types to include in response.',
                            knownValues: [
                                'posts_with_replies',
                                'posts_no_replies',
                                'posts_with_media',
                                'posts_and_author_threads',
                                'posts_with_video'
                            ],
                            default: 'posts_with_replies'
                        },
                        includePins: {
                            type: 'boolean',
                            default: false
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#feedViewPost'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BlockedActor'
                    },
                    {
                        name: 'BlockedByActor'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetFeed: {
        lexicon: 1,
        id: 'app.bsky.feed.getFeed',
        defs: {
            main: {
                type: 'query',
                description: "Get a hydrated feed from an actor's selected feed generator. Implemented by App View.",
                parameters: {
                    type: 'params',
                    required: [
                        'feed'
                    ],
                    properties: {
                        feed: {
                            type: 'string',
                            format: 'at-uri'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#feedViewPost'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'UnknownFeed'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetFeedGenerator: {
        lexicon: 1,
        id: 'app.bsky.feed.getFeedGenerator',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about a feed generator. Implemented by AppView.',
                parameters: {
                    type: 'params',
                    required: [
                        'feed'
                    ],
                    properties: {
                        feed: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'AT-URI of the feed generator record.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'view',
                            'isOnline',
                            'isValid'
                        ],
                        properties: {
                            view: {
                                type: 'ref',
                                ref: 'lex:app.bsky.feed.defs#generatorView'
                            },
                            isOnline: {
                                type: 'boolean',
                                description: 'Indicates whether the feed generator service has been online recently, or else seems to be inactive.'
                            },
                            isValid: {
                                type: 'boolean',
                                description: 'Indicates whether the feed generator service is compatible with the record declaration.'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetFeedGenerators: {
        lexicon: 1,
        id: 'app.bsky.feed.getFeedGenerators',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about a list of feed generators.',
                parameters: {
                    type: 'params',
                    required: [
                        'feeds'
                    ],
                    properties: {
                        feeds: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feeds'
                        ],
                        properties: {
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#generatorView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetFeedSkeleton: {
        lexicon: 1,
        id: 'app.bsky.feed.getFeedSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Get a skeleton of a feed provided by a feed generator. Auth is optional, depending on provider requirements, and provides the DID of the requester. Implemented by Feed Generator Service.',
                parameters: {
                    type: 'params',
                    required: [
                        'feed'
                    ],
                    properties: {
                        feed: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference to feed generator record describing the specific feed being requested.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#skeletonFeedPost'
                                }
                            },
                            reqId: {
                                type: 'string',
                                description: 'Unique identifier per request that may be passed back alongside interactions.',
                                maxLength: 100
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'UnknownFeed'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetLikes: {
        lexicon: 1,
        id: 'app.bsky.feed.getLikes',
        defs: {
            main: {
                type: 'query',
                description: 'Get like records which reference a subject (by AT-URI and CID).',
                parameters: {
                    type: 'params',
                    required: [
                        'uri'
                    ],
                    properties: {
                        uri: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'AT-URI of the subject (eg, a post record).'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid',
                            description: 'CID of the subject record (aka, specific version of record), to filter likes.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'likes'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            cursor: {
                                type: 'string'
                            },
                            likes: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.getLikes#like'
                                }
                            }
                        }
                    }
                }
            },
            like: {
                type: 'object',
                required: [
                    'indexedAt',
                    'createdAt',
                    'actor'
                ],
                properties: {
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    actor: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    }
                }
            }
        }
    },
    AppBskyFeedGetListFeed: {
        lexicon: 1,
        id: 'app.bsky.feed.getListFeed',
        defs: {
            main: {
                type: 'query',
                description: 'Get a feed of recent posts from a list (posts and reposts from any actors on the list). Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'list'
                    ],
                    properties: {
                        list: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the list record.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#feedViewPost'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'UnknownList'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetPostThread: {
        lexicon: 1,
        id: 'app.bsky.feed.getPostThread',
        defs: {
            main: {
                type: 'query',
                description: 'Get posts in a thread. Does not require auth, but additional metadata and filtering will be applied for authed requests.',
                parameters: {
                    type: 'params',
                    required: [
                        'uri'
                    ],
                    properties: {
                        uri: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to post record.'
                        },
                        depth: {
                            type: 'integer',
                            description: 'How many levels of reply depth should be included in response.',
                            default: 6,
                            minimum: 0,
                            maximum: 1000
                        },
                        parentHeight: {
                            type: 'integer',
                            description: 'How many levels of parent (and grandparent, etc) post to include.',
                            default: 80,
                            minimum: 0,
                            maximum: 1000
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'thread'
                        ],
                        properties: {
                            thread: {
                                type: 'union',
                                refs: [
                                    'lex:app.bsky.feed.defs#threadViewPost',
                                    'lex:app.bsky.feed.defs#notFoundPost',
                                    'lex:app.bsky.feed.defs#blockedPost'
                                ]
                            },
                            threadgate: {
                                type: 'ref',
                                ref: 'lex:app.bsky.feed.defs#threadgateView'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'NotFound'
                    }
                ]
            }
        }
    },
    AppBskyFeedGetPosts: {
        lexicon: 1,
        id: 'app.bsky.feed.getPosts',
        defs: {
            main: {
                type: 'query',
                description: "Gets post views for a specified list of posts (by AT-URI). This is sometimes referred to as 'hydrating' a 'feed skeleton'.",
                parameters: {
                    type: 'params',
                    required: [
                        'uris'
                    ],
                    properties: {
                        uris: {
                            type: 'array',
                            description: 'List of post AT-URIs to return hydrated views for.',
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            maxLength: 25
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'posts'
                        ],
                        properties: {
                            posts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#postView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetQuotes: {
        lexicon: 1,
        id: 'app.bsky.feed.getQuotes',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of quotes for a given post.',
                parameters: {
                    type: 'params',
                    required: [
                        'uri'
                    ],
                    properties: {
                        uri: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) of post record'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid',
                            description: 'If supplied, filters to quotes of specific version (by CID) of the post record.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'posts'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            cursor: {
                                type: 'string'
                            },
                            posts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#postView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetRepostedBy: {
        lexicon: 1,
        id: 'app.bsky.feed.getRepostedBy',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of reposts for a given post.',
                parameters: {
                    type: 'params',
                    required: [
                        'uri'
                    ],
                    properties: {
                        uri: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) of post record'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid',
                            description: 'If supplied, filters to reposts of specific version (by CID) of the post record.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'repostedBy'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            cursor: {
                                type: 'string'
                            },
                            repostedBy: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetSuggestedFeeds: {
        lexicon: 1,
        id: 'app.bsky.feed.getSuggestedFeeds',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of suggested feeds (feed generators) for the requesting account.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feeds'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#generatorView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedGetTimeline: {
        lexicon: 1,
        id: 'app.bsky.feed.getTimeline',
        defs: {
            main: {
                type: 'query',
                description: "Get a view of the requesting account's home timeline. This is expected to be some form of reverse-chronological feed.",
                parameters: {
                    type: 'params',
                    properties: {
                        algorithm: {
                            type: 'string',
                            description: "Variant 'algorithm' for timeline. Implementation-specific. NOTE: most feed flexibility has been moved to feed generator mechanism."
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feed'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feed: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#feedViewPost'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedLike: {
        lexicon: 1,
        id: 'app.bsky.feed.like',
        defs: {
            main: {
                type: 'record',
                description: "Record declaring a 'like' of a piece of subject content.",
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'ref',
                            ref: 'lex:com.atproto.repo.strongRef'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        },
                        via: {
                            type: 'ref',
                            ref: 'lex:com.atproto.repo.strongRef'
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedPost: {
        lexicon: 1,
        id: 'app.bsky.feed.post',
        defs: {
            main: {
                type: 'record',
                description: 'Record containing a Bluesky post.',
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'text',
                        'createdAt'
                    ],
                    properties: {
                        text: {
                            type: 'string',
                            maxLength: 3000,
                            maxGraphemes: 300,
                            description: 'The primary post content. May be an empty string, if there are embeds.'
                        },
                        entities: {
                            type: 'array',
                            description: 'DEPRECATED: replaced by app.bsky.richtext.facet.',
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.feed.post#entity'
                            }
                        },
                        facets: {
                            type: 'array',
                            description: 'Annotations of text (mentions, URLs, hashtags, etc)',
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.richtext.facet'
                            }
                        },
                        reply: {
                            type: 'ref',
                            ref: 'lex:app.bsky.feed.post#replyRef'
                        },
                        embed: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.embed.images',
                                'lex:app.bsky.embed.video',
                                'lex:app.bsky.embed.external',
                                'lex:app.bsky.embed.record',
                                'lex:app.bsky.embed.recordWithMedia'
                            ]
                        },
                        langs: {
                            type: 'array',
                            description: 'Indicates human language of post primary text content.',
                            maxLength: 3,
                            items: {
                                type: 'string',
                                format: 'language'
                            }
                        },
                        labels: {
                            type: 'union',
                            description: 'Self-label values for this post. Effectively content warnings.',
                            refs: [
                                'lex:com.atproto.label.defs#selfLabels'
                            ]
                        },
                        tags: {
                            type: 'array',
                            description: 'Additional hashtags, in addition to any included in post text and facets.',
                            maxLength: 8,
                            items: {
                                type: 'string',
                                maxLength: 640,
                                maxGraphemes: 64
                            }
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Client-declared timestamp when this post was originally created.'
                        }
                    }
                }
            },
            replyRef: {
                type: 'object',
                required: [
                    'root',
                    'parent'
                ],
                properties: {
                    root: {
                        type: 'ref',
                        ref: 'lex:com.atproto.repo.strongRef'
                    },
                    parent: {
                        type: 'ref',
                        ref: 'lex:com.atproto.repo.strongRef'
                    }
                }
            },
            entity: {
                type: 'object',
                description: 'Deprecated: use facets instead.',
                required: [
                    'index',
                    'type',
                    'value'
                ],
                properties: {
                    index: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.post#textSlice'
                    },
                    type: {
                        type: 'string',
                        description: "Expected values are 'mention' and 'link'."
                    },
                    value: {
                        type: 'string'
                    }
                }
            },
            textSlice: {
                type: 'object',
                description: 'Deprecated. Use app.bsky.richtext instead -- A text segment. Start is inclusive, end is exclusive. Indices are for utf16-encoded strings.',
                required: [
                    'start',
                    'end'
                ],
                properties: {
                    start: {
                        type: 'integer',
                        minimum: 0
                    },
                    end: {
                        type: 'integer',
                        minimum: 0
                    }
                }
            }
        }
    },
    AppBskyFeedPostgate: {
        lexicon: 1,
        id: 'app.bsky.feed.postgate',
        defs: {
            main: {
                type: 'record',
                key: 'tid',
                description: 'Record defining interaction rules for a post. The record key (rkey) of the postgate record must match the record key of the post, and that record must be in the same repository.',
                record: {
                    type: 'object',
                    required: [
                        'post',
                        'createdAt'
                    ],
                    properties: {
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        },
                        post: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the post record.'
                        },
                        detachedEmbeddingUris: {
                            type: 'array',
                            maxLength: 50,
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            description: 'List of AT-URIs embedding this post that the author has detached from.'
                        },
                        embeddingRules: {
                            description: 'List of rules defining who can embed this post. If value is an empty array or is undefined, no particular rules apply and anyone can embed.',
                            type: 'array',
                            maxLength: 5,
                            items: {
                                type: 'union',
                                refs: [
                                    'lex:app.bsky.feed.postgate#disableRule'
                                ]
                            }
                        }
                    }
                }
            },
            disableRule: {
                type: 'object',
                description: 'Disables embedding of this post.',
                properties: {}
            }
        }
    },
    AppBskyFeedRepost: {
        lexicon: 1,
        id: 'app.bsky.feed.repost',
        defs: {
            main: {
                description: "Record representing a 'repost' of an existing Bluesky post.",
                type: 'record',
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'ref',
                            ref: 'lex:com.atproto.repo.strongRef'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        },
                        via: {
                            type: 'ref',
                            ref: 'lex:com.atproto.repo.strongRef'
                        }
                    }
                }
            }
        }
    },
    AppBskyFeedSearchPosts: {
        lexicon: 1,
        id: 'app.bsky.feed.searchPosts',
        defs: {
            main: {
                type: 'query',
                description: 'Find posts matching search criteria, returning views of those posts. Note that this API endpoint may require authentication (eg, not public) for some service providers and implementations.',
                parameters: {
                    type: 'params',
                    required: [
                        'q'
                    ],
                    properties: {
                        q: {
                            type: 'string',
                            description: 'Search query string; syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended.'
                        },
                        sort: {
                            type: 'string',
                            knownValues: [
                                'top',
                                'latest'
                            ],
                            default: 'latest',
                            description: 'Specifies the ranking order of results.'
                        },
                        since: {
                            type: 'string',
                            description: "Filter results for posts after the indicated datetime (inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYYY-MM-DD)."
                        },
                        until: {
                            type: 'string',
                            description: "Filter results for posts before the indicated datetime (not inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYY-MM-DD)."
                        },
                        mentions: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Filter to posts which mention the given account. Handles are resolved to DID before query-time. Only matches rich-text facet mentions.'
                        },
                        author: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Filter to posts by the given account. Handles are resolved to DID before query-time.'
                        },
                        lang: {
                            type: 'string',
                            format: 'language',
                            description: 'Filter to posts in the given language. Expected to be based on post language field, though server may override language detection.'
                        },
                        domain: {
                            type: 'string',
                            description: 'Filter to posts with URLs (facet links or embeds) linking to the given domain (hostname). Server may apply hostname normalization.'
                        },
                        url: {
                            type: 'string',
                            format: 'uri',
                            description: 'Filter to posts with links (facet links or embeds) pointing to this URL. Server may apply URL normalization or fuzzy matching.'
                        },
                        tag: {
                            type: 'array',
                            items: {
                                type: 'string',
                                maxLength: 640,
                                maxGraphemes: 64
                            },
                            description: "Filter to posts with the given tag (hashtag), based on rich-text facet or tag field. Do not include the hash (#) prefix. Multiple tags can be specified, with 'AND' matching."
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string',
                            description: 'Optional pagination mechanism; may not necessarily allow scrolling through entire result set.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'posts'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            hitsTotal: {
                                type: 'integer',
                                description: 'Count of search hits. Optional, may be rounded/truncated, and may not be possible to paginate through all hits.'
                            },
                            posts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#postView'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BadQueryString'
                    }
                ]
            }
        }
    },
    AppBskyFeedSendInteractions: {
        lexicon: 1,
        id: 'app.bsky.feed.sendInteractions',
        defs: {
            main: {
                type: 'procedure',
                description: 'Send information about interactions with feed items back to the feed generator that served them.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'interactions'
                        ],
                        properties: {
                            interactions: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#interaction'
                                }
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {}
                    }
                }
            }
        }
    },
    AppBskyFeedThreadgate: {
        lexicon: 1,
        id: 'app.bsky.feed.threadgate',
        defs: {
            main: {
                type: 'record',
                key: 'tid',
                description: "Record defining interaction gating rules for a thread (aka, reply controls). The record key (rkey) of the threadgate record must match the record key of the thread's root post, and that record must be in the same repository.",
                record: {
                    type: 'object',
                    required: [
                        'post',
                        'createdAt'
                    ],
                    properties: {
                        post: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the post record.'
                        },
                        allow: {
                            description: 'List of rules defining who can reply to this post. If value is an empty array, no one can reply. If value is undefined, anyone can reply.',
                            type: 'array',
                            maxLength: 5,
                            items: {
                                type: 'union',
                                refs: [
                                    'lex:app.bsky.feed.threadgate#mentionRule',
                                    'lex:app.bsky.feed.threadgate#followerRule',
                                    'lex:app.bsky.feed.threadgate#followingRule',
                                    'lex:app.bsky.feed.threadgate#listRule'
                                ]
                            }
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        },
                        hiddenReplies: {
                            type: 'array',
                            maxLength: 50,
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            description: 'List of hidden reply URIs.'
                        }
                    }
                }
            },
            mentionRule: {
                type: 'object',
                description: 'Allow replies from actors mentioned in your post.',
                properties: {}
            },
            followerRule: {
                type: 'object',
                description: 'Allow replies from actors who follow you.',
                properties: {}
            },
            followingRule: {
                type: 'object',
                description: 'Allow replies from actors you follow.',
                properties: {}
            },
            listRule: {
                type: 'object',
                description: 'Allow replies from actors on a list.',
                required: [
                    'list'
                ],
                properties: {
                    list: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            }
        }
    },
    AppBskyGraphBlock: {
        lexicon: 1,
        id: 'app.bsky.graph.block',
        defs: {
            main: {
                type: 'record',
                description: "Record declaring a 'block' relationship against another account. NOTE: blocks are public in Bluesky; see blog posts for details.",
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account to be blocked.'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphDefs: {
        lexicon: 1,
        id: 'app.bsky.graph.defs',
        defs: {
            listViewBasic: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'name',
                    'purpose'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    name: {
                        type: 'string',
                        maxLength: 64,
                        minLength: 1
                    },
                    purpose: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listPurpose'
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    listItemCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listViewerState'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            listView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'creator',
                    'name',
                    'purpose',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    },
                    name: {
                        type: 'string',
                        maxLength: 64,
                        minLength: 1
                    },
                    purpose: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listPurpose'
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 300,
                        maxLength: 3000
                    },
                    descriptionFacets: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.richtext.facet'
                        }
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    listItemCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listViewerState'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            listItemView: {
                type: 'object',
                required: [
                    'uri',
                    'subject'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    subject: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    }
                }
            },
            starterPackView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'record',
                    'creator',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    record: {
                        type: 'unknown'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                    },
                    list: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listViewBasic'
                    },
                    listItemsSample: {
                        type: 'array',
                        maxLength: 12,
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.graph.defs#listItemView'
                        }
                    },
                    feeds: {
                        type: 'array',
                        maxLength: 3,
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.feed.defs#generatorView'
                        }
                    },
                    joinedWeekCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    joinedAllTimeCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            starterPackViewBasic: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'record',
                    'creator',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    record: {
                        type: 'unknown'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                    },
                    listItemCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    joinedWeekCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    joinedAllTimeCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            listPurpose: {
                type: 'string',
                knownValues: [
                    'app.bsky.graph.defs#modlist',
                    'app.bsky.graph.defs#curatelist',
                    'app.bsky.graph.defs#referencelist'
                ]
            },
            modlist: {
                type: 'token',
                description: 'A list of actors to apply an aggregate moderation action (mute/block) on.'
            },
            curatelist: {
                type: 'token',
                description: 'A list of actors used for curation purposes such as list feeds or interaction gating.'
            },
            referencelist: {
                type: 'token',
                description: 'A list of actors used for only for reference purposes such as within a starter pack.'
            },
            listViewerState: {
                type: 'object',
                properties: {
                    muted: {
                        type: 'boolean'
                    },
                    blocked: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            notFoundActor: {
                type: 'object',
                description: 'indicates that a handle or DID could not be resolved',
                required: [
                    'actor',
                    'notFound'
                ],
                properties: {
                    actor: {
                        type: 'string',
                        format: 'at-identifier'
                    },
                    notFound: {
                        type: 'boolean',
                        const: true
                    }
                }
            },
            relationship: {
                type: 'object',
                description: 'lists the bi-directional graph relationships between one actor (not indicated in the object), and the target actors (the DID included in the object)',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    following: {
                        type: 'string',
                        format: 'at-uri',
                        description: 'if the actor follows this DID, this is the AT-URI of the follow record'
                    },
                    followedBy: {
                        type: 'string',
                        format: 'at-uri',
                        description: 'if the actor is followed by this DID, contains the AT-URI of the follow record'
                    }
                }
            }
        }
    },
    AppBskyGraphFollow: {
        lexicon: 1,
        id: 'app.bsky.graph.follow',
        defs: {
            main: {
                type: 'record',
                description: "Record declaring a social 'follow' relationship of another account. Duplicate follows will be ignored by the AppView.",
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'string',
                            format: 'did'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetActorStarterPacks: {
        lexicon: 1,
        id: 'app.bsky.graph.getActorStarterPacks',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of starter packs created by the actor.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#starterPackViewBasic'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetBlocks: {
        lexicon: 1,
        id: 'app.bsky.graph.getBlocks',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates which accounts the requesting account is currently blocking. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'blocks'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            blocks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetFollowers: {
        lexicon: 1,
        id: 'app.bsky.graph.getFollowers',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates accounts which follow a specified account (actor).',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject',
                            'followers'
                        ],
                        properties: {
                            subject: {
                                type: 'ref',
                                ref: 'lex:app.bsky.actor.defs#profileView'
                            },
                            cursor: {
                                type: 'string'
                            },
                            followers: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetFollows: {
        lexicon: 1,
        id: 'app.bsky.graph.getFollows',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates accounts which a specified account (actor) follows.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject',
                            'follows'
                        ],
                        properties: {
                            subject: {
                                type: 'ref',
                                ref: 'lex:app.bsky.actor.defs#profileView'
                            },
                            cursor: {
                                type: 'string'
                            },
                            follows: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetKnownFollowers: {
        lexicon: 1,
        id: 'app.bsky.graph.getKnownFollowers',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates accounts which follow a specified account (actor) and are followed by the viewer.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject',
                            'followers'
                        ],
                        properties: {
                            subject: {
                                type: 'ref',
                                ref: 'lex:app.bsky.actor.defs#profileView'
                            },
                            cursor: {
                                type: 'string'
                            },
                            followers: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetList: {
        lexicon: 1,
        id: 'app.bsky.graph.getList',
        defs: {
            main: {
                type: 'query',
                description: "Gets a 'view' (with additional context) of a specified list.",
                parameters: {
                    type: 'params',
                    required: [
                        'list'
                    ],
                    properties: {
                        list: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) of the list record to hydrate.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'list',
                            'items'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            list: {
                                type: 'ref',
                                ref: 'lex:app.bsky.graph.defs#listView'
                            },
                            items: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#listItemView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetListBlocks: {
        lexicon: 1,
        id: 'app.bsky.graph.getListBlocks',
        defs: {
            main: {
                type: 'query',
                description: 'Get mod lists that the requesting account (actor) is blocking. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'lists'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            lists: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#listView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetListMutes: {
        lexicon: 1,
        id: 'app.bsky.graph.getListMutes',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates mod lists that the requesting account (actor) currently has muted. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'lists'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            lists: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#listView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetLists: {
        lexicon: 1,
        id: 'app.bsky.graph.getLists',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates the lists created by a specified account (actor).',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'The account (actor) to enumerate lists from.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        purposes: {
                            type: 'array',
                            description: 'Optional filter by list purpose. If not specified, all supported types are returned.',
                            items: {
                                type: 'string',
                                knownValues: [
                                    'modlist',
                                    'curatelist'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'lists'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            lists: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#listView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetListsWithMembership: {
        lexicon: 1,
        id: 'app.bsky.graph.getListsWithMembership',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates the lists created by the session user, and includes membership information about `actor` in those lists. Only supports curation and moderation lists (no reference lists, used in starter packs). Requires auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'The account (actor) to check for membership.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        purposes: {
                            type: 'array',
                            description: 'Optional filter by list purpose. If not specified, all supported types are returned.',
                            items: {
                                type: 'string',
                                knownValues: [
                                    'modlist',
                                    'curatelist'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'listsWithMembership'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            listsWithMembership: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.getListsWithMembership#listWithMembership'
                                }
                            }
                        }
                    }
                }
            },
            listWithMembership: {
                description: 'A list and an optional list item indicating membership of a target user to that list.',
                type: 'object',
                required: [
                    'list'
                ],
                properties: {
                    list: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listView'
                    },
                    listItem: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listItemView'
                    }
                }
            }
        }
    },
    AppBskyGraphGetMutes: {
        lexicon: 1,
        id: 'app.bsky.graph.getMutes',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates accounts that the requesting account (actor) currently has muted. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'mutes'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            mutes: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetRelationships: {
        lexicon: 1,
        id: 'app.bsky.graph.getRelationships',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates public relationships between one account, and a list of other accounts. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Primary account requesting relationships for.'
                        },
                        others: {
                            type: 'array',
                            description: "List of 'other' accounts to be related back to the primary.",
                            maxLength: 30,
                            items: {
                                type: 'string',
                                format: 'at-identifier'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'relationships'
                        ],
                        properties: {
                            actor: {
                                type: 'string',
                                format: 'did'
                            },
                            relationships: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:app.bsky.graph.defs#relationship',
                                        'lex:app.bsky.graph.defs#notFoundActor'
                                    ]
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'ActorNotFound',
                        description: 'the primary actor at-identifier could not be resolved'
                    }
                ]
            }
        }
    },
    AppBskyGraphGetStarterPack: {
        lexicon: 1,
        id: 'app.bsky.graph.getStarterPack',
        defs: {
            main: {
                type: 'query',
                description: 'Gets a view of a starter pack.',
                parameters: {
                    type: 'params',
                    required: [
                        'starterPack'
                    ],
                    properties: {
                        starterPack: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) of the starter pack record.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPack'
                        ],
                        properties: {
                            starterPack: {
                                type: 'ref',
                                ref: 'lex:app.bsky.graph.defs#starterPackView'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetStarterPacks: {
        lexicon: 1,
        id: 'app.bsky.graph.getStarterPacks',
        defs: {
            main: {
                type: 'query',
                description: 'Get views for a list of starter packs.',
                parameters: {
                    type: 'params',
                    required: [
                        'uris'
                    ],
                    properties: {
                        uris: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            maxLength: 25
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#starterPackViewBasic'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphGetStarterPacksWithMembership: {
        lexicon: 1,
        id: 'app.bsky.graph.getStarterPacksWithMembership',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates the starter packs created by the session user, and includes membership information about `actor` in those starter packs. Requires auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'The account (actor) to check for membership.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacksWithMembership'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            starterPacksWithMembership: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.getStarterPacksWithMembership#starterPackWithMembership'
                                }
                            }
                        }
                    }
                }
            },
            starterPackWithMembership: {
                description: 'A starter pack and an optional list item indicating membership of a target user to that starter pack.',
                type: 'object',
                required: [
                    'starterPack'
                ],
                properties: {
                    starterPack: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#starterPackView'
                    },
                    listItem: {
                        type: 'ref',
                        ref: 'lex:app.bsky.graph.defs#listItemView'
                    }
                }
            }
        }
    },
    AppBskyGraphGetSuggestedFollowsByActor: {
        lexicon: 1,
        id: 'app.bsky.graph.getSuggestedFollowsByActor',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates follows similar to a given account (actor). Expected use is to recommend additional accounts immediately after following one account.',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'at-identifier'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'suggestions'
                        ],
                        properties: {
                            suggestions: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            },
                            isFallback: {
                                type: 'boolean',
                                description: 'If true, response has fallen-back to generic results, and is not scoped using relativeToDid',
                                default: false
                            },
                            recId: {
                                type: 'integer',
                                description: 'Snowflake for this recommendation, use when submitting recommendation events.'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphList: {
        lexicon: 1,
        id: 'app.bsky.graph.list',
        defs: {
            main: {
                type: 'record',
                description: 'Record representing a list of accounts (actors). Scope includes both moderation-oriented lists and curration-oriented lists.',
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'name',
                        'purpose',
                        'createdAt'
                    ],
                    properties: {
                        purpose: {
                            type: 'ref',
                            description: 'Defines the purpose of the list (aka, moderation-oriented or curration-oriented)',
                            ref: 'lex:app.bsky.graph.defs#listPurpose'
                        },
                        name: {
                            type: 'string',
                            maxLength: 64,
                            minLength: 1,
                            description: 'Display name for list; can not be empty.'
                        },
                        description: {
                            type: 'string',
                            maxGraphemes: 300,
                            maxLength: 3000
                        },
                        descriptionFacets: {
                            type: 'array',
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.richtext.facet'
                            }
                        },
                        avatar: {
                            type: 'blob',
                            accept: [
                                'image/png',
                                'image/jpeg'
                            ],
                            maxSize: 1000000
                        },
                        labels: {
                            type: 'union',
                            refs: [
                                'lex:com.atproto.label.defs#selfLabels'
                            ]
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphListblock: {
        lexicon: 1,
        id: 'app.bsky.graph.listblock',
        defs: {
            main: {
                type: 'record',
                description: 'Record representing a block relationship against an entire an entire list of accounts (actors).',
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the mod list record.'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphListitem: {
        lexicon: 1,
        id: 'app.bsky.graph.listitem',
        defs: {
            main: {
                type: 'record',
                description: "Record representing an account's inclusion on a specific list. The AppView will ignore duplicate listitem records.",
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'list',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            type: 'string',
                            format: 'did',
                            description: 'The account which is included on the list.'
                        },
                        list: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the list record (app.bsky.graph.list).'
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphMuteActor: {
        lexicon: 1,
        id: 'app.bsky.graph.muteActor',
        defs: {
            main: {
                type: 'procedure',
                description: 'Creates a mute relationship for the specified account. Mutes are private in Bluesky. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actor'
                        ],
                        properties: {
                            actor: {
                                type: 'string',
                                format: 'at-identifier'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphMuteActorList: {
        lexicon: 1,
        id: 'app.bsky.graph.muteActorList',
        defs: {
            main: {
                type: 'procedure',
                description: 'Creates a mute relationship for the specified list of accounts. Mutes are private in Bluesky. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'list'
                        ],
                        properties: {
                            list: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphMuteThread: {
        lexicon: 1,
        id: 'app.bsky.graph.muteThread',
        defs: {
            main: {
                type: 'procedure',
                description: 'Mutes a thread preventing notifications from the thread and any of its children. Mutes are private in Bluesky. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'root'
                        ],
                        properties: {
                            root: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphSearchStarterPacks: {
        lexicon: 1,
        id: 'app.bsky.graph.searchStarterPacks',
        defs: {
            main: {
                type: 'query',
                description: 'Find starter packs matching search criteria. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'q'
                    ],
                    properties: {
                        q: {
                            type: 'string',
                            description: 'Search query string. Syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#starterPackViewBasic'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphStarterpack: {
        lexicon: 1,
        id: 'app.bsky.graph.starterpack',
        defs: {
            main: {
                type: 'record',
                description: 'Record defining a starter pack of actors and feeds for new users.',
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'name',
                        'list',
                        'createdAt'
                    ],
                    properties: {
                        name: {
                            type: 'string',
                            maxGraphemes: 50,
                            maxLength: 500,
                            minLength: 1,
                            description: 'Display name for starter pack; can not be empty.'
                        },
                        description: {
                            type: 'string',
                            maxGraphemes: 300,
                            maxLength: 3000
                        },
                        descriptionFacets: {
                            type: 'array',
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.richtext.facet'
                            }
                        },
                        list: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to the list record.'
                        },
                        feeds: {
                            type: 'array',
                            maxLength: 3,
                            items: {
                                type: 'ref',
                                ref: 'lex:app.bsky.graph.starterpack#feedItem'
                            }
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            },
            feedItem: {
                type: 'object',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            }
        }
    },
    AppBskyGraphUnmuteActor: {
        lexicon: 1,
        id: 'app.bsky.graph.unmuteActor',
        defs: {
            main: {
                type: 'procedure',
                description: 'Unmutes the specified account. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actor'
                        ],
                        properties: {
                            actor: {
                                type: 'string',
                                format: 'at-identifier'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphUnmuteActorList: {
        lexicon: 1,
        id: 'app.bsky.graph.unmuteActorList',
        defs: {
            main: {
                type: 'procedure',
                description: 'Unmutes the specified list of accounts. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'list'
                        ],
                        properties: {
                            list: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphUnmuteThread: {
        lexicon: 1,
        id: 'app.bsky.graph.unmuteThread',
        defs: {
            main: {
                type: 'procedure',
                description: 'Unmutes the specified thread. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'root'
                        ],
                        properties: {
                            root: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyGraphVerification: {
        lexicon: 1,
        id: 'app.bsky.graph.verification',
        defs: {
            main: {
                type: 'record',
                description: 'Record declaring a verification relationship between two accounts. Verifications are only considered valid by an app if issued by an account the app considers trusted.',
                key: 'tid',
                record: {
                    type: 'object',
                    required: [
                        'subject',
                        'handle',
                        'displayName',
                        'createdAt'
                    ],
                    properties: {
                        subject: {
                            description: 'DID of the subject the verification applies to.',
                            type: 'string',
                            format: 'did'
                        },
                        handle: {
                            description: 'Handle of the subject the verification applies to at the moment of verifying, which might not be the same at the time of viewing. The verification is only valid if the current handle matches the one at the time of verifying.',
                            type: 'string',
                            format: 'handle'
                        },
                        displayName: {
                            description: 'Display name of the subject the verification applies to at the moment of verifying, which might not be the same at the time of viewing. The verification is only valid if the current displayName matches the one at the time of verifying.',
                            type: 'string'
                        },
                        createdAt: {
                            description: 'Date of when the verification was created.',
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                }
            }
        }
    },
    AppBskyLabelerDefs: {
        lexicon: 1,
        id: 'app.bsky.labeler.defs',
        defs: {
            labelerView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'creator',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    },
                    likeCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.labeler.defs#labelerViewerState'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    }
                }
            },
            labelerViewDetailed: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'creator',
                    'policies',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    creator: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    },
                    policies: {
                        type: 'ref',
                        ref: 'lex:app.bsky.labeler.defs#labelerPolicies'
                    },
                    likeCount: {
                        type: 'integer',
                        minimum: 0
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.labeler.defs#labelerViewerState'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    reasonTypes: {
                        description: "The set of report reason 'codes' which are in-scope for this service to review and action. These usually align to policy categories. If not defined (distinct from empty array), all reason types are allowed.",
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.moderation.defs#reasonType'
                        }
                    },
                    subjectTypes: {
                        description: 'The set of subject types (account, record, etc) this service accepts reports on.',
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.moderation.defs#subjectType'
                        }
                    },
                    subjectCollections: {
                        type: 'array',
                        description: 'Set of record types (collection NSIDs) which can be reported to this service. If not defined (distinct from empty array), default is any record type.',
                        items: {
                            type: 'string',
                            format: 'nsid'
                        }
                    }
                }
            },
            labelerViewerState: {
                type: 'object',
                properties: {
                    like: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            labelerPolicies: {
                type: 'object',
                required: [
                    'labelValues'
                ],
                properties: {
                    labelValues: {
                        type: 'array',
                        description: 'The label values which this labeler publishes. May include global or custom labels.',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#labelValue'
                        }
                    },
                    labelValueDefinitions: {
                        type: 'array',
                        description: 'Label values created by this labeler and scoped exclusively to it. Labels defined here will override global label definitions for this labeler.',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#labelValueDefinition'
                        }
                    }
                }
            }
        }
    },
    AppBskyLabelerGetServices: {
        lexicon: 1,
        id: 'app.bsky.labeler.getServices',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about a list of labeler services.',
                parameters: {
                    type: 'params',
                    required: [
                        'dids'
                    ],
                    properties: {
                        dids: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        },
                        detailed: {
                            type: 'boolean',
                            default: false
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'views'
                        ],
                        properties: {
                            views: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:app.bsky.labeler.defs#labelerView',
                                        'lex:app.bsky.labeler.defs#labelerViewDetailed'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyLabelerService: {
        lexicon: 1,
        id: 'app.bsky.labeler.service',
        defs: {
            main: {
                type: 'record',
                description: 'A declaration of the existence of labeler service.',
                key: 'literal:self',
                record: {
                    type: 'object',
                    required: [
                        'policies',
                        'createdAt'
                    ],
                    properties: {
                        policies: {
                            type: 'ref',
                            ref: 'lex:app.bsky.labeler.defs#labelerPolicies'
                        },
                        labels: {
                            type: 'union',
                            refs: [
                                'lex:com.atproto.label.defs#selfLabels'
                            ]
                        },
                        createdAt: {
                            type: 'string',
                            format: 'datetime'
                        },
                        reasonTypes: {
                            description: "The set of report reason 'codes' which are in-scope for this service to review and action. These usually align to policy categories. If not defined (distinct from empty array), all reason types are allowed.",
                            type: 'array',
                            items: {
                                type: 'ref',
                                ref: 'lex:com.atproto.moderation.defs#reasonType'
                            }
                        },
                        subjectTypes: {
                            description: 'The set of subject types (account, record, etc) this service accepts reports on.',
                            type: 'array',
                            items: {
                                type: 'ref',
                                ref: 'lex:com.atproto.moderation.defs#subjectType'
                            }
                        },
                        subjectCollections: {
                            type: 'array',
                            description: 'Set of record types (collection NSIDs) which can be reported to this service. If not defined (distinct from empty array), default is any record type.',
                            items: {
                                type: 'string',
                                format: 'nsid'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationDeclaration: {
        lexicon: 1,
        id: 'app.bsky.notification.declaration',
        defs: {
            main: {
                type: 'record',
                description: "A declaration of the user's choices related to notifications that can be produced by them.",
                key: 'literal:self',
                record: {
                    type: 'object',
                    required: [
                        'allowSubscriptions'
                    ],
                    properties: {
                        allowSubscriptions: {
                            type: 'string',
                            description: "A declaration of the user's preference for allowing activity subscriptions from other users. Absence of a record implies 'followers'.",
                            knownValues: [
                                'followers',
                                'mutuals',
                                'none'
                            ]
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationDefs: {
        lexicon: 1,
        id: 'app.bsky.notification.defs',
        defs: {
            recordDeleted: {
                type: 'object',
                properties: {}
            },
            chatPreference: {
                type: 'object',
                required: [
                    'include',
                    'push'
                ],
                properties: {
                    include: {
                        type: 'string',
                        knownValues: [
                            'all',
                            'accepted'
                        ]
                    },
                    push: {
                        type: 'boolean'
                    }
                }
            },
            filterablePreference: {
                type: 'object',
                required: [
                    'include',
                    'list',
                    'push'
                ],
                properties: {
                    include: {
                        type: 'string',
                        knownValues: [
                            'all',
                            'follows'
                        ]
                    },
                    list: {
                        type: 'boolean'
                    },
                    push: {
                        type: 'boolean'
                    }
                }
            },
            preference: {
                type: 'object',
                required: [
                    'list',
                    'push'
                ],
                properties: {
                    list: {
                        type: 'boolean'
                    },
                    push: {
                        type: 'boolean'
                    }
                }
            },
            preferences: {
                type: 'object',
                required: [
                    'chat',
                    'follow',
                    'like',
                    'likeViaRepost',
                    'mention',
                    'quote',
                    'reply',
                    'repost',
                    'repostViaRepost',
                    'starterpackJoined',
                    'subscribedPost',
                    'unverified',
                    'verified'
                ],
                properties: {
                    chat: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#chatPreference'
                    },
                    follow: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#filterablePreference'
                    },
                    like: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#filterablePreference'
                    },
                    likeViaRepost: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#filterablePreference'
                    },
                    mention: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#filterablePreference'
                    },
                    quote: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#filterablePreference'
                    },
                    reply: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#filterablePreference'
                    },
                    repost: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#filterablePreference'
                    },
                    repostViaRepost: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#filterablePreference'
                    },
                    starterpackJoined: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#preference'
                    },
                    subscribedPost: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#preference'
                    },
                    unverified: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#preference'
                    },
                    verified: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#preference'
                    }
                }
            },
            activitySubscription: {
                type: 'object',
                required: [
                    'post',
                    'reply'
                ],
                properties: {
                    post: {
                        type: 'boolean'
                    },
                    reply: {
                        type: 'boolean'
                    }
                }
            },
            subjectActivitySubscription: {
                description: 'Object used to store activity subscription data in stash.',
                type: 'object',
                required: [
                    'subject',
                    'activitySubscription'
                ],
                properties: {
                    subject: {
                        type: 'string',
                        format: 'did'
                    },
                    activitySubscription: {
                        type: 'ref',
                        ref: 'lex:app.bsky.notification.defs#activitySubscription'
                    }
                }
            }
        }
    },
    AppBskyNotificationGetPreferences: {
        lexicon: 1,
        id: 'app.bsky.notification.getPreferences',
        defs: {
            main: {
                type: 'query',
                description: 'Get notification-related preferences for an account. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {}
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'preferences'
                        ],
                        properties: {
                            preferences: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#preferences'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationGetUnreadCount: {
        lexicon: 1,
        id: 'app.bsky.notification.getUnreadCount',
        defs: {
            main: {
                type: 'query',
                description: 'Count the number of unread notifications for the requesting account. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        priority: {
                            type: 'boolean'
                        },
                        seenAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'count'
                        ],
                        properties: {
                            count: {
                                type: 'integer'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationListActivitySubscriptions: {
        lexicon: 1,
        id: 'app.bsky.notification.listActivitySubscriptions',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerate all accounts to which the requesting account is subscribed to receive notifications for. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subscriptions'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            subscriptions: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationListNotifications: {
        lexicon: 1,
        id: 'app.bsky.notification.listNotifications',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerate notifications for the requesting account. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        reasons: {
                            description: 'Notification reasons to include in response.',
                            type: 'array',
                            items: {
                                type: 'string',
                                description: 'A reason that matches the reason property of #notification.'
                            }
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        priority: {
                            type: 'boolean'
                        },
                        cursor: {
                            type: 'string'
                        },
                        seenAt: {
                            type: 'string',
                            format: 'datetime'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'notifications'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            notifications: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.notification.listNotifications#notification'
                                }
                            },
                            priority: {
                                type: 'boolean'
                            },
                            seenAt: {
                                type: 'string',
                                format: 'datetime'
                            }
                        }
                    }
                }
            },
            notification: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'author',
                    'reason',
                    'record',
                    'isRead',
                    'indexedAt'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    author: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileView'
                    },
                    reason: {
                        type: 'string',
                        description: 'The reason why this notification was delivered - e.g. your post was liked, or you received a new follower.',
                        knownValues: [
                            'like',
                            'repost',
                            'follow',
                            'mention',
                            'reply',
                            'quote',
                            'starterpack-joined',
                            'verified',
                            'unverified',
                            'like-via-repost',
                            'repost-via-repost',
                            'subscribed-post'
                        ]
                    },
                    reasonSubject: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    record: {
                        type: 'unknown'
                    },
                    isRead: {
                        type: 'boolean'
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationPutActivitySubscription: {
        lexicon: 1,
        id: 'app.bsky.notification.putActivitySubscription',
        defs: {
            main: {
                type: 'procedure',
                description: 'Puts an activity subscription entry. The key should be omitted for creation and provided for updates. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject',
                            'activitySubscription'
                        ],
                        properties: {
                            subject: {
                                type: 'string',
                                format: 'did'
                            },
                            activitySubscription: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#activitySubscription'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject'
                        ],
                        properties: {
                            subject: {
                                type: 'string',
                                format: 'did'
                            },
                            activitySubscription: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#activitySubscription'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationPutPreferences: {
        lexicon: 1,
        id: 'app.bsky.notification.putPreferences',
        defs: {
            main: {
                type: 'procedure',
                description: 'Set notification-related preferences for an account. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'priority'
                        ],
                        properties: {
                            priority: {
                                type: 'boolean'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationPutPreferencesV2: {
        lexicon: 1,
        id: 'app.bsky.notification.putPreferencesV2',
        defs: {
            main: {
                type: 'procedure',
                description: 'Set notification-related preferences for an account. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            chat: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#chatPreference'
                            },
                            follow: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#filterablePreference'
                            },
                            like: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#filterablePreference'
                            },
                            likeViaRepost: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#filterablePreference'
                            },
                            mention: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#filterablePreference'
                            },
                            quote: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#filterablePreference'
                            },
                            reply: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#filterablePreference'
                            },
                            repost: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#filterablePreference'
                            },
                            repostViaRepost: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#filterablePreference'
                            },
                            starterpackJoined: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#preference'
                            },
                            subscribedPost: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#preference'
                            },
                            unverified: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#preference'
                            },
                            verified: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#preference'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'preferences'
                        ],
                        properties: {
                            preferences: {
                                type: 'ref',
                                ref: 'lex:app.bsky.notification.defs#preferences'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationRegisterPush: {
        lexicon: 1,
        id: 'app.bsky.notification.registerPush',
        defs: {
            main: {
                type: 'procedure',
                description: 'Register to receive push notifications, via a specified service, for the requesting account. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'serviceDid',
                            'token',
                            'platform',
                            'appId'
                        ],
                        properties: {
                            serviceDid: {
                                type: 'string',
                                format: 'did'
                            },
                            token: {
                                type: 'string'
                            },
                            platform: {
                                type: 'string',
                                knownValues: [
                                    'ios',
                                    'android',
                                    'web'
                                ]
                            },
                            appId: {
                                type: 'string'
                            },
                            ageRestricted: {
                                type: 'boolean',
                                description: 'Set to true when the actor is age restricted'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationUnregisterPush: {
        lexicon: 1,
        id: 'app.bsky.notification.unregisterPush',
        defs: {
            main: {
                type: 'procedure',
                description: 'The inverse of registerPush - inform a specified service that push notifications should no longer be sent to the given token for the requesting account. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'serviceDid',
                            'token',
                            'platform',
                            'appId'
                        ],
                        properties: {
                            serviceDid: {
                                type: 'string',
                                format: 'did'
                            },
                            token: {
                                type: 'string'
                            },
                            platform: {
                                type: 'string',
                                knownValues: [
                                    'ios',
                                    'android',
                                    'web'
                                ]
                            },
                            appId: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyNotificationUpdateSeen: {
        lexicon: 1,
        id: 'app.bsky.notification.updateSeen',
        defs: {
            main: {
                type: 'procedure',
                description: 'Notify server that the requesting account has seen notifications. Requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'seenAt'
                        ],
                        properties: {
                            seenAt: {
                                type: 'string',
                                format: 'datetime'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyRichtextFacet: {
        lexicon: 1,
        id: 'app.bsky.richtext.facet',
        defs: {
            main: {
                type: 'object',
                description: 'Annotation of a sub-string within rich text.',
                required: [
                    'index',
                    'features'
                ],
                properties: {
                    index: {
                        type: 'ref',
                        ref: 'lex:app.bsky.richtext.facet#byteSlice'
                    },
                    features: {
                        type: 'array',
                        items: {
                            type: 'union',
                            refs: [
                                'lex:app.bsky.richtext.facet#mention',
                                'lex:app.bsky.richtext.facet#link',
                                'lex:app.bsky.richtext.facet#tag'
                            ]
                        }
                    }
                }
            },
            mention: {
                type: 'object',
                description: "Facet feature for mention of another account. The text is usually a handle, including a '@' prefix, but the facet reference is a DID.",
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            link: {
                type: 'object',
                description: 'Facet feature for a URL. The text URL may have been simplified or truncated, but the facet reference should be a complete URL.',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'uri'
                    }
                }
            },
            tag: {
                type: 'object',
                description: "Facet feature for a hashtag. The text usually includes a '#' prefix, but the facet reference should not (except in the case of 'double hash tags').",
                required: [
                    'tag'
                ],
                properties: {
                    tag: {
                        type: 'string',
                        maxLength: 640,
                        maxGraphemes: 64
                    }
                }
            },
            byteSlice: {
                type: 'object',
                description: 'Specifies the sub-string range a facet feature applies to. Start index is inclusive, end index is exclusive. Indices are zero-indexed, counting bytes of the UTF-8 encoded text. NOTE: some languages, like Javascript, use UTF-16 or Unicode codepoints for string slice indexing; in these languages, convert to byte arrays before working with facets.',
                required: [
                    'byteStart',
                    'byteEnd'
                ],
                properties: {
                    byteStart: {
                        type: 'integer',
                        minimum: 0
                    },
                    byteEnd: {
                        type: 'integer',
                        minimum: 0
                    }
                }
            }
        }
    },
    AppBskyUnspeccedDefs: {
        lexicon: 1,
        id: 'app.bsky.unspecced.defs',
        defs: {
            skeletonSearchPost: {
                type: 'object',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            skeletonSearchActor: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            skeletonSearchStarterPack: {
                type: 'object',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            trendingTopic: {
                type: 'object',
                required: [
                    'topic',
                    'link'
                ],
                properties: {
                    topic: {
                        type: 'string'
                    },
                    displayName: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    link: {
                        type: 'string'
                    }
                }
            },
            skeletonTrend: {
                type: 'object',
                required: [
                    'topic',
                    'displayName',
                    'link',
                    'startedAt',
                    'postCount',
                    'dids'
                ],
                properties: {
                    topic: {
                        type: 'string'
                    },
                    displayName: {
                        type: 'string'
                    },
                    link: {
                        type: 'string'
                    },
                    startedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    postCount: {
                        type: 'integer'
                    },
                    status: {
                        type: 'string',
                        knownValues: [
                            'hot'
                        ]
                    },
                    category: {
                        type: 'string'
                    },
                    dids: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'did'
                        }
                    }
                }
            },
            trendView: {
                type: 'object',
                required: [
                    'topic',
                    'displayName',
                    'link',
                    'startedAt',
                    'postCount',
                    'actors'
                ],
                properties: {
                    topic: {
                        type: 'string'
                    },
                    displayName: {
                        type: 'string'
                    },
                    link: {
                        type: 'string'
                    },
                    startedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    postCount: {
                        type: 'integer'
                    },
                    status: {
                        type: 'string',
                        knownValues: [
                            'hot'
                        ]
                    },
                    category: {
                        type: 'string'
                    },
                    actors: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.actor.defs#profileViewBasic'
                        }
                    }
                }
            },
            threadItemPost: {
                type: 'object',
                required: [
                    'post',
                    'moreParents',
                    'moreReplies',
                    'opThread',
                    'hiddenByThreadgate',
                    'mutedByViewer'
                ],
                properties: {
                    post: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#postView'
                    },
                    moreParents: {
                        type: 'boolean',
                        description: 'This post has more parents that were not present in the response. This is just a boolean, without the number of parents.'
                    },
                    moreReplies: {
                        type: 'integer',
                        description: 'This post has more replies that were not present in the response. This is a numeric value, which is best-effort and might not be accurate.'
                    },
                    opThread: {
                        type: 'boolean',
                        description: 'This post is part of a contiguous thread by the OP from the thread root. Many different OP threads can happen in the same thread.'
                    },
                    hiddenByThreadgate: {
                        type: 'boolean',
                        description: 'The threadgate created by the author indicates this post as a reply to be hidden for everyone consuming the thread.'
                    },
                    mutedByViewer: {
                        type: 'boolean',
                        description: 'This is by an account muted by the viewer requesting it.'
                    }
                }
            },
            threadItemNoUnauthenticated: {
                type: 'object',
                properties: {}
            },
            threadItemNotFound: {
                type: 'object',
                properties: {}
            },
            threadItemBlocked: {
                type: 'object',
                required: [
                    'author'
                ],
                properties: {
                    author: {
                        type: 'ref',
                        ref: 'lex:app.bsky.feed.defs#blockedAuthor'
                    }
                }
            },
            ageAssuranceState: {
                type: 'object',
                description: 'The computed state of the age assurance process, returned to the user in question on certain authenticated requests.',
                required: [
                    'status'
                ],
                properties: {
                    lastInitiatedAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'The timestamp when this state was last updated.'
                    },
                    status: {
                        type: 'string',
                        description: 'The status of the age assurance process.',
                        knownValues: [
                            'unknown',
                            'pending',
                            'assured',
                            'blocked'
                        ]
                    }
                }
            },
            ageAssuranceEvent: {
                type: 'object',
                description: 'Object used to store age assurance data in stash.',
                required: [
                    'createdAt',
                    'status',
                    'attemptId'
                ],
                properties: {
                    createdAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'The date and time of this write operation.'
                    },
                    status: {
                        type: 'string',
                        description: 'The status of the age assurance process.',
                        knownValues: [
                            'unknown',
                            'pending',
                            'assured'
                        ]
                    },
                    attemptId: {
                        type: 'string',
                        description: 'The unique identifier for this instance of the age assurance flow, in UUID format.'
                    },
                    email: {
                        type: 'string',
                        description: 'The email used for AA.'
                    },
                    initIp: {
                        type: 'string',
                        description: 'The IP address used when initiating the AA flow.'
                    },
                    initUa: {
                        type: 'string',
                        description: 'The user agent used when initiating the AA flow.'
                    },
                    completeIp: {
                        type: 'string',
                        description: 'The IP address used when completing the AA flow.'
                    },
                    completeUa: {
                        type: 'string',
                        description: 'The user agent used when completing the AA flow.'
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetAgeAssuranceState: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getAgeAssuranceState',
        defs: {
            main: {
                type: 'query',
                description: 'Returns the current state of the age assurance process for an account. This is used to check if the user has completed age assurance or if further action is required.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:app.bsky.unspecced.defs#ageAssuranceState'
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetConfig: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getConfig',
        defs: {
            main: {
                type: 'query',
                description: 'Get miscellaneous runtime configuration.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [],
                        properties: {
                            checkEmailConfirmed: {
                                type: 'boolean'
                            },
                            liveNow: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.getConfig#liveNowConfig'
                                }
                            }
                        }
                    }
                }
            },
            liveNowConfig: {
                type: 'object',
                required: [
                    'did',
                    'domains'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    domains: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetOnboardingSuggestedStarterPacks: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getOnboardingSuggestedStarterPacks',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of suggested starterpacks for onboarding',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 25,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#starterPackView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetOnboardingSuggestedStarterPacksSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getOnboardingSuggestedStarterPacksSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Get a skeleton of suggested starterpacks for onboarding. Intended to be called and hydrated by app.bsky.unspecced.getOnboardingSuggestedStarterPacks',
                parameters: {
                    type: 'params',
                    properties: {
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries).'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 25,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                    format: 'at-uri'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetPopularFeedGenerators: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getPopularFeedGenerators',
        defs: {
            main: {
                type: 'query',
                description: 'An unspecced view of globally popular feed generators.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        query: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feeds'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#generatorView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetPostThreadOtherV2: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getPostThreadOtherV2',
        defs: {
            main: {
                type: 'query',
                description: "(NOTE: this endpoint is under development and WILL change without notice. Don't use it until it is moved out of `unspecced` or your application WILL break) Get additional posts under a thread e.g. replies hidden by threadgate. Based on an anchor post at any depth of the tree, returns top-level replies below that anchor. It does not include ancestors nor the anchor itself. This should be called after exhausting `app.bsky.unspecced.getPostThreadV2`. Does not require auth, but additional metadata and filtering will be applied for authed requests.",
                parameters: {
                    type: 'params',
                    required: [
                        'anchor'
                    ],
                    properties: {
                        anchor: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to post record. This is the anchor post.'
                        },
                        prioritizeFollowedUsers: {
                            type: 'boolean',
                            description: 'Whether to prioritize posts from followed users. It only has effect when the user is authenticated.',
                            default: false
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'thread'
                        ],
                        properties: {
                            thread: {
                                type: 'array',
                                description: 'A flat list of other thread items. The depth of each item is indicated by the depth property inside the item.',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.getPostThreadOtherV2#threadItem'
                                }
                            }
                        }
                    }
                }
            },
            threadItem: {
                type: 'object',
                required: [
                    'uri',
                    'depth',
                    'value'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    depth: {
                        type: 'integer',
                        description: 'The nesting level of this item in the thread. Depth 0 means the anchor item. Items above have negative depths, items below have positive depths.'
                    },
                    value: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.unspecced.defs#threadItemPost'
                        ]
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetPostThreadV2: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getPostThreadV2',
        defs: {
            main: {
                type: 'query',
                description: "(NOTE: this endpoint is under development and WILL change without notice. Don't use it until it is moved out of `unspecced` or your application WILL break) Get posts in a thread. It is based in an anchor post at any depth of the tree, and returns posts above it (recursively resolving the parent, without further branching to their replies) and below it (recursive replies, with branching to their replies). Does not require auth, but additional metadata and filtering will be applied for authed requests.",
                parameters: {
                    type: 'params',
                    required: [
                        'anchor'
                    ],
                    properties: {
                        anchor: {
                            type: 'string',
                            format: 'at-uri',
                            description: 'Reference (AT-URI) to post record. This is the anchor post, and the thread will be built around it. It can be any post in the tree, not necessarily a root post.'
                        },
                        above: {
                            type: 'boolean',
                            description: 'Whether to include parents above the anchor.',
                            default: true
                        },
                        below: {
                            type: 'integer',
                            description: 'How many levels of replies to include below the anchor.',
                            default: 6,
                            minimum: 0,
                            maximum: 20
                        },
                        branchingFactor: {
                            type: 'integer',
                            description: 'Maximum of replies to include at each level of the thread, except for the direct replies to the anchor, which are (NOTE: currently, during unspecced phase) all returned (NOTE: later they might be paginated).',
                            default: 10,
                            minimum: 0,
                            maximum: 100
                        },
                        prioritizeFollowedUsers: {
                            type: 'boolean',
                            description: 'Whether to prioritize posts from followed users. It only has effect when the user is authenticated.',
                            default: false
                        },
                        sort: {
                            type: 'string',
                            description: 'Sorting for the thread replies.',
                            knownValues: [
                                'newest',
                                'oldest',
                                'top'
                            ],
                            default: 'oldest'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'thread',
                            'hasOtherReplies'
                        ],
                        properties: {
                            thread: {
                                type: 'array',
                                description: 'A flat list of thread items. The depth of each item is indicated by the depth property inside the item.',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.getPostThreadV2#threadItem'
                                }
                            },
                            threadgate: {
                                type: 'ref',
                                ref: 'lex:app.bsky.feed.defs#threadgateView'
                            },
                            hasOtherReplies: {
                                type: 'boolean',
                                description: 'Whether this thread has additional replies. If true, a call can be made to the `getPostThreadOtherV2` endpoint to retrieve them.'
                            }
                        }
                    }
                }
            },
            threadItem: {
                type: 'object',
                required: [
                    'uri',
                    'depth',
                    'value'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    depth: {
                        type: 'integer',
                        description: 'The nesting level of this item in the thread. Depth 0 means the anchor item. Items above have negative depths, items below have positive depths.'
                    },
                    value: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.unspecced.defs#threadItemPost',
                            'lex:app.bsky.unspecced.defs#threadItemNoUnauthenticated',
                            'lex:app.bsky.unspecced.defs#threadItemNotFound',
                            'lex:app.bsky.unspecced.defs#threadItemBlocked'
                        ]
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetSuggestedFeeds: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getSuggestedFeeds',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of suggested feeds',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 25,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feeds'
                        ],
                        properties: {
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.feed.defs#generatorView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetSuggestedFeedsSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getSuggestedFeedsSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Get a skeleton of suggested feeds. Intended to be called and hydrated by app.bsky.unspecced.getSuggestedFeeds',
                parameters: {
                    type: 'params',
                    properties: {
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries).'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 25,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'feeds'
                        ],
                        properties: {
                            feeds: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                    format: 'at-uri'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetSuggestedStarterPacks: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getSuggestedStarterPacks',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of suggested starterpacks',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 25,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.graph.defs#starterPackView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetSuggestedStarterPacksSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getSuggestedStarterPacksSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Get a skeleton of suggested starterpacks. Intended to be called and hydrated by app.bsky.unspecced.getSuggestedStarterpacks',
                parameters: {
                    type: 'params',
                    properties: {
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries).'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 25,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                    format: 'at-uri'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetSuggestedUsers: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getSuggestedUsers',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of suggested users',
                parameters: {
                    type: 'params',
                    properties: {
                        category: {
                            type: 'string',
                            description: 'Category of users to get suggestions for.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 50,
                            default: 25
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actors'
                        ],
                        properties: {
                            actors: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.actor.defs#profileView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetSuggestedUsersSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getSuggestedUsersSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Get a skeleton of suggested users. Intended to be called and hydrated by app.bsky.unspecced.getSuggestedUsers',
                parameters: {
                    type: 'params',
                    properties: {
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries).'
                        },
                        category: {
                            type: 'string',
                            description: 'Category of users to get suggestions for.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 50,
                            default: 25
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'dids'
                        ],
                        properties: {
                            dids: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                    format: 'did'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetSuggestionsSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getSuggestionsSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Get a skeleton of suggested actors. Intended to be called and then hydrated through app.bsky.actor.getSuggestions',
                parameters: {
                    type: 'params',
                    properties: {
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries). Used to boost followed accounts in ranking.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        relativeToDid: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account to get suggestions relative to. If not provided, suggestions will be based on the viewer.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actors'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            actors: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#skeletonSearchActor'
                                }
                            },
                            relativeToDid: {
                                type: 'string',
                                format: 'did',
                                description: 'DID of the account these suggestions are relative to. If this is returned undefined, suggestions are based on the viewer.'
                            },
                            recId: {
                                type: 'integer',
                                description: 'Snowflake for this recommendation, use when submitting recommendation events.'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetTaggedSuggestions: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getTaggedSuggestions',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of suggestions (feeds and users) tagged with categories',
                parameters: {
                    type: 'params',
                    properties: {}
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'suggestions'
                        ],
                        properties: {
                            suggestions: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.getTaggedSuggestions#suggestion'
                                }
                            }
                        }
                    }
                }
            },
            suggestion: {
                type: 'object',
                required: [
                    'tag',
                    'subjectType',
                    'subject'
                ],
                properties: {
                    tag: {
                        type: 'string'
                    },
                    subjectType: {
                        type: 'string',
                        knownValues: [
                            'actor',
                            'feed'
                        ]
                    },
                    subject: {
                        type: 'string',
                        format: 'uri'
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetTrendingTopics: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getTrendingTopics',
        defs: {
            main: {
                type: 'query',
                description: 'Get a list of trending topics',
                parameters: {
                    type: 'params',
                    properties: {
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries). Used to boost followed accounts in ranking.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 25,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'topics',
                            'suggested'
                        ],
                        properties: {
                            topics: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#trendingTopic'
                                }
                            },
                            suggested: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#trendingTopic'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetTrends: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getTrends',
        defs: {
            main: {
                type: 'query',
                description: 'Get the current trends on the network',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 25,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'trends'
                        ],
                        properties: {
                            trends: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#trendView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedGetTrendsSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.getTrendsSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Get the skeleton of trends on the network. Intended to be called and then hydrated through app.bsky.unspecced.getTrends',
                parameters: {
                    type: 'params',
                    properties: {
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries).'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 25,
                            default: 10
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'trends'
                        ],
                        properties: {
                            trends: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#skeletonTrend'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyUnspeccedInitAgeAssurance: {
        lexicon: 1,
        id: 'app.bsky.unspecced.initAgeAssurance',
        defs: {
            main: {
                type: 'procedure',
                description: "Initiate age assurance for an account. This is a one-time action that will start the process of verifying the user's age.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'email',
                            'language',
                            'countryCode'
                        ],
                        properties: {
                            email: {
                                type: 'string',
                                description: "The user's email address to receive assurance instructions."
                            },
                            language: {
                                type: 'string',
                                description: "The user's preferred language for communication during the assurance process."
                            },
                            countryCode: {
                                type: 'string',
                                description: "An ISO 3166-1 alpha-2 code of the user's location."
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:app.bsky.unspecced.defs#ageAssuranceState'
                    }
                },
                errors: [
                    {
                        name: 'InvalidEmail'
                    },
                    {
                        name: 'DidTooLong'
                    },
                    {
                        name: 'InvalidInitiation'
                    }
                ]
            }
        }
    },
    AppBskyUnspeccedSearchActorsSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.searchActorsSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Backend Actors (profile) search, returns only skeleton.',
                parameters: {
                    type: 'params',
                    required: [
                        'q'
                    ],
                    properties: {
                        q: {
                            type: 'string',
                            description: 'Search query string; syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended. For typeahead search, only simple term match is supported, not full syntax.'
                        },
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries). Used to boost followed accounts in ranking.'
                        },
                        typeahead: {
                            type: 'boolean',
                            description: "If true, acts as fast/simple 'typeahead' query."
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string',
                            description: 'Optional pagination mechanism; may not necessarily allow scrolling through entire result set.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actors'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            hitsTotal: {
                                type: 'integer',
                                description: 'Count of search hits. Optional, may be rounded/truncated, and may not be possible to paginate through all hits.'
                            },
                            actors: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#skeletonSearchActor'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BadQueryString'
                    }
                ]
            }
        }
    },
    AppBskyUnspeccedSearchPostsSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.searchPostsSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Backend Posts search, returns only skeleton',
                parameters: {
                    type: 'params',
                    required: [
                        'q'
                    ],
                    properties: {
                        q: {
                            type: 'string',
                            description: 'Search query string; syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended.'
                        },
                        sort: {
                            type: 'string',
                            knownValues: [
                                'top',
                                'latest'
                            ],
                            default: 'latest',
                            description: 'Specifies the ranking order of results.'
                        },
                        since: {
                            type: 'string',
                            description: "Filter results for posts after the indicated datetime (inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYYY-MM-DD)."
                        },
                        until: {
                            type: 'string',
                            description: "Filter results for posts before the indicated datetime (not inclusive). Expected to use 'sortAt' timestamp, which may not match 'createdAt'. Can be a datetime, or just an ISO date (YYY-MM-DD)."
                        },
                        mentions: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Filter to posts which mention the given account. Handles are resolved to DID before query-time. Only matches rich-text facet mentions.'
                        },
                        author: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Filter to posts by the given account. Handles are resolved to DID before query-time.'
                        },
                        lang: {
                            type: 'string',
                            format: 'language',
                            description: 'Filter to posts in the given language. Expected to be based on post language field, though server may override language detection.'
                        },
                        domain: {
                            type: 'string',
                            description: 'Filter to posts with URLs (facet links or embeds) linking to the given domain (hostname). Server may apply hostname normalization.'
                        },
                        url: {
                            type: 'string',
                            format: 'uri',
                            description: 'Filter to posts with links (facet links or embeds) pointing to this URL. Server may apply URL normalization or fuzzy matching.'
                        },
                        tag: {
                            type: 'array',
                            items: {
                                type: 'string',
                                maxLength: 640,
                                maxGraphemes: 64
                            },
                            description: "Filter to posts with the given tag (hashtag), based on rich-text facet or tag field. Do not include the hash (#) prefix. Multiple tags can be specified, with 'AND' matching."
                        },
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: "DID of the account making the request (not included for public/unauthenticated queries). Used for 'from:me' queries."
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string',
                            description: 'Optional pagination mechanism; may not necessarily allow scrolling through entire result set.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'posts'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            hitsTotal: {
                                type: 'integer',
                                description: 'Count of search hits. Optional, may be rounded/truncated, and may not be possible to paginate through all hits.'
                            },
                            posts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#skeletonSearchPost'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BadQueryString'
                    }
                ]
            }
        }
    },
    AppBskyUnspeccedSearchStarterPacksSkeleton: {
        lexicon: 1,
        id: 'app.bsky.unspecced.searchStarterPacksSkeleton',
        defs: {
            main: {
                type: 'query',
                description: 'Backend Starter Pack search, returns only skeleton.',
                parameters: {
                    type: 'params',
                    required: [
                        'q'
                    ],
                    properties: {
                        q: {
                            type: 'string',
                            description: 'Search query string; syntax, phrase, boolean, and faceting is unspecified, but Lucene query syntax is recommended.'
                        },
                        viewer: {
                            type: 'string',
                            format: 'did',
                            description: 'DID of the account making the request (not included for public/unauthenticated queries).'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 25
                        },
                        cursor: {
                            type: 'string',
                            description: 'Optional pagination mechanism; may not necessarily allow scrolling through entire result set.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'starterPacks'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            hitsTotal: {
                                type: 'integer',
                                description: 'Count of search hits. Optional, may be rounded/truncated, and may not be possible to paginate through all hits.'
                            },
                            starterPacks: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:app.bsky.unspecced.defs#skeletonSearchStarterPack'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BadQueryString'
                    }
                ]
            }
        }
    },
    AppBskyVideoDefs: {
        lexicon: 1,
        id: 'app.bsky.video.defs',
        defs: {
            jobStatus: {
                type: 'object',
                required: [
                    'jobId',
                    'did',
                    'state'
                ],
                properties: {
                    jobId: {
                        type: 'string'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    state: {
                        type: 'string',
                        description: 'The state of the video processing job. All values not listed as a known value indicate that the job is in process.',
                        knownValues: [
                            'JOB_STATE_COMPLETED',
                            'JOB_STATE_FAILED'
                        ]
                    },
                    progress: {
                        type: 'integer',
                        minimum: 0,
                        maximum: 100,
                        description: 'Progress within the current processing state.'
                    },
                    blob: {
                        type: 'blob'
                    },
                    error: {
                        type: 'string'
                    },
                    message: {
                        type: 'string'
                    }
                }
            }
        }
    },
    AppBskyVideoGetJobStatus: {
        lexicon: 1,
        id: 'app.bsky.video.getJobStatus',
        defs: {
            main: {
                type: 'query',
                description: 'Get status details for a video processing job.',
                parameters: {
                    type: 'params',
                    required: [
                        'jobId'
                    ],
                    properties: {
                        jobId: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'jobStatus'
                        ],
                        properties: {
                            jobStatus: {
                                type: 'ref',
                                ref: 'lex:app.bsky.video.defs#jobStatus'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyVideoGetUploadLimits: {
        lexicon: 1,
        id: 'app.bsky.video.getUploadLimits',
        defs: {
            main: {
                type: 'query',
                description: 'Get video upload limits for the authenticated user.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'canUpload'
                        ],
                        properties: {
                            canUpload: {
                                type: 'boolean'
                            },
                            remainingDailyVideos: {
                                type: 'integer'
                            },
                            remainingDailyBytes: {
                                type: 'integer'
                            },
                            message: {
                                type: 'string'
                            },
                            error: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    AppBskyVideoUploadVideo: {
        lexicon: 1,
        id: 'app.bsky.video.uploadVideo',
        defs: {
            main: {
                type: 'procedure',
                description: 'Upload a video to be processed then stored on the PDS.',
                input: {
                    encoding: 'video/mp4'
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'jobStatus'
                        ],
                        properties: {
                            jobStatus: {
                                type: 'ref',
                                ref: 'lex:app.bsky.video.defs#jobStatus'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyActorDeclaration: {
        lexicon: 1,
        id: 'chat.bsky.actor.declaration',
        defs: {
            main: {
                type: 'record',
                description: 'A declaration of a Bluesky chat account.',
                key: 'literal:self',
                record: {
                    type: 'object',
                    required: [
                        'allowIncoming'
                    ],
                    properties: {
                        allowIncoming: {
                            type: 'string',
                            knownValues: [
                                'all',
                                'none',
                                'following'
                            ]
                        }
                    }
                }
            }
        }
    },
    ChatBskyActorDefs: {
        lexicon: 1,
        id: 'chat.bsky.actor.defs',
        defs: {
            profileViewBasic: {
                type: 'object',
                required: [
                    'did',
                    'handle'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    displayName: {
                        type: 'string',
                        maxGraphemes: 64,
                        maxLength: 640
                    },
                    avatar: {
                        type: 'string',
                        format: 'uri'
                    },
                    associated: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileAssociated'
                    },
                    viewer: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#viewerState'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    chatDisabled: {
                        type: 'boolean',
                        description: 'Set to true when the actor cannot actively participate in conversations'
                    },
                    verification: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#verificationState'
                    }
                }
            }
        }
    },
    ChatBskyActorDeleteAccount: {
        lexicon: 1,
        id: 'chat.bsky.actor.deleteAccount',
        defs: {
            main: {
                type: 'procedure',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {}
                    }
                }
            }
        }
    },
    ChatBskyActorExportAccountData: {
        lexicon: 1,
        id: 'chat.bsky.actor.exportAccountData',
        defs: {
            main: {
                type: 'query',
                output: {
                    encoding: 'application/jsonl'
                }
            }
        }
    },
    ChatBskyConvoAcceptConvo: {
        lexicon: 1,
        id: 'chat.bsky.convo.acceptConvo',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            rev: {
                                description: 'Rev when the convo was accepted. If not present, the convo was already accepted.',
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoAddReaction: {
        lexicon: 1,
        id: 'chat.bsky.convo.addReaction',
        defs: {
            main: {
                type: 'procedure',
                description: 'Adds an emoji reaction to a message. Requires authentication. It is idempotent, so multiple calls from the same user with the same emoji result in a single reaction.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId',
                            'messageId',
                            'value'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            },
                            messageId: {
                                type: 'string'
                            },
                            value: {
                                type: 'string',
                                minLength: 1,
                                maxLength: 64,
                                minGraphemes: 1,
                                maxGraphemes: 1
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'message'
                        ],
                        properties: {
                            message: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#messageView'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'ReactionMessageDeleted',
                        description: 'Indicates that the message has been deleted and reactions can no longer be added/removed.'
                    },
                    {
                        name: 'ReactionLimitReached',
                        description: "Indicates that the message has the maximum number of reactions allowed for a single user, and the requested reaction wasn't yet present. If it was already present, the request will not fail since it is idempotent."
                    },
                    {
                        name: 'ReactionInvalidValue',
                        description: 'Indicates the value for the reaction is not acceptable. In general, this means it is not an emoji.'
                    }
                ]
            }
        }
    },
    ChatBskyConvoDefs: {
        lexicon: 1,
        id: 'chat.bsky.convo.defs',
        defs: {
            messageRef: {
                type: 'object',
                required: [
                    'did',
                    'messageId',
                    'convoId'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    convoId: {
                        type: 'string'
                    },
                    messageId: {
                        type: 'string'
                    }
                }
            },
            messageInput: {
                type: 'object',
                required: [
                    'text'
                ],
                properties: {
                    text: {
                        type: 'string',
                        maxLength: 10000,
                        maxGraphemes: 1000
                    },
                    facets: {
                        type: 'array',
                        description: 'Annotations of text (mentions, URLs, hashtags, etc)',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.richtext.facet'
                        }
                    },
                    embed: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.record'
                        ]
                    }
                }
            },
            messageView: {
                type: 'object',
                required: [
                    'id',
                    'rev',
                    'text',
                    'sender',
                    'sentAt'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    rev: {
                        type: 'string'
                    },
                    text: {
                        type: 'string',
                        maxLength: 10000,
                        maxGraphemes: 1000
                    },
                    facets: {
                        type: 'array',
                        description: 'Annotations of text (mentions, URLs, hashtags, etc)',
                        items: {
                            type: 'ref',
                            ref: 'lex:app.bsky.richtext.facet'
                        }
                    },
                    embed: {
                        type: 'union',
                        refs: [
                            'lex:app.bsky.embed.record#view'
                        ]
                    },
                    reactions: {
                        type: 'array',
                        description: 'Reactions to this message, in ascending order of creation time.',
                        items: {
                            type: 'ref',
                            ref: 'lex:chat.bsky.convo.defs#reactionView'
                        }
                    },
                    sender: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#messageViewSender'
                    },
                    sentAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            deletedMessageView: {
                type: 'object',
                required: [
                    'id',
                    'rev',
                    'sender',
                    'sentAt'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    rev: {
                        type: 'string'
                    },
                    sender: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#messageViewSender'
                    },
                    sentAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            messageViewSender: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            reactionView: {
                type: 'object',
                required: [
                    'value',
                    'sender',
                    'createdAt'
                ],
                properties: {
                    value: {
                        type: 'string'
                    },
                    sender: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#reactionViewSender'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            reactionViewSender: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            messageAndReactionView: {
                type: 'object',
                required: [
                    'message',
                    'reaction'
                ],
                properties: {
                    message: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#messageView'
                    },
                    reaction: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#reactionView'
                    }
                }
            },
            convoView: {
                type: 'object',
                required: [
                    'id',
                    'rev',
                    'members',
                    'muted',
                    'unreadCount'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    rev: {
                        type: 'string'
                    },
                    members: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:chat.bsky.actor.defs#profileViewBasic'
                        }
                    },
                    lastMessage: {
                        type: 'union',
                        refs: [
                            'lex:chat.bsky.convo.defs#messageView',
                            'lex:chat.bsky.convo.defs#deletedMessageView'
                        ]
                    },
                    lastReaction: {
                        type: 'union',
                        refs: [
                            'lex:chat.bsky.convo.defs#messageAndReactionView'
                        ]
                    },
                    muted: {
                        type: 'boolean'
                    },
                    status: {
                        type: 'string',
                        knownValues: [
                            'request',
                            'accepted'
                        ]
                    },
                    unreadCount: {
                        type: 'integer'
                    }
                }
            },
            logBeginConvo: {
                type: 'object',
                required: [
                    'rev',
                    'convoId'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    }
                }
            },
            logAcceptConvo: {
                type: 'object',
                required: [
                    'rev',
                    'convoId'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    }
                }
            },
            logLeaveConvo: {
                type: 'object',
                required: [
                    'rev',
                    'convoId'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    }
                }
            },
            logMuteConvo: {
                type: 'object',
                required: [
                    'rev',
                    'convoId'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    }
                }
            },
            logUnmuteConvo: {
                type: 'object',
                required: [
                    'rev',
                    'convoId'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    }
                }
            },
            logCreateMessage: {
                type: 'object',
                required: [
                    'rev',
                    'convoId',
                    'message'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    },
                    message: {
                        type: 'union',
                        refs: [
                            'lex:chat.bsky.convo.defs#messageView',
                            'lex:chat.bsky.convo.defs#deletedMessageView'
                        ]
                    }
                }
            },
            logDeleteMessage: {
                type: 'object',
                required: [
                    'rev',
                    'convoId',
                    'message'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    },
                    message: {
                        type: 'union',
                        refs: [
                            'lex:chat.bsky.convo.defs#messageView',
                            'lex:chat.bsky.convo.defs#deletedMessageView'
                        ]
                    }
                }
            },
            logReadMessage: {
                type: 'object',
                required: [
                    'rev',
                    'convoId',
                    'message'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    },
                    message: {
                        type: 'union',
                        refs: [
                            'lex:chat.bsky.convo.defs#messageView',
                            'lex:chat.bsky.convo.defs#deletedMessageView'
                        ]
                    }
                }
            },
            logAddReaction: {
                type: 'object',
                required: [
                    'rev',
                    'convoId',
                    'message',
                    'reaction'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    },
                    message: {
                        type: 'union',
                        refs: [
                            'lex:chat.bsky.convo.defs#messageView',
                            'lex:chat.bsky.convo.defs#deletedMessageView'
                        ]
                    },
                    reaction: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#reactionView'
                    }
                }
            },
            logRemoveReaction: {
                type: 'object',
                required: [
                    'rev',
                    'convoId',
                    'message',
                    'reaction'
                ],
                properties: {
                    rev: {
                        type: 'string'
                    },
                    convoId: {
                        type: 'string'
                    },
                    message: {
                        type: 'union',
                        refs: [
                            'lex:chat.bsky.convo.defs#messageView',
                            'lex:chat.bsky.convo.defs#deletedMessageView'
                        ]
                    },
                    reaction: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#reactionView'
                    }
                }
            }
        }
    },
    ChatBskyConvoDeleteMessageForSelf: {
        lexicon: 1,
        id: 'chat.bsky.convo.deleteMessageForSelf',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId',
                            'messageId'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            },
                            messageId: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#deletedMessageView'
                    }
                }
            }
        }
    },
    ChatBskyConvoGetConvo: {
        lexicon: 1,
        id: 'chat.bsky.convo.getConvo',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [
                        'convoId'
                    ],
                    properties: {
                        convoId: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convo'
                        ],
                        properties: {
                            convo: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#convoView'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoGetConvoAvailability: {
        lexicon: 1,
        id: 'chat.bsky.convo.getConvoAvailability',
        defs: {
            main: {
                type: 'query',
                description: 'Get whether the requester and the other members can chat. If an existing convo is found for these members, it is returned.',
                parameters: {
                    type: 'params',
                    required: [
                        'members'
                    ],
                    properties: {
                        members: {
                            type: 'array',
                            minLength: 1,
                            maxLength: 10,
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'canChat'
                        ],
                        properties: {
                            canChat: {
                                type: 'boolean'
                            },
                            convo: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#convoView'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoGetConvoForMembers: {
        lexicon: 1,
        id: 'chat.bsky.convo.getConvoForMembers',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [
                        'members'
                    ],
                    properties: {
                        members: {
                            type: 'array',
                            minLength: 1,
                            maxLength: 10,
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convo'
                        ],
                        properties: {
                            convo: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#convoView'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoGetLog: {
        lexicon: 1,
        id: 'chat.bsky.convo.getLog',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [],
                    properties: {
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'logs'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            logs: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:chat.bsky.convo.defs#logBeginConvo',
                                        'lex:chat.bsky.convo.defs#logAcceptConvo',
                                        'lex:chat.bsky.convo.defs#logLeaveConvo',
                                        'lex:chat.bsky.convo.defs#logMuteConvo',
                                        'lex:chat.bsky.convo.defs#logUnmuteConvo',
                                        'lex:chat.bsky.convo.defs#logCreateMessage',
                                        'lex:chat.bsky.convo.defs#logDeleteMessage',
                                        'lex:chat.bsky.convo.defs#logReadMessage',
                                        'lex:chat.bsky.convo.defs#logAddReaction',
                                        'lex:chat.bsky.convo.defs#logRemoveReaction'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoGetMessages: {
        lexicon: 1,
        id: 'chat.bsky.convo.getMessages',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [
                        'convoId'
                    ],
                    properties: {
                        convoId: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'messages'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            messages: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:chat.bsky.convo.defs#messageView',
                                        'lex:chat.bsky.convo.defs#deletedMessageView'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoLeaveConvo: {
        lexicon: 1,
        id: 'chat.bsky.convo.leaveConvo',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId',
                            'rev'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            },
                            rev: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoListConvos: {
        lexicon: 1,
        id: 'chat.bsky.convo.listConvos',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        readState: {
                            type: 'string',
                            knownValues: [
                                'unread'
                            ]
                        },
                        status: {
                            type: 'string',
                            knownValues: [
                                'request',
                                'accepted'
                            ]
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convos'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            convos: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:chat.bsky.convo.defs#convoView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoMuteConvo: {
        lexicon: 1,
        id: 'chat.bsky.convo.muteConvo',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convo'
                        ],
                        properties: {
                            convo: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#convoView'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoRemoveReaction: {
        lexicon: 1,
        id: 'chat.bsky.convo.removeReaction',
        defs: {
            main: {
                type: 'procedure',
                description: "Removes an emoji reaction from a message. Requires authentication. It is idempotent, so multiple calls from the same user with the same emoji result in that reaction not being present, even if it already wasn't.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId',
                            'messageId',
                            'value'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            },
                            messageId: {
                                type: 'string'
                            },
                            value: {
                                type: 'string',
                                minLength: 1,
                                maxLength: 64,
                                minGraphemes: 1,
                                maxGraphemes: 1
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'message'
                        ],
                        properties: {
                            message: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#messageView'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'ReactionMessageDeleted',
                        description: 'Indicates that the message has been deleted and reactions can no longer be added/removed.'
                    },
                    {
                        name: 'ReactionInvalidValue',
                        description: 'Indicates the value for the reaction is not acceptable. In general, this means it is not an emoji.'
                    }
                ]
            }
        }
    },
    ChatBskyConvoSendMessage: {
        lexicon: 1,
        id: 'chat.bsky.convo.sendMessage',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId',
                            'message'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            },
                            message: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#messageInput'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#messageView'
                    }
                }
            }
        }
    },
    ChatBskyConvoSendMessageBatch: {
        lexicon: 1,
        id: 'chat.bsky.convo.sendMessageBatch',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'items'
                        ],
                        properties: {
                            items: {
                                type: 'array',
                                maxLength: 100,
                                items: {
                                    type: 'ref',
                                    ref: 'lex:chat.bsky.convo.sendMessageBatch#batchItem'
                                }
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'items'
                        ],
                        properties: {
                            items: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:chat.bsky.convo.defs#messageView'
                                }
                            }
                        }
                    }
                }
            },
            batchItem: {
                type: 'object',
                required: [
                    'convoId',
                    'message'
                ],
                properties: {
                    convoId: {
                        type: 'string'
                    },
                    message: {
                        type: 'ref',
                        ref: 'lex:chat.bsky.convo.defs#messageInput'
                    }
                }
            }
        }
    },
    ChatBskyConvoUnmuteConvo: {
        lexicon: 1,
        id: 'chat.bsky.convo.unmuteConvo',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convo'
                        ],
                        properties: {
                            convo: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#convoView'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoUpdateAllRead: {
        lexicon: 1,
        id: 'chat.bsky.convo.updateAllRead',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            status: {
                                type: 'string',
                                knownValues: [
                                    'request',
                                    'accepted'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'updatedCount'
                        ],
                        properties: {
                            updatedCount: {
                                description: 'The count of updated convos.',
                                type: 'integer'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyConvoUpdateRead: {
        lexicon: 1,
        id: 'chat.bsky.convo.updateRead',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convoId'
                        ],
                        properties: {
                            convoId: {
                                type: 'string'
                            },
                            messageId: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'convo'
                        ],
                        properties: {
                            convo: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.convo.defs#convoView'
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyModerationGetActorMetadata: {
        lexicon: 1,
        id: 'chat.bsky.moderation.getActorMetadata',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [
                        'actor'
                    ],
                    properties: {
                        actor: {
                            type: 'string',
                            format: 'did'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'day',
                            'month',
                            'all'
                        ],
                        properties: {
                            day: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.moderation.getActorMetadata#metadata'
                            },
                            month: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.moderation.getActorMetadata#metadata'
                            },
                            all: {
                                type: 'ref',
                                ref: 'lex:chat.bsky.moderation.getActorMetadata#metadata'
                            }
                        }
                    }
                }
            },
            metadata: {
                type: 'object',
                required: [
                    'messagesSent',
                    'messagesReceived',
                    'convos',
                    'convosStarted'
                ],
                properties: {
                    messagesSent: {
                        type: 'integer'
                    },
                    messagesReceived: {
                        type: 'integer'
                    },
                    convos: {
                        type: 'integer'
                    },
                    convosStarted: {
                        type: 'integer'
                    }
                }
            }
        }
    },
    ChatBskyModerationGetMessageContext: {
        lexicon: 1,
        id: 'chat.bsky.moderation.getMessageContext',
        defs: {
            main: {
                type: 'query',
                parameters: {
                    type: 'params',
                    required: [
                        'messageId'
                    ],
                    properties: {
                        convoId: {
                            type: 'string',
                            description: 'Conversation that the message is from. NOTE: this field will eventually be required.'
                        },
                        messageId: {
                            type: 'string'
                        },
                        before: {
                            type: 'integer',
                            default: 5
                        },
                        after: {
                            type: 'integer',
                            default: 5
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'messages'
                        ],
                        properties: {
                            messages: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:chat.bsky.convo.defs#messageView',
                                        'lex:chat.bsky.convo.defs#deletedMessageView'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ChatBskyModerationUpdateActorAccess: {
        lexicon: 1,
        id: 'chat.bsky.moderation.updateActorAccess',
        defs: {
            main: {
                type: 'procedure',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actor',
                            'allowAccess'
                        ],
                        properties: {
                            actor: {
                                type: 'string',
                                format: 'did'
                            },
                            allowAccess: {
                                type: 'boolean'
                            },
                            ref: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminDefs: {
        lexicon: 1,
        id: 'com.atproto.admin.defs',
        defs: {
            statusAttr: {
                type: 'object',
                required: [
                    'applied'
                ],
                properties: {
                    applied: {
                        type: 'boolean'
                    },
                    ref: {
                        type: 'string'
                    }
                }
            },
            accountView: {
                type: 'object',
                required: [
                    'did',
                    'handle',
                    'indexedAt'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    email: {
                        type: 'string'
                    },
                    relatedRecords: {
                        type: 'array',
                        items: {
                            type: 'unknown'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    invitedBy: {
                        type: 'ref',
                        ref: 'lex:com.atproto.server.defs#inviteCode'
                    },
                    invites: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.server.defs#inviteCode'
                        }
                    },
                    invitesDisabled: {
                        type: 'boolean'
                    },
                    emailConfirmedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    inviteNote: {
                        type: 'string'
                    },
                    deactivatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    threatSignatures: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.admin.defs#threatSignature'
                        }
                    }
                }
            },
            repoRef: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            repoBlobRef: {
                type: 'object',
                required: [
                    'did',
                    'cid'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    recordUri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            threatSignature: {
                type: 'object',
                required: [
                    'property',
                    'value'
                ],
                properties: {
                    property: {
                        type: 'string'
                    },
                    value: {
                        type: 'string'
                    }
                }
            }
        }
    },
    ComAtprotoAdminDeleteAccount: {
        lexicon: 1,
        id: 'com.atproto.admin.deleteAccount',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete a user account as an administrator.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminDisableAccountInvites: {
        lexicon: 1,
        id: 'com.atproto.admin.disableAccountInvites',
        defs: {
            main: {
                type: 'procedure',
                description: 'Disable an account from receiving new invite codes, but does not invalidate existing codes.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'account'
                        ],
                        properties: {
                            account: {
                                type: 'string',
                                format: 'did'
                            },
                            note: {
                                type: 'string',
                                description: 'Optional reason for disabled invites.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminDisableInviteCodes: {
        lexicon: 1,
        id: 'com.atproto.admin.disableInviteCodes',
        defs: {
            main: {
                type: 'procedure',
                description: 'Disable some set of codes and/or all codes associated with a set of users.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            codes: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            accounts: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminEnableAccountInvites: {
        lexicon: 1,
        id: 'com.atproto.admin.enableAccountInvites',
        defs: {
            main: {
                type: 'procedure',
                description: "Re-enable an account's ability to receive invite codes.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'account'
                        ],
                        properties: {
                            account: {
                                type: 'string',
                                format: 'did'
                            },
                            note: {
                                type: 'string',
                                description: 'Optional reason for enabled invites.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminGetAccountInfo: {
        lexicon: 1,
        id: 'com.atproto.admin.getAccountInfo',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about an account.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:com.atproto.admin.defs#accountView'
                    }
                }
            }
        }
    },
    ComAtprotoAdminGetAccountInfos: {
        lexicon: 1,
        id: 'com.atproto.admin.getAccountInfos',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about some accounts.',
                parameters: {
                    type: 'params',
                    required: [
                        'dids'
                    ],
                    properties: {
                        dids: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'infos'
                        ],
                        properties: {
                            infos: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.admin.defs#accountView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminGetInviteCodes: {
        lexicon: 1,
        id: 'com.atproto.admin.getInviteCodes',
        defs: {
            main: {
                type: 'query',
                description: 'Get an admin view of invite codes.',
                parameters: {
                    type: 'params',
                    properties: {
                        sort: {
                            type: 'string',
                            knownValues: [
                                'recent',
                                'usage'
                            ],
                            default: 'recent'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 500,
                            default: 100
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'codes'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            codes: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.server.defs#inviteCode'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminGetSubjectStatus: {
        lexicon: 1,
        id: 'com.atproto.admin.getSubjectStatus',
        defs: {
            main: {
                type: 'query',
                description: 'Get the service-specific admin status of a subject (account, record, or blob).',
                parameters: {
                    type: 'params',
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        },
                        uri: {
                            type: 'string',
                            format: 'at-uri'
                        },
                        blob: {
                            type: 'string',
                            format: 'cid'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject'
                        ],
                        properties: {
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef',
                                    'lex:com.atproto.admin.defs#repoBlobRef'
                                ]
                            },
                            takedown: {
                                type: 'ref',
                                ref: 'lex:com.atproto.admin.defs#statusAttr'
                            },
                            deactivated: {
                                type: 'ref',
                                ref: 'lex:com.atproto.admin.defs#statusAttr'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminSearchAccounts: {
        lexicon: 1,
        id: 'com.atproto.admin.searchAccounts',
        defs: {
            main: {
                type: 'query',
                description: 'Get list of accounts that matches your search query.',
                parameters: {
                    type: 'params',
                    properties: {
                        email: {
                            type: 'string'
                        },
                        cursor: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'accounts'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            accounts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.admin.defs#accountView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminSendEmail: {
        lexicon: 1,
        id: 'com.atproto.admin.sendEmail',
        defs: {
            main: {
                type: 'procedure',
                description: "Send email to a user's account email address.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'recipientDid',
                            'content',
                            'senderDid'
                        ],
                        properties: {
                            recipientDid: {
                                type: 'string',
                                format: 'did'
                            },
                            content: {
                                type: 'string'
                            },
                            subject: {
                                type: 'string'
                            },
                            senderDid: {
                                type: 'string',
                                format: 'did'
                            },
                            comment: {
                                type: 'string',
                                description: "Additional comment by the sender that won't be used in the email itself but helpful to provide more context for moderators/reviewers"
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'sent'
                        ],
                        properties: {
                            sent: {
                                type: 'boolean'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminUpdateAccountEmail: {
        lexicon: 1,
        id: 'com.atproto.admin.updateAccountEmail',
        defs: {
            main: {
                type: 'procedure',
                description: "Administrative action to update an account's email.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'account',
                            'email'
                        ],
                        properties: {
                            account: {
                                type: 'string',
                                format: 'at-identifier',
                                description: 'The handle or DID of the repo.'
                            },
                            email: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminUpdateAccountHandle: {
        lexicon: 1,
        id: 'com.atproto.admin.updateAccountHandle',
        defs: {
            main: {
                type: 'procedure',
                description: "Administrative action to update an account's handle.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'handle'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminUpdateAccountPassword: {
        lexicon: 1,
        id: 'com.atproto.admin.updateAccountPassword',
        defs: {
            main: {
                type: 'procedure',
                description: 'Update the password for a user account as an administrator.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'password'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            password: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminUpdateAccountSigningKey: {
        lexicon: 1,
        id: 'com.atproto.admin.updateAccountSigningKey',
        defs: {
            main: {
                type: 'procedure',
                description: "Administrative action to update an account's signing key in their Did document.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'signingKey'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            signingKey: {
                                type: 'string',
                                format: 'did',
                                description: 'Did-key formatted public key'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoAdminUpdateSubjectStatus: {
        lexicon: 1,
        id: 'com.atproto.admin.updateSubjectStatus',
        defs: {
            main: {
                type: 'procedure',
                description: 'Update the service-specific admin status of a subject (account, record, or blob).',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject'
                        ],
                        properties: {
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef',
                                    'lex:com.atproto.admin.defs#repoBlobRef'
                                ]
                            },
                            takedown: {
                                type: 'ref',
                                ref: 'lex:com.atproto.admin.defs#statusAttr'
                            },
                            deactivated: {
                                type: 'ref',
                                ref: 'lex:com.atproto.admin.defs#statusAttr'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject'
                        ],
                        properties: {
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef',
                                    'lex:com.atproto.admin.defs#repoBlobRef'
                                ]
                            },
                            takedown: {
                                type: 'ref',
                                ref: 'lex:com.atproto.admin.defs#statusAttr'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoIdentityDefs: {
        lexicon: 1,
        id: 'com.atproto.identity.defs',
        defs: {
            identityInfo: {
                type: 'object',
                required: [
                    'did',
                    'handle',
                    'didDoc'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle',
                        description: "The validated handle of the account; or 'handle.invalid' if the handle did not bi-directionally match the DID document."
                    },
                    didDoc: {
                        type: 'unknown',
                        description: 'The complete DID document for the identity.'
                    }
                }
            }
        }
    },
    ComAtprotoIdentityGetRecommendedDidCredentials: {
        lexicon: 1,
        id: 'com.atproto.identity.getRecommendedDidCredentials',
        defs: {
            main: {
                type: 'query',
                description: 'Describe the credentials that should be included in the DID doc of an account that is migrating to this service.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            rotationKeys: {
                                description: 'Recommended rotation keys for PLC dids. Should be undefined (or ignored) for did:webs.',
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            alsoKnownAs: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            verificationMethods: {
                                type: 'unknown'
                            },
                            services: {
                                type: 'unknown'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoIdentityRefreshIdentity: {
        lexicon: 1,
        id: 'com.atproto.identity.refreshIdentity',
        defs: {
            main: {
                type: 'procedure',
                description: 'Request that the server re-resolve an identity (DID and handle). The server may ignore this request, or require authentication, depending on the role, implementation, and policy of the server.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'identifier'
                        ],
                        properties: {
                            identifier: {
                                type: 'string',
                                format: 'at-identifier'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:com.atproto.identity.defs#identityInfo'
                    }
                },
                errors: [
                    {
                        name: 'HandleNotFound',
                        description: 'The resolution process confirmed that the handle does not resolve to any DID.'
                    },
                    {
                        name: 'DidNotFound',
                        description: 'The DID resolution process confirmed that there is no current DID.'
                    },
                    {
                        name: 'DidDeactivated',
                        description: 'The DID previously existed, but has been deactivated.'
                    }
                ]
            }
        }
    },
    ComAtprotoIdentityRequestPlcOperationSignature: {
        lexicon: 1,
        id: 'com.atproto.identity.requestPlcOperationSignature',
        defs: {
            main: {
                type: 'procedure',
                description: 'Request an email with a code to in order to request a signed PLC operation. Requires Auth.'
            }
        }
    },
    ComAtprotoIdentityResolveDid: {
        lexicon: 1,
        id: 'com.atproto.identity.resolveDid',
        defs: {
            main: {
                type: 'query',
                description: 'Resolves DID to DID document. Does not bi-directionally verify handle.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'DID to resolve.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'didDoc'
                        ],
                        properties: {
                            didDoc: {
                                type: 'unknown',
                                description: 'The complete DID document for the identity.'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'DidNotFound',
                        description: 'The DID resolution process confirmed that there is no current DID.'
                    },
                    {
                        name: 'DidDeactivated',
                        description: 'The DID previously existed, but has been deactivated.'
                    }
                ]
            }
        }
    },
    ComAtprotoIdentityResolveHandle: {
        lexicon: 1,
        id: 'com.atproto.identity.resolveHandle',
        defs: {
            main: {
                type: 'query',
                description: 'Resolves an atproto handle (hostname) to a DID. Does not necessarily bi-directionally verify against the the DID document.',
                parameters: {
                    type: 'params',
                    required: [
                        'handle'
                    ],
                    properties: {
                        handle: {
                            type: 'string',
                            format: 'handle',
                            description: 'The handle to resolve.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'HandleNotFound',
                        description: 'The resolution process confirmed that the handle does not resolve to any DID.'
                    }
                ]
            }
        }
    },
    ComAtprotoIdentityResolveIdentity: {
        lexicon: 1,
        id: 'com.atproto.identity.resolveIdentity',
        defs: {
            main: {
                type: 'query',
                description: 'Resolves an identity (DID or Handle) to a full identity (DID document and verified handle).',
                parameters: {
                    type: 'params',
                    required: [
                        'identifier'
                    ],
                    properties: {
                        identifier: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'Handle or DID to resolve.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:com.atproto.identity.defs#identityInfo'
                    }
                },
                errors: [
                    {
                        name: 'HandleNotFound',
                        description: 'The resolution process confirmed that the handle does not resolve to any DID.'
                    },
                    {
                        name: 'DidNotFound',
                        description: 'The DID resolution process confirmed that there is no current DID.'
                    },
                    {
                        name: 'DidDeactivated',
                        description: 'The DID previously existed, but has been deactivated.'
                    }
                ]
            }
        }
    },
    ComAtprotoIdentitySignPlcOperation: {
        lexicon: 1,
        id: 'com.atproto.identity.signPlcOperation',
        defs: {
            main: {
                type: 'procedure',
                description: "Signs a PLC operation to update some value(s) in the requesting DID's document.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            token: {
                                description: 'A token received through com.atproto.identity.requestPlcOperationSignature',
                                type: 'string'
                            },
                            rotationKeys: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            alsoKnownAs: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            verificationMethods: {
                                type: 'unknown'
                            },
                            services: {
                                type: 'unknown'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'operation'
                        ],
                        properties: {
                            operation: {
                                type: 'unknown',
                                description: 'A signed DID PLC operation.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoIdentitySubmitPlcOperation: {
        lexicon: 1,
        id: 'com.atproto.identity.submitPlcOperation',
        defs: {
            main: {
                type: 'procedure',
                description: "Validates a PLC operation to ensure that it doesn't violate a service's constraints or get the identity into a bad state, then submits it to the PLC registry",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'operation'
                        ],
                        properties: {
                            operation: {
                                type: 'unknown'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoIdentityUpdateHandle: {
        lexicon: 1,
        id: 'com.atproto.identity.updateHandle',
        defs: {
            main: {
                type: 'procedure',
                description: "Updates the current account's handle. Verifies handle validity, and updates did:plc document if necessary. Implemented by PDS, and requires auth.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'handle'
                        ],
                        properties: {
                            handle: {
                                type: 'string',
                                format: 'handle',
                                description: 'The new handle.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoLabelDefs: {
        lexicon: 1,
        id: 'com.atproto.label.defs',
        defs: {
            label: {
                type: 'object',
                description: 'Metadata tag on an atproto resource (eg, repo or record).',
                required: [
                    'src',
                    'uri',
                    'val',
                    'cts'
                ],
                properties: {
                    ver: {
                        type: 'integer',
                        description: 'The AT Protocol version of the label object.'
                    },
                    src: {
                        type: 'string',
                        format: 'did',
                        description: 'DID of the actor who created this label.'
                    },
                    uri: {
                        type: 'string',
                        format: 'uri',
                        description: 'AT URI of the record, repository (account), or other resource that this label applies to.'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid',
                        description: "Optionally, CID specifying the specific version of 'uri' resource this label applies to."
                    },
                    val: {
                        type: 'string',
                        maxLength: 128,
                        description: 'The short string name of the value or type of this label.'
                    },
                    neg: {
                        type: 'boolean',
                        description: 'If true, this is a negation label, overwriting a previous label.'
                    },
                    cts: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp when this label was created.'
                    },
                    exp: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp at which this label expires (no longer applies).'
                    },
                    sig: {
                        type: 'bytes',
                        description: 'Signature of dag-cbor encoded label.'
                    }
                }
            },
            selfLabels: {
                type: 'object',
                description: 'Metadata tags on an atproto record, published by the author within the record.',
                required: [
                    'values'
                ],
                properties: {
                    values: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#selfLabel'
                        },
                        maxLength: 10
                    }
                }
            },
            selfLabel: {
                type: 'object',
                description: 'Metadata tag on an atproto record, published by the author within the record. Note that schemas should use #selfLabels, not #selfLabel.',
                required: [
                    'val'
                ],
                properties: {
                    val: {
                        type: 'string',
                        maxLength: 128,
                        description: 'The short string name of the value or type of this label.'
                    }
                }
            },
            labelValueDefinition: {
                type: 'object',
                description: 'Declares a label value and its expected interpretations and behaviors.',
                required: [
                    'identifier',
                    'severity',
                    'blurs',
                    'locales'
                ],
                properties: {
                    identifier: {
                        type: 'string',
                        description: "The value of the label being defined. Must only include lowercase ascii and the '-' character ([a-z-]+).",
                        maxLength: 100,
                        maxGraphemes: 100
                    },
                    severity: {
                        type: 'string',
                        description: "How should a client visually convey this label? 'inform' means neutral and informational; 'alert' means negative and warning; 'none' means show nothing.",
                        knownValues: [
                            'inform',
                            'alert',
                            'none'
                        ]
                    },
                    blurs: {
                        type: 'string',
                        description: "What should this label hide in the UI, if applied? 'content' hides all of the target; 'media' hides the images/video/audio; 'none' hides nothing.",
                        knownValues: [
                            'content',
                            'media',
                            'none'
                        ]
                    },
                    defaultSetting: {
                        type: 'string',
                        description: 'The default setting for this label.',
                        knownValues: [
                            'ignore',
                            'warn',
                            'hide'
                        ],
                        default: 'warn'
                    },
                    adultOnly: {
                        type: 'boolean',
                        description: 'Does the user need to have adult content enabled in order to configure this label?'
                    },
                    locales: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#labelValueDefinitionStrings'
                        }
                    }
                }
            },
            labelValueDefinitionStrings: {
                type: 'object',
                description: 'Strings which describe the label in the UI, localized into a specific language.',
                required: [
                    'lang',
                    'name',
                    'description'
                ],
                properties: {
                    lang: {
                        type: 'string',
                        description: 'The code of the language these strings are written in.',
                        format: 'language'
                    },
                    name: {
                        type: 'string',
                        description: 'A short human-readable name for the label.',
                        maxGraphemes: 64,
                        maxLength: 640
                    },
                    description: {
                        type: 'string',
                        description: 'A longer description of what the label means and why it might be applied.',
                        maxGraphemes: 10000,
                        maxLength: 100000
                    }
                }
            },
            labelValue: {
                type: 'string',
                knownValues: [
                    '!hide',
                    '!no-promote',
                    '!warn',
                    '!no-unauthenticated',
                    'dmca-violation',
                    'doxxing',
                    'porn',
                    'sexual',
                    'nudity',
                    'nsfl',
                    'gore'
                ]
            }
        }
    },
    ComAtprotoLabelQueryLabels: {
        lexicon: 1,
        id: 'com.atproto.label.queryLabels',
        defs: {
            main: {
                type: 'query',
                description: 'Find labels relevant to the provided AT-URI patterns. Public endpoint for moderation services, though may return different or additional results with auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'uriPatterns'
                    ],
                    properties: {
                        uriPatterns: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: "List of AT URI patterns to match (boolean 'OR'). Each may be a prefix (ending with '*'; will match inclusive of the string leading to '*'), or a full URI."
                        },
                        sources: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'did'
                            },
                            description: 'Optional list of label sources (DIDs) to filter on.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 250,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'labels'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            labels: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.label.defs#label'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoLabelSubscribeLabels: {
        lexicon: 1,
        id: 'com.atproto.label.subscribeLabels',
        defs: {
            main: {
                type: 'subscription',
                description: 'Subscribe to stream of labels (and negations). Public endpoint implemented by mod services. Uses same sequencing scheme as repo event stream.',
                parameters: {
                    type: 'params',
                    properties: {
                        cursor: {
                            type: 'integer',
                            description: 'The last known event seq number to backfill from.'
                        }
                    }
                },
                message: {
                    schema: {
                        type: 'union',
                        refs: [
                            'lex:com.atproto.label.subscribeLabels#labels',
                            'lex:com.atproto.label.subscribeLabels#info'
                        ]
                    }
                },
                errors: [
                    {
                        name: 'FutureCursor'
                    }
                ]
            },
            labels: {
                type: 'object',
                required: [
                    'seq',
                    'labels'
                ],
                properties: {
                    seq: {
                        type: 'integer'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    }
                }
            },
            info: {
                type: 'object',
                required: [
                    'name'
                ],
                properties: {
                    name: {
                        type: 'string',
                        knownValues: [
                            'OutdatedCursor'
                        ]
                    },
                    message: {
                        type: 'string'
                    }
                }
            }
        }
    },
    ComAtprotoLexiconSchema: {
        lexicon: 1,
        id: 'com.atproto.lexicon.schema',
        defs: {
            main: {
                type: 'record',
                description: "Representation of Lexicon schemas themselves, when published as atproto records. Note that the schema language is not defined in Lexicon; this meta schema currently only includes a single version field ('lexicon'). See the atproto specifications for description of the other expected top-level fields ('id', 'defs', etc).",
                key: 'nsid',
                record: {
                    type: 'object',
                    required: [
                        'lexicon'
                    ],
                    properties: {
                        lexicon: {
                            type: 'integer',
                            description: "Indicates the 'version' of the Lexicon language. Must be '1' for the current atproto/Lexicon schema system."
                        }
                    }
                }
            }
        }
    },
    ComAtprotoModerationCreateReport: {
        lexicon: 1,
        id: 'com.atproto.moderation.createReport',
        defs: {
            main: {
                type: 'procedure',
                description: 'Submit a moderation report regarding an atproto account or record. Implemented by moderation services (with PDS proxying), and requires auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'reasonType',
                            'subject'
                        ],
                        properties: {
                            reasonType: {
                                type: 'ref',
                                description: 'Indicates the broad category of violation the report is for.',
                                ref: 'lex:com.atproto.moderation.defs#reasonType'
                            },
                            reason: {
                                type: 'string',
                                maxGraphemes: 2000,
                                maxLength: 20000,
                                description: 'Additional context about the content and violation.'
                            },
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef'
                                ]
                            },
                            modTool: {
                                type: 'ref',
                                ref: 'lex:com.atproto.moderation.createReport#modTool'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'id',
                            'reasonType',
                            'subject',
                            'reportedBy',
                            'createdAt'
                        ],
                        properties: {
                            id: {
                                type: 'integer'
                            },
                            reasonType: {
                                type: 'ref',
                                ref: 'lex:com.atproto.moderation.defs#reasonType'
                            },
                            reason: {
                                type: 'string',
                                maxGraphemes: 2000,
                                maxLength: 20000
                            },
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef'
                                ]
                            },
                            reportedBy: {
                                type: 'string',
                                format: 'did'
                            },
                            createdAt: {
                                type: 'string',
                                format: 'datetime'
                            }
                        }
                    }
                }
            },
            modTool: {
                type: 'object',
                description: 'Moderation tool information for tracing the source of the action',
                required: [
                    'name'
                ],
                properties: {
                    name: {
                        type: 'string',
                        description: "Name/identifier of the source (e.g., 'bsky-app/android', 'bsky-web/chrome')"
                    },
                    meta: {
                        type: 'unknown',
                        description: 'Additional arbitrary metadata about the source'
                    }
                }
            }
        }
    },
    ComAtprotoModerationDefs: {
        lexicon: 1,
        id: 'com.atproto.moderation.defs',
        defs: {
            reasonType: {
                type: 'string',
                knownValues: [
                    'com.atproto.moderation.defs#reasonSpam',
                    'com.atproto.moderation.defs#reasonViolation',
                    'com.atproto.moderation.defs#reasonMisleading',
                    'com.atproto.moderation.defs#reasonSexual',
                    'com.atproto.moderation.defs#reasonRude',
                    'com.atproto.moderation.defs#reasonOther',
                    'com.atproto.moderation.defs#reasonAppeal',
                    'tools.ozone.report.defs#reasonAppeal',
                    'tools.ozone.report.defs#reasonOther',
                    'tools.ozone.report.defs#reasonViolenceAnimal',
                    'tools.ozone.report.defs#reasonViolenceThreats',
                    'tools.ozone.report.defs#reasonViolenceGraphicContent',
                    'tools.ozone.report.defs#reasonViolenceGlorification',
                    'tools.ozone.report.defs#reasonViolenceExtremistContent',
                    'tools.ozone.report.defs#reasonViolenceTrafficking',
                    'tools.ozone.report.defs#reasonViolenceOther',
                    'tools.ozone.report.defs#reasonSexualAbuseContent',
                    'tools.ozone.report.defs#reasonSexualNCII',
                    'tools.ozone.report.defs#reasonSexualDeepfake',
                    'tools.ozone.report.defs#reasonSexualAnimal',
                    'tools.ozone.report.defs#reasonSexualUnlabeled',
                    'tools.ozone.report.defs#reasonSexualOther',
                    'tools.ozone.report.defs#reasonChildSafetyCSAM',
                    'tools.ozone.report.defs#reasonChildSafetyGroom',
                    'tools.ozone.report.defs#reasonChildSafetyPrivacy',
                    'tools.ozone.report.defs#reasonChildSafetyHarassment',
                    'tools.ozone.report.defs#reasonChildSafetyOther',
                    'tools.ozone.report.defs#reasonHarassmentTroll',
                    'tools.ozone.report.defs#reasonHarassmentTargeted',
                    'tools.ozone.report.defs#reasonHarassmentHateSpeech',
                    'tools.ozone.report.defs#reasonHarassmentDoxxing',
                    'tools.ozone.report.defs#reasonHarassmentOther',
                    'tools.ozone.report.defs#reasonMisleadingBot',
                    'tools.ozone.report.defs#reasonMisleadingImpersonation',
                    'tools.ozone.report.defs#reasonMisleadingSpam',
                    'tools.ozone.report.defs#reasonMisleadingScam',
                    'tools.ozone.report.defs#reasonMisleadingElections',
                    'tools.ozone.report.defs#reasonMisleadingOther',
                    'tools.ozone.report.defs#reasonRuleSiteSecurity',
                    'tools.ozone.report.defs#reasonRuleProhibitedSales',
                    'tools.ozone.report.defs#reasonRuleBanEvasion',
                    'tools.ozone.report.defs#reasonRuleOther',
                    'tools.ozone.report.defs#reasonSelfHarmContent',
                    'tools.ozone.report.defs#reasonSelfHarmED',
                    'tools.ozone.report.defs#reasonSelfHarmStunts',
                    'tools.ozone.report.defs#reasonSelfHarmSubstances',
                    'tools.ozone.report.defs#reasonSelfHarmOther'
                ]
            },
            reasonSpam: {
                type: 'token',
                description: 'Spam: frequent unwanted promotion, replies, mentions. Prefer new lexicon definition `tools.ozone.report.defs#reasonMisleadingSpam`.'
            },
            reasonViolation: {
                type: 'token',
                description: 'Direct violation of server rules, laws, terms of service. Prefer new lexicon definition `tools.ozone.report.defs#reasonRuleOther`.'
            },
            reasonMisleading: {
                type: 'token',
                description: 'Misleading identity, affiliation, or content. Prefer new lexicon definition `tools.ozone.report.defs#reasonMisleadingOther`.'
            },
            reasonSexual: {
                type: 'token',
                description: 'Unwanted or mislabeled sexual content. Prefer new lexicon definition `tools.ozone.report.defs#reasonSexualUnlabeled`.'
            },
            reasonRude: {
                type: 'token',
                description: 'Rude, harassing, explicit, or otherwise unwelcoming behavior. Prefer new lexicon definition `tools.ozone.report.defs#reasonHarassmentOther`.'
            },
            reasonOther: {
                type: 'token',
                description: 'Reports not falling under another report category. Prefer new lexicon definition `tools.ozone.report.defs#reasonOther`.'
            },
            reasonAppeal: {
                type: 'token',
                description: 'Appeal a previously taken moderation action'
            },
            subjectType: {
                type: 'string',
                description: 'Tag describing a type of subject that might be reported.',
                knownValues: [
                    'account',
                    'record',
                    'chat'
                ]
            }
        }
    },
    ComAtprotoRepoApplyWrites: {
        lexicon: 1,
        id: 'com.atproto.repo.applyWrites',
        defs: {
            main: {
                type: 'procedure',
                description: 'Apply a batch transaction of repository creates, updates, and deletes. Requires auth, implemented by PDS.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repo',
                            'writes'
                        ],
                        properties: {
                            repo: {
                                type: 'string',
                                format: 'at-identifier',
                                description: 'The handle or DID of the repo (aka, current account).'
                            },
                            validate: {
                                type: 'boolean',
                                description: "Can be set to 'false' to skip Lexicon schema validation of record data across all operations, 'true' to require it, or leave unset to validate only for known Lexicons."
                            },
                            writes: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:com.atproto.repo.applyWrites#create',
                                        'lex:com.atproto.repo.applyWrites#update',
                                        'lex:com.atproto.repo.applyWrites#delete'
                                    ],
                                    closed: true
                                }
                            },
                            swapCommit: {
                                type: 'string',
                                description: 'If provided, the entire operation will fail if the current repo commit CID does not match this value. Used to prevent conflicting repo mutations.',
                                format: 'cid'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [],
                        properties: {
                            commit: {
                                type: 'ref',
                                ref: 'lex:com.atproto.repo.defs#commitMeta'
                            },
                            results: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:com.atproto.repo.applyWrites#createResult',
                                        'lex:com.atproto.repo.applyWrites#updateResult',
                                        'lex:com.atproto.repo.applyWrites#deleteResult'
                                    ],
                                    closed: true
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidSwap',
                        description: "Indicates that the 'swapCommit' parameter did not match current commit."
                    }
                ]
            },
            create: {
                type: 'object',
                description: 'Operation which creates a new record.',
                required: [
                    'collection',
                    'value'
                ],
                properties: {
                    collection: {
                        type: 'string',
                        format: 'nsid'
                    },
                    rkey: {
                        type: 'string',
                        maxLength: 512,
                        format: 'record-key',
                        description: 'NOTE: maxLength is redundant with record-key format. Keeping it temporarily to ensure backwards compatibility.'
                    },
                    value: {
                        type: 'unknown'
                    }
                }
            },
            update: {
                type: 'object',
                description: 'Operation which updates an existing record.',
                required: [
                    'collection',
                    'rkey',
                    'value'
                ],
                properties: {
                    collection: {
                        type: 'string',
                        format: 'nsid'
                    },
                    rkey: {
                        type: 'string',
                        format: 'record-key'
                    },
                    value: {
                        type: 'unknown'
                    }
                }
            },
            delete: {
                type: 'object',
                description: 'Operation which deletes an existing record.',
                required: [
                    'collection',
                    'rkey'
                ],
                properties: {
                    collection: {
                        type: 'string',
                        format: 'nsid'
                    },
                    rkey: {
                        type: 'string',
                        format: 'record-key'
                    }
                }
            },
            createResult: {
                type: 'object',
                required: [
                    'uri',
                    'cid'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    validationStatus: {
                        type: 'string',
                        knownValues: [
                            'valid',
                            'unknown'
                        ]
                    }
                }
            },
            updateResult: {
                type: 'object',
                required: [
                    'uri',
                    'cid'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    validationStatus: {
                        type: 'string',
                        knownValues: [
                            'valid',
                            'unknown'
                        ]
                    }
                }
            },
            deleteResult: {
                type: 'object',
                required: [],
                properties: {}
            }
        }
    },
    ComAtprotoRepoCreateRecord: {
        lexicon: 1,
        id: 'com.atproto.repo.createRecord',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create a single new repository record. Requires auth, implemented by PDS.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repo',
                            'collection',
                            'record'
                        ],
                        properties: {
                            repo: {
                                type: 'string',
                                format: 'at-identifier',
                                description: 'The handle or DID of the repo (aka, current account).'
                            },
                            collection: {
                                type: 'string',
                                format: 'nsid',
                                description: 'The NSID of the record collection.'
                            },
                            rkey: {
                                type: 'string',
                                format: 'record-key',
                                description: 'The Record Key.',
                                maxLength: 512
                            },
                            validate: {
                                type: 'boolean',
                                description: "Can be set to 'false' to skip Lexicon schema validation of record data, 'true' to require it, or leave unset to validate only for known Lexicons."
                            },
                            record: {
                                type: 'unknown',
                                description: 'The record itself. Must contain a $type field.'
                            },
                            swapCommit: {
                                type: 'string',
                                format: 'cid',
                                description: 'Compare and swap with the previous commit by CID.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'cid'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            commit: {
                                type: 'ref',
                                ref: 'lex:com.atproto.repo.defs#commitMeta'
                            },
                            validationStatus: {
                                type: 'string',
                                knownValues: [
                                    'valid',
                                    'unknown'
                                ]
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidSwap',
                        description: "Indicates that 'swapCommit' didn't match current repo commit."
                    }
                ]
            }
        }
    },
    ComAtprotoRepoDefs: {
        lexicon: 1,
        id: 'com.atproto.repo.defs',
        defs: {
            commitMeta: {
                type: 'object',
                required: [
                    'cid',
                    'rev'
                ],
                properties: {
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    rev: {
                        type: 'string',
                        format: 'tid'
                    }
                }
            }
        }
    },
    ComAtprotoRepoDeleteRecord: {
        lexicon: 1,
        id: 'com.atproto.repo.deleteRecord',
        defs: {
            main: {
                type: 'procedure',
                description: "Delete a repository record, or ensure it doesn't exist. Requires auth, implemented by PDS.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repo',
                            'collection',
                            'rkey'
                        ],
                        properties: {
                            repo: {
                                type: 'string',
                                format: 'at-identifier',
                                description: 'The handle or DID of the repo (aka, current account).'
                            },
                            collection: {
                                type: 'string',
                                format: 'nsid',
                                description: 'The NSID of the record collection.'
                            },
                            rkey: {
                                type: 'string',
                                format: 'record-key',
                                description: 'The Record Key.'
                            },
                            swapRecord: {
                                type: 'string',
                                format: 'cid',
                                description: 'Compare and swap with the previous record by CID.'
                            },
                            swapCommit: {
                                type: 'string',
                                format: 'cid',
                                description: 'Compare and swap with the previous commit by CID.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            commit: {
                                type: 'ref',
                                ref: 'lex:com.atproto.repo.defs#commitMeta'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidSwap'
                    }
                ]
            }
        }
    },
    ComAtprotoRepoDescribeRepo: {
        lexicon: 1,
        id: 'com.atproto.repo.describeRepo',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about an account and repository, including the list of collections. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'repo'
                    ],
                    properties: {
                        repo: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'The handle or DID of the repo.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'handle',
                            'did',
                            'didDoc',
                            'collections',
                            'handleIsCorrect'
                        ],
                        properties: {
                            handle: {
                                type: 'string',
                                format: 'handle'
                            },
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            didDoc: {
                                type: 'unknown',
                                description: 'The complete DID document for this account.'
                            },
                            collections: {
                                type: 'array',
                                description: 'List of all the collections (NSIDs) for which this repo contains at least one record.',
                                items: {
                                    type: 'string',
                                    format: 'nsid'
                                }
                            },
                            handleIsCorrect: {
                                type: 'boolean',
                                description: 'Indicates if handle is currently valid (resolves bi-directionally)'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoRepoGetRecord: {
        lexicon: 1,
        id: 'com.atproto.repo.getRecord',
        defs: {
            main: {
                type: 'query',
                description: 'Get a single record from a repository. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'repo',
                        'collection',
                        'rkey'
                    ],
                    properties: {
                        repo: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'The handle or DID of the repo.'
                        },
                        collection: {
                            type: 'string',
                            format: 'nsid',
                            description: 'The NSID of the record collection.'
                        },
                        rkey: {
                            type: 'string',
                            description: 'The Record Key.',
                            format: 'record-key'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid',
                            description: 'The CID of the version of the record. If not specified, then return the most recent version.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'value'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            value: {
                                type: 'unknown'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'RecordNotFound'
                    }
                ]
            }
        }
    },
    ComAtprotoRepoImportRepo: {
        lexicon: 1,
        id: 'com.atproto.repo.importRepo',
        defs: {
            main: {
                type: 'procedure',
                description: 'Import a repo in the form of a CAR file. Requires Content-Length HTTP header to be set.',
                input: {
                    encoding: 'application/vnd.ipld.car'
                }
            }
        }
    },
    ComAtprotoRepoListMissingBlobs: {
        lexicon: 1,
        id: 'com.atproto.repo.listMissingBlobs',
        defs: {
            main: {
                type: 'query',
                description: 'Returns a list of missing blobs for the requesting account. Intended to be used in the account migration flow.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 1000,
                            default: 500
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'blobs'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            blobs: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.repo.listMissingBlobs#recordBlob'
                                }
                            }
                        }
                    }
                }
            },
            recordBlob: {
                type: 'object',
                required: [
                    'cid',
                    'recordUri'
                ],
                properties: {
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    recordUri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            }
        }
    },
    ComAtprotoRepoListRecords: {
        lexicon: 1,
        id: 'com.atproto.repo.listRecords',
        defs: {
            main: {
                type: 'query',
                description: 'List a range of records in a repository, matching a specific collection. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'repo',
                        'collection'
                    ],
                    properties: {
                        repo: {
                            type: 'string',
                            format: 'at-identifier',
                            description: 'The handle or DID of the repo.'
                        },
                        collection: {
                            type: 'string',
                            format: 'nsid',
                            description: 'The NSID of the record type.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50,
                            description: 'The number of records to return.'
                        },
                        cursor: {
                            type: 'string'
                        },
                        reverse: {
                            type: 'boolean',
                            description: 'Flag to reverse the order of the returned records.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'records'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            records: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.repo.listRecords#record'
                                }
                            }
                        }
                    }
                }
            },
            record: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'value'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    value: {
                        type: 'unknown'
                    }
                }
            }
        }
    },
    ComAtprotoRepoPutRecord: {
        lexicon: 1,
        id: 'com.atproto.repo.putRecord',
        defs: {
            main: {
                type: 'procedure',
                description: 'Write a repository record, creating or updating it as needed. Requires auth, implemented by PDS.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repo',
                            'collection',
                            'rkey',
                            'record'
                        ],
                        nullable: [
                            'swapRecord'
                        ],
                        properties: {
                            repo: {
                                type: 'string',
                                format: 'at-identifier',
                                description: 'The handle or DID of the repo (aka, current account).'
                            },
                            collection: {
                                type: 'string',
                                format: 'nsid',
                                description: 'The NSID of the record collection.'
                            },
                            rkey: {
                                type: 'string',
                                format: 'record-key',
                                description: 'The Record Key.',
                                maxLength: 512
                            },
                            validate: {
                                type: 'boolean',
                                description: "Can be set to 'false' to skip Lexicon schema validation of record data, 'true' to require it, or leave unset to validate only for known Lexicons."
                            },
                            record: {
                                type: 'unknown',
                                description: 'The record to write.'
                            },
                            swapRecord: {
                                type: 'string',
                                format: 'cid',
                                description: 'Compare and swap with the previous record by CID. WARNING: nullable and optional field; may cause problems with golang implementation'
                            },
                            swapCommit: {
                                type: 'string',
                                format: 'cid',
                                description: 'Compare and swap with the previous commit by CID.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uri',
                            'cid'
                        ],
                        properties: {
                            uri: {
                                type: 'string',
                                format: 'at-uri'
                            },
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            commit: {
                                type: 'ref',
                                ref: 'lex:com.atproto.repo.defs#commitMeta'
                            },
                            validationStatus: {
                                type: 'string',
                                knownValues: [
                                    'valid',
                                    'unknown'
                                ]
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidSwap'
                    }
                ]
            }
        }
    },
    ComAtprotoRepoStrongRef: {
        lexicon: 1,
        id: 'com.atproto.repo.strongRef',
        description: 'A URI with a content-hash fingerprint.',
        defs: {
            main: {
                type: 'object',
                required: [
                    'uri',
                    'cid'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    }
                }
            }
        }
    },
    ComAtprotoRepoUploadBlob: {
        lexicon: 1,
        id: 'com.atproto.repo.uploadBlob',
        defs: {
            main: {
                type: 'procedure',
                description: 'Upload a new blob, to be referenced from a repository record. The blob will be deleted if it is not referenced within a time window (eg, minutes). Blob restrictions (mimetype, size, etc) are enforced when the reference is created. Requires auth, implemented by PDS.',
                input: {
                    encoding: '*/*'
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'blob'
                        ],
                        properties: {
                            blob: {
                                type: 'blob'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerActivateAccount: {
        lexicon: 1,
        id: 'com.atproto.server.activateAccount',
        defs: {
            main: {
                type: 'procedure',
                description: "Activates a currently deactivated account. Used to finalize account migration after the account's repo is imported and identity is setup."
            }
        }
    },
    ComAtprotoServerCheckAccountStatus: {
        lexicon: 1,
        id: 'com.atproto.server.checkAccountStatus',
        defs: {
            main: {
                type: 'query',
                description: 'Returns the status of an account, especially as pertaining to import or recovery. Can be called many times over the course of an account migration. Requires auth and can only be called pertaining to oneself.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'activated',
                            'validDid',
                            'repoCommit',
                            'repoRev',
                            'repoBlocks',
                            'indexedRecords',
                            'privateStateValues',
                            'expectedBlobs',
                            'importedBlobs'
                        ],
                        properties: {
                            activated: {
                                type: 'boolean'
                            },
                            validDid: {
                                type: 'boolean'
                            },
                            repoCommit: {
                                type: 'string',
                                format: 'cid'
                            },
                            repoRev: {
                                type: 'string'
                            },
                            repoBlocks: {
                                type: 'integer'
                            },
                            indexedRecords: {
                                type: 'integer'
                            },
                            privateStateValues: {
                                type: 'integer'
                            },
                            expectedBlobs: {
                                type: 'integer'
                            },
                            importedBlobs: {
                                type: 'integer'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerConfirmEmail: {
        lexicon: 1,
        id: 'com.atproto.server.confirmEmail',
        defs: {
            main: {
                type: 'procedure',
                description: 'Confirm an email using a token from com.atproto.server.requestEmailConfirmation.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'email',
                            'token'
                        ],
                        properties: {
                            email: {
                                type: 'string'
                            },
                            token: {
                                type: 'string'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'AccountNotFound'
                    },
                    {
                        name: 'ExpiredToken'
                    },
                    {
                        name: 'InvalidToken'
                    },
                    {
                        name: 'InvalidEmail'
                    }
                ]
            }
        }
    },
    ComAtprotoServerCreateAccount: {
        lexicon: 1,
        id: 'com.atproto.server.createAccount',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create an account. Implemented by PDS.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'handle'
                        ],
                        properties: {
                            email: {
                                type: 'string'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle',
                                description: 'Requested handle for the account.'
                            },
                            did: {
                                type: 'string',
                                format: 'did',
                                description: 'Pre-existing atproto DID, being imported to a new account.'
                            },
                            inviteCode: {
                                type: 'string'
                            },
                            verificationCode: {
                                type: 'string'
                            },
                            verificationPhone: {
                                type: 'string'
                            },
                            password: {
                                type: 'string',
                                description: 'Initial account password. May need to meet instance-specific password strength requirements.'
                            },
                            recoveryKey: {
                                type: 'string',
                                description: 'DID PLC rotation key (aka, recovery key) to be included in PLC creation operation.'
                            },
                            plcOp: {
                                type: 'unknown',
                                description: 'A signed DID PLC operation to be submitted as part of importing an existing account to this instance. NOTE: this optional field may be updated when full account migration is implemented.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        description: 'Account login session returned on successful account creation.',
                        required: [
                            'accessJwt',
                            'refreshJwt',
                            'handle',
                            'did'
                        ],
                        properties: {
                            accessJwt: {
                                type: 'string'
                            },
                            refreshJwt: {
                                type: 'string'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle'
                            },
                            did: {
                                type: 'string',
                                format: 'did',
                                description: 'The DID of the new account.'
                            },
                            didDoc: {
                                type: 'unknown',
                                description: 'Complete DID document.'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidHandle'
                    },
                    {
                        name: 'InvalidPassword'
                    },
                    {
                        name: 'InvalidInviteCode'
                    },
                    {
                        name: 'HandleNotAvailable'
                    },
                    {
                        name: 'UnsupportedDomain'
                    },
                    {
                        name: 'UnresolvableDid'
                    },
                    {
                        name: 'IncompatibleDidDoc'
                    }
                ]
            }
        }
    },
    ComAtprotoServerCreateAppPassword: {
        lexicon: 1,
        id: 'com.atproto.server.createAppPassword',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create an App Password.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'name'
                        ],
                        properties: {
                            name: {
                                type: 'string',
                                description: 'A short name for the App Password, to help distinguish them.'
                            },
                            privileged: {
                                type: 'boolean',
                                description: "If an app password has 'privileged' access to possibly sensitive account state. Meant for use with trusted clients."
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:com.atproto.server.createAppPassword#appPassword'
                    }
                },
                errors: [
                    {
                        name: 'AccountTakedown'
                    }
                ]
            },
            appPassword: {
                type: 'object',
                required: [
                    'name',
                    'password',
                    'createdAt'
                ],
                properties: {
                    name: {
                        type: 'string'
                    },
                    password: {
                        type: 'string'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    privileged: {
                        type: 'boolean'
                    }
                }
            }
        }
    },
    ComAtprotoServerCreateCustomJwtSession: {
        lexicon: 1,
        id: 'com.atproto.server.createCustomJwtSession',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create an authentication session using custom JWT token.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'verifier',
                            'options'
                        ],
                        properties: {
                            verifier: {
                                type: 'string',
                                description: 'The verifier identifier for authentication.'
                            },
                            options: {
                                type: 'ref',
                                ref: 'lex:com.atproto.server.createCustomJwtSession#jwtOptions'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle',
                                description: 'Requested handle for the account.'
                            },
                            did: {
                                type: 'string',
                                format: 'did',
                                description: 'Pre-existing atproto DID, being imported to a new account.'
                            },
                            plcOp: {
                                type: 'unknown',
                                description: 'A signed DID PLC operation to be submitted as part of importing an existing account to this instance. NOTE: this optional field may be updated when full account migration is implemented.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        description: 'Account login session returned on successful account creation.',
                        required: [
                            'accessJwt',
                            'refreshJwt',
                            'handle',
                            'did'
                        ],
                        properties: {
                            accessJwt: {
                                type: 'string'
                            },
                            refreshJwt: {
                                type: 'string'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle'
                            },
                            did: {
                                type: 'string',
                                format: 'did',
                                description: 'The DID of the new account.'
                            },
                            didDoc: {
                                type: 'unknown',
                                description: 'Complete DID document.'
                            },
                            isNew: {
                                type: 'boolean',
                                description: 'Whether the account is new.'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidJwtToken'
                    },
                    {
                        name: 'HandleNotAvailable'
                    },
                    {
                        name: 'UnsupportedDomain'
                    },
                    {
                        name: 'UnresolvableDid'
                    },
                    {
                        name: 'IncompatibleDidDoc'
                    }
                ]
            },
            jwtOptions: {
                type: 'object',
                required: [
                    'id_token'
                ],
                properties: {
                    id_token: {
                        type: 'string',
                        description: 'The JWT ID token to be verified and used for authentication.'
                    }
                }
            }
        }
    },
    ComAtprotoServerCreateInviteCode: {
        lexicon: 1,
        id: 'com.atproto.server.createInviteCode',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create an invite code.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'useCount'
                        ],
                        properties: {
                            useCount: {
                                type: 'integer'
                            },
                            forAccount: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'code'
                        ],
                        properties: {
                            code: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerCreateInviteCodes: {
        lexicon: 1,
        id: 'com.atproto.server.createInviteCodes',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create invite codes.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'codeCount',
                            'useCount'
                        ],
                        properties: {
                            codeCount: {
                                type: 'integer',
                                default: 1
                            },
                            useCount: {
                                type: 'integer'
                            },
                            forAccounts: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                    format: 'did'
                                }
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'codes'
                        ],
                        properties: {
                            codes: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.server.createInviteCodes#accountCodes'
                                }
                            }
                        }
                    }
                }
            },
            accountCodes: {
                type: 'object',
                required: [
                    'account',
                    'codes'
                ],
                properties: {
                    account: {
                        type: 'string'
                    },
                    codes: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerCreateSession: {
        lexicon: 1,
        id: 'com.atproto.server.createSession',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create an authentication session.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'identifier',
                            'password'
                        ],
                        properties: {
                            identifier: {
                                type: 'string',
                                description: 'Handle or other identifier supported by the server for the authenticating user.'
                            },
                            password: {
                                type: 'string'
                            },
                            authFactorToken: {
                                type: 'string'
                            },
                            allowTakendown: {
                                type: 'boolean',
                                description: 'When true, instead of throwing error for takendown accounts, a valid response with a narrow scoped token will be returned'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'accessJwt',
                            'refreshJwt',
                            'handle',
                            'did'
                        ],
                        properties: {
                            accessJwt: {
                                type: 'string'
                            },
                            refreshJwt: {
                                type: 'string'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle'
                            },
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            didDoc: {
                                type: 'unknown'
                            },
                            email: {
                                type: 'string'
                            },
                            emailConfirmed: {
                                type: 'boolean'
                            },
                            emailAuthFactor: {
                                type: 'boolean'
                            },
                            active: {
                                type: 'boolean'
                            },
                            status: {
                                type: 'string',
                                description: 'If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.',
                                knownValues: [
                                    'takendown',
                                    'suspended',
                                    'deactivated'
                                ]
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'AccountTakedown'
                    },
                    {
                        name: 'AuthFactorTokenRequired'
                    }
                ]
            }
        }
    },
    ComAtprotoServerDeactivateAccount: {
        lexicon: 1,
        id: 'com.atproto.server.deactivateAccount',
        defs: {
            main: {
                type: 'procedure',
                description: 'Deactivates a currently active account. Stops serving of repo, and future writes to repo until reactivated. Used to finalize account migration with the old host after the account has been activated on the new host.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            deleteAfter: {
                                type: 'string',
                                format: 'datetime',
                                description: 'A recommendation to server as to how long they should hold onto the deactivated account before deleting.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerDefs: {
        lexicon: 1,
        id: 'com.atproto.server.defs',
        defs: {
            inviteCode: {
                type: 'object',
                required: [
                    'code',
                    'available',
                    'disabled',
                    'forAccount',
                    'createdBy',
                    'createdAt',
                    'uses'
                ],
                properties: {
                    code: {
                        type: 'string'
                    },
                    available: {
                        type: 'integer'
                    },
                    disabled: {
                        type: 'boolean'
                    },
                    forAccount: {
                        type: 'string'
                    },
                    createdBy: {
                        type: 'string'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    uses: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.server.defs#inviteCodeUse'
                        }
                    }
                }
            },
            inviteCodeUse: {
                type: 'object',
                required: [
                    'usedBy',
                    'usedAt'
                ],
                properties: {
                    usedBy: {
                        type: 'string',
                        format: 'did'
                    },
                    usedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            }
        }
    },
    ComAtprotoServerDeleteAccount: {
        lexicon: 1,
        id: 'com.atproto.server.deleteAccount',
        defs: {
            main: {
                type: 'procedure',
                description: "Delete an actor's account with a token and password. Can only be called after requesting a deletion token. Requires auth.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'password',
                            'token'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            password: {
                                type: 'string'
                            },
                            token: {
                                type: 'string'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'ExpiredToken'
                    },
                    {
                        name: 'InvalidToken'
                    }
                ]
            }
        }
    },
    ComAtprotoServerDeleteSession: {
        lexicon: 1,
        id: 'com.atproto.server.deleteSession',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete the current session. Requires auth.'
            }
        }
    },
    ComAtprotoServerDescribeServer: {
        lexicon: 1,
        id: 'com.atproto.server.describeServer',
        defs: {
            main: {
                type: 'query',
                description: "Describes the server's account creation requirements and capabilities. Implemented by PDS.",
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'availableUserDomains'
                        ],
                        properties: {
                            inviteCodeRequired: {
                                type: 'boolean',
                                description: 'If true, an invite code must be supplied to create an account on this instance.'
                            },
                            phoneVerificationRequired: {
                                type: 'boolean',
                                description: 'If true, a phone verification token must be supplied to create an account on this instance.'
                            },
                            availableUserDomains: {
                                type: 'array',
                                description: 'List of domain suffixes that can be used in account handles.',
                                items: {
                                    type: 'string'
                                }
                            },
                            links: {
                                type: 'ref',
                                description: 'URLs of service policy documents.',
                                ref: 'lex:com.atproto.server.describeServer#links'
                            },
                            contact: {
                                type: 'ref',
                                description: 'Contact information',
                                ref: 'lex:com.atproto.server.describeServer#contact'
                            },
                            did: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                }
            },
            links: {
                type: 'object',
                properties: {
                    privacyPolicy: {
                        type: 'string',
                        format: 'uri'
                    },
                    termsOfService: {
                        type: 'string',
                        format: 'uri'
                    }
                }
            },
            contact: {
                type: 'object',
                properties: {
                    email: {
                        type: 'string'
                    }
                }
            }
        }
    },
    ComAtprotoServerGetAccountInviteCodes: {
        lexicon: 1,
        id: 'com.atproto.server.getAccountInviteCodes',
        defs: {
            main: {
                type: 'query',
                description: 'Get all invite codes for the current account. Requires auth.',
                parameters: {
                    type: 'params',
                    properties: {
                        includeUsed: {
                            type: 'boolean',
                            default: true
                        },
                        createAvailable: {
                            type: 'boolean',
                            default: true,
                            description: "Controls whether any new 'earned' but not 'created' invites should be created."
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'codes'
                        ],
                        properties: {
                            codes: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.server.defs#inviteCode'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'DuplicateCreate'
                    }
                ]
            }
        }
    },
    ComAtprotoServerGetServiceAuth: {
        lexicon: 1,
        id: 'com.atproto.server.getServiceAuth',
        defs: {
            main: {
                type: 'query',
                description: 'Get a signed token on behalf of the requesting DID for the requested service.',
                parameters: {
                    type: 'params',
                    required: [
                        'aud'
                    ],
                    properties: {
                        aud: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the service that the token will be used to authenticate with'
                        },
                        exp: {
                            type: 'integer',
                            description: 'The time in Unix Epoch seconds that the JWT expires. Defaults to 60 seconds in the future. The service may enforce certain time bounds on tokens depending on the requested scope.'
                        },
                        lxm: {
                            type: 'string',
                            format: 'nsid',
                            description: 'Lexicon (XRPC) method to bind the requested token to'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'token'
                        ],
                        properties: {
                            token: {
                                type: 'string'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'BadExpiration',
                        description: 'Indicates that the requested expiration date is not a valid. May be in the past or may be reliant on the requested scopes.'
                    }
                ]
            }
        }
    },
    ComAtprotoServerGetSession: {
        lexicon: 1,
        id: 'com.atproto.server.getSession',
        defs: {
            main: {
                type: 'query',
                description: 'Get information about the current auth session. Requires auth.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'handle',
                            'did'
                        ],
                        properties: {
                            handle: {
                                type: 'string',
                                format: 'handle'
                            },
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            email: {
                                type: 'string'
                            },
                            emailConfirmed: {
                                type: 'boolean'
                            },
                            emailAuthFactor: {
                                type: 'boolean'
                            },
                            didDoc: {
                                type: 'unknown'
                            },
                            active: {
                                type: 'boolean'
                            },
                            status: {
                                type: 'string',
                                description: 'If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.',
                                knownValues: [
                                    'takendown',
                                    'suspended',
                                    'deactivated'
                                ]
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerListAppPasswords: {
        lexicon: 1,
        id: 'com.atproto.server.listAppPasswords',
        defs: {
            main: {
                type: 'query',
                description: 'List all App Passwords.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'passwords'
                        ],
                        properties: {
                            passwords: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.server.listAppPasswords#appPassword'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'AccountTakedown'
                    }
                ]
            },
            appPassword: {
                type: 'object',
                required: [
                    'name',
                    'createdAt'
                ],
                properties: {
                    name: {
                        type: 'string'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    privileged: {
                        type: 'boolean'
                    }
                }
            }
        }
    },
    ComAtprotoServerRefreshSession: {
        lexicon: 1,
        id: 'com.atproto.server.refreshSession',
        defs: {
            main: {
                type: 'procedure',
                description: "Refresh an authentication session. Requires auth using the 'refreshJwt' (not the 'accessJwt').",
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'accessJwt',
                            'refreshJwt',
                            'handle',
                            'did'
                        ],
                        properties: {
                            accessJwt: {
                                type: 'string'
                            },
                            refreshJwt: {
                                type: 'string'
                            },
                            handle: {
                                type: 'string',
                                format: 'handle'
                            },
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            didDoc: {
                                type: 'unknown'
                            },
                            active: {
                                type: 'boolean'
                            },
                            status: {
                                type: 'string',
                                description: "Hosting status of the account. If not specified, then assume 'active'.",
                                knownValues: [
                                    'takendown',
                                    'suspended',
                                    'deactivated'
                                ]
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'AccountTakedown'
                    }
                ]
            }
        }
    },
    ComAtprotoServerRequestAccountDelete: {
        lexicon: 1,
        id: 'com.atproto.server.requestAccountDelete',
        defs: {
            main: {
                type: 'procedure',
                description: 'Initiate a user account deletion via email.'
            }
        }
    },
    ComAtprotoServerRequestEmailConfirmation: {
        lexicon: 1,
        id: 'com.atproto.server.requestEmailConfirmation',
        defs: {
            main: {
                type: 'procedure',
                description: 'Request an email with a code to confirm ownership of email.'
            }
        }
    },
    ComAtprotoServerRequestEmailUpdate: {
        lexicon: 1,
        id: 'com.atproto.server.requestEmailUpdate',
        defs: {
            main: {
                type: 'procedure',
                description: 'Request a token in order to update email.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'tokenRequired'
                        ],
                        properties: {
                            tokenRequired: {
                                type: 'boolean'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerRequestPasswordReset: {
        lexicon: 1,
        id: 'com.atproto.server.requestPasswordReset',
        defs: {
            main: {
                type: 'procedure',
                description: 'Initiate a user account password reset via email.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'email'
                        ],
                        properties: {
                            email: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerReserveSigningKey: {
        lexicon: 1,
        id: 'com.atproto.server.reserveSigningKey',
        defs: {
            main: {
                type: 'procedure',
                description: 'Reserve a repo signing key, for use with account creation. Necessary so that a DID PLC update operation can be constructed during an account migraiton. Public and does not require auth; implemented by PDS. NOTE: this endpoint may change when full account migration is implemented.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did',
                                description: 'The DID to reserve a key for.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'signingKey'
                        ],
                        properties: {
                            signingKey: {
                                type: 'string',
                                description: 'The public key for the reserved signing key, in did:key serialization.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerResetPassword: {
        lexicon: 1,
        id: 'com.atproto.server.resetPassword',
        defs: {
            main: {
                type: 'procedure',
                description: 'Reset a user account password using a token.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'token',
                            'password'
                        ],
                        properties: {
                            token: {
                                type: 'string'
                            },
                            password: {
                                type: 'string'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'ExpiredToken'
                    },
                    {
                        name: 'InvalidToken'
                    }
                ]
            }
        }
    },
    ComAtprotoServerRevokeAppPassword: {
        lexicon: 1,
        id: 'com.atproto.server.revokeAppPassword',
        defs: {
            main: {
                type: 'procedure',
                description: 'Revoke an App Password by name.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'name'
                        ],
                        properties: {
                            name: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoServerUpdateEmail: {
        lexicon: 1,
        id: 'com.atproto.server.updateEmail',
        defs: {
            main: {
                type: 'procedure',
                description: "Update an account's email.",
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'email'
                        ],
                        properties: {
                            email: {
                                type: 'string'
                            },
                            emailAuthFactor: {
                                type: 'boolean'
                            },
                            token: {
                                type: 'string',
                                description: "Requires a token from com.atproto.sever.requestEmailUpdate if the account's email has been confirmed."
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'ExpiredToken'
                    },
                    {
                        name: 'InvalidToken'
                    },
                    {
                        name: 'TokenRequired'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncDefs: {
        lexicon: 1,
        id: 'com.atproto.sync.defs',
        defs: {
            hostStatus: {
                type: 'string',
                knownValues: [
                    'active',
                    'idle',
                    'offline',
                    'throttled',
                    'banned'
                ]
            }
        }
    },
    ComAtprotoSyncGetBlob: {
        lexicon: 1,
        id: 'com.atproto.sync.getBlob',
        defs: {
            main: {
                type: 'query',
                description: 'Get a blob associated with a given account. Returns the full blob as originally uploaded. Does not require auth; implemented by PDS.',
                parameters: {
                    type: 'params',
                    required: [
                        'did',
                        'cid'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the account.'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid',
                            description: 'The CID of the blob to fetch'
                        }
                    }
                },
                output: {
                    encoding: '*/*'
                },
                errors: [
                    {
                        name: 'BlobNotFound'
                    },
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetBlocks: {
        lexicon: 1,
        id: 'com.atproto.sync.getBlocks',
        defs: {
            main: {
                type: 'query',
                description: 'Get data blocks from a given repo, by CID. For example, intermediate MST nodes, or records. Does not require auth; implemented by PDS.',
                parameters: {
                    type: 'params',
                    required: [
                        'did',
                        'cids'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        },
                        cids: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'cid'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/vnd.ipld.car'
                },
                errors: [
                    {
                        name: 'BlockNotFound'
                    },
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetCheckout: {
        lexicon: 1,
        id: 'com.atproto.sync.getCheckout',
        defs: {
            main: {
                type: 'query',
                description: 'DEPRECATED - please use com.atproto.sync.getRepo instead',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        }
                    }
                },
                output: {
                    encoding: 'application/vnd.ipld.car'
                }
            }
        }
    },
    ComAtprotoSyncGetHead: {
        lexicon: 1,
        id: 'com.atproto.sync.getHead',
        defs: {
            main: {
                type: 'query',
                description: 'DEPRECATED - please use com.atproto.sync.getLatestCommit instead',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'root'
                        ],
                        properties: {
                            root: {
                                type: 'string',
                                format: 'cid'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'HeadNotFound'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetHostStatus: {
        lexicon: 1,
        id: 'com.atproto.sync.getHostStatus',
        defs: {
            main: {
                type: 'query',
                description: 'Returns information about a specified upstream host, as consumed by the server. Implemented by relays.',
                parameters: {
                    type: 'params',
                    required: [
                        'hostname'
                    ],
                    properties: {
                        hostname: {
                            type: 'string',
                            description: 'Hostname of the host (eg, PDS or relay) being queried.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'hostname'
                        ],
                        properties: {
                            hostname: {
                                type: 'string'
                            },
                            seq: {
                                type: 'integer',
                                description: 'Recent repo stream event sequence number. May be delayed from actual stream processing (eg, persisted cursor not in-memory cursor).'
                            },
                            accountCount: {
                                type: 'integer',
                                description: 'Number of accounts on the server which are associated with the upstream host. Note that the upstream may actually have more accounts.'
                            },
                            status: {
                                type: 'ref',
                                ref: 'lex:com.atproto.sync.defs#hostStatus'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'HostNotFound'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetLatestCommit: {
        lexicon: 1,
        id: 'com.atproto.sync.getLatestCommit',
        defs: {
            main: {
                type: 'query',
                description: 'Get the current commit CID & revision of the specified repo. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'cid',
                            'rev'
                        ],
                        properties: {
                            cid: {
                                type: 'string',
                                format: 'cid'
                            },
                            rev: {
                                type: 'string',
                                format: 'tid'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetRecord: {
        lexicon: 1,
        id: 'com.atproto.sync.getRecord',
        defs: {
            main: {
                type: 'query',
                description: 'Get data blocks needed to prove the existence or non-existence of record in the current version of repo. Does not require auth.',
                parameters: {
                    type: 'params',
                    required: [
                        'did',
                        'collection',
                        'rkey'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        },
                        collection: {
                            type: 'string',
                            format: 'nsid'
                        },
                        rkey: {
                            type: 'string',
                            description: 'Record Key',
                            format: 'record-key'
                        }
                    }
                },
                output: {
                    encoding: 'application/vnd.ipld.car'
                },
                errors: [
                    {
                        name: 'RecordNotFound'
                    },
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetRepo: {
        lexicon: 1,
        id: 'com.atproto.sync.getRepo',
        defs: {
            main: {
                type: 'query',
                description: "Download a repository export as CAR file. Optionally only a 'diff' since a previous revision. Does not require auth; implemented by PDS.",
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        },
                        since: {
                            type: 'string',
                            format: 'tid',
                            description: "The revision ('rev') of the repo to create a diff from."
                        }
                    }
                },
                output: {
                    encoding: 'application/vnd.ipld.car'
                },
                errors: [
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncGetRepoStatus: {
        lexicon: 1,
        id: 'com.atproto.sync.getRepoStatus',
        defs: {
            main: {
                type: 'query',
                description: 'Get the hosting status for a repository, on this server. Expected to be implemented by PDS and Relay.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'active'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            active: {
                                type: 'boolean'
                            },
                            status: {
                                type: 'string',
                                description: 'If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.',
                                knownValues: [
                                    'takendown',
                                    'suspended',
                                    'deleted',
                                    'deactivated',
                                    'desynchronized',
                                    'throttled'
                                ]
                            },
                            rev: {
                                type: 'string',
                                format: 'tid',
                                description: 'Optional field, the current rev of the repo, if active=true'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'RepoNotFound'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncListBlobs: {
        lexicon: 1,
        id: 'com.atproto.sync.listBlobs',
        defs: {
            main: {
                type: 'query',
                description: 'List blob CIDs for an account, since some repo revision. Does not require auth; implemented by PDS.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did',
                            description: 'The DID of the repo.'
                        },
                        since: {
                            type: 'string',
                            format: 'tid',
                            description: 'Optional revision of the repo to list blobs since.'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 1000,
                            default: 500
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'cids'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            cids: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                    format: 'cid'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'RepoNotFound'
                    },
                    {
                        name: 'RepoTakendown'
                    },
                    {
                        name: 'RepoSuspended'
                    },
                    {
                        name: 'RepoDeactivated'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncListHosts: {
        lexicon: 1,
        id: 'com.atproto.sync.listHosts',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates upstream hosts (eg, PDS or relay instances) that this service consumes from. Implemented by relays.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 1000,
                            default: 200
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'hosts'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            hosts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.sync.listHosts#host'
                                },
                                description: 'Sort order is not formally specified. Recommended order is by time host was first seen by the server, with oldest first.'
                            }
                        }
                    }
                }
            },
            host: {
                type: 'object',
                required: [
                    'hostname'
                ],
                properties: {
                    hostname: {
                        type: 'string',
                        description: 'hostname of server; not a URL (no scheme)'
                    },
                    seq: {
                        type: 'integer',
                        description: 'Recent repo stream event sequence number. May be delayed from actual stream processing (eg, persisted cursor not in-memory cursor).'
                    },
                    accountCount: {
                        type: 'integer'
                    },
                    status: {
                        type: 'ref',
                        ref: 'lex:com.atproto.sync.defs#hostStatus'
                    }
                }
            }
        }
    },
    ComAtprotoSyncListRepos: {
        lexicon: 1,
        id: 'com.atproto.sync.listRepos',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates all the DID, rev, and commit CID for all repos hosted by this service. Does not require auth; implemented by PDS and Relay.',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 1000,
                            default: 500
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repos'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            repos: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.sync.listRepos#repo'
                                }
                            }
                        }
                    }
                }
            },
            repo: {
                type: 'object',
                required: [
                    'did',
                    'head',
                    'rev'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    head: {
                        type: 'string',
                        format: 'cid',
                        description: 'Current repo commit CID'
                    },
                    rev: {
                        type: 'string',
                        format: 'tid'
                    },
                    active: {
                        type: 'boolean'
                    },
                    status: {
                        type: 'string',
                        description: 'If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.',
                        knownValues: [
                            'takendown',
                            'suspended',
                            'deleted',
                            'deactivated',
                            'desynchronized',
                            'throttled'
                        ]
                    }
                }
            }
        }
    },
    ComAtprotoSyncListReposByCollection: {
        lexicon: 1,
        id: 'com.atproto.sync.listReposByCollection',
        defs: {
            main: {
                type: 'query',
                description: 'Enumerates all the DIDs which have records with the given collection NSID.',
                parameters: {
                    type: 'params',
                    required: [
                        'collection'
                    ],
                    properties: {
                        collection: {
                            type: 'string',
                            format: 'nsid'
                        },
                        limit: {
                            type: 'integer',
                            description: 'Maximum size of response set. Recommend setting a large maximum (1000+) when enumerating large DID lists.',
                            minimum: 1,
                            maximum: 2000,
                            default: 500
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repos'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            repos: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.sync.listReposByCollection#repo'
                                }
                            }
                        }
                    }
                }
            },
            repo: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            }
        }
    },
    ComAtprotoSyncNotifyOfUpdate: {
        lexicon: 1,
        id: 'com.atproto.sync.notifyOfUpdate',
        defs: {
            main: {
                type: 'procedure',
                description: 'Notify a crawling service of a recent update, and that crawling should resume. Intended use is after a gap between repo stream events caused the crawling service to disconnect. Does not require auth; implemented by Relay. DEPRECATED: just use com.atproto.sync.requestCrawl',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'hostname'
                        ],
                        properties: {
                            hostname: {
                                type: 'string',
                                description: 'Hostname of the current service (usually a PDS) that is notifying of update.'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoSyncRequestCrawl: {
        lexicon: 1,
        id: 'com.atproto.sync.requestCrawl',
        defs: {
            main: {
                type: 'procedure',
                description: 'Request a service to persistently crawl hosted repos. Expected use is new PDS instances declaring their existence to Relays. Does not require auth.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'hostname'
                        ],
                        properties: {
                            hostname: {
                                type: 'string',
                                description: 'Hostname of the current service (eg, PDS) that is requesting to be crawled.'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'HostBanned'
                    }
                ]
            }
        }
    },
    ComAtprotoSyncSubscribeRepos: {
        lexicon: 1,
        id: 'com.atproto.sync.subscribeRepos',
        defs: {
            main: {
                type: 'subscription',
                description: 'Repository event stream, aka Firehose endpoint. Outputs repo commits with diff data, and identity update events, for all repositories on the current server. See the atproto specifications for details around stream sequencing, repo versioning, CAR diff format, and more. Public and does not require auth; implemented by PDS and Relay.',
                parameters: {
                    type: 'params',
                    properties: {
                        cursor: {
                            type: 'integer',
                            description: 'The last known event seq number to backfill from.'
                        }
                    }
                },
                message: {
                    schema: {
                        type: 'union',
                        refs: [
                            'lex:com.atproto.sync.subscribeRepos#commit',
                            'lex:com.atproto.sync.subscribeRepos#sync',
                            'lex:com.atproto.sync.subscribeRepos#identity',
                            'lex:com.atproto.sync.subscribeRepos#account',
                            'lex:com.atproto.sync.subscribeRepos#info'
                        ]
                    }
                },
                errors: [
                    {
                        name: 'FutureCursor'
                    },
                    {
                        name: 'ConsumerTooSlow',
                        description: 'If the consumer of the stream can not keep up with events, and a backlog gets too large, the server will drop the connection.'
                    }
                ]
            },
            commit: {
                type: 'object',
                description: 'Represents an update of repository state. Note that empty commits are allowed, which include no repo data changes, but an update to rev and signature.',
                required: [
                    'seq',
                    'rebase',
                    'tooBig',
                    'repo',
                    'commit',
                    'rev',
                    'since',
                    'blocks',
                    'ops',
                    'blobs',
                    'time'
                ],
                nullable: [
                    'since'
                ],
                properties: {
                    seq: {
                        type: 'integer',
                        description: 'The stream sequence number of this message.'
                    },
                    rebase: {
                        type: 'boolean',
                        description: 'DEPRECATED -- unused'
                    },
                    tooBig: {
                        type: 'boolean',
                        description: 'DEPRECATED -- replaced by #sync event and data limits. Indicates that this commit contained too many ops, or data size was too large. Consumers will need to make a separate request to get missing data.'
                    },
                    repo: {
                        type: 'string',
                        format: 'did',
                        description: "The repo this event comes from. Note that all other message types name this field 'did'."
                    },
                    commit: {
                        type: 'cid-link',
                        description: 'Repo commit object CID.'
                    },
                    rev: {
                        type: 'string',
                        format: 'tid',
                        description: 'The rev of the emitted commit. Note that this information is also in the commit object included in blocks, unless this is a tooBig event.'
                    },
                    since: {
                        type: 'string',
                        format: 'tid',
                        description: 'The rev of the last emitted commit from this repo (if any).'
                    },
                    blocks: {
                        type: 'bytes',
                        description: "CAR file containing relevant blocks, as a diff since the previous repo state. The commit must be included as a block, and the commit block CID must be the first entry in the CAR header 'roots' list.",
                        maxLength: 2000000
                    },
                    ops: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.sync.subscribeRepos#repoOp',
                            description: 'List of repo mutation operations in this commit (eg, records created, updated, or deleted).'
                        },
                        maxLength: 200
                    },
                    blobs: {
                        type: 'array',
                        items: {
                            type: 'cid-link',
                            description: 'DEPRECATED -- will soon always be empty. List of new blobs (by CID) referenced by records in this commit.'
                        }
                    },
                    prevData: {
                        type: 'cid-link',
                        description: "The root CID of the MST tree for the previous commit from this repo (indicated by the 'since' revision field in this message). Corresponds to the 'data' field in the repo commit object. NOTE: this field is effectively required for the 'inductive' version of firehose."
                    },
                    time: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp of when this message was originally broadcast.'
                    }
                }
            },
            sync: {
                type: 'object',
                description: 'Updates the repo to a new state, without necessarily including that state on the firehose. Used to recover from broken commit streams, data loss incidents, or in situations where upstream host does not know recent state of the repository.',
                required: [
                    'seq',
                    'did',
                    'blocks',
                    'rev',
                    'time'
                ],
                properties: {
                    seq: {
                        type: 'integer',
                        description: 'The stream sequence number of this message.'
                    },
                    did: {
                        type: 'string',
                        format: 'did',
                        description: 'The account this repo event corresponds to. Must match that in the commit object.'
                    },
                    blocks: {
                        type: 'bytes',
                        description: "CAR file containing the commit, as a block. The CAR header must include the commit block CID as the first 'root'.",
                        maxLength: 10000
                    },
                    rev: {
                        type: 'string',
                        description: 'The rev of the commit. This value must match that in the commit object.'
                    },
                    time: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp of when this message was originally broadcast.'
                    }
                }
            },
            identity: {
                type: 'object',
                description: "Represents a change to an account's identity. Could be an updated handle, signing key, or pds hosting endpoint. Serves as a prod to all downstream services to refresh their identity cache.",
                required: [
                    'seq',
                    'did',
                    'time'
                ],
                properties: {
                    seq: {
                        type: 'integer'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    time: {
                        type: 'string',
                        format: 'datetime'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle',
                        description: "The current handle for the account, or 'handle.invalid' if validation fails. This field is optional, might have been validated or passed-through from an upstream source. Semantics and behaviors for PDS vs Relay may evolve in the future; see atproto specs for more details."
                    }
                }
            },
            account: {
                type: 'object',
                description: "Represents a change to an account's status on a host (eg, PDS or Relay). The semantics of this event are that the status is at the host which emitted the event, not necessarily that at the currently active PDS. Eg, a Relay takedown would emit a takedown with active=false, even if the PDS is still active.",
                required: [
                    'seq',
                    'did',
                    'time',
                    'active'
                ],
                properties: {
                    seq: {
                        type: 'integer'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    time: {
                        type: 'string',
                        format: 'datetime'
                    },
                    active: {
                        type: 'boolean',
                        description: 'Indicates that the account has a repository which can be fetched from the host that emitted this event.'
                    },
                    status: {
                        type: 'string',
                        description: 'If active=false, this optional field indicates a reason for why the account is not active.',
                        knownValues: [
                            'takendown',
                            'suspended',
                            'deleted',
                            'deactivated',
                            'desynchronized',
                            'throttled'
                        ]
                    }
                }
            },
            info: {
                type: 'object',
                required: [
                    'name'
                ],
                properties: {
                    name: {
                        type: 'string',
                        knownValues: [
                            'OutdatedCursor'
                        ]
                    },
                    message: {
                        type: 'string'
                    }
                }
            },
            repoOp: {
                type: 'object',
                description: 'A repo operation, ie a mutation of a single record.',
                required: [
                    'action',
                    'path',
                    'cid'
                ],
                nullable: [
                    'cid'
                ],
                properties: {
                    action: {
                        type: 'string',
                        knownValues: [
                            'create',
                            'update',
                            'delete'
                        ]
                    },
                    path: {
                        type: 'string'
                    },
                    cid: {
                        type: 'cid-link',
                        description: 'For creates and updates, the new record CID. For deletions, null.'
                    },
                    prev: {
                        type: 'cid-link',
                        description: 'For updates and deletes, the previous record CID (required for inductive firehose). For creations, field should not be defined.'
                    }
                }
            }
        }
    },
    ComAtprotoTempAddReservedHandle: {
        lexicon: 1,
        id: 'com.atproto.temp.addReservedHandle',
        defs: {
            main: {
                type: 'procedure',
                description: 'Add a handle to the set of reserved handles.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'handle'
                        ],
                        properties: {
                            handle: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {}
                    }
                }
            }
        }
    },
    ComAtprotoTempCheckHandleAvailability: {
        lexicon: 1,
        id: 'com.atproto.temp.checkHandleAvailability',
        defs: {
            main: {
                type: 'query',
                description: 'Checks whether the provided handle is available. If the handle is not available, available suggestions will be returned. Optional inputs will be used to generate suggestions.',
                parameters: {
                    type: 'params',
                    required: [
                        'handle'
                    ],
                    properties: {
                        handle: {
                            type: 'string',
                            format: 'handle',
                            description: 'Tentative handle. Will be checked for availability or used to build handle suggestions.'
                        },
                        email: {
                            type: 'string',
                            description: 'User-provided email. Might be used to build handle suggestions.'
                        },
                        birthDate: {
                            type: 'string',
                            format: 'datetime',
                            description: 'User-provided birth date. Might be used to build handle suggestions.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'handle',
                            'result'
                        ],
                        properties: {
                            handle: {
                                type: 'string',
                                format: 'handle',
                                description: 'Echo of the input handle.'
                            },
                            result: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.temp.checkHandleAvailability#resultAvailable',
                                    'lex:com.atproto.temp.checkHandleAvailability#resultUnavailable'
                                ]
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidEmail',
                        description: 'An invalid email was provided.'
                    }
                ]
            },
            resultAvailable: {
                type: 'object',
                description: 'Indicates the provided handle is available.',
                properties: {}
            },
            resultUnavailable: {
                type: 'object',
                description: 'Indicates the provided handle is unavailable and gives suggestions of available handles.',
                required: [
                    'suggestions'
                ],
                properties: {
                    suggestions: {
                        type: 'array',
                        description: 'List of suggested handles based on the provided inputs.',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.temp.checkHandleAvailability#suggestion'
                        }
                    }
                }
            },
            suggestion: {
                type: 'object',
                required: [
                    'handle',
                    'method'
                ],
                properties: {
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    method: {
                        type: 'string',
                        description: 'Method used to build this suggestion. Should be considered opaque to clients. Can be used for metrics.'
                    }
                }
            }
        }
    },
    ComAtprotoTempCheckSignupQueue: {
        lexicon: 1,
        id: 'com.atproto.temp.checkSignupQueue',
        defs: {
            main: {
                type: 'query',
                description: 'Check accounts location in signup queue.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'activated'
                        ],
                        properties: {
                            activated: {
                                type: 'boolean'
                            },
                            placeInQueue: {
                                type: 'integer'
                            },
                            estimatedTimeMs: {
                                type: 'integer'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoTempDereferenceScope: {
        lexicon: 1,
        id: 'com.atproto.temp.dereferenceScope',
        defs: {
            main: {
                type: 'query',
                description: 'Allows finding the oauth permission scope from a reference',
                parameters: {
                    type: 'params',
                    required: [
                        'scope'
                    ],
                    properties: {
                        scope: {
                            type: 'string',
                            description: "The scope reference (starts with 'ref:')"
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'scope'
                        ],
                        properties: {
                            scope: {
                                type: 'string',
                                description: 'The full oauth permission scope'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'InvalidScopeReference',
                        description: 'An invalid scope reference was provided.'
                    }
                ]
            }
        }
    },
    ComAtprotoTempFetchLabels: {
        lexicon: 1,
        id: 'com.atproto.temp.fetchLabels',
        defs: {
            main: {
                type: 'query',
                description: 'DEPRECATED: use queryLabels or subscribeLabels instead -- Fetch all labels from a labeler created after a certain date.',
                parameters: {
                    type: 'params',
                    properties: {
                        since: {
                            type: 'integer'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 250,
                            default: 50
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'labels'
                        ],
                        properties: {
                            labels: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.label.defs#label'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoTempRequestPhoneVerification: {
        lexicon: 1,
        id: 'com.atproto.temp.requestPhoneVerification',
        defs: {
            main: {
                type: 'procedure',
                description: 'Request a verification code to be sent to the supplied phone number',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'phoneNumber'
                        ],
                        properties: {
                            phoneNumber: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ComAtprotoTempRevokeAccountCredentials: {
        lexicon: 1,
        id: 'com.atproto.temp.revokeAccountCredentials',
        defs: {
            main: {
                type: 'procedure',
                description: 'Revoke sessions, password, and app passwords associated with account. May be resolved by a password reset.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'account'
                        ],
                        properties: {
                            account: {
                                type: 'string',
                                format: 'at-identifier'
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneCommunicationCreateTemplate: {
        lexicon: 1,
        id: 'tools.ozone.communication.createTemplate',
        defs: {
            main: {
                type: 'procedure',
                description: 'Administrative action to create a new, re-usable communication (email for now) template.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subject',
                            'contentMarkdown',
                            'name'
                        ],
                        properties: {
                            name: {
                                type: 'string',
                                description: 'Name of the template.'
                            },
                            contentMarkdown: {
                                type: 'string',
                                description: 'Content of the template, markdown supported, can contain variable placeholders.'
                            },
                            subject: {
                                type: 'string',
                                description: 'Subject of the message, used in emails.'
                            },
                            lang: {
                                type: 'string',
                                format: 'language',
                                description: 'Message language.'
                            },
                            createdBy: {
                                type: 'string',
                                format: 'did',
                                description: 'DID of the user who is creating the template.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.communication.defs#templateView'
                    }
                },
                errors: [
                    {
                        name: 'DuplicateTemplateName'
                    }
                ]
            }
        }
    },
    ToolsOzoneCommunicationDefs: {
        lexicon: 1,
        id: 'tools.ozone.communication.defs',
        defs: {
            templateView: {
                type: 'object',
                required: [
                    'id',
                    'name',
                    'contentMarkdown',
                    'disabled',
                    'lastUpdatedBy',
                    'createdAt',
                    'updatedAt'
                ],
                properties: {
                    id: {
                        type: 'string'
                    },
                    name: {
                        type: 'string',
                        description: 'Name of the template.'
                    },
                    subject: {
                        type: 'string',
                        description: 'Content of the template, can contain markdown and variable placeholders.'
                    },
                    contentMarkdown: {
                        type: 'string',
                        description: 'Subject of the message, used in emails.'
                    },
                    disabled: {
                        type: 'boolean'
                    },
                    lang: {
                        type: 'string',
                        format: 'language',
                        description: 'Message language.'
                    },
                    lastUpdatedBy: {
                        type: 'string',
                        format: 'did',
                        description: 'DID of the user who last updated the template.'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            }
        }
    },
    ToolsOzoneCommunicationDeleteTemplate: {
        lexicon: 1,
        id: 'tools.ozone.communication.deleteTemplate',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete a communication template.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'id'
                        ],
                        properties: {
                            id: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneCommunicationListTemplates: {
        lexicon: 1,
        id: 'tools.ozone.communication.listTemplates',
        defs: {
            main: {
                type: 'query',
                description: 'Get list of all communication templates.',
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'communicationTemplates'
                        ],
                        properties: {
                            communicationTemplates: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.communication.defs#templateView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneCommunicationUpdateTemplate: {
        lexicon: 1,
        id: 'tools.ozone.communication.updateTemplate',
        defs: {
            main: {
                type: 'procedure',
                description: 'Administrative action to update an existing communication template. Allows passing partial fields to patch specific fields only.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'id'
                        ],
                        properties: {
                            id: {
                                type: 'string',
                                description: 'ID of the template to be updated.'
                            },
                            name: {
                                type: 'string',
                                description: 'Name of the template.'
                            },
                            lang: {
                                type: 'string',
                                format: 'language',
                                description: 'Message language.'
                            },
                            contentMarkdown: {
                                type: 'string',
                                description: 'Content of the template, markdown supported, can contain variable placeholders.'
                            },
                            subject: {
                                type: 'string',
                                description: 'Subject of the message, used in emails.'
                            },
                            updatedBy: {
                                type: 'string',
                                format: 'did',
                                description: 'DID of the user who is updating the template.'
                            },
                            disabled: {
                                type: 'boolean'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.communication.defs#templateView'
                    }
                },
                errors: [
                    {
                        name: 'DuplicateTemplateName'
                    }
                ]
            }
        }
    },
    ToolsOzoneHostingGetAccountHistory: {
        lexicon: 1,
        id: 'tools.ozone.hosting.getAccountHistory',
        defs: {
            main: {
                type: 'query',
                description: 'Get account history, e.g. log of updated email addresses or other identity information.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        },
                        events: {
                            type: 'array',
                            items: {
                                type: 'string',
                                knownValues: [
                                    'accountCreated',
                                    'emailUpdated',
                                    'emailConfirmed',
                                    'passwordUpdated',
                                    'handleUpdated'
                                ]
                            }
                        },
                        cursor: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'events'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            events: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.hosting.getAccountHistory#event'
                                }
                            }
                        }
                    }
                }
            },
            event: {
                type: 'object',
                required: [
                    'details',
                    'createdBy',
                    'createdAt'
                ],
                properties: {
                    details: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.hosting.getAccountHistory#accountCreated',
                            'lex:tools.ozone.hosting.getAccountHistory#emailUpdated',
                            'lex:tools.ozone.hosting.getAccountHistory#emailConfirmed',
                            'lex:tools.ozone.hosting.getAccountHistory#passwordUpdated',
                            'lex:tools.ozone.hosting.getAccountHistory#handleUpdated'
                        ]
                    },
                    createdBy: {
                        type: 'string'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            accountCreated: {
                type: 'object',
                required: [],
                properties: {
                    email: {
                        type: 'string'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    }
                }
            },
            emailUpdated: {
                type: 'object',
                required: [
                    'email'
                ],
                properties: {
                    email: {
                        type: 'string'
                    }
                }
            },
            emailConfirmed: {
                type: 'object',
                required: [
                    'email'
                ],
                properties: {
                    email: {
                        type: 'string'
                    }
                }
            },
            passwordUpdated: {
                type: 'object',
                required: [],
                properties: {}
            },
            handleUpdated: {
                type: 'object',
                required: [
                    'handle'
                ],
                properties: {
                    handle: {
                        type: 'string',
                        format: 'handle'
                    }
                }
            }
        }
    },
    ToolsOzoneModerationCancelScheduledActions: {
        lexicon: 1,
        id: 'tools.ozone.moderation.cancelScheduledActions',
        defs: {
            main: {
                type: 'procedure',
                description: 'Cancel all pending scheduled moderation actions for specified subjects',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subjects'
                        ],
                        properties: {
                            subjects: {
                                type: 'array',
                                maxLength: 100,
                                items: {
                                    type: 'string',
                                    format: 'did'
                                },
                                description: 'Array of DID subjects to cancel scheduled actions for'
                            },
                            comment: {
                                type: 'string',
                                description: 'Optional comment describing the reason for cancellation'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.cancelScheduledActions#cancellationResults'
                    }
                }
            },
            cancellationResults: {
                type: 'object',
                required: [
                    'succeeded',
                    'failed'
                ],
                properties: {
                    succeeded: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'did'
                        },
                        description: 'DIDs for which all pending scheduled actions were successfully cancelled'
                    },
                    failed: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:tools.ozone.moderation.cancelScheduledActions#failedCancellation'
                        },
                        description: 'DIDs for which cancellation failed with error details'
                    }
                }
            },
            failedCancellation: {
                type: 'object',
                required: [
                    'did',
                    'error'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    error: {
                        type: 'string'
                    },
                    errorCode: {
                        type: 'string'
                    }
                }
            }
        }
    },
    ToolsOzoneModerationDefs: {
        lexicon: 1,
        id: 'tools.ozone.moderation.defs',
        defs: {
            modEventView: {
                type: 'object',
                required: [
                    'id',
                    'event',
                    'subject',
                    'subjectBlobCids',
                    'createdBy',
                    'createdAt'
                ],
                properties: {
                    id: {
                        type: 'integer'
                    },
                    event: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#modEventTakedown',
                            'lex:tools.ozone.moderation.defs#modEventReverseTakedown',
                            'lex:tools.ozone.moderation.defs#modEventComment',
                            'lex:tools.ozone.moderation.defs#modEventReport',
                            'lex:tools.ozone.moderation.defs#modEventLabel',
                            'lex:tools.ozone.moderation.defs#modEventAcknowledge',
                            'lex:tools.ozone.moderation.defs#modEventEscalate',
                            'lex:tools.ozone.moderation.defs#modEventMute',
                            'lex:tools.ozone.moderation.defs#modEventUnmute',
                            'lex:tools.ozone.moderation.defs#modEventMuteReporter',
                            'lex:tools.ozone.moderation.defs#modEventUnmuteReporter',
                            'lex:tools.ozone.moderation.defs#modEventEmail',
                            'lex:tools.ozone.moderation.defs#modEventResolveAppeal',
                            'lex:tools.ozone.moderation.defs#modEventDivert',
                            'lex:tools.ozone.moderation.defs#modEventTag',
                            'lex:tools.ozone.moderation.defs#accountEvent',
                            'lex:tools.ozone.moderation.defs#identityEvent',
                            'lex:tools.ozone.moderation.defs#recordEvent',
                            'lex:tools.ozone.moderation.defs#modEventPriorityScore',
                            'lex:tools.ozone.moderation.defs#ageAssuranceEvent',
                            'lex:tools.ozone.moderation.defs#ageAssuranceOverrideEvent',
                            'lex:tools.ozone.moderation.defs#revokeAccountCredentialsEvent',
                            'lex:tools.ozone.moderation.defs#scheduleTakedownEvent',
                            'lex:tools.ozone.moderation.defs#cancelScheduledTakedownEvent'
                        ]
                    },
                    subject: {
                        type: 'union',
                        refs: [
                            'lex:com.atproto.admin.defs#repoRef',
                            'lex:com.atproto.repo.strongRef',
                            'lex:chat.bsky.convo.defs#messageRef'
                        ]
                    },
                    subjectBlobCids: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    },
                    createdBy: {
                        type: 'string',
                        format: 'did'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    creatorHandle: {
                        type: 'string'
                    },
                    subjectHandle: {
                        type: 'string'
                    },
                    modTool: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#modTool'
                    }
                }
            },
            modEventViewDetail: {
                type: 'object',
                required: [
                    'id',
                    'event',
                    'subject',
                    'subjectBlobs',
                    'createdBy',
                    'createdAt'
                ],
                properties: {
                    id: {
                        type: 'integer'
                    },
                    event: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#modEventTakedown',
                            'lex:tools.ozone.moderation.defs#modEventReverseTakedown',
                            'lex:tools.ozone.moderation.defs#modEventComment',
                            'lex:tools.ozone.moderation.defs#modEventReport',
                            'lex:tools.ozone.moderation.defs#modEventLabel',
                            'lex:tools.ozone.moderation.defs#modEventAcknowledge',
                            'lex:tools.ozone.moderation.defs#modEventEscalate',
                            'lex:tools.ozone.moderation.defs#modEventMute',
                            'lex:tools.ozone.moderation.defs#modEventUnmute',
                            'lex:tools.ozone.moderation.defs#modEventMuteReporter',
                            'lex:tools.ozone.moderation.defs#modEventUnmuteReporter',
                            'lex:tools.ozone.moderation.defs#modEventEmail',
                            'lex:tools.ozone.moderation.defs#modEventResolveAppeal',
                            'lex:tools.ozone.moderation.defs#modEventDivert',
                            'lex:tools.ozone.moderation.defs#modEventTag',
                            'lex:tools.ozone.moderation.defs#accountEvent',
                            'lex:tools.ozone.moderation.defs#identityEvent',
                            'lex:tools.ozone.moderation.defs#recordEvent',
                            'lex:tools.ozone.moderation.defs#modEventPriorityScore',
                            'lex:tools.ozone.moderation.defs#ageAssuranceEvent',
                            'lex:tools.ozone.moderation.defs#ageAssuranceOverrideEvent',
                            'lex:tools.ozone.moderation.defs#revokeAccountCredentialsEvent',
                            'lex:tools.ozone.moderation.defs#scheduleTakedownEvent',
                            'lex:tools.ozone.moderation.defs#cancelScheduledTakedownEvent'
                        ]
                    },
                    subject: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#repoView',
                            'lex:tools.ozone.moderation.defs#repoViewNotFound',
                            'lex:tools.ozone.moderation.defs#recordView',
                            'lex:tools.ozone.moderation.defs#recordViewNotFound'
                        ]
                    },
                    subjectBlobs: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:tools.ozone.moderation.defs#blobView'
                        }
                    },
                    createdBy: {
                        type: 'string',
                        format: 'did'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    modTool: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#modTool'
                    }
                }
            },
            subjectStatusView: {
                type: 'object',
                required: [
                    'id',
                    'subject',
                    'createdAt',
                    'updatedAt',
                    'reviewState'
                ],
                properties: {
                    id: {
                        type: 'integer'
                    },
                    subject: {
                        type: 'union',
                        refs: [
                            'lex:com.atproto.admin.defs#repoRef',
                            'lex:com.atproto.repo.strongRef',
                            'lex:chat.bsky.convo.defs#messageRef'
                        ]
                    },
                    hosting: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#accountHosting',
                            'lex:tools.ozone.moderation.defs#recordHosting'
                        ]
                    },
                    subjectBlobCids: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'cid'
                        }
                    },
                    subjectRepoHandle: {
                        type: 'string'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp referencing when the last update was made to the moderation status of the subject'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp referencing the first moderation status impacting event was emitted on the subject'
                    },
                    reviewState: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#subjectReviewState'
                    },
                    comment: {
                        type: 'string',
                        description: 'Sticky comment on the subject.'
                    },
                    priorityScore: {
                        type: 'integer',
                        description: 'Numeric value representing the level of priority. Higher score means higher priority.',
                        minimum: 0,
                        maximum: 100
                    },
                    muteUntil: {
                        type: 'string',
                        format: 'datetime'
                    },
                    muteReportingUntil: {
                        type: 'string',
                        format: 'datetime'
                    },
                    lastReviewedBy: {
                        type: 'string',
                        format: 'did'
                    },
                    lastReviewedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    lastReportedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    lastAppealedAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp referencing when the author of the subject appealed a moderation action'
                    },
                    takendown: {
                        type: 'boolean'
                    },
                    appealed: {
                        type: 'boolean',
                        description: 'True indicates that the a previously taken moderator action was appealed against, by the author of the content. False indicates last appeal was resolved by moderators.'
                    },
                    suspendUntil: {
                        type: 'string',
                        format: 'datetime'
                    },
                    tags: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    },
                    accountStats: {
                        description: 'Statistics related to the account subject',
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#accountStats'
                    },
                    recordsStats: {
                        description: "Statistics related to the record subjects authored by the subject's account",
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#recordsStats'
                    },
                    ageAssuranceState: {
                        type: 'string',
                        description: 'Current age assurance state of the subject.',
                        knownValues: [
                            'pending',
                            'assured',
                            'unknown',
                            'reset',
                            'blocked'
                        ]
                    },
                    ageAssuranceUpdatedBy: {
                        type: 'string',
                        description: 'Whether or not the last successful update to age assurance was made by the user or admin.',
                        knownValues: [
                            'admin',
                            'user'
                        ]
                    }
                }
            },
            subjectView: {
                description: "Detailed view of a subject. For record subjects, the author's repo and profile will be returned.",
                type: 'object',
                required: [
                    'type',
                    'subject'
                ],
                properties: {
                    type: {
                        type: 'ref',
                        ref: 'lex:com.atproto.moderation.defs#subjectType'
                    },
                    subject: {
                        type: 'string'
                    },
                    status: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#subjectStatusView'
                    },
                    repo: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#repoViewDetail'
                    },
                    profile: {
                        type: 'union',
                        refs: []
                    },
                    record: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#recordViewDetail'
                    }
                }
            },
            accountStats: {
                description: 'Statistics about a particular account subject',
                type: 'object',
                properties: {
                    reportCount: {
                        description: 'Total number of reports on the account',
                        type: 'integer'
                    },
                    appealCount: {
                        description: 'Total number of appeals against a moderation action on the account',
                        type: 'integer'
                    },
                    suspendCount: {
                        description: 'Number of times the account was suspended',
                        type: 'integer'
                    },
                    escalateCount: {
                        description: 'Number of times the account was escalated',
                        type: 'integer'
                    },
                    takedownCount: {
                        description: 'Number of times the account was taken down',
                        type: 'integer'
                    }
                }
            },
            recordsStats: {
                description: 'Statistics about a set of record subject items',
                type: 'object',
                properties: {
                    totalReports: {
                        description: 'Cumulative sum of the number of reports on the items in the set',
                        type: 'integer'
                    },
                    reportedCount: {
                        description: 'Number of items that were reported at least once',
                        type: 'integer'
                    },
                    escalatedCount: {
                        description: 'Number of items that were escalated at least once',
                        type: 'integer'
                    },
                    appealedCount: {
                        description: 'Number of items that were appealed at least once',
                        type: 'integer'
                    },
                    subjectCount: {
                        description: 'Total number of item in the set',
                        type: 'integer'
                    },
                    pendingCount: {
                        description: 'Number of item currently in "reviewOpen" or "reviewEscalated" state',
                        type: 'integer'
                    },
                    processedCount: {
                        description: 'Number of item currently in "reviewNone" or "reviewClosed" state',
                        type: 'integer'
                    },
                    takendownCount: {
                        description: 'Number of item currently taken down',
                        type: 'integer'
                    }
                }
            },
            subjectReviewState: {
                type: 'string',
                knownValues: [
                    'lex:tools.ozone.moderation.defs#reviewOpen',
                    'lex:tools.ozone.moderation.defs#reviewEscalated',
                    'lex:tools.ozone.moderation.defs#reviewClosed',
                    'lex:tools.ozone.moderation.defs#reviewNone'
                ]
            },
            reviewOpen: {
                type: 'token',
                description: 'Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator'
            },
            reviewEscalated: {
                type: 'token',
                description: 'Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator'
            },
            reviewClosed: {
                type: 'token',
                description: 'Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator'
            },
            reviewNone: {
                type: 'token',
                description: 'Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it'
            },
            modEventTakedown: {
                type: 'object',
                description: 'Take down a subject permanently or temporarily',
                properties: {
                    comment: {
                        type: 'string'
                    },
                    durationInHours: {
                        type: 'integer',
                        description: 'Indicates how long the takedown should be in effect before automatically expiring.'
                    },
                    acknowledgeAccountSubjects: {
                        type: 'boolean',
                        description: 'If true, all other reports on content authored by this account will be resolved (acknowledged).'
                    },
                    policies: {
                        type: 'array',
                        maxLength: 5,
                        items: {
                            type: 'string'
                        },
                        description: 'Names/Keywords of the policies that drove the decision.'
                    }
                }
            },
            modEventReverseTakedown: {
                type: 'object',
                description: 'Revert take down action on a subject',
                properties: {
                    comment: {
                        type: 'string',
                        description: 'Describe reasoning behind the reversal.'
                    }
                }
            },
            modEventResolveAppeal: {
                type: 'object',
                description: 'Resolve appeal on a subject',
                properties: {
                    comment: {
                        type: 'string',
                        description: 'Describe resolution.'
                    }
                }
            },
            modEventComment: {
                type: 'object',
                description: 'Add a comment to a subject. An empty comment will clear any previously set sticky comment.',
                properties: {
                    comment: {
                        type: 'string'
                    },
                    sticky: {
                        type: 'boolean',
                        description: 'Make the comment persistent on the subject'
                    }
                }
            },
            modEventReport: {
                type: 'object',
                description: 'Report a subject',
                required: [
                    'reportType'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    isReporterMuted: {
                        type: 'boolean',
                        description: "Set to true if the reporter was muted from reporting at the time of the event. These reports won't impact the reviewState of the subject."
                    },
                    reportType: {
                        type: 'ref',
                        ref: 'lex:com.atproto.moderation.defs#reasonType'
                    }
                }
            },
            modEventLabel: {
                type: 'object',
                description: 'Apply/Negate labels on a subject',
                required: [
                    'createLabelVals',
                    'negateLabelVals'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    createLabelVals: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    },
                    negateLabelVals: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    },
                    durationInHours: {
                        type: 'integer',
                        description: 'Indicates how long the label will remain on the subject. Only applies on labels that are being added.'
                    }
                }
            },
            modEventPriorityScore: {
                type: 'object',
                description: 'Set priority score of the subject. Higher score means higher priority.',
                required: [
                    'score'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    score: {
                        type: 'integer',
                        minimum: 0,
                        maximum: 100
                    }
                }
            },
            ageAssuranceEvent: {
                type: 'object',
                description: 'Age assurance info coming directly from users. Only works on DID subjects.',
                required: [
                    'createdAt',
                    'status',
                    'attemptId'
                ],
                properties: {
                    createdAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'The date and time of this write operation.'
                    },
                    status: {
                        type: 'string',
                        description: 'The status of the age assurance process.',
                        knownValues: [
                            'unknown',
                            'pending',
                            'assured'
                        ]
                    },
                    attemptId: {
                        type: 'string',
                        description: 'The unique identifier for this instance of the age assurance flow, in UUID format.'
                    },
                    initIp: {
                        type: 'string',
                        description: 'The IP address used when initiating the AA flow.'
                    },
                    initUa: {
                        type: 'string',
                        description: 'The user agent used when initiating the AA flow.'
                    },
                    completeIp: {
                        type: 'string',
                        description: 'The IP address used when completing the AA flow.'
                    },
                    completeUa: {
                        type: 'string',
                        description: 'The user agent used when completing the AA flow.'
                    }
                }
            },
            ageAssuranceOverrideEvent: {
                type: 'object',
                description: 'Age assurance status override by moderators. Only works on DID subjects.',
                required: [
                    'comment',
                    'status'
                ],
                properties: {
                    status: {
                        type: 'string',
                        description: 'The status to be set for the user decided by a moderator, overriding whatever value the user had previously. Use reset to default to original state.',
                        knownValues: [
                            'assured',
                            'reset',
                            'blocked'
                        ]
                    },
                    comment: {
                        type: 'string',
                        description: 'Comment describing the reason for the override.'
                    }
                }
            },
            revokeAccountCredentialsEvent: {
                type: 'object',
                description: 'Account credentials revocation by moderators. Only works on DID subjects.',
                required: [
                    'comment'
                ],
                properties: {
                    comment: {
                        type: 'string',
                        description: 'Comment describing the reason for the revocation.'
                    }
                }
            },
            modEventAcknowledge: {
                type: 'object',
                properties: {
                    comment: {
                        type: 'string'
                    },
                    acknowledgeAccountSubjects: {
                        type: 'boolean',
                        description: 'If true, all other reports on content authored by this account will be resolved (acknowledged).'
                    }
                }
            },
            modEventEscalate: {
                type: 'object',
                properties: {
                    comment: {
                        type: 'string'
                    }
                }
            },
            modEventMute: {
                type: 'object',
                description: 'Mute incoming reports on a subject',
                required: [
                    'durationInHours'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    durationInHours: {
                        type: 'integer',
                        description: 'Indicates how long the subject should remain muted.'
                    }
                }
            },
            modEventUnmute: {
                type: 'object',
                description: 'Unmute action on a subject',
                properties: {
                    comment: {
                        type: 'string',
                        description: 'Describe reasoning behind the reversal.'
                    }
                }
            },
            modEventMuteReporter: {
                type: 'object',
                description: 'Mute incoming reports from an account',
                properties: {
                    comment: {
                        type: 'string'
                    },
                    durationInHours: {
                        type: 'integer',
                        description: 'Indicates how long the account should remain muted. Falsy value here means a permanent mute.'
                    }
                }
            },
            modEventUnmuteReporter: {
                type: 'object',
                description: 'Unmute incoming reports from an account',
                properties: {
                    comment: {
                        type: 'string',
                        description: 'Describe reasoning behind the reversal.'
                    }
                }
            },
            modEventEmail: {
                type: 'object',
                description: 'Keep a log of outgoing email to a user',
                required: [
                    'subjectLine'
                ],
                properties: {
                    subjectLine: {
                        type: 'string',
                        description: 'The subject line of the email sent to the user.'
                    },
                    content: {
                        type: 'string',
                        description: 'The content of the email sent to the user.'
                    },
                    comment: {
                        type: 'string',
                        description: 'Additional comment about the outgoing comm.'
                    }
                }
            },
            modEventDivert: {
                type: 'object',
                description: "Divert a record's blobs to a 3rd party service for further scanning/tagging",
                properties: {
                    comment: {
                        type: 'string'
                    }
                }
            },
            modEventTag: {
                type: 'object',
                description: 'Add/Remove a tag on a subject',
                required: [
                    'add',
                    'remove'
                ],
                properties: {
                    add: {
                        type: 'array',
                        items: {
                            type: 'string'
                        },
                        description: "Tags to be added to the subject. If already exists, won't be duplicated."
                    },
                    remove: {
                        type: 'array',
                        items: {
                            type: 'string'
                        },
                        description: "Tags to be removed to the subject. Ignores a tag If it doesn't exist, won't be duplicated."
                    },
                    comment: {
                        type: 'string',
                        description: 'Additional comment about added/removed tags.'
                    }
                }
            },
            accountEvent: {
                type: 'object',
                description: 'Logs account status related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking.',
                required: [
                    'timestamp',
                    'active'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    active: {
                        type: 'boolean',
                        description: 'Indicates that the account has a repository which can be fetched from the host that emitted this event.'
                    },
                    status: {
                        type: 'string',
                        knownValues: [
                            'unknown',
                            'deactivated',
                            'deleted',
                            'takendown',
                            'suspended',
                            'tombstoned'
                        ]
                    },
                    timestamp: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            identityEvent: {
                type: 'object',
                description: 'Logs identity related events on a repo subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking.',
                required: [
                    'timestamp'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    pdsHost: {
                        type: 'string',
                        format: 'uri'
                    },
                    tombstone: {
                        type: 'boolean'
                    },
                    timestamp: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            recordEvent: {
                type: 'object',
                description: 'Logs lifecycle event on a record subject. Normally captured by automod from the firehose and emitted to ozone for historical tracking.',
                required: [
                    'timestamp',
                    'op'
                ],
                properties: {
                    comment: {
                        type: 'string'
                    },
                    op: {
                        type: 'string',
                        knownValues: [
                            'create',
                            'update',
                            'delete'
                        ]
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    timestamp: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            scheduleTakedownEvent: {
                type: 'object',
                description: 'Logs a scheduled takedown action for an account.',
                properties: {
                    comment: {
                        type: 'string'
                    },
                    executeAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    executeAfter: {
                        type: 'string',
                        format: 'datetime'
                    },
                    executeUntil: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            cancelScheduledTakedownEvent: {
                type: 'object',
                description: 'Logs cancellation of a scheduled takedown action for an account.',
                properties: {
                    comment: {
                        type: 'string'
                    }
                }
            },
            repoView: {
                type: 'object',
                required: [
                    'did',
                    'handle',
                    'relatedRecords',
                    'indexedAt',
                    'moderation'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    email: {
                        type: 'string'
                    },
                    relatedRecords: {
                        type: 'array',
                        items: {
                            type: 'unknown'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    moderation: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#moderation'
                    },
                    invitedBy: {
                        type: 'ref',
                        ref: 'lex:com.atproto.server.defs#inviteCode'
                    },
                    invitesDisabled: {
                        type: 'boolean'
                    },
                    inviteNote: {
                        type: 'string'
                    },
                    deactivatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    threatSignatures: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.admin.defs#threatSignature'
                        }
                    }
                }
            },
            repoViewDetail: {
                type: 'object',
                required: [
                    'did',
                    'handle',
                    'relatedRecords',
                    'indexedAt',
                    'moderation'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        format: 'handle'
                    },
                    email: {
                        type: 'string'
                    },
                    relatedRecords: {
                        type: 'array',
                        items: {
                            type: 'unknown'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    moderation: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#moderationDetail'
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    invitedBy: {
                        type: 'ref',
                        ref: 'lex:com.atproto.server.defs#inviteCode'
                    },
                    invites: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.server.defs#inviteCode'
                        }
                    },
                    invitesDisabled: {
                        type: 'boolean'
                    },
                    inviteNote: {
                        type: 'string'
                    },
                    emailConfirmedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    deactivatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    threatSignatures: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.admin.defs#threatSignature'
                        }
                    }
                }
            },
            repoViewNotFound: {
                type: 'object',
                required: [
                    'did'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    }
                }
            },
            recordView: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'value',
                    'blobCids',
                    'indexedAt',
                    'moderation',
                    'repo'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    value: {
                        type: 'unknown'
                    },
                    blobCids: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'cid'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    moderation: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#moderation'
                    },
                    repo: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#repoView'
                    }
                }
            },
            recordViewDetail: {
                type: 'object',
                required: [
                    'uri',
                    'cid',
                    'value',
                    'blobs',
                    'indexedAt',
                    'moderation',
                    'repo'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    },
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    value: {
                        type: 'unknown'
                    },
                    blobs: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:tools.ozone.moderation.defs#blobView'
                        }
                    },
                    labels: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:com.atproto.label.defs#label'
                        }
                    },
                    indexedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    moderation: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#moderationDetail'
                    },
                    repo: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#repoView'
                    }
                }
            },
            recordViewNotFound: {
                type: 'object',
                required: [
                    'uri'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        format: 'at-uri'
                    }
                }
            },
            moderation: {
                type: 'object',
                properties: {
                    subjectStatus: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#subjectStatusView'
                    }
                }
            },
            moderationDetail: {
                type: 'object',
                properties: {
                    subjectStatus: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#subjectStatusView'
                    }
                }
            },
            blobView: {
                type: 'object',
                required: [
                    'cid',
                    'mimeType',
                    'size',
                    'createdAt'
                ],
                properties: {
                    cid: {
                        type: 'string',
                        format: 'cid'
                    },
                    mimeType: {
                        type: 'string'
                    },
                    size: {
                        type: 'integer'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    details: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#imageDetails',
                            'lex:tools.ozone.moderation.defs#videoDetails'
                        ]
                    },
                    moderation: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#moderation'
                    }
                }
            },
            imageDetails: {
                type: 'object',
                required: [
                    'width',
                    'height'
                ],
                properties: {
                    width: {
                        type: 'integer'
                    },
                    height: {
                        type: 'integer'
                    }
                }
            },
            videoDetails: {
                type: 'object',
                required: [
                    'width',
                    'height',
                    'length'
                ],
                properties: {
                    width: {
                        type: 'integer'
                    },
                    height: {
                        type: 'integer'
                    },
                    length: {
                        type: 'integer'
                    }
                }
            },
            accountHosting: {
                type: 'object',
                required: [
                    'status'
                ],
                properties: {
                    status: {
                        type: 'string',
                        knownValues: [
                            'takendown',
                            'suspended',
                            'deleted',
                            'deactivated',
                            'unknown'
                        ]
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    deletedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    deactivatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    reactivatedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            recordHosting: {
                type: 'object',
                required: [
                    'status'
                ],
                properties: {
                    status: {
                        type: 'string',
                        knownValues: [
                            'deleted',
                            'unknown'
                        ]
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    deletedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            },
            reporterStats: {
                type: 'object',
                required: [
                    'did',
                    'accountReportCount',
                    'recordReportCount',
                    'reportedAccountCount',
                    'reportedRecordCount',
                    'takendownAccountCount',
                    'takendownRecordCount',
                    'labeledAccountCount',
                    'labeledRecordCount'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    accountReportCount: {
                        type: 'integer',
                        description: 'The total number of reports made by the user on accounts.'
                    },
                    recordReportCount: {
                        type: 'integer',
                        description: 'The total number of reports made by the user on records.'
                    },
                    reportedAccountCount: {
                        type: 'integer',
                        description: 'The total number of accounts reported by the user.'
                    },
                    reportedRecordCount: {
                        type: 'integer',
                        description: 'The total number of records reported by the user.'
                    },
                    takendownAccountCount: {
                        type: 'integer',
                        description: "The total number of accounts taken down as a result of the user's reports."
                    },
                    takendownRecordCount: {
                        type: 'integer',
                        description: "The total number of records taken down as a result of the user's reports."
                    },
                    labeledAccountCount: {
                        type: 'integer',
                        description: "The total number of accounts labeled as a result of the user's reports."
                    },
                    labeledRecordCount: {
                        type: 'integer',
                        description: "The total number of records labeled as a result of the user's reports."
                    }
                }
            },
            modTool: {
                type: 'object',
                description: 'Moderation tool information for tracing the source of the action',
                required: [
                    'name'
                ],
                properties: {
                    name: {
                        type: 'string',
                        description: "Name/identifier of the source (e.g., 'automod', 'ozone/workspace')"
                    },
                    meta: {
                        type: 'unknown',
                        description: 'Additional arbitrary metadata about the source'
                    }
                }
            },
            timelineEventPlcCreate: {
                type: 'token',
                description: 'Moderation event timeline event for a PLC create operation'
            },
            timelineEventPlcOperation: {
                type: 'token',
                description: 'Moderation event timeline event for generic PLC operation'
            },
            timelineEventPlcTombstone: {
                type: 'token',
                description: 'Moderation event timeline event for a PLC tombstone operation'
            },
            scheduledActionView: {
                type: 'object',
                description: 'View of a scheduled moderation action',
                required: [
                    'id',
                    'action',
                    'did',
                    'createdBy',
                    'createdAt',
                    'status'
                ],
                properties: {
                    id: {
                        type: 'integer',
                        description: 'Auto-incrementing row ID'
                    },
                    action: {
                        type: 'string',
                        knownValues: [
                            'takedown'
                        ],
                        description: 'Type of action to be executed'
                    },
                    eventData: {
                        type: 'unknown',
                        description: 'Serialized event object that will be propagated to the event when performed'
                    },
                    did: {
                        type: 'string',
                        format: 'did',
                        description: 'Subject DID for the action'
                    },
                    executeAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Exact time to execute the action'
                    },
                    executeAfter: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Earliest time to execute the action (for randomized scheduling)'
                    },
                    executeUntil: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Latest time to execute the action (for randomized scheduling)'
                    },
                    randomizeExecution: {
                        type: 'boolean',
                        description: 'Whether execution time should be randomized within the specified range'
                    },
                    createdBy: {
                        type: 'string',
                        format: 'did',
                        description: 'DID of the user who created this scheduled action'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'When the scheduled action was created'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'When the scheduled action was last updated'
                    },
                    status: {
                        type: 'string',
                        knownValues: [
                            'pending',
                            'executed',
                            'cancelled',
                            'failed'
                        ],
                        description: 'Current status of the scheduled action'
                    },
                    lastExecutedAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'When the action was last attempted to be executed'
                    },
                    lastFailureReason: {
                        type: 'string',
                        description: 'Reason for the last execution failure'
                    },
                    executionEventId: {
                        type: 'integer',
                        description: 'ID of the moderation event created when action was successfully executed'
                    }
                }
            }
        }
    },
    ToolsOzoneModerationEmitEvent: {
        lexicon: 1,
        id: 'tools.ozone.moderation.emitEvent',
        defs: {
            main: {
                type: 'procedure',
                description: 'Take a moderation action on an actor.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'event',
                            'subject',
                            'createdBy'
                        ],
                        properties: {
                            event: {
                                type: 'union',
                                refs: [
                                    'lex:tools.ozone.moderation.defs#modEventTakedown',
                                    'lex:tools.ozone.moderation.defs#modEventAcknowledge',
                                    'lex:tools.ozone.moderation.defs#modEventEscalate',
                                    'lex:tools.ozone.moderation.defs#modEventComment',
                                    'lex:tools.ozone.moderation.defs#modEventLabel',
                                    'lex:tools.ozone.moderation.defs#modEventReport',
                                    'lex:tools.ozone.moderation.defs#modEventMute',
                                    'lex:tools.ozone.moderation.defs#modEventUnmute',
                                    'lex:tools.ozone.moderation.defs#modEventMuteReporter',
                                    'lex:tools.ozone.moderation.defs#modEventUnmuteReporter',
                                    'lex:tools.ozone.moderation.defs#modEventReverseTakedown',
                                    'lex:tools.ozone.moderation.defs#modEventResolveAppeal',
                                    'lex:tools.ozone.moderation.defs#modEventEmail',
                                    'lex:tools.ozone.moderation.defs#modEventDivert',
                                    'lex:tools.ozone.moderation.defs#modEventTag',
                                    'lex:tools.ozone.moderation.defs#accountEvent',
                                    'lex:tools.ozone.moderation.defs#identityEvent',
                                    'lex:tools.ozone.moderation.defs#recordEvent',
                                    'lex:tools.ozone.moderation.defs#modEventPriorityScore',
                                    'lex:tools.ozone.moderation.defs#ageAssuranceEvent',
                                    'lex:tools.ozone.moderation.defs#ageAssuranceOverrideEvent',
                                    'lex:tools.ozone.moderation.defs#revokeAccountCredentialsEvent',
                                    'lex:tools.ozone.moderation.defs#scheduleTakedownEvent',
                                    'lex:tools.ozone.moderation.defs#cancelScheduledTakedownEvent'
                                ]
                            },
                            subject: {
                                type: 'union',
                                refs: [
                                    'lex:com.atproto.admin.defs#repoRef',
                                    'lex:com.atproto.repo.strongRef'
                                ]
                            },
                            subjectBlobCids: {
                                type: 'array',
                                items: {
                                    type: 'string',
                                    format: 'cid'
                                }
                            },
                            createdBy: {
                                type: 'string',
                                format: 'did'
                            },
                            modTool: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.moderation.defs#modTool'
                            },
                            externalId: {
                                type: 'string',
                                description: 'An optional external ID for the event, used to deduplicate events from external systems. Fails when an event of same type with the same external ID exists for the same subject.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#modEventView'
                    }
                },
                errors: [
                    {
                        name: 'SubjectHasAction'
                    },
                    {
                        name: 'DuplicateExternalId',
                        description: 'An event with the same external ID already exists for the subject.'
                    }
                ]
            }
        }
    },
    ToolsOzoneModerationGetAccountTimeline: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getAccountTimeline',
        defs: {
            main: {
                type: 'query',
                description: 'Get timeline of all available events of an account. This includes moderation events, account history and did history.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'timeline'
                        ],
                        properties: {
                            timeline: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.moderation.getAccountTimeline#timelineItem'
                                }
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'RepoNotFound'
                    }
                ]
            },
            timelineItem: {
                type: 'object',
                required: [
                    'day',
                    'summary'
                ],
                properties: {
                    day: {
                        type: 'string'
                    },
                    summary: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:tools.ozone.moderation.getAccountTimeline#timelineItemSummary'
                        }
                    }
                }
            },
            timelineItemSummary: {
                type: 'object',
                required: [
                    'eventSubjectType',
                    'eventType',
                    'count'
                ],
                properties: {
                    eventSubjectType: {
                        type: 'string',
                        knownValues: [
                            'account',
                            'record',
                            'chat'
                        ]
                    },
                    eventType: {
                        type: 'string',
                        knownValues: [
                            'tools.ozone.moderation.defs#modEventTakedown',
                            'tools.ozone.moderation.defs#modEventReverseTakedown',
                            'tools.ozone.moderation.defs#modEventComment',
                            'tools.ozone.moderation.defs#modEventReport',
                            'tools.ozone.moderation.defs#modEventLabel',
                            'tools.ozone.moderation.defs#modEventAcknowledge',
                            'tools.ozone.moderation.defs#modEventEscalate',
                            'tools.ozone.moderation.defs#modEventMute',
                            'tools.ozone.moderation.defs#modEventUnmute',
                            'tools.ozone.moderation.defs#modEventMuteReporter',
                            'tools.ozone.moderation.defs#modEventUnmuteReporter',
                            'tools.ozone.moderation.defs#modEventEmail',
                            'tools.ozone.moderation.defs#modEventResolveAppeal',
                            'tools.ozone.moderation.defs#modEventDivert',
                            'tools.ozone.moderation.defs#modEventTag',
                            'tools.ozone.moderation.defs#accountEvent',
                            'tools.ozone.moderation.defs#identityEvent',
                            'tools.ozone.moderation.defs#recordEvent',
                            'tools.ozone.moderation.defs#modEventPriorityScore',
                            'tools.ozone.moderation.defs#revokeAccountCredentialsEvent',
                            'tools.ozone.moderation.defs#ageAssuranceEvent',
                            'tools.ozone.moderation.defs#ageAssuranceOverrideEvent',
                            'tools.ozone.moderation.defs#timelineEventPlcCreate',
                            'tools.ozone.moderation.defs#timelineEventPlcOperation',
                            'tools.ozone.moderation.defs#timelineEventPlcTombstone',
                            'tools.ozone.hosting.getAccountHistory#accountCreated',
                            'tools.ozone.hosting.getAccountHistory#emailConfirmed',
                            'tools.ozone.hosting.getAccountHistory#passwordUpdated',
                            'tools.ozone.hosting.getAccountHistory#handleUpdated',
                            'tools.ozone.moderation.defs#scheduleTakedownEvent',
                            'tools.ozone.moderation.defs#cancelScheduledTakedownEvent'
                        ]
                    },
                    count: {
                        type: 'integer'
                    }
                }
            }
        }
    },
    ToolsOzoneModerationGetEvent: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getEvent',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about a moderation event.',
                parameters: {
                    type: 'params',
                    required: [
                        'id'
                    ],
                    properties: {
                        id: {
                            type: 'integer'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#modEventViewDetail'
                    }
                }
            }
        }
    },
    ToolsOzoneModerationGetRecord: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getRecord',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about a record.',
                parameters: {
                    type: 'params',
                    required: [
                        'uri'
                    ],
                    properties: {
                        uri: {
                            type: 'string',
                            format: 'at-uri'
                        },
                        cid: {
                            type: 'string',
                            format: 'cid'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#recordViewDetail'
                    }
                },
                errors: [
                    {
                        name: 'RecordNotFound'
                    }
                ]
            }
        }
    },
    ToolsOzoneModerationGetRecords: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getRecords',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about some records.',
                parameters: {
                    type: 'params',
                    required: [
                        'uris'
                    ],
                    properties: {
                        uris: {
                            type: 'array',
                            maxLength: 100,
                            items: {
                                type: 'string',
                                format: 'at-uri'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'records'
                        ],
                        properties: {
                            records: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:tools.ozone.moderation.defs#recordViewDetail',
                                        'lex:tools.ozone.moderation.defs#recordViewNotFound'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneModerationGetRepo: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getRepo',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about a repository.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.defs#repoViewDetail'
                    }
                },
                errors: [
                    {
                        name: 'RepoNotFound'
                    }
                ]
            }
        }
    },
    ToolsOzoneModerationGetReporterStats: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getReporterStats',
        defs: {
            main: {
                type: 'query',
                description: 'Get reporter stats for a list of users.',
                parameters: {
                    type: 'params',
                    required: [
                        'dids'
                    ],
                    properties: {
                        dids: {
                            type: 'array',
                            maxLength: 100,
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'stats'
                        ],
                        properties: {
                            stats: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.moderation.defs#reporterStats'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneModerationGetRepos: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getRepos',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about some repositories.',
                parameters: {
                    type: 'params',
                    required: [
                        'dids'
                    ],
                    properties: {
                        dids: {
                            type: 'array',
                            maxLength: 100,
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repos'
                        ],
                        properties: {
                            repos: {
                                type: 'array',
                                items: {
                                    type: 'union',
                                    refs: [
                                        'lex:tools.ozone.moderation.defs#repoViewDetail',
                                        'lex:tools.ozone.moderation.defs#repoViewNotFound'
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneModerationGetSubjects: {
        lexicon: 1,
        id: 'tools.ozone.moderation.getSubjects',
        defs: {
            main: {
                type: 'query',
                description: 'Get details about subjects.',
                parameters: {
                    type: 'params',
                    required: [
                        'subjects'
                    ],
                    properties: {
                        subjects: {
                            type: 'array',
                            maxLength: 100,
                            minLength: 1,
                            items: {
                                type: 'string'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subjects'
                        ],
                        properties: {
                            subjects: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.moderation.defs#subjectView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneModerationListScheduledActions: {
        lexicon: 1,
        id: 'tools.ozone.moderation.listScheduledActions',
        defs: {
            main: {
                type: 'procedure',
                description: 'List scheduled moderation actions with optional filtering',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'statuses'
                        ],
                        properties: {
                            startsAfter: {
                                type: 'string',
                                format: 'datetime',
                                description: 'Filter actions scheduled to execute after this time'
                            },
                            endsBefore: {
                                type: 'string',
                                format: 'datetime',
                                description: 'Filter actions scheduled to execute before this time'
                            },
                            subjects: {
                                type: 'array',
                                maxLength: 100,
                                items: {
                                    type: 'string',
                                    format: 'did'
                                },
                                description: 'Filter actions for specific DID subjects'
                            },
                            statuses: {
                                type: 'array',
                                minLength: 1,
                                items: {
                                    type: 'string',
                                    knownValues: [
                                        'pending',
                                        'executed',
                                        'cancelled',
                                        'failed'
                                    ]
                                },
                                description: 'Filter actions by status'
                            },
                            limit: {
                                type: 'integer',
                                minimum: 1,
                                maximum: 100,
                                default: 50,
                                description: 'Maximum number of results to return'
                            },
                            cursor: {
                                type: 'string',
                                description: 'Cursor for pagination'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'actions'
                        ],
                        properties: {
                            actions: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.moderation.defs#scheduledActionView'
                                }
                            },
                            cursor: {
                                type: 'string',
                                description: 'Cursor for next page of results'
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneModerationQueryEvents: {
        lexicon: 1,
        id: 'tools.ozone.moderation.queryEvents',
        defs: {
            main: {
                type: 'query',
                description: 'List moderation events related to a subject.',
                parameters: {
                    type: 'params',
                    properties: {
                        types: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'The types of events (fully qualified string in the format of tools.ozone.moderation.defs#modEvent<name>) to filter by. If not specified, all events are returned.'
                        },
                        createdBy: {
                            type: 'string',
                            format: 'did'
                        },
                        sortDirection: {
                            type: 'string',
                            default: 'desc',
                            enum: [
                                'asc',
                                'desc'
                            ],
                            description: 'Sort direction for the events. Defaults to descending order of created at timestamp.'
                        },
                        createdAfter: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Retrieve events created after a given timestamp'
                        },
                        createdBefore: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Retrieve events created before a given timestamp'
                        },
                        subject: {
                            type: 'string',
                            format: 'uri'
                        },
                        collections: {
                            type: 'array',
                            maxLength: 20,
                            description: "If specified, only events where the subject belongs to the given collections will be returned. When subjectType is set to 'account', this will be ignored.",
                            items: {
                                type: 'string',
                                format: 'nsid'
                            }
                        },
                        subjectType: {
                            type: 'string',
                            description: "If specified, only events where the subject is of the given type (account or record) will be returned. When this is set to 'account' the 'collections' parameter will be ignored. When includeAllUserRecords or subject is set, this will be ignored.",
                            knownValues: [
                                'account',
                                'record'
                            ]
                        },
                        includeAllUserRecords: {
                            type: 'boolean',
                            default: false,
                            description: "If true, events on all record types (posts, lists, profile etc.) or records from given 'collections' param, owned by the did are returned."
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        hasComment: {
                            type: 'boolean',
                            description: 'If true, only events with comments are returned'
                        },
                        comment: {
                            type: 'string',
                            description: 'If specified, only events with comments containing the keyword are returned. Apply || separator to use multiple keywords and match using OR condition.'
                        },
                        addedLabels: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'If specified, only events where all of these labels were added are returned'
                        },
                        removedLabels: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'If specified, only events where all of these labels were removed are returned'
                        },
                        addedTags: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'If specified, only events where all of these tags were added are returned'
                        },
                        removedTags: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'If specified, only events where all of these tags were removed are returned'
                        },
                        reportTypes: {
                            type: 'array',
                            items: {
                                type: 'string'
                            }
                        },
                        policies: {
                            type: 'array',
                            items: {
                                type: 'string',
                                description: 'If specified, only events where the action policies match any of the given policies are returned'
                            }
                        },
                        modTool: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'If specified, only events where the modTool name matches any of the given values are returned'
                        },
                        batchId: {
                            type: 'string',
                            description: 'If specified, only events where the batchId matches the given value are returned'
                        },
                        ageAssuranceState: {
                            type: 'string',
                            description: 'If specified, only events where the age assurance state matches the given value are returned',
                            knownValues: [
                                'pending',
                                'assured',
                                'unknown',
                                'reset',
                                'blocked'
                            ]
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'events'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            events: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.moderation.defs#modEventView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneModerationQueryStatuses: {
        lexicon: 1,
        id: 'tools.ozone.moderation.queryStatuses',
        defs: {
            main: {
                type: 'query',
                description: 'View moderation statuses of subjects (record or repo).',
                parameters: {
                    type: 'params',
                    properties: {
                        queueCount: {
                            type: 'integer',
                            description: 'Number of queues being used by moderators. Subjects will be split among all queues.'
                        },
                        queueIndex: {
                            type: 'integer',
                            description: 'Index of the queue to fetch subjects from. Works only when queueCount value is specified.'
                        },
                        queueSeed: {
                            type: 'string',
                            description: 'A seeder to shuffle/balance the queue items.'
                        },
                        includeAllUserRecords: {
                            type: 'boolean',
                            description: "All subjects, or subjects from given 'collections' param, belonging to the account specified in the 'subject' param will be returned."
                        },
                        subject: {
                            type: 'string',
                            format: 'uri',
                            description: 'The subject to get the status for.'
                        },
                        comment: {
                            type: 'string',
                            description: 'Search subjects by keyword from comments'
                        },
                        reportedAfter: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects reported after a given timestamp'
                        },
                        reportedBefore: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects reported before a given timestamp'
                        },
                        reviewedAfter: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects reviewed after a given timestamp'
                        },
                        hostingDeletedAfter: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects where the associated record/account was deleted after a given timestamp'
                        },
                        hostingDeletedBefore: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects where the associated record/account was deleted before a given timestamp'
                        },
                        hostingUpdatedAfter: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects where the associated record/account was updated after a given timestamp'
                        },
                        hostingUpdatedBefore: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects where the associated record/account was updated before a given timestamp'
                        },
                        hostingStatuses: {
                            type: 'array',
                            items: {
                                type: 'string'
                            },
                            description: 'Search subjects by the status of the associated record/account'
                        },
                        reviewedBefore: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Search subjects reviewed before a given timestamp'
                        },
                        includeMuted: {
                            type: 'boolean',
                            description: "By default, we don't include muted subjects in the results. Set this to true to include them."
                        },
                        onlyMuted: {
                            type: 'boolean',
                            description: 'When set to true, only muted subjects and reporters will be returned.'
                        },
                        reviewState: {
                            type: 'string',
                            description: 'Specify when fetching subjects in a certain state'
                        },
                        ignoreSubjects: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'uri'
                            }
                        },
                        lastReviewedBy: {
                            type: 'string',
                            format: 'did',
                            description: 'Get all subject statuses that were reviewed by a specific moderator'
                        },
                        sortField: {
                            type: 'string',
                            default: 'lastReportedAt',
                            enum: [
                                'lastReviewedAt',
                                'lastReportedAt',
                                'reportedRecordsCount',
                                'takendownRecordsCount',
                                'priorityScore'
                            ]
                        },
                        sortDirection: {
                            type: 'string',
                            default: 'desc',
                            enum: [
                                'asc',
                                'desc'
                            ]
                        },
                        takendown: {
                            type: 'boolean',
                            description: 'Get subjects that were taken down'
                        },
                        appealed: {
                            type: 'boolean',
                            description: 'Get subjects in unresolved appealed status'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        tags: {
                            type: 'array',
                            maxLength: 25,
                            items: {
                                type: 'string',
                                description: 'Items in this array are applied with OR filters. To apply AND filter, put all tags in the same string and separate using && characters'
                            }
                        },
                        excludeTags: {
                            type: 'array',
                            items: {
                                type: 'string'
                            }
                        },
                        cursor: {
                            type: 'string'
                        },
                        collections: {
                            type: 'array',
                            maxLength: 20,
                            description: "If specified, subjects belonging to the given collections will be returned. When subjectType is set to 'account', this will be ignored.",
                            items: {
                                type: 'string',
                                format: 'nsid'
                            }
                        },
                        subjectType: {
                            type: 'string',
                            description: "If specified, subjects of the given type (account or record) will be returned. When this is set to 'account' the 'collections' parameter will be ignored. When includeAllUserRecords or subject is set, this will be ignored.",
                            knownValues: [
                                'account',
                                'record'
                            ]
                        },
                        minAccountSuspendCount: {
                            type: 'integer',
                            description: 'If specified, only subjects that belong to an account that has at least this many suspensions will be returned.'
                        },
                        minReportedRecordsCount: {
                            type: 'integer',
                            description: 'If specified, only subjects that belong to an account that has at least this many reported records will be returned.'
                        },
                        minTakendownRecordsCount: {
                            type: 'integer',
                            description: 'If specified, only subjects that belong to an account that has at least this many taken down records will be returned.'
                        },
                        minPriorityScore: {
                            minimum: 0,
                            maximum: 100,
                            type: 'integer',
                            description: 'If specified, only subjects that have priority score value above the given value will be returned.'
                        },
                        ageAssuranceState: {
                            type: 'string',
                            description: 'If specified, only subjects with the given age assurance state will be returned.',
                            knownValues: [
                                'pending',
                                'assured',
                                'unknown',
                                'reset',
                                'blocked'
                            ]
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'subjectStatuses'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            subjectStatuses: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.moderation.defs#subjectStatusView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneModerationScheduleAction: {
        lexicon: 1,
        id: 'tools.ozone.moderation.scheduleAction',
        defs: {
            main: {
                type: 'procedure',
                description: 'Schedule a moderation action to be executed at a future time',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'action',
                            'subjects',
                            'createdBy',
                            'scheduling'
                        ],
                        properties: {
                            action: {
                                type: 'union',
                                refs: [
                                    'lex:tools.ozone.moderation.scheduleAction#takedown'
                                ]
                            },
                            subjects: {
                                type: 'array',
                                maxLength: 100,
                                items: {
                                    type: 'string',
                                    format: 'did'
                                },
                                description: 'Array of DID subjects to schedule the action for'
                            },
                            createdBy: {
                                type: 'string',
                                format: 'did'
                            },
                            scheduling: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.moderation.scheduleAction#schedulingConfig'
                            },
                            modTool: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.moderation.defs#modTool',
                                description: 'This will be propagated to the moderation event when it is applied'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.moderation.scheduleAction#scheduledActionResults'
                    }
                }
            },
            takedown: {
                type: 'object',
                description: 'Schedule a takedown action',
                properties: {
                    comment: {
                        type: 'string'
                    },
                    durationInHours: {
                        type: 'integer',
                        description: 'Indicates how long the takedown should be in effect before automatically expiring.'
                    },
                    acknowledgeAccountSubjects: {
                        type: 'boolean',
                        description: 'If true, all other reports on content authored by this account will be resolved (acknowledged).'
                    },
                    policies: {
                        type: 'array',
                        maxLength: 5,
                        items: {
                            type: 'string'
                        },
                        description: 'Names/Keywords of the policies that drove the decision.'
                    }
                }
            },
            schedulingConfig: {
                type: 'object',
                description: 'Configuration for when the action should be executed',
                properties: {
                    executeAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Exact time to execute the action'
                    },
                    executeAfter: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Earliest time to execute the action (for randomized scheduling)'
                    },
                    executeUntil: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Latest time to execute the action (for randomized scheduling)'
                    }
                }
            },
            scheduledActionResults: {
                type: 'object',
                required: [
                    'succeeded',
                    'failed'
                ],
                properties: {
                    succeeded: {
                        type: 'array',
                        items: {
                            type: 'string',
                            format: 'did'
                        }
                    },
                    failed: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:tools.ozone.moderation.scheduleAction#failedScheduling'
                        }
                    }
                }
            },
            failedScheduling: {
                type: 'object',
                required: [
                    'subject',
                    'error'
                ],
                properties: {
                    subject: {
                        type: 'string',
                        format: 'did'
                    },
                    error: {
                        type: 'string'
                    },
                    errorCode: {
                        type: 'string'
                    }
                }
            }
        }
    },
    ToolsOzoneModerationSearchRepos: {
        lexicon: 1,
        id: 'tools.ozone.moderation.searchRepos',
        defs: {
            main: {
                type: 'query',
                description: 'Find repositories based on a search term.',
                parameters: {
                    type: 'params',
                    properties: {
                        term: {
                            type: 'string',
                            description: "DEPRECATED: use 'q' instead"
                        },
                        q: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'repos'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            repos: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.moderation.defs#repoView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneReportDefs: {
        lexicon: 1,
        id: 'tools.ozone.report.defs',
        defs: {
            reasonType: {
                type: 'string',
                knownValues: [
                    'tools.ozone.report.defs#reasonAppeal',
                    'tools.ozone.report.defs#reasonOther',
                    'tools.ozone.report.defs#reasonViolenceAnimal',
                    'tools.ozone.report.defs#reasonViolenceThreats',
                    'tools.ozone.report.defs#reasonViolenceGraphicContent',
                    'tools.ozone.report.defs#reasonViolenceGlorification',
                    'tools.ozone.report.defs#reasonViolenceExtremistContent',
                    'tools.ozone.report.defs#reasonViolenceTrafficking',
                    'tools.ozone.report.defs#reasonViolenceOther',
                    'tools.ozone.report.defs#reasonSexualAbuseContent',
                    'tools.ozone.report.defs#reasonSexualNCII',
                    'tools.ozone.report.defs#reasonSexualDeepfake',
                    'tools.ozone.report.defs#reasonSexualAnimal',
                    'tools.ozone.report.defs#reasonSexualUnlabeled',
                    'tools.ozone.report.defs#reasonSexualOther',
                    'tools.ozone.report.defs#reasonChildSafetyCSAM',
                    'tools.ozone.report.defs#reasonChildSafetyGroom',
                    'tools.ozone.report.defs#reasonChildSafetyPrivacy',
                    'tools.ozone.report.defs#reasonChildSafetyHarassment',
                    'tools.ozone.report.defs#reasonChildSafetyOther',
                    'tools.ozone.report.defs#reasonHarassmentTroll',
                    'tools.ozone.report.defs#reasonHarassmentTargeted',
                    'tools.ozone.report.defs#reasonHarassmentHateSpeech',
                    'tools.ozone.report.defs#reasonHarassmentDoxxing',
                    'tools.ozone.report.defs#reasonHarassmentOther',
                    'tools.ozone.report.defs#reasonMisleadingBot',
                    'tools.ozone.report.defs#reasonMisleadingImpersonation',
                    'tools.ozone.report.defs#reasonMisleadingSpam',
                    'tools.ozone.report.defs#reasonMisleadingScam',
                    'tools.ozone.report.defs#reasonMisleadingElections',
                    'tools.ozone.report.defs#reasonMisleadingOther',
                    'tools.ozone.report.defs#reasonRuleSiteSecurity',
                    'tools.ozone.report.defs#reasonRuleProhibitedSales',
                    'tools.ozone.report.defs#reasonRuleBanEvasion',
                    'tools.ozone.report.defs#reasonRuleOther',
                    'tools.ozone.report.defs#reasonSelfHarmContent',
                    'tools.ozone.report.defs#reasonSelfHarmED',
                    'tools.ozone.report.defs#reasonSelfHarmStunts',
                    'tools.ozone.report.defs#reasonSelfHarmSubstances',
                    'tools.ozone.report.defs#reasonSelfHarmOther'
                ]
            },
            reasonAppeal: {
                type: 'token',
                description: 'Appeal a previously taken moderation action'
            },
            reasonOther: {
                type: 'token',
                description: 'An issue not included in these options'
            },
            reasonViolenceAnimal: {
                type: 'token',
                description: 'Animal welfare violations'
            },
            reasonViolenceThreats: {
                type: 'token',
                description: 'Threats or incitement'
            },
            reasonViolenceGraphicContent: {
                type: 'token',
                description: 'Graphic violent content'
            },
            reasonViolenceGlorification: {
                type: 'token',
                description: 'Glorification of violence'
            },
            reasonViolenceExtremistContent: {
                type: 'token',
                description: "Extremist content. These reports will be sent only be sent to the application's Moderation Authority."
            },
            reasonViolenceTrafficking: {
                type: 'token',
                description: 'Human trafficking'
            },
            reasonViolenceOther: {
                type: 'token',
                description: 'Other violent content'
            },
            reasonSexualAbuseContent: {
                type: 'token',
                description: 'Adult sexual abuse content'
            },
            reasonSexualNCII: {
                type: 'token',
                description: 'Non-consensual intimate imagery'
            },
            reasonSexualDeepfake: {
                type: 'token',
                description: 'Deepfake adult content'
            },
            reasonSexualAnimal: {
                type: 'token',
                description: 'Animal sexual abuse'
            },
            reasonSexualUnlabeled: {
                type: 'token',
                description: 'Unlabelled adult content'
            },
            reasonSexualOther: {
                type: 'token',
                description: 'Other sexual violence content'
            },
            reasonChildSafetyCSAM: {
                type: 'token',
                description: "Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority."
            },
            reasonChildSafetyGroom: {
                type: 'token',
                description: "Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority."
            },
            reasonChildSafetyPrivacy: {
                type: 'token',
                description: 'Privacy violation involving a minor'
            },
            reasonChildSafetyHarassment: {
                type: 'token',
                description: 'Harassment or bullying of minors'
            },
            reasonChildSafetyOther: {
                type: 'token',
                description: "Other child safety. These reports will be sent only be sent to the application's Moderation Authority."
            },
            reasonHarassmentTroll: {
                type: 'token',
                description: 'Trolling'
            },
            reasonHarassmentTargeted: {
                type: 'token',
                description: 'Targeted harassment'
            },
            reasonHarassmentHateSpeech: {
                type: 'token',
                description: 'Hate speech'
            },
            reasonHarassmentDoxxing: {
                type: 'token',
                description: 'Doxxing'
            },
            reasonHarassmentOther: {
                type: 'token',
                description: 'Other harassing or hateful content'
            },
            reasonMisleadingBot: {
                type: 'token',
                description: 'Fake account or bot'
            },
            reasonMisleadingImpersonation: {
                type: 'token',
                description: 'Impersonation'
            },
            reasonMisleadingSpam: {
                type: 'token',
                description: 'Spam'
            },
            reasonMisleadingScam: {
                type: 'token',
                description: 'Scam'
            },
            reasonMisleadingElections: {
                type: 'token',
                description: 'False information about elections'
            },
            reasonMisleadingOther: {
                type: 'token',
                description: 'Other misleading content'
            },
            reasonRuleSiteSecurity: {
                type: 'token',
                description: 'Hacking or system attacks'
            },
            reasonRuleProhibitedSales: {
                type: 'token',
                description: 'Promoting or selling prohibited items or services'
            },
            reasonRuleBanEvasion: {
                type: 'token',
                description: 'Banned user returning'
            },
            reasonRuleOther: {
                type: 'token',
                description: 'Other'
            },
            reasonSelfHarmContent: {
                type: 'token',
                description: 'Content promoting or depicting self-harm'
            },
            reasonSelfHarmED: {
                type: 'token',
                description: 'Eating disorders'
            },
            reasonSelfHarmStunts: {
                type: 'token',
                description: 'Dangerous challenges or activities'
            },
            reasonSelfHarmSubstances: {
                type: 'token',
                description: 'Dangerous substances or drug abuse'
            },
            reasonSelfHarmOther: {
                type: 'token',
                description: 'Other dangerous content'
            }
        }
    },
    ToolsOzoneSafelinkAddRule: {
        lexicon: 1,
        id: 'tools.ozone.safelink.addRule',
        defs: {
            main: {
                type: 'procedure',
                description: 'Add a new URL safety rule',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'url',
                            'pattern',
                            'action',
                            'reason'
                        ],
                        properties: {
                            url: {
                                type: 'string',
                                description: 'The URL or domain to apply the rule to'
                            },
                            pattern: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.safelink.defs#patternType'
                            },
                            action: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.safelink.defs#actionType'
                            },
                            reason: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.safelink.defs#reasonType'
                            },
                            comment: {
                                type: 'string',
                                description: 'Optional comment about the decision'
                            },
                            createdBy: {
                                type: 'string',
                                format: 'did',
                                description: 'Author DID. Only respected when using admin auth'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.safelink.defs#event'
                    }
                },
                errors: [
                    {
                        name: 'InvalidUrl',
                        description: 'The provided URL is invalid'
                    },
                    {
                        name: 'RuleAlreadyExists',
                        description: 'A rule for this URL/domain already exists'
                    }
                ]
            }
        }
    },
    ToolsOzoneSafelinkDefs: {
        lexicon: 1,
        id: 'tools.ozone.safelink.defs',
        defs: {
            event: {
                type: 'object',
                description: 'An event for URL safety decisions',
                required: [
                    'id',
                    'eventType',
                    'url',
                    'pattern',
                    'action',
                    'reason',
                    'createdBy',
                    'createdAt'
                ],
                properties: {
                    id: {
                        type: 'integer',
                        description: 'Auto-incrementing row ID'
                    },
                    eventType: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.safelink.defs#eventType'
                    },
                    url: {
                        type: 'string',
                        description: 'The URL that this rule applies to'
                    },
                    pattern: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.safelink.defs#patternType'
                    },
                    action: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.safelink.defs#actionType'
                    },
                    reason: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.safelink.defs#reasonType'
                    },
                    createdBy: {
                        type: 'string',
                        format: 'did',
                        description: 'DID of the user who created this rule'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    comment: {
                        type: 'string',
                        description: 'Optional comment about the decision'
                    }
                }
            },
            eventType: {
                type: 'string',
                knownValues: [
                    'addRule',
                    'updateRule',
                    'removeRule'
                ]
            },
            patternType: {
                type: 'string',
                knownValues: [
                    'domain',
                    'url'
                ]
            },
            actionType: {
                type: 'string',
                knownValues: [
                    'block',
                    'warn',
                    'whitelist'
                ]
            },
            reasonType: {
                type: 'string',
                knownValues: [
                    'csam',
                    'spam',
                    'phishing',
                    'none'
                ]
            },
            urlRule: {
                type: 'object',
                description: 'Input for creating a URL safety rule',
                required: [
                    'url',
                    'pattern',
                    'action',
                    'reason',
                    'createdBy',
                    'createdAt',
                    'updatedAt'
                ],
                properties: {
                    url: {
                        type: 'string',
                        description: 'The URL or domain to apply the rule to'
                    },
                    pattern: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.safelink.defs#patternType'
                    },
                    action: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.safelink.defs#actionType'
                    },
                    reason: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.safelink.defs#reasonType'
                    },
                    comment: {
                        type: 'string',
                        description: 'Optional comment about the decision'
                    },
                    createdBy: {
                        type: 'string',
                        format: 'did',
                        description: 'DID of the user added the rule.'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp when the rule was created'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp when the rule was last updated'
                    }
                }
            }
        }
    },
    ToolsOzoneSafelinkQueryEvents: {
        lexicon: 1,
        id: 'tools.ozone.safelink.queryEvents',
        defs: {
            main: {
                type: 'procedure',
                description: 'Query URL safety audit events',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            cursor: {
                                type: 'string',
                                description: 'Cursor for pagination'
                            },
                            limit: {
                                type: 'integer',
                                minimum: 1,
                                maximum: 100,
                                default: 50,
                                description: 'Maximum number of results to return'
                            },
                            urls: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                },
                                description: 'Filter by specific URLs or domains'
                            },
                            patternType: {
                                type: 'string',
                                description: 'Filter by pattern type'
                            },
                            sortDirection: {
                                type: 'string',
                                knownValues: [
                                    'asc',
                                    'desc'
                                ],
                                default: 'desc',
                                description: 'Sort direction'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'events'
                        ],
                        properties: {
                            cursor: {
                                type: 'string',
                                description: 'Next cursor for pagination. Only present if there are more results.'
                            },
                            events: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.safelink.defs#event'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSafelinkQueryRules: {
        lexicon: 1,
        id: 'tools.ozone.safelink.queryRules',
        defs: {
            main: {
                type: 'procedure',
                description: 'Query URL safety rules',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            cursor: {
                                type: 'string',
                                description: 'Cursor for pagination'
                            },
                            limit: {
                                type: 'integer',
                                minimum: 1,
                                maximum: 100,
                                default: 50,
                                description: 'Maximum number of results to return'
                            },
                            urls: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                },
                                description: 'Filter by specific URLs or domains'
                            },
                            patternType: {
                                type: 'string',
                                description: 'Filter by pattern type'
                            },
                            actions: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                },
                                description: 'Filter by action types'
                            },
                            reason: {
                                type: 'string',
                                description: 'Filter by reason type'
                            },
                            createdBy: {
                                type: 'string',
                                format: 'did',
                                description: 'Filter by rule creator'
                            },
                            sortDirection: {
                                type: 'string',
                                knownValues: [
                                    'asc',
                                    'desc'
                                ],
                                default: 'desc',
                                description: 'Sort direction'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'rules'
                        ],
                        properties: {
                            cursor: {
                                type: 'string',
                                description: 'Next cursor for pagination. Only present if there are more results.'
                            },
                            rules: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.safelink.defs#urlRule'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSafelinkRemoveRule: {
        lexicon: 1,
        id: 'tools.ozone.safelink.removeRule',
        defs: {
            main: {
                type: 'procedure',
                description: 'Remove an existing URL safety rule',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'url',
                            'pattern'
                        ],
                        properties: {
                            url: {
                                type: 'string',
                                description: 'The URL or domain to remove the rule for'
                            },
                            pattern: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.safelink.defs#patternType'
                            },
                            comment: {
                                type: 'string',
                                description: 'Optional comment about why the rule is being removed'
                            },
                            createdBy: {
                                type: 'string',
                                format: 'did',
                                description: 'Optional DID of the user. Only respected when using admin auth.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.safelink.defs#event'
                    }
                },
                errors: [
                    {
                        name: 'RuleNotFound',
                        description: 'No active rule found for this URL/domain'
                    }
                ]
            }
        }
    },
    ToolsOzoneSafelinkUpdateRule: {
        lexicon: 1,
        id: 'tools.ozone.safelink.updateRule',
        defs: {
            main: {
                type: 'procedure',
                description: 'Update an existing URL safety rule',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'url',
                            'pattern',
                            'action',
                            'reason'
                        ],
                        properties: {
                            url: {
                                type: 'string',
                                description: 'The URL or domain to update the rule for'
                            },
                            pattern: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.safelink.defs#patternType'
                            },
                            action: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.safelink.defs#actionType'
                            },
                            reason: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.safelink.defs#reasonType'
                            },
                            comment: {
                                type: 'string',
                                description: 'Optional comment about the update'
                            },
                            createdBy: {
                                type: 'string',
                                format: 'did',
                                description: 'Optional DID to credit as the creator. Only respected for admin_token authentication.'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.safelink.defs#event'
                    }
                },
                errors: [
                    {
                        name: 'RuleNotFound',
                        description: 'No active rule found for this URL/domain'
                    }
                ]
            }
        }
    },
    ToolsOzoneServerGetConfig: {
        lexicon: 1,
        id: 'tools.ozone.server.getConfig',
        defs: {
            main: {
                type: 'query',
                description: "Get details about ozone's server configuration.",
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {
                            appview: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.server.getConfig#serviceConfig'
                            },
                            pds: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.server.getConfig#serviceConfig'
                            },
                            blobDivert: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.server.getConfig#serviceConfig'
                            },
                            chat: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.server.getConfig#serviceConfig'
                            },
                            viewer: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.server.getConfig#viewerConfig'
                            },
                            verifierDid: {
                                type: 'string',
                                format: 'did',
                                description: 'The did of the verifier used for verification.'
                            }
                        }
                    }
                }
            },
            serviceConfig: {
                type: 'object',
                properties: {
                    url: {
                        type: 'string',
                        format: 'uri'
                    }
                }
            },
            viewerConfig: {
                type: 'object',
                properties: {
                    role: {
                        type: 'string',
                        knownValues: [
                            'tools.ozone.team.defs#roleAdmin',
                            'tools.ozone.team.defs#roleModerator',
                            'tools.ozone.team.defs#roleTriage',
                            'tools.ozone.team.defs#roleVerifier'
                        ]
                    }
                }
            }
        }
    },
    ToolsOzoneSetAddValues: {
        lexicon: 1,
        id: 'tools.ozone.set.addValues',
        defs: {
            main: {
                type: 'procedure',
                description: 'Add values to a specific set. Attempting to add values to a set that does not exist will result in an error.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'name',
                            'values'
                        ],
                        properties: {
                            name: {
                                type: 'string',
                                description: 'Name of the set to add values to'
                            },
                            values: {
                                type: 'array',
                                minLength: 1,
                                maxLength: 1000,
                                items: {
                                    type: 'string'
                                },
                                description: 'Array of string values to add to the set'
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSetDefs: {
        lexicon: 1,
        id: 'tools.ozone.set.defs',
        defs: {
            set: {
                type: 'object',
                required: [
                    'name'
                ],
                properties: {
                    name: {
                        type: 'string',
                        minLength: 3,
                        maxLength: 128
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 1024,
                        maxLength: 10240
                    }
                }
            },
            setView: {
                type: 'object',
                required: [
                    'name',
                    'setSize',
                    'createdAt',
                    'updatedAt'
                ],
                properties: {
                    name: {
                        type: 'string',
                        minLength: 3,
                        maxLength: 128
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 1024,
                        maxLength: 10240
                    },
                    setSize: {
                        type: 'integer'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    }
                }
            }
        }
    },
    ToolsOzoneSetDeleteSet: {
        lexicon: 1,
        id: 'tools.ozone.set.deleteSet',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete an entire set. Attempting to delete a set that does not exist will result in an error.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'name'
                        ],
                        properties: {
                            name: {
                                type: 'string',
                                description: 'Name of the set to delete'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {}
                    }
                },
                errors: [
                    {
                        name: 'SetNotFound',
                        description: 'set with the given name does not exist'
                    }
                ]
            }
        }
    },
    ToolsOzoneSetDeleteValues: {
        lexicon: 1,
        id: 'tools.ozone.set.deleteValues',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete values from a specific set. Attempting to delete values that are not in the set will not result in an error',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'name',
                            'values'
                        ],
                        properties: {
                            name: {
                                type: 'string',
                                description: 'Name of the set to delete values from'
                            },
                            values: {
                                type: 'array',
                                minLength: 1,
                                items: {
                                    type: 'string'
                                },
                                description: 'Array of string values to delete from the set'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'SetNotFound',
                        description: 'set with the given name does not exist'
                    }
                ]
            }
        }
    },
    ToolsOzoneSetGetValues: {
        lexicon: 1,
        id: 'tools.ozone.set.getValues',
        defs: {
            main: {
                type: 'query',
                description: 'Get a specific set and its values',
                parameters: {
                    type: 'params',
                    required: [
                        'name'
                    ],
                    properties: {
                        name: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 1000,
                            default: 100
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'set',
                            'values'
                        ],
                        properties: {
                            set: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.set.defs#setView'
                            },
                            values: {
                                type: 'array',
                                items: {
                                    type: 'string'
                                }
                            },
                            cursor: {
                                type: 'string'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'SetNotFound',
                        description: 'set with the given name does not exist'
                    }
                ]
            }
        }
    },
    ToolsOzoneSetQuerySets: {
        lexicon: 1,
        id: 'tools.ozone.set.querySets',
        defs: {
            main: {
                type: 'query',
                description: 'Query available sets',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        namePrefix: {
                            type: 'string'
                        },
                        sortBy: {
                            type: 'string',
                            enum: [
                                'name',
                                'createdAt',
                                'updatedAt'
                            ],
                            default: 'name'
                        },
                        sortDirection: {
                            type: 'string',
                            default: 'asc',
                            enum: [
                                'asc',
                                'desc'
                            ],
                            description: 'Defaults to ascending order of name field.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'sets'
                        ],
                        properties: {
                            sets: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.set.defs#setView'
                                }
                            },
                            cursor: {
                                type: 'string'
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSetUpsertSet: {
        lexicon: 1,
        id: 'tools.ozone.set.upsertSet',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create or update set metadata',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.set.defs#set'
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.set.defs#setView'
                    }
                }
            }
        }
    },
    ToolsOzoneSettingDefs: {
        lexicon: 1,
        id: 'tools.ozone.setting.defs',
        defs: {
            option: {
                type: 'object',
                required: [
                    'key',
                    'value',
                    'did',
                    'scope',
                    'createdBy',
                    'lastUpdatedBy'
                ],
                properties: {
                    key: {
                        type: 'string',
                        format: 'nsid'
                    },
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    value: {
                        type: 'unknown'
                    },
                    description: {
                        type: 'string',
                        maxGraphemes: 1024,
                        maxLength: 10240
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    managerRole: {
                        type: 'string',
                        knownValues: [
                            'tools.ozone.team.defs#roleModerator',
                            'tools.ozone.team.defs#roleTriage',
                            'tools.ozone.team.defs#roleAdmin',
                            'tools.ozone.team.defs#roleVerifier'
                        ]
                    },
                    scope: {
                        type: 'string',
                        knownValues: [
                            'instance',
                            'personal'
                        ]
                    },
                    createdBy: {
                        type: 'string',
                        format: 'did'
                    },
                    lastUpdatedBy: {
                        type: 'string',
                        format: 'did'
                    }
                }
            }
        }
    },
    ToolsOzoneSettingListOptions: {
        lexicon: 1,
        id: 'tools.ozone.setting.listOptions',
        defs: {
            main: {
                type: 'query',
                description: 'List settings with optional filtering',
                parameters: {
                    type: 'params',
                    properties: {
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        },
                        scope: {
                            type: 'string',
                            knownValues: [
                                'instance',
                                'personal'
                            ],
                            default: 'instance'
                        },
                        prefix: {
                            type: 'string',
                            description: 'Filter keys by prefix'
                        },
                        keys: {
                            type: 'array',
                            maxLength: 100,
                            items: {
                                type: 'string',
                                format: 'nsid'
                            },
                            description: 'Filter for only the specified keys. Ignored if prefix is provided'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'options'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            options: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.setting.defs#option'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSettingRemoveOptions: {
        lexicon: 1,
        id: 'tools.ozone.setting.removeOptions',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete settings by key',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'keys',
                            'scope'
                        ],
                        properties: {
                            keys: {
                                type: 'array',
                                minLength: 1,
                                maxLength: 200,
                                items: {
                                    type: 'string',
                                    format: 'nsid'
                                }
                            },
                            scope: {
                                type: 'string',
                                knownValues: [
                                    'instance',
                                    'personal'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        properties: {}
                    }
                }
            }
        }
    },
    ToolsOzoneSettingUpsertOption: {
        lexicon: 1,
        id: 'tools.ozone.setting.upsertOption',
        defs: {
            main: {
                type: 'procedure',
                description: 'Create or update setting option',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'key',
                            'scope',
                            'value'
                        ],
                        properties: {
                            key: {
                                type: 'string',
                                format: 'nsid'
                            },
                            scope: {
                                type: 'string',
                                knownValues: [
                                    'instance',
                                    'personal'
                                ]
                            },
                            value: {
                                type: 'unknown'
                            },
                            description: {
                                type: 'string',
                                maxLength: 2000
                            },
                            managerRole: {
                                type: 'string',
                                knownValues: [
                                    'tools.ozone.team.defs#roleModerator',
                                    'tools.ozone.team.defs#roleTriage',
                                    'tools.ozone.team.defs#roleVerifier',
                                    'tools.ozone.team.defs#roleAdmin'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'option'
                        ],
                        properties: {
                            option: {
                                type: 'ref',
                                ref: 'lex:tools.ozone.setting.defs#option'
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSignatureDefs: {
        lexicon: 1,
        id: 'tools.ozone.signature.defs',
        defs: {
            sigDetail: {
                type: 'object',
                required: [
                    'property',
                    'value'
                ],
                properties: {
                    property: {
                        type: 'string'
                    },
                    value: {
                        type: 'string'
                    }
                }
            }
        }
    },
    ToolsOzoneSignatureFindCorrelation: {
        lexicon: 1,
        id: 'tools.ozone.signature.findCorrelation',
        defs: {
            main: {
                type: 'query',
                description: 'Find all correlated threat signatures between 2 or more accounts.',
                parameters: {
                    type: 'params',
                    required: [
                        'dids'
                    ],
                    properties: {
                        dids: {
                            type: 'array',
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'details'
                        ],
                        properties: {
                            details: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.signature.defs#sigDetail'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSignatureFindRelatedAccounts: {
        lexicon: 1,
        id: 'tools.ozone.signature.findRelatedAccounts',
        defs: {
            main: {
                type: 'query',
                description: 'Get accounts that share some matching threat signatures with the root account.',
                parameters: {
                    type: 'params',
                    required: [
                        'did'
                    ],
                    properties: {
                        did: {
                            type: 'string',
                            format: 'did'
                        },
                        cursor: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'accounts'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            accounts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.signature.findRelatedAccounts#relatedAccount'
                                }
                            }
                        }
                    }
                }
            },
            relatedAccount: {
                type: 'object',
                required: [
                    'account'
                ],
                properties: {
                    account: {
                        type: 'ref',
                        ref: 'lex:com.atproto.admin.defs#accountView'
                    },
                    similarities: {
                        type: 'array',
                        items: {
                            type: 'ref',
                            ref: 'lex:tools.ozone.signature.defs#sigDetail'
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneSignatureSearchAccounts: {
        lexicon: 1,
        id: 'tools.ozone.signature.searchAccounts',
        defs: {
            main: {
                type: 'query',
                description: 'Search for accounts that match one or more threat signature values.',
                parameters: {
                    type: 'params',
                    required: [
                        'values'
                    ],
                    properties: {
                        values: {
                            type: 'array',
                            items: {
                                type: 'string'
                            }
                        },
                        cursor: {
                            type: 'string'
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'accounts'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            accounts: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:com.atproto.admin.defs#accountView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneTeamAddMember: {
        lexicon: 1,
        id: 'tools.ozone.team.addMember',
        defs: {
            main: {
                type: 'procedure',
                description: 'Add a member to the ozone team. Requires admin role.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did',
                            'role'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            role: {
                                type: 'string',
                                knownValues: [
                                    'tools.ozone.team.defs#roleAdmin',
                                    'tools.ozone.team.defs#roleModerator',
                                    'tools.ozone.team.defs#roleVerifier',
                                    'tools.ozone.team.defs#roleTriage'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.team.defs#member'
                    }
                },
                errors: [
                    {
                        name: 'MemberAlreadyExists',
                        description: 'Member already exists in the team.'
                    }
                ]
            }
        }
    },
    ToolsOzoneTeamDefs: {
        lexicon: 1,
        id: 'tools.ozone.team.defs',
        defs: {
            member: {
                type: 'object',
                required: [
                    'did',
                    'role'
                ],
                properties: {
                    did: {
                        type: 'string',
                        format: 'did'
                    },
                    disabled: {
                        type: 'boolean'
                    },
                    profile: {
                        type: 'ref',
                        ref: 'lex:app.bsky.actor.defs#profileViewDetailed'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    updatedAt: {
                        type: 'string',
                        format: 'datetime'
                    },
                    lastUpdatedBy: {
                        type: 'string'
                    },
                    role: {
                        type: 'string',
                        knownValues: [
                            'lex:tools.ozone.team.defs#roleAdmin',
                            'lex:tools.ozone.team.defs#roleModerator',
                            'lex:tools.ozone.team.defs#roleTriage',
                            'lex:tools.ozone.team.defs#roleVerifier'
                        ]
                    }
                }
            },
            roleAdmin: {
                type: 'token',
                description: 'Admin role. Highest level of access, can perform all actions.'
            },
            roleModerator: {
                type: 'token',
                description: 'Moderator role. Can perform most actions.'
            },
            roleTriage: {
                type: 'token',
                description: 'Triage role. Mostly intended for monitoring and escalating issues.'
            },
            roleVerifier: {
                type: 'token',
                description: 'Verifier role. Only allowed to issue verifications.'
            }
        }
    },
    ToolsOzoneTeamDeleteMember: {
        lexicon: 1,
        id: 'tools.ozone.team.deleteMember',
        defs: {
            main: {
                type: 'procedure',
                description: 'Delete a member from ozone team. Requires admin role.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            }
                        }
                    }
                },
                errors: [
                    {
                        name: 'MemberNotFound',
                        description: 'The member being deleted does not exist'
                    },
                    {
                        name: 'CannotDeleteSelf',
                        description: 'You can not delete yourself from the team'
                    }
                ]
            }
        }
    },
    ToolsOzoneTeamListMembers: {
        lexicon: 1,
        id: 'tools.ozone.team.listMembers',
        defs: {
            main: {
                type: 'query',
                description: 'List all members with access to the ozone service.',
                parameters: {
                    type: 'params',
                    properties: {
                        q: {
                            type: 'string'
                        },
                        disabled: {
                            type: 'boolean'
                        },
                        roles: {
                            type: 'array',
                            items: {
                                type: 'string'
                            }
                        },
                        limit: {
                            type: 'integer',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        cursor: {
                            type: 'string'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'members'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            members: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.team.defs#member'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneTeamUpdateMember: {
        lexicon: 1,
        id: 'tools.ozone.team.updateMember',
        defs: {
            main: {
                type: 'procedure',
                description: 'Update a member in the ozone service. Requires admin role.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'did'
                        ],
                        properties: {
                            did: {
                                type: 'string',
                                format: 'did'
                            },
                            disabled: {
                                type: 'boolean'
                            },
                            role: {
                                type: 'string',
                                knownValues: [
                                    'tools.ozone.team.defs#roleAdmin',
                                    'tools.ozone.team.defs#roleModerator',
                                    'tools.ozone.team.defs#roleVerifier',
                                    'tools.ozone.team.defs#roleTriage'
                                ]
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'ref',
                        ref: 'lex:tools.ozone.team.defs#member'
                    }
                },
                errors: [
                    {
                        name: 'MemberNotFound',
                        description: 'The member being updated does not exist in the team'
                    }
                ]
            }
        }
    },
    ToolsOzoneVerificationDefs: {
        lexicon: 1,
        id: 'tools.ozone.verification.defs',
        defs: {
            verificationView: {
                type: 'object',
                description: 'Verification data for the associated subject.',
                required: [
                    'issuer',
                    'uri',
                    'subject',
                    'handle',
                    'displayName',
                    'createdAt'
                ],
                properties: {
                    issuer: {
                        type: 'string',
                        description: 'The user who issued this verification.',
                        format: 'did'
                    },
                    uri: {
                        type: 'string',
                        description: 'The AT-URI of the verification record.',
                        format: 'at-uri'
                    },
                    subject: {
                        type: 'string',
                        format: 'did',
                        description: 'The subject of the verification.'
                    },
                    handle: {
                        type: 'string',
                        description: 'Handle of the subject the verification applies to at the moment of verifying, which might not be the same at the time of viewing. The verification is only valid if the current handle matches the one at the time of verifying.',
                        format: 'handle'
                    },
                    displayName: {
                        type: 'string',
                        description: 'Display name of the subject the verification applies to at the moment of verifying, which might not be the same at the time of viewing. The verification is only valid if the current displayName matches the one at the time of verifying.'
                    },
                    createdAt: {
                        type: 'string',
                        description: 'Timestamp when the verification was created.',
                        format: 'datetime'
                    },
                    revokeReason: {
                        type: 'string',
                        description: 'Describes the reason for revocation, also indicating that the verification is no longer valid.'
                    },
                    revokedAt: {
                        type: 'string',
                        description: 'Timestamp when the verification was revoked.',
                        format: 'datetime'
                    },
                    revokedBy: {
                        type: 'string',
                        description: 'The user who revoked this verification.',
                        format: 'did'
                    },
                    subjectProfile: {
                        type: 'union',
                        refs: []
                    },
                    issuerProfile: {
                        type: 'union',
                        refs: []
                    },
                    subjectRepo: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#repoViewDetail',
                            'lex:tools.ozone.moderation.defs#repoViewNotFound'
                        ]
                    },
                    issuerRepo: {
                        type: 'union',
                        refs: [
                            'lex:tools.ozone.moderation.defs#repoViewDetail',
                            'lex:tools.ozone.moderation.defs#repoViewNotFound'
                        ]
                    }
                }
            }
        }
    },
    ToolsOzoneVerificationGrantVerifications: {
        lexicon: 1,
        id: 'tools.ozone.verification.grantVerifications',
        defs: {
            main: {
                type: 'procedure',
                description: 'Grant verifications to multiple subjects. Allows batch processing of up to 100 verifications at once.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'verifications'
                        ],
                        properties: {
                            verifications: {
                                type: 'array',
                                description: 'Array of verification requests to process',
                                maxLength: 100,
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.verification.grantVerifications#verificationInput'
                                }
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'verifications',
                            'failedVerifications'
                        ],
                        properties: {
                            verifications: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.verification.defs#verificationView'
                                }
                            },
                            failedVerifications: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.verification.grantVerifications#grantError'
                                }
                            }
                        }
                    }
                }
            },
            verificationInput: {
                type: 'object',
                required: [
                    'subject',
                    'handle',
                    'displayName'
                ],
                properties: {
                    subject: {
                        type: 'string',
                        description: 'The did of the subject being verified',
                        format: 'did'
                    },
                    handle: {
                        type: 'string',
                        description: 'Handle of the subject the verification applies to at the moment of verifying.',
                        format: 'handle'
                    },
                    displayName: {
                        type: 'string',
                        description: 'Display name of the subject the verification applies to at the moment of verifying.'
                    },
                    createdAt: {
                        type: 'string',
                        format: 'datetime',
                        description: 'Timestamp for verification record. Defaults to current time when not specified.'
                    }
                }
            },
            grantError: {
                type: 'object',
                description: 'Error object for failed verifications.',
                required: [
                    'error',
                    'subject'
                ],
                properties: {
                    error: {
                        type: 'string',
                        description: 'Error message describing the reason for failure.'
                    },
                    subject: {
                        type: 'string',
                        description: 'The did of the subject being verified',
                        format: 'did'
                    }
                }
            }
        }
    },
    ToolsOzoneVerificationListVerifications: {
        lexicon: 1,
        id: 'tools.ozone.verification.listVerifications',
        defs: {
            main: {
                type: 'query',
                description: 'List verifications',
                parameters: {
                    type: 'params',
                    properties: {
                        cursor: {
                            type: 'string',
                            description: 'Pagination cursor'
                        },
                        limit: {
                            type: 'integer',
                            description: 'Maximum number of results to return',
                            minimum: 1,
                            maximum: 100,
                            default: 50
                        },
                        createdAfter: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Filter to verifications created after this timestamp'
                        },
                        createdBefore: {
                            type: 'string',
                            format: 'datetime',
                            description: 'Filter to verifications created before this timestamp'
                        },
                        issuers: {
                            type: 'array',
                            maxLength: 100,
                            description: 'Filter to verifications from specific issuers',
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        },
                        subjects: {
                            type: 'array',
                            description: 'Filter to specific verified DIDs',
                            maxLength: 100,
                            items: {
                                type: 'string',
                                format: 'did'
                            }
                        },
                        sortDirection: {
                            type: 'string',
                            description: 'Sort direction for creation date',
                            enum: [
                                'asc',
                                'desc'
                            ],
                            default: 'desc'
                        },
                        isRevoked: {
                            type: 'boolean',
                            description: 'Filter to verifications that are revoked or not. By default, includes both.'
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'verifications'
                        ],
                        properties: {
                            cursor: {
                                type: 'string'
                            },
                            verifications: {
                                type: 'array',
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.verification.defs#verificationView'
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    ToolsOzoneVerificationRevokeVerifications: {
        lexicon: 1,
        id: 'tools.ozone.verification.revokeVerifications',
        defs: {
            main: {
                type: 'procedure',
                description: 'Revoke previously granted verifications in batches of up to 100.',
                input: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'uris'
                        ],
                        properties: {
                            uris: {
                                type: 'array',
                                description: 'Array of verification record uris to revoke',
                                maxLength: 100,
                                items: {
                                    type: 'string',
                                    description: 'The AT-URI of the verification record to revoke.',
                                    format: 'at-uri'
                                }
                            },
                            revokeReason: {
                                type: 'string',
                                description: 'Reason for revoking the verification. This is optional and can be omitted if not needed.',
                                maxLength: 1000
                            }
                        }
                    }
                },
                output: {
                    encoding: 'application/json',
                    schema: {
                        type: 'object',
                        required: [
                            'revokedVerifications',
                            'failedRevocations'
                        ],
                        properties: {
                            revokedVerifications: {
                                type: 'array',
                                description: 'List of verification uris successfully revoked',
                                items: {
                                    type: 'string',
                                    format: 'at-uri'
                                }
                            },
                            failedRevocations: {
                                type: 'array',
                                description: "List of verification uris that couldn't be revoked, including failure reasons",
                                items: {
                                    type: 'ref',
                                    ref: 'lex:tools.ozone.verification.revokeVerifications#revokeError'
                                }
                            }
                        }
                    }
                }
            },
            revokeError: {
                type: 'object',
                description: 'Error object for failed revocations',
                required: [
                    'uri',
                    'error'
                ],
                properties: {
                    uri: {
                        type: 'string',
                        description: 'The AT-URI of the verification record that failed to revoke.',
                        format: 'at-uri'
                    },
                    error: {
                        type: 'string',
                        description: 'Description of the error that occurred during revocation.'
                    }
                }
            }
        }
    }
};
exports.schemas = Object.values(exports.schemaDict);
exports.lexicons = new lexicon_1.Lexicons(exports.schemas);
function validate(v, id, hash, requiredType) {
    return (requiredType ? util_js_1.is$typed : util_js_1.maybe$typed)(v, id, hash) ? exports.lexicons.validate(`${id}#${hash}`, v) : {
        success: false,
        error: new lexicon_1.ValidationError(`Must be an object with "${hash === 'main' ? id : `${id}#${hash}`}" $type property`)
    };
}
exports.ids = {
    AppBskyActorDefs: 'app.bsky.actor.defs',
    AppBskyActorGetPreferences: 'app.bsky.actor.getPreferences',
    AppBskyActorGetProfile: 'app.bsky.actor.getProfile',
    AppBskyActorGetProfiles: 'app.bsky.actor.getProfiles',
    AppBskyActorGetSuggestions: 'app.bsky.actor.getSuggestions',
    AppBskyActorProfile: 'app.bsky.actor.profile',
    AppBskyActorPutPreferences: 'app.bsky.actor.putPreferences',
    AppBskyActorSearchActors: 'app.bsky.actor.searchActors',
    AppBskyActorSearchActorsTypeahead: 'app.bsky.actor.searchActorsTypeahead',
    AppBskyActorStatus: 'app.bsky.actor.status',
    AppBskyBookmarkCreateBookmark: 'app.bsky.bookmark.createBookmark',
    AppBskyBookmarkDefs: 'app.bsky.bookmark.defs',
    AppBskyBookmarkDeleteBookmark: 'app.bsky.bookmark.deleteBookmark',
    AppBskyBookmarkGetBookmarks: 'app.bsky.bookmark.getBookmarks',
    AppBskyEmbedDefs: 'app.bsky.embed.defs',
    AppBskyEmbedExternal: 'app.bsky.embed.external',
    AppBskyEmbedImages: 'app.bsky.embed.images',
    AppBskyEmbedRecord: 'app.bsky.embed.record',
    AppBskyEmbedRecordWithMedia: 'app.bsky.embed.recordWithMedia',
    AppBskyEmbedVideo: 'app.bsky.embed.video',
    AppBskyFeedDefs: 'app.bsky.feed.defs',
    AppBskyFeedDescribeFeedGenerator: 'app.bsky.feed.describeFeedGenerator',
    AppBskyFeedGenerator: 'app.bsky.feed.generator',
    AppBskyFeedGetActorFeeds: 'app.bsky.feed.getActorFeeds',
    AppBskyFeedGetActorLikes: 'app.bsky.feed.getActorLikes',
    AppBskyFeedGetAuthorFeed: 'app.bsky.feed.getAuthorFeed',
    AppBskyFeedGetFeed: 'app.bsky.feed.getFeed',
    AppBskyFeedGetFeedGenerator: 'app.bsky.feed.getFeedGenerator',
    AppBskyFeedGetFeedGenerators: 'app.bsky.feed.getFeedGenerators',
    AppBskyFeedGetFeedSkeleton: 'app.bsky.feed.getFeedSkeleton',
    AppBskyFeedGetLikes: 'app.bsky.feed.getLikes',
    AppBskyFeedGetListFeed: 'app.bsky.feed.getListFeed',
    AppBskyFeedGetPostThread: 'app.bsky.feed.getPostThread',
    AppBskyFeedGetPosts: 'app.bsky.feed.getPosts',
    AppBskyFeedGetQuotes: 'app.bsky.feed.getQuotes',
    AppBskyFeedGetRepostedBy: 'app.bsky.feed.getRepostedBy',
    AppBskyFeedGetSuggestedFeeds: 'app.bsky.feed.getSuggestedFeeds',
    AppBskyFeedGetTimeline: 'app.bsky.feed.getTimeline',
    AppBskyFeedLike: 'app.bsky.feed.like',
    AppBskyFeedPost: 'app.bsky.feed.post',
    AppBskyFeedPostgate: 'app.bsky.feed.postgate',
    AppBskyFeedRepost: 'app.bsky.feed.repost',
    AppBskyFeedSearchPosts: 'app.bsky.feed.searchPosts',
    AppBskyFeedSendInteractions: 'app.bsky.feed.sendInteractions',
    AppBskyFeedThreadgate: 'app.bsky.feed.threadgate',
    AppBskyGraphBlock: 'app.bsky.graph.block',
    AppBskyGraphDefs: 'app.bsky.graph.defs',
    AppBskyGraphFollow: 'app.bsky.graph.follow',
    AppBskyGraphGetActorStarterPacks: 'app.bsky.graph.getActorStarterPacks',
    AppBskyGraphGetBlocks: 'app.bsky.graph.getBlocks',
    AppBskyGraphGetFollowers: 'app.bsky.graph.getFollowers',
    AppBskyGraphGetFollows: 'app.bsky.graph.getFollows',
    AppBskyGraphGetKnownFollowers: 'app.bsky.graph.getKnownFollowers',
    AppBskyGraphGetList: 'app.bsky.graph.getList',
    AppBskyGraphGetListBlocks: 'app.bsky.graph.getListBlocks',
    AppBskyGraphGetListMutes: 'app.bsky.graph.getListMutes',
    AppBskyGraphGetLists: 'app.bsky.graph.getLists',
    AppBskyGraphGetListsWithMembership: 'app.bsky.graph.getListsWithMembership',
    AppBskyGraphGetMutes: 'app.bsky.graph.getMutes',
    AppBskyGraphGetRelationships: 'app.bsky.graph.getRelationships',
    AppBskyGraphGetStarterPack: 'app.bsky.graph.getStarterPack',
    AppBskyGraphGetStarterPacks: 'app.bsky.graph.getStarterPacks',
    AppBskyGraphGetStarterPacksWithMembership: 'app.bsky.graph.getStarterPacksWithMembership',
    AppBskyGraphGetSuggestedFollowsByActor: 'app.bsky.graph.getSuggestedFollowsByActor',
    AppBskyGraphList: 'app.bsky.graph.list',
    AppBskyGraphListblock: 'app.bsky.graph.listblock',
    AppBskyGraphListitem: 'app.bsky.graph.listitem',
    AppBskyGraphMuteActor: 'app.bsky.graph.muteActor',
    AppBskyGraphMuteActorList: 'app.bsky.graph.muteActorList',
    AppBskyGraphMuteThread: 'app.bsky.graph.muteThread',
    AppBskyGraphSearchStarterPacks: 'app.bsky.graph.searchStarterPacks',
    AppBskyGraphStarterpack: 'app.bsky.graph.starterpack',
    AppBskyGraphUnmuteActor: 'app.bsky.graph.unmuteActor',
    AppBskyGraphUnmuteActorList: 'app.bsky.graph.unmuteActorList',
    AppBskyGraphUnmuteThread: 'app.bsky.graph.unmuteThread',
    AppBskyGraphVerification: 'app.bsky.graph.verification',
    AppBskyLabelerDefs: 'app.bsky.labeler.defs',
    AppBskyLabelerGetServices: 'app.bsky.labeler.getServices',
    AppBskyLabelerService: 'app.bsky.labeler.service',
    AppBskyNotificationDeclaration: 'app.bsky.notification.declaration',
    AppBskyNotificationDefs: 'app.bsky.notification.defs',
    AppBskyNotificationGetPreferences: 'app.bsky.notification.getPreferences',
    AppBskyNotificationGetUnreadCount: 'app.bsky.notification.getUnreadCount',
    AppBskyNotificationListActivitySubscriptions: 'app.bsky.notification.listActivitySubscriptions',
    AppBskyNotificationListNotifications: 'app.bsky.notification.listNotifications',
    AppBskyNotificationPutActivitySubscription: 'app.bsky.notification.putActivitySubscription',
    AppBskyNotificationPutPreferences: 'app.bsky.notification.putPreferences',
    AppBskyNotificationPutPreferencesV2: 'app.bsky.notification.putPreferencesV2',
    AppBskyNotificationRegisterPush: 'app.bsky.notification.registerPush',
    AppBskyNotificationUnregisterPush: 'app.bsky.notification.unregisterPush',
    AppBskyNotificationUpdateSeen: 'app.bsky.notification.updateSeen',
    AppBskyRichtextFacet: 'app.bsky.richtext.facet',
    AppBskyUnspeccedDefs: 'app.bsky.unspecced.defs',
    AppBskyUnspeccedGetAgeAssuranceState: 'app.bsky.unspecced.getAgeAssuranceState',
    AppBskyUnspeccedGetConfig: 'app.bsky.unspecced.getConfig',
    AppBskyUnspeccedGetOnboardingSuggestedStarterPacks: 'app.bsky.unspecced.getOnboardingSuggestedStarterPacks',
    AppBskyUnspeccedGetOnboardingSuggestedStarterPacksSkeleton: 'app.bsky.unspecced.getOnboardingSuggestedStarterPacksSkeleton',
    AppBskyUnspeccedGetPopularFeedGenerators: 'app.bsky.unspecced.getPopularFeedGenerators',
    AppBskyUnspeccedGetPostThreadOtherV2: 'app.bsky.unspecced.getPostThreadOtherV2',
    AppBskyUnspeccedGetPostThreadV2: 'app.bsky.unspecced.getPostThreadV2',
    AppBskyUnspeccedGetSuggestedFeeds: 'app.bsky.unspecced.getSuggestedFeeds',
    AppBskyUnspeccedGetSuggestedFeedsSkeleton: 'app.bsky.unspecced.getSuggestedFeedsSkeleton',
    AppBskyUnspeccedGetSuggestedStarterPacks: 'app.bsky.unspecced.getSuggestedStarterPacks',
    AppBskyUnspeccedGetSuggestedStarterPacksSkeleton: 'app.bsky.unspecced.getSuggestedStarterPacksSkeleton',
    AppBskyUnspeccedGetSuggestedUsers: 'app.bsky.unspecced.getSuggestedUsers',
    AppBskyUnspeccedGetSuggestedUsersSkeleton: 'app.bsky.unspecced.getSuggestedUsersSkeleton',
    AppBskyUnspeccedGetSuggestionsSkeleton: 'app.bsky.unspecced.getSuggestionsSkeleton',
    AppBskyUnspeccedGetTaggedSuggestions: 'app.bsky.unspecced.getTaggedSuggestions',
    AppBskyUnspeccedGetTrendingTopics: 'app.bsky.unspecced.getTrendingTopics',
    AppBskyUnspeccedGetTrends: 'app.bsky.unspecced.getTrends',
    AppBskyUnspeccedGetTrendsSkeleton: 'app.bsky.unspecced.getTrendsSkeleton',
    AppBskyUnspeccedInitAgeAssurance: 'app.bsky.unspecced.initAgeAssurance',
    AppBskyUnspeccedSearchActorsSkeleton: 'app.bsky.unspecced.searchActorsSkeleton',
    AppBskyUnspeccedSearchPostsSkeleton: 'app.bsky.unspecced.searchPostsSkeleton',
    AppBskyUnspeccedSearchStarterPacksSkeleton: 'app.bsky.unspecced.searchStarterPacksSkeleton',
    AppBskyVideoDefs: 'app.bsky.video.defs',
    AppBskyVideoGetJobStatus: 'app.bsky.video.getJobStatus',
    AppBskyVideoGetUploadLimits: 'app.bsky.video.getUploadLimits',
    AppBskyVideoUploadVideo: 'app.bsky.video.uploadVideo',
    ChatBskyActorDeclaration: 'chat.bsky.actor.declaration',
    ChatBskyActorDefs: 'chat.bsky.actor.defs',
    ChatBskyActorDeleteAccount: 'chat.bsky.actor.deleteAccount',
    ChatBskyActorExportAccountData: 'chat.bsky.actor.exportAccountData',
    ChatBskyConvoAcceptConvo: 'chat.bsky.convo.acceptConvo',
    ChatBskyConvoAddReaction: 'chat.bsky.convo.addReaction',
    ChatBskyConvoDefs: 'chat.bsky.convo.defs',
    ChatBskyConvoDeleteMessageForSelf: 'chat.bsky.convo.deleteMessageForSelf',
    ChatBskyConvoGetConvo: 'chat.bsky.convo.getConvo',
    ChatBskyConvoGetConvoAvailability: 'chat.bsky.convo.getConvoAvailability',
    ChatBskyConvoGetConvoForMembers: 'chat.bsky.convo.getConvoForMembers',
    ChatBskyConvoGetLog: 'chat.bsky.convo.getLog',
    ChatBskyConvoGetMessages: 'chat.bsky.convo.getMessages',
    ChatBskyConvoLeaveConvo: 'chat.bsky.convo.leaveConvo',
    ChatBskyConvoListConvos: 'chat.bsky.convo.listConvos',
    ChatBskyConvoMuteConvo: 'chat.bsky.convo.muteConvo',
    ChatBskyConvoRemoveReaction: 'chat.bsky.convo.removeReaction',
    ChatBskyConvoSendMessage: 'chat.bsky.convo.sendMessage',
    ChatBskyConvoSendMessageBatch: 'chat.bsky.convo.sendMessageBatch',
    ChatBskyConvoUnmuteConvo: 'chat.bsky.convo.unmuteConvo',
    ChatBskyConvoUpdateAllRead: 'chat.bsky.convo.updateAllRead',
    ChatBskyConvoUpdateRead: 'chat.bsky.convo.updateRead',
    ChatBskyModerationGetActorMetadata: 'chat.bsky.moderation.getActorMetadata',
    ChatBskyModerationGetMessageContext: 'chat.bsky.moderation.getMessageContext',
    ChatBskyModerationUpdateActorAccess: 'chat.bsky.moderation.updateActorAccess',
    ComAtprotoAdminDefs: 'com.atproto.admin.defs',
    ComAtprotoAdminDeleteAccount: 'com.atproto.admin.deleteAccount',
    ComAtprotoAdminDisableAccountInvites: 'com.atproto.admin.disableAccountInvites',
    ComAtprotoAdminDisableInviteCodes: 'com.atproto.admin.disableInviteCodes',
    ComAtprotoAdminEnableAccountInvites: 'com.atproto.admin.enableAccountInvites',
    ComAtprotoAdminGetAccountInfo: 'com.atproto.admin.getAccountInfo',
    ComAtprotoAdminGetAccountInfos: 'com.atproto.admin.getAccountInfos',
    ComAtprotoAdminGetInviteCodes: 'com.atproto.admin.getInviteCodes',
    ComAtprotoAdminGetSubjectStatus: 'com.atproto.admin.getSubjectStatus',
    ComAtprotoAdminSearchAccounts: 'com.atproto.admin.searchAccounts',
    ComAtprotoAdminSendEmail: 'com.atproto.admin.sendEmail',
    ComAtprotoAdminUpdateAccountEmail: 'com.atproto.admin.updateAccountEmail',
    ComAtprotoAdminUpdateAccountHandle: 'com.atproto.admin.updateAccountHandle',
    ComAtprotoAdminUpdateAccountPassword: 'com.atproto.admin.updateAccountPassword',
    ComAtprotoAdminUpdateAccountSigningKey: 'com.atproto.admin.updateAccountSigningKey',
    ComAtprotoAdminUpdateSubjectStatus: 'com.atproto.admin.updateSubjectStatus',
    ComAtprotoIdentityDefs: 'com.atproto.identity.defs',
    ComAtprotoIdentityGetRecommendedDidCredentials: 'com.atproto.identity.getRecommendedDidCredentials',
    ComAtprotoIdentityRefreshIdentity: 'com.atproto.identity.refreshIdentity',
    ComAtprotoIdentityRequestPlcOperationSignature: 'com.atproto.identity.requestPlcOperationSignature',
    ComAtprotoIdentityResolveDid: 'com.atproto.identity.resolveDid',
    ComAtprotoIdentityResolveHandle: 'com.atproto.identity.resolveHandle',
    ComAtprotoIdentityResolveIdentity: 'com.atproto.identity.resolveIdentity',
    ComAtprotoIdentitySignPlcOperation: 'com.atproto.identity.signPlcOperation',
    ComAtprotoIdentitySubmitPlcOperation: 'com.atproto.identity.submitPlcOperation',
    ComAtprotoIdentityUpdateHandle: 'com.atproto.identity.updateHandle',
    ComAtprotoLabelDefs: 'com.atproto.label.defs',
    ComAtprotoLabelQueryLabels: 'com.atproto.label.queryLabels',
    ComAtprotoLabelSubscribeLabels: 'com.atproto.label.subscribeLabels',
    ComAtprotoLexiconSchema: 'com.atproto.lexicon.schema',
    ComAtprotoModerationCreateReport: 'com.atproto.moderation.createReport',
    ComAtprotoModerationDefs: 'com.atproto.moderation.defs',
    ComAtprotoRepoApplyWrites: 'com.atproto.repo.applyWrites',
    ComAtprotoRepoCreateRecord: 'com.atproto.repo.createRecord',
    ComAtprotoRepoDefs: 'com.atproto.repo.defs',
    ComAtprotoRepoDeleteRecord: 'com.atproto.repo.deleteRecord',
    ComAtprotoRepoDescribeRepo: 'com.atproto.repo.describeRepo',
    ComAtprotoRepoGetRecord: 'com.atproto.repo.getRecord',
    ComAtprotoRepoImportRepo: 'com.atproto.repo.importRepo',
    ComAtprotoRepoListMissingBlobs: 'com.atproto.repo.listMissingBlobs',
    ComAtprotoRepoListRecords: 'com.atproto.repo.listRecords',
    ComAtprotoRepoPutRecord: 'com.atproto.repo.putRecord',
    ComAtprotoRepoStrongRef: 'com.atproto.repo.strongRef',
    ComAtprotoRepoUploadBlob: 'com.atproto.repo.uploadBlob',
    ComAtprotoServerActivateAccount: 'com.atproto.server.activateAccount',
    ComAtprotoServerCheckAccountStatus: 'com.atproto.server.checkAccountStatus',
    ComAtprotoServerConfirmEmail: 'com.atproto.server.confirmEmail',
    ComAtprotoServerCreateAccount: 'com.atproto.server.createAccount',
    ComAtprotoServerCreateAppPassword: 'com.atproto.server.createAppPassword',
    ComAtprotoServerCreateCustomJwtSession: 'com.atproto.server.createCustomJwtSession',
    ComAtprotoServerCreateInviteCode: 'com.atproto.server.createInviteCode',
    ComAtprotoServerCreateInviteCodes: 'com.atproto.server.createInviteCodes',
    ComAtprotoServerCreateSession: 'com.atproto.server.createSession',
    ComAtprotoServerDeactivateAccount: 'com.atproto.server.deactivateAccount',
    ComAtprotoServerDefs: 'com.atproto.server.defs',
    ComAtprotoServerDeleteAccount: 'com.atproto.server.deleteAccount',
    ComAtprotoServerDeleteSession: 'com.atproto.server.deleteSession',
    ComAtprotoServerDescribeServer: 'com.atproto.server.describeServer',
    ComAtprotoServerGetAccountInviteCodes: 'com.atproto.server.getAccountInviteCodes',
    ComAtprotoServerGetServiceAuth: 'com.atproto.server.getServiceAuth',
    ComAtprotoServerGetSession: 'com.atproto.server.getSession',
    ComAtprotoServerListAppPasswords: 'com.atproto.server.listAppPasswords',
    ComAtprotoServerRefreshSession: 'com.atproto.server.refreshSession',
    ComAtprotoServerRequestAccountDelete: 'com.atproto.server.requestAccountDelete',
    ComAtprotoServerRequestEmailConfirmation: 'com.atproto.server.requestEmailConfirmation',
    ComAtprotoServerRequestEmailUpdate: 'com.atproto.server.requestEmailUpdate',
    ComAtprotoServerRequestPasswordReset: 'com.atproto.server.requestPasswordReset',
    ComAtprotoServerReserveSigningKey: 'com.atproto.server.reserveSigningKey',
    ComAtprotoServerResetPassword: 'com.atproto.server.resetPassword',
    ComAtprotoServerRevokeAppPassword: 'com.atproto.server.revokeAppPassword',
    ComAtprotoServerUpdateEmail: 'com.atproto.server.updateEmail',
    ComAtprotoSyncDefs: 'com.atproto.sync.defs',
    ComAtprotoSyncGetBlob: 'com.atproto.sync.getBlob',
    ComAtprotoSyncGetBlocks: 'com.atproto.sync.getBlocks',
    ComAtprotoSyncGetCheckout: 'com.atproto.sync.getCheckout',
    ComAtprotoSyncGetHead: 'com.atproto.sync.getHead',
    ComAtprotoSyncGetHostStatus: 'com.atproto.sync.getHostStatus',
    ComAtprotoSyncGetLatestCommit: 'com.atproto.sync.getLatestCommit',
    ComAtprotoSyncGetRecord: 'com.atproto.sync.getRecord',
    ComAtprotoSyncGetRepo: 'com.atproto.sync.getRepo',
    ComAtprotoSyncGetRepoStatus: 'com.atproto.sync.getRepoStatus',
    ComAtprotoSyncListBlobs: 'com.atproto.sync.listBlobs',
    ComAtprotoSyncListHosts: 'com.atproto.sync.listHosts',
    ComAtprotoSyncListRepos: 'com.atproto.sync.listRepos',
    ComAtprotoSyncListReposByCollection: 'com.atproto.sync.listReposByCollection',
    ComAtprotoSyncNotifyOfUpdate: 'com.atproto.sync.notifyOfUpdate',
    ComAtprotoSyncRequestCrawl: 'com.atproto.sync.requestCrawl',
    ComAtprotoSyncSubscribeRepos: 'com.atproto.sync.subscribeRepos',
    ComAtprotoTempAddReservedHandle: 'com.atproto.temp.addReservedHandle',
    ComAtprotoTempCheckHandleAvailability: 'com.atproto.temp.checkHandleAvailability',
    ComAtprotoTempCheckSignupQueue: 'com.atproto.temp.checkSignupQueue',
    ComAtprotoTempDereferenceScope: 'com.atproto.temp.dereferenceScope',
    ComAtprotoTempFetchLabels: 'com.atproto.temp.fetchLabels',
    ComAtprotoTempRequestPhoneVerification: 'com.atproto.temp.requestPhoneVerification',
    ComAtprotoTempRevokeAccountCredentials: 'com.atproto.temp.revokeAccountCredentials',
    ToolsOzoneCommunicationCreateTemplate: 'tools.ozone.communication.createTemplate',
    ToolsOzoneCommunicationDefs: 'tools.ozone.communication.defs',
    ToolsOzoneCommunicationDeleteTemplate: 'tools.ozone.communication.deleteTemplate',
    ToolsOzoneCommunicationListTemplates: 'tools.ozone.communication.listTemplates',
    ToolsOzoneCommunicationUpdateTemplate: 'tools.ozone.communication.updateTemplate',
    ToolsOzoneHostingGetAccountHistory: 'tools.ozone.hosting.getAccountHistory',
    ToolsOzoneModerationCancelScheduledActions: 'tools.ozone.moderation.cancelScheduledActions',
    ToolsOzoneModerationDefs: 'tools.ozone.moderation.defs',
    ToolsOzoneModerationEmitEvent: 'tools.ozone.moderation.emitEvent',
    ToolsOzoneModerationGetAccountTimeline: 'tools.ozone.moderation.getAccountTimeline',
    ToolsOzoneModerationGetEvent: 'tools.ozone.moderation.getEvent',
    ToolsOzoneModerationGetRecord: 'tools.ozone.moderation.getRecord',
    ToolsOzoneModerationGetRecords: 'tools.ozone.moderation.getRecords',
    ToolsOzoneModerationGetRepo: 'tools.ozone.moderation.getRepo',
    ToolsOzoneModerationGetReporterStats: 'tools.ozone.moderation.getReporterStats',
    ToolsOzoneModerationGetRepos: 'tools.ozone.moderation.getRepos',
    ToolsOzoneModerationGetSubjects: 'tools.ozone.moderation.getSubjects',
    ToolsOzoneModerationListScheduledActions: 'tools.ozone.moderation.listScheduledActions',
    ToolsOzoneModerationQueryEvents: 'tools.ozone.moderation.queryEvents',
    ToolsOzoneModerationQueryStatuses: 'tools.ozone.moderation.queryStatuses',
    ToolsOzoneModerationScheduleAction: 'tools.ozone.moderation.scheduleAction',
    ToolsOzoneModerationSearchRepos: 'tools.ozone.moderation.searchRepos',
    ToolsOzoneReportDefs: 'tools.ozone.report.defs',
    ToolsOzoneSafelinkAddRule: 'tools.ozone.safelink.addRule',
    ToolsOzoneSafelinkDefs: 'tools.ozone.safelink.defs',
    ToolsOzoneSafelinkQueryEvents: 'tools.ozone.safelink.queryEvents',
    ToolsOzoneSafelinkQueryRules: 'tools.ozone.safelink.queryRules',
    ToolsOzoneSafelinkRemoveRule: 'tools.ozone.safelink.removeRule',
    ToolsOzoneSafelinkUpdateRule: 'tools.ozone.safelink.updateRule',
    ToolsOzoneServerGetConfig: 'tools.ozone.server.getConfig',
    ToolsOzoneSetAddValues: 'tools.ozone.set.addValues',
    ToolsOzoneSetDefs: 'tools.ozone.set.defs',
    ToolsOzoneSetDeleteSet: 'tools.ozone.set.deleteSet',
    ToolsOzoneSetDeleteValues: 'tools.ozone.set.deleteValues',
    ToolsOzoneSetGetValues: 'tools.ozone.set.getValues',
    ToolsOzoneSetQuerySets: 'tools.ozone.set.querySets',
    ToolsOzoneSetUpsertSet: 'tools.ozone.set.upsertSet',
    ToolsOzoneSettingDefs: 'tools.ozone.setting.defs',
    ToolsOzoneSettingListOptions: 'tools.ozone.setting.listOptions',
    ToolsOzoneSettingRemoveOptions: 'tools.ozone.setting.removeOptions',
    ToolsOzoneSettingUpsertOption: 'tools.ozone.setting.upsertOption',
    ToolsOzoneSignatureDefs: 'tools.ozone.signature.defs',
    ToolsOzoneSignatureFindCorrelation: 'tools.ozone.signature.findCorrelation',
    ToolsOzoneSignatureFindRelatedAccounts: 'tools.ozone.signature.findRelatedAccounts',
    ToolsOzoneSignatureSearchAccounts: 'tools.ozone.signature.searchAccounts',
    ToolsOzoneTeamAddMember: 'tools.ozone.team.addMember',
    ToolsOzoneTeamDefs: 'tools.ozone.team.defs',
    ToolsOzoneTeamDeleteMember: 'tools.ozone.team.deleteMember',
    ToolsOzoneTeamListMembers: 'tools.ozone.team.listMembers',
    ToolsOzoneTeamUpdateMember: 'tools.ozone.team.updateMember',
    ToolsOzoneVerificationDefs: 'tools.ozone.verification.defs',
    ToolsOzoneVerificationGrantVerifications: 'tools.ozone.verification.grantVerifications',
    ToolsOzoneVerificationListVerifications: 'tools.ozone.verification.listVerifications',
    ToolsOzoneVerificationRevokeVerifications: 'tools.ozone.verification.revokeVerifications'
};

},{"e3bc5e4d947f7c7a":"aBnF9","a8e3287ef4cff6dd":"45ZSh"}],"45ZSh":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * GENERATED CODE - DO NOT MODIFY
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.is$typed = is$typed;
exports.maybe$typed = maybe$typed;
exports.asPredicate = asPredicate;
function isObject(v) {
    return v != null && typeof v === 'object';
}
function is$type($type, id, hash) {
    return hash === 'main' ? $type === id : typeof $type === 'string' && $type.length === id.length + 1 + hash.length && $type.charCodeAt(id.length) === 35 /* '#' */  && $type.startsWith(id) && $type.endsWith(hash);
}
function is$typed(v, id, hash) {
    return isObject(v) && '$type' in v && is$type(v.$type, id, hash);
}
function maybe$typed(v, id, hash) {
    return isObject(v) && ('$type' in v ? v.$type === undefined || is$type(v.$type, id, hash) : true);
}
/**
 * Utility function that allows to convert a "validate*" utility function into a
 * type predicate.
 */ function asPredicate(validate) {
    return function(v) {
        return validate(v).success;
    };
}

},{}],"cODXL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAtprotoServiceType = isAtprotoServiceType;
exports.isDid = isDid;
exports.assertDid = assertDid;
exports.asDid = asDid;
exports.isAtprotoProxy = isAtprotoProxy;
exports.assertAtprotoProxy = assertAtprotoProxy;
exports.asAtprotoProxy = asAtprotoProxy;
function isAtprotoServiceType(input) {
    return !input.includes(' ') && !input.includes('#');
}
function isDid(input) {
    if (!input.startsWith('did:')) return false;
    if (input.length < 8) return false;
    if (input.length > 2048) return false;
    const msidx = input.indexOf(':', 4);
    return msidx > 4 && msidx < input.length - 1;
}
function assertDid(input) {
    if (!isDid(input)) throw new TypeError(`Invalid DID: ${input}`);
}
function asDid(input) {
    assertDid(input);
    return input;
}
function isAtprotoProxy(input) {
    const { length, [0]: did, [1]: service } = input.split('#');
    return length === 2 && isDid(did) && isAtprotoServiceType(service);
}
function assertAtprotoProxy(input) {
    if (!isAtprotoProxy(input)) throw new TypeError(`Invalid DID reference: ${input} (must be of the form did:example:alice#service)`);
}
function asAtprotoProxy(input) {
    assertAtprotoProxy(input);
    return input;
}

},{}],"8d2D9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BSKY_LABELER_DID = void 0;
exports.BSKY_LABELER_DID = 'did:plc:ar7c4by46qjdydhdevvrndac';

},{}],"eeUEr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.nuxSchema = void 0;
exports.sanitizeMutedWordValue = sanitizeMutedWordValue;
exports.savedFeedsToUriArrays = savedFeedsToUriArrays;
exports.getSavedFeedType = getSavedFeedType;
exports.validateSavedFeed = validateSavedFeed;
exports.validateNux = validateNux;
const zod_1 = require("6e465cda20f57fcc");
const syntax_1 = require("a443647b9d1c94fb");
function sanitizeMutedWordValue(value) {
    return value.trim().replace(/^#(?!\ufe0f)/, '')// eslint-disable-next-line no-misleading-character-class
    .replace(/[\r\n\u00AD\u2060\u200D\u200C\u200B]+/, '');
}
function savedFeedsToUriArrays(savedFeeds) {
    const pinned = [];
    const saved = [];
    for (const feed of savedFeeds)if (feed.pinned) {
        pinned.push(feed.value);
        // saved in v1 includes pinned
        saved.push(feed.value);
    } else saved.push(feed.value);
    return {
        pinned,
        saved
    };
}
/**
 * Get the type of a saved feed, used by deprecated methods for backwards
 * compat. Should not be used moving forward. *Invalid URIs will throw.*
 *
 * @param uri - The AT URI of the saved feed
 */ function getSavedFeedType(uri) {
    const urip = new syntax_1.AtUri(uri);
    switch(urip.collection){
        case 'app.bsky.feed.generator':
            return 'feed';
        case 'app.bsky.graph.list':
            return 'list';
        default:
            return 'unknown';
    }
}
function validateSavedFeed(savedFeed) {
    if (!savedFeed.id) throw new Error('Saved feed must have an `id` - use a TID');
    if ([
        'feed',
        'list'
    ].includes(savedFeed.type)) {
        const uri = new syntax_1.AtUri(savedFeed.value);
        const isFeed = uri.collection === 'app.bsky.feed.generator';
        const isList = uri.collection === 'app.bsky.graph.list';
        if (savedFeed.type === 'feed' && !isFeed) throw new Error(`Saved feed of type 'feed' must be a feed, got ${uri.collection}`);
        if (savedFeed.type === 'list' && !isList) throw new Error(`Saved feed of type 'list' must be a list, got ${uri.collection}`);
    }
}
exports.nuxSchema = zod_1.z.object({
    id: zod_1.z.string().max(64),
    completed: zod_1.z.boolean(),
    data: zod_1.z.string().max(300).optional(),
    expiresAt: zod_1.z.string().datetime().optional()
}).strict();
function validateNux(nux) {
    exports.nuxSchema.parse(nux);
}

},{"6e465cda20f57fcc":"3vQQ2","a443647b9d1c94fb":"dBffO"}],"3vQQ2":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.z = void 0;
const z = __importStar(require("c70038f135adfff1"));
exports.z = z;
__exportStar(require("c70038f135adfff1"), exports);
exports.default = z;

},{"c70038f135adfff1":"kCwsq"}],"kCwsq":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("4cdadb748893f9c0"), exports);
__exportStar(require("f414539a6e7bb92f"), exports);
__exportStar(require("602d97ff467e3589"), exports);
__exportStar(require("5eee30a2f159abb8"), exports);
__exportStar(require("4357e4798cbbeb07"), exports);
__exportStar(require("7cf6bae13e56defc"), exports);

},{"4cdadb748893f9c0":"2zU38","f414539a6e7bb92f":"1ANpf","602d97ff467e3589":"8Q9FX","5eee30a2f159abb8":"gBcmo","4357e4798cbbeb07":"Rj9fd","7cf6bae13e56defc":"i4PBZ"}],"2zU38":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultErrorMap = void 0;
exports.setErrorMap = setErrorMap;
exports.getErrorMap = getErrorMap;
const en_js_1 = __importDefault(require("10006e8b62520d72"));
exports.defaultErrorMap = en_js_1.default;
let overrideErrorMap = en_js_1.default;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

},{"10006e8b62520d72":"79zea"}],"79zea":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const ZodError_js_1 = require("5987dc8f7f585f0f");
const util_js_1 = require("b7f030d592ceef6f");
const errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case ZodError_js_1.ZodIssueCode.invalid_type:
            if (issue.received === util_js_1.ZodParsedType.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util_js_1.util.jsonStringifyReplacer)}`;
            break;
        case ZodError_js_1.ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util_js_1.util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util_js_1.util.joinValues(issue.options)}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util_js_1.util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else util_js_1.util.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case ZodError_js_1.ZodIssueCode.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case ZodError_js_1.ZodIssueCode.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case ZodError_js_1.ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodError_js_1.ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodError_js_1.ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util_js_1.util.assertNever(issue);
    }
    return {
        message
    };
};
exports.default = errorMap;

},{"5987dc8f7f585f0f":"i4PBZ","b7f030d592ceef6f":"gBcmo"}],"i4PBZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ZodError = exports.quotelessJson = exports.ZodIssueCode = void 0;
const util_js_1 = require("9659e46a1792038e");
exports.ZodIssueCode = util_js_1.util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const quotelessJson = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
exports.quotelessJson = quotelessJson;
class ZodError extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util_js_1.util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors,
            fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
exports.ZodError = ZodError;
ZodError.create = (issues)=>{
    const error = new ZodError(issues);
    return error;
};

},{"9659e46a1792038e":"gBcmo"}],"gBcmo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getParsedType = exports.ZodParsedType = exports.objectUtil = exports.util = void 0;
var util;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})(util || (exports.util = util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})(objectUtil || (exports.objectUtil = objectUtil = {}));
exports.ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return exports.ZodParsedType.undefined;
        case "string":
            return exports.ZodParsedType.string;
        case "number":
            return Number.isNaN(data) ? exports.ZodParsedType.nan : exports.ZodParsedType.number;
        case "boolean":
            return exports.ZodParsedType.boolean;
        case "function":
            return exports.ZodParsedType.function;
        case "bigint":
            return exports.ZodParsedType.bigint;
        case "symbol":
            return exports.ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return exports.ZodParsedType.array;
            if (data === null) return exports.ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return exports.ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return exports.ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return exports.ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return exports.ZodParsedType.date;
            return exports.ZodParsedType.object;
        default:
            return exports.ZodParsedType.unknown;
    }
};
exports.getParsedType = getParsedType;

},{}],"1ANpf":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAsync = exports.isValid = exports.isDirty = exports.isAborted = exports.OK = exports.DIRTY = exports.INVALID = exports.ParseStatus = exports.EMPTY_PATH = exports.makeIssue = void 0;
exports.addIssueToContext = addIssueToContext;
const errors_js_1 = require("96170231b4526878");
const en_js_1 = __importDefault(require("a65683d3d4f03680"));
const makeIssue = (params)=>{
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
exports.makeIssue = makeIssue;
exports.EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = (0, errors_js_1.getErrorMap)();
    const issue = (0, exports.makeIssue)({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === en_js_1.default ? undefined : en_js_1.default
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return exports.INVALID;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key, value } = pair;
            if (key.status === "aborted") return exports.INVALID;
            if (value.status === "aborted") return exports.INVALID;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
exports.ParseStatus = ParseStatus;
exports.INVALID = Object.freeze({
    status: "aborted"
});
const DIRTY = (value)=>({
        status: "dirty",
        value
    });
exports.DIRTY = DIRTY;
const OK = (value)=>({
        status: "valid",
        value
    });
exports.OK = OK;
const isAborted = (x)=>x.status === "aborted";
exports.isAborted = isAborted;
const isDirty = (x)=>x.status === "dirty";
exports.isDirty = isDirty;
const isValid = (x)=>x.status === "valid";
exports.isValid = isValid;
const isAsync = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
exports.isAsync = isAsync;

},{"96170231b4526878":"2zU38","a65683d3d4f03680":"79zea"}],"8Q9FX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"Rj9fd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.discriminatedUnion = exports.date = exports.boolean = exports.bigint = exports.array = exports.any = exports.coerce = exports.ZodFirstPartyTypeKind = exports.late = exports.ZodSchema = exports.Schema = exports.ZodReadonly = exports.ZodPipeline = exports.ZodBranded = exports.BRAND = exports.ZodNaN = exports.ZodCatch = exports.ZodDefault = exports.ZodNullable = exports.ZodOptional = exports.ZodTransformer = exports.ZodEffects = exports.ZodPromise = exports.ZodNativeEnum = exports.ZodEnum = exports.ZodLiteral = exports.ZodLazy = exports.ZodFunction = exports.ZodSet = exports.ZodMap = exports.ZodRecord = exports.ZodTuple = exports.ZodIntersection = exports.ZodDiscriminatedUnion = exports.ZodUnion = exports.ZodObject = exports.ZodArray = exports.ZodVoid = exports.ZodNever = exports.ZodUnknown = exports.ZodAny = exports.ZodNull = exports.ZodUndefined = exports.ZodSymbol = exports.ZodDate = exports.ZodBoolean = exports.ZodBigInt = exports.ZodNumber = exports.ZodString = exports.ZodType = void 0;
exports.NEVER = exports.void = exports.unknown = exports.union = exports.undefined = exports.tuple = exports.transformer = exports.symbol = exports.string = exports.strictObject = exports.set = exports.record = exports.promise = exports.preprocess = exports.pipeline = exports.ostring = exports.optional = exports.onumber = exports.oboolean = exports.object = exports.number = exports.nullable = exports.null = exports.never = exports.nativeEnum = exports.nan = exports.map = exports.literal = exports.lazy = exports.intersection = exports.instanceof = exports.function = exports.enum = exports.effect = void 0;
exports.datetimeRegex = datetimeRegex;
exports.custom = custom;
const ZodError_js_1 = require("adbb2753d41a8ef");
const errors_js_1 = require("a63873d49bff3757");
const errorUtil_js_1 = require("eb61d7a1b54f2edd");
const parseUtil_js_1 = require("f5d51f4fc743f105");
const util_js_1 = require("5d51679e84f4812d");
class ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result)=>{
    if ((0, parseUtil_js_1.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new ZodError_js_1.ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description
    };
    const customMap = (iss, ctx)=>{
        const { message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description
    };
}
class ZodType {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, util_js_1.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, util_js_1.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new parseUtil_js_1.ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, util_js_1.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, parseUtil_js_1.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        const result = this._parseSync({
            data,
            path: ctx.path,
            parent: ctx
        });
        return handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data,
                path: [],
                parent: ctx
            });
            return (0, parseUtil_js_1.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data,
            path: [],
            parent: ctx
        }).then((result)=>(0, parseUtil_js_1.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, parseUtil_js_1.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: ZodError_js_1.ZodIssueCode.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
exports.ZodType = ZodType;
exports.Schema = ZodType;
exports.ZodSchema = ZodType;
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
function isValidJWT(jwt, alg) {
    if (!jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function isValidCidr(ip, version) {
    if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) return true;
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.string,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const status = new parseUtil_js_1.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "email",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    validation: "url",
                    code: ZodError_js_1.ZodIssueCode.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation,
            code: ZodError_js_1.ZodIssueCode.invalid_string,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, errorUtil_js_1.errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
exports.ZodString = ZodString;
ZodString.create = (params)=>{
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class ZodNumber extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.number,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        let ctx = undefined;
        const status = new parseUtil_js_1.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!util_js_1.util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil_js_1.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil_js_1.errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && util_js_1.util.isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
exports.ZodNumber = ZodNumber;
ZodNumber.create = (params)=>{
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodBigInt extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new parseUtil_js_1.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, parseUtil_js_1.addIssueToContext)(ctx, {
            code: ZodError_js_1.ZodIssueCode.invalid_type,
            expected: util_js_1.ZodParsedType.bigint,
            received: ctx.parsedType
        });
        return parseUtil_js_1.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil_js_1.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
exports.ZodBigInt = ZodBigInt;
ZodBigInt.create = (params)=>{
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.boolean,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodBoolean = ZodBoolean;
ZodBoolean.create = (params)=>{
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.date,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_date
            });
            return parseUtil_js_1.INVALID;
        }
        const status = new parseUtil_js_1.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
exports.ZodDate = ZodDate;
ZodDate.create = (params)=>{
    return new ZodDate({
        checks: [],
        coerce: params?.coerce || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params)
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.symbol,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodSymbol = ZodSymbol;
ZodSymbol.create = (params)=>{
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params)
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.undefined,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodUndefined = ZodUndefined;
ZodUndefined.create = (params)=>{
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params)
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.null,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodNull = ZodNull;
ZodNull.create = (params)=>{
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params)
    });
};
class ZodAny extends ZodType {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodAny = ZodAny;
ZodAny.create = (params)=>{
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params)
    });
};
class ZodUnknown extends ZodType {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodUnknown = ZodUnknown;
ZodUnknown.create = (params)=>{
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params)
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, parseUtil_js_1.addIssueToContext)(ctx, {
            code: ZodError_js_1.ZodIssueCode.invalid_type,
            expected: util_js_1.ZodParsedType.never,
            received: ctx.parsedType
        });
        return parseUtil_js_1.INVALID;
    }
}
exports.ZodNever = ZodNever;
ZodNever.create = (params)=>{
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params)
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.void,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodVoid = ZodVoid;
ZodVoid.create = (params)=>{
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params)
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== util_js_1.ZodParsedType.array) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.array,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: tooBig ? ZodError_js_1.ZodIssueCode.too_big : ZodError_js_1.ZodIssueCode.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return parseUtil_js_1.ParseStatus.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return parseUtil_js_1.ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: {
                value: minLength,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: {
                value: len,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
exports.ZodArray = ZodArray;
ZodArray.create = (schema, params)=>{
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params)
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof ZodArray) return new ZodArray({
        ...schema._def,
        type: deepPartialify(schema.element)
    });
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map((item)=>deepPartialify(item)));
    else return schema;
}
class ZodObject extends ZodType {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = util_js_1.util.objectKeys(shape);
        this._cached = {
            shape,
            keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key,
                    value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return parseUtil_js_1.ParseStatus.mergeObjectSync(status, syncPairs);
        });
        else return parseUtil_js_1.ParseStatus.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil_js_1.errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: errorUtil_js_1.errorUtil.errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of util_js_1.util.objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of util_js_1.util.objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of util_js_1.util.objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of util_js_1.util.objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof ZodOptional)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return createZodEnum(util_js_1.util.objectKeys(this.shape));
    }
}
exports.ZodObject = ZodObject;
ZodObject.create = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.strictCreate = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.lazycreate = (shape, params)=>{
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new ZodError_js_1.ZodError(result.ctx.common.issues));
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union,
                unionErrors
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new ZodError_js_1.ZodError(issues));
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union,
                unionErrors
            });
            return parseUtil_js_1.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
exports.ZodUnion = ZodUnion;
ZodUnion.create = (types, params)=>{
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type)=>{
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return util_js_1.util.objectValues(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else if (type instanceof ZodOptional) return [
        undefined,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodNullable) return [
        null,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodBranded) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodReadonly) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodCatch) return getDiscriminator(type._def.innerType);
    else return [];
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.object) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params)
        });
    }
}
exports.ZodDiscriminatedUnion = ZodDiscriminatedUnion;
function mergeValues(a, b) {
    const aType = (0, util_js_1.getParsedType)(a);
    const bType = (0, util_js_1.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === util_js_1.ZodParsedType.object && bType === util_js_1.ZodParsedType.object) {
        const bKeys = util_js_1.util.objectKeys(b);
        const sharedKeys = util_js_1.util.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === util_js_1.ZodParsedType.array && bType === util_js_1.ZodParsedType.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === util_js_1.ZodParsedType.date && bType === util_js_1.ZodParsedType.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, parseUtil_js_1.isAborted)(parsedLeft) || (0, parseUtil_js_1.isAborted)(parsedRight)) return parseUtil_js_1.INVALID;
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.invalid_intersection_types
                });
                return parseUtil_js_1.INVALID;
            }
            if ((0, parseUtil_js_1.isDirty)(parsedLeft) || (0, parseUtil_js_1.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
exports.ZodIntersection = ZodIntersection;
ZodIntersection.create = (left, right, params)=>{
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params)
    });
};
// type ZodTupleItems = [ZodTypeAny, ...ZodTypeAny[]];
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.array) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.array,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return parseUtil_js_1.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return parseUtil_js_1.ParseStatus.mergeArray(status, results);
        });
        else return parseUtil_js_1.ParseStatus.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest
        });
    }
}
exports.ZodTuple = ZodTuple;
ZodTuple.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params)
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.object) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return parseUtil_js_1.ParseStatus.mergeObjectAsync(status, pairs);
        else return parseUtil_js_1.ParseStatus.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) return new ZodRecord({
            keyType: first,
            valueType: second,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(third)
        });
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second)
        });
    }
}
exports.ZodRecord = ZodRecord;
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.map) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.map,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return parseUtil_js_1.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return parseUtil_js_1.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
exports.ZodMap = ZodMap;
ZodMap.create = (keyType, valueType, params)=>{
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params)
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.set) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.set,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return parseUtil_js_1.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: {
                value: minSize,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
exports.ZodSet = ZodSet;
ZodSet.create = (valueType, params)=>{
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params)
    });
};
class ZodFunction extends ZodType {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.function) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.function,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, parseUtil_js_1.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, errors_js_1.getErrorMap)(),
                    errors_js_1.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodError_js_1.ZodIssueCode.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, parseUtil_js_1.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, errors_js_1.getErrorMap)(),
                    errors_js_1.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodError_js_1.ZodIssueCode.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, parseUtil_js_1.OK)(async function(...args) {
                const error = new ZodError_js_1.ZodError([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, parseUtil_js_1.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new ZodError_js_1.ZodError([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new ZodError_js_1.ZodError([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create())
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params)
        });
    }
}
exports.ZodFunction = ZodFunction;
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
exports.ZodLazy = ZodLazy;
ZodLazy.create = (getter, params)=>{
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params)
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_literal,
                expected: this._def.value
            });
            return parseUtil_js_1.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
exports.ZodLiteral = ZodLiteral;
ZodLiteral.create = (value, params)=>{
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params)
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params)
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                expected: util_js_1.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodError_js_1.ZodIssueCode.invalid_type
            });
            return parseUtil_js_1.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
exports.ZodEnum = ZodEnum;
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util_js_1.util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.string && ctx.parsedType !== util_js_1.ZodParsedType.number) {
            const expectedValues = util_js_1.util.objectValues(nativeEnumValues);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                expected: util_js_1.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodError_js_1.ZodIssueCode.invalid_type
            });
            return parseUtil_js_1.INVALID;
        }
        if (!this._cache) this._cache = new Set(util_js_1.util.getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = util_js_1.util.objectValues(nativeEnumValues);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
exports.ZodNativeEnum = ZodNativeEnum;
ZodNativeEnum.create = (values, params)=>{
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params)
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.promise && ctx.common.async === false) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.promise,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const promisified = ctx.parsedType === util_js_1.ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, parseUtil_js_1.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
exports.ZodPromise = ZodPromise;
ZodPromise.create = (schema, params)=>{
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params)
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, parseUtil_js_1.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return parseUtil_js_1.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return parseUtil_js_1.INVALID;
                if (result.status === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                if (status.value === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return parseUtil_js_1.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return parseUtil_js_1.INVALID;
                if (result.status === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                if (status.value === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return parseUtil_js_1.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return parseUtil_js_1.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, parseUtil_js_1.isValid)(base)) return parseUtil_js_1.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, parseUtil_js_1.isValid)(base)) return parseUtil_js_1.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        util_js_1.util.assertNever(effect);
    }
}
exports.ZodEffects = ZodEffects;
exports.ZodTransformer = ZodEffects;
ZodEffects.create = (schema, effect, params)=>{
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params)
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params)=>{
    return new ZodEffects({
        schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params)
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === util_js_1.ZodParsedType.undefined) return (0, parseUtil_js_1.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodOptional = ZodOptional;
ZodOptional.create = (type, params)=>{
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params)
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === util_js_1.ZodParsedType.null) return (0, parseUtil_js_1.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodNullable = ZodNullable;
ZodNullable.create = (type, params)=>{
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params)
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === util_js_1.ZodParsedType.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
exports.ZodDefault = ZodDefault;
ZodDefault.create = (type, params)=>{
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...processCreateParams(params)
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, parseUtil_js_1.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new ZodError_js_1.ZodError(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new ZodError_js_1.ZodError(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
exports.ZodCatch = ZodCatch;
ZodCatch.create = (type, params)=>{
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...processCreateParams(params)
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.nan,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
exports.ZodNaN = ZodNaN;
ZodNaN.create = (params)=>{
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params)
    });
};
exports.BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
exports.ZodBranded = ZodBranded;
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return parseUtil_js_1.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, parseUtil_js_1.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return parseUtil_js_1.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline
        });
    }
}
exports.ZodPipeline = ZodPipeline;
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, parseUtil_js_1.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, parseUtil_js_1.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodReadonly = ZodReadonly;
ZodReadonly.create = (type, params)=>{
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function custom(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return ZodAny.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return ZodAny.create();
}
exports.late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (exports.ZodFirstPartyTypeKind = ZodFirstPartyTypeKind = {}));
// requires TS 4.4+
class Class {
    constructor(..._){}
}
const instanceOfType = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>custom((data)=>data instanceof cls, params);
exports.instanceof = instanceOfType;
const stringType = ZodString.create;
exports.string = stringType;
const numberType = ZodNumber.create;
exports.number = numberType;
const nanType = ZodNaN.create;
exports.nan = nanType;
const bigIntType = ZodBigInt.create;
exports.bigint = bigIntType;
const booleanType = ZodBoolean.create;
exports.boolean = booleanType;
const dateType = ZodDate.create;
exports.date = dateType;
const symbolType = ZodSymbol.create;
exports.symbol = symbolType;
const undefinedType = ZodUndefined.create;
exports.undefined = undefinedType;
const nullType = ZodNull.create;
exports.null = nullType;
const anyType = ZodAny.create;
exports.any = anyType;
const unknownType = ZodUnknown.create;
exports.unknown = unknownType;
const neverType = ZodNever.create;
exports.never = neverType;
const voidType = ZodVoid.create;
exports.void = voidType;
const arrayType = ZodArray.create;
exports.array = arrayType;
const objectType = ZodObject.create;
exports.object = objectType;
const strictObjectType = ZodObject.strictCreate;
exports.strictObject = strictObjectType;
const unionType = ZodUnion.create;
exports.union = unionType;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
exports.discriminatedUnion = discriminatedUnionType;
const intersectionType = ZodIntersection.create;
exports.intersection = intersectionType;
const tupleType = ZodTuple.create;
exports.tuple = tupleType;
const recordType = ZodRecord.create;
exports.record = recordType;
const mapType = ZodMap.create;
exports.map = mapType;
const setType = ZodSet.create;
exports.set = setType;
const functionType = ZodFunction.create;
exports.function = functionType;
const lazyType = ZodLazy.create;
exports.lazy = lazyType;
const literalType = ZodLiteral.create;
exports.literal = literalType;
const enumType = ZodEnum.create;
exports.enum = enumType;
const nativeEnumType = ZodNativeEnum.create;
exports.nativeEnum = nativeEnumType;
const promiseType = ZodPromise.create;
exports.promise = promiseType;
const effectsType = ZodEffects.create;
exports.effect = effectsType;
exports.transformer = effectsType;
const optionalType = ZodOptional.create;
exports.optional = optionalType;
const nullableType = ZodNullable.create;
exports.nullable = nullableType;
const preprocessType = ZodEffects.createWithPreprocess;
exports.preprocess = preprocessType;
const pipelineType = ZodPipeline.create;
exports.pipeline = pipelineType;
const ostring = ()=>stringType().optional();
exports.ostring = ostring;
const onumber = ()=>numberType().optional();
exports.onumber = onumber;
const oboolean = ()=>booleanType().optional();
exports.oboolean = oboolean;
exports.coerce = {
    string: (arg)=>ZodString.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>ZodNumber.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>ZodBoolean.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>ZodBigInt.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>ZodDate.create({
            ...arg,
            coerce: true
        })
};
exports.NEVER = parseUtil_js_1.INVALID;

},{"adbb2753d41a8ef":"i4PBZ","a63873d49bff3757":"2zU38","eb61d7a1b54f2edd":"ax8bJ","f5d51f4fc743f105":"1ANpf","5d51679e84f4812d":"gBcmo"}],"ax8bJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.errorUtil = void 0;
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})(errorUtil || (exports.errorUtil = errorUtil = {}));

},{}],"a8Anh":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
        }
        __setModuleDefault(result, mod);
        return result;
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AppBskyGraphGetBlocks = exports.AppBskyGraphGetActorStarterPacks = exports.AppBskyGraphFollow = exports.AppBskyGraphDefs = exports.AppBskyGraphBlock = exports.AppBskyFeedThreadgate = exports.AppBskyFeedSendInteractions = exports.AppBskyFeedSearchPosts = exports.AppBskyFeedRepost = exports.AppBskyFeedPostgate = exports.AppBskyFeedPost = exports.AppBskyFeedLike = exports.AppBskyFeedGetTimeline = exports.AppBskyFeedGetSuggestedFeeds = exports.AppBskyFeedGetRepostedBy = exports.AppBskyFeedGetQuotes = exports.AppBskyFeedGetPosts = exports.AppBskyFeedGetPostThread = exports.AppBskyFeedGetListFeed = exports.AppBskyFeedGetLikes = exports.AppBskyFeedGetFeedSkeleton = exports.AppBskyFeedGetFeedGenerators = exports.AppBskyFeedGetFeedGenerator = exports.AppBskyFeedGetFeed = exports.AppBskyFeedGetAuthorFeed = exports.AppBskyFeedGetActorLikes = exports.AppBskyFeedGetActorFeeds = exports.AppBskyFeedGenerator = exports.AppBskyFeedDescribeFeedGenerator = exports.AppBskyFeedDefs = exports.AppBskyEmbedVideo = exports.AppBskyEmbedRecordWithMedia = exports.AppBskyEmbedRecord = exports.AppBskyEmbedImages = exports.AppBskyEmbedExternal = exports.AppBskyEmbedDefs = exports.AppBskyBookmarkGetBookmarks = exports.AppBskyBookmarkDeleteBookmark = exports.AppBskyBookmarkDefs = exports.AppBskyBookmarkCreateBookmark = exports.AppBskyActorStatus = exports.AppBskyActorSearchActorsTypeahead = exports.AppBskyActorSearchActors = exports.AppBskyActorPutPreferences = exports.AppBskyActorProfile = exports.AppBskyActorGetSuggestions = exports.AppBskyActorGetProfiles = exports.AppBskyActorGetProfile = exports.AppBskyActorGetPreferences = exports.AppBskyActorDefs = void 0;
exports.AppBskyUnspeccedGetPostThreadV2 = exports.AppBskyUnspeccedGetPostThreadOtherV2 = exports.AppBskyUnspeccedGetPopularFeedGenerators = exports.AppBskyUnspeccedGetOnboardingSuggestedStarterPacksSkeleton = exports.AppBskyUnspeccedGetOnboardingSuggestedStarterPacks = exports.AppBskyUnspeccedGetConfig = exports.AppBskyUnspeccedGetAgeAssuranceState = exports.AppBskyUnspeccedDefs = exports.AppBskyRichtextFacet = exports.AppBskyNotificationUpdateSeen = exports.AppBskyNotificationUnregisterPush = exports.AppBskyNotificationRegisterPush = exports.AppBskyNotificationPutPreferencesV2 = exports.AppBskyNotificationPutPreferences = exports.AppBskyNotificationPutActivitySubscription = exports.AppBskyNotificationListNotifications = exports.AppBskyNotificationListActivitySubscriptions = exports.AppBskyNotificationGetUnreadCount = exports.AppBskyNotificationGetPreferences = exports.AppBskyNotificationDefs = exports.AppBskyNotificationDeclaration = exports.AppBskyLabelerService = exports.AppBskyLabelerGetServices = exports.AppBskyLabelerDefs = exports.AppBskyGraphVerification = exports.AppBskyGraphUnmuteThread = exports.AppBskyGraphUnmuteActorList = exports.AppBskyGraphUnmuteActor = exports.AppBskyGraphStarterpack = exports.AppBskyGraphSearchStarterPacks = exports.AppBskyGraphMuteThread = exports.AppBskyGraphMuteActorList = exports.AppBskyGraphMuteActor = exports.AppBskyGraphListitem = exports.AppBskyGraphListblock = exports.AppBskyGraphList = exports.AppBskyGraphGetSuggestedFollowsByActor = exports.AppBskyGraphGetStarterPacksWithMembership = exports.AppBskyGraphGetStarterPacks = exports.AppBskyGraphGetStarterPack = exports.AppBskyGraphGetRelationships = exports.AppBskyGraphGetMutes = exports.AppBskyGraphGetListsWithMembership = exports.AppBskyGraphGetLists = exports.AppBskyGraphGetListMutes = exports.AppBskyGraphGetListBlocks = exports.AppBskyGraphGetList = exports.AppBskyGraphGetKnownFollowers = exports.AppBskyGraphGetFollows = exports.AppBskyGraphGetFollowers = void 0;
exports.ComAtprotoAdminGetAccountInfo = exports.ComAtprotoAdminEnableAccountInvites = exports.ComAtprotoAdminDisableInviteCodes = exports.ComAtprotoAdminDisableAccountInvites = exports.ComAtprotoAdminDeleteAccount = exports.ComAtprotoAdminDefs = exports.ChatBskyModerationUpdateActorAccess = exports.ChatBskyModerationGetMessageContext = exports.ChatBskyModerationGetActorMetadata = exports.ChatBskyConvoUpdateRead = exports.ChatBskyConvoUpdateAllRead = exports.ChatBskyConvoUnmuteConvo = exports.ChatBskyConvoSendMessageBatch = exports.ChatBskyConvoSendMessage = exports.ChatBskyConvoRemoveReaction = exports.ChatBskyConvoMuteConvo = exports.ChatBskyConvoListConvos = exports.ChatBskyConvoLeaveConvo = exports.ChatBskyConvoGetMessages = exports.ChatBskyConvoGetLog = exports.ChatBskyConvoGetConvoForMembers = exports.ChatBskyConvoGetConvoAvailability = exports.ChatBskyConvoGetConvo = exports.ChatBskyConvoDeleteMessageForSelf = exports.ChatBskyConvoDefs = exports.ChatBskyConvoAddReaction = exports.ChatBskyConvoAcceptConvo = exports.ChatBskyActorExportAccountData = exports.ChatBskyActorDeleteAccount = exports.ChatBskyActorDefs = exports.ChatBskyActorDeclaration = exports.AppBskyVideoUploadVideo = exports.AppBskyVideoGetUploadLimits = exports.AppBskyVideoGetJobStatus = exports.AppBskyVideoDefs = exports.AppBskyUnspeccedSearchStarterPacksSkeleton = exports.AppBskyUnspeccedSearchPostsSkeleton = exports.AppBskyUnspeccedSearchActorsSkeleton = exports.AppBskyUnspeccedInitAgeAssurance = exports.AppBskyUnspeccedGetTrendsSkeleton = exports.AppBskyUnspeccedGetTrends = exports.AppBskyUnspeccedGetTrendingTopics = exports.AppBskyUnspeccedGetTaggedSuggestions = exports.AppBskyUnspeccedGetSuggestionsSkeleton = exports.AppBskyUnspeccedGetSuggestedUsersSkeleton = exports.AppBskyUnspeccedGetSuggestedUsers = exports.AppBskyUnspeccedGetSuggestedStarterPacksSkeleton = exports.AppBskyUnspeccedGetSuggestedStarterPacks = exports.AppBskyUnspeccedGetSuggestedFeedsSkeleton = exports.AppBskyUnspeccedGetSuggestedFeeds = void 0;
exports.ComAtprotoServerDeleteAccount = exports.ComAtprotoServerDefs = exports.ComAtprotoServerDeactivateAccount = exports.ComAtprotoServerCreateSession = exports.ComAtprotoServerCreateInviteCodes = exports.ComAtprotoServerCreateInviteCode = exports.ComAtprotoServerCreateCustomJwtSession = exports.ComAtprotoServerCreateAppPassword = exports.ComAtprotoServerCreateAccount = exports.ComAtprotoServerConfirmEmail = exports.ComAtprotoServerCheckAccountStatus = exports.ComAtprotoServerActivateAccount = exports.ComAtprotoRepoUploadBlob = exports.ComAtprotoRepoStrongRef = exports.ComAtprotoRepoPutRecord = exports.ComAtprotoRepoListRecords = exports.ComAtprotoRepoListMissingBlobs = exports.ComAtprotoRepoImportRepo = exports.ComAtprotoRepoGetRecord = exports.ComAtprotoRepoDescribeRepo = exports.ComAtprotoRepoDeleteRecord = exports.ComAtprotoRepoDefs = exports.ComAtprotoRepoCreateRecord = exports.ComAtprotoRepoApplyWrites = exports.ComAtprotoModerationDefs = exports.ComAtprotoModerationCreateReport = exports.ComAtprotoLexiconSchema = exports.ComAtprotoLabelSubscribeLabels = exports.ComAtprotoLabelQueryLabels = exports.ComAtprotoLabelDefs = exports.ComAtprotoIdentityUpdateHandle = exports.ComAtprotoIdentitySubmitPlcOperation = exports.ComAtprotoIdentitySignPlcOperation = exports.ComAtprotoIdentityResolveIdentity = exports.ComAtprotoIdentityResolveHandle = exports.ComAtprotoIdentityResolveDid = exports.ComAtprotoIdentityRequestPlcOperationSignature = exports.ComAtprotoIdentityRefreshIdentity = exports.ComAtprotoIdentityGetRecommendedDidCredentials = exports.ComAtprotoIdentityDefs = exports.ComAtprotoAdminUpdateSubjectStatus = exports.ComAtprotoAdminUpdateAccountSigningKey = exports.ComAtprotoAdminUpdateAccountPassword = exports.ComAtprotoAdminUpdateAccountHandle = exports.ComAtprotoAdminUpdateAccountEmail = exports.ComAtprotoAdminSendEmail = exports.ComAtprotoAdminSearchAccounts = exports.ComAtprotoAdminGetSubjectStatus = exports.ComAtprotoAdminGetInviteCodes = exports.ComAtprotoAdminGetAccountInfos = void 0;
exports.ToolsOzoneModerationGetEvent = exports.ToolsOzoneModerationGetAccountTimeline = exports.ToolsOzoneModerationEmitEvent = exports.ToolsOzoneModerationDefs = exports.ToolsOzoneModerationCancelScheduledActions = exports.ToolsOzoneHostingGetAccountHistory = exports.ToolsOzoneCommunicationUpdateTemplate = exports.ToolsOzoneCommunicationListTemplates = exports.ToolsOzoneCommunicationDeleteTemplate = exports.ToolsOzoneCommunicationDefs = exports.ToolsOzoneCommunicationCreateTemplate = exports.ComAtprotoTempRevokeAccountCredentials = exports.ComAtprotoTempRequestPhoneVerification = exports.ComAtprotoTempFetchLabels = exports.ComAtprotoTempDereferenceScope = exports.ComAtprotoTempCheckSignupQueue = exports.ComAtprotoTempCheckHandleAvailability = exports.ComAtprotoTempAddReservedHandle = exports.ComAtprotoSyncSubscribeRepos = exports.ComAtprotoSyncRequestCrawl = exports.ComAtprotoSyncNotifyOfUpdate = exports.ComAtprotoSyncListReposByCollection = exports.ComAtprotoSyncListRepos = exports.ComAtprotoSyncListHosts = exports.ComAtprotoSyncListBlobs = exports.ComAtprotoSyncGetRepoStatus = exports.ComAtprotoSyncGetRepo = exports.ComAtprotoSyncGetRecord = exports.ComAtprotoSyncGetLatestCommit = exports.ComAtprotoSyncGetHostStatus = exports.ComAtprotoSyncGetHead = exports.ComAtprotoSyncGetCheckout = exports.ComAtprotoSyncGetBlocks = exports.ComAtprotoSyncGetBlob = exports.ComAtprotoSyncDefs = exports.ComAtprotoServerUpdateEmail = exports.ComAtprotoServerRevokeAppPassword = exports.ComAtprotoServerResetPassword = exports.ComAtprotoServerReserveSigningKey = exports.ComAtprotoServerRequestPasswordReset = exports.ComAtprotoServerRequestEmailUpdate = exports.ComAtprotoServerRequestEmailConfirmation = exports.ComAtprotoServerRequestAccountDelete = exports.ComAtprotoServerRefreshSession = exports.ComAtprotoServerListAppPasswords = exports.ComAtprotoServerGetSession = exports.ComAtprotoServerGetServiceAuth = exports.ComAtprotoServerGetAccountInviteCodes = exports.ComAtprotoServerDescribeServer = exports.ComAtprotoServerDeleteSession = void 0;
exports.TOOLS_OZONE_TEAM = exports.TOOLS_OZONE_REPORT = exports.TOOLS_OZONE_MODERATION = exports.COM_ATPROTO_MODERATION = exports.APP_BSKY_GRAPH = exports.APP_BSKY_FEED = exports.APP_BSKY_ACTOR = exports.ToolsOzoneVerificationRevokeVerifications = exports.ToolsOzoneVerificationListVerifications = exports.ToolsOzoneVerificationGrantVerifications = exports.ToolsOzoneVerificationDefs = exports.ToolsOzoneTeamUpdateMember = exports.ToolsOzoneTeamListMembers = exports.ToolsOzoneTeamDeleteMember = exports.ToolsOzoneTeamDefs = exports.ToolsOzoneTeamAddMember = exports.ToolsOzoneSignatureSearchAccounts = exports.ToolsOzoneSignatureFindRelatedAccounts = exports.ToolsOzoneSignatureFindCorrelation = exports.ToolsOzoneSignatureDefs = exports.ToolsOzoneSettingUpsertOption = exports.ToolsOzoneSettingRemoveOptions = exports.ToolsOzoneSettingListOptions = exports.ToolsOzoneSettingDefs = exports.ToolsOzoneSetUpsertSet = exports.ToolsOzoneSetQuerySets = exports.ToolsOzoneSetGetValues = exports.ToolsOzoneSetDeleteValues = exports.ToolsOzoneSetDeleteSet = exports.ToolsOzoneSetDefs = exports.ToolsOzoneSetAddValues = exports.ToolsOzoneServerGetConfig = exports.ToolsOzoneSafelinkUpdateRule = exports.ToolsOzoneSafelinkRemoveRule = exports.ToolsOzoneSafelinkQueryRules = exports.ToolsOzoneSafelinkQueryEvents = exports.ToolsOzoneSafelinkDefs = exports.ToolsOzoneSafelinkAddRule = exports.ToolsOzoneReportDefs = exports.ToolsOzoneModerationSearchRepos = exports.ToolsOzoneModerationScheduleAction = exports.ToolsOzoneModerationQueryStatuses = exports.ToolsOzoneModerationQueryEvents = exports.ToolsOzoneModerationListScheduledActions = exports.ToolsOzoneModerationGetSubjects = exports.ToolsOzoneModerationGetRepos = exports.ToolsOzoneModerationGetReporterStats = exports.ToolsOzoneModerationGetRepo = exports.ToolsOzoneModerationGetRecords = exports.ToolsOzoneModerationGetRecord = void 0;
exports.ToolsOzoneNS = exports.ToolsNS = exports.ComAtprotoTempNS = exports.ComAtprotoSyncNS = exports.ComAtprotoServerNS = exports.ComAtprotoRepoNS = exports.ComAtprotoModerationNS = exports.ComAtprotoLexiconSchemaRecord = exports.ComAtprotoLexiconNS = exports.ComAtprotoLabelNS = exports.ComAtprotoIdentityNS = exports.ComAtprotoAdminNS = exports.ComAtprotoNS = exports.ComNS = exports.ChatBskyModerationNS = exports.ChatBskyConvoNS = exports.ChatBskyActorDeclarationRecord = exports.ChatBskyActorNS = exports.ChatBskyNS = exports.ChatNS = exports.AppBskyVideoNS = exports.AppBskyUnspeccedNS = exports.AppBskyRichtextNS = exports.AppBskyNotificationDeclarationRecord = exports.AppBskyNotificationNS = exports.AppBskyLabelerServiceRecord = exports.AppBskyLabelerNS = exports.AppBskyGraphVerificationRecord = exports.AppBskyGraphStarterpackRecord = exports.AppBskyGraphListitemRecord = exports.AppBskyGraphListblockRecord = exports.AppBskyGraphListRecord = exports.AppBskyGraphFollowRecord = exports.AppBskyGraphBlockRecord = exports.AppBskyGraphNS = exports.AppBskyFeedThreadgateRecord = exports.AppBskyFeedRepostRecord = exports.AppBskyFeedPostgateRecord = exports.AppBskyFeedPostRecord = exports.AppBskyFeedLikeRecord = exports.AppBskyFeedGeneratorRecord = exports.AppBskyFeedNS = exports.AppBskyEmbedNS = exports.AppBskyBookmarkNS = exports.AppBskyActorStatusRecord = exports.AppBskyActorProfileRecord = exports.AppBskyActorNS = exports.AppBskyNS = exports.AppNS = exports.AtpBaseClient = void 0;
exports.ToolsOzoneVerificationNS = exports.ToolsOzoneTeamNS = exports.ToolsOzoneSignatureNS = exports.ToolsOzoneSettingNS = exports.ToolsOzoneSetNS = exports.ToolsOzoneServerNS = exports.ToolsOzoneSafelinkNS = exports.ToolsOzoneModerationNS = exports.ToolsOzoneHostingNS = exports.ToolsOzoneCommunicationNS = void 0;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("5b1cb0c8a2c6c556");
const lexicons_js_1 = require("4a480041bf85d273");
const AppBskyBookmarkCreateBookmark = __importStar(require("dc80e21f29507626"));
const AppBskyBookmarkDeleteBookmark = __importStar(require("e6c3a17e90d55fd8"));
const AppBskyFeedGetActorLikes = __importStar(require("167f6379847b390"));
const AppBskyFeedGetAuthorFeed = __importStar(require("2397d032dc139d25"));
const AppBskyFeedGetFeed = __importStar(require("1629084e1eb1ef2b"));
const AppBskyFeedGetFeedSkeleton = __importStar(require("9027d24e35207ac4"));
const AppBskyFeedGetListFeed = __importStar(require("e885adb39cb619b8"));
const AppBskyFeedGetPostThread = __importStar(require("6840540394c1a961"));
const AppBskyFeedSearchPosts = __importStar(require("3f723a3f7d3b5ce6"));
const AppBskyGraphGetRelationships = __importStar(require("f2518ec5a3a4dd8b"));
const AppBskyUnspeccedInitAgeAssurance = __importStar(require("1e3e5b969aa9b8e6"));
const AppBskyUnspeccedSearchActorsSkeleton = __importStar(require("52f91ac520a4d3ea"));
const AppBskyUnspeccedSearchPostsSkeleton = __importStar(require("e8fb82ed0c581d47"));
const AppBskyUnspeccedSearchStarterPacksSkeleton = __importStar(require("9d32d58b0ef08209"));
const ChatBskyConvoAddReaction = __importStar(require("4cd67407124f68a5"));
const ChatBskyConvoRemoveReaction = __importStar(require("a70c562109b81fcd"));
const ComAtprotoIdentityRefreshIdentity = __importStar(require("9f69a63c4c2d93d7"));
const ComAtprotoIdentityResolveDid = __importStar(require("8b0a2d57dd1dc651"));
const ComAtprotoIdentityResolveHandle = __importStar(require("f97a0107051ac852"));
const ComAtprotoIdentityResolveIdentity = __importStar(require("ae93e8c57ae9c299"));
const ComAtprotoRepoApplyWrites = __importStar(require("a43fb793d668ec02"));
const ComAtprotoRepoCreateRecord = __importStar(require("766f66d9a3fd6728"));
const ComAtprotoRepoDeleteRecord = __importStar(require("db79bcc33d4be3a6"));
const ComAtprotoRepoGetRecord = __importStar(require("815bbc3ffebea408"));
const ComAtprotoRepoPutRecord = __importStar(require("e501a9cd82565848"));
const ComAtprotoServerConfirmEmail = __importStar(require("cb62e7808a4d564"));
const ComAtprotoServerCreateAccount = __importStar(require("90690a38251be7ab"));
const ComAtprotoServerCreateAppPassword = __importStar(require("faa2ae7a02083c9"));
const ComAtprotoServerCreateCustomJwtSession = __importStar(require("a5405150917559b8"));
const ComAtprotoServerCreateSession = __importStar(require("4d69f0e13fff815"));
const ComAtprotoServerDeleteAccount = __importStar(require("c287c2c6352607d0"));
const ComAtprotoServerGetAccountInviteCodes = __importStar(require("4278c46f41b0b8e8"));
const ComAtprotoServerGetServiceAuth = __importStar(require("df7be3b318b0abb2"));
const ComAtprotoServerListAppPasswords = __importStar(require("3df541c59279f028"));
const ComAtprotoServerRefreshSession = __importStar(require("e871c6c23ce4d72c"));
const ComAtprotoServerResetPassword = __importStar(require("9e2b7b051eef2a08"));
const ComAtprotoServerUpdateEmail = __importStar(require("310de8020ac35b1f"));
const ComAtprotoSyncGetBlob = __importStar(require("b46eef6a7b953826"));
const ComAtprotoSyncGetBlocks = __importStar(require("afbf0f6a40841488"));
const ComAtprotoSyncGetHead = __importStar(require("812f68c1311c8d21"));
const ComAtprotoSyncGetHostStatus = __importStar(require("92367178757cb63f"));
const ComAtprotoSyncGetLatestCommit = __importStar(require("bb626ab6038c3016"));
const ComAtprotoSyncGetRecord = __importStar(require("de4419b219788732"));
const ComAtprotoSyncGetRepo = __importStar(require("78f72b0385da6b74"));
const ComAtprotoSyncGetRepoStatus = __importStar(require("5b5c453a4cd13c3e"));
const ComAtprotoSyncListBlobs = __importStar(require("22f75326edbc016f"));
const ComAtprotoSyncRequestCrawl = __importStar(require("df19566a34724a91"));
const ComAtprotoTempCheckHandleAvailability = __importStar(require("ca222c96438db773"));
const ComAtprotoTempDereferenceScope = __importStar(require("eb81d423eaf73127"));
const ToolsOzoneCommunicationCreateTemplate = __importStar(require("7716f19a3ed6bb54"));
const ToolsOzoneCommunicationUpdateTemplate = __importStar(require("6aa8b1d145cc42c0"));
const ToolsOzoneModerationEmitEvent = __importStar(require("2c0506b198454861"));
const ToolsOzoneModerationGetAccountTimeline = __importStar(require("702871d69330373b"));
const ToolsOzoneModerationGetRecord = __importStar(require("ab9070dfc7a624e7"));
const ToolsOzoneModerationGetRepo = __importStar(require("3eb16909f4c37f1c"));
const ToolsOzoneSafelinkAddRule = __importStar(require("9ff9adbbc09df2fd"));
const ToolsOzoneSafelinkRemoveRule = __importStar(require("c107c422a2d48691"));
const ToolsOzoneSafelinkUpdateRule = __importStar(require("10539fcb7fee110a"));
const ToolsOzoneSetDeleteSet = __importStar(require("978f382424658b9e"));
const ToolsOzoneSetDeleteValues = __importStar(require("41fd180fa0c18902"));
const ToolsOzoneSetGetValues = __importStar(require("9a5198cdb748f50b"));
const ToolsOzoneTeamAddMember = __importStar(require("3a590041db175bce"));
const ToolsOzoneTeamDeleteMember = __importStar(require("7936d0860528d93a"));
const ToolsOzoneTeamUpdateMember = __importStar(require("8b83da9c4685102d"));
exports.AppBskyActorDefs = __importStar(require("2d686b80e9529927"));
exports.AppBskyActorGetPreferences = __importStar(require("48f0f9f48461ae8"));
exports.AppBskyActorGetProfile = __importStar(require("947416b2e5ac047e"));
exports.AppBskyActorGetProfiles = __importStar(require("d7a81c965cacb653"));
exports.AppBskyActorGetSuggestions = __importStar(require("e31966189d7b75be"));
exports.AppBskyActorProfile = __importStar(require("102aa5879aaec3c8"));
exports.AppBskyActorPutPreferences = __importStar(require("171affd6e290adc1"));
exports.AppBskyActorSearchActors = __importStar(require("5b428b95aec07fe6"));
exports.AppBskyActorSearchActorsTypeahead = __importStar(require("980dc3a902f7999a"));
exports.AppBskyActorStatus = __importStar(require("e5ccba9b3a3718de"));
exports.AppBskyBookmarkCreateBookmark = __importStar(require("dc80e21f29507626"));
exports.AppBskyBookmarkDefs = __importStar(require("3277c19dae3de398"));
exports.AppBskyBookmarkDeleteBookmark = __importStar(require("e6c3a17e90d55fd8"));
exports.AppBskyBookmarkGetBookmarks = __importStar(require("f3afd6596c73f2dc"));
exports.AppBskyEmbedDefs = __importStar(require("ec1d8dbd32c93c6e"));
exports.AppBskyEmbedExternal = __importStar(require("7735018159ddcf1f"));
exports.AppBskyEmbedImages = __importStar(require("6aa4afaaff005352"));
exports.AppBskyEmbedRecord = __importStar(require("8ee3953cd5ddeecb"));
exports.AppBskyEmbedRecordWithMedia = __importStar(require("43ecbfee2849591c"));
exports.AppBskyEmbedVideo = __importStar(require("f169c60df28b509d"));
exports.AppBskyFeedDefs = __importStar(require("4f668ebca80f5bde"));
exports.AppBskyFeedDescribeFeedGenerator = __importStar(require("3aad549558d5cdd8"));
exports.AppBskyFeedGenerator = __importStar(require("f25a7aac19174c36"));
exports.AppBskyFeedGetActorFeeds = __importStar(require("c335133809446777"));
exports.AppBskyFeedGetActorLikes = __importStar(require("167f6379847b390"));
exports.AppBskyFeedGetAuthorFeed = __importStar(require("2397d032dc139d25"));
exports.AppBskyFeedGetFeed = __importStar(require("1629084e1eb1ef2b"));
exports.AppBskyFeedGetFeedGenerator = __importStar(require("f5279241d33c9f19"));
exports.AppBskyFeedGetFeedGenerators = __importStar(require("16dfb640a04309ba"));
exports.AppBskyFeedGetFeedSkeleton = __importStar(require("9027d24e35207ac4"));
exports.AppBskyFeedGetLikes = __importStar(require("b2eef4fcea42b90a"));
exports.AppBskyFeedGetListFeed = __importStar(require("e885adb39cb619b8"));
exports.AppBskyFeedGetPostThread = __importStar(require("6840540394c1a961"));
exports.AppBskyFeedGetPosts = __importStar(require("557eef132a1dddff"));
exports.AppBskyFeedGetQuotes = __importStar(require("575322c47bceab29"));
exports.AppBskyFeedGetRepostedBy = __importStar(require("a2d2dded80247133"));
exports.AppBskyFeedGetSuggestedFeeds = __importStar(require("cbfb4ecbac35418e"));
exports.AppBskyFeedGetTimeline = __importStar(require("21f35c558efbe8d4"));
exports.AppBskyFeedLike = __importStar(require("55d971bd76eeeb74"));
exports.AppBskyFeedPost = __importStar(require("1696e8f7b2bfb333"));
exports.AppBskyFeedPostgate = __importStar(require("230c00356d666010"));
exports.AppBskyFeedRepost = __importStar(require("371c539f9a600a51"));
exports.AppBskyFeedSearchPosts = __importStar(require("3f723a3f7d3b5ce6"));
exports.AppBskyFeedSendInteractions = __importStar(require("b617fb90d5d4a633"));
exports.AppBskyFeedThreadgate = __importStar(require("f37d9accf8c762b9"));
exports.AppBskyGraphBlock = __importStar(require("b17dc45682936c2f"));
exports.AppBskyGraphDefs = __importStar(require("65993a8a65c778b4"));
exports.AppBskyGraphFollow = __importStar(require("f2ffba85f63b7f23"));
exports.AppBskyGraphGetActorStarterPacks = __importStar(require("8b4c57d4b15b4e9a"));
exports.AppBskyGraphGetBlocks = __importStar(require("de202866d04ad9e0"));
exports.AppBskyGraphGetFollowers = __importStar(require("fe4ad919b53a7ed4"));
exports.AppBskyGraphGetFollows = __importStar(require("c45c957d412c07e2"));
exports.AppBskyGraphGetKnownFollowers = __importStar(require("7a14f32d83cb9aa2"));
exports.AppBskyGraphGetList = __importStar(require("b8279366350b9069"));
exports.AppBskyGraphGetListBlocks = __importStar(require("fcf00b174d06b0e0"));
exports.AppBskyGraphGetListMutes = __importStar(require("6afd728a21390908"));
exports.AppBskyGraphGetLists = __importStar(require("cda8da0ffba5b846"));
exports.AppBskyGraphGetListsWithMembership = __importStar(require("76271026fe3bb25"));
exports.AppBskyGraphGetMutes = __importStar(require("b0cf74d7c933c678"));
exports.AppBskyGraphGetRelationships = __importStar(require("f2518ec5a3a4dd8b"));
exports.AppBskyGraphGetStarterPack = __importStar(require("11688f38d2127ea9"));
exports.AppBskyGraphGetStarterPacks = __importStar(require("609c761c1787a800"));
exports.AppBskyGraphGetStarterPacksWithMembership = __importStar(require("f115a352d5c3b20d"));
exports.AppBskyGraphGetSuggestedFollowsByActor = __importStar(require("21457739d1ffc497"));
exports.AppBskyGraphList = __importStar(require("89c54d933792f810"));
exports.AppBskyGraphListblock = __importStar(require("41ea0596d2681034"));
exports.AppBskyGraphListitem = __importStar(require("9be69a92bd0c3614"));
exports.AppBskyGraphMuteActor = __importStar(require("83735652a9020b25"));
exports.AppBskyGraphMuteActorList = __importStar(require("22b7652370f78038"));
exports.AppBskyGraphMuteThread = __importStar(require("d241d321490c09d8"));
exports.AppBskyGraphSearchStarterPacks = __importStar(require("32956f5e1ebbcb75"));
exports.AppBskyGraphStarterpack = __importStar(require("6109559b6946d060"));
exports.AppBskyGraphUnmuteActor = __importStar(require("861bcce6a43bef9b"));
exports.AppBskyGraphUnmuteActorList = __importStar(require("1ae47b85361d7ec5"));
exports.AppBskyGraphUnmuteThread = __importStar(require("9a4ae81c6bd19a72"));
exports.AppBskyGraphVerification = __importStar(require("b5b6bcbd2a62f69"));
exports.AppBskyLabelerDefs = __importStar(require("c7e2890635f8f5e5"));
exports.AppBskyLabelerGetServices = __importStar(require("f2f5dfc9d4fbf7cd"));
exports.AppBskyLabelerService = __importStar(require("8e43dae95283a5ea"));
exports.AppBskyNotificationDeclaration = __importStar(require("5a3bf298c1f789ac"));
exports.AppBskyNotificationDefs = __importStar(require("30e27d250ae8c353"));
exports.AppBskyNotificationGetPreferences = __importStar(require("f50c7eba7f308af7"));
exports.AppBskyNotificationGetUnreadCount = __importStar(require("50fc26c3e8e2797b"));
exports.AppBskyNotificationListActivitySubscriptions = __importStar(require("2aa5faef45744bf9"));
exports.AppBskyNotificationListNotifications = __importStar(require("dab67a2f92aa3eab"));
exports.AppBskyNotificationPutActivitySubscription = __importStar(require("401764d482ac3c83"));
exports.AppBskyNotificationPutPreferences = __importStar(require("a03547755080275e"));
exports.AppBskyNotificationPutPreferencesV2 = __importStar(require("160e3b60af3762b6"));
exports.AppBskyNotificationRegisterPush = __importStar(require("5d5cc6cf81a2405c"));
exports.AppBskyNotificationUnregisterPush = __importStar(require("b36fa7fb230114f4"));
exports.AppBskyNotificationUpdateSeen = __importStar(require("15fe0e7174562923"));
exports.AppBskyRichtextFacet = __importStar(require("b80e56ccee14de59"));
exports.AppBskyUnspeccedDefs = __importStar(require("c4efa2c99d57c044"));
exports.AppBskyUnspeccedGetAgeAssuranceState = __importStar(require("7174b5edaadc3539"));
exports.AppBskyUnspeccedGetConfig = __importStar(require("f8de1ad4d39d28ea"));
exports.AppBskyUnspeccedGetOnboardingSuggestedStarterPacks = __importStar(require("e94353a12648d08a"));
exports.AppBskyUnspeccedGetOnboardingSuggestedStarterPacksSkeleton = __importStar(require("b2a22d6542847888"));
exports.AppBskyUnspeccedGetPopularFeedGenerators = __importStar(require("9b6b8ac0dd388661"));
exports.AppBskyUnspeccedGetPostThreadOtherV2 = __importStar(require("5ba812c500a72468"));
exports.AppBskyUnspeccedGetPostThreadV2 = __importStar(require("595e34f92964a020"));
exports.AppBskyUnspeccedGetSuggestedFeeds = __importStar(require("205561f7796d5f41"));
exports.AppBskyUnspeccedGetSuggestedFeedsSkeleton = __importStar(require("27cbb04db8248e2c"));
exports.AppBskyUnspeccedGetSuggestedStarterPacks = __importStar(require("4978ce73f6b00cba"));
exports.AppBskyUnspeccedGetSuggestedStarterPacksSkeleton = __importStar(require("d316cc3a7ba72e34"));
exports.AppBskyUnspeccedGetSuggestedUsers = __importStar(require("53c37a8133451f98"));
exports.AppBskyUnspeccedGetSuggestedUsersSkeleton = __importStar(require("494f3fe1236c9ec5"));
exports.AppBskyUnspeccedGetSuggestionsSkeleton = __importStar(require("d6d9c737f4405968"));
exports.AppBskyUnspeccedGetTaggedSuggestions = __importStar(require("d55d30f4eaf5d58b"));
exports.AppBskyUnspeccedGetTrendingTopics = __importStar(require("ee5b45debe4a5f7d"));
exports.AppBskyUnspeccedGetTrends = __importStar(require("7e037ed0e08bfb36"));
exports.AppBskyUnspeccedGetTrendsSkeleton = __importStar(require("f0def9a7d3a81533"));
exports.AppBskyUnspeccedInitAgeAssurance = __importStar(require("1e3e5b969aa9b8e6"));
exports.AppBskyUnspeccedSearchActorsSkeleton = __importStar(require("52f91ac520a4d3ea"));
exports.AppBskyUnspeccedSearchPostsSkeleton = __importStar(require("e8fb82ed0c581d47"));
exports.AppBskyUnspeccedSearchStarterPacksSkeleton = __importStar(require("9d32d58b0ef08209"));
exports.AppBskyVideoDefs = __importStar(require("bfb292a58739b55b"));
exports.AppBskyVideoGetJobStatus = __importStar(require("2d1ab10d229dece7"));
exports.AppBskyVideoGetUploadLimits = __importStar(require("547b57acf41c1a48"));
exports.AppBskyVideoUploadVideo = __importStar(require("70f108bdf5bf1bba"));
exports.ChatBskyActorDeclaration = __importStar(require("b165def850aeb31b"));
exports.ChatBskyActorDefs = __importStar(require("3e602d7e4606cd91"));
exports.ChatBskyActorDeleteAccount = __importStar(require("2d41b6ce683ce393"));
exports.ChatBskyActorExportAccountData = __importStar(require("70022b39f37a2a28"));
exports.ChatBskyConvoAcceptConvo = __importStar(require("2dbd20c037f8718a"));
exports.ChatBskyConvoAddReaction = __importStar(require("4cd67407124f68a5"));
exports.ChatBskyConvoDefs = __importStar(require("913e61e8b232b503"));
exports.ChatBskyConvoDeleteMessageForSelf = __importStar(require("9dcf10c01d99fcd2"));
exports.ChatBskyConvoGetConvo = __importStar(require("d562080fd27fe165"));
exports.ChatBskyConvoGetConvoAvailability = __importStar(require("f846777691160d1"));
exports.ChatBskyConvoGetConvoForMembers = __importStar(require("bd86e664a3bb847e"));
exports.ChatBskyConvoGetLog = __importStar(require("8e671bb7e08459ad"));
exports.ChatBskyConvoGetMessages = __importStar(require("375ad1e9ed04bdae"));
exports.ChatBskyConvoLeaveConvo = __importStar(require("57fe03cd07448fa4"));
exports.ChatBskyConvoListConvos = __importStar(require("94d7eba3961773ae"));
exports.ChatBskyConvoMuteConvo = __importStar(require("77ce1af28bdaeb45"));
exports.ChatBskyConvoRemoveReaction = __importStar(require("a70c562109b81fcd"));
exports.ChatBskyConvoSendMessage = __importStar(require("a43b4864c268aff"));
exports.ChatBskyConvoSendMessageBatch = __importStar(require("48df3cfcb24cda0b"));
exports.ChatBskyConvoUnmuteConvo = __importStar(require("42600f25a5b134f5"));
exports.ChatBskyConvoUpdateAllRead = __importStar(require("f51ee0af7366a288"));
exports.ChatBskyConvoUpdateRead = __importStar(require("22090fcd02c4f57d"));
exports.ChatBskyModerationGetActorMetadata = __importStar(require("2e76328acc1b9bea"));
exports.ChatBskyModerationGetMessageContext = __importStar(require("fd01341d3976280e"));
exports.ChatBskyModerationUpdateActorAccess = __importStar(require("7573dba73a41a821"));
exports.ComAtprotoAdminDefs = __importStar(require("21a33b7cf74da1e0"));
exports.ComAtprotoAdminDeleteAccount = __importStar(require("8dc306f426693caf"));
exports.ComAtprotoAdminDisableAccountInvites = __importStar(require("230a127e41b707e8"));
exports.ComAtprotoAdminDisableInviteCodes = __importStar(require("7ff0f63d415a8ec9"));
exports.ComAtprotoAdminEnableAccountInvites = __importStar(require("bd6157f536f2e10"));
exports.ComAtprotoAdminGetAccountInfo = __importStar(require("d1fd574a1fd8b88c"));
exports.ComAtprotoAdminGetAccountInfos = __importStar(require("9e26ded5da192d26"));
exports.ComAtprotoAdminGetInviteCodes = __importStar(require("6c1664347c6a05c6"));
exports.ComAtprotoAdminGetSubjectStatus = __importStar(require("7164708dfd4d2726"));
exports.ComAtprotoAdminSearchAccounts = __importStar(require("628f5e2260ce1bd4"));
exports.ComAtprotoAdminSendEmail = __importStar(require("e299490f64845729"));
exports.ComAtprotoAdminUpdateAccountEmail = __importStar(require("4acd501d206e1713"));
exports.ComAtprotoAdminUpdateAccountHandle = __importStar(require("a9c096dba1535960"));
exports.ComAtprotoAdminUpdateAccountPassword = __importStar(require("bdc00eaa6cc74729"));
exports.ComAtprotoAdminUpdateAccountSigningKey = __importStar(require("a165d6fc57d7fd7d"));
exports.ComAtprotoAdminUpdateSubjectStatus = __importStar(require("9775c3fa102b4b31"));
exports.ComAtprotoIdentityDefs = __importStar(require("2994bf710f027aeb"));
exports.ComAtprotoIdentityGetRecommendedDidCredentials = __importStar(require("9922f080934f4653"));
exports.ComAtprotoIdentityRefreshIdentity = __importStar(require("9f69a63c4c2d93d7"));
exports.ComAtprotoIdentityRequestPlcOperationSignature = __importStar(require("56d9ed01e20a9277"));
exports.ComAtprotoIdentityResolveDid = __importStar(require("8b0a2d57dd1dc651"));
exports.ComAtprotoIdentityResolveHandle = __importStar(require("f97a0107051ac852"));
exports.ComAtprotoIdentityResolveIdentity = __importStar(require("ae93e8c57ae9c299"));
exports.ComAtprotoIdentitySignPlcOperation = __importStar(require("8b84df95136dc859"));
exports.ComAtprotoIdentitySubmitPlcOperation = __importStar(require("cbad5192d1c72b7c"));
exports.ComAtprotoIdentityUpdateHandle = __importStar(require("a019bd9b4d4c5c28"));
exports.ComAtprotoLabelDefs = __importStar(require("4855f09c0ee8d78d"));
exports.ComAtprotoLabelQueryLabels = __importStar(require("43740260f8e8d7c5"));
exports.ComAtprotoLabelSubscribeLabels = __importStar(require("7ce12eb244eed6bf"));
exports.ComAtprotoLexiconSchema = __importStar(require("edadfee595d0ba67"));
exports.ComAtprotoModerationCreateReport = __importStar(require("45feda9c05751043"));
exports.ComAtprotoModerationDefs = __importStar(require("69671cf4259d4a07"));
exports.ComAtprotoRepoApplyWrites = __importStar(require("a43fb793d668ec02"));
exports.ComAtprotoRepoCreateRecord = __importStar(require("766f66d9a3fd6728"));
exports.ComAtprotoRepoDefs = __importStar(require("4e62b49d1b8f71a6"));
exports.ComAtprotoRepoDeleteRecord = __importStar(require("db79bcc33d4be3a6"));
exports.ComAtprotoRepoDescribeRepo = __importStar(require("226bb6d8a532872"));
exports.ComAtprotoRepoGetRecord = __importStar(require("815bbc3ffebea408"));
exports.ComAtprotoRepoImportRepo = __importStar(require("491928e4097d220b"));
exports.ComAtprotoRepoListMissingBlobs = __importStar(require("140152ec7b28ad81"));
exports.ComAtprotoRepoListRecords = __importStar(require("9bbe8e7601a85abb"));
exports.ComAtprotoRepoPutRecord = __importStar(require("e501a9cd82565848"));
exports.ComAtprotoRepoStrongRef = __importStar(require("199672845afeefd8"));
exports.ComAtprotoRepoUploadBlob = __importStar(require("9ba7202c173ed173"));
exports.ComAtprotoServerActivateAccount = __importStar(require("2b76d5b99bddd24a"));
exports.ComAtprotoServerCheckAccountStatus = __importStar(require("6e4ab8648e933e16"));
exports.ComAtprotoServerConfirmEmail = __importStar(require("cb62e7808a4d564"));
exports.ComAtprotoServerCreateAccount = __importStar(require("90690a38251be7ab"));
exports.ComAtprotoServerCreateAppPassword = __importStar(require("faa2ae7a02083c9"));
exports.ComAtprotoServerCreateCustomJwtSession = __importStar(require("a5405150917559b8"));
exports.ComAtprotoServerCreateInviteCode = __importStar(require("498f1c63441aab5e"));
exports.ComAtprotoServerCreateInviteCodes = __importStar(require("b94f9a954a9946c7"));
exports.ComAtprotoServerCreateSession = __importStar(require("4d69f0e13fff815"));
exports.ComAtprotoServerDeactivateAccount = __importStar(require("c0983ac3f52bdb79"));
exports.ComAtprotoServerDefs = __importStar(require("321204f18c55d6d0"));
exports.ComAtprotoServerDeleteAccount = __importStar(require("c287c2c6352607d0"));
exports.ComAtprotoServerDeleteSession = __importStar(require("403f62f897d56340"));
exports.ComAtprotoServerDescribeServer = __importStar(require("d2a9e5a330fc3cd8"));
exports.ComAtprotoServerGetAccountInviteCodes = __importStar(require("4278c46f41b0b8e8"));
exports.ComAtprotoServerGetServiceAuth = __importStar(require("df7be3b318b0abb2"));
exports.ComAtprotoServerGetSession = __importStar(require("cecfc71aa76224dd"));
exports.ComAtprotoServerListAppPasswords = __importStar(require("3df541c59279f028"));
exports.ComAtprotoServerRefreshSession = __importStar(require("e871c6c23ce4d72c"));
exports.ComAtprotoServerRequestAccountDelete = __importStar(require("4629614dbcb4ae8e"));
exports.ComAtprotoServerRequestEmailConfirmation = __importStar(require("9fd5cecf6b0fb93"));
exports.ComAtprotoServerRequestEmailUpdate = __importStar(require("55602c01fd210f9a"));
exports.ComAtprotoServerRequestPasswordReset = __importStar(require("8ba753ede2c6cb5b"));
exports.ComAtprotoServerReserveSigningKey = __importStar(require("42506f480bfae2a0"));
exports.ComAtprotoServerResetPassword = __importStar(require("9e2b7b051eef2a08"));
exports.ComAtprotoServerRevokeAppPassword = __importStar(require("fbef7c8ae0d27b20"));
exports.ComAtprotoServerUpdateEmail = __importStar(require("310de8020ac35b1f"));
exports.ComAtprotoSyncDefs = __importStar(require("4eccf3f89bbbbf4f"));
exports.ComAtprotoSyncGetBlob = __importStar(require("b46eef6a7b953826"));
exports.ComAtprotoSyncGetBlocks = __importStar(require("afbf0f6a40841488"));
exports.ComAtprotoSyncGetCheckout = __importStar(require("93c5868b3f7de6c0"));
exports.ComAtprotoSyncGetHead = __importStar(require("812f68c1311c8d21"));
exports.ComAtprotoSyncGetHostStatus = __importStar(require("92367178757cb63f"));
exports.ComAtprotoSyncGetLatestCommit = __importStar(require("bb626ab6038c3016"));
exports.ComAtprotoSyncGetRecord = __importStar(require("de4419b219788732"));
exports.ComAtprotoSyncGetRepo = __importStar(require("78f72b0385da6b74"));
exports.ComAtprotoSyncGetRepoStatus = __importStar(require("5b5c453a4cd13c3e"));
exports.ComAtprotoSyncListBlobs = __importStar(require("22f75326edbc016f"));
exports.ComAtprotoSyncListHosts = __importStar(require("14fb56ba752a0fab"));
exports.ComAtprotoSyncListRepos = __importStar(require("f61d8a08f723672b"));
exports.ComAtprotoSyncListReposByCollection = __importStar(require("30d6ed7da6463ffd"));
exports.ComAtprotoSyncNotifyOfUpdate = __importStar(require("4b66b58a8066bb82"));
exports.ComAtprotoSyncRequestCrawl = __importStar(require("df19566a34724a91"));
exports.ComAtprotoSyncSubscribeRepos = __importStar(require("e2d96fc2b573d610"));
exports.ComAtprotoTempAddReservedHandle = __importStar(require("4caf04216096c722"));
exports.ComAtprotoTempCheckHandleAvailability = __importStar(require("ca222c96438db773"));
exports.ComAtprotoTempCheckSignupQueue = __importStar(require("5d5d608ef740c0e5"));
exports.ComAtprotoTempDereferenceScope = __importStar(require("eb81d423eaf73127"));
exports.ComAtprotoTempFetchLabels = __importStar(require("59362b50d5d74027"));
exports.ComAtprotoTempRequestPhoneVerification = __importStar(require("e1eb51f8c912d82d"));
exports.ComAtprotoTempRevokeAccountCredentials = __importStar(require("5b7bca3aee65c213"));
exports.ToolsOzoneCommunicationCreateTemplate = __importStar(require("7716f19a3ed6bb54"));
exports.ToolsOzoneCommunicationDefs = __importStar(require("a5566a89fcd9d6c"));
exports.ToolsOzoneCommunicationDeleteTemplate = __importStar(require("ee61749d0652fb42"));
exports.ToolsOzoneCommunicationListTemplates = __importStar(require("8315cbdfa3108dcb"));
exports.ToolsOzoneCommunicationUpdateTemplate = __importStar(require("6aa8b1d145cc42c0"));
exports.ToolsOzoneHostingGetAccountHistory = __importStar(require("7b02361c68f732f2"));
exports.ToolsOzoneModerationCancelScheduledActions = __importStar(require("124fe8a50d853cbe"));
exports.ToolsOzoneModerationDefs = __importStar(require("d26faf2c7656ee4"));
exports.ToolsOzoneModerationEmitEvent = __importStar(require("2c0506b198454861"));
exports.ToolsOzoneModerationGetAccountTimeline = __importStar(require("702871d69330373b"));
exports.ToolsOzoneModerationGetEvent = __importStar(require("675d70e4e5421057"));
exports.ToolsOzoneModerationGetRecord = __importStar(require("ab9070dfc7a624e7"));
exports.ToolsOzoneModerationGetRecords = __importStar(require("29cdcbb7fad006a7"));
exports.ToolsOzoneModerationGetRepo = __importStar(require("3eb16909f4c37f1c"));
exports.ToolsOzoneModerationGetReporterStats = __importStar(require("164eae2a1bedc410"));
exports.ToolsOzoneModerationGetRepos = __importStar(require("2ab81609aa08eea8"));
exports.ToolsOzoneModerationGetSubjects = __importStar(require("273ba8238e46a210"));
exports.ToolsOzoneModerationListScheduledActions = __importStar(require("899dfc5ac8559c3"));
exports.ToolsOzoneModerationQueryEvents = __importStar(require("8432f8db91d82361"));
exports.ToolsOzoneModerationQueryStatuses = __importStar(require("d8017836ef59a812"));
exports.ToolsOzoneModerationScheduleAction = __importStar(require("7e7979a98a2426e2"));
exports.ToolsOzoneModerationSearchRepos = __importStar(require("809ffc508cbf3930"));
exports.ToolsOzoneReportDefs = __importStar(require("c291d969bc77d960"));
exports.ToolsOzoneSafelinkAddRule = __importStar(require("9ff9adbbc09df2fd"));
exports.ToolsOzoneSafelinkDefs = __importStar(require("3d780cf5eb4308f3"));
exports.ToolsOzoneSafelinkQueryEvents = __importStar(require("884860bb0daf421b"));
exports.ToolsOzoneSafelinkQueryRules = __importStar(require("71cac5cafe4d005"));
exports.ToolsOzoneSafelinkRemoveRule = __importStar(require("c107c422a2d48691"));
exports.ToolsOzoneSafelinkUpdateRule = __importStar(require("10539fcb7fee110a"));
exports.ToolsOzoneServerGetConfig = __importStar(require("7d0b14561cdc8ecd"));
exports.ToolsOzoneSetAddValues = __importStar(require("9e077659c14f619d"));
exports.ToolsOzoneSetDefs = __importStar(require("da835b3cd56d6998"));
exports.ToolsOzoneSetDeleteSet = __importStar(require("978f382424658b9e"));
exports.ToolsOzoneSetDeleteValues = __importStar(require("41fd180fa0c18902"));
exports.ToolsOzoneSetGetValues = __importStar(require("9a5198cdb748f50b"));
exports.ToolsOzoneSetQuerySets = __importStar(require("c1b8563af7f925bf"));
exports.ToolsOzoneSetUpsertSet = __importStar(require("8b6e4709c7be018a"));
exports.ToolsOzoneSettingDefs = __importStar(require("9e4eb7c56a31a28e"));
exports.ToolsOzoneSettingListOptions = __importStar(require("1d651856cbf1b55"));
exports.ToolsOzoneSettingRemoveOptions = __importStar(require("18a8782a57894c74"));
exports.ToolsOzoneSettingUpsertOption = __importStar(require("6d098d736984e06"));
exports.ToolsOzoneSignatureDefs = __importStar(require("818c65a360944e28"));
exports.ToolsOzoneSignatureFindCorrelation = __importStar(require("2d6289f75e849e9"));
exports.ToolsOzoneSignatureFindRelatedAccounts = __importStar(require("467741958f01d51d"));
exports.ToolsOzoneSignatureSearchAccounts = __importStar(require("15de330b89dc402d"));
exports.ToolsOzoneTeamAddMember = __importStar(require("3a590041db175bce"));
exports.ToolsOzoneTeamDefs = __importStar(require("fd7e352f9a62ded7"));
exports.ToolsOzoneTeamDeleteMember = __importStar(require("7936d0860528d93a"));
exports.ToolsOzoneTeamListMembers = __importStar(require("f765d3f64fcff8d5"));
exports.ToolsOzoneTeamUpdateMember = __importStar(require("8b83da9c4685102d"));
exports.ToolsOzoneVerificationDefs = __importStar(require("423d23a892a9e8b7"));
exports.ToolsOzoneVerificationGrantVerifications = __importStar(require("aaacd1190c28b237"));
exports.ToolsOzoneVerificationListVerifications = __importStar(require("34154b827d5c7e41"));
exports.ToolsOzoneVerificationRevokeVerifications = __importStar(require("193ea32fb7dee63c"));
exports.APP_BSKY_ACTOR = {
    StatusLive: 'app.bsky.actor.status#live'
};
exports.APP_BSKY_FEED = {
    DefsRequestLess: 'app.bsky.feed.defs#requestLess',
    DefsRequestMore: 'app.bsky.feed.defs#requestMore',
    DefsClickthroughItem: 'app.bsky.feed.defs#clickthroughItem',
    DefsClickthroughAuthor: 'app.bsky.feed.defs#clickthroughAuthor',
    DefsClickthroughReposter: 'app.bsky.feed.defs#clickthroughReposter',
    DefsClickthroughEmbed: 'app.bsky.feed.defs#clickthroughEmbed',
    DefsContentModeUnspecified: 'app.bsky.feed.defs#contentModeUnspecified',
    DefsContentModeVideo: 'app.bsky.feed.defs#contentModeVideo',
    DefsInteractionSeen: 'app.bsky.feed.defs#interactionSeen',
    DefsInteractionLike: 'app.bsky.feed.defs#interactionLike',
    DefsInteractionRepost: 'app.bsky.feed.defs#interactionRepost',
    DefsInteractionReply: 'app.bsky.feed.defs#interactionReply',
    DefsInteractionQuote: 'app.bsky.feed.defs#interactionQuote',
    DefsInteractionShare: 'app.bsky.feed.defs#interactionShare'
};
exports.APP_BSKY_GRAPH = {
    DefsModlist: 'app.bsky.graph.defs#modlist',
    DefsCuratelist: 'app.bsky.graph.defs#curatelist',
    DefsReferencelist: 'app.bsky.graph.defs#referencelist'
};
exports.COM_ATPROTO_MODERATION = {
    DefsReasonSpam: 'com.atproto.moderation.defs#reasonSpam',
    DefsReasonViolation: 'com.atproto.moderation.defs#reasonViolation',
    DefsReasonMisleading: 'com.atproto.moderation.defs#reasonMisleading',
    DefsReasonSexual: 'com.atproto.moderation.defs#reasonSexual',
    DefsReasonRude: 'com.atproto.moderation.defs#reasonRude',
    DefsReasonOther: 'com.atproto.moderation.defs#reasonOther',
    DefsReasonAppeal: 'com.atproto.moderation.defs#reasonAppeal'
};
exports.TOOLS_OZONE_MODERATION = {
    DefsReviewOpen: 'tools.ozone.moderation.defs#reviewOpen',
    DefsReviewEscalated: 'tools.ozone.moderation.defs#reviewEscalated',
    DefsReviewClosed: 'tools.ozone.moderation.defs#reviewClosed',
    DefsReviewNone: 'tools.ozone.moderation.defs#reviewNone',
    DefsTimelineEventPlcCreate: 'tools.ozone.moderation.defs#timelineEventPlcCreate',
    DefsTimelineEventPlcOperation: 'tools.ozone.moderation.defs#timelineEventPlcOperation',
    DefsTimelineEventPlcTombstone: 'tools.ozone.moderation.defs#timelineEventPlcTombstone'
};
exports.TOOLS_OZONE_REPORT = {
    DefsReasonAppeal: 'tools.ozone.report.defs#reasonAppeal',
    DefsReasonOther: 'tools.ozone.report.defs#reasonOther',
    DefsReasonViolenceAnimal: 'tools.ozone.report.defs#reasonViolenceAnimal',
    DefsReasonViolenceThreats: 'tools.ozone.report.defs#reasonViolenceThreats',
    DefsReasonViolenceGraphicContent: 'tools.ozone.report.defs#reasonViolenceGraphicContent',
    DefsReasonViolenceGlorification: 'tools.ozone.report.defs#reasonViolenceGlorification',
    DefsReasonViolenceExtremistContent: 'tools.ozone.report.defs#reasonViolenceExtremistContent',
    DefsReasonViolenceTrafficking: 'tools.ozone.report.defs#reasonViolenceTrafficking',
    DefsReasonViolenceOther: 'tools.ozone.report.defs#reasonViolenceOther',
    DefsReasonSexualAbuseContent: 'tools.ozone.report.defs#reasonSexualAbuseContent',
    DefsReasonSexualNCII: 'tools.ozone.report.defs#reasonSexualNCII',
    DefsReasonSexualDeepfake: 'tools.ozone.report.defs#reasonSexualDeepfake',
    DefsReasonSexualAnimal: 'tools.ozone.report.defs#reasonSexualAnimal',
    DefsReasonSexualUnlabeled: 'tools.ozone.report.defs#reasonSexualUnlabeled',
    DefsReasonSexualOther: 'tools.ozone.report.defs#reasonSexualOther',
    DefsReasonChildSafetyCSAM: 'tools.ozone.report.defs#reasonChildSafetyCSAM',
    DefsReasonChildSafetyGroom: 'tools.ozone.report.defs#reasonChildSafetyGroom',
    DefsReasonChildSafetyPrivacy: 'tools.ozone.report.defs#reasonChildSafetyPrivacy',
    DefsReasonChildSafetyHarassment: 'tools.ozone.report.defs#reasonChildSafetyHarassment',
    DefsReasonChildSafetyOther: 'tools.ozone.report.defs#reasonChildSafetyOther',
    DefsReasonHarassmentTroll: 'tools.ozone.report.defs#reasonHarassmentTroll',
    DefsReasonHarassmentTargeted: 'tools.ozone.report.defs#reasonHarassmentTargeted',
    DefsReasonHarassmentHateSpeech: 'tools.ozone.report.defs#reasonHarassmentHateSpeech',
    DefsReasonHarassmentDoxxing: 'tools.ozone.report.defs#reasonHarassmentDoxxing',
    DefsReasonHarassmentOther: 'tools.ozone.report.defs#reasonHarassmentOther',
    DefsReasonMisleadingBot: 'tools.ozone.report.defs#reasonMisleadingBot',
    DefsReasonMisleadingImpersonation: 'tools.ozone.report.defs#reasonMisleadingImpersonation',
    DefsReasonMisleadingSpam: 'tools.ozone.report.defs#reasonMisleadingSpam',
    DefsReasonMisleadingScam: 'tools.ozone.report.defs#reasonMisleadingScam',
    DefsReasonMisleadingElections: 'tools.ozone.report.defs#reasonMisleadingElections',
    DefsReasonMisleadingOther: 'tools.ozone.report.defs#reasonMisleadingOther',
    DefsReasonRuleSiteSecurity: 'tools.ozone.report.defs#reasonRuleSiteSecurity',
    DefsReasonRuleProhibitedSales: 'tools.ozone.report.defs#reasonRuleProhibitedSales',
    DefsReasonRuleBanEvasion: 'tools.ozone.report.defs#reasonRuleBanEvasion',
    DefsReasonRuleOther: 'tools.ozone.report.defs#reasonRuleOther',
    DefsReasonSelfHarmContent: 'tools.ozone.report.defs#reasonSelfHarmContent',
    DefsReasonSelfHarmED: 'tools.ozone.report.defs#reasonSelfHarmED',
    DefsReasonSelfHarmStunts: 'tools.ozone.report.defs#reasonSelfHarmStunts',
    DefsReasonSelfHarmSubstances: 'tools.ozone.report.defs#reasonSelfHarmSubstances',
    DefsReasonSelfHarmOther: 'tools.ozone.report.defs#reasonSelfHarmOther'
};
exports.TOOLS_OZONE_TEAM = {
    DefsRoleAdmin: 'tools.ozone.team.defs#roleAdmin',
    DefsRoleModerator: 'tools.ozone.team.defs#roleModerator',
    DefsRoleTriage: 'tools.ozone.team.defs#roleTriage',
    DefsRoleVerifier: 'tools.ozone.team.defs#roleVerifier'
};
class AtpBaseClient extends xrpc_1.XrpcClient {
    constructor(options){
        super(options, lexicons_js_1.schemas);
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "chat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "com", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tools", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.app = new AppNS(this);
        this.chat = new ChatNS(this);
        this.com = new ComNS(this);
        this.tools = new ToolsNS(this);
    }
    /** @deprecated use `this` instead */ get xrpc() {
        return this;
    }
}
exports.AtpBaseClient = AtpBaseClient;
class AppNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bsky", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.bsky = new AppBskyNS(client);
    }
}
exports.AppNS = AppNS;
class AppBskyNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "actor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bookmark", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "embed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "feed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "graph", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "labeler", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notification", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "richtext", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unspecced", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "video", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.actor = new AppBskyActorNS(client);
        this.bookmark = new AppBskyBookmarkNS(client);
        this.embed = new AppBskyEmbedNS(client);
        this.feed = new AppBskyFeedNS(client);
        this.graph = new AppBskyGraphNS(client);
        this.labeler = new AppBskyLabelerNS(client);
        this.notification = new AppBskyNotificationNS(client);
        this.richtext = new AppBskyRichtextNS(client);
        this.unspecced = new AppBskyUnspeccedNS(client);
        this.video = new AppBskyVideoNS(client);
    }
}
exports.AppBskyNS = AppBskyNS;
class AppBskyActorNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "profile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.profile = new AppBskyActorProfileRecord(client);
        this.status = new AppBskyActorStatusRecord(client);
    }
    getPreferences(params, opts) {
        return this._client.call('app.bsky.actor.getPreferences', params, undefined, opts);
    }
    getProfile(params, opts) {
        return this._client.call('app.bsky.actor.getProfile', params, undefined, opts);
    }
    getProfiles(params, opts) {
        return this._client.call('app.bsky.actor.getProfiles', params, undefined, opts);
    }
    getSuggestions(params, opts) {
        return this._client.call('app.bsky.actor.getSuggestions', params, undefined, opts);
    }
    putPreferences(data, opts) {
        return this._client.call('app.bsky.actor.putPreferences', opts?.qp, data, opts);
    }
    searchActors(params, opts) {
        return this._client.call('app.bsky.actor.searchActors', params, undefined, opts);
    }
    searchActorsTypeahead(params, opts) {
        return this._client.call('app.bsky.actor.searchActorsTypeahead', params, undefined, opts);
    }
}
exports.AppBskyActorNS = AppBskyActorNS;
class AppBskyActorProfileRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.actor.profile',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.actor.profile',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.actor.profile';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            rkey: 'self',
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.actor.profile';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.actor.profile',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyActorProfileRecord = AppBskyActorProfileRecord;
class AppBskyActorStatusRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.actor.status',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.actor.status',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.actor.status';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            rkey: 'self',
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.actor.status';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.actor.status',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyActorStatusRecord = AppBskyActorStatusRecord;
class AppBskyBookmarkNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    createBookmark(data, opts) {
        return this._client.call('app.bsky.bookmark.createBookmark', opts?.qp, data, opts).catch((e)=>{
            throw AppBskyBookmarkCreateBookmark.toKnownErr(e);
        });
    }
    deleteBookmark(data, opts) {
        return this._client.call('app.bsky.bookmark.deleteBookmark', opts?.qp, data, opts).catch((e)=>{
            throw AppBskyBookmarkDeleteBookmark.toKnownErr(e);
        });
    }
    getBookmarks(params, opts) {
        return this._client.call('app.bsky.bookmark.getBookmarks', params, undefined, opts);
    }
}
exports.AppBskyBookmarkNS = AppBskyBookmarkNS;
class AppBskyEmbedNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
}
exports.AppBskyEmbedNS = AppBskyEmbedNS;
class AppBskyFeedNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "generator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "like", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "post", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "postgate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "repost", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "threadgate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.generator = new AppBskyFeedGeneratorRecord(client);
        this.like = new AppBskyFeedLikeRecord(client);
        this.post = new AppBskyFeedPostRecord(client);
        this.postgate = new AppBskyFeedPostgateRecord(client);
        this.repost = new AppBskyFeedRepostRecord(client);
        this.threadgate = new AppBskyFeedThreadgateRecord(client);
    }
    describeFeedGenerator(params, opts) {
        return this._client.call('app.bsky.feed.describeFeedGenerator', params, undefined, opts);
    }
    getActorFeeds(params, opts) {
        return this._client.call('app.bsky.feed.getActorFeeds', params, undefined, opts);
    }
    getActorLikes(params, opts) {
        return this._client.call('app.bsky.feed.getActorLikes', params, undefined, opts).catch((e)=>{
            throw AppBskyFeedGetActorLikes.toKnownErr(e);
        });
    }
    getAuthorFeed(params, opts) {
        return this._client.call('app.bsky.feed.getAuthorFeed', params, undefined, opts).catch((e)=>{
            throw AppBskyFeedGetAuthorFeed.toKnownErr(e);
        });
    }
    getFeed(params, opts) {
        return this._client.call('app.bsky.feed.getFeed', params, undefined, opts).catch((e)=>{
            throw AppBskyFeedGetFeed.toKnownErr(e);
        });
    }
    getFeedGenerator(params, opts) {
        return this._client.call('app.bsky.feed.getFeedGenerator', params, undefined, opts);
    }
    getFeedGenerators(params, opts) {
        return this._client.call('app.bsky.feed.getFeedGenerators', params, undefined, opts);
    }
    getFeedSkeleton(params, opts) {
        return this._client.call('app.bsky.feed.getFeedSkeleton', params, undefined, opts).catch((e)=>{
            throw AppBskyFeedGetFeedSkeleton.toKnownErr(e);
        });
    }
    getLikes(params, opts) {
        return this._client.call('app.bsky.feed.getLikes', params, undefined, opts);
    }
    getListFeed(params, opts) {
        return this._client.call('app.bsky.feed.getListFeed', params, undefined, opts).catch((e)=>{
            throw AppBskyFeedGetListFeed.toKnownErr(e);
        });
    }
    getPostThread(params, opts) {
        return this._client.call('app.bsky.feed.getPostThread', params, undefined, opts).catch((e)=>{
            throw AppBskyFeedGetPostThread.toKnownErr(e);
        });
    }
    getPosts(params, opts) {
        return this._client.call('app.bsky.feed.getPosts', params, undefined, opts);
    }
    getQuotes(params, opts) {
        return this._client.call('app.bsky.feed.getQuotes', params, undefined, opts);
    }
    getRepostedBy(params, opts) {
        return this._client.call('app.bsky.feed.getRepostedBy', params, undefined, opts);
    }
    getSuggestedFeeds(params, opts) {
        return this._client.call('app.bsky.feed.getSuggestedFeeds', params, undefined, opts);
    }
    getTimeline(params, opts) {
        return this._client.call('app.bsky.feed.getTimeline', params, undefined, opts);
    }
    searchPosts(params, opts) {
        return this._client.call('app.bsky.feed.searchPosts', params, undefined, opts).catch((e)=>{
            throw AppBskyFeedSearchPosts.toKnownErr(e);
        });
    }
    sendInteractions(data, opts) {
        return this._client.call('app.bsky.feed.sendInteractions', opts?.qp, data, opts);
    }
}
exports.AppBskyFeedNS = AppBskyFeedNS;
class AppBskyFeedGeneratorRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.generator',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.generator',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.feed.generator';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.feed.generator';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.generator',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyFeedGeneratorRecord = AppBskyFeedGeneratorRecord;
class AppBskyFeedLikeRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.like',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.like',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.feed.like';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.feed.like';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.like',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyFeedLikeRecord = AppBskyFeedLikeRecord;
class AppBskyFeedPostRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.post',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.post',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.feed.post';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.feed.post';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.post',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyFeedPostRecord = AppBskyFeedPostRecord;
class AppBskyFeedPostgateRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.postgate',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.postgate',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.feed.postgate';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.feed.postgate';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.postgate',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyFeedPostgateRecord = AppBskyFeedPostgateRecord;
class AppBskyFeedRepostRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.repost',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.repost',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.feed.repost';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.feed.repost';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.repost',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyFeedRepostRecord = AppBskyFeedRepostRecord;
class AppBskyFeedThreadgateRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.feed.threadgate',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.feed.threadgate',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.feed.threadgate';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.feed.threadgate';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.feed.threadgate',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyFeedThreadgateRecord = AppBskyFeedThreadgateRecord;
class AppBskyGraphNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "block", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "follow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "list", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "listblock", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "listitem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "starterpack", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "verification", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.block = new AppBskyGraphBlockRecord(client);
        this.follow = new AppBskyGraphFollowRecord(client);
        this.list = new AppBskyGraphListRecord(client);
        this.listblock = new AppBskyGraphListblockRecord(client);
        this.listitem = new AppBskyGraphListitemRecord(client);
        this.starterpack = new AppBskyGraphStarterpackRecord(client);
        this.verification = new AppBskyGraphVerificationRecord(client);
    }
    getActorStarterPacks(params, opts) {
        return this._client.call('app.bsky.graph.getActorStarterPacks', params, undefined, opts);
    }
    getBlocks(params, opts) {
        return this._client.call('app.bsky.graph.getBlocks', params, undefined, opts);
    }
    getFollowers(params, opts) {
        return this._client.call('app.bsky.graph.getFollowers', params, undefined, opts);
    }
    getFollows(params, opts) {
        return this._client.call('app.bsky.graph.getFollows', params, undefined, opts);
    }
    getKnownFollowers(params, opts) {
        return this._client.call('app.bsky.graph.getKnownFollowers', params, undefined, opts);
    }
    getList(params, opts) {
        return this._client.call('app.bsky.graph.getList', params, undefined, opts);
    }
    getListBlocks(params, opts) {
        return this._client.call('app.bsky.graph.getListBlocks', params, undefined, opts);
    }
    getListMutes(params, opts) {
        return this._client.call('app.bsky.graph.getListMutes', params, undefined, opts);
    }
    getLists(params, opts) {
        return this._client.call('app.bsky.graph.getLists', params, undefined, opts);
    }
    getListsWithMembership(params, opts) {
        return this._client.call('app.bsky.graph.getListsWithMembership', params, undefined, opts);
    }
    getMutes(params, opts) {
        return this._client.call('app.bsky.graph.getMutes', params, undefined, opts);
    }
    getRelationships(params, opts) {
        return this._client.call('app.bsky.graph.getRelationships', params, undefined, opts).catch((e)=>{
            throw AppBskyGraphGetRelationships.toKnownErr(e);
        });
    }
    getStarterPack(params, opts) {
        return this._client.call('app.bsky.graph.getStarterPack', params, undefined, opts);
    }
    getStarterPacks(params, opts) {
        return this._client.call('app.bsky.graph.getStarterPacks', params, undefined, opts);
    }
    getStarterPacksWithMembership(params, opts) {
        return this._client.call('app.bsky.graph.getStarterPacksWithMembership', params, undefined, opts);
    }
    getSuggestedFollowsByActor(params, opts) {
        return this._client.call('app.bsky.graph.getSuggestedFollowsByActor', params, undefined, opts);
    }
    muteActor(data, opts) {
        return this._client.call('app.bsky.graph.muteActor', opts?.qp, data, opts);
    }
    muteActorList(data, opts) {
        return this._client.call('app.bsky.graph.muteActorList', opts?.qp, data, opts);
    }
    muteThread(data, opts) {
        return this._client.call('app.bsky.graph.muteThread', opts?.qp, data, opts);
    }
    searchStarterPacks(params, opts) {
        return this._client.call('app.bsky.graph.searchStarterPacks', params, undefined, opts);
    }
    unmuteActor(data, opts) {
        return this._client.call('app.bsky.graph.unmuteActor', opts?.qp, data, opts);
    }
    unmuteActorList(data, opts) {
        return this._client.call('app.bsky.graph.unmuteActorList', opts?.qp, data, opts);
    }
    unmuteThread(data, opts) {
        return this._client.call('app.bsky.graph.unmuteThread', opts?.qp, data, opts);
    }
}
exports.AppBskyGraphNS = AppBskyGraphNS;
class AppBskyGraphBlockRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.block',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.block',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.graph.block';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.graph.block';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.block',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyGraphBlockRecord = AppBskyGraphBlockRecord;
class AppBskyGraphFollowRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.follow',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.follow',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.graph.follow';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.graph.follow';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.follow',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyGraphFollowRecord = AppBskyGraphFollowRecord;
class AppBskyGraphListRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.list',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.list',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.graph.list';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.graph.list';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.list',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyGraphListRecord = AppBskyGraphListRecord;
class AppBskyGraphListblockRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.listblock',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.listblock',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.graph.listblock';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.graph.listblock';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.listblock',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyGraphListblockRecord = AppBskyGraphListblockRecord;
class AppBskyGraphListitemRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.listitem',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.listitem',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.graph.listitem';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.graph.listitem';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.listitem',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyGraphListitemRecord = AppBskyGraphListitemRecord;
class AppBskyGraphStarterpackRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.starterpack',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.starterpack',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.graph.starterpack';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.graph.starterpack';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.starterpack',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyGraphStarterpackRecord = AppBskyGraphStarterpackRecord;
class AppBskyGraphVerificationRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.graph.verification',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.graph.verification',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.graph.verification';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.graph.verification';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.graph.verification',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyGraphVerificationRecord = AppBskyGraphVerificationRecord;
class AppBskyLabelerNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "service", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.service = new AppBskyLabelerServiceRecord(client);
    }
    getServices(params, opts) {
        return this._client.call('app.bsky.labeler.getServices', params, undefined, opts);
    }
}
exports.AppBskyLabelerNS = AppBskyLabelerNS;
class AppBskyLabelerServiceRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.labeler.service',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.labeler.service',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.labeler.service';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            rkey: 'self',
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.labeler.service';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.labeler.service',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyLabelerServiceRecord = AppBskyLabelerServiceRecord;
class AppBskyNotificationNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "declaration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.declaration = new AppBskyNotificationDeclarationRecord(client);
    }
    getPreferences(params, opts) {
        return this._client.call('app.bsky.notification.getPreferences', params, undefined, opts);
    }
    getUnreadCount(params, opts) {
        return this._client.call('app.bsky.notification.getUnreadCount', params, undefined, opts);
    }
    listActivitySubscriptions(params, opts) {
        return this._client.call('app.bsky.notification.listActivitySubscriptions', params, undefined, opts);
    }
    listNotifications(params, opts) {
        return this._client.call('app.bsky.notification.listNotifications', params, undefined, opts);
    }
    putActivitySubscription(data, opts) {
        return this._client.call('app.bsky.notification.putActivitySubscription', opts?.qp, data, opts);
    }
    putPreferences(data, opts) {
        return this._client.call('app.bsky.notification.putPreferences', opts?.qp, data, opts);
    }
    putPreferencesV2(data, opts) {
        return this._client.call('app.bsky.notification.putPreferencesV2', opts?.qp, data, opts);
    }
    registerPush(data, opts) {
        return this._client.call('app.bsky.notification.registerPush', opts?.qp, data, opts);
    }
    unregisterPush(data, opts) {
        return this._client.call('app.bsky.notification.unregisterPush', opts?.qp, data, opts);
    }
    updateSeen(data, opts) {
        return this._client.call('app.bsky.notification.updateSeen', opts?.qp, data, opts);
    }
}
exports.AppBskyNotificationNS = AppBskyNotificationNS;
class AppBskyNotificationDeclarationRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'app.bsky.notification.declaration',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'app.bsky.notification.declaration',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'app.bsky.notification.declaration';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            rkey: 'self',
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'app.bsky.notification.declaration';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'app.bsky.notification.declaration',
            ...params
        }, {
            headers
        });
    }
}
exports.AppBskyNotificationDeclarationRecord = AppBskyNotificationDeclarationRecord;
class AppBskyRichtextNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
}
exports.AppBskyRichtextNS = AppBskyRichtextNS;
class AppBskyUnspeccedNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getAgeAssuranceState(params, opts) {
        return this._client.call('app.bsky.unspecced.getAgeAssuranceState', params, undefined, opts);
    }
    getConfig(params, opts) {
        return this._client.call('app.bsky.unspecced.getConfig', params, undefined, opts);
    }
    getOnboardingSuggestedStarterPacks(params, opts) {
        return this._client.call('app.bsky.unspecced.getOnboardingSuggestedStarterPacks', params, undefined, opts);
    }
    getOnboardingSuggestedStarterPacksSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.getOnboardingSuggestedStarterPacksSkeleton', params, undefined, opts);
    }
    getPopularFeedGenerators(params, opts) {
        return this._client.call('app.bsky.unspecced.getPopularFeedGenerators', params, undefined, opts);
    }
    getPostThreadOtherV2(params, opts) {
        return this._client.call('app.bsky.unspecced.getPostThreadOtherV2', params, undefined, opts);
    }
    getPostThreadV2(params, opts) {
        return this._client.call('app.bsky.unspecced.getPostThreadV2', params, undefined, opts);
    }
    getSuggestedFeeds(params, opts) {
        return this._client.call('app.bsky.unspecced.getSuggestedFeeds', params, undefined, opts);
    }
    getSuggestedFeedsSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.getSuggestedFeedsSkeleton', params, undefined, opts);
    }
    getSuggestedStarterPacks(params, opts) {
        return this._client.call('app.bsky.unspecced.getSuggestedStarterPacks', params, undefined, opts);
    }
    getSuggestedStarterPacksSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.getSuggestedStarterPacksSkeleton', params, undefined, opts);
    }
    getSuggestedUsers(params, opts) {
        return this._client.call('app.bsky.unspecced.getSuggestedUsers', params, undefined, opts);
    }
    getSuggestedUsersSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.getSuggestedUsersSkeleton', params, undefined, opts);
    }
    getSuggestionsSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.getSuggestionsSkeleton', params, undefined, opts);
    }
    getTaggedSuggestions(params, opts) {
        return this._client.call('app.bsky.unspecced.getTaggedSuggestions', params, undefined, opts);
    }
    getTrendingTopics(params, opts) {
        return this._client.call('app.bsky.unspecced.getTrendingTopics', params, undefined, opts);
    }
    getTrends(params, opts) {
        return this._client.call('app.bsky.unspecced.getTrends', params, undefined, opts);
    }
    getTrendsSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.getTrendsSkeleton', params, undefined, opts);
    }
    initAgeAssurance(data, opts) {
        return this._client.call('app.bsky.unspecced.initAgeAssurance', opts?.qp, data, opts).catch((e)=>{
            throw AppBskyUnspeccedInitAgeAssurance.toKnownErr(e);
        });
    }
    searchActorsSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.searchActorsSkeleton', params, undefined, opts).catch((e)=>{
            throw AppBskyUnspeccedSearchActorsSkeleton.toKnownErr(e);
        });
    }
    searchPostsSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.searchPostsSkeleton', params, undefined, opts).catch((e)=>{
            throw AppBskyUnspeccedSearchPostsSkeleton.toKnownErr(e);
        });
    }
    searchStarterPacksSkeleton(params, opts) {
        return this._client.call('app.bsky.unspecced.searchStarterPacksSkeleton', params, undefined, opts).catch((e)=>{
            throw AppBskyUnspeccedSearchStarterPacksSkeleton.toKnownErr(e);
        });
    }
}
exports.AppBskyUnspeccedNS = AppBskyUnspeccedNS;
class AppBskyVideoNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getJobStatus(params, opts) {
        return this._client.call('app.bsky.video.getJobStatus', params, undefined, opts);
    }
    getUploadLimits(params, opts) {
        return this._client.call('app.bsky.video.getUploadLimits', params, undefined, opts);
    }
    uploadVideo(data, opts) {
        return this._client.call('app.bsky.video.uploadVideo', opts?.qp, data, opts);
    }
}
exports.AppBskyVideoNS = AppBskyVideoNS;
class ChatNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "bsky", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.bsky = new ChatBskyNS(client);
    }
}
exports.ChatNS = ChatNS;
class ChatBskyNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "actor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "convo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "moderation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.actor = new ChatBskyActorNS(client);
        this.convo = new ChatBskyConvoNS(client);
        this.moderation = new ChatBskyModerationNS(client);
    }
}
exports.ChatBskyNS = ChatBskyNS;
class ChatBskyActorNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "declaration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.declaration = new ChatBskyActorDeclarationRecord(client);
    }
    deleteAccount(data, opts) {
        return this._client.call('chat.bsky.actor.deleteAccount', opts?.qp, data, opts);
    }
    exportAccountData(params, opts) {
        return this._client.call('chat.bsky.actor.exportAccountData', params, undefined, opts);
    }
}
exports.ChatBskyActorNS = ChatBskyActorNS;
class ChatBskyActorDeclarationRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'chat.bsky.actor.declaration',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'chat.bsky.actor.declaration',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'chat.bsky.actor.declaration';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            rkey: 'self',
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'chat.bsky.actor.declaration';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'chat.bsky.actor.declaration',
            ...params
        }, {
            headers
        });
    }
}
exports.ChatBskyActorDeclarationRecord = ChatBskyActorDeclarationRecord;
class ChatBskyConvoNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    acceptConvo(data, opts) {
        return this._client.call('chat.bsky.convo.acceptConvo', opts?.qp, data, opts);
    }
    addReaction(data, opts) {
        return this._client.call('chat.bsky.convo.addReaction', opts?.qp, data, opts).catch((e)=>{
            throw ChatBskyConvoAddReaction.toKnownErr(e);
        });
    }
    deleteMessageForSelf(data, opts) {
        return this._client.call('chat.bsky.convo.deleteMessageForSelf', opts?.qp, data, opts);
    }
    getConvo(params, opts) {
        return this._client.call('chat.bsky.convo.getConvo', params, undefined, opts);
    }
    getConvoAvailability(params, opts) {
        return this._client.call('chat.bsky.convo.getConvoAvailability', params, undefined, opts);
    }
    getConvoForMembers(params, opts) {
        return this._client.call('chat.bsky.convo.getConvoForMembers', params, undefined, opts);
    }
    getLog(params, opts) {
        return this._client.call('chat.bsky.convo.getLog', params, undefined, opts);
    }
    getMessages(params, opts) {
        return this._client.call('chat.bsky.convo.getMessages', params, undefined, opts);
    }
    leaveConvo(data, opts) {
        return this._client.call('chat.bsky.convo.leaveConvo', opts?.qp, data, opts);
    }
    listConvos(params, opts) {
        return this._client.call('chat.bsky.convo.listConvos', params, undefined, opts);
    }
    muteConvo(data, opts) {
        return this._client.call('chat.bsky.convo.muteConvo', opts?.qp, data, opts);
    }
    removeReaction(data, opts) {
        return this._client.call('chat.bsky.convo.removeReaction', opts?.qp, data, opts).catch((e)=>{
            throw ChatBskyConvoRemoveReaction.toKnownErr(e);
        });
    }
    sendMessage(data, opts) {
        return this._client.call('chat.bsky.convo.sendMessage', opts?.qp, data, opts);
    }
    sendMessageBatch(data, opts) {
        return this._client.call('chat.bsky.convo.sendMessageBatch', opts?.qp, data, opts);
    }
    unmuteConvo(data, opts) {
        return this._client.call('chat.bsky.convo.unmuteConvo', opts?.qp, data, opts);
    }
    updateAllRead(data, opts) {
        return this._client.call('chat.bsky.convo.updateAllRead', opts?.qp, data, opts);
    }
    updateRead(data, opts) {
        return this._client.call('chat.bsky.convo.updateRead', opts?.qp, data, opts);
    }
}
exports.ChatBskyConvoNS = ChatBskyConvoNS;
class ChatBskyModerationNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getActorMetadata(params, opts) {
        return this._client.call('chat.bsky.moderation.getActorMetadata', params, undefined, opts);
    }
    getMessageContext(params, opts) {
        return this._client.call('chat.bsky.moderation.getMessageContext', params, undefined, opts);
    }
    updateActorAccess(data, opts) {
        return this._client.call('chat.bsky.moderation.updateActorAccess', opts?.qp, data, opts);
    }
}
exports.ChatBskyModerationNS = ChatBskyModerationNS;
class ComNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "atproto", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.atproto = new ComAtprotoNS(client);
    }
}
exports.ComNS = ComNS;
class ComAtprotoNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "admin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "identity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "label", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lexicon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "moderation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "repo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "server", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sync", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "temp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.admin = new ComAtprotoAdminNS(client);
        this.identity = new ComAtprotoIdentityNS(client);
        this.label = new ComAtprotoLabelNS(client);
        this.lexicon = new ComAtprotoLexiconNS(client);
        this.moderation = new ComAtprotoModerationNS(client);
        this.repo = new ComAtprotoRepoNS(client);
        this.server = new ComAtprotoServerNS(client);
        this.sync = new ComAtprotoSyncNS(client);
        this.temp = new ComAtprotoTempNS(client);
    }
}
exports.ComAtprotoNS = ComAtprotoNS;
class ComAtprotoAdminNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    deleteAccount(data, opts) {
        return this._client.call('com.atproto.admin.deleteAccount', opts?.qp, data, opts);
    }
    disableAccountInvites(data, opts) {
        return this._client.call('com.atproto.admin.disableAccountInvites', opts?.qp, data, opts);
    }
    disableInviteCodes(data, opts) {
        return this._client.call('com.atproto.admin.disableInviteCodes', opts?.qp, data, opts);
    }
    enableAccountInvites(data, opts) {
        return this._client.call('com.atproto.admin.enableAccountInvites', opts?.qp, data, opts);
    }
    getAccountInfo(params, opts) {
        return this._client.call('com.atproto.admin.getAccountInfo', params, undefined, opts);
    }
    getAccountInfos(params, opts) {
        return this._client.call('com.atproto.admin.getAccountInfos', params, undefined, opts);
    }
    getInviteCodes(params, opts) {
        return this._client.call('com.atproto.admin.getInviteCodes', params, undefined, opts);
    }
    getSubjectStatus(params, opts) {
        return this._client.call('com.atproto.admin.getSubjectStatus', params, undefined, opts);
    }
    searchAccounts(params, opts) {
        return this._client.call('com.atproto.admin.searchAccounts', params, undefined, opts);
    }
    sendEmail(data, opts) {
        return this._client.call('com.atproto.admin.sendEmail', opts?.qp, data, opts);
    }
    updateAccountEmail(data, opts) {
        return this._client.call('com.atproto.admin.updateAccountEmail', opts?.qp, data, opts);
    }
    updateAccountHandle(data, opts) {
        return this._client.call('com.atproto.admin.updateAccountHandle', opts?.qp, data, opts);
    }
    updateAccountPassword(data, opts) {
        return this._client.call('com.atproto.admin.updateAccountPassword', opts?.qp, data, opts);
    }
    updateAccountSigningKey(data, opts) {
        return this._client.call('com.atproto.admin.updateAccountSigningKey', opts?.qp, data, opts);
    }
    updateSubjectStatus(data, opts) {
        return this._client.call('com.atproto.admin.updateSubjectStatus', opts?.qp, data, opts);
    }
}
exports.ComAtprotoAdminNS = ComAtprotoAdminNS;
class ComAtprotoIdentityNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getRecommendedDidCredentials(params, opts) {
        return this._client.call('com.atproto.identity.getRecommendedDidCredentials', params, undefined, opts);
    }
    refreshIdentity(data, opts) {
        return this._client.call('com.atproto.identity.refreshIdentity', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoIdentityRefreshIdentity.toKnownErr(e);
        });
    }
    requestPlcOperationSignature(data, opts) {
        return this._client.call('com.atproto.identity.requestPlcOperationSignature', opts?.qp, data, opts);
    }
    resolveDid(params, opts) {
        return this._client.call('com.atproto.identity.resolveDid', params, undefined, opts).catch((e)=>{
            throw ComAtprotoIdentityResolveDid.toKnownErr(e);
        });
    }
    resolveHandle(params, opts) {
        return this._client.call('com.atproto.identity.resolveHandle', params, undefined, opts).catch((e)=>{
            throw ComAtprotoIdentityResolveHandle.toKnownErr(e);
        });
    }
    resolveIdentity(params, opts) {
        return this._client.call('com.atproto.identity.resolveIdentity', params, undefined, opts).catch((e)=>{
            throw ComAtprotoIdentityResolveIdentity.toKnownErr(e);
        });
    }
    signPlcOperation(data, opts) {
        return this._client.call('com.atproto.identity.signPlcOperation', opts?.qp, data, opts);
    }
    submitPlcOperation(data, opts) {
        return this._client.call('com.atproto.identity.submitPlcOperation', opts?.qp, data, opts);
    }
    updateHandle(data, opts) {
        return this._client.call('com.atproto.identity.updateHandle', opts?.qp, data, opts);
    }
}
exports.ComAtprotoIdentityNS = ComAtprotoIdentityNS;
class ComAtprotoLabelNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    queryLabels(params, opts) {
        return this._client.call('com.atproto.label.queryLabels', params, undefined, opts);
    }
}
exports.ComAtprotoLabelNS = ComAtprotoLabelNS;
class ComAtprotoLexiconNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.schema = new ComAtprotoLexiconSchemaRecord(client);
    }
}
exports.ComAtprotoLexiconNS = ComAtprotoLexiconNS;
class ComAtprotoLexiconSchemaRecord {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    async list(params) {
        const res = await this._client.call('com.atproto.repo.listRecords', {
            collection: 'com.atproto.lexicon.schema',
            ...params
        });
        return res.data;
    }
    async get(params) {
        const res = await this._client.call('com.atproto.repo.getRecord', {
            collection: 'com.atproto.lexicon.schema',
            ...params
        });
        return res.data;
    }
    async create(params, record, headers) {
        const collection = 'com.atproto.lexicon.schema';
        const res = await this._client.call('com.atproto.repo.createRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async put(params, record, headers) {
        const collection = 'com.atproto.lexicon.schema';
        const res = await this._client.call('com.atproto.repo.putRecord', undefined, {
            collection,
            ...params,
            record: {
                ...record,
                $type: collection
            }
        }, {
            encoding: 'application/json',
            headers
        });
        return res.data;
    }
    async delete(params, headers) {
        await this._client.call('com.atproto.repo.deleteRecord', undefined, {
            collection: 'com.atproto.lexicon.schema',
            ...params
        }, {
            headers
        });
    }
}
exports.ComAtprotoLexiconSchemaRecord = ComAtprotoLexiconSchemaRecord;
class ComAtprotoModerationNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    createReport(data, opts) {
        return this._client.call('com.atproto.moderation.createReport', opts?.qp, data, opts);
    }
}
exports.ComAtprotoModerationNS = ComAtprotoModerationNS;
class ComAtprotoRepoNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    applyWrites(data, opts) {
        return this._client.call('com.atproto.repo.applyWrites', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoRepoApplyWrites.toKnownErr(e);
        });
    }
    createRecord(data, opts) {
        return this._client.call('com.atproto.repo.createRecord', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoRepoCreateRecord.toKnownErr(e);
        });
    }
    deleteRecord(data, opts) {
        return this._client.call('com.atproto.repo.deleteRecord', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoRepoDeleteRecord.toKnownErr(e);
        });
    }
    describeRepo(params, opts) {
        return this._client.call('com.atproto.repo.describeRepo', params, undefined, opts);
    }
    getRecord(params, opts) {
        return this._client.call('com.atproto.repo.getRecord', params, undefined, opts).catch((e)=>{
            throw ComAtprotoRepoGetRecord.toKnownErr(e);
        });
    }
    importRepo(data, opts) {
        return this._client.call('com.atproto.repo.importRepo', opts?.qp, data, opts);
    }
    listMissingBlobs(params, opts) {
        return this._client.call('com.atproto.repo.listMissingBlobs', params, undefined, opts);
    }
    listRecords(params, opts) {
        return this._client.call('com.atproto.repo.listRecords', params, undefined, opts);
    }
    putRecord(data, opts) {
        return this._client.call('com.atproto.repo.putRecord', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoRepoPutRecord.toKnownErr(e);
        });
    }
    uploadBlob(data, opts) {
        return this._client.call('com.atproto.repo.uploadBlob', opts?.qp, data, opts);
    }
}
exports.ComAtprotoRepoNS = ComAtprotoRepoNS;
class ComAtprotoServerNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    activateAccount(data, opts) {
        return this._client.call('com.atproto.server.activateAccount', opts?.qp, data, opts);
    }
    checkAccountStatus(params, opts) {
        return this._client.call('com.atproto.server.checkAccountStatus', params, undefined, opts);
    }
    confirmEmail(data, opts) {
        return this._client.call('com.atproto.server.confirmEmail', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoServerConfirmEmail.toKnownErr(e);
        });
    }
    createAccount(data, opts) {
        return this._client.call('com.atproto.server.createAccount', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoServerCreateAccount.toKnownErr(e);
        });
    }
    createAppPassword(data, opts) {
        return this._client.call('com.atproto.server.createAppPassword', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoServerCreateAppPassword.toKnownErr(e);
        });
    }
    createCustomJwtSession(data, opts) {
        return this._client.call('com.atproto.server.createCustomJwtSession', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoServerCreateCustomJwtSession.toKnownErr(e);
        });
    }
    createInviteCode(data, opts) {
        return this._client.call('com.atproto.server.createInviteCode', opts?.qp, data, opts);
    }
    createInviteCodes(data, opts) {
        return this._client.call('com.atproto.server.createInviteCodes', opts?.qp, data, opts);
    }
    createSession(data, opts) {
        return this._client.call('com.atproto.server.createSession', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoServerCreateSession.toKnownErr(e);
        });
    }
    deactivateAccount(data, opts) {
        return this._client.call('com.atproto.server.deactivateAccount', opts?.qp, data, opts);
    }
    deleteAccount(data, opts) {
        return this._client.call('com.atproto.server.deleteAccount', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoServerDeleteAccount.toKnownErr(e);
        });
    }
    deleteSession(data, opts) {
        return this._client.call('com.atproto.server.deleteSession', opts?.qp, data, opts);
    }
    describeServer(params, opts) {
        return this._client.call('com.atproto.server.describeServer', params, undefined, opts);
    }
    getAccountInviteCodes(params, opts) {
        return this._client.call('com.atproto.server.getAccountInviteCodes', params, undefined, opts).catch((e)=>{
            throw ComAtprotoServerGetAccountInviteCodes.toKnownErr(e);
        });
    }
    getServiceAuth(params, opts) {
        return this._client.call('com.atproto.server.getServiceAuth', params, undefined, opts).catch((e)=>{
            throw ComAtprotoServerGetServiceAuth.toKnownErr(e);
        });
    }
    getSession(params, opts) {
        return this._client.call('com.atproto.server.getSession', params, undefined, opts);
    }
    listAppPasswords(params, opts) {
        return this._client.call('com.atproto.server.listAppPasswords', params, undefined, opts).catch((e)=>{
            throw ComAtprotoServerListAppPasswords.toKnownErr(e);
        });
    }
    refreshSession(data, opts) {
        return this._client.call('com.atproto.server.refreshSession', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoServerRefreshSession.toKnownErr(e);
        });
    }
    requestAccountDelete(data, opts) {
        return this._client.call('com.atproto.server.requestAccountDelete', opts?.qp, data, opts);
    }
    requestEmailConfirmation(data, opts) {
        return this._client.call('com.atproto.server.requestEmailConfirmation', opts?.qp, data, opts);
    }
    requestEmailUpdate(data, opts) {
        return this._client.call('com.atproto.server.requestEmailUpdate', opts?.qp, data, opts);
    }
    requestPasswordReset(data, opts) {
        return this._client.call('com.atproto.server.requestPasswordReset', opts?.qp, data, opts);
    }
    reserveSigningKey(data, opts) {
        return this._client.call('com.atproto.server.reserveSigningKey', opts?.qp, data, opts);
    }
    resetPassword(data, opts) {
        return this._client.call('com.atproto.server.resetPassword', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoServerResetPassword.toKnownErr(e);
        });
    }
    revokeAppPassword(data, opts) {
        return this._client.call('com.atproto.server.revokeAppPassword', opts?.qp, data, opts);
    }
    updateEmail(data, opts) {
        return this._client.call('com.atproto.server.updateEmail', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoServerUpdateEmail.toKnownErr(e);
        });
    }
}
exports.ComAtprotoServerNS = ComAtprotoServerNS;
class ComAtprotoSyncNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getBlob(params, opts) {
        return this._client.call('com.atproto.sync.getBlob', params, undefined, opts).catch((e)=>{
            throw ComAtprotoSyncGetBlob.toKnownErr(e);
        });
    }
    getBlocks(params, opts) {
        return this._client.call('com.atproto.sync.getBlocks', params, undefined, opts).catch((e)=>{
            throw ComAtprotoSyncGetBlocks.toKnownErr(e);
        });
    }
    getCheckout(params, opts) {
        return this._client.call('com.atproto.sync.getCheckout', params, undefined, opts);
    }
    getHead(params, opts) {
        return this._client.call('com.atproto.sync.getHead', params, undefined, opts).catch((e)=>{
            throw ComAtprotoSyncGetHead.toKnownErr(e);
        });
    }
    getHostStatus(params, opts) {
        return this._client.call('com.atproto.sync.getHostStatus', params, undefined, opts).catch((e)=>{
            throw ComAtprotoSyncGetHostStatus.toKnownErr(e);
        });
    }
    getLatestCommit(params, opts) {
        return this._client.call('com.atproto.sync.getLatestCommit', params, undefined, opts).catch((e)=>{
            throw ComAtprotoSyncGetLatestCommit.toKnownErr(e);
        });
    }
    getRecord(params, opts) {
        return this._client.call('com.atproto.sync.getRecord', params, undefined, opts).catch((e)=>{
            throw ComAtprotoSyncGetRecord.toKnownErr(e);
        });
    }
    getRepo(params, opts) {
        return this._client.call('com.atproto.sync.getRepo', params, undefined, opts).catch((e)=>{
            throw ComAtprotoSyncGetRepo.toKnownErr(e);
        });
    }
    getRepoStatus(params, opts) {
        return this._client.call('com.atproto.sync.getRepoStatus', params, undefined, opts).catch((e)=>{
            throw ComAtprotoSyncGetRepoStatus.toKnownErr(e);
        });
    }
    listBlobs(params, opts) {
        return this._client.call('com.atproto.sync.listBlobs', params, undefined, opts).catch((e)=>{
            throw ComAtprotoSyncListBlobs.toKnownErr(e);
        });
    }
    listHosts(params, opts) {
        return this._client.call('com.atproto.sync.listHosts', params, undefined, opts);
    }
    listRepos(params, opts) {
        return this._client.call('com.atproto.sync.listRepos', params, undefined, opts);
    }
    listReposByCollection(params, opts) {
        return this._client.call('com.atproto.sync.listReposByCollection', params, undefined, opts);
    }
    notifyOfUpdate(data, opts) {
        return this._client.call('com.atproto.sync.notifyOfUpdate', opts?.qp, data, opts);
    }
    requestCrawl(data, opts) {
        return this._client.call('com.atproto.sync.requestCrawl', opts?.qp, data, opts).catch((e)=>{
            throw ComAtprotoSyncRequestCrawl.toKnownErr(e);
        });
    }
}
exports.ComAtprotoSyncNS = ComAtprotoSyncNS;
class ComAtprotoTempNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    addReservedHandle(data, opts) {
        return this._client.call('com.atproto.temp.addReservedHandle', opts?.qp, data, opts);
    }
    checkHandleAvailability(params, opts) {
        return this._client.call('com.atproto.temp.checkHandleAvailability', params, undefined, opts).catch((e)=>{
            throw ComAtprotoTempCheckHandleAvailability.toKnownErr(e);
        });
    }
    checkSignupQueue(params, opts) {
        return this._client.call('com.atproto.temp.checkSignupQueue', params, undefined, opts);
    }
    dereferenceScope(params, opts) {
        return this._client.call('com.atproto.temp.dereferenceScope', params, undefined, opts).catch((e)=>{
            throw ComAtprotoTempDereferenceScope.toKnownErr(e);
        });
    }
    fetchLabels(params, opts) {
        return this._client.call('com.atproto.temp.fetchLabels', params, undefined, opts);
    }
    requestPhoneVerification(data, opts) {
        return this._client.call('com.atproto.temp.requestPhoneVerification', opts?.qp, data, opts);
    }
    revokeAccountCredentials(data, opts) {
        return this._client.call('com.atproto.temp.revokeAccountCredentials', opts?.qp, data, opts);
    }
}
exports.ComAtprotoTempNS = ComAtprotoTempNS;
class ToolsNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ozone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.ozone = new ToolsOzoneNS(client);
    }
}
exports.ToolsNS = ToolsNS;
class ToolsOzoneNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "communication", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hosting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "moderation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "safelink", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "server", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "set", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "team", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "verification", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
        this.communication = new ToolsOzoneCommunicationNS(client);
        this.hosting = new ToolsOzoneHostingNS(client);
        this.moderation = new ToolsOzoneModerationNS(client);
        this.safelink = new ToolsOzoneSafelinkNS(client);
        this.server = new ToolsOzoneServerNS(client);
        this.set = new ToolsOzoneSetNS(client);
        this.setting = new ToolsOzoneSettingNS(client);
        this.signature = new ToolsOzoneSignatureNS(client);
        this.team = new ToolsOzoneTeamNS(client);
        this.verification = new ToolsOzoneVerificationNS(client);
    }
}
exports.ToolsOzoneNS = ToolsOzoneNS;
class ToolsOzoneCommunicationNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    createTemplate(data, opts) {
        return this._client.call('tools.ozone.communication.createTemplate', opts?.qp, data, opts).catch((e)=>{
            throw ToolsOzoneCommunicationCreateTemplate.toKnownErr(e);
        });
    }
    deleteTemplate(data, opts) {
        return this._client.call('tools.ozone.communication.deleteTemplate', opts?.qp, data, opts);
    }
    listTemplates(params, opts) {
        return this._client.call('tools.ozone.communication.listTemplates', params, undefined, opts);
    }
    updateTemplate(data, opts) {
        return this._client.call('tools.ozone.communication.updateTemplate', opts?.qp, data, opts).catch((e)=>{
            throw ToolsOzoneCommunicationUpdateTemplate.toKnownErr(e);
        });
    }
}
exports.ToolsOzoneCommunicationNS = ToolsOzoneCommunicationNS;
class ToolsOzoneHostingNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getAccountHistory(params, opts) {
        return this._client.call('tools.ozone.hosting.getAccountHistory', params, undefined, opts);
    }
}
exports.ToolsOzoneHostingNS = ToolsOzoneHostingNS;
class ToolsOzoneModerationNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    cancelScheduledActions(data, opts) {
        return this._client.call('tools.ozone.moderation.cancelScheduledActions', opts?.qp, data, opts);
    }
    emitEvent(data, opts) {
        return this._client.call('tools.ozone.moderation.emitEvent', opts?.qp, data, opts).catch((e)=>{
            throw ToolsOzoneModerationEmitEvent.toKnownErr(e);
        });
    }
    getAccountTimeline(params, opts) {
        return this._client.call('tools.ozone.moderation.getAccountTimeline', params, undefined, opts).catch((e)=>{
            throw ToolsOzoneModerationGetAccountTimeline.toKnownErr(e);
        });
    }
    getEvent(params, opts) {
        return this._client.call('tools.ozone.moderation.getEvent', params, undefined, opts);
    }
    getRecord(params, opts) {
        return this._client.call('tools.ozone.moderation.getRecord', params, undefined, opts).catch((e)=>{
            throw ToolsOzoneModerationGetRecord.toKnownErr(e);
        });
    }
    getRecords(params, opts) {
        return this._client.call('tools.ozone.moderation.getRecords', params, undefined, opts);
    }
    getRepo(params, opts) {
        return this._client.call('tools.ozone.moderation.getRepo', params, undefined, opts).catch((e)=>{
            throw ToolsOzoneModerationGetRepo.toKnownErr(e);
        });
    }
    getReporterStats(params, opts) {
        return this._client.call('tools.ozone.moderation.getReporterStats', params, undefined, opts);
    }
    getRepos(params, opts) {
        return this._client.call('tools.ozone.moderation.getRepos', params, undefined, opts);
    }
    getSubjects(params, opts) {
        return this._client.call('tools.ozone.moderation.getSubjects', params, undefined, opts);
    }
    listScheduledActions(data, opts) {
        return this._client.call('tools.ozone.moderation.listScheduledActions', opts?.qp, data, opts);
    }
    queryEvents(params, opts) {
        return this._client.call('tools.ozone.moderation.queryEvents', params, undefined, opts);
    }
    queryStatuses(params, opts) {
        return this._client.call('tools.ozone.moderation.queryStatuses', params, undefined, opts);
    }
    scheduleAction(data, opts) {
        return this._client.call('tools.ozone.moderation.scheduleAction', opts?.qp, data, opts);
    }
    searchRepos(params, opts) {
        return this._client.call('tools.ozone.moderation.searchRepos', params, undefined, opts);
    }
}
exports.ToolsOzoneModerationNS = ToolsOzoneModerationNS;
class ToolsOzoneSafelinkNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    addRule(data, opts) {
        return this._client.call('tools.ozone.safelink.addRule', opts?.qp, data, opts).catch((e)=>{
            throw ToolsOzoneSafelinkAddRule.toKnownErr(e);
        });
    }
    queryEvents(data, opts) {
        return this._client.call('tools.ozone.safelink.queryEvents', opts?.qp, data, opts);
    }
    queryRules(data, opts) {
        return this._client.call('tools.ozone.safelink.queryRules', opts?.qp, data, opts);
    }
    removeRule(data, opts) {
        return this._client.call('tools.ozone.safelink.removeRule', opts?.qp, data, opts).catch((e)=>{
            throw ToolsOzoneSafelinkRemoveRule.toKnownErr(e);
        });
    }
    updateRule(data, opts) {
        return this._client.call('tools.ozone.safelink.updateRule', opts?.qp, data, opts).catch((e)=>{
            throw ToolsOzoneSafelinkUpdateRule.toKnownErr(e);
        });
    }
}
exports.ToolsOzoneSafelinkNS = ToolsOzoneSafelinkNS;
class ToolsOzoneServerNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    getConfig(params, opts) {
        return this._client.call('tools.ozone.server.getConfig', params, undefined, opts);
    }
}
exports.ToolsOzoneServerNS = ToolsOzoneServerNS;
class ToolsOzoneSetNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    addValues(data, opts) {
        return this._client.call('tools.ozone.set.addValues', opts?.qp, data, opts);
    }
    deleteSet(data, opts) {
        return this._client.call('tools.ozone.set.deleteSet', opts?.qp, data, opts).catch((e)=>{
            throw ToolsOzoneSetDeleteSet.toKnownErr(e);
        });
    }
    deleteValues(data, opts) {
        return this._client.call('tools.ozone.set.deleteValues', opts?.qp, data, opts).catch((e)=>{
            throw ToolsOzoneSetDeleteValues.toKnownErr(e);
        });
    }
    getValues(params, opts) {
        return this._client.call('tools.ozone.set.getValues', params, undefined, opts).catch((e)=>{
            throw ToolsOzoneSetGetValues.toKnownErr(e);
        });
    }
    querySets(params, opts) {
        return this._client.call('tools.ozone.set.querySets', params, undefined, opts);
    }
    upsertSet(data, opts) {
        return this._client.call('tools.ozone.set.upsertSet', opts?.qp, data, opts);
    }
}
exports.ToolsOzoneSetNS = ToolsOzoneSetNS;
class ToolsOzoneSettingNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    listOptions(params, opts) {
        return this._client.call('tools.ozone.setting.listOptions', params, undefined, opts);
    }
    removeOptions(data, opts) {
        return this._client.call('tools.ozone.setting.removeOptions', opts?.qp, data, opts);
    }
    upsertOption(data, opts) {
        return this._client.call('tools.ozone.setting.upsertOption', opts?.qp, data, opts);
    }
}
exports.ToolsOzoneSettingNS = ToolsOzoneSettingNS;
class ToolsOzoneSignatureNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    findCorrelation(params, opts) {
        return this._client.call('tools.ozone.signature.findCorrelation', params, undefined, opts);
    }
    findRelatedAccounts(params, opts) {
        return this._client.call('tools.ozone.signature.findRelatedAccounts', params, undefined, opts);
    }
    searchAccounts(params, opts) {
        return this._client.call('tools.ozone.signature.searchAccounts', params, undefined, opts);
    }
}
exports.ToolsOzoneSignatureNS = ToolsOzoneSignatureNS;
class ToolsOzoneTeamNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    addMember(data, opts) {
        return this._client.call('tools.ozone.team.addMember', opts?.qp, data, opts).catch((e)=>{
            throw ToolsOzoneTeamAddMember.toKnownErr(e);
        });
    }
    deleteMember(data, opts) {
        return this._client.call('tools.ozone.team.deleteMember', opts?.qp, data, opts).catch((e)=>{
            throw ToolsOzoneTeamDeleteMember.toKnownErr(e);
        });
    }
    listMembers(params, opts) {
        return this._client.call('tools.ozone.team.listMembers', params, undefined, opts);
    }
    updateMember(data, opts) {
        return this._client.call('tools.ozone.team.updateMember', opts?.qp, data, opts).catch((e)=>{
            throw ToolsOzoneTeamUpdateMember.toKnownErr(e);
        });
    }
}
exports.ToolsOzoneTeamNS = ToolsOzoneTeamNS;
class ToolsOzoneVerificationNS {
    constructor(client){
        Object.defineProperty(this, "_client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._client = client;
    }
    grantVerifications(data, opts) {
        return this._client.call('tools.ozone.verification.grantVerifications', opts?.qp, data, opts);
    }
    listVerifications(params, opts) {
        return this._client.call('tools.ozone.verification.listVerifications', params, undefined, opts);
    }
    revokeVerifications(data, opts) {
        return this._client.call('tools.ozone.verification.revokeVerifications', opts?.qp, data, opts);
    }
}
exports.ToolsOzoneVerificationNS = ToolsOzoneVerificationNS;

},{"5b1cb0c8a2c6c556":"3J4dg","4a480041bf85d273":"4ClhN","dc80e21f29507626":"gAwq2","e6c3a17e90d55fd8":"2ziro","167f6379847b390":"5xM4s","2397d032dc139d25":"2RaxF","1629084e1eb1ef2b":"1rvdF","9027d24e35207ac4":"8iEWZ","e885adb39cb619b8":"lhDui","6840540394c1a961":"5jIzX","3f723a3f7d3b5ce6":"lmcZG","f2518ec5a3a4dd8b":"jJ6eS","1e3e5b969aa9b8e6":"cSywb","52f91ac520a4d3ea":"6ib8d","e8fb82ed0c581d47":"7jE1P","9d32d58b0ef08209":"dIofs","4cd67407124f68a5":"eYNpg","a70c562109b81fcd":"jQfoy","9f69a63c4c2d93d7":"jAakA","8b0a2d57dd1dc651":"iKB1Y","f97a0107051ac852":"d6gcu","ae93e8c57ae9c299":"cCVI5","a43fb793d668ec02":"aJakc","766f66d9a3fd6728":"1wK6d","db79bcc33d4be3a6":"jHbgW","815bbc3ffebea408":"15DKb","e501a9cd82565848":"4Sdpp","cb62e7808a4d564":"iUuCT","90690a38251be7ab":"4xYY0","faa2ae7a02083c9":"8263w","a5405150917559b8":"8Qp2Z","4d69f0e13fff815":"gfTct","c287c2c6352607d0":"cnxXm","4278c46f41b0b8e8":"8wLL3","df7be3b318b0abb2":"5M4TD","3df541c59279f028":"cL6N8","e871c6c23ce4d72c":"gniX8","9e2b7b051eef2a08":"aYqC6","310de8020ac35b1f":"1B7NR","b46eef6a7b953826":"iM1Za","afbf0f6a40841488":"itz1L","812f68c1311c8d21":"7CfN9","92367178757cb63f":"dwB9p","bb626ab6038c3016":"5O8fC","de4419b219788732":"hiVCo","78f72b0385da6b74":"hWlVf","5b5c453a4cd13c3e":"6DBK5","22f75326edbc016f":"4YJ90","df19566a34724a91":"7GKR7","ca222c96438db773":"acvKW","eb81d423eaf73127":"lr6W9","7716f19a3ed6bb54":"erF4G","6aa8b1d145cc42c0":"iujz0","2c0506b198454861":"a6fKU","702871d69330373b":"6AUeQ","ab9070dfc7a624e7":"b3pf5","3eb16909f4c37f1c":"kNLHN","9ff9adbbc09df2fd":"fGyGV","c107c422a2d48691":"lYujD","10539fcb7fee110a":"iFUxP","978f382424658b9e":"386xZ","41fd180fa0c18902":"jFQuj","9a5198cdb748f50b":"8At3M","3a590041db175bce":"8PIJt","7936d0860528d93a":"gjtJd","8b83da9c4685102d":"iPNkS","2d686b80e9529927":"fZ5Ea","48f0f9f48461ae8":"9B31A","947416b2e5ac047e":"639Tq","d7a81c965cacb653":"cqnLX","e31966189d7b75be":"46QWx","102aa5879aaec3c8":"eAZdd","171affd6e290adc1":"dPUDr","5b428b95aec07fe6":"9M9tK","980dc3a902f7999a":"eW0YN","e5ccba9b3a3718de":"cNzZK","3277c19dae3de398":"hz3Ow","f3afd6596c73f2dc":"dLP0x","ec1d8dbd32c93c6e":"gQFV2","7735018159ddcf1f":"5ZM9l","6aa4afaaff005352":"duMQ0","8ee3953cd5ddeecb":"kO9qQ","43ecbfee2849591c":"9MWFe","f169c60df28b509d":"90aSZ","4f668ebca80f5bde":"lVwJR","3aad549558d5cdd8":"eEWgu","f25a7aac19174c36":"iQVrE","c335133809446777":"3ccfs","f5279241d33c9f19":"dsbW1","16dfb640a04309ba":"7sMBr","b2eef4fcea42b90a":"lIKMV","557eef132a1dddff":"iJF7Z","575322c47bceab29":"3QE4m","a2d2dded80247133":"d3scM","cbfb4ecbac35418e":"kT3Jq","21f35c558efbe8d4":"3lbIQ","55d971bd76eeeb74":"4djUZ","1696e8f7b2bfb333":"2Nfiu","230c00356d666010":"kt5HW","371c539f9a600a51":"80bs9","b617fb90d5d4a633":"h0ZId","f37d9accf8c762b9":"3g9dr","b17dc45682936c2f":"kwMBt","65993a8a65c778b4":"eLNSh","f2ffba85f63b7f23":"1jm7W","8b4c57d4b15b4e9a":"i1TXH","de202866d04ad9e0":"Y6DVI","fe4ad919b53a7ed4":"kdKzS","c45c957d412c07e2":"dDuOm","7a14f32d83cb9aa2":"hTGJK","b8279366350b9069":"cF2Vi","fcf00b174d06b0e0":"hLaMM","6afd728a21390908":"iKZwL","cda8da0ffba5b846":"7BV95","76271026fe3bb25":"cs6kf","b0cf74d7c933c678":"awoBN","11688f38d2127ea9":"89sPn","609c761c1787a800":"4pQgk","f115a352d5c3b20d":"18F8z","21457739d1ffc497":"k4ESl","89c54d933792f810":"3WJia","41ea0596d2681034":"jysHQ","9be69a92bd0c3614":"de729","83735652a9020b25":"54Yrh","22b7652370f78038":"fspL3","d241d321490c09d8":"fBUvT","32956f5e1ebbcb75":"88aB9","6109559b6946d060":"gXGfk","861bcce6a43bef9b":"hFpBl","1ae47b85361d7ec5":"lIs5a","9a4ae81c6bd19a72":"1QDIi","b5b6bcbd2a62f69":"647rw","c7e2890635f8f5e5":"cADnl","f2f5dfc9d4fbf7cd":"ehtTK","8e43dae95283a5ea":"5mJGy","5a3bf298c1f789ac":"aaslT","30e27d250ae8c353":"86zoL","f50c7eba7f308af7":"gjGj9","50fc26c3e8e2797b":"8W1nR","2aa5faef45744bf9":"h7ZmX","dab67a2f92aa3eab":"zHuSn","401764d482ac3c83":"aFkLK","a03547755080275e":"9jJX4","160e3b60af3762b6":"lDeyr","5d5cc6cf81a2405c":"eJhje","b36fa7fb230114f4":"kubyo","15fe0e7174562923":"9ARQz","b80e56ccee14de59":"5bhKK","c4efa2c99d57c044":"esoj1","7174b5edaadc3539":"54iCb","f8de1ad4d39d28ea":"ivWbh","e94353a12648d08a":"ekkD4","b2a22d6542847888":"iO9xs","9b6b8ac0dd388661":"cPn3G","5ba812c500a72468":"h08V9","595e34f92964a020":"7nyuY","205561f7796d5f41":"gCJye","27cbb04db8248e2c":"2WEZQ","4978ce73f6b00cba":"cK28v","d316cc3a7ba72e34":"eyZIJ","53c37a8133451f98":"gsPyE","494f3fe1236c9ec5":"1ZgYv","d6d9c737f4405968":"RNabW","d55d30f4eaf5d58b":"60oxh","ee5b45debe4a5f7d":"ix8cX","7e037ed0e08bfb36":"biEWK","f0def9a7d3a81533":"iBwfz","bfb292a58739b55b":"hOwis","2d1ab10d229dece7":"5bips","547b57acf41c1a48":"7AFvY","70f108bdf5bf1bba":"jwn6T","b165def850aeb31b":"jql1S","3e602d7e4606cd91":"hWjyF","2d41b6ce683ce393":"18mTA","70022b39f37a2a28":"k4rUc","2dbd20c037f8718a":"2KO8K","913e61e8b232b503":"iZJ9g","9dcf10c01d99fcd2":"ivey9","d562080fd27fe165":"cdc1D","f846777691160d1":"aLOSB","bd86e664a3bb847e":"3jksT","8e671bb7e08459ad":"a6CEY","375ad1e9ed04bdae":"kqbYV","57fe03cd07448fa4":"9SHUM","94d7eba3961773ae":"ipgbC","77ce1af28bdaeb45":"gmRi9","a43b4864c268aff":"8kVqQ","48df3cfcb24cda0b":"lAoOM","42600f25a5b134f5":"8RFd7","f51ee0af7366a288":"dj9IN","22090fcd02c4f57d":"c9fJS","2e76328acc1b9bea":"aARlY","fd01341d3976280e":"7mGiL","7573dba73a41a821":"hTAy8","21a33b7cf74da1e0":"1B06d","8dc306f426693caf":"1Bp5d","230a127e41b707e8":"20S2X","7ff0f63d415a8ec9":"f2y2c","bd6157f536f2e10":"1NEUi","d1fd574a1fd8b88c":"lsPqA","9e26ded5da192d26":"lRyzN","6c1664347c6a05c6":"g0W7b","7164708dfd4d2726":"iaXCP","628f5e2260ce1bd4":"ajyrD","e299490f64845729":"aWXj1","4acd501d206e1713":"feGzr","a9c096dba1535960":"l5Ffq","bdc00eaa6cc74729":"dVC0o","a165d6fc57d7fd7d":"df40w","9775c3fa102b4b31":"lcE2j","2994bf710f027aeb":"dJ7iU","9922f080934f4653":"5MS6j","56d9ed01e20a9277":"aYrZ0","8b84df95136dc859":"4qmfA","cbad5192d1c72b7c":"7JFec","a019bd9b4d4c5c28":"27epi","4855f09c0ee8d78d":"72O1l","43740260f8e8d7c5":"6WQqY","7ce12eb244eed6bf":"7mnZI","edadfee595d0ba67":"dp0Os","45feda9c05751043":"bxIi5","69671cf4259d4a07":"l2Rs3","4e62b49d1b8f71a6":"11nCp","226bb6d8a532872":"dpgNl","491928e4097d220b":"l70O2","140152ec7b28ad81":"dNJki","9bbe8e7601a85abb":"7xeaO","199672845afeefd8":"MZECW","9ba7202c173ed173":"3V7yv","2b76d5b99bddd24a":"i6W2K","6e4ab8648e933e16":"hrPXH","498f1c63441aab5e":"kCRZF","b94f9a954a9946c7":"jOYW1","c0983ac3f52bdb79":"6V0dg","321204f18c55d6d0":"65ow7","403f62f897d56340":"5NPbf","d2a9e5a330fc3cd8":"g5IFT","cecfc71aa76224dd":"9qcqD","4629614dbcb4ae8e":"bMO7h","9fd5cecf6b0fb93":"4hD0n","55602c01fd210f9a":"dbUmz","8ba753ede2c6cb5b":"2Bt94","42506f480bfae2a0":"jtEIi","fbef7c8ae0d27b20":"1ejft","4eccf3f89bbbbf4f":"7BMac","93c5868b3f7de6c0":"l3WW5","14fb56ba752a0fab":"2Gxk3","f61d8a08f723672b":"1IGif","30d6ed7da6463ffd":"bOj9g","4b66b58a8066bb82":"qPmxk","e2d96fc2b573d610":"8qR6G","4caf04216096c722":"cdMSF","5d5d608ef740c0e5":"6fp23","59362b50d5d74027":"gtviJ","e1eb51f8c912d82d":"jVQDd","5b7bca3aee65c213":"5Bpn6","a5566a89fcd9d6c":"fMJSR","ee61749d0652fb42":"gn7lw","8315cbdfa3108dcb":"eZuGO","7b02361c68f732f2":"cBy4G","124fe8a50d853cbe":"3eSbY","d26faf2c7656ee4":"hxrzZ","675d70e4e5421057":"6GCJR","29cdcbb7fad006a7":"dCAV8","164eae2a1bedc410":"cpxS5","2ab81609aa08eea8":"aH5Rt","273ba8238e46a210":"hcjLB","899dfc5ac8559c3":"gekZN","8432f8db91d82361":"3wfjJ","d8017836ef59a812":"8VuN2","7e7979a98a2426e2":"8uQ7V","809ffc508cbf3930":"9wWz6","c291d969bc77d960":"eoPDH","3d780cf5eb4308f3":"6ZZaI","884860bb0daf421b":"khuOv","71cac5cafe4d005":"hEFlj","7d0b14561cdc8ecd":"jeLKn","9e077659c14f619d":"8EZxH","da835b3cd56d6998":"dYeXv","c1b8563af7f925bf":"yyvON","8b6e4709c7be018a":"dVBfw","9e4eb7c56a31a28e":"fmy64","1d651856cbf1b55":"a4b0b","18a8782a57894c74":"fUQtp","6d098d736984e06":"kgHNy","818c65a360944e28":"cpRhR","2d6289f75e849e9":"g2JoW","467741958f01d51d":"eJ66l","15de330b89dc402d":"95Ujn","fd7e352f9a62ded7":"01vbV","f765d3f64fcff8d5":"4o1aR","423d23a892a9e8b7":"7lVLD","aaacd1190c28b237":"88DiA","34154b827d5c7e41":"4Gr2Z","193ea32fb7dee63c":"2sZv9"}],"3J4dg":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("3de4ee1b8c9c647"), exports);
__exportStar(require("51cf9156b31d62a6"), exports);
__exportStar(require("ba44f67781616223"), exports);
__exportStar(require("e124373fab952975"), exports);
__exportStar(require("a7f8b7470b228fa"), exports);
/* eslint-disable import/no-deprecated */ const client_1 = require("3de4ee1b8c9c647");
/** @deprecated create a local {@link XrpcClient} instance instead */ const defaultInst = new client_1.Client();
exports.default = defaultInst; /* eslint-enable import/no-deprecated */ 

},{"3de4ee1b8c9c647":"9qBmV","51cf9156b31d62a6":"6Od8p","ba44f67781616223":"g90cV","e124373fab952975":"gBA26","a7f8b7470b228fa":"iILcw"}],"9qBmV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ServiceClient = exports.Client = void 0;
const lexicon_1 = require("e800ef83be9ac4aa");
const util_1 = require("ad3265dc552ec60");
const xrpc_client_1 = require("c6710ce2539b472d");
/** @deprecated Use {@link XrpcClient} instead */ class Client {
    constructor(){
        Object.defineProperty(this, "lex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new lexicon_1.Lexicons()
        });
    }
    /** @deprecated */ get fetch() {
        throw new Error('Client.fetch is no longer supported. Use an XrpcClient instead.');
    }
    /** @deprecated */ set fetch(_) {
        throw new Error('Client.fetch is no longer supported. Use an XrpcClient instead.');
    }
    // method calls
    //
    async call(serviceUri, methodNsid, params, data, opts) {
        return this.service(serviceUri).call(methodNsid, params, data, opts);
    }
    service(serviceUri) {
        return new ServiceClient(this, serviceUri);
    }
    // schemas
    // =
    addLexicon(doc) {
        this.lex.add(doc);
    }
    addLexicons(docs) {
        for (const doc of docs)this.addLexicon(doc);
    }
    removeLexicon(uri) {
        this.lex.remove(uri);
    }
}
exports.Client = Client;
/** @deprecated Use {@link XrpcClient} instead */ class ServiceClient extends xrpc_client_1.XrpcClient {
    constructor(baseClient, serviceUri){
        super(async (input, init)=>{
            const headers = (0, util_1.combineHeaders)(init.headers, Object.entries(this.headers));
            return fetch(new URL(input, this.uri), {
                ...init,
                headers
            });
        }, baseClient.lex);
        Object.defineProperty(this, "baseClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: baseClient
        });
        Object.defineProperty(this, "uri", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.uri = typeof serviceUri === 'string' ? new URL(serviceUri) : serviceUri;
    }
}
exports.ServiceClient = ServiceClient;

},{"e800ef83be9ac4aa":"aBnF9","ad3265dc552ec60":"gBA26","c6710ce2539b472d":"iILcw"}],"gBA26":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isErrorResponseBody = isErrorResponseBody;
exports.getMethodSchemaHTTPMethod = getMethodSchemaHTTPMethod;
exports.constructMethodCallUri = constructMethodCallUri;
exports.constructMethodCallUrl = constructMethodCallUrl;
exports.encodeQueryParam = encodeQueryParam;
exports.constructMethodCallHeaders = constructMethodCallHeaders;
exports.combineHeaders = combineHeaders;
exports.isBodyInit = isBodyInit;
exports.isIterable = isIterable;
exports.encodeMethodCallBody = encodeMethodCallBody;
exports.httpResponseBodyParse = httpResponseBodyParse;
const lexicon_1 = require("981eb0bb43642a12");
const types_1 = require("f8d3aee11b5be286");
const ReadableStream = globalThis.ReadableStream || class {
    constructor(){
        // This anonymous class will never pass any "instanceof" check and cannot
        // be instantiated.
        throw new Error('ReadableStream is not supported in this environment');
    }
};
function isErrorResponseBody(v) {
    return types_1.errorResponseBody.safeParse(v).success;
}
function getMethodSchemaHTTPMethod(schema) {
    if (schema.type === 'procedure') return 'post';
    return 'get';
}
function constructMethodCallUri(nsid, schema, serviceUri, params) {
    const uri = new URL(constructMethodCallUrl(nsid, schema, params), serviceUri);
    return uri.toString();
}
function constructMethodCallUrl(nsid, schema, params) {
    const pathname = `/xrpc/${encodeURIComponent(nsid)}`;
    if (!params) return pathname;
    const searchParams = [];
    for (const [key, value] of Object.entries(params)){
        const paramSchema = schema.parameters?.properties?.[key];
        if (!paramSchema) throw new Error(`Invalid query parameter: ${key}`);
        if (value !== undefined) {
            if (paramSchema.type === 'array') {
                const values = Array.isArray(value) ? value : [
                    value
                ];
                for (const val of values)searchParams.push([
                    key,
                    encodeQueryParam(paramSchema.items.type, val)
                ]);
            } else searchParams.push([
                key,
                encodeQueryParam(paramSchema.type, value)
            ]);
        }
    }
    if (!searchParams.length) return pathname;
    return `${pathname}?${new URLSearchParams(searchParams).toString()}`;
}
function encodeQueryParam(type, value) {
    if (type === 'string' || type === 'unknown') return String(value);
    if (type === 'float') return String(Number(value));
    else if (type === 'integer') return String(Number(value) | 0);
    else if (type === 'boolean') return value ? 'true' : 'false';
    else if (type === 'datetime') {
        if (value instanceof Date) return value.toISOString();
        return String(value);
    }
    throw new Error(`Unsupported query param type: ${type}`);
}
function constructMethodCallHeaders(schema, data, opts) {
    // Not using `new Headers(opts?.headers)` to avoid duplicating headers values
    // due to inconsistent casing in headers name. In case of multiple headers
    // with the same name (but using a different case), the last one will be used.
    // new Headers({ 'content-type': 'foo', 'Content-Type': 'bar' }).get('content-type')
    // => 'foo, bar'
    const headers = new Headers();
    if (opts?.headers) for(const name in opts.headers){
        if (headers.has(name)) throw new TypeError(`Duplicate header: ${name}`);
        const value = opts.headers[name];
        if (value != null) headers.set(name, value);
    }
    if (schema.type === 'procedure') {
        if (opts?.encoding) headers.set('content-type', opts.encoding);
        else if (!headers.has('content-type') && typeof data !== 'undefined') {
            // Special handling of BodyInit types before falling back to JSON encoding
            if (data instanceof ArrayBuffer || data instanceof ReadableStream || ArrayBuffer.isView(data)) headers.set('content-type', 'application/octet-stream');
            else if (data instanceof FormData) // Note: The multipart form data boundary is missing from the header
            // we set here, making that header invalid. This special case will be
            // handled in encodeMethodCallBody()
            headers.set('content-type', 'multipart/form-data');
            else if (data instanceof URLSearchParams) headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            else if (isBlobLike(data)) headers.set('content-type', data.type || 'application/octet-stream');
            else if (typeof data === 'string') headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (isIterable(data)) headers.set('content-type', 'application/octet-stream');
            else if (typeof data === 'boolean' || typeof data === 'number' || typeof data === 'string' || typeof data === 'object' // covers "null"
            ) headers.set('content-type', 'application/json');
            else // symbol, function, bigint
            throw new types_1.XRPCError(types_1.ResponseType.InvalidRequest, `Unsupported data type: ${typeof data}`);
        }
    }
    return headers;
}
function combineHeaders(headersInit, defaultHeaders) {
    if (!defaultHeaders) return headersInit;
    let headers = undefined;
    for (const [name, definition] of defaultHeaders){
        // Ignore undefined values (allowed for convenience when using
        // Object.entries).
        if (definition === undefined) continue;
        // Lazy initialization of the headers object
        headers ?? (headers = new Headers(headersInit));
        if (headers.has(name)) continue;
        const value = typeof definition === 'function' ? definition() : definition;
        if (typeof value === 'string') headers.set(name, value);
        else if (value === null) headers.delete(name);
        else throw new TypeError(`Invalid "${name}" header value: ${typeof value}`);
    }
    return headers ?? headersInit;
}
function isBlobLike(value) {
    if (value == null) return false;
    if (typeof value !== 'object') return false;
    if (typeof Blob === 'function' && value instanceof Blob) return true;
    // Support for Blobs provided by libraries that don't use the native Blob
    // (e.g. fetch-blob from node-fetch).
    // https://github.com/node-fetch/fetch-blob/blob/a1a182e5978811407bef4ea1632b517567dda01f/index.js#L233-L244
    const tag = value[Symbol.toStringTag];
    if (tag === 'Blob' || tag === 'File') return 'stream' in value && typeof value.stream === 'function';
    return false;
}
function isBodyInit(value) {
    switch(typeof value){
        case 'string':
            return true;
        case 'object':
            return value instanceof ArrayBuffer || value instanceof FormData || value instanceof URLSearchParams || value instanceof ReadableStream || ArrayBuffer.isView(value) || isBlobLike(value);
        default:
            return false;
    }
}
function isIterable(value) {
    return value != null && typeof value === 'object' && (Symbol.iterator in value || Symbol.asyncIterator in value);
}
function encodeMethodCallBody(headers, data) {
    // Silently ignore the body if there is no content-type header.
    const contentType = headers.get('content-type');
    if (!contentType) return undefined;
    if (typeof data === 'undefined') // This error would be returned by the server, but we can catch it earlier
    // to avoid un-necessary requests. Note that a content-length of 0 does not
    // necessary mean that the body is "empty" (e.g. an empty txt file).
    throw new types_1.XRPCError(types_1.ResponseType.InvalidRequest, `A request body is expected but none was provided`);
    if (isBodyInit(data)) {
        if (data instanceof FormData && contentType === 'multipart/form-data') // fetch() will encode FormData payload itself, but it won't override the
        // content-type header if already present. This would cause the boundary
        // to be missing from the content-type header, resulting in a 400 error.
        // Deleting the content-type header here to let fetch() re-create it.
        headers.delete('content-type');
        // Will be encoded by the fetch API.
        return data;
    }
    if (isIterable(data)) // Note that some environments support using Iterable & AsyncIterable as the
    // body (e.g. Node's fetch), but not all of them do (browsers).
    return iterableToReadableStream(data);
    if (contentType.startsWith('text/')) return new TextEncoder().encode(String(data));
    if (contentType.startsWith('application/json')) {
        const json = (0, lexicon_1.stringifyLex)(data);
        // Server would return a 400 error if the JSON is invalid (e.g. trying to
        // JSONify a function, or an object that implements toJSON() poorly).
        if (json === undefined) throw new types_1.XRPCError(types_1.ResponseType.InvalidRequest, `Failed to encode request body as JSON`);
        return new TextEncoder().encode(json);
    }
    // At this point, "data" is not a valid BodyInit value, and we don't know how
    // to encode it into one. Passing it to fetch would result in an error. Let's
    // throw our own error instead.
    const type = !data || typeof data !== 'object' ? typeof data : data.constructor !== Object && typeof data.constructor === 'function' && typeof data.constructor?.name === 'string' ? data.constructor.name : 'object';
    throw new types_1.XRPCError(types_1.ResponseType.InvalidRequest, `Unable to encode ${type} as ${contentType} data`);
}
/**
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream/from_static}
 */ function iterableToReadableStream(iterable) {
    // Use the native ReadableStream.from() if available.
    if ('from' in ReadableStream && typeof ReadableStream.from === 'function') return ReadableStream.from(iterable);
    // If you see this error, consider using a polyfill for ReadableStream. For
    // example, the "web-streams-polyfill" package:
    // https://github.com/MattiasBuelens/web-streams-polyfill
    throw new TypeError("ReadableStream.from() is not supported in this environment. It is required to support using iterables as the request body. Consider using a polyfill or re-write your code to use a different body type.");
}
function httpResponseBodyParse(mimeType, data) {
    try {
        if (mimeType) {
            if (mimeType.includes('application/json')) {
                const str = new TextDecoder().decode(data);
                return (0, lexicon_1.jsonStringToLex)(str);
            }
            if (mimeType.startsWith('text/')) return new TextDecoder().decode(data);
        }
        if (data instanceof ArrayBuffer) return new Uint8Array(data);
        return data;
    } catch (cause) {
        throw new types_1.XRPCError(types_1.ResponseType.InvalidResponse, undefined, `Failed to parse response body: ${String(cause)}`, undefined, {
            cause
        });
    }
}

},{"981eb0bb43642a12":"aBnF9","f8d3aee11b5be286":"g90cV"}],"g90cV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.XRPCInvalidResponseError = exports.XRPCError = exports.XRPCResponse = exports.ResponseTypeStrings = exports.ResponseType = exports.errorResponseBody = void 0;
exports.httpResponseCodeToEnum = httpResponseCodeToEnum;
exports.httpResponseCodeToName = httpResponseCodeToName;
exports.httpResponseCodeToString = httpResponseCodeToString;
const zod_1 = require("d45690efe0b56e6");
exports.errorResponseBody = zod_1.z.object({
    error: zod_1.z.string().optional(),
    message: zod_1.z.string().optional()
});
var ResponseType;
(function(ResponseType) {
    /**
     * Network issue, unable to get response from the server.
     */ ResponseType[ResponseType["Unknown"] = 1] = "Unknown";
    /**
     * Response failed lexicon validation.
     */ ResponseType[ResponseType["InvalidResponse"] = 2] = "InvalidResponse";
    ResponseType[ResponseType["Success"] = 200] = "Success";
    ResponseType[ResponseType["InvalidRequest"] = 400] = "InvalidRequest";
    ResponseType[ResponseType["AuthenticationRequired"] = 401] = "AuthenticationRequired";
    ResponseType[ResponseType["Forbidden"] = 403] = "Forbidden";
    ResponseType[ResponseType["XRPCNotSupported"] = 404] = "XRPCNotSupported";
    ResponseType[ResponseType["NotAcceptable"] = 406] = "NotAcceptable";
    ResponseType[ResponseType["PayloadTooLarge"] = 413] = "PayloadTooLarge";
    ResponseType[ResponseType["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    ResponseType[ResponseType["RateLimitExceeded"] = 429] = "RateLimitExceeded";
    ResponseType[ResponseType["InternalServerError"] = 500] = "InternalServerError";
    ResponseType[ResponseType["MethodNotImplemented"] = 501] = "MethodNotImplemented";
    ResponseType[ResponseType["UpstreamFailure"] = 502] = "UpstreamFailure";
    ResponseType[ResponseType["NotEnoughResources"] = 503] = "NotEnoughResources";
    ResponseType[ResponseType["UpstreamTimeout"] = 504] = "UpstreamTimeout";
})(ResponseType || (exports.ResponseType = ResponseType = {}));
function httpResponseCodeToEnum(status) {
    if (status in ResponseType) return status;
    else if (status >= 100 && status < 200) return ResponseType.XRPCNotSupported;
    else if (status >= 200 && status < 300) return ResponseType.Success;
    else if (status >= 300 && status < 400) return ResponseType.XRPCNotSupported;
    else if (status >= 400 && status < 500) return ResponseType.InvalidRequest;
    else return ResponseType.InternalServerError;
}
function httpResponseCodeToName(status) {
    return ResponseType[httpResponseCodeToEnum(status)];
}
exports.ResponseTypeStrings = {
    [ResponseType.Unknown]: 'Unknown',
    [ResponseType.InvalidResponse]: 'Invalid Response',
    [ResponseType.Success]: 'Success',
    [ResponseType.InvalidRequest]: 'Invalid Request',
    [ResponseType.AuthenticationRequired]: 'Authentication Required',
    [ResponseType.Forbidden]: 'Forbidden',
    [ResponseType.XRPCNotSupported]: 'XRPC Not Supported',
    [ResponseType.NotAcceptable]: 'Not Acceptable',
    [ResponseType.PayloadTooLarge]: 'Payload Too Large',
    [ResponseType.UnsupportedMediaType]: 'Unsupported Media Type',
    [ResponseType.RateLimitExceeded]: 'Rate Limit Exceeded',
    [ResponseType.InternalServerError]: 'Internal Server Error',
    [ResponseType.MethodNotImplemented]: 'Method Not Implemented',
    [ResponseType.UpstreamFailure]: 'Upstream Failure',
    [ResponseType.NotEnoughResources]: 'Not Enough Resources',
    [ResponseType.UpstreamTimeout]: 'Upstream Timeout'
};
function httpResponseCodeToString(status) {
    return exports.ResponseTypeStrings[httpResponseCodeToEnum(status)];
}
class XRPCResponse {
    constructor(data, headers){
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: data
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: headers
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
    }
}
exports.XRPCResponse = XRPCResponse;
class XRPCError extends Error {
    constructor(statusCode, error = httpResponseCodeToName(statusCode), message, headers, options){
        super(message || error || httpResponseCodeToString(statusCode), options);
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: error
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: headers
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.status = httpResponseCodeToEnum(statusCode);
        // Pre 2022 runtimes won't handle the "options" constructor argument
        const cause = options?.cause;
        if (this.cause === undefined && cause !== undefined) this.cause = cause;
    }
    static from(cause, fallbackStatus) {
        if (cause instanceof XRPCError) return cause;
        // Type cast the cause to an Error if it is one
        const causeErr = cause instanceof Error ? cause : undefined;
        // Try and find a Response object in the cause
        const causeResponse = cause instanceof Response ? cause : cause?.['response'] instanceof Response ? cause['response'] : undefined;
        const statusCode = // Extract status code from "http-errors" like errors
        causeErr?.['statusCode'] ?? causeErr?.['status'] ?? // Use the status code from the response object as fallback
        causeResponse?.status;
        // Convert the status code to a ResponseType
        const status = typeof statusCode === 'number' ? httpResponseCodeToEnum(statusCode) : fallbackStatus ?? ResponseType.Unknown;
        const message = causeErr?.message ?? String(cause);
        const headers = causeResponse ? Object.fromEntries(causeResponse.headers.entries()) : undefined;
        return new XRPCError(status, undefined, message, headers, {
            cause
        });
    }
}
exports.XRPCError = XRPCError;
class XRPCInvalidResponseError extends XRPCError {
    constructor(lexiconNsid, validationError, responseBody){
        super(ResponseType.InvalidResponse, // @NOTE: This is probably wrong and should use ResponseTypeNames instead.
        // But it would mean a breaking change.
        exports.ResponseTypeStrings[ResponseType.InvalidResponse], `The server gave an invalid response and may be out of date.`, undefined, {
            cause: validationError
        });
        Object.defineProperty(this, "lexiconNsid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: lexiconNsid
        });
        Object.defineProperty(this, "validationError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: validationError
        });
        Object.defineProperty(this, "responseBody", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: responseBody
        });
    }
}
exports.XRPCInvalidResponseError = XRPCInvalidResponseError;

},{"d45690efe0b56e6":"6KnSB"}],"6KnSB":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.z = void 0;
const z = __importStar(require("43b16ae350bf2084"));
exports.z = z;
__exportStar(require("43b16ae350bf2084"), exports);
exports.default = z;

},{"43b16ae350bf2084":"25Dgz"}],"25Dgz":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("9afdd508d4a045b7"), exports);
__exportStar(require("5f04d989f8dd781b"), exports);
__exportStar(require("8689a30021c76871"), exports);
__exportStar(require("410672850ee9dd50"), exports);
__exportStar(require("3d9abfcbe9623a91"), exports);
__exportStar(require("830feedf65b3a3a2"), exports);

},{"9afdd508d4a045b7":"6myP3","5f04d989f8dd781b":"i36Y5","8689a30021c76871":"9J6XM","410672850ee9dd50":"8PCSj","3d9abfcbe9623a91":"l2YGy","830feedf65b3a3a2":"1inZo"}],"6myP3":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultErrorMap = void 0;
exports.setErrorMap = setErrorMap;
exports.getErrorMap = getErrorMap;
const en_js_1 = __importDefault(require("be9ca485fb5a2459"));
exports.defaultErrorMap = en_js_1.default;
let overrideErrorMap = en_js_1.default;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

},{"be9ca485fb5a2459":"4ZdwZ"}],"4ZdwZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const ZodError_js_1 = require("9e5bb25c6b6c93a4");
const util_js_1 = require("b7f7f0fb92570871");
const errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case ZodError_js_1.ZodIssueCode.invalid_type:
            if (issue.received === util_js_1.ZodParsedType.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util_js_1.util.jsonStringifyReplacer)}`;
            break;
        case ZodError_js_1.ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util_js_1.util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util_js_1.util.joinValues(issue.options)}`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util_js_1.util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else util_js_1.util.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case ZodError_js_1.ZodIssueCode.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case ZodError_js_1.ZodIssueCode.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case ZodError_js_1.ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodError_js_1.ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodError_js_1.ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodError_js_1.ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util_js_1.util.assertNever(issue);
    }
    return {
        message
    };
};
exports.default = errorMap;

},{"9e5bb25c6b6c93a4":"1inZo","b7f7f0fb92570871":"8PCSj"}],"1inZo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ZodError = exports.quotelessJson = exports.ZodIssueCode = void 0;
const util_js_1 = require("ca9ceace08f430f3");
exports.ZodIssueCode = util_js_1.util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const quotelessJson = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
exports.quotelessJson = quotelessJson;
class ZodError extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util_js_1.util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors,
            fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
exports.ZodError = ZodError;
ZodError.create = (issues)=>{
    const error = new ZodError(issues);
    return error;
};

},{"ca9ceace08f430f3":"8PCSj"}],"8PCSj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getParsedType = exports.ZodParsedType = exports.objectUtil = exports.util = void 0;
var util;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})(util || (exports.util = util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})(objectUtil || (exports.objectUtil = objectUtil = {}));
exports.ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return exports.ZodParsedType.undefined;
        case "string":
            return exports.ZodParsedType.string;
        case "number":
            return Number.isNaN(data) ? exports.ZodParsedType.nan : exports.ZodParsedType.number;
        case "boolean":
            return exports.ZodParsedType.boolean;
        case "function":
            return exports.ZodParsedType.function;
        case "bigint":
            return exports.ZodParsedType.bigint;
        case "symbol":
            return exports.ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return exports.ZodParsedType.array;
            if (data === null) return exports.ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return exports.ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return exports.ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return exports.ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return exports.ZodParsedType.date;
            return exports.ZodParsedType.object;
        default:
            return exports.ZodParsedType.unknown;
    }
};
exports.getParsedType = getParsedType;

},{}],"i36Y5":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAsync = exports.isValid = exports.isDirty = exports.isAborted = exports.OK = exports.DIRTY = exports.INVALID = exports.ParseStatus = exports.EMPTY_PATH = exports.makeIssue = void 0;
exports.addIssueToContext = addIssueToContext;
const errors_js_1 = require("67d3343168c7e327");
const en_js_1 = __importDefault(require("a0dd586aed76ad0f"));
const makeIssue = (params)=>{
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
exports.makeIssue = makeIssue;
exports.EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = (0, errors_js_1.getErrorMap)();
    const issue = (0, exports.makeIssue)({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === en_js_1.default ? undefined : en_js_1.default
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return exports.INVALID;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key, value } = pair;
            if (key.status === "aborted") return exports.INVALID;
            if (value.status === "aborted") return exports.INVALID;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
exports.ParseStatus = ParseStatus;
exports.INVALID = Object.freeze({
    status: "aborted"
});
const DIRTY = (value)=>({
        status: "dirty",
        value
    });
exports.DIRTY = DIRTY;
const OK = (value)=>({
        status: "valid",
        value
    });
exports.OK = OK;
const isAborted = (x)=>x.status === "aborted";
exports.isAborted = isAborted;
const isDirty = (x)=>x.status === "dirty";
exports.isDirty = isDirty;
const isValid = (x)=>x.status === "valid";
exports.isValid = isValid;
const isAsync = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
exports.isAsync = isAsync;

},{"67d3343168c7e327":"6myP3","a0dd586aed76ad0f":"4ZdwZ"}],"9J6XM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"l2YGy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.discriminatedUnion = exports.date = exports.boolean = exports.bigint = exports.array = exports.any = exports.coerce = exports.ZodFirstPartyTypeKind = exports.late = exports.ZodSchema = exports.Schema = exports.ZodReadonly = exports.ZodPipeline = exports.ZodBranded = exports.BRAND = exports.ZodNaN = exports.ZodCatch = exports.ZodDefault = exports.ZodNullable = exports.ZodOptional = exports.ZodTransformer = exports.ZodEffects = exports.ZodPromise = exports.ZodNativeEnum = exports.ZodEnum = exports.ZodLiteral = exports.ZodLazy = exports.ZodFunction = exports.ZodSet = exports.ZodMap = exports.ZodRecord = exports.ZodTuple = exports.ZodIntersection = exports.ZodDiscriminatedUnion = exports.ZodUnion = exports.ZodObject = exports.ZodArray = exports.ZodVoid = exports.ZodNever = exports.ZodUnknown = exports.ZodAny = exports.ZodNull = exports.ZodUndefined = exports.ZodSymbol = exports.ZodDate = exports.ZodBoolean = exports.ZodBigInt = exports.ZodNumber = exports.ZodString = exports.ZodType = void 0;
exports.NEVER = exports.void = exports.unknown = exports.union = exports.undefined = exports.tuple = exports.transformer = exports.symbol = exports.string = exports.strictObject = exports.set = exports.record = exports.promise = exports.preprocess = exports.pipeline = exports.ostring = exports.optional = exports.onumber = exports.oboolean = exports.object = exports.number = exports.nullable = exports.null = exports.never = exports.nativeEnum = exports.nan = exports.map = exports.literal = exports.lazy = exports.intersection = exports.instanceof = exports.function = exports.enum = exports.effect = void 0;
exports.datetimeRegex = datetimeRegex;
exports.custom = custom;
const ZodError_js_1 = require("b3610e3cd6af6af1");
const errors_js_1 = require("bdd45173b55f3e51");
const errorUtil_js_1 = require("f296269cfb0dc64e");
const parseUtil_js_1 = require("4246a3c9b44a4cbe");
const util_js_1 = require("ec587fb60306375d");
class ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result)=>{
    if ((0, parseUtil_js_1.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new ZodError_js_1.ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description
    };
    const customMap = (iss, ctx)=>{
        const { message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description
    };
}
class ZodType {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, util_js_1.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, util_js_1.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new parseUtil_js_1.ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, util_js_1.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, parseUtil_js_1.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        const result = this._parseSync({
            data,
            path: ctx.path,
            parent: ctx
        });
        return handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data,
                path: [],
                parent: ctx
            });
            return (0, parseUtil_js_1.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data,
            path: [],
            parent: ctx
        }).then((result)=>(0, parseUtil_js_1.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, util_js_1.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, parseUtil_js_1.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: ZodError_js_1.ZodIssueCode.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
exports.ZodType = ZodType;
exports.Schema = ZodType;
exports.ZodSchema = ZodType;
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
function isValidJWT(jwt, alg) {
    if (!jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function isValidCidr(ip, version) {
    if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) return true;
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.string,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const status = new parseUtil_js_1.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "email",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    validation: "url",
                    code: ZodError_js_1.ZodIssueCode.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: ZodError_js_1.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation,
            code: ZodError_js_1.ZodIssueCode.invalid_string,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...errorUtil_js_1.errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...errorUtil_js_1.errorUtil.errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil_js_1.errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, errorUtil_js_1.errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
exports.ZodString = ZodString;
ZodString.create = (params)=>{
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class ZodNumber extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.number,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        let ctx = undefined;
        const status = new parseUtil_js_1.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!util_js_1.util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil_js_1.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil_js_1.errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && util_js_1.util.isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
exports.ZodNumber = ZodNumber;
ZodNumber.create = (params)=>{
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodBigInt extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new parseUtil_js_1.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, parseUtil_js_1.addIssueToContext)(ctx, {
            code: ZodError_js_1.ZodIssueCode.invalid_type,
            expected: util_js_1.ZodParsedType.bigint,
            received: ctx.parsedType
        });
        return parseUtil_js_1.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil_js_1.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil_js_1.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil_js_1.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
exports.ZodBigInt = ZodBigInt;
ZodBigInt.create = (params)=>{
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.boolean,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodBoolean = ZodBoolean;
ZodBoolean.create = (params)=>{
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.date,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_date
            });
            return parseUtil_js_1.INVALID;
        }
        const status = new parseUtil_js_1.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else util_js_1.util.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil_js_1.errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
exports.ZodDate = ZodDate;
ZodDate.create = (params)=>{
    return new ZodDate({
        checks: [],
        coerce: params?.coerce || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params)
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.symbol,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodSymbol = ZodSymbol;
ZodSymbol.create = (params)=>{
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params)
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.undefined,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodUndefined = ZodUndefined;
ZodUndefined.create = (params)=>{
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params)
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.null,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodNull = ZodNull;
ZodNull.create = (params)=>{
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params)
    });
};
class ZodAny extends ZodType {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodAny = ZodAny;
ZodAny.create = (params)=>{
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params)
    });
};
class ZodUnknown extends ZodType {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodUnknown = ZodUnknown;
ZodUnknown.create = (params)=>{
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params)
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, parseUtil_js_1.addIssueToContext)(ctx, {
            code: ZodError_js_1.ZodIssueCode.invalid_type,
            expected: util_js_1.ZodParsedType.never,
            received: ctx.parsedType
        });
        return parseUtil_js_1.INVALID;
    }
}
exports.ZodNever = ZodNever;
ZodNever.create = (params)=>{
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params)
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.void,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
}
exports.ZodVoid = ZodVoid;
ZodVoid.create = (params)=>{
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params)
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== util_js_1.ZodParsedType.array) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.array,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: tooBig ? ZodError_js_1.ZodIssueCode.too_big : ZodError_js_1.ZodIssueCode.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return parseUtil_js_1.ParseStatus.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return parseUtil_js_1.ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: {
                value: minLength,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: {
                value: len,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
exports.ZodArray = ZodArray;
ZodArray.create = (schema, params)=>{
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params)
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof ZodArray) return new ZodArray({
        ...schema._def,
        type: deepPartialify(schema.element)
    });
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map((item)=>deepPartialify(item)));
    else return schema;
}
class ZodObject extends ZodType {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = util_js_1.util.objectKeys(shape);
        this._cached = {
            shape,
            keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, parseUtil_js_1.addIssueToContext)(ctx, {
                        code: ZodError_js_1.ZodIssueCode.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key,
                    value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return parseUtil_js_1.ParseStatus.mergeObjectSync(status, syncPairs);
        });
        else return parseUtil_js_1.ParseStatus.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil_js_1.errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: errorUtil_js_1.errorUtil.errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of util_js_1.util.objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of util_js_1.util.objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of util_js_1.util.objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of util_js_1.util.objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof ZodOptional)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return createZodEnum(util_js_1.util.objectKeys(this.shape));
    }
}
exports.ZodObject = ZodObject;
ZodObject.create = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.strictCreate = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.lazycreate = (shape, params)=>{
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new ZodError_js_1.ZodError(result.ctx.common.issues));
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union,
                unionErrors
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new ZodError_js_1.ZodError(issues));
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union,
                unionErrors
            });
            return parseUtil_js_1.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
exports.ZodUnion = ZodUnion;
ZodUnion.create = (types, params)=>{
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type)=>{
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return util_js_1.util.objectValues(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else if (type instanceof ZodOptional) return [
        undefined,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodNullable) return [
        null,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodBranded) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodReadonly) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodCatch) return getDiscriminator(type._def.innerType);
    else return [];
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.object) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params)
        });
    }
}
exports.ZodDiscriminatedUnion = ZodDiscriminatedUnion;
function mergeValues(a, b) {
    const aType = (0, util_js_1.getParsedType)(a);
    const bType = (0, util_js_1.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === util_js_1.ZodParsedType.object && bType === util_js_1.ZodParsedType.object) {
        const bKeys = util_js_1.util.objectKeys(b);
        const sharedKeys = util_js_1.util.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === util_js_1.ZodParsedType.array && bType === util_js_1.ZodParsedType.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === util_js_1.ZodParsedType.date && bType === util_js_1.ZodParsedType.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, parseUtil_js_1.isAborted)(parsedLeft) || (0, parseUtil_js_1.isAborted)(parsedRight)) return parseUtil_js_1.INVALID;
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.invalid_intersection_types
                });
                return parseUtil_js_1.INVALID;
            }
            if ((0, parseUtil_js_1.isDirty)(parsedLeft) || (0, parseUtil_js_1.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
exports.ZodIntersection = ZodIntersection;
ZodIntersection.create = (left, right, params)=>{
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params)
    });
};
// type ZodTupleItems = [ZodTypeAny, ...ZodTypeAny[]];
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.array) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.array,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return parseUtil_js_1.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return parseUtil_js_1.ParseStatus.mergeArray(status, results);
        });
        else return parseUtil_js_1.ParseStatus.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest
        });
    }
}
exports.ZodTuple = ZodTuple;
ZodTuple.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params)
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.object) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.object,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return parseUtil_js_1.ParseStatus.mergeObjectAsync(status, pairs);
        else return parseUtil_js_1.ParseStatus.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) return new ZodRecord({
            keyType: first,
            valueType: second,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(third)
        });
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second)
        });
    }
}
exports.ZodRecord = ZodRecord;
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.map) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.map,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return parseUtil_js_1.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return parseUtil_js_1.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
exports.ZodMap = ZodMap;
ZodMap.create = (keyType, valueType, params)=>{
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params)
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.set) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.set,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, parseUtil_js_1.addIssueToContext)(ctx, {
                    code: ZodError_js_1.ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return parseUtil_js_1.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: {
                value: minSize,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: errorUtil_js_1.errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
exports.ZodSet = ZodSet;
ZodSet.create = (valueType, params)=>{
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params)
    });
};
class ZodFunction extends ZodType {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.function) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.function,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, parseUtil_js_1.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, errors_js_1.getErrorMap)(),
                    errors_js_1.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodError_js_1.ZodIssueCode.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, parseUtil_js_1.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, errors_js_1.getErrorMap)(),
                    errors_js_1.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: ZodError_js_1.ZodIssueCode.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, parseUtil_js_1.OK)(async function(...args) {
                const error = new ZodError_js_1.ZodError([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, parseUtil_js_1.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new ZodError_js_1.ZodError([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new ZodError_js_1.ZodError([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create())
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params)
        });
    }
}
exports.ZodFunction = ZodFunction;
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
exports.ZodLazy = ZodLazy;
ZodLazy.create = (getter, params)=>{
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params)
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_literal,
                expected: this._def.value
            });
            return parseUtil_js_1.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
exports.ZodLiteral = ZodLiteral;
ZodLiteral.create = (value, params)=>{
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params)
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params)
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                expected: util_js_1.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodError_js_1.ZodIssueCode.invalid_type
            });
            return parseUtil_js_1.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
exports.ZodEnum = ZodEnum;
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util_js_1.util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.string && ctx.parsedType !== util_js_1.ZodParsedType.number) {
            const expectedValues = util_js_1.util.objectValues(nativeEnumValues);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                expected: util_js_1.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodError_js_1.ZodIssueCode.invalid_type
            });
            return parseUtil_js_1.INVALID;
        }
        if (!this._cache) this._cache = new Set(util_js_1.util.getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = util_js_1.util.objectValues(nativeEnumValues);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                received: ctx.data,
                code: ZodError_js_1.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return parseUtil_js_1.INVALID;
        }
        return (0, parseUtil_js_1.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
exports.ZodNativeEnum = ZodNativeEnum;
ZodNativeEnum.create = (values, params)=>{
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params)
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== util_js_1.ZodParsedType.promise && ctx.common.async === false) {
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.promise,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        const promisified = ctx.parsedType === util_js_1.ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, parseUtil_js_1.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
exports.ZodPromise = ZodPromise;
ZodPromise.create = (schema, params)=>{
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params)
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, parseUtil_js_1.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return parseUtil_js_1.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return parseUtil_js_1.INVALID;
                if (result.status === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                if (status.value === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return parseUtil_js_1.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return parseUtil_js_1.INVALID;
                if (result.status === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                if (status.value === "dirty") return (0, parseUtil_js_1.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return parseUtil_js_1.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return parseUtil_js_1.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, parseUtil_js_1.isValid)(base)) return parseUtil_js_1.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, parseUtil_js_1.isValid)(base)) return parseUtil_js_1.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        util_js_1.util.assertNever(effect);
    }
}
exports.ZodEffects = ZodEffects;
exports.ZodTransformer = ZodEffects;
ZodEffects.create = (schema, effect, params)=>{
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params)
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params)=>{
    return new ZodEffects({
        schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params)
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === util_js_1.ZodParsedType.undefined) return (0, parseUtil_js_1.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodOptional = ZodOptional;
ZodOptional.create = (type, params)=>{
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params)
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === util_js_1.ZodParsedType.null) return (0, parseUtil_js_1.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodNullable = ZodNullable;
ZodNullable.create = (type, params)=>{
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params)
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === util_js_1.ZodParsedType.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
exports.ZodDefault = ZodDefault;
ZodDefault.create = (type, params)=>{
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...processCreateParams(params)
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, parseUtil_js_1.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new ZodError_js_1.ZodError(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new ZodError_js_1.ZodError(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
exports.ZodCatch = ZodCatch;
ZodCatch.create = (type, params)=>{
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...processCreateParams(params)
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== util_js_1.ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, parseUtil_js_1.addIssueToContext)(ctx, {
                code: ZodError_js_1.ZodIssueCode.invalid_type,
                expected: util_js_1.ZodParsedType.nan,
                received: ctx.parsedType
            });
            return parseUtil_js_1.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
exports.ZodNaN = ZodNaN;
ZodNaN.create = (params)=>{
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params)
    });
};
exports.BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
exports.ZodBranded = ZodBranded;
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return parseUtil_js_1.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, parseUtil_js_1.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return parseUtil_js_1.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline
        });
    }
}
exports.ZodPipeline = ZodPipeline;
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, parseUtil_js_1.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, parseUtil_js_1.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
exports.ZodReadonly = ZodReadonly;
ZodReadonly.create = (type, params)=>{
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function custom(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return ZodAny.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return ZodAny.create();
}
exports.late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (exports.ZodFirstPartyTypeKind = ZodFirstPartyTypeKind = {}));
// requires TS 4.4+
class Class {
    constructor(..._){}
}
const instanceOfType = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>custom((data)=>data instanceof cls, params);
exports.instanceof = instanceOfType;
const stringType = ZodString.create;
exports.string = stringType;
const numberType = ZodNumber.create;
exports.number = numberType;
const nanType = ZodNaN.create;
exports.nan = nanType;
const bigIntType = ZodBigInt.create;
exports.bigint = bigIntType;
const booleanType = ZodBoolean.create;
exports.boolean = booleanType;
const dateType = ZodDate.create;
exports.date = dateType;
const symbolType = ZodSymbol.create;
exports.symbol = symbolType;
const undefinedType = ZodUndefined.create;
exports.undefined = undefinedType;
const nullType = ZodNull.create;
exports.null = nullType;
const anyType = ZodAny.create;
exports.any = anyType;
const unknownType = ZodUnknown.create;
exports.unknown = unknownType;
const neverType = ZodNever.create;
exports.never = neverType;
const voidType = ZodVoid.create;
exports.void = voidType;
const arrayType = ZodArray.create;
exports.array = arrayType;
const objectType = ZodObject.create;
exports.object = objectType;
const strictObjectType = ZodObject.strictCreate;
exports.strictObject = strictObjectType;
const unionType = ZodUnion.create;
exports.union = unionType;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
exports.discriminatedUnion = discriminatedUnionType;
const intersectionType = ZodIntersection.create;
exports.intersection = intersectionType;
const tupleType = ZodTuple.create;
exports.tuple = tupleType;
const recordType = ZodRecord.create;
exports.record = recordType;
const mapType = ZodMap.create;
exports.map = mapType;
const setType = ZodSet.create;
exports.set = setType;
const functionType = ZodFunction.create;
exports.function = functionType;
const lazyType = ZodLazy.create;
exports.lazy = lazyType;
const literalType = ZodLiteral.create;
exports.literal = literalType;
const enumType = ZodEnum.create;
exports.enum = enumType;
const nativeEnumType = ZodNativeEnum.create;
exports.nativeEnum = nativeEnumType;
const promiseType = ZodPromise.create;
exports.promise = promiseType;
const effectsType = ZodEffects.create;
exports.effect = effectsType;
exports.transformer = effectsType;
const optionalType = ZodOptional.create;
exports.optional = optionalType;
const nullableType = ZodNullable.create;
exports.nullable = nullableType;
const preprocessType = ZodEffects.createWithPreprocess;
exports.preprocess = preprocessType;
const pipelineType = ZodPipeline.create;
exports.pipeline = pipelineType;
const ostring = ()=>stringType().optional();
exports.ostring = ostring;
const onumber = ()=>numberType().optional();
exports.onumber = onumber;
const oboolean = ()=>booleanType().optional();
exports.oboolean = oboolean;
exports.coerce = {
    string: (arg)=>ZodString.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>ZodNumber.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>ZodBoolean.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>ZodBigInt.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>ZodDate.create({
            ...arg,
            coerce: true
        })
};
exports.NEVER = parseUtil_js_1.INVALID;

},{"b3610e3cd6af6af1":"1inZo","bdd45173b55f3e51":"6myP3","f296269cfb0dc64e":"63gNk","4246a3c9b44a4cbe":"i36Y5","ec587fb60306375d":"8PCSj"}],"63gNk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.errorUtil = void 0;
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})(errorUtil || (exports.errorUtil = errorUtil = {}));

},{}],"iILcw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.XrpcClient = void 0;
const lexicon_1 = require("131a4c95c0bb2263");
const fetch_handler_1 = require("bc5bcd64043af30c");
const types_1 = require("65c68da84d5bdb77");
const util_1 = require("5f7c72cdbec1cae9");
class XrpcClient {
    constructor(fetchHandlerOpts, // "Lexicons" is redundant here (because that class implements
    // "Iterable<LexiconDoc>") but we keep it for explicitness:
    lex){
        Object.defineProperty(this, "fetchHandler", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "lex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.fetchHandler = (0, fetch_handler_1.buildFetchHandler)(fetchHandlerOpts);
        this.lex = lex instanceof lexicon_1.Lexicons ? lex : new lexicon_1.Lexicons(lex);
    }
    setHeader(key, value) {
        this.headers.set(key.toLowerCase(), value);
    }
    unsetHeader(key) {
        this.headers.delete(key.toLowerCase());
    }
    clearHeaders() {
        this.headers.clear();
    }
    async call(methodNsid, params, data, opts) {
        const def = this.lex.getDefOrThrow(methodNsid);
        if (!def || def.type !== 'query' && def.type !== 'procedure') throw new TypeError(`Invalid lexicon: ${methodNsid}. Must be a query or procedure.`);
        // @TODO: should we validate the params and data here?
        // this.lex.assertValidXrpcParams(methodNsid, params)
        // if (data !== undefined) {
        //   this.lex.assertValidXrpcInput(methodNsid, data)
        // }
        const reqUrl = (0, util_1.constructMethodCallUrl)(methodNsid, def, params);
        const reqMethod = (0, util_1.getMethodSchemaHTTPMethod)(def);
        const reqHeaders = (0, util_1.constructMethodCallHeaders)(def, data, opts);
        const reqBody = (0, util_1.encodeMethodCallBody)(reqHeaders, data);
        // The duplex field is required for streaming bodies, but not yet reflected
        // anywhere in docs or types. See whatwg/fetch#1438, nodejs/node#46221.
        const init = {
            method: reqMethod,
            headers: (0, util_1.combineHeaders)(reqHeaders, this.headers),
            body: reqBody,
            duplex: 'half',
            redirect: 'follow',
            signal: opts?.signal
        };
        try {
            const response = await this.fetchHandler.call(undefined, reqUrl, init);
            const resStatus = response.status;
            const resHeaders = Object.fromEntries(response.headers.entries());
            const resBodyBytes = await response.arrayBuffer();
            const resBody = (0, util_1.httpResponseBodyParse)(response.headers.get('content-type'), resBodyBytes);
            const resCode = (0, types_1.httpResponseCodeToEnum)(resStatus);
            if (resCode !== types_1.ResponseType.Success) {
                const { error, message } = resBody && (0, util_1.isErrorResponseBody)(resBody) ? resBody : {};
                throw new types_1.XRPCError(resCode, error, message, resHeaders);
            }
            try {
                this.lex.assertValidXrpcOutput(methodNsid, resBody);
            } catch (e) {
                if (e instanceof lexicon_1.ValidationError) throw new types_1.XRPCInvalidResponseError(methodNsid, e, resBody);
                throw e;
            }
            return new types_1.XRPCResponse(resBody, resHeaders);
        } catch (err) {
            throw types_1.XRPCError.from(err);
        }
    }
}
exports.XrpcClient = XrpcClient;

},{"131a4c95c0bb2263":"aBnF9","bc5bcd64043af30c":"6Od8p","65c68da84d5bdb77":"g90cV","5f7c72cdbec1cae9":"gBA26"}],"6Od8p":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildFetchHandler = buildFetchHandler;
const util_1 = require("5d37e6ff5ebc07f4");
function buildFetchHandler(options) {
    // Already a fetch handler (allowed for convenience)
    if (typeof options === 'function') return options;
    if (typeof options === 'object' && 'fetchHandler' in options) return options.fetchHandler.bind(options);
    const { service, headers: defaultHeaders, fetch = globalThis.fetch } = typeof options === 'string' || options instanceof URL ? {
        service: options
    } : options;
    if (typeof fetch !== 'function') throw new TypeError('XrpcDispatcher requires fetch() to be available in your environment.');
    const defaultHeadersEntries = defaultHeaders != null ? Object.entries(defaultHeaders) : undefined;
    return async function(url, init) {
        const base = typeof service === 'function' ? service() : service;
        const fullUrl = new URL(url, base);
        const headers = (0, util_1.combineHeaders)(init.headers, defaultHeadersEntries);
        return fetch(fullUrl, {
            ...init,
            headers
        });
    };
}

},{"5d37e6ff5ebc07f4":"gBA26"}],"gAwq2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnsupportedCollectionError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("e3251104ed37e7f0");
const lexicons_1 = require("d3215052a3947d30");
const util_1 = require("517e571043afcfc3");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.bookmark.createBookmark';
class UnsupportedCollectionError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.UnsupportedCollectionError = UnsupportedCollectionError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'UnsupportedCollection') return new UnsupportedCollectionError(e);
    }
    return e;
}

},{"e3251104ed37e7f0":"3J4dg","d3215052a3947d30":"4ClhN","517e571043afcfc3":"45ZSh"}],"2ziro":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnsupportedCollectionError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("83868011fca049ac");
const lexicons_1 = require("a306b4ae3ee56b5c");
const util_1 = require("19fd4a036f133a2e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.bookmark.deleteBookmark';
class UnsupportedCollectionError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.UnsupportedCollectionError = UnsupportedCollectionError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'UnsupportedCollection') return new UnsupportedCollectionError(e);
    }
    return e;
}

},{"83868011fca049ac":"3J4dg","a306b4ae3ee56b5c":"4ClhN","19fd4a036f133a2e":"45ZSh"}],"5xM4s":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BlockedByActorError = exports.BlockedActorError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("5f2ef23b306b8ef");
const lexicons_1 = require("4458f1879cdbbcf5");
const util_1 = require("6f72da22bf99d84f");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getActorLikes';
class BlockedActorError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.BlockedActorError = BlockedActorError;
class BlockedByActorError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.BlockedByActorError = BlockedByActorError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'BlockedActor') return new BlockedActorError(e);
        if (e.error === 'BlockedByActor') return new BlockedByActorError(e);
    }
    return e;
}

},{"5f2ef23b306b8ef":"3J4dg","4458f1879cdbbcf5":"4ClhN","6f72da22bf99d84f":"45ZSh"}],"2RaxF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BlockedByActorError = exports.BlockedActorError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("2625e29abe6857d");
const lexicons_1 = require("896e2d1673201f00");
const util_1 = require("61b339de744e4dcd");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getAuthorFeed';
class BlockedActorError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.BlockedActorError = BlockedActorError;
class BlockedByActorError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.BlockedByActorError = BlockedByActorError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'BlockedActor') return new BlockedActorError(e);
        if (e.error === 'BlockedByActor') return new BlockedByActorError(e);
    }
    return e;
}

},{"2625e29abe6857d":"3J4dg","896e2d1673201f00":"4ClhN","61b339de744e4dcd":"45ZSh"}],"1rvdF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnknownFeedError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("334d1a2f2502312c");
const lexicons_1 = require("3cfcf1c90c168e19");
const util_1 = require("23fcbe0dd04d5e21");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getFeed';
class UnknownFeedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.UnknownFeedError = UnknownFeedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'UnknownFeed') return new UnknownFeedError(e);
    }
    return e;
}

},{"334d1a2f2502312c":"3J4dg","3cfcf1c90c168e19":"4ClhN","23fcbe0dd04d5e21":"45ZSh"}],"8iEWZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnknownFeedError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("66f1dd769fc13e29");
const lexicons_1 = require("6c3c216d8dfe50e5");
const util_1 = require("5d7b5ffebb4b84f7");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getFeedSkeleton';
class UnknownFeedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.UnknownFeedError = UnknownFeedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'UnknownFeed') return new UnknownFeedError(e);
    }
    return e;
}

},{"66f1dd769fc13e29":"3J4dg","6c3c216d8dfe50e5":"4ClhN","5d7b5ffebb4b84f7":"45ZSh"}],"lhDui":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnknownListError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("2fdb2e2338d4da92");
const lexicons_1 = require("729821ab343f1993");
const util_1 = require("534fe40f91e56784");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getListFeed';
class UnknownListError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.UnknownListError = UnknownListError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'UnknownList') return new UnknownListError(e);
    }
    return e;
}

},{"2fdb2e2338d4da92":"3J4dg","729821ab343f1993":"4ClhN","534fe40f91e56784":"45ZSh"}],"5jIzX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("d48949acb8abed79");
const lexicons_1 = require("4ccc0141aa125188");
const util_1 = require("a0cbeb6f7c7c3b5f");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getPostThread';
class NotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.NotFoundError = NotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'NotFound') return new NotFoundError(e);
    }
    return e;
}

},{"d48949acb8abed79":"3J4dg","4ccc0141aa125188":"4ClhN","a0cbeb6f7c7c3b5f":"45ZSh"}],"lmcZG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BadQueryStringError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("7cbd6f4b1c1ef6d7");
const lexicons_1 = require("9fd197c004612b3f");
const util_1 = require("8ddb071a4a5297ae");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.searchPosts';
class BadQueryStringError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.BadQueryStringError = BadQueryStringError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'BadQueryString') return new BadQueryStringError(e);
    }
    return e;
}

},{"7cbd6f4b1c1ef6d7":"3J4dg","9fd197c004612b3f":"4ClhN","8ddb071a4a5297ae":"45ZSh"}],"jJ6eS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ActorNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("ebce2b71f8ccad11");
const lexicons_1 = require("8e1bd1250c6d2147");
const util_1 = require("26a661fc864e89c3");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getRelationships';
class ActorNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.ActorNotFoundError = ActorNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'ActorNotFound') return new ActorNotFoundError(e);
    }
    return e;
}

},{"ebce2b71f8ccad11":"3J4dg","8e1bd1250c6d2147":"4ClhN","26a661fc864e89c3":"45ZSh"}],"cSywb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidInitiationError = exports.DidTooLongError = exports.InvalidEmailError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("4c1efcc35c45c563");
const lexicons_1 = require("bcb460c8eb2ceeeb");
const util_1 = require("6785996051c0f565");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.initAgeAssurance';
class InvalidEmailError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidEmailError = InvalidEmailError;
class DidTooLongError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.DidTooLongError = DidTooLongError;
class InvalidInitiationError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidInitiationError = InvalidInitiationError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'InvalidEmail') return new InvalidEmailError(e);
        if (e.error === 'DidTooLong') return new DidTooLongError(e);
        if (e.error === 'InvalidInitiation') return new InvalidInitiationError(e);
    }
    return e;
}

},{"4c1efcc35c45c563":"3J4dg","bcb460c8eb2ceeeb":"4ClhN","6785996051c0f565":"45ZSh"}],"6ib8d":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BadQueryStringError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("af44556fd5e591ac");
const lexicons_1 = require("9464704c1f4f8839");
const util_1 = require("694048dbed3ccc29");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.searchActorsSkeleton';
class BadQueryStringError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.BadQueryStringError = BadQueryStringError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'BadQueryString') return new BadQueryStringError(e);
    }
    return e;
}

},{"af44556fd5e591ac":"3J4dg","9464704c1f4f8839":"4ClhN","694048dbed3ccc29":"45ZSh"}],"7jE1P":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BadQueryStringError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("d439a4ccad73569e");
const lexicons_1 = require("c2d8c3daf604c913");
const util_1 = require("8a99006c31fd2104");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.searchPostsSkeleton';
class BadQueryStringError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.BadQueryStringError = BadQueryStringError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'BadQueryString') return new BadQueryStringError(e);
    }
    return e;
}

},{"d439a4ccad73569e":"3J4dg","c2d8c3daf604c913":"4ClhN","8a99006c31fd2104":"45ZSh"}],"dIofs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BadQueryStringError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("f975d6e7f4891122");
const lexicons_1 = require("41802ecb6773902a");
const util_1 = require("d1e7292ecc9b4712");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.searchStarterPacksSkeleton';
class BadQueryStringError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.BadQueryStringError = BadQueryStringError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'BadQueryString') return new BadQueryStringError(e);
    }
    return e;
}

},{"f975d6e7f4891122":"3J4dg","41802ecb6773902a":"4ClhN","d1e7292ecc9b4712":"45ZSh"}],"eYNpg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReactionInvalidValueError = exports.ReactionLimitReachedError = exports.ReactionMessageDeletedError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("e7067e4886d0b4de");
const lexicons_1 = require("f811adf145931a6c");
const util_1 = require("f8bea7d2c795ac49");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.addReaction';
class ReactionMessageDeletedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.ReactionMessageDeletedError = ReactionMessageDeletedError;
class ReactionLimitReachedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.ReactionLimitReachedError = ReactionLimitReachedError;
class ReactionInvalidValueError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.ReactionInvalidValueError = ReactionInvalidValueError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'ReactionMessageDeleted') return new ReactionMessageDeletedError(e);
        if (e.error === 'ReactionLimitReached') return new ReactionLimitReachedError(e);
        if (e.error === 'ReactionInvalidValue') return new ReactionInvalidValueError(e);
    }
    return e;
}

},{"e7067e4886d0b4de":"3J4dg","f811adf145931a6c":"4ClhN","f8bea7d2c795ac49":"45ZSh"}],"jQfoy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReactionInvalidValueError = exports.ReactionMessageDeletedError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("c2a5e0e6c43d6aef");
const lexicons_1 = require("5935ee251882966d");
const util_1 = require("fea73ed22d12e279");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.removeReaction';
class ReactionMessageDeletedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.ReactionMessageDeletedError = ReactionMessageDeletedError;
class ReactionInvalidValueError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.ReactionInvalidValueError = ReactionInvalidValueError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'ReactionMessageDeleted') return new ReactionMessageDeletedError(e);
        if (e.error === 'ReactionInvalidValue') return new ReactionInvalidValueError(e);
    }
    return e;
}

},{"c2a5e0e6c43d6aef":"3J4dg","5935ee251882966d":"4ClhN","fea73ed22d12e279":"45ZSh"}],"jAakA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DidDeactivatedError = exports.DidNotFoundError = exports.HandleNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("fda2cce0ddc8fe3");
const lexicons_1 = require("bd649af937976de5");
const util_1 = require("7b63b5aabeaa05d4");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.identity.refreshIdentity';
class HandleNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.HandleNotFoundError = HandleNotFoundError;
class DidNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.DidNotFoundError = DidNotFoundError;
class DidDeactivatedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.DidDeactivatedError = DidDeactivatedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'HandleNotFound') return new HandleNotFoundError(e);
        if (e.error === 'DidNotFound') return new DidNotFoundError(e);
        if (e.error === 'DidDeactivated') return new DidDeactivatedError(e);
    }
    return e;
}

},{"fda2cce0ddc8fe3":"3J4dg","bd649af937976de5":"4ClhN","7b63b5aabeaa05d4":"45ZSh"}],"iKB1Y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DidDeactivatedError = exports.DidNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("189efc0974ca6937");
const lexicons_1 = require("ffcfe689bf2f1b71");
const util_1 = require("38490b1accb7588a");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.identity.resolveDid';
class DidNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.DidNotFoundError = DidNotFoundError;
class DidDeactivatedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.DidDeactivatedError = DidDeactivatedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'DidNotFound') return new DidNotFoundError(e);
        if (e.error === 'DidDeactivated') return new DidDeactivatedError(e);
    }
    return e;
}

},{"189efc0974ca6937":"3J4dg","ffcfe689bf2f1b71":"4ClhN","38490b1accb7588a":"45ZSh"}],"d6gcu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HandleNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("9ce929f81d3d9106");
const lexicons_1 = require("b3c1d19b2cf4c718");
const util_1 = require("f68875cc3689d23a");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.identity.resolveHandle';
class HandleNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.HandleNotFoundError = HandleNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'HandleNotFound') return new HandleNotFoundError(e);
    }
    return e;
}

},{"9ce929f81d3d9106":"3J4dg","b3c1d19b2cf4c718":"4ClhN","f68875cc3689d23a":"45ZSh"}],"cCVI5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DidDeactivatedError = exports.DidNotFoundError = exports.HandleNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("c6fbb27576b4345b");
const lexicons_1 = require("cec072c282b4338c");
const util_1 = require("9d7b1f08007f45ec");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.identity.resolveIdentity';
class HandleNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.HandleNotFoundError = HandleNotFoundError;
class DidNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.DidNotFoundError = DidNotFoundError;
class DidDeactivatedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.DidDeactivatedError = DidDeactivatedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'HandleNotFound') return new HandleNotFoundError(e);
        if (e.error === 'DidNotFound') return new DidNotFoundError(e);
        if (e.error === 'DidDeactivated') return new DidDeactivatedError(e);
    }
    return e;
}

},{"c6fbb27576b4345b":"3J4dg","cec072c282b4338c":"4ClhN","9d7b1f08007f45ec":"45ZSh"}],"aJakc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidSwapError = void 0;
exports.toKnownErr = toKnownErr;
exports.isCreate = isCreate;
exports.validateCreate = validateCreate;
exports.isUpdate = isUpdate;
exports.validateUpdate = validateUpdate;
exports.isDelete = isDelete;
exports.validateDelete = validateDelete;
exports.isCreateResult = isCreateResult;
exports.validateCreateResult = validateCreateResult;
exports.isUpdateResult = isUpdateResult;
exports.validateUpdateResult = validateUpdateResult;
exports.isDeleteResult = isDeleteResult;
exports.validateDeleteResult = validateDeleteResult;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("c78d848047b55915");
const lexicons_1 = require("5d50d79865cc2a");
const util_1 = require("52d9a33a66f87a15");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.applyWrites';
class InvalidSwapError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidSwapError = InvalidSwapError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'InvalidSwap') return new InvalidSwapError(e);
    }
    return e;
}
const hashCreate = 'create';
function isCreate(v) {
    return is$typed(v, id, hashCreate);
}
function validateCreate(v) {
    return validate(v, id, hashCreate);
}
const hashUpdate = 'update';
function isUpdate(v) {
    return is$typed(v, id, hashUpdate);
}
function validateUpdate(v) {
    return validate(v, id, hashUpdate);
}
const hashDelete = 'delete';
function isDelete(v) {
    return is$typed(v, id, hashDelete);
}
function validateDelete(v) {
    return validate(v, id, hashDelete);
}
const hashCreateResult = 'createResult';
function isCreateResult(v) {
    return is$typed(v, id, hashCreateResult);
}
function validateCreateResult(v) {
    return validate(v, id, hashCreateResult);
}
const hashUpdateResult = 'updateResult';
function isUpdateResult(v) {
    return is$typed(v, id, hashUpdateResult);
}
function validateUpdateResult(v) {
    return validate(v, id, hashUpdateResult);
}
const hashDeleteResult = 'deleteResult';
function isDeleteResult(v) {
    return is$typed(v, id, hashDeleteResult);
}
function validateDeleteResult(v) {
    return validate(v, id, hashDeleteResult);
}

},{"c78d848047b55915":"3J4dg","5d50d79865cc2a":"4ClhN","52d9a33a66f87a15":"45ZSh"}],"1wK6d":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidSwapError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("ada4d4bddb4fd6f5");
const lexicons_1 = require("59caca7657395d11");
const util_1 = require("ff9bc7e2bd1ab2d0");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.createRecord';
class InvalidSwapError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidSwapError = InvalidSwapError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'InvalidSwap') return new InvalidSwapError(e);
    }
    return e;
}

},{"ada4d4bddb4fd6f5":"3J4dg","59caca7657395d11":"4ClhN","ff9bc7e2bd1ab2d0":"45ZSh"}],"jHbgW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidSwapError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("3bb644e1124b6402");
const lexicons_1 = require("63a08f4cf4c338a2");
const util_1 = require("e7194edf890509f9");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.deleteRecord';
class InvalidSwapError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidSwapError = InvalidSwapError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'InvalidSwap') return new InvalidSwapError(e);
    }
    return e;
}

},{"3bb644e1124b6402":"3J4dg","63a08f4cf4c338a2":"4ClhN","e7194edf890509f9":"45ZSh"}],"15DKb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RecordNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("5c84fb0a70c2e97a");
const lexicons_1 = require("9f782010eb121621");
const util_1 = require("c6fa63079239fb7e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.getRecord';
class RecordNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RecordNotFoundError = RecordNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'RecordNotFound') return new RecordNotFoundError(e);
    }
    return e;
}

},{"5c84fb0a70c2e97a":"3J4dg","9f782010eb121621":"4ClhN","c6fa63079239fb7e":"45ZSh"}],"4Sdpp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidSwapError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("1e159fb0eaf3dcb7");
const lexicons_1 = require("e23c54557b18b2d4");
const util_1 = require("298932c94cca8225");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.putRecord';
class InvalidSwapError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidSwapError = InvalidSwapError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'InvalidSwap') return new InvalidSwapError(e);
    }
    return e;
}

},{"1e159fb0eaf3dcb7":"3J4dg","e23c54557b18b2d4":"4ClhN","298932c94cca8225":"45ZSh"}],"iUuCT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidEmailError = exports.InvalidTokenError = exports.ExpiredTokenError = exports.AccountNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("76906d95d157e373");
const lexicons_1 = require("bee85994b494985e");
const util_1 = require("b5862213901eb25f");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.confirmEmail';
class AccountNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.AccountNotFoundError = AccountNotFoundError;
class ExpiredTokenError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.ExpiredTokenError = ExpiredTokenError;
class InvalidTokenError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidTokenError = InvalidTokenError;
class InvalidEmailError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidEmailError = InvalidEmailError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'AccountNotFound') return new AccountNotFoundError(e);
        if (e.error === 'ExpiredToken') return new ExpiredTokenError(e);
        if (e.error === 'InvalidToken') return new InvalidTokenError(e);
        if (e.error === 'InvalidEmail') return new InvalidEmailError(e);
    }
    return e;
}

},{"76906d95d157e373":"3J4dg","bee85994b494985e":"4ClhN","b5862213901eb25f":"45ZSh"}],"4xYY0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IncompatibleDidDocError = exports.UnresolvableDidError = exports.UnsupportedDomainError = exports.HandleNotAvailableError = exports.InvalidInviteCodeError = exports.InvalidPasswordError = exports.InvalidHandleError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("ca2381e23526b330");
const lexicons_1 = require("a22cf4aed3c97792");
const util_1 = require("f2c2f33ec5b73cb4");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.createAccount';
class InvalidHandleError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidHandleError = InvalidHandleError;
class InvalidPasswordError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidPasswordError = InvalidPasswordError;
class InvalidInviteCodeError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidInviteCodeError = InvalidInviteCodeError;
class HandleNotAvailableError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.HandleNotAvailableError = HandleNotAvailableError;
class UnsupportedDomainError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.UnsupportedDomainError = UnsupportedDomainError;
class UnresolvableDidError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.UnresolvableDidError = UnresolvableDidError;
class IncompatibleDidDocError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.IncompatibleDidDocError = IncompatibleDidDocError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'InvalidHandle') return new InvalidHandleError(e);
        if (e.error === 'InvalidPassword') return new InvalidPasswordError(e);
        if (e.error === 'InvalidInviteCode') return new InvalidInviteCodeError(e);
        if (e.error === 'HandleNotAvailable') return new HandleNotAvailableError(e);
        if (e.error === 'UnsupportedDomain') return new UnsupportedDomainError(e);
        if (e.error === 'UnresolvableDid') return new UnresolvableDidError(e);
        if (e.error === 'IncompatibleDidDoc') return new IncompatibleDidDocError(e);
    }
    return e;
}

},{"ca2381e23526b330":"3J4dg","a22cf4aed3c97792":"4ClhN","f2c2f33ec5b73cb4":"45ZSh"}],"8263w":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AccountTakedownError = void 0;
exports.toKnownErr = toKnownErr;
exports.isAppPassword = isAppPassword;
exports.validateAppPassword = validateAppPassword;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("afac8d2073290c8c");
const lexicons_1 = require("20e9ce5d643215f9");
const util_1 = require("a06966e1b9be859c");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.createAppPassword';
class AccountTakedownError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.AccountTakedownError = AccountTakedownError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'AccountTakedown') return new AccountTakedownError(e);
    }
    return e;
}
const hashAppPassword = 'appPassword';
function isAppPassword(v) {
    return is$typed(v, id, hashAppPassword);
}
function validateAppPassword(v) {
    return validate(v, id, hashAppPassword);
}

},{"afac8d2073290c8c":"3J4dg","20e9ce5d643215f9":"4ClhN","a06966e1b9be859c":"45ZSh"}],"8Qp2Z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IncompatibleDidDocError = exports.UnresolvableDidError = exports.UnsupportedDomainError = exports.HandleNotAvailableError = exports.InvalidJwtTokenError = void 0;
exports.toKnownErr = toKnownErr;
exports.isJwtOptions = isJwtOptions;
exports.validateJwtOptions = validateJwtOptions;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("201dd016dbf3db8d");
const lexicons_1 = require("db101bc9c6733036");
const util_1 = require("fa6bb8771226dc0f");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.createCustomJwtSession';
class InvalidJwtTokenError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidJwtTokenError = InvalidJwtTokenError;
class HandleNotAvailableError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.HandleNotAvailableError = HandleNotAvailableError;
class UnsupportedDomainError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.UnsupportedDomainError = UnsupportedDomainError;
class UnresolvableDidError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.UnresolvableDidError = UnresolvableDidError;
class IncompatibleDidDocError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.IncompatibleDidDocError = IncompatibleDidDocError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'InvalidJwtToken') return new InvalidJwtTokenError(e);
        if (e.error === 'HandleNotAvailable') return new HandleNotAvailableError(e);
        if (e.error === 'UnsupportedDomain') return new UnsupportedDomainError(e);
        if (e.error === 'UnresolvableDid') return new UnresolvableDidError(e);
        if (e.error === 'IncompatibleDidDoc') return new IncompatibleDidDocError(e);
    }
    return e;
}
const hashJwtOptions = 'jwtOptions';
function isJwtOptions(v) {
    return is$typed(v, id, hashJwtOptions);
}
function validateJwtOptions(v) {
    return validate(v, id, hashJwtOptions);
}

},{"201dd016dbf3db8d":"3J4dg","db101bc9c6733036":"4ClhN","fa6bb8771226dc0f":"45ZSh"}],"gfTct":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthFactorTokenRequiredError = exports.AccountTakedownError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("873b4e940866d121");
const lexicons_1 = require("d72c9bac28c7f642");
const util_1 = require("6b9dbc406ac841a6");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.createSession';
class AccountTakedownError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.AccountTakedownError = AccountTakedownError;
class AuthFactorTokenRequiredError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.AuthFactorTokenRequiredError = AuthFactorTokenRequiredError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'AccountTakedown') return new AccountTakedownError(e);
        if (e.error === 'AuthFactorTokenRequired') return new AuthFactorTokenRequiredError(e);
    }
    return e;
}

},{"873b4e940866d121":"3J4dg","d72c9bac28c7f642":"4ClhN","6b9dbc406ac841a6":"45ZSh"}],"cnxXm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidTokenError = exports.ExpiredTokenError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("3abe31fb994fff35");
const lexicons_1 = require("dc7f31544e57f89");
const util_1 = require("abf4449e10c6fdc5");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.deleteAccount';
class ExpiredTokenError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.ExpiredTokenError = ExpiredTokenError;
class InvalidTokenError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidTokenError = InvalidTokenError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'ExpiredToken') return new ExpiredTokenError(e);
        if (e.error === 'InvalidToken') return new InvalidTokenError(e);
    }
    return e;
}

},{"3abe31fb994fff35":"3J4dg","dc7f31544e57f89":"4ClhN","abf4449e10c6fdc5":"45ZSh"}],"8wLL3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DuplicateCreateError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("d6f8aa86c2550aca");
const lexicons_1 = require("abb04903fad42ec9");
const util_1 = require("726b406e75d8ff2f");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.getAccountInviteCodes';
class DuplicateCreateError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.DuplicateCreateError = DuplicateCreateError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'DuplicateCreate') return new DuplicateCreateError(e);
    }
    return e;
}

},{"d6f8aa86c2550aca":"3J4dg","abb04903fad42ec9":"4ClhN","726b406e75d8ff2f":"45ZSh"}],"5M4TD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BadExpirationError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("1b863ad2f3e02d37");
const lexicons_1 = require("cbd60da19b664646");
const util_1 = require("e7ddb2991b8477b4");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.getServiceAuth';
class BadExpirationError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.BadExpirationError = BadExpirationError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'BadExpiration') return new BadExpirationError(e);
    }
    return e;
}

},{"1b863ad2f3e02d37":"3J4dg","cbd60da19b664646":"4ClhN","e7ddb2991b8477b4":"45ZSh"}],"cL6N8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AccountTakedownError = void 0;
exports.toKnownErr = toKnownErr;
exports.isAppPassword = isAppPassword;
exports.validateAppPassword = validateAppPassword;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("e995484349e69dc3");
const lexicons_1 = require("2a5e3f01855608de");
const util_1 = require("3f048adeff332c7a");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.listAppPasswords';
class AccountTakedownError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.AccountTakedownError = AccountTakedownError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'AccountTakedown') return new AccountTakedownError(e);
    }
    return e;
}
const hashAppPassword = 'appPassword';
function isAppPassword(v) {
    return is$typed(v, id, hashAppPassword);
}
function validateAppPassword(v) {
    return validate(v, id, hashAppPassword);
}

},{"e995484349e69dc3":"3J4dg","2a5e3f01855608de":"4ClhN","3f048adeff332c7a":"45ZSh"}],"gniX8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AccountTakedownError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("9867e2e9ccf15e06");
const lexicons_1 = require("1deba311651ccd37");
const util_1 = require("58f3f553eb009f64");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.refreshSession';
class AccountTakedownError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.AccountTakedownError = AccountTakedownError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'AccountTakedown') return new AccountTakedownError(e);
    }
    return e;
}

},{"9867e2e9ccf15e06":"3J4dg","1deba311651ccd37":"4ClhN","58f3f553eb009f64":"45ZSh"}],"aYqC6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidTokenError = exports.ExpiredTokenError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("b6fcbe3e6740de34");
const lexicons_1 = require("665522aa365f0463");
const util_1 = require("f8f7816f61799984");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.resetPassword';
class ExpiredTokenError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.ExpiredTokenError = ExpiredTokenError;
class InvalidTokenError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidTokenError = InvalidTokenError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'ExpiredToken') return new ExpiredTokenError(e);
        if (e.error === 'InvalidToken') return new InvalidTokenError(e);
    }
    return e;
}

},{"b6fcbe3e6740de34":"3J4dg","665522aa365f0463":"4ClhN","f8f7816f61799984":"45ZSh"}],"1B7NR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TokenRequiredError = exports.InvalidTokenError = exports.ExpiredTokenError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("f9c39656c873055a");
const lexicons_1 = require("8d8a6982ad274699");
const util_1 = require("76b2b67891422af2");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.updateEmail';
class ExpiredTokenError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.ExpiredTokenError = ExpiredTokenError;
class InvalidTokenError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidTokenError = InvalidTokenError;
class TokenRequiredError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.TokenRequiredError = TokenRequiredError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'ExpiredToken') return new ExpiredTokenError(e);
        if (e.error === 'InvalidToken') return new InvalidTokenError(e);
        if (e.error === 'TokenRequired') return new TokenRequiredError(e);
    }
    return e;
}

},{"f9c39656c873055a":"3J4dg","8d8a6982ad274699":"4ClhN","76b2b67891422af2":"45ZSh"}],"iM1Za":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RepoDeactivatedError = exports.RepoSuspendedError = exports.RepoTakendownError = exports.RepoNotFoundError = exports.BlobNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("f6137cd27d2f5fa0");
const lexicons_1 = require("31fbaf5e64b045e9");
const util_1 = require("55fed5f0839559ac");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.getBlob';
class BlobNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.BlobNotFoundError = BlobNotFoundError;
class RepoNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoNotFoundError = RepoNotFoundError;
class RepoTakendownError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoTakendownError = RepoTakendownError;
class RepoSuspendedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoSuspendedError = RepoSuspendedError;
class RepoDeactivatedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoDeactivatedError = RepoDeactivatedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'BlobNotFound') return new BlobNotFoundError(e);
        if (e.error === 'RepoNotFound') return new RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new RepoDeactivatedError(e);
    }
    return e;
}

},{"f6137cd27d2f5fa0":"3J4dg","31fbaf5e64b045e9":"4ClhN","55fed5f0839559ac":"45ZSh"}],"itz1L":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RepoDeactivatedError = exports.RepoSuspendedError = exports.RepoTakendownError = exports.RepoNotFoundError = exports.BlockNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("53225dea4809fe1d");
const lexicons_1 = require("2c3580ff0654173a");
const util_1 = require("3e4fb833ada85f23");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.getBlocks';
class BlockNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.BlockNotFoundError = BlockNotFoundError;
class RepoNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoNotFoundError = RepoNotFoundError;
class RepoTakendownError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoTakendownError = RepoTakendownError;
class RepoSuspendedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoSuspendedError = RepoSuspendedError;
class RepoDeactivatedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoDeactivatedError = RepoDeactivatedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'BlockNotFound') return new BlockNotFoundError(e);
        if (e.error === 'RepoNotFound') return new RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new RepoDeactivatedError(e);
    }
    return e;
}

},{"53225dea4809fe1d":"3J4dg","2c3580ff0654173a":"4ClhN","3e4fb833ada85f23":"45ZSh"}],"7CfN9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HeadNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("fb2813bb750fd592");
const lexicons_1 = require("b841450873f563e3");
const util_1 = require("97c1c7a3605ad9a6");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.getHead';
class HeadNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.HeadNotFoundError = HeadNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'HeadNotFound') return new HeadNotFoundError(e);
    }
    return e;
}

},{"fb2813bb750fd592":"3J4dg","b841450873f563e3":"4ClhN","97c1c7a3605ad9a6":"45ZSh"}],"dwB9p":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HostNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("c895f949ef4d2061");
const lexicons_1 = require("1361792f2d394ebe");
const util_1 = require("491c0483db5797cf");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.getHostStatus';
class HostNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.HostNotFoundError = HostNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'HostNotFound') return new HostNotFoundError(e);
    }
    return e;
}

},{"c895f949ef4d2061":"3J4dg","1361792f2d394ebe":"4ClhN","491c0483db5797cf":"45ZSh"}],"5O8fC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RepoDeactivatedError = exports.RepoSuspendedError = exports.RepoTakendownError = exports.RepoNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("330b3fe7d077d7c6");
const lexicons_1 = require("baa2591a33aa36b7");
const util_1 = require("f0437bb5e689de97");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.getLatestCommit';
class RepoNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoNotFoundError = RepoNotFoundError;
class RepoTakendownError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoTakendownError = RepoTakendownError;
class RepoSuspendedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoSuspendedError = RepoSuspendedError;
class RepoDeactivatedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoDeactivatedError = RepoDeactivatedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'RepoNotFound') return new RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new RepoDeactivatedError(e);
    }
    return e;
}

},{"330b3fe7d077d7c6":"3J4dg","baa2591a33aa36b7":"4ClhN","f0437bb5e689de97":"45ZSh"}],"hiVCo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RepoDeactivatedError = exports.RepoSuspendedError = exports.RepoTakendownError = exports.RepoNotFoundError = exports.RecordNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("35f3b53613f04a1e");
const lexicons_1 = require("b3a5348c2cc7e526");
const util_1 = require("7159e4a76321d57a");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.getRecord';
class RecordNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RecordNotFoundError = RecordNotFoundError;
class RepoNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoNotFoundError = RepoNotFoundError;
class RepoTakendownError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoTakendownError = RepoTakendownError;
class RepoSuspendedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoSuspendedError = RepoSuspendedError;
class RepoDeactivatedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoDeactivatedError = RepoDeactivatedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'RecordNotFound') return new RecordNotFoundError(e);
        if (e.error === 'RepoNotFound') return new RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new RepoDeactivatedError(e);
    }
    return e;
}

},{"35f3b53613f04a1e":"3J4dg","b3a5348c2cc7e526":"4ClhN","7159e4a76321d57a":"45ZSh"}],"hWlVf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RepoDeactivatedError = exports.RepoSuspendedError = exports.RepoTakendownError = exports.RepoNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("331c102ede0f47f9");
const lexicons_1 = require("54292ecdf158fdfe");
const util_1 = require("d6b92fdfb4f18050");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.getRepo';
class RepoNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoNotFoundError = RepoNotFoundError;
class RepoTakendownError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoTakendownError = RepoTakendownError;
class RepoSuspendedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoSuspendedError = RepoSuspendedError;
class RepoDeactivatedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoDeactivatedError = RepoDeactivatedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'RepoNotFound') return new RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new RepoDeactivatedError(e);
    }
    return e;
}

},{"331c102ede0f47f9":"3J4dg","54292ecdf158fdfe":"4ClhN","d6b92fdfb4f18050":"45ZSh"}],"6DBK5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RepoNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("f32224e65da9128e");
const lexicons_1 = require("5d8e4f4a533e7bbc");
const util_1 = require("377c257ea4303f3c");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.getRepoStatus';
class RepoNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoNotFoundError = RepoNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'RepoNotFound') return new RepoNotFoundError(e);
    }
    return e;
}

},{"f32224e65da9128e":"3J4dg","5d8e4f4a533e7bbc":"4ClhN","377c257ea4303f3c":"45ZSh"}],"4YJ90":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RepoDeactivatedError = exports.RepoSuspendedError = exports.RepoTakendownError = exports.RepoNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("d7bcb7d262b240ee");
const lexicons_1 = require("b0674f78dc18cba3");
const util_1 = require("681c83ef343a6eb6");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.listBlobs';
class RepoNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoNotFoundError = RepoNotFoundError;
class RepoTakendownError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoTakendownError = RepoTakendownError;
class RepoSuspendedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoSuspendedError = RepoSuspendedError;
class RepoDeactivatedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoDeactivatedError = RepoDeactivatedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'RepoNotFound') return new RepoNotFoundError(e);
        if (e.error === 'RepoTakendown') return new RepoTakendownError(e);
        if (e.error === 'RepoSuspended') return new RepoSuspendedError(e);
        if (e.error === 'RepoDeactivated') return new RepoDeactivatedError(e);
    }
    return e;
}

},{"d7bcb7d262b240ee":"3J4dg","b0674f78dc18cba3":"4ClhN","681c83ef343a6eb6":"45ZSh"}],"7GKR7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HostBannedError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("d0c9fd0168be970b");
const lexicons_1 = require("ae88995360d63d1f");
const util_1 = require("f50df4b33e9286cd");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.requestCrawl';
class HostBannedError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.HostBannedError = HostBannedError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'HostBanned') return new HostBannedError(e);
    }
    return e;
}

},{"d0c9fd0168be970b":"3J4dg","ae88995360d63d1f":"4ClhN","f50df4b33e9286cd":"45ZSh"}],"acvKW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidEmailError = void 0;
exports.toKnownErr = toKnownErr;
exports.isResultAvailable = isResultAvailable;
exports.validateResultAvailable = validateResultAvailable;
exports.isResultUnavailable = isResultUnavailable;
exports.validateResultUnavailable = validateResultUnavailable;
exports.isSuggestion = isSuggestion;
exports.validateSuggestion = validateSuggestion;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("4337d774fbf4cd35");
const lexicons_1 = require("993ed4c485c7ac4d");
const util_1 = require("8ac6adaba4304963");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.temp.checkHandleAvailability';
class InvalidEmailError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidEmailError = InvalidEmailError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'InvalidEmail') return new InvalidEmailError(e);
    }
    return e;
}
const hashResultAvailable = 'resultAvailable';
function isResultAvailable(v) {
    return is$typed(v, id, hashResultAvailable);
}
function validateResultAvailable(v) {
    return validate(v, id, hashResultAvailable);
}
const hashResultUnavailable = 'resultUnavailable';
function isResultUnavailable(v) {
    return is$typed(v, id, hashResultUnavailable);
}
function validateResultUnavailable(v) {
    return validate(v, id, hashResultUnavailable);
}
const hashSuggestion = 'suggestion';
function isSuggestion(v) {
    return is$typed(v, id, hashSuggestion);
}
function validateSuggestion(v) {
    return validate(v, id, hashSuggestion);
}

},{"4337d774fbf4cd35":"3J4dg","993ed4c485c7ac4d":"4ClhN","8ac6adaba4304963":"45ZSh"}],"lr6W9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidScopeReferenceError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("49eb536e39ad30c5");
const lexicons_1 = require("5516e988d72bd521");
const util_1 = require("77718e1c2158e25f");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.temp.dereferenceScope';
class InvalidScopeReferenceError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidScopeReferenceError = InvalidScopeReferenceError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'InvalidScopeReference') return new InvalidScopeReferenceError(e);
    }
    return e;
}

},{"49eb536e39ad30c5":"3J4dg","5516e988d72bd521":"4ClhN","77718e1c2158e25f":"45ZSh"}],"erF4G":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DuplicateTemplateNameError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("a23cbd2fd082d350");
const lexicons_1 = require("fc06cba81834c678");
const util_1 = require("61dc1daedc2ff85a");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.communication.createTemplate';
class DuplicateTemplateNameError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.DuplicateTemplateNameError = DuplicateTemplateNameError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'DuplicateTemplateName') return new DuplicateTemplateNameError(e);
    }
    return e;
}

},{"a23cbd2fd082d350":"3J4dg","fc06cba81834c678":"4ClhN","61dc1daedc2ff85a":"45ZSh"}],"iujz0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DuplicateTemplateNameError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("f9e25c002645291e");
const lexicons_1 = require("fb584fa622e146e");
const util_1 = require("5eaa08524a8fecb0");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.communication.updateTemplate';
class DuplicateTemplateNameError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.DuplicateTemplateNameError = DuplicateTemplateNameError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'DuplicateTemplateName') return new DuplicateTemplateNameError(e);
    }
    return e;
}

},{"f9e25c002645291e":"3J4dg","fb584fa622e146e":"4ClhN","5eaa08524a8fecb0":"45ZSh"}],"a6fKU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DuplicateExternalIdError = exports.SubjectHasActionError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("a167382f57b4590c");
const lexicons_1 = require("69d130a6f86dd4fd");
const util_1 = require("c43c4155f1ffd6be");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.emitEvent';
class SubjectHasActionError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.SubjectHasActionError = SubjectHasActionError;
class DuplicateExternalIdError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.DuplicateExternalIdError = DuplicateExternalIdError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'SubjectHasAction') return new SubjectHasActionError(e);
        if (e.error === 'DuplicateExternalId') return new DuplicateExternalIdError(e);
    }
    return e;
}

},{"a167382f57b4590c":"3J4dg","69d130a6f86dd4fd":"4ClhN","c43c4155f1ffd6be":"45ZSh"}],"6AUeQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RepoNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
exports.isTimelineItem = isTimelineItem;
exports.validateTimelineItem = validateTimelineItem;
exports.isTimelineItemSummary = isTimelineItemSummary;
exports.validateTimelineItemSummary = validateTimelineItemSummary;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("2a7e4577a49dbb48");
const lexicons_1 = require("13515a64114ddeeb");
const util_1 = require("f2807f96198e3211");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.getAccountTimeline';
class RepoNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoNotFoundError = RepoNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'RepoNotFound') return new RepoNotFoundError(e);
    }
    return e;
}
const hashTimelineItem = 'timelineItem';
function isTimelineItem(v) {
    return is$typed(v, id, hashTimelineItem);
}
function validateTimelineItem(v) {
    return validate(v, id, hashTimelineItem);
}
const hashTimelineItemSummary = 'timelineItemSummary';
function isTimelineItemSummary(v) {
    return is$typed(v, id, hashTimelineItemSummary);
}
function validateTimelineItemSummary(v) {
    return validate(v, id, hashTimelineItemSummary);
}

},{"2a7e4577a49dbb48":"3J4dg","13515a64114ddeeb":"4ClhN","f2807f96198e3211":"45ZSh"}],"b3pf5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RecordNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("33608f274a36349c");
const lexicons_1 = require("4a7ce9a2c1120a7e");
const util_1 = require("a0f61836f1e0f803");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.getRecord';
class RecordNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RecordNotFoundError = RecordNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'RecordNotFound') return new RecordNotFoundError(e);
    }
    return e;
}

},{"33608f274a36349c":"3J4dg","4a7ce9a2c1120a7e":"4ClhN","a0f61836f1e0f803":"45ZSh"}],"kNLHN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RepoNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("3b127288e0138381");
const lexicons_1 = require("19d9a719fefb0ba9");
const util_1 = require("4251b3e69bf26912");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.getRepo';
class RepoNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RepoNotFoundError = RepoNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'RepoNotFound') return new RepoNotFoundError(e);
    }
    return e;
}

},{"3b127288e0138381":"3J4dg","19d9a719fefb0ba9":"4ClhN","4251b3e69bf26912":"45ZSh"}],"fGyGV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RuleAlreadyExistsError = exports.InvalidUrlError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("5f10ec47ee34db7d");
const lexicons_1 = require("99b04bbe6610a44f");
const util_1 = require("4cce40b55429260c");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.safelink.addRule';
class InvalidUrlError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.InvalidUrlError = InvalidUrlError;
class RuleAlreadyExistsError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RuleAlreadyExistsError = RuleAlreadyExistsError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'InvalidUrl') return new InvalidUrlError(e);
        if (e.error === 'RuleAlreadyExists') return new RuleAlreadyExistsError(e);
    }
    return e;
}

},{"5f10ec47ee34db7d":"3J4dg","99b04bbe6610a44f":"4ClhN","4cce40b55429260c":"45ZSh"}],"lYujD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RuleNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("d40a055a0680a81b");
const lexicons_1 = require("496864b6963469c1");
const util_1 = require("47a4317f296c8d45");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.safelink.removeRule';
class RuleNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RuleNotFoundError = RuleNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'RuleNotFound') return new RuleNotFoundError(e);
    }
    return e;
}

},{"d40a055a0680a81b":"3J4dg","496864b6963469c1":"4ClhN","47a4317f296c8d45":"45ZSh"}],"iFUxP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RuleNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("63ae495640727eea");
const lexicons_1 = require("f0e4ba7810fb38f4");
const util_1 = require("237762a84659c018");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.safelink.updateRule';
class RuleNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.RuleNotFoundError = RuleNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'RuleNotFound') return new RuleNotFoundError(e);
    }
    return e;
}

},{"63ae495640727eea":"3J4dg","f0e4ba7810fb38f4":"4ClhN","237762a84659c018":"45ZSh"}],"386xZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SetNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("adc2fd16584ba210");
const lexicons_1 = require("b9a2e8aad344c190");
const util_1 = require("e927915bd40c5fe0");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.set.deleteSet';
class SetNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.SetNotFoundError = SetNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'SetNotFound') return new SetNotFoundError(e);
    }
    return e;
}

},{"adc2fd16584ba210":"3J4dg","b9a2e8aad344c190":"4ClhN","e927915bd40c5fe0":"45ZSh"}],"jFQuj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SetNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("746ed2263d734448");
const lexicons_1 = require("135f44edfd364a1");
const util_1 = require("17f2a480fd8554bd");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.set.deleteValues';
class SetNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.SetNotFoundError = SetNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'SetNotFound') return new SetNotFoundError(e);
    }
    return e;
}

},{"746ed2263d734448":"3J4dg","135f44edfd364a1":"4ClhN","17f2a480fd8554bd":"45ZSh"}],"8At3M":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SetNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("f10fc2824cedb506");
const lexicons_1 = require("85ef02be36b4c4fe");
const util_1 = require("7a9780cf8a4231d");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.set.getValues';
class SetNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.SetNotFoundError = SetNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'SetNotFound') return new SetNotFoundError(e);
    }
    return e;
}

},{"f10fc2824cedb506":"3J4dg","85ef02be36b4c4fe":"4ClhN","7a9780cf8a4231d":"45ZSh"}],"8PIJt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MemberAlreadyExistsError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("b88a49094c757bdb");
const lexicons_1 = require("3a6ca7a06796ced1");
const util_1 = require("6b79a285bc27564");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.team.addMember';
class MemberAlreadyExistsError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.MemberAlreadyExistsError = MemberAlreadyExistsError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'MemberAlreadyExists') return new MemberAlreadyExistsError(e);
    }
    return e;
}

},{"b88a49094c757bdb":"3J4dg","3a6ca7a06796ced1":"4ClhN","6b79a285bc27564":"45ZSh"}],"gjtJd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CannotDeleteSelfError = exports.MemberNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("6fee4fddd3024f6c");
const lexicons_1 = require("e78b585d9880747e");
const util_1 = require("c85b9e212b132188");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.team.deleteMember';
class MemberNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.MemberNotFoundError = MemberNotFoundError;
class CannotDeleteSelfError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.CannotDeleteSelfError = CannotDeleteSelfError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'MemberNotFound') return new MemberNotFoundError(e);
        if (e.error === 'CannotDeleteSelf') return new CannotDeleteSelfError(e);
    }
    return e;
}

},{"6fee4fddd3024f6c":"3J4dg","e78b585d9880747e":"4ClhN","c85b9e212b132188":"45ZSh"}],"iPNkS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MemberNotFoundError = void 0;
exports.toKnownErr = toKnownErr;
/**
 * GENERATED CODE - DO NOT MODIFY
 */ const xrpc_1 = require("27a88d6b7baca97e");
const lexicons_1 = require("5e0e2f1bcf503b12");
const util_1 = require("bfe8320c10217963");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.team.updateMember';
class MemberNotFoundError extends xrpc_1.XRPCError {
    constructor(src){
        super(src.status, src.error, src.message, src.headers, {
            cause: src
        });
    }
}
exports.MemberNotFoundError = MemberNotFoundError;
function toKnownErr(e) {
    if (e instanceof xrpc_1.XRPCError) {
        if (e.error === 'MemberNotFound') return new MemberNotFoundError(e);
    }
    return e;
}

},{"27a88d6b7baca97e":"3J4dg","5e0e2f1bcf503b12":"4ClhN","bfe8320c10217963":"45ZSh"}],"fZ5Ea":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isProfileViewBasic = isProfileViewBasic;
exports.validateProfileViewBasic = validateProfileViewBasic;
exports.isProfileView = isProfileView;
exports.validateProfileView = validateProfileView;
exports.isProfileViewDetailed = isProfileViewDetailed;
exports.validateProfileViewDetailed = validateProfileViewDetailed;
exports.isProfileAssociated = isProfileAssociated;
exports.validateProfileAssociated = validateProfileAssociated;
exports.isProfileAssociatedChat = isProfileAssociatedChat;
exports.validateProfileAssociatedChat = validateProfileAssociatedChat;
exports.isProfileAssociatedActivitySubscription = isProfileAssociatedActivitySubscription;
exports.validateProfileAssociatedActivitySubscription = validateProfileAssociatedActivitySubscription;
exports.isViewerState = isViewerState;
exports.validateViewerState = validateViewerState;
exports.isKnownFollowers = isKnownFollowers;
exports.validateKnownFollowers = validateKnownFollowers;
exports.isVerificationState = isVerificationState;
exports.validateVerificationState = validateVerificationState;
exports.isVerificationView = isVerificationView;
exports.validateVerificationView = validateVerificationView;
exports.isAdultContentPref = isAdultContentPref;
exports.validateAdultContentPref = validateAdultContentPref;
exports.isContentLabelPref = isContentLabelPref;
exports.validateContentLabelPref = validateContentLabelPref;
exports.isSavedFeed = isSavedFeed;
exports.validateSavedFeed = validateSavedFeed;
exports.isSavedFeedsPrefV2 = isSavedFeedsPrefV2;
exports.validateSavedFeedsPrefV2 = validateSavedFeedsPrefV2;
exports.isSavedFeedsPref = isSavedFeedsPref;
exports.validateSavedFeedsPref = validateSavedFeedsPref;
exports.isPersonalDetailsPref = isPersonalDetailsPref;
exports.validatePersonalDetailsPref = validatePersonalDetailsPref;
exports.isFeedViewPref = isFeedViewPref;
exports.validateFeedViewPref = validateFeedViewPref;
exports.isThreadViewPref = isThreadViewPref;
exports.validateThreadViewPref = validateThreadViewPref;
exports.isInterestsPref = isInterestsPref;
exports.validateInterestsPref = validateInterestsPref;
exports.isMutedWord = isMutedWord;
exports.validateMutedWord = validateMutedWord;
exports.isMutedWordsPref = isMutedWordsPref;
exports.validateMutedWordsPref = validateMutedWordsPref;
exports.isHiddenPostsPref = isHiddenPostsPref;
exports.validateHiddenPostsPref = validateHiddenPostsPref;
exports.isLabelersPref = isLabelersPref;
exports.validateLabelersPref = validateLabelersPref;
exports.isLabelerPrefItem = isLabelerPrefItem;
exports.validateLabelerPrefItem = validateLabelerPrefItem;
exports.isBskyAppStatePref = isBskyAppStatePref;
exports.validateBskyAppStatePref = validateBskyAppStatePref;
exports.isBskyAppProgressGuide = isBskyAppProgressGuide;
exports.validateBskyAppProgressGuide = validateBskyAppProgressGuide;
exports.isNux = isNux;
exports.validateNux = validateNux;
exports.isVerificationPrefs = isVerificationPrefs;
exports.validateVerificationPrefs = validateVerificationPrefs;
exports.isPostInteractionSettingsPref = isPostInteractionSettingsPref;
exports.validatePostInteractionSettingsPref = validatePostInteractionSettingsPref;
exports.isStatusView = isStatusView;
exports.validateStatusView = validateStatusView;
const lexicons_1 = require("29863c92d0c4d85a");
const util_1 = require("e42df88f6384c827");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.actor.defs';
const hashProfileViewBasic = 'profileViewBasic';
function isProfileViewBasic(v) {
    return is$typed(v, id, hashProfileViewBasic);
}
function validateProfileViewBasic(v) {
    return validate(v, id, hashProfileViewBasic);
}
const hashProfileView = 'profileView';
function isProfileView(v) {
    return is$typed(v, id, hashProfileView);
}
function validateProfileView(v) {
    return validate(v, id, hashProfileView);
}
const hashProfileViewDetailed = 'profileViewDetailed';
function isProfileViewDetailed(v) {
    return is$typed(v, id, hashProfileViewDetailed);
}
function validateProfileViewDetailed(v) {
    return validate(v, id, hashProfileViewDetailed);
}
const hashProfileAssociated = 'profileAssociated';
function isProfileAssociated(v) {
    return is$typed(v, id, hashProfileAssociated);
}
function validateProfileAssociated(v) {
    return validate(v, id, hashProfileAssociated);
}
const hashProfileAssociatedChat = 'profileAssociatedChat';
function isProfileAssociatedChat(v) {
    return is$typed(v, id, hashProfileAssociatedChat);
}
function validateProfileAssociatedChat(v) {
    return validate(v, id, hashProfileAssociatedChat);
}
const hashProfileAssociatedActivitySubscription = 'profileAssociatedActivitySubscription';
function isProfileAssociatedActivitySubscription(v) {
    return is$typed(v, id, hashProfileAssociatedActivitySubscription);
}
function validateProfileAssociatedActivitySubscription(v) {
    return validate(v, id, hashProfileAssociatedActivitySubscription);
}
const hashViewerState = 'viewerState';
function isViewerState(v) {
    return is$typed(v, id, hashViewerState);
}
function validateViewerState(v) {
    return validate(v, id, hashViewerState);
}
const hashKnownFollowers = 'knownFollowers';
function isKnownFollowers(v) {
    return is$typed(v, id, hashKnownFollowers);
}
function validateKnownFollowers(v) {
    return validate(v, id, hashKnownFollowers);
}
const hashVerificationState = 'verificationState';
function isVerificationState(v) {
    return is$typed(v, id, hashVerificationState);
}
function validateVerificationState(v) {
    return validate(v, id, hashVerificationState);
}
const hashVerificationView = 'verificationView';
function isVerificationView(v) {
    return is$typed(v, id, hashVerificationView);
}
function validateVerificationView(v) {
    return validate(v, id, hashVerificationView);
}
const hashAdultContentPref = 'adultContentPref';
function isAdultContentPref(v) {
    return is$typed(v, id, hashAdultContentPref);
}
function validateAdultContentPref(v) {
    return validate(v, id, hashAdultContentPref);
}
const hashContentLabelPref = 'contentLabelPref';
function isContentLabelPref(v) {
    return is$typed(v, id, hashContentLabelPref);
}
function validateContentLabelPref(v) {
    return validate(v, id, hashContentLabelPref);
}
const hashSavedFeed = 'savedFeed';
function isSavedFeed(v) {
    return is$typed(v, id, hashSavedFeed);
}
function validateSavedFeed(v) {
    return validate(v, id, hashSavedFeed);
}
const hashSavedFeedsPrefV2 = 'savedFeedsPrefV2';
function isSavedFeedsPrefV2(v) {
    return is$typed(v, id, hashSavedFeedsPrefV2);
}
function validateSavedFeedsPrefV2(v) {
    return validate(v, id, hashSavedFeedsPrefV2);
}
const hashSavedFeedsPref = 'savedFeedsPref';
function isSavedFeedsPref(v) {
    return is$typed(v, id, hashSavedFeedsPref);
}
function validateSavedFeedsPref(v) {
    return validate(v, id, hashSavedFeedsPref);
}
const hashPersonalDetailsPref = 'personalDetailsPref';
function isPersonalDetailsPref(v) {
    return is$typed(v, id, hashPersonalDetailsPref);
}
function validatePersonalDetailsPref(v) {
    return validate(v, id, hashPersonalDetailsPref);
}
const hashFeedViewPref = 'feedViewPref';
function isFeedViewPref(v) {
    return is$typed(v, id, hashFeedViewPref);
}
function validateFeedViewPref(v) {
    return validate(v, id, hashFeedViewPref);
}
const hashThreadViewPref = 'threadViewPref';
function isThreadViewPref(v) {
    return is$typed(v, id, hashThreadViewPref);
}
function validateThreadViewPref(v) {
    return validate(v, id, hashThreadViewPref);
}
const hashInterestsPref = 'interestsPref';
function isInterestsPref(v) {
    return is$typed(v, id, hashInterestsPref);
}
function validateInterestsPref(v) {
    return validate(v, id, hashInterestsPref);
}
const hashMutedWord = 'mutedWord';
function isMutedWord(v) {
    return is$typed(v, id, hashMutedWord);
}
function validateMutedWord(v) {
    return validate(v, id, hashMutedWord);
}
const hashMutedWordsPref = 'mutedWordsPref';
function isMutedWordsPref(v) {
    return is$typed(v, id, hashMutedWordsPref);
}
function validateMutedWordsPref(v) {
    return validate(v, id, hashMutedWordsPref);
}
const hashHiddenPostsPref = 'hiddenPostsPref';
function isHiddenPostsPref(v) {
    return is$typed(v, id, hashHiddenPostsPref);
}
function validateHiddenPostsPref(v) {
    return validate(v, id, hashHiddenPostsPref);
}
const hashLabelersPref = 'labelersPref';
function isLabelersPref(v) {
    return is$typed(v, id, hashLabelersPref);
}
function validateLabelersPref(v) {
    return validate(v, id, hashLabelersPref);
}
const hashLabelerPrefItem = 'labelerPrefItem';
function isLabelerPrefItem(v) {
    return is$typed(v, id, hashLabelerPrefItem);
}
function validateLabelerPrefItem(v) {
    return validate(v, id, hashLabelerPrefItem);
}
const hashBskyAppStatePref = 'bskyAppStatePref';
function isBskyAppStatePref(v) {
    return is$typed(v, id, hashBskyAppStatePref);
}
function validateBskyAppStatePref(v) {
    return validate(v, id, hashBskyAppStatePref);
}
const hashBskyAppProgressGuide = 'bskyAppProgressGuide';
function isBskyAppProgressGuide(v) {
    return is$typed(v, id, hashBskyAppProgressGuide);
}
function validateBskyAppProgressGuide(v) {
    return validate(v, id, hashBskyAppProgressGuide);
}
const hashNux = 'nux';
function isNux(v) {
    return is$typed(v, id, hashNux);
}
function validateNux(v) {
    return validate(v, id, hashNux);
}
const hashVerificationPrefs = 'verificationPrefs';
function isVerificationPrefs(v) {
    return is$typed(v, id, hashVerificationPrefs);
}
function validateVerificationPrefs(v) {
    return validate(v, id, hashVerificationPrefs);
}
const hashPostInteractionSettingsPref = 'postInteractionSettingsPref';
function isPostInteractionSettingsPref(v) {
    return is$typed(v, id, hashPostInteractionSettingsPref);
}
function validatePostInteractionSettingsPref(v) {
    return validate(v, id, hashPostInteractionSettingsPref);
}
const hashStatusView = 'statusView';
function isStatusView(v) {
    return is$typed(v, id, hashStatusView);
}
function validateStatusView(v) {
    return validate(v, id, hashStatusView);
}

},{"29863c92d0c4d85a":"4ClhN","e42df88f6384c827":"45ZSh"}],"9B31A":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("e74673173cb78d25");
const util_1 = require("7c53b0ec9b6b7f54");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.actor.getPreferences';
function toKnownErr(e) {
    return e;
}

},{"e74673173cb78d25":"4ClhN","7c53b0ec9b6b7f54":"45ZSh"}],"639Tq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("51633e3af9bcc4be");
const util_1 = require("880583e0f9808007");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.actor.getProfile';
function toKnownErr(e) {
    return e;
}

},{"51633e3af9bcc4be":"4ClhN","880583e0f9808007":"45ZSh"}],"cqnLX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("513fbc4cf57577a5");
const util_1 = require("fc14d9daafc68b64");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.actor.getProfiles';
function toKnownErr(e) {
    return e;
}

},{"513fbc4cf57577a5":"4ClhN","fc14d9daafc68b64":"45ZSh"}],"46QWx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("ed73ccddf5f59942");
const util_1 = require("c8fd2e3a5bc69bf2");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.actor.getSuggestions';
function toKnownErr(e) {
    return e;
}

},{"ed73ccddf5f59942":"4ClhN","c8fd2e3a5bc69bf2":"45ZSh"}],"eAZdd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("b28bc0bcfd38428f");
const util_1 = require("799c832b992720a1");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.actor.profile';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"b28bc0bcfd38428f":"4ClhN","799c832b992720a1":"45ZSh"}],"dPUDr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("90c26ac4f8f524fd");
const util_1 = require("eafa6ec646efd141");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.actor.putPreferences';
function toKnownErr(e) {
    return e;
}

},{"90c26ac4f8f524fd":"4ClhN","eafa6ec646efd141":"45ZSh"}],"9M9tK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("874f6cea6034fe2e");
const util_1 = require("eafbaf18efaffe21");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.actor.searchActors';
function toKnownErr(e) {
    return e;
}

},{"874f6cea6034fe2e":"4ClhN","eafbaf18efaffe21":"45ZSh"}],"eW0YN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("b14169a494bfbcb5");
const util_1 = require("ffeb44d6deb61a9a");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.actor.searchActorsTypeahead';
function toKnownErr(e) {
    return e;
}

},{"b14169a494bfbcb5":"4ClhN","ffeb44d6deb61a9a":"45ZSh"}],"cNzZK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LIVE = void 0;
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("2318391c6b3a1126");
const util_1 = require("c0090f2458970c8b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.actor.status';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}
/** Advertises an account as currently offering live content. */ exports.LIVE = `${id}#live`;

},{"2318391c6b3a1126":"4ClhN","c0090f2458970c8b":"45ZSh"}],"hz3Ow":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isBookmark = isBookmark;
exports.validateBookmark = validateBookmark;
exports.isBookmarkView = isBookmarkView;
exports.validateBookmarkView = validateBookmarkView;
const lexicons_1 = require("c5464ecd14b2392d");
const util_1 = require("d9881051b23b8aa5");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.bookmark.defs';
const hashBookmark = 'bookmark';
function isBookmark(v) {
    return is$typed(v, id, hashBookmark);
}
function validateBookmark(v) {
    return validate(v, id, hashBookmark);
}
const hashBookmarkView = 'bookmarkView';
function isBookmarkView(v) {
    return is$typed(v, id, hashBookmarkView);
}
function validateBookmarkView(v) {
    return validate(v, id, hashBookmarkView);
}

},{"c5464ecd14b2392d":"4ClhN","d9881051b23b8aa5":"45ZSh"}],"dLP0x":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("f411a897a97e4ba8");
const util_1 = require("47ccbff648492a7f");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.bookmark.getBookmarks';
function toKnownErr(e) {
    return e;
}

},{"f411a897a97e4ba8":"4ClhN","47ccbff648492a7f":"45ZSh"}],"gQFV2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAspectRatio = isAspectRatio;
exports.validateAspectRatio = validateAspectRatio;
const lexicons_1 = require("d7e208a8dfb08b3f");
const util_1 = require("8d8fecb384ca3fb5");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.embed.defs';
const hashAspectRatio = 'aspectRatio';
function isAspectRatio(v) {
    return is$typed(v, id, hashAspectRatio);
}
function validateAspectRatio(v) {
    return validate(v, id, hashAspectRatio);
}

},{"d7e208a8dfb08b3f":"4ClhN","8d8fecb384ca3fb5":"45ZSh"}],"5ZM9l":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMain = isMain;
exports.validateMain = validateMain;
exports.isExternal = isExternal;
exports.validateExternal = validateExternal;
exports.isView = isView;
exports.validateView = validateView;
exports.isViewExternal = isViewExternal;
exports.validateViewExternal = validateViewExternal;
const lexicons_1 = require("29ecbabe29fc1ca");
const util_1 = require("e02a83eefc68df24");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.embed.external';
const hashMain = 'main';
function isMain(v) {
    return is$typed(v, id, hashMain);
}
function validateMain(v) {
    return validate(v, id, hashMain);
}
const hashExternal = 'external';
function isExternal(v) {
    return is$typed(v, id, hashExternal);
}
function validateExternal(v) {
    return validate(v, id, hashExternal);
}
const hashView = 'view';
function isView(v) {
    return is$typed(v, id, hashView);
}
function validateView(v) {
    return validate(v, id, hashView);
}
const hashViewExternal = 'viewExternal';
function isViewExternal(v) {
    return is$typed(v, id, hashViewExternal);
}
function validateViewExternal(v) {
    return validate(v, id, hashViewExternal);
}

},{"29ecbabe29fc1ca":"4ClhN","e02a83eefc68df24":"45ZSh"}],"duMQ0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMain = isMain;
exports.validateMain = validateMain;
exports.isImage = isImage;
exports.validateImage = validateImage;
exports.isView = isView;
exports.validateView = validateView;
exports.isViewImage = isViewImage;
exports.validateViewImage = validateViewImage;
const lexicons_1 = require("8053ab65f7b46806");
const util_1 = require("f24d2a5869038ad8");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.embed.images';
const hashMain = 'main';
function isMain(v) {
    return is$typed(v, id, hashMain);
}
function validateMain(v) {
    return validate(v, id, hashMain);
}
const hashImage = 'image';
function isImage(v) {
    return is$typed(v, id, hashImage);
}
function validateImage(v) {
    return validate(v, id, hashImage);
}
const hashView = 'view';
function isView(v) {
    return is$typed(v, id, hashView);
}
function validateView(v) {
    return validate(v, id, hashView);
}
const hashViewImage = 'viewImage';
function isViewImage(v) {
    return is$typed(v, id, hashViewImage);
}
function validateViewImage(v) {
    return validate(v, id, hashViewImage);
}

},{"8053ab65f7b46806":"4ClhN","f24d2a5869038ad8":"45ZSh"}],"kO9qQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMain = isMain;
exports.validateMain = validateMain;
exports.isView = isView;
exports.validateView = validateView;
exports.isViewRecord = isViewRecord;
exports.validateViewRecord = validateViewRecord;
exports.isViewNotFound = isViewNotFound;
exports.validateViewNotFound = validateViewNotFound;
exports.isViewBlocked = isViewBlocked;
exports.validateViewBlocked = validateViewBlocked;
exports.isViewDetached = isViewDetached;
exports.validateViewDetached = validateViewDetached;
const lexicons_1 = require("56f916a281c79b73");
const util_1 = require("6d182c6c81deba20");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.embed.record';
const hashMain = 'main';
function isMain(v) {
    return is$typed(v, id, hashMain);
}
function validateMain(v) {
    return validate(v, id, hashMain);
}
const hashView = 'view';
function isView(v) {
    return is$typed(v, id, hashView);
}
function validateView(v) {
    return validate(v, id, hashView);
}
const hashViewRecord = 'viewRecord';
function isViewRecord(v) {
    return is$typed(v, id, hashViewRecord);
}
function validateViewRecord(v) {
    return validate(v, id, hashViewRecord);
}
const hashViewNotFound = 'viewNotFound';
function isViewNotFound(v) {
    return is$typed(v, id, hashViewNotFound);
}
function validateViewNotFound(v) {
    return validate(v, id, hashViewNotFound);
}
const hashViewBlocked = 'viewBlocked';
function isViewBlocked(v) {
    return is$typed(v, id, hashViewBlocked);
}
function validateViewBlocked(v) {
    return validate(v, id, hashViewBlocked);
}
const hashViewDetached = 'viewDetached';
function isViewDetached(v) {
    return is$typed(v, id, hashViewDetached);
}
function validateViewDetached(v) {
    return validate(v, id, hashViewDetached);
}

},{"56f916a281c79b73":"4ClhN","6d182c6c81deba20":"45ZSh"}],"9MWFe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMain = isMain;
exports.validateMain = validateMain;
exports.isView = isView;
exports.validateView = validateView;
const lexicons_1 = require("93bec0db3f966e5c");
const util_1 = require("16c43ff6ce772f48");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.embed.recordWithMedia';
const hashMain = 'main';
function isMain(v) {
    return is$typed(v, id, hashMain);
}
function validateMain(v) {
    return validate(v, id, hashMain);
}
const hashView = 'view';
function isView(v) {
    return is$typed(v, id, hashView);
}
function validateView(v) {
    return validate(v, id, hashView);
}

},{"93bec0db3f966e5c":"4ClhN","16c43ff6ce772f48":"45ZSh"}],"90aSZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMain = isMain;
exports.validateMain = validateMain;
exports.isCaption = isCaption;
exports.validateCaption = validateCaption;
exports.isView = isView;
exports.validateView = validateView;
const lexicons_1 = require("4853bb0f45e78093");
const util_1 = require("50515fb25f55d97a");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.embed.video';
const hashMain = 'main';
function isMain(v) {
    return is$typed(v, id, hashMain);
}
function validateMain(v) {
    return validate(v, id, hashMain);
}
const hashCaption = 'caption';
function isCaption(v) {
    return is$typed(v, id, hashCaption);
}
function validateCaption(v) {
    return validate(v, id, hashCaption);
}
const hashView = 'view';
function isView(v) {
    return is$typed(v, id, hashView);
}
function validateView(v) {
    return validate(v, id, hashView);
}

},{"4853bb0f45e78093":"4ClhN","50515fb25f55d97a":"45ZSh"}],"lVwJR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.INTERACTIONSHARE = exports.INTERACTIONQUOTE = exports.INTERACTIONREPLY = exports.INTERACTIONREPOST = exports.INTERACTIONLIKE = exports.INTERACTIONSEEN = exports.CONTENTMODEVIDEO = exports.CONTENTMODEUNSPECIFIED = exports.CLICKTHROUGHEMBED = exports.CLICKTHROUGHREPOSTER = exports.CLICKTHROUGHAUTHOR = exports.CLICKTHROUGHITEM = exports.REQUESTMORE = exports.REQUESTLESS = void 0;
exports.isPostView = isPostView;
exports.validatePostView = validatePostView;
exports.isViewerState = isViewerState;
exports.validateViewerState = validateViewerState;
exports.isThreadContext = isThreadContext;
exports.validateThreadContext = validateThreadContext;
exports.isFeedViewPost = isFeedViewPost;
exports.validateFeedViewPost = validateFeedViewPost;
exports.isReplyRef = isReplyRef;
exports.validateReplyRef = validateReplyRef;
exports.isReasonRepost = isReasonRepost;
exports.validateReasonRepost = validateReasonRepost;
exports.isReasonPin = isReasonPin;
exports.validateReasonPin = validateReasonPin;
exports.isThreadViewPost = isThreadViewPost;
exports.validateThreadViewPost = validateThreadViewPost;
exports.isNotFoundPost = isNotFoundPost;
exports.validateNotFoundPost = validateNotFoundPost;
exports.isBlockedPost = isBlockedPost;
exports.validateBlockedPost = validateBlockedPost;
exports.isBlockedAuthor = isBlockedAuthor;
exports.validateBlockedAuthor = validateBlockedAuthor;
exports.isGeneratorView = isGeneratorView;
exports.validateGeneratorView = validateGeneratorView;
exports.isGeneratorViewerState = isGeneratorViewerState;
exports.validateGeneratorViewerState = validateGeneratorViewerState;
exports.isSkeletonFeedPost = isSkeletonFeedPost;
exports.validateSkeletonFeedPost = validateSkeletonFeedPost;
exports.isSkeletonReasonRepost = isSkeletonReasonRepost;
exports.validateSkeletonReasonRepost = validateSkeletonReasonRepost;
exports.isSkeletonReasonPin = isSkeletonReasonPin;
exports.validateSkeletonReasonPin = validateSkeletonReasonPin;
exports.isThreadgateView = isThreadgateView;
exports.validateThreadgateView = validateThreadgateView;
exports.isInteraction = isInteraction;
exports.validateInteraction = validateInteraction;
const lexicons_1 = require("de5c9f274fbcb2f0");
const util_1 = require("b29e20a561960bd");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.defs';
const hashPostView = 'postView';
function isPostView(v) {
    return is$typed(v, id, hashPostView);
}
function validatePostView(v) {
    return validate(v, id, hashPostView);
}
const hashViewerState = 'viewerState';
function isViewerState(v) {
    return is$typed(v, id, hashViewerState);
}
function validateViewerState(v) {
    return validate(v, id, hashViewerState);
}
const hashThreadContext = 'threadContext';
function isThreadContext(v) {
    return is$typed(v, id, hashThreadContext);
}
function validateThreadContext(v) {
    return validate(v, id, hashThreadContext);
}
const hashFeedViewPost = 'feedViewPost';
function isFeedViewPost(v) {
    return is$typed(v, id, hashFeedViewPost);
}
function validateFeedViewPost(v) {
    return validate(v, id, hashFeedViewPost);
}
const hashReplyRef = 'replyRef';
function isReplyRef(v) {
    return is$typed(v, id, hashReplyRef);
}
function validateReplyRef(v) {
    return validate(v, id, hashReplyRef);
}
const hashReasonRepost = 'reasonRepost';
function isReasonRepost(v) {
    return is$typed(v, id, hashReasonRepost);
}
function validateReasonRepost(v) {
    return validate(v, id, hashReasonRepost);
}
const hashReasonPin = 'reasonPin';
function isReasonPin(v) {
    return is$typed(v, id, hashReasonPin);
}
function validateReasonPin(v) {
    return validate(v, id, hashReasonPin);
}
const hashThreadViewPost = 'threadViewPost';
function isThreadViewPost(v) {
    return is$typed(v, id, hashThreadViewPost);
}
function validateThreadViewPost(v) {
    return validate(v, id, hashThreadViewPost);
}
const hashNotFoundPost = 'notFoundPost';
function isNotFoundPost(v) {
    return is$typed(v, id, hashNotFoundPost);
}
function validateNotFoundPost(v) {
    return validate(v, id, hashNotFoundPost);
}
const hashBlockedPost = 'blockedPost';
function isBlockedPost(v) {
    return is$typed(v, id, hashBlockedPost);
}
function validateBlockedPost(v) {
    return validate(v, id, hashBlockedPost);
}
const hashBlockedAuthor = 'blockedAuthor';
function isBlockedAuthor(v) {
    return is$typed(v, id, hashBlockedAuthor);
}
function validateBlockedAuthor(v) {
    return validate(v, id, hashBlockedAuthor);
}
const hashGeneratorView = 'generatorView';
function isGeneratorView(v) {
    return is$typed(v, id, hashGeneratorView);
}
function validateGeneratorView(v) {
    return validate(v, id, hashGeneratorView);
}
const hashGeneratorViewerState = 'generatorViewerState';
function isGeneratorViewerState(v) {
    return is$typed(v, id, hashGeneratorViewerState);
}
function validateGeneratorViewerState(v) {
    return validate(v, id, hashGeneratorViewerState);
}
const hashSkeletonFeedPost = 'skeletonFeedPost';
function isSkeletonFeedPost(v) {
    return is$typed(v, id, hashSkeletonFeedPost);
}
function validateSkeletonFeedPost(v) {
    return validate(v, id, hashSkeletonFeedPost);
}
const hashSkeletonReasonRepost = 'skeletonReasonRepost';
function isSkeletonReasonRepost(v) {
    return is$typed(v, id, hashSkeletonReasonRepost);
}
function validateSkeletonReasonRepost(v) {
    return validate(v, id, hashSkeletonReasonRepost);
}
const hashSkeletonReasonPin = 'skeletonReasonPin';
function isSkeletonReasonPin(v) {
    return is$typed(v, id, hashSkeletonReasonPin);
}
function validateSkeletonReasonPin(v) {
    return validate(v, id, hashSkeletonReasonPin);
}
const hashThreadgateView = 'threadgateView';
function isThreadgateView(v) {
    return is$typed(v, id, hashThreadgateView);
}
function validateThreadgateView(v) {
    return validate(v, id, hashThreadgateView);
}
const hashInteraction = 'interaction';
function isInteraction(v) {
    return is$typed(v, id, hashInteraction);
}
function validateInteraction(v) {
    return validate(v, id, hashInteraction);
}
/** Request that less content like the given feed item be shown in the feed */ exports.REQUESTLESS = `${id}#requestLess`;
/** Request that more content like the given feed item be shown in the feed */ exports.REQUESTMORE = `${id}#requestMore`;
/** User clicked through to the feed item */ exports.CLICKTHROUGHITEM = `${id}#clickthroughItem`;
/** User clicked through to the author of the feed item */ exports.CLICKTHROUGHAUTHOR = `${id}#clickthroughAuthor`;
/** User clicked through to the reposter of the feed item */ exports.CLICKTHROUGHREPOSTER = `${id}#clickthroughReposter`;
/** User clicked through to the embedded content of the feed item */ exports.CLICKTHROUGHEMBED = `${id}#clickthroughEmbed`;
/** Declares the feed generator returns any types of posts. */ exports.CONTENTMODEUNSPECIFIED = `${id}#contentModeUnspecified`;
/** Declares the feed generator returns posts containing app.bsky.embed.video embeds. */ exports.CONTENTMODEVIDEO = `${id}#contentModeVideo`;
/** Feed item was seen by user */ exports.INTERACTIONSEEN = `${id}#interactionSeen`;
/** User liked the feed item */ exports.INTERACTIONLIKE = `${id}#interactionLike`;
/** User reposted the feed item */ exports.INTERACTIONREPOST = `${id}#interactionRepost`;
/** User replied to the feed item */ exports.INTERACTIONREPLY = `${id}#interactionReply`;
/** User quoted the feed item */ exports.INTERACTIONQUOTE = `${id}#interactionQuote`;
/** User shared the feed item */ exports.INTERACTIONSHARE = `${id}#interactionShare`;

},{"de5c9f274fbcb2f0":"4ClhN","b29e20a561960bd":"45ZSh"}],"eEWgu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isFeed = isFeed;
exports.validateFeed = validateFeed;
exports.isLinks = isLinks;
exports.validateLinks = validateLinks;
const lexicons_1 = require("942759c7d291ad9d");
const util_1 = require("aeb0264fa1a220ad");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.describeFeedGenerator';
function toKnownErr(e) {
    return e;
}
const hashFeed = 'feed';
function isFeed(v) {
    return is$typed(v, id, hashFeed);
}
function validateFeed(v) {
    return validate(v, id, hashFeed);
}
const hashLinks = 'links';
function isLinks(v) {
    return is$typed(v, id, hashLinks);
}
function validateLinks(v) {
    return validate(v, id, hashLinks);
}

},{"942759c7d291ad9d":"4ClhN","aeb0264fa1a220ad":"45ZSh"}],"iQVrE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("b5b833fada5eb3a4");
const util_1 = require("a2dfe51b9d629589");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.generator';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"b5b833fada5eb3a4":"4ClhN","a2dfe51b9d629589":"45ZSh"}],"3ccfs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("a391b481e3a2e730");
const util_1 = require("df5f3ad37431aa5e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getActorFeeds';
function toKnownErr(e) {
    return e;
}

},{"a391b481e3a2e730":"4ClhN","df5f3ad37431aa5e":"45ZSh"}],"dsbW1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("74cc18e9de1591e5");
const util_1 = require("baeebf29a2edad27");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getFeedGenerator';
function toKnownErr(e) {
    return e;
}

},{"74cc18e9de1591e5":"4ClhN","baeebf29a2edad27":"45ZSh"}],"7sMBr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("43cc3f4220e56e52");
const util_1 = require("988d81f3560cc556");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getFeedGenerators';
function toKnownErr(e) {
    return e;
}

},{"43cc3f4220e56e52":"4ClhN","988d81f3560cc556":"45ZSh"}],"lIKMV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isLike = isLike;
exports.validateLike = validateLike;
const lexicons_1 = require("71ffed6fc87f8ad4");
const util_1 = require("e3bc7f1f02743fbe");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getLikes';
function toKnownErr(e) {
    return e;
}
const hashLike = 'like';
function isLike(v) {
    return is$typed(v, id, hashLike);
}
function validateLike(v) {
    return validate(v, id, hashLike);
}

},{"71ffed6fc87f8ad4":"4ClhN","e3bc7f1f02743fbe":"45ZSh"}],"iJF7Z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("5fed10e2f676ed4");
const util_1 = require("a8778ad7c9cc8880");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getPosts';
function toKnownErr(e) {
    return e;
}

},{"5fed10e2f676ed4":"4ClhN","a8778ad7c9cc8880":"45ZSh"}],"3QE4m":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("7f228d8f76a48130");
const util_1 = require("18a328d73193d33");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getQuotes';
function toKnownErr(e) {
    return e;
}

},{"7f228d8f76a48130":"4ClhN","18a328d73193d33":"45ZSh"}],"d3scM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("a88b588385a15e5d");
const util_1 = require("ef0a2ee48fb8775e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getRepostedBy';
function toKnownErr(e) {
    return e;
}

},{"a88b588385a15e5d":"4ClhN","ef0a2ee48fb8775e":"45ZSh"}],"kT3Jq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("349a6c7b2ec314a4");
const util_1 = require("68ee084afa3b136e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getSuggestedFeeds';
function toKnownErr(e) {
    return e;
}

},{"349a6c7b2ec314a4":"4ClhN","68ee084afa3b136e":"45ZSh"}],"3lbIQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("2346410c24b8a8fb");
const util_1 = require("89e1dea336a363e9");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.getTimeline';
function toKnownErr(e) {
    return e;
}

},{"2346410c24b8a8fb":"4ClhN","89e1dea336a363e9":"45ZSh"}],"4djUZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("51603834c35b53d0");
const util_1 = require("c7229e5150270647");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.like';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"51603834c35b53d0":"4ClhN","c7229e5150270647":"45ZSh"}],"2Nfiu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
exports.isReplyRef = isReplyRef;
exports.validateReplyRef = validateReplyRef;
exports.isEntity = isEntity;
exports.validateEntity = validateEntity;
exports.isTextSlice = isTextSlice;
exports.validateTextSlice = validateTextSlice;
const lexicons_1 = require("79f05582911df94c");
const util_1 = require("c09ef75b417844f4");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.post';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}
const hashReplyRef = 'replyRef';
function isReplyRef(v) {
    return is$typed(v, id, hashReplyRef);
}
function validateReplyRef(v) {
    return validate(v, id, hashReplyRef);
}
const hashEntity = 'entity';
function isEntity(v) {
    return is$typed(v, id, hashEntity);
}
function validateEntity(v) {
    return validate(v, id, hashEntity);
}
const hashTextSlice = 'textSlice';
function isTextSlice(v) {
    return is$typed(v, id, hashTextSlice);
}
function validateTextSlice(v) {
    return validate(v, id, hashTextSlice);
}

},{"79f05582911df94c":"4ClhN","c09ef75b417844f4":"45ZSh"}],"kt5HW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
exports.isDisableRule = isDisableRule;
exports.validateDisableRule = validateDisableRule;
const lexicons_1 = require("134ac670ff37a7b6");
const util_1 = require("a41f41ee19ad4fea");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.postgate';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}
const hashDisableRule = 'disableRule';
function isDisableRule(v) {
    return is$typed(v, id, hashDisableRule);
}
function validateDisableRule(v) {
    return validate(v, id, hashDisableRule);
}

},{"134ac670ff37a7b6":"4ClhN","a41f41ee19ad4fea":"45ZSh"}],"80bs9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("292a7f5e29e68cdf");
const util_1 = require("82004ad53e8d2481");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.repost';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"292a7f5e29e68cdf":"4ClhN","82004ad53e8d2481":"45ZSh"}],"h0ZId":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("d8d085e9c03ad6a8");
const util_1 = require("6fec5c6e26b6a194");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.sendInteractions';
function toKnownErr(e) {
    return e;
}

},{"d8d085e9c03ad6a8":"4ClhN","6fec5c6e26b6a194":"45ZSh"}],"3g9dr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
exports.isMentionRule = isMentionRule;
exports.validateMentionRule = validateMentionRule;
exports.isFollowerRule = isFollowerRule;
exports.validateFollowerRule = validateFollowerRule;
exports.isFollowingRule = isFollowingRule;
exports.validateFollowingRule = validateFollowingRule;
exports.isListRule = isListRule;
exports.validateListRule = validateListRule;
const lexicons_1 = require("9a279e12374dd0a6");
const util_1 = require("6cd4eecb24a85981");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.feed.threadgate';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}
const hashMentionRule = 'mentionRule';
function isMentionRule(v) {
    return is$typed(v, id, hashMentionRule);
}
function validateMentionRule(v) {
    return validate(v, id, hashMentionRule);
}
const hashFollowerRule = 'followerRule';
function isFollowerRule(v) {
    return is$typed(v, id, hashFollowerRule);
}
function validateFollowerRule(v) {
    return validate(v, id, hashFollowerRule);
}
const hashFollowingRule = 'followingRule';
function isFollowingRule(v) {
    return is$typed(v, id, hashFollowingRule);
}
function validateFollowingRule(v) {
    return validate(v, id, hashFollowingRule);
}
const hashListRule = 'listRule';
function isListRule(v) {
    return is$typed(v, id, hashListRule);
}
function validateListRule(v) {
    return validate(v, id, hashListRule);
}

},{"9a279e12374dd0a6":"4ClhN","6cd4eecb24a85981":"45ZSh"}],"kwMBt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("2a2b07db2a59f053");
const util_1 = require("4cb3e91b0586455d");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.block';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"2a2b07db2a59f053":"4ClhN","4cb3e91b0586455d":"45ZSh"}],"eLNSh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REFERENCELIST = exports.CURATELIST = exports.MODLIST = void 0;
exports.isListViewBasic = isListViewBasic;
exports.validateListViewBasic = validateListViewBasic;
exports.isListView = isListView;
exports.validateListView = validateListView;
exports.isListItemView = isListItemView;
exports.validateListItemView = validateListItemView;
exports.isStarterPackView = isStarterPackView;
exports.validateStarterPackView = validateStarterPackView;
exports.isStarterPackViewBasic = isStarterPackViewBasic;
exports.validateStarterPackViewBasic = validateStarterPackViewBasic;
exports.isListViewerState = isListViewerState;
exports.validateListViewerState = validateListViewerState;
exports.isNotFoundActor = isNotFoundActor;
exports.validateNotFoundActor = validateNotFoundActor;
exports.isRelationship = isRelationship;
exports.validateRelationship = validateRelationship;
const lexicons_1 = require("85228bd9ea09251f");
const util_1 = require("9b8900391227c62c");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.defs';
const hashListViewBasic = 'listViewBasic';
function isListViewBasic(v) {
    return is$typed(v, id, hashListViewBasic);
}
function validateListViewBasic(v) {
    return validate(v, id, hashListViewBasic);
}
const hashListView = 'listView';
function isListView(v) {
    return is$typed(v, id, hashListView);
}
function validateListView(v) {
    return validate(v, id, hashListView);
}
const hashListItemView = 'listItemView';
function isListItemView(v) {
    return is$typed(v, id, hashListItemView);
}
function validateListItemView(v) {
    return validate(v, id, hashListItemView);
}
const hashStarterPackView = 'starterPackView';
function isStarterPackView(v) {
    return is$typed(v, id, hashStarterPackView);
}
function validateStarterPackView(v) {
    return validate(v, id, hashStarterPackView);
}
const hashStarterPackViewBasic = 'starterPackViewBasic';
function isStarterPackViewBasic(v) {
    return is$typed(v, id, hashStarterPackViewBasic);
}
function validateStarterPackViewBasic(v) {
    return validate(v, id, hashStarterPackViewBasic);
}
/** A list of actors to apply an aggregate moderation action (mute/block) on. */ exports.MODLIST = `${id}#modlist`;
/** A list of actors used for curation purposes such as list feeds or interaction gating. */ exports.CURATELIST = `${id}#curatelist`;
/** A list of actors used for only for reference purposes such as within a starter pack. */ exports.REFERENCELIST = `${id}#referencelist`;
const hashListViewerState = 'listViewerState';
function isListViewerState(v) {
    return is$typed(v, id, hashListViewerState);
}
function validateListViewerState(v) {
    return validate(v, id, hashListViewerState);
}
const hashNotFoundActor = 'notFoundActor';
function isNotFoundActor(v) {
    return is$typed(v, id, hashNotFoundActor);
}
function validateNotFoundActor(v) {
    return validate(v, id, hashNotFoundActor);
}
const hashRelationship = 'relationship';
function isRelationship(v) {
    return is$typed(v, id, hashRelationship);
}
function validateRelationship(v) {
    return validate(v, id, hashRelationship);
}

},{"85228bd9ea09251f":"4ClhN","9b8900391227c62c":"45ZSh"}],"1jm7W":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("98bfce17a4cde895");
const util_1 = require("fd4b03a8654921b3");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.follow';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"98bfce17a4cde895":"4ClhN","fd4b03a8654921b3":"45ZSh"}],"i1TXH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("db8321c0458763cf");
const util_1 = require("7de9255f837f5fc2");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getActorStarterPacks';
function toKnownErr(e) {
    return e;
}

},{"db8321c0458763cf":"4ClhN","7de9255f837f5fc2":"45ZSh"}],"Y6DVI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("ea21a355a33f1980");
const util_1 = require("725ad905cc078d99");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getBlocks';
function toKnownErr(e) {
    return e;
}

},{"ea21a355a33f1980":"4ClhN","725ad905cc078d99":"45ZSh"}],"kdKzS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("ca1d2f28681a3f9");
const util_1 = require("a64dc313081d636");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getFollowers';
function toKnownErr(e) {
    return e;
}

},{"ca1d2f28681a3f9":"4ClhN","a64dc313081d636":"45ZSh"}],"dDuOm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("2d4547a95464f787");
const util_1 = require("3d6759f35be7016c");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getFollows';
function toKnownErr(e) {
    return e;
}

},{"2d4547a95464f787":"4ClhN","3d6759f35be7016c":"45ZSh"}],"hTGJK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("5519c14adef6841f");
const util_1 = require("3cb6c0358e0f5ccc");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getKnownFollowers';
function toKnownErr(e) {
    return e;
}

},{"5519c14adef6841f":"4ClhN","3cb6c0358e0f5ccc":"45ZSh"}],"cF2Vi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("7aa9a7c8f1b56e37");
const util_1 = require("c36fbb2106edc345");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getList';
function toKnownErr(e) {
    return e;
}

},{"7aa9a7c8f1b56e37":"4ClhN","c36fbb2106edc345":"45ZSh"}],"hLaMM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("1d987b66f666f7bc");
const util_1 = require("4089634339fd64db");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getListBlocks';
function toKnownErr(e) {
    return e;
}

},{"1d987b66f666f7bc":"4ClhN","4089634339fd64db":"45ZSh"}],"iKZwL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("dcf23261e31cb770");
const util_1 = require("f7df19c33e2841af");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getListMutes';
function toKnownErr(e) {
    return e;
}

},{"dcf23261e31cb770":"4ClhN","f7df19c33e2841af":"45ZSh"}],"7BV95":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("bc12c3a6a9fdc95a");
const util_1 = require("7616724523756076");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getLists';
function toKnownErr(e) {
    return e;
}

},{"bc12c3a6a9fdc95a":"4ClhN","7616724523756076":"45ZSh"}],"cs6kf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isListWithMembership = isListWithMembership;
exports.validateListWithMembership = validateListWithMembership;
const lexicons_1 = require("df60c6d5b631f707");
const util_1 = require("d63165f8e47c44a1");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getListsWithMembership';
function toKnownErr(e) {
    return e;
}
const hashListWithMembership = 'listWithMembership';
function isListWithMembership(v) {
    return is$typed(v, id, hashListWithMembership);
}
function validateListWithMembership(v) {
    return validate(v, id, hashListWithMembership);
}

},{"df60c6d5b631f707":"4ClhN","d63165f8e47c44a1":"45ZSh"}],"awoBN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("524442af18bbdc05");
const util_1 = require("17c2abe3f120b6b7");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getMutes';
function toKnownErr(e) {
    return e;
}

},{"524442af18bbdc05":"4ClhN","17c2abe3f120b6b7":"45ZSh"}],"89sPn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("38381484e68ec6f2");
const util_1 = require("119dd3cca1853c54");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getStarterPack';
function toKnownErr(e) {
    return e;
}

},{"38381484e68ec6f2":"4ClhN","119dd3cca1853c54":"45ZSh"}],"4pQgk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("9360d584cd0be00");
const util_1 = require("a9ff092ff28a61c3");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getStarterPacks';
function toKnownErr(e) {
    return e;
}

},{"9360d584cd0be00":"4ClhN","a9ff092ff28a61c3":"45ZSh"}],"18F8z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isStarterPackWithMembership = isStarterPackWithMembership;
exports.validateStarterPackWithMembership = validateStarterPackWithMembership;
const lexicons_1 = require("ec12a1eebc91bd39");
const util_1 = require("82faf39b2a16747b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getStarterPacksWithMembership';
function toKnownErr(e) {
    return e;
}
const hashStarterPackWithMembership = 'starterPackWithMembership';
function isStarterPackWithMembership(v) {
    return is$typed(v, id, hashStarterPackWithMembership);
}
function validateStarterPackWithMembership(v) {
    return validate(v, id, hashStarterPackWithMembership);
}

},{"ec12a1eebc91bd39":"4ClhN","82faf39b2a16747b":"45ZSh"}],"k4ESl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("75a2bc78c061d354");
const util_1 = require("f546e244df0c0c35");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.getSuggestedFollowsByActor';
function toKnownErr(e) {
    return e;
}

},{"75a2bc78c061d354":"4ClhN","f546e244df0c0c35":"45ZSh"}],"3WJia":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("98f0789466b26832");
const util_1 = require("3a4d9420a7fce261");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.list';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"98f0789466b26832":"4ClhN","3a4d9420a7fce261":"45ZSh"}],"jysHQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("5baef46b59b2ebc6");
const util_1 = require("7da89e23a90933f0");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.listblock';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"5baef46b59b2ebc6":"4ClhN","7da89e23a90933f0":"45ZSh"}],"de729":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("125d9a55513a49bc");
const util_1 = require("d765652ed2a85b96");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.listitem';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"125d9a55513a49bc":"4ClhN","d765652ed2a85b96":"45ZSh"}],"54Yrh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("3800a3ef92661918");
const util_1 = require("689cf795c7a3cd36");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.muteActor';
function toKnownErr(e) {
    return e;
}

},{"3800a3ef92661918":"4ClhN","689cf795c7a3cd36":"45ZSh"}],"fspL3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("53ffe40d9c59773f");
const util_1 = require("e642f00b1cffd184");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.muteActorList';
function toKnownErr(e) {
    return e;
}

},{"53ffe40d9c59773f":"4ClhN","e642f00b1cffd184":"45ZSh"}],"fBUvT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("cc15d1e937997a45");
const util_1 = require("af229eeb7032d0fd");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.muteThread';
function toKnownErr(e) {
    return e;
}

},{"cc15d1e937997a45":"4ClhN","af229eeb7032d0fd":"45ZSh"}],"88aB9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("cfbfd96274b2c291");
const util_1 = require("46325ac7ad21bf25");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.searchStarterPacks';
function toKnownErr(e) {
    return e;
}

},{"cfbfd96274b2c291":"4ClhN","46325ac7ad21bf25":"45ZSh"}],"gXGfk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
exports.isFeedItem = isFeedItem;
exports.validateFeedItem = validateFeedItem;
const lexicons_1 = require("3b21a588fc66ca6f");
const util_1 = require("2841c7b81d38eddd");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.starterpack';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}
const hashFeedItem = 'feedItem';
function isFeedItem(v) {
    return is$typed(v, id, hashFeedItem);
}
function validateFeedItem(v) {
    return validate(v, id, hashFeedItem);
}

},{"3b21a588fc66ca6f":"4ClhN","2841c7b81d38eddd":"45ZSh"}],"hFpBl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("8dcf01fde629c1d5");
const util_1 = require("90b7af663e6a494a");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.unmuteActor';
function toKnownErr(e) {
    return e;
}

},{"8dcf01fde629c1d5":"4ClhN","90b7af663e6a494a":"45ZSh"}],"lIs5a":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("845493821e77b7ca");
const util_1 = require("fdbd6f66b2bb099");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.unmuteActorList';
function toKnownErr(e) {
    return e;
}

},{"845493821e77b7ca":"4ClhN","fdbd6f66b2bb099":"45ZSh"}],"1QDIi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("7bcdfab4f468f318");
const util_1 = require("37fe579dcf9d2345");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.unmuteThread';
function toKnownErr(e) {
    return e;
}

},{"7bcdfab4f468f318":"4ClhN","37fe579dcf9d2345":"45ZSh"}],"647rw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("93fb60d1fb5f8c3");
const util_1 = require("65fd1ea9d6d8ff9b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.graph.verification';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"93fb60d1fb5f8c3":"4ClhN","65fd1ea9d6d8ff9b":"45ZSh"}],"cADnl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLabelerView = isLabelerView;
exports.validateLabelerView = validateLabelerView;
exports.isLabelerViewDetailed = isLabelerViewDetailed;
exports.validateLabelerViewDetailed = validateLabelerViewDetailed;
exports.isLabelerViewerState = isLabelerViewerState;
exports.validateLabelerViewerState = validateLabelerViewerState;
exports.isLabelerPolicies = isLabelerPolicies;
exports.validateLabelerPolicies = validateLabelerPolicies;
const lexicons_1 = require("cf7c5dab1835c76f");
const util_1 = require("64ab16b6ab9f3cf0");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.labeler.defs';
const hashLabelerView = 'labelerView';
function isLabelerView(v) {
    return is$typed(v, id, hashLabelerView);
}
function validateLabelerView(v) {
    return validate(v, id, hashLabelerView);
}
const hashLabelerViewDetailed = 'labelerViewDetailed';
function isLabelerViewDetailed(v) {
    return is$typed(v, id, hashLabelerViewDetailed);
}
function validateLabelerViewDetailed(v) {
    return validate(v, id, hashLabelerViewDetailed);
}
const hashLabelerViewerState = 'labelerViewerState';
function isLabelerViewerState(v) {
    return is$typed(v, id, hashLabelerViewerState);
}
function validateLabelerViewerState(v) {
    return validate(v, id, hashLabelerViewerState);
}
const hashLabelerPolicies = 'labelerPolicies';
function isLabelerPolicies(v) {
    return is$typed(v, id, hashLabelerPolicies);
}
function validateLabelerPolicies(v) {
    return validate(v, id, hashLabelerPolicies);
}

},{"cf7c5dab1835c76f":"4ClhN","64ab16b6ab9f3cf0":"45ZSh"}],"ehtTK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("5a9c5abd26b5db64");
const util_1 = require("44011dbdcc21e3f7");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.labeler.getServices';
function toKnownErr(e) {
    return e;
}

},{"5a9c5abd26b5db64":"4ClhN","44011dbdcc21e3f7":"45ZSh"}],"5mJGy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("b0420cd26e947a4a");
const util_1 = require("f94dff1411841931");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.labeler.service';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"b0420cd26e947a4a":"4ClhN","f94dff1411841931":"45ZSh"}],"aaslT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("8808e71ab85e24b7");
const util_1 = require("2d559b4c442dbfdc");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.declaration';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"8808e71ab85e24b7":"4ClhN","2d559b4c442dbfdc":"45ZSh"}],"86zoL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecordDeleted = isRecordDeleted;
exports.validateRecordDeleted = validateRecordDeleted;
exports.isChatPreference = isChatPreference;
exports.validateChatPreference = validateChatPreference;
exports.isFilterablePreference = isFilterablePreference;
exports.validateFilterablePreference = validateFilterablePreference;
exports.isPreference = isPreference;
exports.validatePreference = validatePreference;
exports.isPreferences = isPreferences;
exports.validatePreferences = validatePreferences;
exports.isActivitySubscription = isActivitySubscription;
exports.validateActivitySubscription = validateActivitySubscription;
exports.isSubjectActivitySubscription = isSubjectActivitySubscription;
exports.validateSubjectActivitySubscription = validateSubjectActivitySubscription;
const lexicons_1 = require("9651fe78e422a23d");
const util_1 = require("f5aa61ba3767d76b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.defs';
const hashRecordDeleted = 'recordDeleted';
function isRecordDeleted(v) {
    return is$typed(v, id, hashRecordDeleted);
}
function validateRecordDeleted(v) {
    return validate(v, id, hashRecordDeleted);
}
const hashChatPreference = 'chatPreference';
function isChatPreference(v) {
    return is$typed(v, id, hashChatPreference);
}
function validateChatPreference(v) {
    return validate(v, id, hashChatPreference);
}
const hashFilterablePreference = 'filterablePreference';
function isFilterablePreference(v) {
    return is$typed(v, id, hashFilterablePreference);
}
function validateFilterablePreference(v) {
    return validate(v, id, hashFilterablePreference);
}
const hashPreference = 'preference';
function isPreference(v) {
    return is$typed(v, id, hashPreference);
}
function validatePreference(v) {
    return validate(v, id, hashPreference);
}
const hashPreferences = 'preferences';
function isPreferences(v) {
    return is$typed(v, id, hashPreferences);
}
function validatePreferences(v) {
    return validate(v, id, hashPreferences);
}
const hashActivitySubscription = 'activitySubscription';
function isActivitySubscription(v) {
    return is$typed(v, id, hashActivitySubscription);
}
function validateActivitySubscription(v) {
    return validate(v, id, hashActivitySubscription);
}
const hashSubjectActivitySubscription = 'subjectActivitySubscription';
function isSubjectActivitySubscription(v) {
    return is$typed(v, id, hashSubjectActivitySubscription);
}
function validateSubjectActivitySubscription(v) {
    return validate(v, id, hashSubjectActivitySubscription);
}

},{"9651fe78e422a23d":"4ClhN","f5aa61ba3767d76b":"45ZSh"}],"gjGj9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("9f940ddd7b942df8");
const util_1 = require("acbec7ed09376ca4");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.getPreferences';
function toKnownErr(e) {
    return e;
}

},{"9f940ddd7b942df8":"4ClhN","acbec7ed09376ca4":"45ZSh"}],"8W1nR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("242b6e5589ab42ba");
const util_1 = require("3cf6cfcd8f6796c");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.getUnreadCount';
function toKnownErr(e) {
    return e;
}

},{"242b6e5589ab42ba":"4ClhN","3cf6cfcd8f6796c":"45ZSh"}],"h7ZmX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("c303c0bac5ee7d25");
const util_1 = require("83cf623b8a793035");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.listActivitySubscriptions';
function toKnownErr(e) {
    return e;
}

},{"c303c0bac5ee7d25":"4ClhN","83cf623b8a793035":"45ZSh"}],"zHuSn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isNotification = isNotification;
exports.validateNotification = validateNotification;
const lexicons_1 = require("b5d0f110c2d70a66");
const util_1 = require("8a233cac71fd63a0");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.listNotifications';
function toKnownErr(e) {
    return e;
}
const hashNotification = 'notification';
function isNotification(v) {
    return is$typed(v, id, hashNotification);
}
function validateNotification(v) {
    return validate(v, id, hashNotification);
}

},{"b5d0f110c2d70a66":"4ClhN","8a233cac71fd63a0":"45ZSh"}],"aFkLK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("2c3cec3c1d1475c8");
const util_1 = require("75bf581601907b31");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.putActivitySubscription';
function toKnownErr(e) {
    return e;
}

},{"2c3cec3c1d1475c8":"4ClhN","75bf581601907b31":"45ZSh"}],"9jJX4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("4e67ad1bc9860c72");
const util_1 = require("27f56344e185cd46");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.putPreferences';
function toKnownErr(e) {
    return e;
}

},{"4e67ad1bc9860c72":"4ClhN","27f56344e185cd46":"45ZSh"}],"lDeyr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("a970c3a461d17518");
const util_1 = require("6c80f363d1cdac4e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.putPreferencesV2';
function toKnownErr(e) {
    return e;
}

},{"a970c3a461d17518":"4ClhN","6c80f363d1cdac4e":"45ZSh"}],"eJhje":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("caec9e78cbc86ba3");
const util_1 = require("ac5afb3bea3a86fd");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.registerPush';
function toKnownErr(e) {
    return e;
}

},{"caec9e78cbc86ba3":"4ClhN","ac5afb3bea3a86fd":"45ZSh"}],"kubyo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("2023f69030e39a39");
const util_1 = require("97f84c99dcf49f8d");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.unregisterPush';
function toKnownErr(e) {
    return e;
}

},{"2023f69030e39a39":"4ClhN","97f84c99dcf49f8d":"45ZSh"}],"9ARQz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("828e687f20523ad7");
const util_1 = require("10688ca40c3bbcef");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.notification.updateSeen';
function toKnownErr(e) {
    return e;
}

},{"828e687f20523ad7":"4ClhN","10688ca40c3bbcef":"45ZSh"}],"5bhKK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMain = isMain;
exports.validateMain = validateMain;
exports.isMention = isMention;
exports.validateMention = validateMention;
exports.isLink = isLink;
exports.validateLink = validateLink;
exports.isTag = isTag;
exports.validateTag = validateTag;
exports.isByteSlice = isByteSlice;
exports.validateByteSlice = validateByteSlice;
const lexicons_1 = require("6c450d62db877ee3");
const util_1 = require("708036c2012797b6");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.richtext.facet';
const hashMain = 'main';
function isMain(v) {
    return is$typed(v, id, hashMain);
}
function validateMain(v) {
    return validate(v, id, hashMain);
}
const hashMention = 'mention';
function isMention(v) {
    return is$typed(v, id, hashMention);
}
function validateMention(v) {
    return validate(v, id, hashMention);
}
const hashLink = 'link';
function isLink(v) {
    return is$typed(v, id, hashLink);
}
function validateLink(v) {
    return validate(v, id, hashLink);
}
const hashTag = 'tag';
function isTag(v) {
    return is$typed(v, id, hashTag);
}
function validateTag(v) {
    return validate(v, id, hashTag);
}
const hashByteSlice = 'byteSlice';
function isByteSlice(v) {
    return is$typed(v, id, hashByteSlice);
}
function validateByteSlice(v) {
    return validate(v, id, hashByteSlice);
}

},{"6c450d62db877ee3":"4ClhN","708036c2012797b6":"45ZSh"}],"esoj1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSkeletonSearchPost = isSkeletonSearchPost;
exports.validateSkeletonSearchPost = validateSkeletonSearchPost;
exports.isSkeletonSearchActor = isSkeletonSearchActor;
exports.validateSkeletonSearchActor = validateSkeletonSearchActor;
exports.isSkeletonSearchStarterPack = isSkeletonSearchStarterPack;
exports.validateSkeletonSearchStarterPack = validateSkeletonSearchStarterPack;
exports.isTrendingTopic = isTrendingTopic;
exports.validateTrendingTopic = validateTrendingTopic;
exports.isSkeletonTrend = isSkeletonTrend;
exports.validateSkeletonTrend = validateSkeletonTrend;
exports.isTrendView = isTrendView;
exports.validateTrendView = validateTrendView;
exports.isThreadItemPost = isThreadItemPost;
exports.validateThreadItemPost = validateThreadItemPost;
exports.isThreadItemNoUnauthenticated = isThreadItemNoUnauthenticated;
exports.validateThreadItemNoUnauthenticated = validateThreadItemNoUnauthenticated;
exports.isThreadItemNotFound = isThreadItemNotFound;
exports.validateThreadItemNotFound = validateThreadItemNotFound;
exports.isThreadItemBlocked = isThreadItemBlocked;
exports.validateThreadItemBlocked = validateThreadItemBlocked;
exports.isAgeAssuranceState = isAgeAssuranceState;
exports.validateAgeAssuranceState = validateAgeAssuranceState;
exports.isAgeAssuranceEvent = isAgeAssuranceEvent;
exports.validateAgeAssuranceEvent = validateAgeAssuranceEvent;
const lexicons_1 = require("94e3b4164e0fa807");
const util_1 = require("9b8cacb5e880926");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.defs';
const hashSkeletonSearchPost = 'skeletonSearchPost';
function isSkeletonSearchPost(v) {
    return is$typed(v, id, hashSkeletonSearchPost);
}
function validateSkeletonSearchPost(v) {
    return validate(v, id, hashSkeletonSearchPost);
}
const hashSkeletonSearchActor = 'skeletonSearchActor';
function isSkeletonSearchActor(v) {
    return is$typed(v, id, hashSkeletonSearchActor);
}
function validateSkeletonSearchActor(v) {
    return validate(v, id, hashSkeletonSearchActor);
}
const hashSkeletonSearchStarterPack = 'skeletonSearchStarterPack';
function isSkeletonSearchStarterPack(v) {
    return is$typed(v, id, hashSkeletonSearchStarterPack);
}
function validateSkeletonSearchStarterPack(v) {
    return validate(v, id, hashSkeletonSearchStarterPack);
}
const hashTrendingTopic = 'trendingTopic';
function isTrendingTopic(v) {
    return is$typed(v, id, hashTrendingTopic);
}
function validateTrendingTopic(v) {
    return validate(v, id, hashTrendingTopic);
}
const hashSkeletonTrend = 'skeletonTrend';
function isSkeletonTrend(v) {
    return is$typed(v, id, hashSkeletonTrend);
}
function validateSkeletonTrend(v) {
    return validate(v, id, hashSkeletonTrend);
}
const hashTrendView = 'trendView';
function isTrendView(v) {
    return is$typed(v, id, hashTrendView);
}
function validateTrendView(v) {
    return validate(v, id, hashTrendView);
}
const hashThreadItemPost = 'threadItemPost';
function isThreadItemPost(v) {
    return is$typed(v, id, hashThreadItemPost);
}
function validateThreadItemPost(v) {
    return validate(v, id, hashThreadItemPost);
}
const hashThreadItemNoUnauthenticated = 'threadItemNoUnauthenticated';
function isThreadItemNoUnauthenticated(v) {
    return is$typed(v, id, hashThreadItemNoUnauthenticated);
}
function validateThreadItemNoUnauthenticated(v) {
    return validate(v, id, hashThreadItemNoUnauthenticated);
}
const hashThreadItemNotFound = 'threadItemNotFound';
function isThreadItemNotFound(v) {
    return is$typed(v, id, hashThreadItemNotFound);
}
function validateThreadItemNotFound(v) {
    return validate(v, id, hashThreadItemNotFound);
}
const hashThreadItemBlocked = 'threadItemBlocked';
function isThreadItemBlocked(v) {
    return is$typed(v, id, hashThreadItemBlocked);
}
function validateThreadItemBlocked(v) {
    return validate(v, id, hashThreadItemBlocked);
}
const hashAgeAssuranceState = 'ageAssuranceState';
function isAgeAssuranceState(v) {
    return is$typed(v, id, hashAgeAssuranceState);
}
function validateAgeAssuranceState(v) {
    return validate(v, id, hashAgeAssuranceState);
}
const hashAgeAssuranceEvent = 'ageAssuranceEvent';
function isAgeAssuranceEvent(v) {
    return is$typed(v, id, hashAgeAssuranceEvent);
}
function validateAgeAssuranceEvent(v) {
    return validate(v, id, hashAgeAssuranceEvent);
}

},{"94e3b4164e0fa807":"4ClhN","9b8cacb5e880926":"45ZSh"}],"54iCb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("b7c50d2d7fd2b29e");
const util_1 = require("3c253f89b2e11cff");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getAgeAssuranceState';
function toKnownErr(e) {
    return e;
}

},{"b7c50d2d7fd2b29e":"4ClhN","3c253f89b2e11cff":"45ZSh"}],"ivWbh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isLiveNowConfig = isLiveNowConfig;
exports.validateLiveNowConfig = validateLiveNowConfig;
const lexicons_1 = require("4128fd689600f226");
const util_1 = require("3663c6a67901c763");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getConfig';
function toKnownErr(e) {
    return e;
}
const hashLiveNowConfig = 'liveNowConfig';
function isLiveNowConfig(v) {
    return is$typed(v, id, hashLiveNowConfig);
}
function validateLiveNowConfig(v) {
    return validate(v, id, hashLiveNowConfig);
}

},{"4128fd689600f226":"4ClhN","3663c6a67901c763":"45ZSh"}],"ekkD4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("db1766d817a4cb03");
const util_1 = require("5a7d9d9d7d6dfaa2");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getOnboardingSuggestedStarterPacks';
function toKnownErr(e) {
    return e;
}

},{"db1766d817a4cb03":"4ClhN","5a7d9d9d7d6dfaa2":"45ZSh"}],"iO9xs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("b82b5ab8d3c5717b");
const util_1 = require("f5025f5e3f875806");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getOnboardingSuggestedStarterPacksSkeleton';
function toKnownErr(e) {
    return e;
}

},{"b82b5ab8d3c5717b":"4ClhN","f5025f5e3f875806":"45ZSh"}],"cPn3G":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("8df01893150bdf2f");
const util_1 = require("83c383dfad6f35e1");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getPopularFeedGenerators';
function toKnownErr(e) {
    return e;
}

},{"8df01893150bdf2f":"4ClhN","83c383dfad6f35e1":"45ZSh"}],"h08V9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isThreadItem = isThreadItem;
exports.validateThreadItem = validateThreadItem;
const lexicons_1 = require("ada8bdd0e9fe0ed0");
const util_1 = require("cc2734fb4da91f14");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getPostThreadOtherV2';
function toKnownErr(e) {
    return e;
}
const hashThreadItem = 'threadItem';
function isThreadItem(v) {
    return is$typed(v, id, hashThreadItem);
}
function validateThreadItem(v) {
    return validate(v, id, hashThreadItem);
}

},{"ada8bdd0e9fe0ed0":"4ClhN","cc2734fb4da91f14":"45ZSh"}],"7nyuY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isThreadItem = isThreadItem;
exports.validateThreadItem = validateThreadItem;
const lexicons_1 = require("6511325affc34adc");
const util_1 = require("ea2f0a27958f4dc7");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getPostThreadV2';
function toKnownErr(e) {
    return e;
}
const hashThreadItem = 'threadItem';
function isThreadItem(v) {
    return is$typed(v, id, hashThreadItem);
}
function validateThreadItem(v) {
    return validate(v, id, hashThreadItem);
}

},{"6511325affc34adc":"4ClhN","ea2f0a27958f4dc7":"45ZSh"}],"gCJye":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("5c04df6ced6c8078");
const util_1 = require("94509b9740a155fa");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getSuggestedFeeds';
function toKnownErr(e) {
    return e;
}

},{"5c04df6ced6c8078":"4ClhN","94509b9740a155fa":"45ZSh"}],"2WEZQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("c43d39fb1a565255");
const util_1 = require("c5cef0b9ce159b91");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getSuggestedFeedsSkeleton';
function toKnownErr(e) {
    return e;
}

},{"c43d39fb1a565255":"4ClhN","c5cef0b9ce159b91":"45ZSh"}],"cK28v":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("8eb14ba1ca1e8ce2");
const util_1 = require("67121397b45988dc");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getSuggestedStarterPacks';
function toKnownErr(e) {
    return e;
}

},{"8eb14ba1ca1e8ce2":"4ClhN","67121397b45988dc":"45ZSh"}],"eyZIJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("8da1ec0fe51a1f8a");
const util_1 = require("26b10ff3da3bf6c3");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getSuggestedStarterPacksSkeleton';
function toKnownErr(e) {
    return e;
}

},{"8da1ec0fe51a1f8a":"4ClhN","26b10ff3da3bf6c3":"45ZSh"}],"gsPyE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("14960a10391c694f");
const util_1 = require("d5b89536a17e4a97");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getSuggestedUsers';
function toKnownErr(e) {
    return e;
}

},{"14960a10391c694f":"4ClhN","d5b89536a17e4a97":"45ZSh"}],"1ZgYv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("21af041172503331");
const util_1 = require("f0cf1df05097ab50");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getSuggestedUsersSkeleton';
function toKnownErr(e) {
    return e;
}

},{"21af041172503331":"4ClhN","f0cf1df05097ab50":"45ZSh"}],"RNabW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("ba9cce03bae092ce");
const util_1 = require("1df17b96ff527377");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getSuggestionsSkeleton';
function toKnownErr(e) {
    return e;
}

},{"ba9cce03bae092ce":"4ClhN","1df17b96ff527377":"45ZSh"}],"60oxh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isSuggestion = isSuggestion;
exports.validateSuggestion = validateSuggestion;
const lexicons_1 = require("fb134c07ec7fa8e1");
const util_1 = require("303eeb8b7895841");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getTaggedSuggestions';
function toKnownErr(e) {
    return e;
}
const hashSuggestion = 'suggestion';
function isSuggestion(v) {
    return is$typed(v, id, hashSuggestion);
}
function validateSuggestion(v) {
    return validate(v, id, hashSuggestion);
}

},{"fb134c07ec7fa8e1":"4ClhN","303eeb8b7895841":"45ZSh"}],"ix8cX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("33005464bf2ec53b");
const util_1 = require("96fcf99e81e14297");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getTrendingTopics';
function toKnownErr(e) {
    return e;
}

},{"33005464bf2ec53b":"4ClhN","96fcf99e81e14297":"45ZSh"}],"biEWK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("aa424ecaaeb197c");
const util_1 = require("b59f019f1491965f");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getTrends';
function toKnownErr(e) {
    return e;
}

},{"aa424ecaaeb197c":"4ClhN","b59f019f1491965f":"45ZSh"}],"iBwfz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("41f5011664fcb390");
const util_1 = require("af3a6f8ebc732291");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.unspecced.getTrendsSkeleton';
function toKnownErr(e) {
    return e;
}

},{"41f5011664fcb390":"4ClhN","af3a6f8ebc732291":"45ZSh"}],"hOwis":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isJobStatus = isJobStatus;
exports.validateJobStatus = validateJobStatus;
const lexicons_1 = require("4fb55589f0e4ecb7");
const util_1 = require("6b5b505ffa7641ff");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.video.defs';
const hashJobStatus = 'jobStatus';
function isJobStatus(v) {
    return is$typed(v, id, hashJobStatus);
}
function validateJobStatus(v) {
    return validate(v, id, hashJobStatus);
}

},{"4fb55589f0e4ecb7":"4ClhN","6b5b505ffa7641ff":"45ZSh"}],"5bips":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("7f033f8b005d68e1");
const util_1 = require("4ccb2893a9cc192e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.video.getJobStatus';
function toKnownErr(e) {
    return e;
}

},{"7f033f8b005d68e1":"4ClhN","4ccb2893a9cc192e":"45ZSh"}],"7AFvY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("96177971ca852f5f");
const util_1 = require("fc177644be1c522d");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.video.getUploadLimits';
function toKnownErr(e) {
    return e;
}

},{"96177971ca852f5f":"4ClhN","fc177644be1c522d":"45ZSh"}],"jwn6T":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("f829f8e4a3e41218");
const util_1 = require("bc3ea1d428d6d98e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'app.bsky.video.uploadVideo';
function toKnownErr(e) {
    return e;
}

},{"f829f8e4a3e41218":"4ClhN","bc3ea1d428d6d98e":"45ZSh"}],"jql1S":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("73de9a6eb187f2a7");
const util_1 = require("6ce0d862aaeb3950");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.actor.declaration';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"73de9a6eb187f2a7":"4ClhN","6ce0d862aaeb3950":"45ZSh"}],"hWjyF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isProfileViewBasic = isProfileViewBasic;
exports.validateProfileViewBasic = validateProfileViewBasic;
const lexicons_1 = require("dfe52285e91daffb");
const util_1 = require("f9babcc5ddbb7430");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.actor.defs';
const hashProfileViewBasic = 'profileViewBasic';
function isProfileViewBasic(v) {
    return is$typed(v, id, hashProfileViewBasic);
}
function validateProfileViewBasic(v) {
    return validate(v, id, hashProfileViewBasic);
}

},{"dfe52285e91daffb":"4ClhN","f9babcc5ddbb7430":"45ZSh"}],"18mTA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("b4a37585df0db91d");
const util_1 = require("9581925d9db526c7");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.actor.deleteAccount';
function toKnownErr(e) {
    return e;
}

},{"b4a37585df0db91d":"4ClhN","9581925d9db526c7":"45ZSh"}],"k4rUc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("a29cb3f3dbac64bf");
const util_1 = require("d0d5eaefef884fb6");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.actor.exportAccountData';
function toKnownErr(e) {
    return e;
}

},{"a29cb3f3dbac64bf":"4ClhN","d0d5eaefef884fb6":"45ZSh"}],"2KO8K":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("29c27d7a2881bb7c");
const util_1 = require("5b273d886abd7bcf");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.acceptConvo';
function toKnownErr(e) {
    return e;
}

},{"29c27d7a2881bb7c":"4ClhN","5b273d886abd7bcf":"45ZSh"}],"iZJ9g":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMessageRef = isMessageRef;
exports.validateMessageRef = validateMessageRef;
exports.isMessageInput = isMessageInput;
exports.validateMessageInput = validateMessageInput;
exports.isMessageView = isMessageView;
exports.validateMessageView = validateMessageView;
exports.isDeletedMessageView = isDeletedMessageView;
exports.validateDeletedMessageView = validateDeletedMessageView;
exports.isMessageViewSender = isMessageViewSender;
exports.validateMessageViewSender = validateMessageViewSender;
exports.isReactionView = isReactionView;
exports.validateReactionView = validateReactionView;
exports.isReactionViewSender = isReactionViewSender;
exports.validateReactionViewSender = validateReactionViewSender;
exports.isMessageAndReactionView = isMessageAndReactionView;
exports.validateMessageAndReactionView = validateMessageAndReactionView;
exports.isConvoView = isConvoView;
exports.validateConvoView = validateConvoView;
exports.isLogBeginConvo = isLogBeginConvo;
exports.validateLogBeginConvo = validateLogBeginConvo;
exports.isLogAcceptConvo = isLogAcceptConvo;
exports.validateLogAcceptConvo = validateLogAcceptConvo;
exports.isLogLeaveConvo = isLogLeaveConvo;
exports.validateLogLeaveConvo = validateLogLeaveConvo;
exports.isLogMuteConvo = isLogMuteConvo;
exports.validateLogMuteConvo = validateLogMuteConvo;
exports.isLogUnmuteConvo = isLogUnmuteConvo;
exports.validateLogUnmuteConvo = validateLogUnmuteConvo;
exports.isLogCreateMessage = isLogCreateMessage;
exports.validateLogCreateMessage = validateLogCreateMessage;
exports.isLogDeleteMessage = isLogDeleteMessage;
exports.validateLogDeleteMessage = validateLogDeleteMessage;
exports.isLogReadMessage = isLogReadMessage;
exports.validateLogReadMessage = validateLogReadMessage;
exports.isLogAddReaction = isLogAddReaction;
exports.validateLogAddReaction = validateLogAddReaction;
exports.isLogRemoveReaction = isLogRemoveReaction;
exports.validateLogRemoveReaction = validateLogRemoveReaction;
const lexicons_1 = require("68b45fd52238dee0");
const util_1 = require("891fc73bad709107");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.defs';
const hashMessageRef = 'messageRef';
function isMessageRef(v) {
    return is$typed(v, id, hashMessageRef);
}
function validateMessageRef(v) {
    return validate(v, id, hashMessageRef);
}
const hashMessageInput = 'messageInput';
function isMessageInput(v) {
    return is$typed(v, id, hashMessageInput);
}
function validateMessageInput(v) {
    return validate(v, id, hashMessageInput);
}
const hashMessageView = 'messageView';
function isMessageView(v) {
    return is$typed(v, id, hashMessageView);
}
function validateMessageView(v) {
    return validate(v, id, hashMessageView);
}
const hashDeletedMessageView = 'deletedMessageView';
function isDeletedMessageView(v) {
    return is$typed(v, id, hashDeletedMessageView);
}
function validateDeletedMessageView(v) {
    return validate(v, id, hashDeletedMessageView);
}
const hashMessageViewSender = 'messageViewSender';
function isMessageViewSender(v) {
    return is$typed(v, id, hashMessageViewSender);
}
function validateMessageViewSender(v) {
    return validate(v, id, hashMessageViewSender);
}
const hashReactionView = 'reactionView';
function isReactionView(v) {
    return is$typed(v, id, hashReactionView);
}
function validateReactionView(v) {
    return validate(v, id, hashReactionView);
}
const hashReactionViewSender = 'reactionViewSender';
function isReactionViewSender(v) {
    return is$typed(v, id, hashReactionViewSender);
}
function validateReactionViewSender(v) {
    return validate(v, id, hashReactionViewSender);
}
const hashMessageAndReactionView = 'messageAndReactionView';
function isMessageAndReactionView(v) {
    return is$typed(v, id, hashMessageAndReactionView);
}
function validateMessageAndReactionView(v) {
    return validate(v, id, hashMessageAndReactionView);
}
const hashConvoView = 'convoView';
function isConvoView(v) {
    return is$typed(v, id, hashConvoView);
}
function validateConvoView(v) {
    return validate(v, id, hashConvoView);
}
const hashLogBeginConvo = 'logBeginConvo';
function isLogBeginConvo(v) {
    return is$typed(v, id, hashLogBeginConvo);
}
function validateLogBeginConvo(v) {
    return validate(v, id, hashLogBeginConvo);
}
const hashLogAcceptConvo = 'logAcceptConvo';
function isLogAcceptConvo(v) {
    return is$typed(v, id, hashLogAcceptConvo);
}
function validateLogAcceptConvo(v) {
    return validate(v, id, hashLogAcceptConvo);
}
const hashLogLeaveConvo = 'logLeaveConvo';
function isLogLeaveConvo(v) {
    return is$typed(v, id, hashLogLeaveConvo);
}
function validateLogLeaveConvo(v) {
    return validate(v, id, hashLogLeaveConvo);
}
const hashLogMuteConvo = 'logMuteConvo';
function isLogMuteConvo(v) {
    return is$typed(v, id, hashLogMuteConvo);
}
function validateLogMuteConvo(v) {
    return validate(v, id, hashLogMuteConvo);
}
const hashLogUnmuteConvo = 'logUnmuteConvo';
function isLogUnmuteConvo(v) {
    return is$typed(v, id, hashLogUnmuteConvo);
}
function validateLogUnmuteConvo(v) {
    return validate(v, id, hashLogUnmuteConvo);
}
const hashLogCreateMessage = 'logCreateMessage';
function isLogCreateMessage(v) {
    return is$typed(v, id, hashLogCreateMessage);
}
function validateLogCreateMessage(v) {
    return validate(v, id, hashLogCreateMessage);
}
const hashLogDeleteMessage = 'logDeleteMessage';
function isLogDeleteMessage(v) {
    return is$typed(v, id, hashLogDeleteMessage);
}
function validateLogDeleteMessage(v) {
    return validate(v, id, hashLogDeleteMessage);
}
const hashLogReadMessage = 'logReadMessage';
function isLogReadMessage(v) {
    return is$typed(v, id, hashLogReadMessage);
}
function validateLogReadMessage(v) {
    return validate(v, id, hashLogReadMessage);
}
const hashLogAddReaction = 'logAddReaction';
function isLogAddReaction(v) {
    return is$typed(v, id, hashLogAddReaction);
}
function validateLogAddReaction(v) {
    return validate(v, id, hashLogAddReaction);
}
const hashLogRemoveReaction = 'logRemoveReaction';
function isLogRemoveReaction(v) {
    return is$typed(v, id, hashLogRemoveReaction);
}
function validateLogRemoveReaction(v) {
    return validate(v, id, hashLogRemoveReaction);
}

},{"68b45fd52238dee0":"4ClhN","891fc73bad709107":"45ZSh"}],"ivey9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("b4ef1e97f13910e7");
const util_1 = require("5c37376fa31755e7");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.deleteMessageForSelf';
function toKnownErr(e) {
    return e;
}

},{"b4ef1e97f13910e7":"4ClhN","5c37376fa31755e7":"45ZSh"}],"cdc1D":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("641c85678f696aa");
const util_1 = require("9a6dab06082617fc");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.getConvo';
function toKnownErr(e) {
    return e;
}

},{"641c85678f696aa":"4ClhN","9a6dab06082617fc":"45ZSh"}],"aLOSB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("cc41359804066794");
const util_1 = require("bfe281d2392911eb");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.getConvoAvailability';
function toKnownErr(e) {
    return e;
}

},{"cc41359804066794":"4ClhN","bfe281d2392911eb":"45ZSh"}],"3jksT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("965be4d204d505c0");
const util_1 = require("723e3a1e64604343");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.getConvoForMembers';
function toKnownErr(e) {
    return e;
}

},{"965be4d204d505c0":"4ClhN","723e3a1e64604343":"45ZSh"}],"a6CEY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("33c6941f4e29fbe4");
const util_1 = require("21c6175b6357c5f0");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.getLog';
function toKnownErr(e) {
    return e;
}

},{"33c6941f4e29fbe4":"4ClhN","21c6175b6357c5f0":"45ZSh"}],"kqbYV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("ae6d6a964c047229");
const util_1 = require("2d4f9e6e7c5dc3d3");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.getMessages';
function toKnownErr(e) {
    return e;
}

},{"ae6d6a964c047229":"4ClhN","2d4f9e6e7c5dc3d3":"45ZSh"}],"9SHUM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("2e611ac4c3c73d2d");
const util_1 = require("8a1f30820e3d274");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.leaveConvo';
function toKnownErr(e) {
    return e;
}

},{"2e611ac4c3c73d2d":"4ClhN","8a1f30820e3d274":"45ZSh"}],"ipgbC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("1cc4288ac9136f48");
const util_1 = require("25be95b4012ee6a9");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.listConvos';
function toKnownErr(e) {
    return e;
}

},{"1cc4288ac9136f48":"4ClhN","25be95b4012ee6a9":"45ZSh"}],"gmRi9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("20999cd28d646d12");
const util_1 = require("7e1def8d2b2877a5");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.muteConvo';
function toKnownErr(e) {
    return e;
}

},{"20999cd28d646d12":"4ClhN","7e1def8d2b2877a5":"45ZSh"}],"8kVqQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("e158ee7e53784356");
const util_1 = require("e60ac2bb825cc294");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.sendMessage';
function toKnownErr(e) {
    return e;
}

},{"e158ee7e53784356":"4ClhN","e60ac2bb825cc294":"45ZSh"}],"lAoOM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isBatchItem = isBatchItem;
exports.validateBatchItem = validateBatchItem;
const lexicons_1 = require("51966924184c9270");
const util_1 = require("c4e0448af11f284d");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.sendMessageBatch';
function toKnownErr(e) {
    return e;
}
const hashBatchItem = 'batchItem';
function isBatchItem(v) {
    return is$typed(v, id, hashBatchItem);
}
function validateBatchItem(v) {
    return validate(v, id, hashBatchItem);
}

},{"51966924184c9270":"4ClhN","c4e0448af11f284d":"45ZSh"}],"8RFd7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("4c81eac1278a8cc0");
const util_1 = require("121978a16e329e57");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.unmuteConvo';
function toKnownErr(e) {
    return e;
}

},{"4c81eac1278a8cc0":"4ClhN","121978a16e329e57":"45ZSh"}],"dj9IN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("1ca6611c925a87b5");
const util_1 = require("dd472cd770cbb45e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.updateAllRead';
function toKnownErr(e) {
    return e;
}

},{"1ca6611c925a87b5":"4ClhN","dd472cd770cbb45e":"45ZSh"}],"c9fJS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("9f6e9eb1654ebd73");
const util_1 = require("b7d7665816617fff");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.convo.updateRead';
function toKnownErr(e) {
    return e;
}

},{"9f6e9eb1654ebd73":"4ClhN","b7d7665816617fff":"45ZSh"}],"aARlY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isMetadata = isMetadata;
exports.validateMetadata = validateMetadata;
const lexicons_1 = require("c504fb32be096a49");
const util_1 = require("577048a8733a7531");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.moderation.getActorMetadata';
function toKnownErr(e) {
    return e;
}
const hashMetadata = 'metadata';
function isMetadata(v) {
    return is$typed(v, id, hashMetadata);
}
function validateMetadata(v) {
    return validate(v, id, hashMetadata);
}

},{"c504fb32be096a49":"4ClhN","577048a8733a7531":"45ZSh"}],"7mGiL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("233bbe4eac5fe8ef");
const util_1 = require("ea55a5b84fd7e1dc");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.moderation.getMessageContext';
function toKnownErr(e) {
    return e;
}

},{"233bbe4eac5fe8ef":"4ClhN","ea55a5b84fd7e1dc":"45ZSh"}],"hTAy8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("cf07169a7261a73a");
const util_1 = require("fc8e8bb1c2c61284");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'chat.bsky.moderation.updateActorAccess';
function toKnownErr(e) {
    return e;
}

},{"cf07169a7261a73a":"4ClhN","fc8e8bb1c2c61284":"45ZSh"}],"1B06d":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isStatusAttr = isStatusAttr;
exports.validateStatusAttr = validateStatusAttr;
exports.isAccountView = isAccountView;
exports.validateAccountView = validateAccountView;
exports.isRepoRef = isRepoRef;
exports.validateRepoRef = validateRepoRef;
exports.isRepoBlobRef = isRepoBlobRef;
exports.validateRepoBlobRef = validateRepoBlobRef;
exports.isThreatSignature = isThreatSignature;
exports.validateThreatSignature = validateThreatSignature;
const lexicons_1 = require("7caaf14efb129014");
const util_1 = require("2818eb3340df5fde");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.defs';
const hashStatusAttr = 'statusAttr';
function isStatusAttr(v) {
    return is$typed(v, id, hashStatusAttr);
}
function validateStatusAttr(v) {
    return validate(v, id, hashStatusAttr);
}
const hashAccountView = 'accountView';
function isAccountView(v) {
    return is$typed(v, id, hashAccountView);
}
function validateAccountView(v) {
    return validate(v, id, hashAccountView);
}
const hashRepoRef = 'repoRef';
function isRepoRef(v) {
    return is$typed(v, id, hashRepoRef);
}
function validateRepoRef(v) {
    return validate(v, id, hashRepoRef);
}
const hashRepoBlobRef = 'repoBlobRef';
function isRepoBlobRef(v) {
    return is$typed(v, id, hashRepoBlobRef);
}
function validateRepoBlobRef(v) {
    return validate(v, id, hashRepoBlobRef);
}
const hashThreatSignature = 'threatSignature';
function isThreatSignature(v) {
    return is$typed(v, id, hashThreatSignature);
}
function validateThreatSignature(v) {
    return validate(v, id, hashThreatSignature);
}

},{"7caaf14efb129014":"4ClhN","2818eb3340df5fde":"45ZSh"}],"1Bp5d":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("20b3501f42c5b0cc");
const util_1 = require("98a124352af9fdc6");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.deleteAccount';
function toKnownErr(e) {
    return e;
}

},{"20b3501f42c5b0cc":"4ClhN","98a124352af9fdc6":"45ZSh"}],"20S2X":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("2f2f56454e3a0cdc");
const util_1 = require("683bc23f0c1e348b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.disableAccountInvites';
function toKnownErr(e) {
    return e;
}

},{"2f2f56454e3a0cdc":"4ClhN","683bc23f0c1e348b":"45ZSh"}],"f2y2c":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("a85cb797a431d5");
const util_1 = require("2782cfe3e5546684");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.disableInviteCodes';
function toKnownErr(e) {
    return e;
}

},{"a85cb797a431d5":"4ClhN","2782cfe3e5546684":"45ZSh"}],"1NEUi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("e2b8ae29a867d9c1");
const util_1 = require("8390c0574780c541");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.enableAccountInvites';
function toKnownErr(e) {
    return e;
}

},{"e2b8ae29a867d9c1":"4ClhN","8390c0574780c541":"45ZSh"}],"lsPqA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("8e5684a700fc1997");
const util_1 = require("90184e066742a75f");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.getAccountInfo';
function toKnownErr(e) {
    return e;
}

},{"8e5684a700fc1997":"4ClhN","90184e066742a75f":"45ZSh"}],"lRyzN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("5ed2232bdb2793cb");
const util_1 = require("a931574e810904d4");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.getAccountInfos';
function toKnownErr(e) {
    return e;
}

},{"5ed2232bdb2793cb":"4ClhN","a931574e810904d4":"45ZSh"}],"g0W7b":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("2de16f126598dc79");
const util_1 = require("b0dcca56d8418c95");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.getInviteCodes';
function toKnownErr(e) {
    return e;
}

},{"2de16f126598dc79":"4ClhN","b0dcca56d8418c95":"45ZSh"}],"iaXCP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("a7e9962abb949bc3");
const util_1 = require("293ba0cb46a10112");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.getSubjectStatus';
function toKnownErr(e) {
    return e;
}

},{"a7e9962abb949bc3":"4ClhN","293ba0cb46a10112":"45ZSh"}],"ajyrD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("3cbc93bea743795f");
const util_1 = require("c2a56057458c2495");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.searchAccounts';
function toKnownErr(e) {
    return e;
}

},{"3cbc93bea743795f":"4ClhN","c2a56057458c2495":"45ZSh"}],"aWXj1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("880a64bce33806df");
const util_1 = require("b8ac0b369800c24b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.sendEmail';
function toKnownErr(e) {
    return e;
}

},{"880a64bce33806df":"4ClhN","b8ac0b369800c24b":"45ZSh"}],"feGzr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("ab3e999a68feb7e");
const util_1 = require("39c424086304e3ec");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.updateAccountEmail';
function toKnownErr(e) {
    return e;
}

},{"ab3e999a68feb7e":"4ClhN","39c424086304e3ec":"45ZSh"}],"l5Ffq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("f21c0a77bd32631b");
const util_1 = require("46c1d3084e11b6d6");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.updateAccountHandle';
function toKnownErr(e) {
    return e;
}

},{"f21c0a77bd32631b":"4ClhN","46c1d3084e11b6d6":"45ZSh"}],"dVC0o":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("659556674943125f");
const util_1 = require("bfc10c4e7528833b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.updateAccountPassword';
function toKnownErr(e) {
    return e;
}

},{"659556674943125f":"4ClhN","bfc10c4e7528833b":"45ZSh"}],"df40w":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("dc514b9636e9eb7c");
const util_1 = require("dec55b11856182b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.updateAccountSigningKey';
function toKnownErr(e) {
    return e;
}

},{"dc514b9636e9eb7c":"4ClhN","dec55b11856182b":"45ZSh"}],"lcE2j":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("a264e2f8bdfd0866");
const util_1 = require("1a2dd0fcc9c1950d");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.updateSubjectStatus';
function toKnownErr(e) {
    return e;
}

},{"a264e2f8bdfd0866":"4ClhN","1a2dd0fcc9c1950d":"45ZSh"}],"dJ7iU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isIdentityInfo = isIdentityInfo;
exports.validateIdentityInfo = validateIdentityInfo;
const lexicons_1 = require("f2b88a423808cbc");
const util_1 = require("5e36a4abb48dd14e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.identity.defs';
const hashIdentityInfo = 'identityInfo';
function isIdentityInfo(v) {
    return is$typed(v, id, hashIdentityInfo);
}
function validateIdentityInfo(v) {
    return validate(v, id, hashIdentityInfo);
}

},{"f2b88a423808cbc":"4ClhN","5e36a4abb48dd14e":"45ZSh"}],"5MS6j":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("f831e0f14ff98329");
const util_1 = require("5c3e4b4160953869");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.identity.getRecommendedDidCredentials';
function toKnownErr(e) {
    return e;
}

},{"f831e0f14ff98329":"4ClhN","5c3e4b4160953869":"45ZSh"}],"aYrZ0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("55dbcd02153e0fc1");
const util_1 = require("76460268149932c9");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.identity.requestPlcOperationSignature';
function toKnownErr(e) {
    return e;
}

},{"55dbcd02153e0fc1":"4ClhN","76460268149932c9":"45ZSh"}],"4qmfA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("8c430a69a293b1ca");
const util_1 = require("c7c2192c62b23917");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.identity.signPlcOperation';
function toKnownErr(e) {
    return e;
}

},{"8c430a69a293b1ca":"4ClhN","c7c2192c62b23917":"45ZSh"}],"7JFec":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("45cc790033f4c0da");
const util_1 = require("be8c4164ed1ae10b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.identity.submitPlcOperation';
function toKnownErr(e) {
    return e;
}

},{"45cc790033f4c0da":"4ClhN","be8c4164ed1ae10b":"45ZSh"}],"27epi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("3ffb6cd8b39082b");
const util_1 = require("526e73e3c51c0522");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.identity.updateHandle';
function toKnownErr(e) {
    return e;
}

},{"3ffb6cd8b39082b":"4ClhN","526e73e3c51c0522":"45ZSh"}],"72O1l":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLabel = isLabel;
exports.validateLabel = validateLabel;
exports.isSelfLabels = isSelfLabels;
exports.validateSelfLabels = validateSelfLabels;
exports.isSelfLabel = isSelfLabel;
exports.validateSelfLabel = validateSelfLabel;
exports.isLabelValueDefinition = isLabelValueDefinition;
exports.validateLabelValueDefinition = validateLabelValueDefinition;
exports.isLabelValueDefinitionStrings = isLabelValueDefinitionStrings;
exports.validateLabelValueDefinitionStrings = validateLabelValueDefinitionStrings;
const lexicons_1 = require("6c9548bb583a514b");
const util_1 = require("9e508cf20ee6e981");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.label.defs';
const hashLabel = 'label';
function isLabel(v) {
    return is$typed(v, id, hashLabel);
}
function validateLabel(v) {
    return validate(v, id, hashLabel);
}
const hashSelfLabels = 'selfLabels';
function isSelfLabels(v) {
    return is$typed(v, id, hashSelfLabels);
}
function validateSelfLabels(v) {
    return validate(v, id, hashSelfLabels);
}
const hashSelfLabel = 'selfLabel';
function isSelfLabel(v) {
    return is$typed(v, id, hashSelfLabel);
}
function validateSelfLabel(v) {
    return validate(v, id, hashSelfLabel);
}
const hashLabelValueDefinition = 'labelValueDefinition';
function isLabelValueDefinition(v) {
    return is$typed(v, id, hashLabelValueDefinition);
}
function validateLabelValueDefinition(v) {
    return validate(v, id, hashLabelValueDefinition);
}
const hashLabelValueDefinitionStrings = 'labelValueDefinitionStrings';
function isLabelValueDefinitionStrings(v) {
    return is$typed(v, id, hashLabelValueDefinitionStrings);
}
function validateLabelValueDefinitionStrings(v) {
    return validate(v, id, hashLabelValueDefinitionStrings);
}

},{"6c9548bb583a514b":"4ClhN","9e508cf20ee6e981":"45ZSh"}],"6WQqY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("340f989c62359ab4");
const util_1 = require("97e76d0cf2e62a7");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.label.queryLabels';
function toKnownErr(e) {
    return e;
}

},{"340f989c62359ab4":"4ClhN","97e76d0cf2e62a7":"45ZSh"}],"7mnZI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLabels = isLabels;
exports.validateLabels = validateLabels;
exports.isInfo = isInfo;
exports.validateInfo = validateInfo;
const lexicons_1 = require("7f9218787a9c404e");
const util_1 = require("f724c8895cfdae18");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.label.subscribeLabels';
const hashLabels = 'labels';
function isLabels(v) {
    return is$typed(v, id, hashLabels);
}
function validateLabels(v) {
    return validate(v, id, hashLabels);
}
const hashInfo = 'info';
function isInfo(v) {
    return is$typed(v, id, hashInfo);
}
function validateInfo(v) {
    return validate(v, id, hashInfo);
}

},{"7f9218787a9c404e":"4ClhN","f724c8895cfdae18":"45ZSh"}],"dp0Os":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("ba4f39e291d5d4ed");
const util_1 = require("d10bcaff8ca028bf");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.lexicon.schema';
const hashRecord = 'main';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord, true);
}

},{"ba4f39e291d5d4ed":"4ClhN","d10bcaff8ca028bf":"45ZSh"}],"bxIi5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isModTool = isModTool;
exports.validateModTool = validateModTool;
const lexicons_1 = require("61e408e1a7943270");
const util_1 = require("ea6d2cad61ee8a61");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.moderation.createReport';
function toKnownErr(e) {
    return e;
}
const hashModTool = 'modTool';
function isModTool(v) {
    return is$typed(v, id, hashModTool);
}
function validateModTool(v) {
    return validate(v, id, hashModTool);
}

},{"61e408e1a7943270":"4ClhN","ea6d2cad61ee8a61":"45ZSh"}],"l2Rs3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REASONAPPEAL = exports.REASONOTHER = exports.REASONRUDE = exports.REASONSEXUAL = exports.REASONMISLEADING = exports.REASONVIOLATION = exports.REASONSPAM = void 0;
const lexicons_1 = require("ff083a3cc9f63fcf");
const util_1 = require("aaaa9d00073bd243");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.moderation.defs';
/** Spam: frequent unwanted promotion, replies, mentions. Prefer new lexicon definition `tools.ozone.report.defs#reasonMisleadingSpam`. */ exports.REASONSPAM = `${id}#reasonSpam`;
/** Direct violation of server rules, laws, terms of service. Prefer new lexicon definition `tools.ozone.report.defs#reasonRuleOther`. */ exports.REASONVIOLATION = `${id}#reasonViolation`;
/** Misleading identity, affiliation, or content. Prefer new lexicon definition `tools.ozone.report.defs#reasonMisleadingOther`. */ exports.REASONMISLEADING = `${id}#reasonMisleading`;
/** Unwanted or mislabeled sexual content. Prefer new lexicon definition `tools.ozone.report.defs#reasonSexualUnlabeled`. */ exports.REASONSEXUAL = `${id}#reasonSexual`;
/** Rude, harassing, explicit, or otherwise unwelcoming behavior. Prefer new lexicon definition `tools.ozone.report.defs#reasonHarassmentOther`. */ exports.REASONRUDE = `${id}#reasonRude`;
/** Reports not falling under another report category. Prefer new lexicon definition `tools.ozone.report.defs#reasonOther`. */ exports.REASONOTHER = `${id}#reasonOther`;
/** Appeal a previously taken moderation action */ exports.REASONAPPEAL = `${id}#reasonAppeal`;

},{"ff083a3cc9f63fcf":"4ClhN","aaaa9d00073bd243":"45ZSh"}],"11nCp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isCommitMeta = isCommitMeta;
exports.validateCommitMeta = validateCommitMeta;
const lexicons_1 = require("d03c945d085a8131");
const util_1 = require("be5b2c3ec3de4b18");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.defs';
const hashCommitMeta = 'commitMeta';
function isCommitMeta(v) {
    return is$typed(v, id, hashCommitMeta);
}
function validateCommitMeta(v) {
    return validate(v, id, hashCommitMeta);
}

},{"d03c945d085a8131":"4ClhN","be5b2c3ec3de4b18":"45ZSh"}],"dpgNl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("6a03b64f453c62b4");
const util_1 = require("68dea9676cd4e2a2");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.describeRepo';
function toKnownErr(e) {
    return e;
}

},{"6a03b64f453c62b4":"4ClhN","68dea9676cd4e2a2":"45ZSh"}],"l70O2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("511ebb3c21d04bf1");
const util_1 = require("8b659dcf7ed8b60c");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.importRepo';
function toKnownErr(e) {
    return e;
}

},{"511ebb3c21d04bf1":"4ClhN","8b659dcf7ed8b60c":"45ZSh"}],"dNJki":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isRecordBlob = isRecordBlob;
exports.validateRecordBlob = validateRecordBlob;
const lexicons_1 = require("6ef673cb9da25897");
const util_1 = require("67b4877902b68128");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.listMissingBlobs';
function toKnownErr(e) {
    return e;
}
const hashRecordBlob = 'recordBlob';
function isRecordBlob(v) {
    return is$typed(v, id, hashRecordBlob);
}
function validateRecordBlob(v) {
    return validate(v, id, hashRecordBlob);
}

},{"6ef673cb9da25897":"4ClhN","67b4877902b68128":"45ZSh"}],"7xeaO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isRecord = isRecord;
exports.validateRecord = validateRecord;
const lexicons_1 = require("28057b3a44482679");
const util_1 = require("5723cb04dfa703fb");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.listRecords';
function toKnownErr(e) {
    return e;
}
const hashRecord = 'record';
function isRecord(v) {
    return is$typed(v, id, hashRecord);
}
function validateRecord(v) {
    return validate(v, id, hashRecord);
}

},{"28057b3a44482679":"4ClhN","5723cb04dfa703fb":"45ZSh"}],"MZECW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMain = isMain;
exports.validateMain = validateMain;
const lexicons_1 = require("894d76d2465cfca");
const util_1 = require("1324ab2c643e2351");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.strongRef';
const hashMain = 'main';
function isMain(v) {
    return is$typed(v, id, hashMain);
}
function validateMain(v) {
    return validate(v, id, hashMain);
}

},{"894d76d2465cfca":"4ClhN","1324ab2c643e2351":"45ZSh"}],"3V7yv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("3ad773c9ddaeecd6");
const util_1 = require("b930001bd388163b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.repo.uploadBlob';
function toKnownErr(e) {
    return e;
}

},{"3ad773c9ddaeecd6":"4ClhN","b930001bd388163b":"45ZSh"}],"i6W2K":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("28bdada07e33263d");
const util_1 = require("ece9d47759a17f27");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.activateAccount';
function toKnownErr(e) {
    return e;
}

},{"28bdada07e33263d":"4ClhN","ece9d47759a17f27":"45ZSh"}],"hrPXH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("4138320a4c62ee2d");
const util_1 = require("9359131de40d0651");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.checkAccountStatus';
function toKnownErr(e) {
    return e;
}

},{"4138320a4c62ee2d":"4ClhN","9359131de40d0651":"45ZSh"}],"kCRZF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("9022186073698388");
const util_1 = require("9d3d980abb5f4d4e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.createInviteCode';
function toKnownErr(e) {
    return e;
}

},{"9022186073698388":"4ClhN","9d3d980abb5f4d4e":"45ZSh"}],"jOYW1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isAccountCodes = isAccountCodes;
exports.validateAccountCodes = validateAccountCodes;
const lexicons_1 = require("b958ab2fecf89654");
const util_1 = require("7e62c96bfdd043f2");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.createInviteCodes';
function toKnownErr(e) {
    return e;
}
const hashAccountCodes = 'accountCodes';
function isAccountCodes(v) {
    return is$typed(v, id, hashAccountCodes);
}
function validateAccountCodes(v) {
    return validate(v, id, hashAccountCodes);
}

},{"b958ab2fecf89654":"4ClhN","7e62c96bfdd043f2":"45ZSh"}],"6V0dg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("db9d243084beb2bc");
const util_1 = require("e97052d258225ea6");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.deactivateAccount';
function toKnownErr(e) {
    return e;
}

},{"db9d243084beb2bc":"4ClhN","e97052d258225ea6":"45ZSh"}],"65ow7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isInviteCode = isInviteCode;
exports.validateInviteCode = validateInviteCode;
exports.isInviteCodeUse = isInviteCodeUse;
exports.validateInviteCodeUse = validateInviteCodeUse;
const lexicons_1 = require("789500fcaf8155a5");
const util_1 = require("e9b40c860cd684be");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.defs';
const hashInviteCode = 'inviteCode';
function isInviteCode(v) {
    return is$typed(v, id, hashInviteCode);
}
function validateInviteCode(v) {
    return validate(v, id, hashInviteCode);
}
const hashInviteCodeUse = 'inviteCodeUse';
function isInviteCodeUse(v) {
    return is$typed(v, id, hashInviteCodeUse);
}
function validateInviteCodeUse(v) {
    return validate(v, id, hashInviteCodeUse);
}

},{"789500fcaf8155a5":"4ClhN","e9b40c860cd684be":"45ZSh"}],"5NPbf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("4ba97b35b5943bcb");
const util_1 = require("181a366c33183930");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.deleteSession';
function toKnownErr(e) {
    return e;
}

},{"4ba97b35b5943bcb":"4ClhN","181a366c33183930":"45ZSh"}],"g5IFT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isLinks = isLinks;
exports.validateLinks = validateLinks;
exports.isContact = isContact;
exports.validateContact = validateContact;
const lexicons_1 = require("6028217fb21ddd04");
const util_1 = require("970357fb10f0f058");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.describeServer';
function toKnownErr(e) {
    return e;
}
const hashLinks = 'links';
function isLinks(v) {
    return is$typed(v, id, hashLinks);
}
function validateLinks(v) {
    return validate(v, id, hashLinks);
}
const hashContact = 'contact';
function isContact(v) {
    return is$typed(v, id, hashContact);
}
function validateContact(v) {
    return validate(v, id, hashContact);
}

},{"6028217fb21ddd04":"4ClhN","970357fb10f0f058":"45ZSh"}],"9qcqD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("cd2951d339e69113");
const util_1 = require("244f8f5a68985222");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.getSession';
function toKnownErr(e) {
    return e;
}

},{"cd2951d339e69113":"4ClhN","244f8f5a68985222":"45ZSh"}],"bMO7h":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("ceeb9c9f80c4d1f5");
const util_1 = require("f4a0d3597275b397");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.requestAccountDelete';
function toKnownErr(e) {
    return e;
}

},{"ceeb9c9f80c4d1f5":"4ClhN","f4a0d3597275b397":"45ZSh"}],"4hD0n":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("65d4ade2657868c8");
const util_1 = require("f2ef486ac9c8c59");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.requestEmailConfirmation';
function toKnownErr(e) {
    return e;
}

},{"65d4ade2657868c8":"4ClhN","f2ef486ac9c8c59":"45ZSh"}],"dbUmz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("71be8cf1e8da9716");
const util_1 = require("91a224f077cf1a3c");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.requestEmailUpdate';
function toKnownErr(e) {
    return e;
}

},{"71be8cf1e8da9716":"4ClhN","91a224f077cf1a3c":"45ZSh"}],"2Bt94":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("4c035dd2c57ee3d7");
const util_1 = require("e861da0e8b78894f");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.requestPasswordReset';
function toKnownErr(e) {
    return e;
}

},{"4c035dd2c57ee3d7":"4ClhN","e861da0e8b78894f":"45ZSh"}],"jtEIi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("29b9fe1d6c31dd1c");
const util_1 = require("434d9cd10e24b5e1");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.reserveSigningKey';
function toKnownErr(e) {
    return e;
}

},{"29b9fe1d6c31dd1c":"4ClhN","434d9cd10e24b5e1":"45ZSh"}],"1ejft":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("4789be120be05941");
const util_1 = require("6746229735a0f2a2");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.server.revokeAppPassword';
function toKnownErr(e) {
    return e;
}

},{"4789be120be05941":"4ClhN","6746229735a0f2a2":"45ZSh"}],"7BMac":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const lexicons_1 = require("dd894746b9c04a99");
const util_1 = require("167603b91d3f1bbe");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.defs';

},{"dd894746b9c04a99":"4ClhN","167603b91d3f1bbe":"45ZSh"}],"l3WW5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("d76ba2b23dfca6a4");
const util_1 = require("8ade5a6ea7144c78");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.getCheckout';
function toKnownErr(e) {
    return e;
}

},{"d76ba2b23dfca6a4":"4ClhN","8ade5a6ea7144c78":"45ZSh"}],"2Gxk3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isHost = isHost;
exports.validateHost = validateHost;
const lexicons_1 = require("b9a0e1546da66d07");
const util_1 = require("c745352b82c86de4");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.listHosts';
function toKnownErr(e) {
    return e;
}
const hashHost = 'host';
function isHost(v) {
    return is$typed(v, id, hashHost);
}
function validateHost(v) {
    return validate(v, id, hashHost);
}

},{"b9a0e1546da66d07":"4ClhN","c745352b82c86de4":"45ZSh"}],"1IGif":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isRepo = isRepo;
exports.validateRepo = validateRepo;
const lexicons_1 = require("40af3b0737fa055b");
const util_1 = require("183e2e7fa82f26b8");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.listRepos';
function toKnownErr(e) {
    return e;
}
const hashRepo = 'repo';
function isRepo(v) {
    return is$typed(v, id, hashRepo);
}
function validateRepo(v) {
    return validate(v, id, hashRepo);
}

},{"40af3b0737fa055b":"4ClhN","183e2e7fa82f26b8":"45ZSh"}],"bOj9g":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isRepo = isRepo;
exports.validateRepo = validateRepo;
const lexicons_1 = require("74470648325fa48d");
const util_1 = require("87369e5df8f1b465");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.listReposByCollection';
function toKnownErr(e) {
    return e;
}
const hashRepo = 'repo';
function isRepo(v) {
    return is$typed(v, id, hashRepo);
}
function validateRepo(v) {
    return validate(v, id, hashRepo);
}

},{"74470648325fa48d":"4ClhN","87369e5df8f1b465":"45ZSh"}],"qPmxk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("f38cbb04ec6cea3b");
const util_1 = require("1b1036c0e77210bc");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.notifyOfUpdate';
function toKnownErr(e) {
    return e;
}

},{"f38cbb04ec6cea3b":"4ClhN","1b1036c0e77210bc":"45ZSh"}],"8qR6G":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isCommit = isCommit;
exports.validateCommit = validateCommit;
exports.isSync = isSync;
exports.validateSync = validateSync;
exports.isIdentity = isIdentity;
exports.validateIdentity = validateIdentity;
exports.isAccount = isAccount;
exports.validateAccount = validateAccount;
exports.isInfo = isInfo;
exports.validateInfo = validateInfo;
exports.isRepoOp = isRepoOp;
exports.validateRepoOp = validateRepoOp;
const lexicons_1 = require("f42af703db0aab11");
const util_1 = require("77cdc341e5332c02");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.sync.subscribeRepos';
const hashCommit = 'commit';
function isCommit(v) {
    return is$typed(v, id, hashCommit);
}
function validateCommit(v) {
    return validate(v, id, hashCommit);
}
const hashSync = 'sync';
function isSync(v) {
    return is$typed(v, id, hashSync);
}
function validateSync(v) {
    return validate(v, id, hashSync);
}
const hashIdentity = 'identity';
function isIdentity(v) {
    return is$typed(v, id, hashIdentity);
}
function validateIdentity(v) {
    return validate(v, id, hashIdentity);
}
const hashAccount = 'account';
function isAccount(v) {
    return is$typed(v, id, hashAccount);
}
function validateAccount(v) {
    return validate(v, id, hashAccount);
}
const hashInfo = 'info';
function isInfo(v) {
    return is$typed(v, id, hashInfo);
}
function validateInfo(v) {
    return validate(v, id, hashInfo);
}
const hashRepoOp = 'repoOp';
function isRepoOp(v) {
    return is$typed(v, id, hashRepoOp);
}
function validateRepoOp(v) {
    return validate(v, id, hashRepoOp);
}

},{"f42af703db0aab11":"4ClhN","77cdc341e5332c02":"45ZSh"}],"cdMSF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("6397713c2f7c052a");
const util_1 = require("e2617119173b9185");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.temp.addReservedHandle';
function toKnownErr(e) {
    return e;
}

},{"6397713c2f7c052a":"4ClhN","e2617119173b9185":"45ZSh"}],"6fp23":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("ad2b0d8db05361f7");
const util_1 = require("a5b7815153e78276");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.temp.checkSignupQueue';
function toKnownErr(e) {
    return e;
}

},{"ad2b0d8db05361f7":"4ClhN","a5b7815153e78276":"45ZSh"}],"gtviJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("905b35a2b80272c6");
const util_1 = require("a9025077549e43cd");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.temp.fetchLabels';
function toKnownErr(e) {
    return e;
}

},{"905b35a2b80272c6":"4ClhN","a9025077549e43cd":"45ZSh"}],"jVQDd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("7288b34c05aee067");
const util_1 = require("b5d41d5ef6f2ff72");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.temp.requestPhoneVerification';
function toKnownErr(e) {
    return e;
}

},{"7288b34c05aee067":"4ClhN","b5d41d5ef6f2ff72":"45ZSh"}],"5Bpn6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("945ff33e9d8434f3");
const util_1 = require("a204d398d283f650");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.temp.revokeAccountCredentials';
function toKnownErr(e) {
    return e;
}

},{"945ff33e9d8434f3":"4ClhN","a204d398d283f650":"45ZSh"}],"fMJSR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isTemplateView = isTemplateView;
exports.validateTemplateView = validateTemplateView;
const lexicons_1 = require("49c892541f26709e");
const util_1 = require("34a7616536aefc05");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.communication.defs';
const hashTemplateView = 'templateView';
function isTemplateView(v) {
    return is$typed(v, id, hashTemplateView);
}
function validateTemplateView(v) {
    return validate(v, id, hashTemplateView);
}

},{"49c892541f26709e":"4ClhN","34a7616536aefc05":"45ZSh"}],"gn7lw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("617e61d49c50f6da");
const util_1 = require("c8629b07c143fa2e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.communication.deleteTemplate';
function toKnownErr(e) {
    return e;
}

},{"617e61d49c50f6da":"4ClhN","c8629b07c143fa2e":"45ZSh"}],"eZuGO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("5d814824a0d7df3b");
const util_1 = require("da06367bc013985");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.communication.listTemplates';
function toKnownErr(e) {
    return e;
}

},{"5d814824a0d7df3b":"4ClhN","da06367bc013985":"45ZSh"}],"cBy4G":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isEvent = isEvent;
exports.validateEvent = validateEvent;
exports.isAccountCreated = isAccountCreated;
exports.validateAccountCreated = validateAccountCreated;
exports.isEmailUpdated = isEmailUpdated;
exports.validateEmailUpdated = validateEmailUpdated;
exports.isEmailConfirmed = isEmailConfirmed;
exports.validateEmailConfirmed = validateEmailConfirmed;
exports.isPasswordUpdated = isPasswordUpdated;
exports.validatePasswordUpdated = validatePasswordUpdated;
exports.isHandleUpdated = isHandleUpdated;
exports.validateHandleUpdated = validateHandleUpdated;
const lexicons_1 = require("33c8fb5fd2f047a5");
const util_1 = require("8ce4555aac50a40a");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.hosting.getAccountHistory';
function toKnownErr(e) {
    return e;
}
const hashEvent = 'event';
function isEvent(v) {
    return is$typed(v, id, hashEvent);
}
function validateEvent(v) {
    return validate(v, id, hashEvent);
}
const hashAccountCreated = 'accountCreated';
function isAccountCreated(v) {
    return is$typed(v, id, hashAccountCreated);
}
function validateAccountCreated(v) {
    return validate(v, id, hashAccountCreated);
}
const hashEmailUpdated = 'emailUpdated';
function isEmailUpdated(v) {
    return is$typed(v, id, hashEmailUpdated);
}
function validateEmailUpdated(v) {
    return validate(v, id, hashEmailUpdated);
}
const hashEmailConfirmed = 'emailConfirmed';
function isEmailConfirmed(v) {
    return is$typed(v, id, hashEmailConfirmed);
}
function validateEmailConfirmed(v) {
    return validate(v, id, hashEmailConfirmed);
}
const hashPasswordUpdated = 'passwordUpdated';
function isPasswordUpdated(v) {
    return is$typed(v, id, hashPasswordUpdated);
}
function validatePasswordUpdated(v) {
    return validate(v, id, hashPasswordUpdated);
}
const hashHandleUpdated = 'handleUpdated';
function isHandleUpdated(v) {
    return is$typed(v, id, hashHandleUpdated);
}
function validateHandleUpdated(v) {
    return validate(v, id, hashHandleUpdated);
}

},{"33c8fb5fd2f047a5":"4ClhN","8ce4555aac50a40a":"45ZSh"}],"3eSbY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isCancellationResults = isCancellationResults;
exports.validateCancellationResults = validateCancellationResults;
exports.isFailedCancellation = isFailedCancellation;
exports.validateFailedCancellation = validateFailedCancellation;
const lexicons_1 = require("7884141240479ea8");
const util_1 = require("52b47f57f8ecf66b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.cancelScheduledActions';
function toKnownErr(e) {
    return e;
}
const hashCancellationResults = 'cancellationResults';
function isCancellationResults(v) {
    return is$typed(v, id, hashCancellationResults);
}
function validateCancellationResults(v) {
    return validate(v, id, hashCancellationResults);
}
const hashFailedCancellation = 'failedCancellation';
function isFailedCancellation(v) {
    return is$typed(v, id, hashFailedCancellation);
}
function validateFailedCancellation(v) {
    return validate(v, id, hashFailedCancellation);
}

},{"7884141240479ea8":"4ClhN","52b47f57f8ecf66b":"45ZSh"}],"hxrzZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TIMELINEEVENTPLCTOMBSTONE = exports.TIMELINEEVENTPLCOPERATION = exports.TIMELINEEVENTPLCCREATE = exports.REVIEWNONE = exports.REVIEWCLOSED = exports.REVIEWESCALATED = exports.REVIEWOPEN = void 0;
exports.isModEventView = isModEventView;
exports.validateModEventView = validateModEventView;
exports.isModEventViewDetail = isModEventViewDetail;
exports.validateModEventViewDetail = validateModEventViewDetail;
exports.isSubjectStatusView = isSubjectStatusView;
exports.validateSubjectStatusView = validateSubjectStatusView;
exports.isSubjectView = isSubjectView;
exports.validateSubjectView = validateSubjectView;
exports.isAccountStats = isAccountStats;
exports.validateAccountStats = validateAccountStats;
exports.isRecordsStats = isRecordsStats;
exports.validateRecordsStats = validateRecordsStats;
exports.isModEventTakedown = isModEventTakedown;
exports.validateModEventTakedown = validateModEventTakedown;
exports.isModEventReverseTakedown = isModEventReverseTakedown;
exports.validateModEventReverseTakedown = validateModEventReverseTakedown;
exports.isModEventResolveAppeal = isModEventResolveAppeal;
exports.validateModEventResolveAppeal = validateModEventResolveAppeal;
exports.isModEventComment = isModEventComment;
exports.validateModEventComment = validateModEventComment;
exports.isModEventReport = isModEventReport;
exports.validateModEventReport = validateModEventReport;
exports.isModEventLabel = isModEventLabel;
exports.validateModEventLabel = validateModEventLabel;
exports.isModEventPriorityScore = isModEventPriorityScore;
exports.validateModEventPriorityScore = validateModEventPriorityScore;
exports.isAgeAssuranceEvent = isAgeAssuranceEvent;
exports.validateAgeAssuranceEvent = validateAgeAssuranceEvent;
exports.isAgeAssuranceOverrideEvent = isAgeAssuranceOverrideEvent;
exports.validateAgeAssuranceOverrideEvent = validateAgeAssuranceOverrideEvent;
exports.isRevokeAccountCredentialsEvent = isRevokeAccountCredentialsEvent;
exports.validateRevokeAccountCredentialsEvent = validateRevokeAccountCredentialsEvent;
exports.isModEventAcknowledge = isModEventAcknowledge;
exports.validateModEventAcknowledge = validateModEventAcknowledge;
exports.isModEventEscalate = isModEventEscalate;
exports.validateModEventEscalate = validateModEventEscalate;
exports.isModEventMute = isModEventMute;
exports.validateModEventMute = validateModEventMute;
exports.isModEventUnmute = isModEventUnmute;
exports.validateModEventUnmute = validateModEventUnmute;
exports.isModEventMuteReporter = isModEventMuteReporter;
exports.validateModEventMuteReporter = validateModEventMuteReporter;
exports.isModEventUnmuteReporter = isModEventUnmuteReporter;
exports.validateModEventUnmuteReporter = validateModEventUnmuteReporter;
exports.isModEventEmail = isModEventEmail;
exports.validateModEventEmail = validateModEventEmail;
exports.isModEventDivert = isModEventDivert;
exports.validateModEventDivert = validateModEventDivert;
exports.isModEventTag = isModEventTag;
exports.validateModEventTag = validateModEventTag;
exports.isAccountEvent = isAccountEvent;
exports.validateAccountEvent = validateAccountEvent;
exports.isIdentityEvent = isIdentityEvent;
exports.validateIdentityEvent = validateIdentityEvent;
exports.isRecordEvent = isRecordEvent;
exports.validateRecordEvent = validateRecordEvent;
exports.isScheduleTakedownEvent = isScheduleTakedownEvent;
exports.validateScheduleTakedownEvent = validateScheduleTakedownEvent;
exports.isCancelScheduledTakedownEvent = isCancelScheduledTakedownEvent;
exports.validateCancelScheduledTakedownEvent = validateCancelScheduledTakedownEvent;
exports.isRepoView = isRepoView;
exports.validateRepoView = validateRepoView;
exports.isRepoViewDetail = isRepoViewDetail;
exports.validateRepoViewDetail = validateRepoViewDetail;
exports.isRepoViewNotFound = isRepoViewNotFound;
exports.validateRepoViewNotFound = validateRepoViewNotFound;
exports.isRecordView = isRecordView;
exports.validateRecordView = validateRecordView;
exports.isRecordViewDetail = isRecordViewDetail;
exports.validateRecordViewDetail = validateRecordViewDetail;
exports.isRecordViewNotFound = isRecordViewNotFound;
exports.validateRecordViewNotFound = validateRecordViewNotFound;
exports.isModeration = isModeration;
exports.validateModeration = validateModeration;
exports.isModerationDetail = isModerationDetail;
exports.validateModerationDetail = validateModerationDetail;
exports.isBlobView = isBlobView;
exports.validateBlobView = validateBlobView;
exports.isImageDetails = isImageDetails;
exports.validateImageDetails = validateImageDetails;
exports.isVideoDetails = isVideoDetails;
exports.validateVideoDetails = validateVideoDetails;
exports.isAccountHosting = isAccountHosting;
exports.validateAccountHosting = validateAccountHosting;
exports.isRecordHosting = isRecordHosting;
exports.validateRecordHosting = validateRecordHosting;
exports.isReporterStats = isReporterStats;
exports.validateReporterStats = validateReporterStats;
exports.isModTool = isModTool;
exports.validateModTool = validateModTool;
exports.isScheduledActionView = isScheduledActionView;
exports.validateScheduledActionView = validateScheduledActionView;
const lexicons_1 = require("58deb76201477631");
const util_1 = require("afcd97b75e271655");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.defs';
const hashModEventView = 'modEventView';
function isModEventView(v) {
    return is$typed(v, id, hashModEventView);
}
function validateModEventView(v) {
    return validate(v, id, hashModEventView);
}
const hashModEventViewDetail = 'modEventViewDetail';
function isModEventViewDetail(v) {
    return is$typed(v, id, hashModEventViewDetail);
}
function validateModEventViewDetail(v) {
    return validate(v, id, hashModEventViewDetail);
}
const hashSubjectStatusView = 'subjectStatusView';
function isSubjectStatusView(v) {
    return is$typed(v, id, hashSubjectStatusView);
}
function validateSubjectStatusView(v) {
    return validate(v, id, hashSubjectStatusView);
}
const hashSubjectView = 'subjectView';
function isSubjectView(v) {
    return is$typed(v, id, hashSubjectView);
}
function validateSubjectView(v) {
    return validate(v, id, hashSubjectView);
}
const hashAccountStats = 'accountStats';
function isAccountStats(v) {
    return is$typed(v, id, hashAccountStats);
}
function validateAccountStats(v) {
    return validate(v, id, hashAccountStats);
}
const hashRecordsStats = 'recordsStats';
function isRecordsStats(v) {
    return is$typed(v, id, hashRecordsStats);
}
function validateRecordsStats(v) {
    return validate(v, id, hashRecordsStats);
}
/** Moderator review status of a subject: Open. Indicates that the subject needs to be reviewed by a moderator */ exports.REVIEWOPEN = `${id}#reviewOpen`;
/** Moderator review status of a subject: Escalated. Indicates that the subject was escalated for review by a moderator */ exports.REVIEWESCALATED = `${id}#reviewEscalated`;
/** Moderator review status of a subject: Closed. Indicates that the subject was already reviewed and resolved by a moderator */ exports.REVIEWCLOSED = `${id}#reviewClosed`;
/** Moderator review status of a subject: Unnecessary. Indicates that the subject does not need a review at the moment but there is probably some moderation related metadata available for it */ exports.REVIEWNONE = `${id}#reviewNone`;
const hashModEventTakedown = 'modEventTakedown';
function isModEventTakedown(v) {
    return is$typed(v, id, hashModEventTakedown);
}
function validateModEventTakedown(v) {
    return validate(v, id, hashModEventTakedown);
}
const hashModEventReverseTakedown = 'modEventReverseTakedown';
function isModEventReverseTakedown(v) {
    return is$typed(v, id, hashModEventReverseTakedown);
}
function validateModEventReverseTakedown(v) {
    return validate(v, id, hashModEventReverseTakedown);
}
const hashModEventResolveAppeal = 'modEventResolveAppeal';
function isModEventResolveAppeal(v) {
    return is$typed(v, id, hashModEventResolveAppeal);
}
function validateModEventResolveAppeal(v) {
    return validate(v, id, hashModEventResolveAppeal);
}
const hashModEventComment = 'modEventComment';
function isModEventComment(v) {
    return is$typed(v, id, hashModEventComment);
}
function validateModEventComment(v) {
    return validate(v, id, hashModEventComment);
}
const hashModEventReport = 'modEventReport';
function isModEventReport(v) {
    return is$typed(v, id, hashModEventReport);
}
function validateModEventReport(v) {
    return validate(v, id, hashModEventReport);
}
const hashModEventLabel = 'modEventLabel';
function isModEventLabel(v) {
    return is$typed(v, id, hashModEventLabel);
}
function validateModEventLabel(v) {
    return validate(v, id, hashModEventLabel);
}
const hashModEventPriorityScore = 'modEventPriorityScore';
function isModEventPriorityScore(v) {
    return is$typed(v, id, hashModEventPriorityScore);
}
function validateModEventPriorityScore(v) {
    return validate(v, id, hashModEventPriorityScore);
}
const hashAgeAssuranceEvent = 'ageAssuranceEvent';
function isAgeAssuranceEvent(v) {
    return is$typed(v, id, hashAgeAssuranceEvent);
}
function validateAgeAssuranceEvent(v) {
    return validate(v, id, hashAgeAssuranceEvent);
}
const hashAgeAssuranceOverrideEvent = 'ageAssuranceOverrideEvent';
function isAgeAssuranceOverrideEvent(v) {
    return is$typed(v, id, hashAgeAssuranceOverrideEvent);
}
function validateAgeAssuranceOverrideEvent(v) {
    return validate(v, id, hashAgeAssuranceOverrideEvent);
}
const hashRevokeAccountCredentialsEvent = 'revokeAccountCredentialsEvent';
function isRevokeAccountCredentialsEvent(v) {
    return is$typed(v, id, hashRevokeAccountCredentialsEvent);
}
function validateRevokeAccountCredentialsEvent(v) {
    return validate(v, id, hashRevokeAccountCredentialsEvent);
}
const hashModEventAcknowledge = 'modEventAcknowledge';
function isModEventAcknowledge(v) {
    return is$typed(v, id, hashModEventAcknowledge);
}
function validateModEventAcknowledge(v) {
    return validate(v, id, hashModEventAcknowledge);
}
const hashModEventEscalate = 'modEventEscalate';
function isModEventEscalate(v) {
    return is$typed(v, id, hashModEventEscalate);
}
function validateModEventEscalate(v) {
    return validate(v, id, hashModEventEscalate);
}
const hashModEventMute = 'modEventMute';
function isModEventMute(v) {
    return is$typed(v, id, hashModEventMute);
}
function validateModEventMute(v) {
    return validate(v, id, hashModEventMute);
}
const hashModEventUnmute = 'modEventUnmute';
function isModEventUnmute(v) {
    return is$typed(v, id, hashModEventUnmute);
}
function validateModEventUnmute(v) {
    return validate(v, id, hashModEventUnmute);
}
const hashModEventMuteReporter = 'modEventMuteReporter';
function isModEventMuteReporter(v) {
    return is$typed(v, id, hashModEventMuteReporter);
}
function validateModEventMuteReporter(v) {
    return validate(v, id, hashModEventMuteReporter);
}
const hashModEventUnmuteReporter = 'modEventUnmuteReporter';
function isModEventUnmuteReporter(v) {
    return is$typed(v, id, hashModEventUnmuteReporter);
}
function validateModEventUnmuteReporter(v) {
    return validate(v, id, hashModEventUnmuteReporter);
}
const hashModEventEmail = 'modEventEmail';
function isModEventEmail(v) {
    return is$typed(v, id, hashModEventEmail);
}
function validateModEventEmail(v) {
    return validate(v, id, hashModEventEmail);
}
const hashModEventDivert = 'modEventDivert';
function isModEventDivert(v) {
    return is$typed(v, id, hashModEventDivert);
}
function validateModEventDivert(v) {
    return validate(v, id, hashModEventDivert);
}
const hashModEventTag = 'modEventTag';
function isModEventTag(v) {
    return is$typed(v, id, hashModEventTag);
}
function validateModEventTag(v) {
    return validate(v, id, hashModEventTag);
}
const hashAccountEvent = 'accountEvent';
function isAccountEvent(v) {
    return is$typed(v, id, hashAccountEvent);
}
function validateAccountEvent(v) {
    return validate(v, id, hashAccountEvent);
}
const hashIdentityEvent = 'identityEvent';
function isIdentityEvent(v) {
    return is$typed(v, id, hashIdentityEvent);
}
function validateIdentityEvent(v) {
    return validate(v, id, hashIdentityEvent);
}
const hashRecordEvent = 'recordEvent';
function isRecordEvent(v) {
    return is$typed(v, id, hashRecordEvent);
}
function validateRecordEvent(v) {
    return validate(v, id, hashRecordEvent);
}
const hashScheduleTakedownEvent = 'scheduleTakedownEvent';
function isScheduleTakedownEvent(v) {
    return is$typed(v, id, hashScheduleTakedownEvent);
}
function validateScheduleTakedownEvent(v) {
    return validate(v, id, hashScheduleTakedownEvent);
}
const hashCancelScheduledTakedownEvent = 'cancelScheduledTakedownEvent';
function isCancelScheduledTakedownEvent(v) {
    return is$typed(v, id, hashCancelScheduledTakedownEvent);
}
function validateCancelScheduledTakedownEvent(v) {
    return validate(v, id, hashCancelScheduledTakedownEvent);
}
const hashRepoView = 'repoView';
function isRepoView(v) {
    return is$typed(v, id, hashRepoView);
}
function validateRepoView(v) {
    return validate(v, id, hashRepoView);
}
const hashRepoViewDetail = 'repoViewDetail';
function isRepoViewDetail(v) {
    return is$typed(v, id, hashRepoViewDetail);
}
function validateRepoViewDetail(v) {
    return validate(v, id, hashRepoViewDetail);
}
const hashRepoViewNotFound = 'repoViewNotFound';
function isRepoViewNotFound(v) {
    return is$typed(v, id, hashRepoViewNotFound);
}
function validateRepoViewNotFound(v) {
    return validate(v, id, hashRepoViewNotFound);
}
const hashRecordView = 'recordView';
function isRecordView(v) {
    return is$typed(v, id, hashRecordView);
}
function validateRecordView(v) {
    return validate(v, id, hashRecordView);
}
const hashRecordViewDetail = 'recordViewDetail';
function isRecordViewDetail(v) {
    return is$typed(v, id, hashRecordViewDetail);
}
function validateRecordViewDetail(v) {
    return validate(v, id, hashRecordViewDetail);
}
const hashRecordViewNotFound = 'recordViewNotFound';
function isRecordViewNotFound(v) {
    return is$typed(v, id, hashRecordViewNotFound);
}
function validateRecordViewNotFound(v) {
    return validate(v, id, hashRecordViewNotFound);
}
const hashModeration = 'moderation';
function isModeration(v) {
    return is$typed(v, id, hashModeration);
}
function validateModeration(v) {
    return validate(v, id, hashModeration);
}
const hashModerationDetail = 'moderationDetail';
function isModerationDetail(v) {
    return is$typed(v, id, hashModerationDetail);
}
function validateModerationDetail(v) {
    return validate(v, id, hashModerationDetail);
}
const hashBlobView = 'blobView';
function isBlobView(v) {
    return is$typed(v, id, hashBlobView);
}
function validateBlobView(v) {
    return validate(v, id, hashBlobView);
}
const hashImageDetails = 'imageDetails';
function isImageDetails(v) {
    return is$typed(v, id, hashImageDetails);
}
function validateImageDetails(v) {
    return validate(v, id, hashImageDetails);
}
const hashVideoDetails = 'videoDetails';
function isVideoDetails(v) {
    return is$typed(v, id, hashVideoDetails);
}
function validateVideoDetails(v) {
    return validate(v, id, hashVideoDetails);
}
const hashAccountHosting = 'accountHosting';
function isAccountHosting(v) {
    return is$typed(v, id, hashAccountHosting);
}
function validateAccountHosting(v) {
    return validate(v, id, hashAccountHosting);
}
const hashRecordHosting = 'recordHosting';
function isRecordHosting(v) {
    return is$typed(v, id, hashRecordHosting);
}
function validateRecordHosting(v) {
    return validate(v, id, hashRecordHosting);
}
const hashReporterStats = 'reporterStats';
function isReporterStats(v) {
    return is$typed(v, id, hashReporterStats);
}
function validateReporterStats(v) {
    return validate(v, id, hashReporterStats);
}
const hashModTool = 'modTool';
function isModTool(v) {
    return is$typed(v, id, hashModTool);
}
function validateModTool(v) {
    return validate(v, id, hashModTool);
}
/** Moderation event timeline event for a PLC create operation */ exports.TIMELINEEVENTPLCCREATE = `${id}#timelineEventPlcCreate`;
/** Moderation event timeline event for generic PLC operation */ exports.TIMELINEEVENTPLCOPERATION = `${id}#timelineEventPlcOperation`;
/** Moderation event timeline event for a PLC tombstone operation */ exports.TIMELINEEVENTPLCTOMBSTONE = `${id}#timelineEventPlcTombstone`;
const hashScheduledActionView = 'scheduledActionView';
function isScheduledActionView(v) {
    return is$typed(v, id, hashScheduledActionView);
}
function validateScheduledActionView(v) {
    return validate(v, id, hashScheduledActionView);
}

},{"58deb76201477631":"4ClhN","afcd97b75e271655":"45ZSh"}],"6GCJR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("74810408746ff6c0");
const util_1 = require("c60356b7018d8aec");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.getEvent';
function toKnownErr(e) {
    return e;
}

},{"74810408746ff6c0":"4ClhN","c60356b7018d8aec":"45ZSh"}],"dCAV8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("e7191943f7efa40");
const util_1 = require("c31499da4ea8ebf9");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.getRecords';
function toKnownErr(e) {
    return e;
}

},{"e7191943f7efa40":"4ClhN","c31499da4ea8ebf9":"45ZSh"}],"cpxS5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("da06b5d36c8d6f70");
const util_1 = require("a967b6d57c9b1dce");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.getReporterStats';
function toKnownErr(e) {
    return e;
}

},{"da06b5d36c8d6f70":"4ClhN","a967b6d57c9b1dce":"45ZSh"}],"aH5Rt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("892ad26537c2fd36");
const util_1 = require("12ee46211963256a");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.getRepos';
function toKnownErr(e) {
    return e;
}

},{"892ad26537c2fd36":"4ClhN","12ee46211963256a":"45ZSh"}],"hcjLB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("a3b8359d352592d6");
const util_1 = require("818d1b39c5487bb9");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.getSubjects';
function toKnownErr(e) {
    return e;
}

},{"a3b8359d352592d6":"4ClhN","818d1b39c5487bb9":"45ZSh"}],"gekZN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("523331797999bef0");
const util_1 = require("27979bef1c7ed301");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.listScheduledActions';
function toKnownErr(e) {
    return e;
}

},{"523331797999bef0":"4ClhN","27979bef1c7ed301":"45ZSh"}],"3wfjJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("e239c22a3b255d9a");
const util_1 = require("7195b1b91a349647");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.queryEvents';
function toKnownErr(e) {
    return e;
}

},{"e239c22a3b255d9a":"4ClhN","7195b1b91a349647":"45ZSh"}],"8VuN2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("645f3cfbaf716d79");
const util_1 = require("2d554c2b5722f8dc");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.queryStatuses';
function toKnownErr(e) {
    return e;
}

},{"645f3cfbaf716d79":"4ClhN","2d554c2b5722f8dc":"45ZSh"}],"8uQ7V":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isTakedown = isTakedown;
exports.validateTakedown = validateTakedown;
exports.isSchedulingConfig = isSchedulingConfig;
exports.validateSchedulingConfig = validateSchedulingConfig;
exports.isScheduledActionResults = isScheduledActionResults;
exports.validateScheduledActionResults = validateScheduledActionResults;
exports.isFailedScheduling = isFailedScheduling;
exports.validateFailedScheduling = validateFailedScheduling;
const lexicons_1 = require("fdb72262e6759499");
const util_1 = require("d811de08a47fccd5");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.scheduleAction';
function toKnownErr(e) {
    return e;
}
const hashTakedown = 'takedown';
function isTakedown(v) {
    return is$typed(v, id, hashTakedown);
}
function validateTakedown(v) {
    return validate(v, id, hashTakedown);
}
const hashSchedulingConfig = 'schedulingConfig';
function isSchedulingConfig(v) {
    return is$typed(v, id, hashSchedulingConfig);
}
function validateSchedulingConfig(v) {
    return validate(v, id, hashSchedulingConfig);
}
const hashScheduledActionResults = 'scheduledActionResults';
function isScheduledActionResults(v) {
    return is$typed(v, id, hashScheduledActionResults);
}
function validateScheduledActionResults(v) {
    return validate(v, id, hashScheduledActionResults);
}
const hashFailedScheduling = 'failedScheduling';
function isFailedScheduling(v) {
    return is$typed(v, id, hashFailedScheduling);
}
function validateFailedScheduling(v) {
    return validate(v, id, hashFailedScheduling);
}

},{"fdb72262e6759499":"4ClhN","d811de08a47fccd5":"45ZSh"}],"9wWz6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("d9e63cc1753f6b2f");
const util_1 = require("1a6db08c37e479f5");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.moderation.searchRepos';
function toKnownErr(e) {
    return e;
}

},{"d9e63cc1753f6b2f":"4ClhN","1a6db08c37e479f5":"45ZSh"}],"eoPDH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REASONSELFHARMOTHER = exports.REASONSELFHARMSUBSTANCES = exports.REASONSELFHARMSTUNTS = exports.REASONSELFHARMED = exports.REASONSELFHARMCONTENT = exports.REASONRULEOTHER = exports.REASONRULEBANEVASION = exports.REASONRULEPROHIBITEDSALES = exports.REASONRULESITESECURITY = exports.REASONMISLEADINGOTHER = exports.REASONMISLEADINGELECTIONS = exports.REASONMISLEADINGSCAM = exports.REASONMISLEADINGSPAM = exports.REASONMISLEADINGIMPERSONATION = exports.REASONMISLEADINGBOT = exports.REASONHARASSMENTOTHER = exports.REASONHARASSMENTDOXXING = exports.REASONHARASSMENTHATESPEECH = exports.REASONHARASSMENTTARGETED = exports.REASONHARASSMENTTROLL = exports.REASONCHILDSAFETYOTHER = exports.REASONCHILDSAFETYHARASSMENT = exports.REASONCHILDSAFETYPRIVACY = exports.REASONCHILDSAFETYGROOM = exports.REASONCHILDSAFETYCSAM = exports.REASONSEXUALOTHER = exports.REASONSEXUALUNLABELED = exports.REASONSEXUALANIMAL = exports.REASONSEXUALDEEPFAKE = exports.REASONSEXUALNCII = exports.REASONSEXUALABUSECONTENT = exports.REASONVIOLENCEOTHER = exports.REASONVIOLENCETRAFFICKING = exports.REASONVIOLENCEEXTREMISTCONTENT = exports.REASONVIOLENCEGLORIFICATION = exports.REASONVIOLENCEGRAPHICCONTENT = exports.REASONVIOLENCETHREATS = exports.REASONVIOLENCEANIMAL = exports.REASONOTHER = exports.REASONAPPEAL = void 0;
const lexicons_1 = require("ef91b4297a05fb82");
const util_1 = require("a60db9e1ed7c02e3");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.report.defs';
/** Appeal a previously taken moderation action */ exports.REASONAPPEAL = `${id}#reasonAppeal`;
/** An issue not included in these options */ exports.REASONOTHER = `${id}#reasonOther`;
/** Animal welfare violations */ exports.REASONVIOLENCEANIMAL = `${id}#reasonViolenceAnimal`;
/** Threats or incitement */ exports.REASONVIOLENCETHREATS = `${id}#reasonViolenceThreats`;
/** Graphic violent content */ exports.REASONVIOLENCEGRAPHICCONTENT = `${id}#reasonViolenceGraphicContent`;
/** Glorification of violence */ exports.REASONVIOLENCEGLORIFICATION = `${id}#reasonViolenceGlorification`;
/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */ exports.REASONVIOLENCEEXTREMISTCONTENT = `${id}#reasonViolenceExtremistContent`;
/** Human trafficking */ exports.REASONVIOLENCETRAFFICKING = `${id}#reasonViolenceTrafficking`;
/** Other violent content */ exports.REASONVIOLENCEOTHER = `${id}#reasonViolenceOther`;
/** Adult sexual abuse content */ exports.REASONSEXUALABUSECONTENT = `${id}#reasonSexualAbuseContent`;
/** Non-consensual intimate imagery */ exports.REASONSEXUALNCII = `${id}#reasonSexualNCII`;
/** Deepfake adult content */ exports.REASONSEXUALDEEPFAKE = `${id}#reasonSexualDeepfake`;
/** Animal sexual abuse */ exports.REASONSEXUALANIMAL = `${id}#reasonSexualAnimal`;
/** Unlabelled adult content */ exports.REASONSEXUALUNLABELED = `${id}#reasonSexualUnlabeled`;
/** Other sexual violence content */ exports.REASONSEXUALOTHER = `${id}#reasonSexualOther`;
/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */ exports.REASONCHILDSAFETYCSAM = `${id}#reasonChildSafetyCSAM`;
/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */ exports.REASONCHILDSAFETYGROOM = `${id}#reasonChildSafetyGroom`;
/** Privacy violation involving a minor */ exports.REASONCHILDSAFETYPRIVACY = `${id}#reasonChildSafetyPrivacy`;
/** Harassment or bullying of minors */ exports.REASONCHILDSAFETYHARASSMENT = `${id}#reasonChildSafetyHarassment`;
/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */ exports.REASONCHILDSAFETYOTHER = `${id}#reasonChildSafetyOther`;
/** Trolling */ exports.REASONHARASSMENTTROLL = `${id}#reasonHarassmentTroll`;
/** Targeted harassment */ exports.REASONHARASSMENTTARGETED = `${id}#reasonHarassmentTargeted`;
/** Hate speech */ exports.REASONHARASSMENTHATESPEECH = `${id}#reasonHarassmentHateSpeech`;
/** Doxxing */ exports.REASONHARASSMENTDOXXING = `${id}#reasonHarassmentDoxxing`;
/** Other harassing or hateful content */ exports.REASONHARASSMENTOTHER = `${id}#reasonHarassmentOther`;
/** Fake account or bot */ exports.REASONMISLEADINGBOT = `${id}#reasonMisleadingBot`;
/** Impersonation */ exports.REASONMISLEADINGIMPERSONATION = `${id}#reasonMisleadingImpersonation`;
/** Spam */ exports.REASONMISLEADINGSPAM = `${id}#reasonMisleadingSpam`;
/** Scam */ exports.REASONMISLEADINGSCAM = `${id}#reasonMisleadingScam`;
/** False information about elections */ exports.REASONMISLEADINGELECTIONS = `${id}#reasonMisleadingElections`;
/** Other misleading content */ exports.REASONMISLEADINGOTHER = `${id}#reasonMisleadingOther`;
/** Hacking or system attacks */ exports.REASONRULESITESECURITY = `${id}#reasonRuleSiteSecurity`;
/** Promoting or selling prohibited items or services */ exports.REASONRULEPROHIBITEDSALES = `${id}#reasonRuleProhibitedSales`;
/** Banned user returning */ exports.REASONRULEBANEVASION = `${id}#reasonRuleBanEvasion`;
/** Other */ exports.REASONRULEOTHER = `${id}#reasonRuleOther`;
/** Content promoting or depicting self-harm */ exports.REASONSELFHARMCONTENT = `${id}#reasonSelfHarmContent`;
/** Eating disorders */ exports.REASONSELFHARMED = `${id}#reasonSelfHarmED`;
/** Dangerous challenges or activities */ exports.REASONSELFHARMSTUNTS = `${id}#reasonSelfHarmStunts`;
/** Dangerous substances or drug abuse */ exports.REASONSELFHARMSUBSTANCES = `${id}#reasonSelfHarmSubstances`;
/** Other dangerous content */ exports.REASONSELFHARMOTHER = `${id}#reasonSelfHarmOther`;

},{"ef91b4297a05fb82":"4ClhN","a60db9e1ed7c02e3":"45ZSh"}],"6ZZaI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEvent = isEvent;
exports.validateEvent = validateEvent;
exports.isUrlRule = isUrlRule;
exports.validateUrlRule = validateUrlRule;
const lexicons_1 = require("8f625c1b8253bcd5");
const util_1 = require("545d9f7092cb23c5");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.safelink.defs';
const hashEvent = 'event';
function isEvent(v) {
    return is$typed(v, id, hashEvent);
}
function validateEvent(v) {
    return validate(v, id, hashEvent);
}
const hashUrlRule = 'urlRule';
function isUrlRule(v) {
    return is$typed(v, id, hashUrlRule);
}
function validateUrlRule(v) {
    return validate(v, id, hashUrlRule);
}

},{"8f625c1b8253bcd5":"4ClhN","545d9f7092cb23c5":"45ZSh"}],"khuOv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("1c707a6828a80e23");
const util_1 = require("539a40bf2622e4ce");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.safelink.queryEvents';
function toKnownErr(e) {
    return e;
}

},{"1c707a6828a80e23":"4ClhN","539a40bf2622e4ce":"45ZSh"}],"hEFlj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("acb4644d6145e1ea");
const util_1 = require("994e833182cebbac");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.safelink.queryRules';
function toKnownErr(e) {
    return e;
}

},{"acb4644d6145e1ea":"4ClhN","994e833182cebbac":"45ZSh"}],"jeLKn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isServiceConfig = isServiceConfig;
exports.validateServiceConfig = validateServiceConfig;
exports.isViewerConfig = isViewerConfig;
exports.validateViewerConfig = validateViewerConfig;
const lexicons_1 = require("313343cb1c2f2e8b");
const util_1 = require("4d2ca7121890e023");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.server.getConfig';
function toKnownErr(e) {
    return e;
}
const hashServiceConfig = 'serviceConfig';
function isServiceConfig(v) {
    return is$typed(v, id, hashServiceConfig);
}
function validateServiceConfig(v) {
    return validate(v, id, hashServiceConfig);
}
const hashViewerConfig = 'viewerConfig';
function isViewerConfig(v) {
    return is$typed(v, id, hashViewerConfig);
}
function validateViewerConfig(v) {
    return validate(v, id, hashViewerConfig);
}

},{"313343cb1c2f2e8b":"4ClhN","4d2ca7121890e023":"45ZSh"}],"8EZxH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("627d2fb77eb44f62");
const util_1 = require("b319349aacd3fd8b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.set.addValues';
function toKnownErr(e) {
    return e;
}

},{"627d2fb77eb44f62":"4ClhN","b319349aacd3fd8b":"45ZSh"}],"dYeXv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSet = isSet;
exports.validateSet = validateSet;
exports.isSetView = isSetView;
exports.validateSetView = validateSetView;
const lexicons_1 = require("b003724d5445859c");
const util_1 = require("7af5bd434de086ba");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.set.defs';
const hashSet = 'set';
function isSet(v) {
    return is$typed(v, id, hashSet);
}
function validateSet(v) {
    return validate(v, id, hashSet);
}
const hashSetView = 'setView';
function isSetView(v) {
    return is$typed(v, id, hashSetView);
}
function validateSetView(v) {
    return validate(v, id, hashSetView);
}

},{"b003724d5445859c":"4ClhN","7af5bd434de086ba":"45ZSh"}],"yyvON":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("59a3ebc96fa7e9ee");
const util_1 = require("f0f940517d117431");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.set.querySets';
function toKnownErr(e) {
    return e;
}

},{"59a3ebc96fa7e9ee":"4ClhN","f0f940517d117431":"45ZSh"}],"dVBfw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("62722dff5b87b592");
const util_1 = require("e16d1b712189614c");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.set.upsertSet';
function toKnownErr(e) {
    return e;
}

},{"62722dff5b87b592":"4ClhN","e16d1b712189614c":"45ZSh"}],"fmy64":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isOption = isOption;
exports.validateOption = validateOption;
const lexicons_1 = require("4d2692bab92d9924");
const util_1 = require("769837e3a19cd9f4");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.setting.defs';
const hashOption = 'option';
function isOption(v) {
    return is$typed(v, id, hashOption);
}
function validateOption(v) {
    return validate(v, id, hashOption);
}

},{"4d2692bab92d9924":"4ClhN","769837e3a19cd9f4":"45ZSh"}],"a4b0b":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("3af60bfcb6d1f804");
const util_1 = require("6dfedb6d5b169c9e");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.setting.listOptions';
function toKnownErr(e) {
    return e;
}

},{"3af60bfcb6d1f804":"4ClhN","6dfedb6d5b169c9e":"45ZSh"}],"fUQtp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("4a7c3b4df27cf051");
const util_1 = require("5d352ace036164ef");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.setting.removeOptions';
function toKnownErr(e) {
    return e;
}

},{"4a7c3b4df27cf051":"4ClhN","5d352ace036164ef":"45ZSh"}],"kgHNy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("5d190a93b0d8ba15");
const util_1 = require("4c524c38b8d390df");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.setting.upsertOption';
function toKnownErr(e) {
    return e;
}

},{"5d190a93b0d8ba15":"4ClhN","4c524c38b8d390df":"45ZSh"}],"cpRhR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSigDetail = isSigDetail;
exports.validateSigDetail = validateSigDetail;
const lexicons_1 = require("995b18a035f1bcd8");
const util_1 = require("f0711a096271f495");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.signature.defs';
const hashSigDetail = 'sigDetail';
function isSigDetail(v) {
    return is$typed(v, id, hashSigDetail);
}
function validateSigDetail(v) {
    return validate(v, id, hashSigDetail);
}

},{"995b18a035f1bcd8":"4ClhN","f0711a096271f495":"45ZSh"}],"g2JoW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("77d6fecc29b9721d");
const util_1 = require("a81a52a1916b7cf2");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.signature.findCorrelation';
function toKnownErr(e) {
    return e;
}

},{"77d6fecc29b9721d":"4ClhN","a81a52a1916b7cf2":"45ZSh"}],"eJ66l":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isRelatedAccount = isRelatedAccount;
exports.validateRelatedAccount = validateRelatedAccount;
const lexicons_1 = require("cf9c4cee41812d0a");
const util_1 = require("9d12e00a2de91766");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.signature.findRelatedAccounts';
function toKnownErr(e) {
    return e;
}
const hashRelatedAccount = 'relatedAccount';
function isRelatedAccount(v) {
    return is$typed(v, id, hashRelatedAccount);
}
function validateRelatedAccount(v) {
    return validate(v, id, hashRelatedAccount);
}

},{"cf9c4cee41812d0a":"4ClhN","9d12e00a2de91766":"45ZSh"}],"95Ujn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("2c83592aa9d9f8c1");
const util_1 = require("5e005e1092cc8b11");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.signature.searchAccounts';
function toKnownErr(e) {
    return e;
}

},{"2c83592aa9d9f8c1":"4ClhN","5e005e1092cc8b11":"45ZSh"}],"01vbV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ROLEVERIFIER = exports.ROLETRIAGE = exports.ROLEMODERATOR = exports.ROLEADMIN = void 0;
exports.isMember = isMember;
exports.validateMember = validateMember;
const lexicons_1 = require("fc5f792293836457");
const util_1 = require("fb253a4f06d18d65");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.team.defs';
const hashMember = 'member';
function isMember(v) {
    return is$typed(v, id, hashMember);
}
function validateMember(v) {
    return validate(v, id, hashMember);
}
/** Admin role. Highest level of access, can perform all actions. */ exports.ROLEADMIN = `${id}#roleAdmin`;
/** Moderator role. Can perform most actions. */ exports.ROLEMODERATOR = `${id}#roleModerator`;
/** Triage role. Mostly intended for monitoring and escalating issues. */ exports.ROLETRIAGE = `${id}#roleTriage`;
/** Verifier role. Only allowed to issue verifications. */ exports.ROLEVERIFIER = `${id}#roleVerifier`;

},{"fc5f792293836457":"4ClhN","fb253a4f06d18d65":"45ZSh"}],"4o1aR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("a41e61a9d8fe374e");
const util_1 = require("95147536b0fbc70a");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.team.listMembers';
function toKnownErr(e) {
    return e;
}

},{"a41e61a9d8fe374e":"4ClhN","95147536b0fbc70a":"45ZSh"}],"7lVLD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isVerificationView = isVerificationView;
exports.validateVerificationView = validateVerificationView;
const lexicons_1 = require("6e6000b169867ee7");
const util_1 = require("956d34107f13257d");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.verification.defs';
const hashVerificationView = 'verificationView';
function isVerificationView(v) {
    return is$typed(v, id, hashVerificationView);
}
function validateVerificationView(v) {
    return validate(v, id, hashVerificationView);
}

},{"6e6000b169867ee7":"4ClhN","956d34107f13257d":"45ZSh"}],"88DiA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isVerificationInput = isVerificationInput;
exports.validateVerificationInput = validateVerificationInput;
exports.isGrantError = isGrantError;
exports.validateGrantError = validateGrantError;
const lexicons_1 = require("f8f1445d07233aaa");
const util_1 = require("e5910726695ffe7c");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.verification.grantVerifications';
function toKnownErr(e) {
    return e;
}
const hashVerificationInput = 'verificationInput';
function isVerificationInput(v) {
    return is$typed(v, id, hashVerificationInput);
}
function validateVerificationInput(v) {
    return validate(v, id, hashVerificationInput);
}
const hashGrantError = 'grantError';
function isGrantError(v) {
    return is$typed(v, id, hashGrantError);
}
function validateGrantError(v) {
    return validate(v, id, hashGrantError);
}

},{"f8f1445d07233aaa":"4ClhN","e5910726695ffe7c":"45ZSh"}],"4Gr2Z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("5c9788fec252306a");
const util_1 = require("f60ff70066efb588");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.verification.listVerifications';
function toKnownErr(e) {
    return e;
}

},{"5c9788fec252306a":"4ClhN","f60ff70066efb588":"45ZSh"}],"2sZv9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toKnownErr = toKnownErr;
exports.isRevokeError = isRevokeError;
exports.validateRevokeError = validateRevokeError;
const lexicons_1 = require("1f059643a2b2b07c");
const util_1 = require("89d53e28c2e27d1b");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'tools.ozone.verification.revokeVerifications';
function toKnownErr(e) {
    return e;
}
const hashRevokeError = 'revokeError';
function isRevokeError(v) {
    return is$typed(v, id, hashRevokeError);
}
function validateRevokeError(v) {
    return validate(v, id, hashRevokeError);
}

},{"1f059643a2b2b07c":"4ClhN","89d53e28c2e27d1b":"45ZSh"}],"8Pawe":[function(require,module,exports,__globalThis) {
"use strict";
/*
= Rich Text Manipulation

When we sanitize rich text, we have to update the entity indices as the
text is modified. This can be modeled as inserts() and deletes() of the
rich text string. The possible scenarios are outlined below, along with
their expected behaviors.

NOTE: Slices are start inclusive, end exclusive

== richTextInsert()

Target string:

   0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l o   w o r l d   // string value
       ^-------^           // target slice {start: 2, end: 7}

Scenarios:

A: ^                       // insert "test" at 0
B:        ^                // insert "test" at 4
C:                 ^       // insert "test" at 8

A = before           -> move both by num added
B = inner            -> move end by num added
C = after            -> noop

Results:

A: 0 1 2 3 4 5 6 7 8 910   // string indices
   t e s t h e l l o   w   // string value
               ^-------^   // target slice {start: 6, end: 11}

B: 0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l t e s t o   w   // string value
       ^---------------^   // target slice {start: 2, end: 11}

C: 0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l o   w o t e s   // string value
       ^-------^           // target slice {start: 2, end: 7}

== richTextDelete()

Target string:

   0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l o   w o r l d   // string value
       ^-------^           // target slice {start: 2, end: 7}

Scenarios:

A: ^---------------^       // remove slice {start: 0, end: 9}
B:               ^-----^   // remove slice {start: 7, end: 11}
C:         ^-----------^   // remove slice {start: 4, end: 11}
D:       ^-^               // remove slice {start: 3, end: 5}
E:   ^-----^               // remove slice {start: 1, end: 5}
F: ^-^                     // remove slice {start: 0, end: 2}

A = entirely outer   -> delete slice
B = entirely after   -> noop
C = partially after  -> move end to remove-start
D = entirely inner   -> move end by num removed
E = partially before -> move start to remove-start index, move end by num removed
F = entirely before  -> move both by num removed

Results:

A: 0 1 2 3 4 5 6 7 8 910   // string indices
   l d                     // string value
                           // target slice (deleted)

B: 0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l o   w           // string value
       ^-------^           // target slice {start: 2, end: 7}

C: 0 1 2 3 4 5 6 7 8 910   // string indices
   h e l l                 // string value
       ^-^                 // target slice {start: 2, end: 4}

D: 0 1 2 3 4 5 6 7 8 910   // string indices
   h e l   w o r l d       // string value
       ^---^               // target slice {start: 2, end: 5}

E: 0 1 2 3 4 5 6 7 8 910   // string indices
   h   w o r l d           // string value
     ^-^                   // target slice {start: 1, end: 3}

F: 0 1 2 3 4 5 6 7 8 910   // string indices
   l l o   w o r l d       // string value
   ^-------^               // target slice {start: 0, end: 5}
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RichText = exports.RichTextSegment = void 0;
const client_1 = require("d9cfa6d06d6c7936");
const detection_1 = require("abc81589ab9e8078");
const sanitization_1 = require("b7e7669c60cab849");
const unicode_1 = require("df151258c37a1366");
class RichTextSegment {
    constructor(text, facet){
        Object.defineProperty(this, "text", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: text
        });
        Object.defineProperty(this, "facet", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: facet
        });
    }
    get link() {
        return this.facet?.features.find(client_1.AppBskyRichtextFacet.isLink);
    }
    isLink() {
        return !!this.link;
    }
    get mention() {
        return this.facet?.features.find(client_1.AppBskyRichtextFacet.isMention);
    }
    isMention() {
        return !!this.mention;
    }
    get tag() {
        return this.facet?.features.find(client_1.AppBskyRichtextFacet.isTag);
    }
    isTag() {
        return !!this.tag;
    }
}
exports.RichTextSegment = RichTextSegment;
class RichText {
    constructor(props, opts){
        Object.defineProperty(this, "unicodeText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "facets", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.unicodeText = new unicode_1.UnicodeString(props.text);
        this.facets = props.facets;
        if (!this.facets?.length && props.entities?.length) this.facets = entitiesToFacets(this.unicodeText, props.entities);
        if (this.facets) this.facets = this.facets.filter(facetFilter).sort(facetSort);
        if (opts?.cleanNewlines) (0, sanitization_1.sanitizeRichText)(this, {
            cleanNewlines: true
        }).copyInto(this);
    }
    get text() {
        return this.unicodeText.toString();
    }
    get length() {
        return this.unicodeText.length;
    }
    get graphemeLength() {
        return this.unicodeText.graphemeLength;
    }
    clone() {
        return new RichText({
            text: this.unicodeText.utf16,
            facets: cloneDeep(this.facets)
        });
    }
    copyInto(target) {
        target.unicodeText = this.unicodeText;
        target.facets = cloneDeep(this.facets);
    }
    *segments() {
        const facets = this.facets || [];
        if (!facets.length) {
            yield new RichTextSegment(this.unicodeText.utf16);
            return;
        }
        let textCursor = 0;
        let facetCursor = 0;
        do {
            const currFacet = facets[facetCursor];
            if (textCursor < currFacet.index.byteStart) yield new RichTextSegment(this.unicodeText.slice(textCursor, currFacet.index.byteStart));
            else if (textCursor > currFacet.index.byteStart) {
                facetCursor++;
                continue;
            }
            if (currFacet.index.byteStart < currFacet.index.byteEnd) {
                const subtext = this.unicodeText.slice(currFacet.index.byteStart, currFacet.index.byteEnd);
                if (!subtext.trim()) // dont empty string entities
                yield new RichTextSegment(subtext);
                else yield new RichTextSegment(subtext, currFacet);
            }
            textCursor = currFacet.index.byteEnd;
            facetCursor++;
        }while (facetCursor < facets.length);
        if (textCursor < this.unicodeText.length) yield new RichTextSegment(this.unicodeText.slice(textCursor, this.unicodeText.length));
    }
    insert(insertIndex, insertText) {
        this.unicodeText = new unicode_1.UnicodeString(this.unicodeText.slice(0, insertIndex) + insertText + this.unicodeText.slice(insertIndex));
        if (!this.facets?.length) return this;
        const numCharsAdded = insertText.length;
        for (const ent of this.facets){
            // see comment at top of file for labels of each scenario
            // scenario A (before)
            if (insertIndex <= ent.index.byteStart) {
                // move both by num added
                ent.index.byteStart += numCharsAdded;
                ent.index.byteEnd += numCharsAdded;
            } else if (insertIndex >= ent.index.byteStart && insertIndex < ent.index.byteEnd) // move end by num added
            ent.index.byteEnd += numCharsAdded;
        // scenario C (after)
        // noop
        }
        return this;
    }
    delete(removeStartIndex, removeEndIndex) {
        this.unicodeText = new unicode_1.UnicodeString(this.unicodeText.slice(0, removeStartIndex) + this.unicodeText.slice(removeEndIndex));
        if (!this.facets?.length) return this;
        const numCharsRemoved = removeEndIndex - removeStartIndex;
        for (const ent of this.facets){
            // see comment at top of file for labels of each scenario
            // scenario A (entirely outer)
            if (removeStartIndex <= ent.index.byteStart && removeEndIndex >= ent.index.byteEnd) {
                // delete slice (will get removed in final pass)
                ent.index.byteStart = 0;
                ent.index.byteEnd = 0;
            } else if (removeStartIndex > ent.index.byteEnd) ;
            else if (removeStartIndex > ent.index.byteStart && removeStartIndex <= ent.index.byteEnd && removeEndIndex > ent.index.byteEnd) // move end to remove start
            ent.index.byteEnd = removeStartIndex;
            else if (removeStartIndex >= ent.index.byteStart && removeEndIndex <= ent.index.byteEnd) // move end by num removed
            ent.index.byteEnd -= numCharsRemoved;
            else if (removeStartIndex < ent.index.byteStart && removeEndIndex >= ent.index.byteStart && removeEndIndex <= ent.index.byteEnd) {
                // move start to remove-start index, move end by num removed
                ent.index.byteStart = removeStartIndex;
                ent.index.byteEnd -= numCharsRemoved;
            } else if (removeEndIndex < ent.index.byteStart) {
                // move both by num removed
                ent.index.byteStart -= numCharsRemoved;
                ent.index.byteEnd -= numCharsRemoved;
            }
        }
        // filter out any facets that were made irrelevant
        this.facets = this.facets.filter((ent)=>ent.index.byteStart < ent.index.byteEnd);
        return this;
    }
    /**
     * Detects facets such as links and mentions
     * Note: Overwrites the existing facets with auto-detected facets
     */ async detectFacets(agent) {
        this.facets = (0, detection_1.detectFacets)(this.unicodeText);
        if (this.facets) {
            const promises = [];
            for (const facet of this.facets){
                for (const feature of facet.features)if (client_1.AppBskyRichtextFacet.isMention(feature)) promises.push(agent.com.atproto.identity.resolveHandle({
                    handle: feature.did
                }).then((res)=>res?.data.did).catch((_)=>undefined).then((did)=>{
                    feature.did = did || '';
                }));
            }
            await Promise.allSettled(promises);
            this.facets.sort(facetSort);
        }
    }
    /**
     * Detects facets such as links and mentions but does not resolve them
     * Will produce invalid facets! For instance, mentions will not have their DIDs set.
     * Note: Overwrites the existing facets with auto-detected facets
     */ detectFacetsWithoutResolution() {
        this.facets = (0, detection_1.detectFacets)(this.unicodeText);
        if (this.facets) this.facets.sort(facetSort);
    }
}
exports.RichText = RichText;
const facetSort = (a, b)=>a.index.byteStart - b.index.byteStart;
const facetFilter = (facet)=>// discard negative-length facets. zero-length facets are valid
    facet.index.byteStart <= facet.index.byteEnd;
function entitiesToFacets(text, entities) {
    const facets = [];
    for (const ent of entities){
        if (ent.type === 'link') facets.push({
            $type: 'app.bsky.richtext.facet',
            index: {
                byteStart: text.utf16IndexToUtf8Index(ent.index.start),
                byteEnd: text.utf16IndexToUtf8Index(ent.index.end)
            },
            features: [
                {
                    $type: 'app.bsky.richtext.facet#link',
                    uri: ent.value
                }
            ]
        });
        else if (ent.type === 'mention') facets.push({
            $type: 'app.bsky.richtext.facet',
            index: {
                byteStart: text.utf16IndexToUtf8Index(ent.index.start),
                byteEnd: text.utf16IndexToUtf8Index(ent.index.end)
            },
            features: [
                {
                    $type: 'app.bsky.richtext.facet#mention',
                    did: ent.value
                }
            ]
        });
    }
    return facets;
}
function cloneDeep(v) {
    if (typeof v === 'undefined') return v;
    return JSON.parse(JSON.stringify(v));
}

},{"d9cfa6d06d6c7936":"a8Anh","abc81589ab9e8078":"gHCZl","b7e7669c60cab849":"6BAaP","df151258c37a1366":"i9wVR"}],"gHCZl":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.detectFacets = detectFacets;
const tlds_1 = __importDefault(require("60f343303dfd9c1c"));
const util_1 = require("d9f438887f2924cf");
function detectFacets(text) {
    let match;
    const facets = [];
    {
        // mentions
        const re = util_1.MENTION_REGEX;
        while(match = re.exec(text.utf16)){
            if (!isValidDomain(match[3]) && !match[3].endsWith('.test')) continue; // probably not a handle
            const start = text.utf16.indexOf(match[3], match.index) - 1;
            facets.push({
                $type: 'app.bsky.richtext.facet',
                index: {
                    byteStart: text.utf16IndexToUtf8Index(start),
                    byteEnd: text.utf16IndexToUtf8Index(start + match[3].length + 1)
                },
                features: [
                    {
                        $type: 'app.bsky.richtext.facet#mention',
                        did: match[3]
                    }
                ]
            });
        }
    }
    {
        // links
        const re = util_1.URL_REGEX;
        while(match = re.exec(text.utf16)){
            let uri = match[2];
            if (!uri.startsWith('http')) {
                const domain = match.groups?.domain;
                if (!domain || !isValidDomain(domain)) continue;
                uri = `https://${uri}`;
            }
            const start = text.utf16.indexOf(match[2], match.index);
            const index = {
                start,
                end: start + match[2].length
            };
            // strip ending puncuation
            if (/[.,;:!?]$/.test(uri)) {
                uri = uri.slice(0, -1);
                index.end--;
            }
            if (/[)]$/.test(uri) && !uri.includes('(')) {
                uri = uri.slice(0, -1);
                index.end--;
            }
            facets.push({
                index: {
                    byteStart: text.utf16IndexToUtf8Index(index.start),
                    byteEnd: text.utf16IndexToUtf8Index(index.end)
                },
                features: [
                    {
                        $type: 'app.bsky.richtext.facet#link',
                        uri
                    }
                ]
            });
        }
    }
    {
        const re = util_1.TAG_REGEX;
        while(match = re.exec(text.utf16)){
            const leading = match[1];
            let tag = match[2];
            if (!tag) continue;
            // strip ending punctuation and any spaces
            tag = tag.trim().replace(util_1.TRAILING_PUNCTUATION_REGEX, '');
            if (tag.length === 0 || tag.length > 64) continue;
            const index = match.index + leading.length;
            facets.push({
                index: {
                    byteStart: text.utf16IndexToUtf8Index(index),
                    byteEnd: text.utf16IndexToUtf8Index(index + 1 + tag.length)
                },
                features: [
                    {
                        $type: 'app.bsky.richtext.facet#tag',
                        tag: tag
                    }
                ]
            });
        }
    }
    return facets.length > 0 ? facets : undefined;
}
function isValidDomain(str) {
    return !!tlds_1.default.find((tld)=>{
        const i = str.lastIndexOf(tld);
        if (i === -1) return false;
        return str.charAt(i - 1) === '.' && i === str.length - tld.length;
    });
}

},{"60f343303dfd9c1c":"1u0Ls","d9f438887f2924cf":"8ZpS2"}],"1u0Ls":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('["aaa","aarp","abb","abbott","abbvie","abc","able","abogado","abudhabi","ac","academy","accenture","accountant","accountants","aco","actor","ad","ads","adult","ae","aeg","aero","aetna","af","afl","africa","ag","agakhan","agency","ai","aig","airbus","airforce","airtel","akdn","al","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","am","amazon","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","ao","aol","apartments","app","apple","aq","aquarelle","ar","arab","aramco","archi","army","arpa","art","arte","as","asda","asia","associates","at","athleta","attorney","au","auction","audi","audible","audio","auspost","author","auto","autos","aw","aws","ax","axa","az","azure","ba","baby","baidu","banamex","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bb","bbc","bbt","bbva","bcg","bcn","bd","be","beats","beauty","beer","berlin","best","bestbuy","bet","bf","bg","bh","bharti","bi","bible","bid","bike","bing","bingo","bio","biz","bj","black","blackfriday","blockbuster","blog","bloomberg","blue","bm","bms","bmw","bn","bnpparibas","bo","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","br","bradesco","bridgestone","broadway","broker","brother","brussels","bs","bt","build","builders","business","buy","buzz","bv","bw","by","bz","bzh","ca","cab","cafe","cal","call","calvinklein","cam","camera","camp","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","casa","case","cash","casino","cat","catering","catholic","cba","cbn","cbre","cc","cd","center","ceo","cern","cf","cfa","cfd","cg","ch","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","church","ci","cipriani","circle","cisco","citadel","citi","citic","city","ck","cl","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","cm","cn","co","coach","codes","coffee","college","cologne","com","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cool","coop","corsica","country","coupon","coupons","courses","cpa","cr","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","cu","cuisinella","cv","cw","cx","cy","cymru","cyou","cz","dad","dance","data","date","dating","datsun","day","dclk","dds","de","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dj","dk","dm","dnp","do","docs","doctor","dog","domains","dot","download","drive","dtv","dubai","dupont","durban","dvag","dvr","dz","earth","eat","ec","eco","edeka","edu","education","ee","eg","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","er","ericsson","erni","es","esq","estate","et","eu","eurovision","eus","events","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fi","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","fj","fk","flickr","flights","flir","florist","flowers","fly","fm","fo","foo","food","football","ford","forex","forsale","forum","foundation","fox","fr","free","fresenius","frl","frogans","frontier","ftr","fujitsu","fun","fund","furniture","futbol","fyi","ga","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gb","gbiz","gd","gdn","ge","gea","gent","genting","george","gf","gg","ggee","gh","gi","gift","gifts","gives","giving","gl","glass","gle","global","globo","gm","gmail","gmbh","gmo","gmx","gn","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","gov","gp","gq","gr","grainger","graphics","gratis","green","gripe","grocery","group","gs","gt","gu","gucci","guge","guide","guitars","guru","gw","gy","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hiphop","hisamitsu","hitachi","hiv","hk","hkt","hm","hn","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hotels","hotmail","house","how","hr","hsbc","ht","hu","hughes","hyatt","hyundai","ibm","icbc","ice","icu","id","ie","ieee","ifm","ikano","il","im","imamat","imdb","immo","immobilien","in","inc","industries","infiniti","info","ing","ink","institute","insurance","insure","int","international","intuit","investments","io","ipiranga","iq","ir","irish","is","ismaili","ist","istanbul","it","itau","itv","jaguar","java","jcb","je","jeep","jetzt","jewelry","jio","jll","jm","jmp","jnj","jo","jobs","joburg","jot","joy","jp","jpmorgan","jprs","juegos","juniper","kaufen","kddi","ke","kerryhotels","kerryproperties","kfh","kg","kh","ki","kia","kids","kim","kindle","kitchen","kiwi","km","kn","koeln","komatsu","kosher","kp","kpmg","kpn","kr","krd","kred","kuokgroup","kw","ky","kyoto","kz","la","lacaixa","lamborghini","lamer","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lb","lc","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","li","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","link","live","living","lk","llc","llp","loan","loans","locker","locus","lol","london","lotte","lotto","love","lpl","lplfinancial","lr","ls","lt","ltd","ltda","lu","lundbeck","luxe","luxury","lv","ly","ma","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","mattel","mba","mc","mckinsey","md","me","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","mg","mh","miami","microsoft","mil","mini","mint","mit","mitsubishi","mk","ml","mlb","mls","mm","mma","mn","mo","mobi","mobile","moda","moe","moi","mom","monash","money","monster","mormon","mortgage","moscow","moto","motorcycles","mov","movie","mp","mq","mr","ms","msd","mt","mtn","mtr","mu","museum","music","mv","mw","mx","my","mz","na","nab","nagoya","name","navy","nba","nc","ne","nec","net","netbank","netflix","network","neustar","new","news","next","nextdirect","nexus","nf","nfl","ng","ngo","nhk","ni","nico","nike","nikon","ninja","nissan","nissay","nl","no","nokia","norton","now","nowruz","nowtv","np","nr","nra","nrw","ntt","nu","nyc","nz","obi","observer","office","okinawa","olayan","olayangroup","ollo","om","omega","one","ong","onl","online","ooo","open","oracle","orange","org","organic","origins","osaka","otsuka","ott","ovh","pa","page","panasonic","paris","pars","partners","parts","party","pay","pccw","pe","pet","pf","pfizer","pg","ph","pharmacy","phd","philips","phone","photo","photography","photos","physio","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","pk","pl","place","play","playstation","plumbing","plus","pm","pn","pnc","pohl","poker","politie","porn","post","pr","praxi","press","prime","pro","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","ps","pt","pub","pw","pwc","py","qa","qpon","quebec","quest","racing","radio","re","read","realestate","realtor","realty","recipes","red","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","ril","rio","rip","ro","rocks","rodeo","rogers","room","rs","rsvp","ru","rugby","ruhr","run","rw","rwe","ryukyu","sa","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sb","sbi","sbs","sc","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scot","sd","se","search","seat","secure","security","seek","select","sener","services","seven","sew","sex","sexy","sfr","sg","sh","shangrila","sharp","shell","shia","shiksha","shoes","shop","shopping","shouji","show","si","silk","sina","singles","site","sj","sk","ski","skin","sky","skype","sl","sling","sm","smart","smile","sn","sncf","so","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","spa","space","sport","spot","sr","srl","ss","st","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","su","sucks","supplies","supply","support","surf","surgery","suzuki","sv","swatch","swiss","sx","sy","sydney","systems","sz","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tc","tci","td","tdk","team","tech","technology","tel","temasek","tennis","teva","tf","tg","th","thd","theater","theatre","tiaa","tickets","tienda","tips","tires","tirol","tj","tjmaxx","tjx","tk","tkmaxx","tl","tm","tmall","tn","to","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","tr","trade","trading","training","travel","travelers","travelersinsurance","trust","trv","tt","tube","tui","tunes","tushu","tv","tvs","tw","tz","ua","ubank","ubs","ug","uk","unicom","university","uno","uol","ups","us","uy","uz","va","vacations","vana","vanguard","vc","ve","vegas","ventures","verisign","verm\xf6gensberater","verm\xf6gensberatung","versicherung","vet","vg","vi","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","viva","vivo","vlaanderen","vn","vodka","volvo","vote","voting","voto","voyage","vu","wales","walmart","walter","wang","wanggou","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","wf","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","ws","wtc","wtf","xbox","xerox","xihuan","xin","xxx","xyz","yachts","yahoo","yamaxun","yandex","ye","yodobashi","yoga","yokohama","you","youtube","yt","yun","za","zappos","zara","zero","zip","zm","zone","zuerich","zw","\u03B5\u03BB","\u03B5\u03C5","\u0431\u0433","\u0431\u0435\u043B","\u0434\u0435\u0442\u0438","\u0435\u044E","\u043A\u0430\u0442\u043E\u043B\u0438\u043A","\u043A\u043E\u043C","\u043C\u043A\u0434","\u043C\u043E\u043D","\u043C\u043E\u0441\u043A\u0432\u0430","\u043E\u043D\u043B\u0430\u0439\u043D","\u043E\u0440\u0433","\u0440\u0443\u0441","\u0440\u0444","\u0441\u0430\u0439\u0442","\u0441\u0440\u0431","\u0443\u043A\u0440","\u049B\u0430\u0437","\u0570\u0561\u0575","\u05D9\u05E9\u05E8\u05D0\u05DC","\u05E7\u05D5\u05DD","\u0627\u0628\u0648\u0638\u0628\u064A","\u0627\u0631\u0627\u0645\u0643\u0648","\u0627\u0644\u0627\u0631\u062F\u0646","\u0627\u0644\u0628\u062D\u0631\u064A\u0646","\u0627\u0644\u062C\u0632\u0627\u0626\u0631","\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629","\u0627\u0644\u0639\u0644\u064A\u0627\u0646","\u0627\u0644\u0645\u063A\u0631\u0628","\u0627\u0645\u0627\u0631\u0627\u062A","\u0627\u06CC\u0631\u0627\u0646","\u0628\u0627\u0631\u062A","\u0628\u0627\u0632\u0627\u0631","\u0628\u064A\u062A\u0643","\u0628\u06BE\u0627\u0631\u062A","\u062A\u0648\u0646\u0633","\u0633\u0648\u062F\u0627\u0646","\u0633\u0648\u0631\u064A\u0629","\u0634\u0628\u0643\u0629","\u0639\u0631\u0627\u0642","\u0639\u0631\u0628","\u0639\u0645\u0627\u0646","\u0641\u0644\u0633\u0637\u064A\u0646","\u0642\u0637\u0631","\u0643\u0627\u062B\u0648\u0644\u064A\u0643","\u0643\u0648\u0645","\u0645\u0635\u0631","\u0645\u0644\u064A\u0633\u064A\u0627","\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627","\u0645\u0648\u0642\u0639","\u0647\u0645\u0631\u0627\u0647","\u067E\u0627\u06A9\u0633\u062A\u0627\u0646","\u0680\u0627\u0631\u062A","\u0915\u0949\u092E","\u0928\u0947\u091F","\u092D\u093E\u0930\u0924","\u092D\u093E\u0930\u0924\u092E\u094D","\u092D\u093E\u0930\u094B\u0924","\u0938\u0902\u0917\u0920\u0928","\u09AC\u09BE\u0982\u09B2\u09BE","\u09AD\u09BE\u09B0\u09A4","\u09AD\u09BE\u09F0\u09A4","\u0A2D\u0A3E\u0A30\u0A24","\u0AAD\u0ABE\u0AB0\u0AA4","\u0B2D\u0B3E\u0B30\u0B24","\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE","\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8","\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD","\u0C2D\u0C3E\u0C30\u0C24\u0C4D","\u0CAD\u0CBE\u0CB0\u0CA4","\u0D2D\u0D3E\u0D30\u0D24\u0D02","\u0DBD\u0D82\u0D9A\u0DCF","\u0E04\u0E2D\u0E21","\u0E44\u0E17\u0E22","\u0EA5\u0EB2\u0EA7","\u10D2\u10D4","\u307F\u3093\u306A","\u30A2\u30DE\u30BE\u30F3","\u30AF\u30E9\u30A6\u30C9","\u30B0\u30FC\u30B0\u30EB","\u30B3\u30E0","\u30B9\u30C8\u30A2","\u30BB\u30FC\u30EB","\u30D5\u30A1\u30C3\u30B7\u30E7\u30F3","\u30DD\u30A4\u30F3\u30C8","\u4E16\u754C","\u4E2D\u4FE1","\u4E2D\u56FD","\u4E2D\u570B","\u4E2D\u6587\u7F51","\u4E9A\u9A6C\u900A","\u4F01\u4E1A","\u4F5B\u5C71","\u4FE1\u606F","\u5065\u5EB7","\u516B\u5366","\u516C\u53F8","\u516C\u76CA","\u53F0\u6E7E","\u53F0\u7063","\u5546\u57CE","\u5546\u5E97","\u5546\u6807","\u5609\u91CC","\u5609\u91CC\u5927\u9152\u5E97","\u5728\u7EBF","\u5927\u62FF","\u5929\u4E3B\u6559","\u5A31\u4E50","\u5BB6\u96FB","\u5E7F\u4E1C","\u5FAE\u535A","\u6148\u5584","\u6211\u7231\u4F60","\u624B\u673A","\u62DB\u8058","\u653F\u52A1","\u653F\u5E9C","\u65B0\u52A0\u5761","\u65B0\u95FB","\u65F6\u5C1A","\u66F8\u7C4D","\u673A\u6784","\u6DE1\u9A6C\u9521","\u6E38\u620F","\u6FB3\u9580","\u70B9\u770B","\u79FB\u52A8","\u7EC4\u7EC7\u673A\u6784","\u7F51\u5740","\u7F51\u5E97","\u7F51\u7AD9","\u7F51\u7EDC","\u8054\u901A","\u8C37\u6B4C","\u8D2D\u7269","\u901A\u8CA9","\u96C6\u56E2","\u96FB\u8A0A\u76C8\u79D1","\u98DE\u5229\u6D66","\u98DF\u54C1","\u9910\u5385","\u9999\u683C\u91CC\u62C9","\u9999\u6E2F","\uB2F7\uB137","\uB2F7\uCEF4","\uC0BC\uC131","\uD55C\uAD6D"]');

},{}],"8ZpS2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TAG_REGEX = exports.TRAILING_PUNCTUATION_REGEX = exports.URL_REGEX = exports.MENTION_REGEX = void 0;
exports.MENTION_REGEX = /(^|\s|\()(@)([a-zA-Z0-9.-]+)(\b)/g;
exports.URL_REGEX = /(^|\s|\()((https?:\/\/[\S]+)|((?<domain>[a-z][a-z0-9]*(\.[a-z0-9]+)+)[\S]*))/gim;
exports.TRAILING_PUNCTUATION_REGEX = /\p{P}+$/gu;
/**
 * `\ufe0f` emoji modifier
 * `\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2` zero-width spaces (likely incomplete)
 */ exports.TAG_REGEX = // eslint-disable-next-line no-misleading-character-class
/(^|\s)[#＃]((?!\ufe0f)[^\s\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2]*[^\d\s\p{P}\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2]+[^\s\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2]*)?/gu;

},{}],"6BAaP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sanitizeRichText = sanitizeRichText;
const unicode_1 = require("f91dc11a2f17403a");
// this regex is intentionally matching on the zero-with-separator codepoint
// eslint-disable-next-line no-misleading-character-class
const EXCESS_SPACE_RE = /[\r\n]([\u00AD\u2060\u200D\u200C\u200B\s]*[\r\n]){2,}/;
const REPLACEMENT_STR = '\n\n';
function sanitizeRichText(richText, opts) {
    if (opts.cleanNewlines) richText = clean(richText, EXCESS_SPACE_RE, REPLACEMENT_STR);
    return richText;
}
function clean(richText, targetRegexp, replacementString) {
    richText = richText.clone();
    let match = richText.unicodeText.utf16.match(targetRegexp);
    while(match && typeof match.index !== 'undefined'){
        const oldText = richText.unicodeText;
        const removeStartIndex = richText.unicodeText.utf16IndexToUtf8Index(match.index);
        const removeEndIndex = removeStartIndex + new unicode_1.UnicodeString(match[0]).length;
        richText.delete(removeStartIndex, removeEndIndex);
        if (richText.unicodeText.utf16 === oldText.utf16) break; // sanity check
        richText.insert(removeStartIndex, replacementString);
        match = richText.unicodeText.utf16.match(targetRegexp);
    }
    return richText;
}

},{"f91dc11a2f17403a":"i9wVR"}],"i9wVR":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * Javascript uses utf16-encoded strings while most environments and specs
 * have standardized around utf8 (including JSON).
 *
 * After some lengthy debated we decided that richtext facets need to use
 * utf8 indices. This means we need tools to convert indices between utf8
 * and utf16, and that's precisely what this library handles.
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnicodeString = void 0;
const common_web_1 = require("6359384d0393d4dd");
const encoder = new TextEncoder();
const decoder = new TextDecoder();
class UnicodeString {
    constructor(utf16){
        Object.defineProperty(this, "utf16", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "utf8", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_graphemeLen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.utf16 = utf16;
        this.utf8 = encoder.encode(utf16);
    }
    get length() {
        return this.utf8.byteLength;
    }
    get graphemeLength() {
        if (!this._graphemeLen) this._graphemeLen = (0, common_web_1.graphemeLen)(this.utf16);
        return this._graphemeLen;
    }
    slice(start, end) {
        return decoder.decode(this.utf8.slice(start, end));
    }
    utf16IndexToUtf8Index(i) {
        return encoder.encode(this.utf16.slice(0, i)).byteLength;
    }
    toString() {
        return this.utf16;
    }
}
exports.UnicodeString = UnicodeString;

},{"6359384d0393d4dd":"jDe1t"}],"4z6F1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.interpretLabelValueDefinitions = exports.interpretLabelValueDefinition = exports.matchMuteWords = exports.hasMutedWord = exports.ModerationDecision = exports.ModerationUI = void 0;
exports.moderateProfile = moderateProfile;
exports.moderatePost = moderatePost;
exports.moderateNotification = moderateNotification;
exports.moderateFeedGenerator = moderateFeedGenerator;
exports.moderateUserList = moderateUserList;
const decision_1 = require("74d83b938525eb27");
const account_1 = require("9baddf2ee61afff");
const feed_generator_1 = require("11a6358d9ef3cbe9");
const notification_1 = require("a349ee04ab9c4104");
const post_1 = require("b9a439404898ed4e");
const profile_1 = require("176caa6e36130559");
const user_list_1 = require("d081e3a26dd32c5d");
var ui_1 = require("2c97ff742fdbf1b2");
Object.defineProperty(exports, "ModerationUI", {
    enumerable: true,
    get: function() {
        return ui_1.ModerationUI;
    }
});
var decision_2 = require("74d83b938525eb27");
Object.defineProperty(exports, "ModerationDecision", {
    enumerable: true,
    get: function() {
        return decision_2.ModerationDecision;
    }
});
var mutewords_1 = require("f8a26a073e107803");
Object.defineProperty(exports, "hasMutedWord", {
    enumerable: true,
    get: function() {
        return mutewords_1.hasMutedWord;
    }
});
Object.defineProperty(exports, "matchMuteWords", {
    enumerable: true,
    get: function() {
        return mutewords_1.matchMuteWords;
    }
});
var util_1 = require("94da33b2d94f32fd");
Object.defineProperty(exports, "interpretLabelValueDefinition", {
    enumerable: true,
    get: function() {
        return util_1.interpretLabelValueDefinition;
    }
});
Object.defineProperty(exports, "interpretLabelValueDefinitions", {
    enumerable: true,
    get: function() {
        return util_1.interpretLabelValueDefinitions;
    }
});
function moderateProfile(subject, opts) {
    return decision_1.ModerationDecision.merge((0, account_1.decideAccount)(subject, opts), (0, profile_1.decideProfile)(subject, opts));
}
function moderatePost(subject, opts) {
    return (0, post_1.decidePost)(subject, opts);
}
function moderateNotification(subject, opts) {
    return (0, notification_1.decideNotification)(subject, opts);
}
function moderateFeedGenerator(subject, opts) {
    return (0, feed_generator_1.decideFeedGenerator)(subject, opts);
}
function moderateUserList(subject, opts) {
    return (0, user_list_1.decideUserList)(subject, opts);
}

},{"74d83b938525eb27":"gRguA","9baddf2ee61afff":"lc66W","11a6358d9ef3cbe9":"an36n","a349ee04ab9c4104":"1ywiK","b9a439404898ed4e":"5erpI","176caa6e36130559":"2Bdqz","d081e3a26dd32c5d":"fLPhD","2c97ff742fdbf1b2":"3czjJ","f8a26a073e107803":"kyzAP","94da33b2d94f32fd":"6hYAt"}],"gRguA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModerationDecision = void 0;
const labels_1 = require("8d74f2891f4dcc9c");
const types_1 = require("28835550e5d159a5");
const ui_1 = require("fadf3465d7156b07");
var ModerationBehaviorSeverity;
(function(ModerationBehaviorSeverity) {
    ModerationBehaviorSeverity[ModerationBehaviorSeverity["High"] = 0] = "High";
    ModerationBehaviorSeverity[ModerationBehaviorSeverity["Medium"] = 1] = "Medium";
    ModerationBehaviorSeverity[ModerationBehaviorSeverity["Low"] = 2] = "Low";
})(ModerationBehaviorSeverity || (ModerationBehaviorSeverity = {}));
class ModerationDecision {
    constructor(){
        Object.defineProperty(this, "did", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "isMe", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "causes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    static merge(...decisions) {
        const decisionsFiltered = decisions.filter((v)=>v != null);
        const decision = new ModerationDecision();
        if (decisionsFiltered[0]) {
            decision.did = decisionsFiltered[0].did;
            decision.isMe = decisionsFiltered[0].isMe;
        }
        decision.causes = decisionsFiltered.flatMap((d)=>d.causes);
        return decision;
    }
    downgrade() {
        for (const cause of this.causes)cause.downgraded = true;
        return this;
    }
    get blocked() {
        return !!this.blockCause;
    }
    get muted() {
        return !!this.muteCause;
    }
    get blockCause() {
        return this.causes.find((cause)=>cause.type === 'blocking' || cause.type === 'blocked-by' || cause.type === 'block-other');
    }
    get muteCause() {
        return this.causes.find((cause)=>cause.type === 'muted');
    }
    get labelCauses() {
        return this.causes.filter((cause)=>cause.type === 'label');
    }
    ui(context) {
        const ui = new ui_1.ModerationUI();
        for (const cause of this.causes){
            if (cause.type === 'blocking' || cause.type === 'blocked-by' || cause.type === 'block-other') {
                if (this.isMe) continue;
                if (context === 'profileList' || context === 'contentList') ui.filters.push(cause);
                if (!cause.downgraded) {
                    if (types_1.BLOCK_BEHAVIOR[context] === 'blur') {
                        ui.noOverride = true;
                        ui.blurs.push(cause);
                    } else if (types_1.BLOCK_BEHAVIOR[context] === 'alert') ui.alerts.push(cause);
                    else if (types_1.BLOCK_BEHAVIOR[context] === 'inform') ui.informs.push(cause);
                }
            } else if (cause.type === 'muted') {
                if (this.isMe) continue;
                if (context === 'profileList' || context === 'contentList') ui.filters.push(cause);
                if (!cause.downgraded) {
                    if (types_1.MUTE_BEHAVIOR[context] === 'blur') ui.blurs.push(cause);
                    else if (types_1.MUTE_BEHAVIOR[context] === 'alert') ui.alerts.push(cause);
                    else if (types_1.MUTE_BEHAVIOR[context] === 'inform') ui.informs.push(cause);
                }
            } else if (cause.type === 'mute-word') {
                if (this.isMe) continue;
                if (context === 'contentList') ui.filters.push(cause);
                if (!cause.downgraded) {
                    if (types_1.MUTEWORD_BEHAVIOR[context] === 'blur') ui.blurs.push(cause);
                    else if (types_1.MUTEWORD_BEHAVIOR[context] === 'alert') ui.alerts.push(cause);
                    else if (types_1.MUTEWORD_BEHAVIOR[context] === 'inform') ui.informs.push(cause);
                }
            } else if (cause.type === 'hidden') {
                if (context === 'profileList' || context === 'contentList') ui.filters.push(cause);
                if (!cause.downgraded) {
                    if (types_1.HIDE_BEHAVIOR[context] === 'blur') ui.blurs.push(cause);
                    else if (types_1.HIDE_BEHAVIOR[context] === 'alert') ui.alerts.push(cause);
                    else if (types_1.HIDE_BEHAVIOR[context] === 'inform') ui.informs.push(cause);
                }
            } else if (cause.type === 'label') {
                if (context === 'profileList' && cause.target === 'account') {
                    if (cause.setting === 'hide' && !this.isMe) ui.filters.push(cause);
                } else if (context === 'contentList' && (cause.target === 'account' || cause.target === 'content')) {
                    if (cause.setting === 'hide' && !this.isMe) ui.filters.push(cause);
                }
                if (!cause.downgraded) {
                    if (cause.behavior[context] === 'blur') {
                        ui.blurs.push(cause);
                        if (cause.noOverride && !this.isMe) ui.noOverride = true;
                    } else if (cause.behavior[context] === 'alert') ui.alerts.push(cause);
                    else if (cause.behavior[context] === 'inform') ui.informs.push(cause);
                }
            }
        }
        ui.filters.sort(sortByPriority);
        ui.blurs.sort(sortByPriority);
        return ui;
    }
    setDid(did) {
        this.did = did;
    }
    setIsMe(isMe) {
        this.isMe = isMe;
    }
    addHidden(hidden) {
        if (hidden) this.causes.push({
            type: 'hidden',
            source: {
                type: 'user'
            },
            priority: 6
        });
    }
    addMutedWord(matches) {
        if (matches?.length) this.causes.push({
            type: 'mute-word',
            source: {
                type: 'user'
            },
            priority: 6,
            matches
        });
    }
    addBlocking(blocking) {
        if (blocking) this.causes.push({
            type: 'blocking',
            source: {
                type: 'user'
            },
            priority: 3
        });
    }
    addBlockingByList(blockingByList) {
        if (blockingByList) this.causes.push({
            type: 'blocking',
            source: {
                type: 'list',
                list: blockingByList
            },
            priority: 3
        });
    }
    addBlockedBy(blockedBy) {
        if (blockedBy) this.causes.push({
            type: 'blocked-by',
            source: {
                type: 'user'
            },
            priority: 4
        });
    }
    addBlockOther(blockOther) {
        if (blockOther) this.causes.push({
            type: 'block-other',
            source: {
                type: 'user'
            },
            priority: 4
        });
    }
    addLabel(target, label, opts) {
        // look up the label definition
        const labelDef = types_1.CUSTOM_LABEL_VALUE_RE.test(label.val) ? opts.labelDefs?.[label.src]?.find((def)=>def.identifier === label.val) || labels_1.LABELS[label.val] : labels_1.LABELS[label.val];
        if (!labelDef) // ignore labels we don't understand
        return;
        // look up the label preference
        const isSelf = label.src === this.did;
        const labeler = isSelf ? undefined : opts.prefs.labelers.find((s)=>s.did === label.src);
        if (!isSelf && !labeler) return; // skip labelers not configured by the user
        if (isSelf && labelDef.flags.includes('no-self')) return; // skip self-labels that aren't supported
        // establish the label preference for interpretation
        let labelPref = labelDef.defaultSetting || 'ignore';
        if (!labelDef.configurable) labelPref = labelDef.defaultSetting || 'hide';
        else if (labelDef.flags.includes('adult') && !opts.prefs.adultContentEnabled) labelPref = 'hide';
        else if (labeler?.labels[labelDef.identifier]) labelPref = labeler?.labels[labelDef.identifier];
        else if (opts.prefs.labels[labelDef.identifier]) labelPref = opts.prefs.labels[labelDef.identifier];
        // ignore labels the user has asked to ignore
        if (labelPref === 'ignore') return;
        // ignore 'unauthed' labels when the user is authed
        if (labelDef.flags.includes('unauthed') && !!opts.userDid) return;
        // establish the priority of the label
        let priority;
        const severity = measureModerationBehaviorSeverity(labelDef.behaviors[target]);
        if (labelDef.flags.includes('no-override') || labelDef.flags.includes('adult') && !opts.prefs.adultContentEnabled) priority = 1;
        else if (labelPref === 'hide') priority = 2;
        else if (severity === ModerationBehaviorSeverity.High) // blurring profile view or content view
        priority = 5;
        else if (severity === ModerationBehaviorSeverity.Medium) // blurring content list or content media
        priority = 7;
        else // blurring avatar, adding alerts
        priority = 8;
        let noOverride = false;
        if (labelDef.flags.includes('no-override')) noOverride = true;
        else if (labelDef.flags.includes('adult') && !opts.prefs.adultContentEnabled) noOverride = true;
        this.causes.push({
            type: 'label',
            source: isSelf || !labeler ? {
                type: 'user'
            } : {
                type: 'labeler',
                did: labeler.did
            },
            label,
            labelDef,
            target,
            setting: labelPref,
            behavior: labelDef.behaviors[target] || types_1.NOOP_BEHAVIOR,
            noOverride,
            priority
        });
    }
    addMuted(muted) {
        if (muted) this.causes.push({
            type: 'muted',
            source: {
                type: 'user'
            },
            priority: 6
        });
    }
    addMutedByList(mutedByList) {
        if (mutedByList) this.causes.push({
            type: 'muted',
            source: {
                type: 'list',
                list: mutedByList
            },
            priority: 6
        });
    }
}
exports.ModerationDecision = ModerationDecision;
function measureModerationBehaviorSeverity(beh) {
    if (!beh) return ModerationBehaviorSeverity.Low;
    if (beh.profileView === 'blur' || beh.contentView === 'blur') return ModerationBehaviorSeverity.High;
    if (beh.contentList === 'blur' || beh.contentMedia === 'blur') return ModerationBehaviorSeverity.Medium;
    return ModerationBehaviorSeverity.Low;
}
function sortByPriority(a, b) {
    return a.priority - b.priority;
}

},{"8d74f2891f4dcc9c":"8B59F","28835550e5d159a5":"9DYVM","fadf3465d7156b07":"3czjJ"}],"8B59F":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LABELS = exports.DEFAULT_LABEL_SETTINGS = void 0;
exports.DEFAULT_LABEL_SETTINGS = {
    porn: 'hide',
    sexual: 'warn',
    nudity: 'ignore',
    'graphic-media': 'warn'
};
exports.LABELS = {
    '!hide': {
        identifier: '!hide',
        configurable: false,
        defaultSetting: 'hide',
        flags: [
            'no-override',
            'no-self'
        ],
        severity: 'alert',
        blurs: 'content',
        behaviors: {
            account: {
                profileList: 'blur',
                profileView: 'blur',
                avatar: 'blur',
                banner: 'blur',
                displayName: 'blur',
                contentList: 'blur',
                contentView: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur',
                displayName: 'blur'
            },
            content: {
                contentList: 'blur',
                contentView: 'blur'
            }
        },
        locales: []
    },
    '!warn': {
        identifier: '!warn',
        configurable: false,
        defaultSetting: 'warn',
        flags: [
            'no-self'
        ],
        severity: 'none',
        blurs: 'content',
        behaviors: {
            account: {
                profileList: 'blur',
                profileView: 'blur',
                avatar: 'blur',
                banner: 'blur',
                contentList: 'blur',
                contentView: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur',
                displayName: 'blur'
            },
            content: {
                contentList: 'blur',
                contentView: 'blur'
            }
        },
        locales: []
    },
    '!no-unauthenticated': {
        identifier: '!no-unauthenticated',
        configurable: false,
        defaultSetting: 'hide',
        flags: [
            'no-override',
            'unauthed'
        ],
        severity: 'none',
        blurs: 'content',
        behaviors: {
            account: {
                profileList: 'blur',
                profileView: 'blur',
                avatar: 'blur',
                banner: 'blur',
                displayName: 'blur',
                contentList: 'blur',
                contentView: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur',
                displayName: 'blur'
            },
            content: {
                contentList: 'blur',
                contentView: 'blur'
            }
        },
        locales: []
    },
    porn: {
        identifier: 'porn',
        configurable: true,
        defaultSetting: 'hide',
        flags: [
            'adult'
        ],
        severity: 'none',
        blurs: 'media',
        behaviors: {
            account: {
                avatar: 'blur',
                banner: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur'
            },
            content: {
                contentMedia: 'blur'
            }
        },
        locales: []
    },
    sexual: {
        identifier: 'sexual',
        configurable: true,
        defaultSetting: 'warn',
        flags: [
            'adult'
        ],
        severity: 'none',
        blurs: 'media',
        behaviors: {
            account: {
                avatar: 'blur',
                banner: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur'
            },
            content: {
                contentMedia: 'blur'
            }
        },
        locales: []
    },
    nudity: {
        identifier: 'nudity',
        configurable: true,
        defaultSetting: 'ignore',
        flags: [],
        severity: 'none',
        blurs: 'media',
        behaviors: {
            account: {
                avatar: 'blur',
                banner: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur'
            },
            content: {
                contentMedia: 'blur'
            }
        },
        locales: []
    },
    'graphic-media': {
        identifier: 'graphic-media',
        flags: [
            'adult'
        ],
        configurable: true,
        defaultSetting: 'warn',
        severity: 'none',
        blurs: 'media',
        behaviors: {
            account: {
                avatar: 'blur',
                banner: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur'
            },
            content: {
                contentMedia: 'blur'
            }
        },
        locales: []
    },
    /** @deprecated alias for `graphic-media` */ gore: {
        identifier: 'gore',
        flags: [
            'adult'
        ],
        configurable: true,
        defaultSetting: 'warn',
        severity: 'none',
        blurs: 'media',
        behaviors: {
            account: {
                avatar: 'blur',
                banner: 'blur'
            },
            profile: {
                avatar: 'blur',
                banner: 'blur'
            },
            content: {
                contentMedia: 'blur'
            }
        },
        locales: []
    }
};

},{}],"9DYVM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NOOP_BEHAVIOR = exports.HIDE_BEHAVIOR = exports.MUTEWORD_BEHAVIOR = exports.MUTE_BEHAVIOR = exports.BLOCK_BEHAVIOR = exports.CUSTOM_LABEL_VALUE_RE = void 0;
// syntax
// =
exports.CUSTOM_LABEL_VALUE_RE = /^[a-z-]+$/;
exports.BLOCK_BEHAVIOR = {
    profileList: 'blur',
    profileView: 'alert',
    avatar: 'blur',
    banner: 'blur',
    contentList: 'blur',
    contentView: 'blur'
};
exports.MUTE_BEHAVIOR = {
    profileList: 'inform',
    profileView: 'alert',
    contentList: 'blur',
    contentView: 'inform'
};
exports.MUTEWORD_BEHAVIOR = {
    contentList: 'blur',
    contentView: 'blur'
};
exports.HIDE_BEHAVIOR = {
    contentList: 'blur',
    contentView: 'blur'
};
exports.NOOP_BEHAVIOR = {};

},{}],"3czjJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModerationUI = void 0;
class ModerationUI {
    constructor(){
        Object.defineProperty(this, "noOverride", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "filters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "blurs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "alerts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "informs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    get filter() {
        return this.filters.length !== 0;
    }
    get blur() {
        return this.blurs.length !== 0;
    }
    get alert() {
        return this.alerts.length !== 0;
    }
    get inform() {
        return this.informs.length !== 0;
    }
}
exports.ModerationUI = ModerationUI;

},{}],"lc66W":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.decideAccount = decideAccount;
exports.filterAccountLabels = filterAccountLabels;
const decision_1 = require("7a96ada4b098774f");
function decideAccount(subject, opts) {
    const acc = new decision_1.ModerationDecision();
    acc.setDid(subject.did);
    acc.setIsMe(subject.did === opts.userDid);
    if (subject.viewer?.muted) {
        if (subject.viewer?.mutedByList) acc.addMutedByList(subject.viewer?.mutedByList);
        else acc.addMuted(subject.viewer?.muted);
    }
    if (subject.viewer?.blocking) {
        if (subject.viewer?.blockingByList) acc.addBlockingByList(subject.viewer?.blockingByList);
        else acc.addBlocking(subject.viewer?.blocking);
    }
    acc.addBlockedBy(subject.viewer?.blockedBy);
    for (const label of filterAccountLabels(subject.labels))acc.addLabel('account', label, opts);
    return acc;
}
function filterAccountLabels(labels) {
    if (!labels) return [];
    return labels.filter((label)=>!label.uri.endsWith('/app.bsky.actor.profile/self') || label.val === '!no-unauthenticated');
}

},{"7a96ada4b098774f":"gRguA"}],"an36n":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.decideFeedGenerator = decideFeedGenerator;
const decision_1 = require("229f03793bede797");
const account_1 = require("e4112526b9530470");
const profile_1 = require("61dab9ae681f7ed1");
function decideFeedGenerator(subject, opts) {
    const acc = new decision_1.ModerationDecision();
    acc.setDid(subject.creator.did);
    acc.setIsMe(subject.creator.did === opts.userDid);
    if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
    return decision_1.ModerationDecision.merge(acc, (0, account_1.decideAccount)(subject.creator, opts), (0, profile_1.decideProfile)(subject.creator, opts));
}

},{"229f03793bede797":"gRguA","e4112526b9530470":"lc66W","61dab9ae681f7ed1":"2Bdqz"}],"2Bdqz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.decideProfile = decideProfile;
exports.filterProfileLabels = filterProfileLabels;
const decision_1 = require("cea311a642c1d8cf");
function decideProfile(subject, opts) {
    const acc = new decision_1.ModerationDecision();
    acc.setDid(subject.did);
    acc.setIsMe(subject.did === opts.userDid);
    for (const label of filterProfileLabels(subject.labels))acc.addLabel('profile', label, opts);
    return acc;
}
function filterProfileLabels(labels) {
    if (!labels) return [];
    return labels.filter((label)=>label.uri.endsWith('/app.bsky.actor.profile/self'));
}

},{"cea311a642c1d8cf":"gRguA"}],"1ywiK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.decideNotification = decideNotification;
const decision_1 = require("e49358e387a4cedd");
const account_1 = require("6ce295a2005da63e");
const profile_1 = require("8ed2c171761c993e");
function decideNotification(subject, opts) {
    const acc = new decision_1.ModerationDecision();
    acc.setDid(subject.author.did);
    acc.setIsMe(subject.author.did === opts.userDid);
    if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
    return decision_1.ModerationDecision.merge(acc, (0, account_1.decideAccount)(subject.author, opts), (0, profile_1.decideProfile)(subject.author, opts));
}

},{"e49358e387a4cedd":"gRguA","6ce295a2005da63e":"lc66W","8ed2c171761c993e":"2Bdqz"}],"5erpI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.decidePost = decidePost;
const client_1 = require("677601642d2e8284");
const decision_1 = require("389d81fc76a12fff");
const mutewords_1 = require("d40fed58313a331f");
const account_1 = require("e6752ba7aabbf692");
const profile_1 = require("f17ac8ab5e453917");
function decidePost(subject, opts) {
    return decision_1.ModerationDecision.merge(decideSubject(subject, opts), decideEmbed(subject.embed, opts)?.downgrade(), (0, account_1.decideAccount)(subject.author, opts), (0, profile_1.decideProfile)(subject.author, opts));
}
function decideSubject(subject, opts) {
    const acc = new decision_1.ModerationDecision();
    acc.setDid(subject.author.did);
    acc.setIsMe(subject.author.did === opts.userDid);
    if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
    acc.addHidden(checkHiddenPost(subject, opts.prefs.hiddenPosts));
    if (!acc.isMe) acc.addMutedWord(matchAllMuteWords(subject, opts.prefs.mutedWords));
    return acc;
}
function decideEmbed(embed, opts) {
    if (embed) {
        if ((client_1.AppBskyEmbedRecord.isView(embed) || client_1.AppBskyEmbedRecordWithMedia.isView(embed)) && client_1.AppBskyEmbedRecord.isViewRecord(embed.record)) // quote post
        return decideQuotedPost(embed.record, opts);
        else if (client_1.AppBskyEmbedRecordWithMedia.isView(embed) && client_1.AppBskyEmbedRecord.isViewRecord(embed.record.record)) // quoted post with media
        return decideQuotedPost(embed.record.record, opts);
        else if ((client_1.AppBskyEmbedRecord.isView(embed) || client_1.AppBskyEmbedRecordWithMedia.isView(embed)) && client_1.AppBskyEmbedRecord.isViewBlocked(embed.record)) // blocked quote post
        return decideBlockedQuotedPost(embed.record, opts);
        else if (client_1.AppBskyEmbedRecordWithMedia.isView(embed) && client_1.AppBskyEmbedRecord.isViewBlocked(embed.record.record)) // blocked quoted post with media
        return decideBlockedQuotedPost(embed.record.record, opts);
    }
    return undefined;
}
function decideQuotedPost(subject, opts) {
    const acc = new decision_1.ModerationDecision();
    acc.setDid(subject.author.did);
    acc.setIsMe(subject.author.did === opts.userDid);
    if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
    return decision_1.ModerationDecision.merge(acc, (0, account_1.decideAccount)(subject.author, opts), (0, profile_1.decideProfile)(subject.author, opts));
}
function decideBlockedQuotedPost(subject, opts) {
    const acc = new decision_1.ModerationDecision();
    acc.setDid(subject.author.did);
    acc.setIsMe(subject.author.did === opts.userDid);
    if (subject.author.viewer?.muted) {
        if (subject.author.viewer?.mutedByList) acc.addMutedByList(subject.author.viewer?.mutedByList);
        else acc.addMuted(subject.author.viewer?.muted);
    }
    if (subject.author.viewer?.blocking) {
        if (subject.author.viewer?.blockingByList) acc.addBlockingByList(subject.author.viewer?.blockingByList);
        else acc.addBlocking(subject.author.viewer?.blocking);
    }
    acc.addBlockedBy(subject.author.viewer?.blockedBy);
    return acc;
}
function checkHiddenPost(subject, hiddenPosts) {
    if (!hiddenPosts?.length) return false;
    if (hiddenPosts.includes(subject.uri)) return true;
    if (subject.embed) {
        if (client_1.AppBskyEmbedRecord.isView(subject.embed) && client_1.AppBskyEmbedRecord.isViewRecord(subject.embed.record) && hiddenPosts.includes(subject.embed.record.uri)) return true;
        if (client_1.AppBskyEmbedRecordWithMedia.isView(subject.embed) && client_1.AppBskyEmbedRecord.isViewRecord(subject.embed.record.record) && hiddenPosts.includes(subject.embed.record.record.uri)) return true;
    }
    return false;
}
function matchAllMuteWords(subject, mutedWords) {
    if (!mutedWords?.length) return;
    const postAuthor = subject.author;
    if (client_1.AppBskyFeedPost.isRecord(subject.record)) {
        const post = subject.record;
        const matches = (0, mutewords_1.matchMuteWords)({
            mutedWords,
            text: post.text,
            facets: post.facets,
            outlineTags: post.tags,
            languages: post.langs,
            actor: postAuthor
        });
        // post text
        if (matches) return matches;
        if (post.embed && client_1.AppBskyEmbedImages.isMain(post.embed)) // post images
        for (const image of post.embed.images){
            const matches = (0, mutewords_1.matchMuteWords)({
                mutedWords,
                text: image.alt,
                languages: post.langs,
                actor: postAuthor
            });
            if (matches) return matches;
        }
    }
    const { embed } = subject;
    if (embed) {
        // quote post
        if ((client_1.AppBskyEmbedRecord.isView(embed) || client_1.AppBskyEmbedRecordWithMedia.isView(embed)) && client_1.AppBskyEmbedRecord.isViewRecord(embed.record)) {
            if (client_1.AppBskyFeedPost.isRecord(embed.record.value)) {
                const embeddedPost = embed.record.value;
                const embedAuthor = embed.record.author;
                const matches = (0, mutewords_1.matchMuteWords)({
                    mutedWords,
                    text: embeddedPost.text,
                    facets: embeddedPost.facets,
                    outlineTags: embeddedPost.tags,
                    languages: embeddedPost.langs,
                    actor: embedAuthor
                });
                // quoted post text
                if (matches) return matches;
                // quoted post's images
                if (client_1.AppBskyEmbedImages.isMain(embeddedPost.embed)) for (const image of embeddedPost.embed.images){
                    const matches = (0, mutewords_1.matchMuteWords)({
                        mutedWords,
                        text: image.alt,
                        languages: embeddedPost.langs,
                        actor: embedAuthor
                    });
                    if (matches) return matches;
                }
                // quoted post's link card
                if (client_1.AppBskyEmbedExternal.isMain(embeddedPost.embed)) {
                    const { external } = embeddedPost.embed;
                    const matches = (0, mutewords_1.matchMuteWords)({
                        mutedWords,
                        text: external.title + ' ' + external.description,
                        languages: [],
                        actor: embedAuthor
                    });
                    if (matches) return matches;
                }
                if (client_1.AppBskyEmbedRecordWithMedia.isMain(embeddedPost.embed)) {
                    // quoted post's link card when it did a quote + media
                    if (client_1.AppBskyEmbedExternal.isMain(embeddedPost.embed.media)) {
                        const { external } = embeddedPost.embed.media;
                        const matches = (0, mutewords_1.matchMuteWords)({
                            mutedWords,
                            text: external.title + ' ' + external.description,
                            languages: [],
                            actor: embedAuthor
                        });
                        if (matches) return matches;
                    }
                    // quoted post's images when it did a quote + media
                    if (client_1.AppBskyEmbedImages.isMain(embeddedPost.embed.media)) for (const image of embeddedPost.embed.media.images){
                        const matches = (0, mutewords_1.matchMuteWords)({
                            mutedWords,
                            text: image.alt,
                            languages: client_1.AppBskyFeedPost.isRecord(embeddedPost.record) ? embeddedPost.langs : [],
                            actor: embedAuthor
                        });
                        if (matches) return matches;
                    }
                }
            }
        } else if (client_1.AppBskyEmbedExternal.isView(embed)) {
            const { external } = embed;
            const matches = (0, mutewords_1.matchMuteWords)({
                mutedWords,
                text: external.title + ' ' + external.description,
                languages: [],
                actor: postAuthor
            });
            if (matches) return matches;
        } else if (client_1.AppBskyEmbedRecordWithMedia.isView(embed) && client_1.AppBskyEmbedRecord.isViewRecord(embed.record.record)) {
            const embedAuthor = embed.record.record.author;
            // quoted post text
            if (client_1.AppBskyFeedPost.isRecord(embed.record.record.value)) {
                const post = embed.record.record.value;
                const matches = (0, mutewords_1.matchMuteWords)({
                    mutedWords,
                    text: post.text,
                    facets: post.facets,
                    outlineTags: post.tags,
                    languages: post.langs,
                    actor: embedAuthor
                });
                if (matches) return matches;
            }
            // quoted post images
            if (client_1.AppBskyEmbedImages.isView(embed.media)) for (const image of embed.media.images){
                const matches = (0, mutewords_1.matchMuteWords)({
                    mutedWords,
                    text: image.alt,
                    languages: client_1.AppBskyFeedPost.isRecord(subject.record) ? subject.record.langs : [],
                    actor: embedAuthor
                });
                if (matches) return matches;
            }
            if (client_1.AppBskyEmbedExternal.isView(embed.media)) {
                const { external } = embed.media;
                const matches = (0, mutewords_1.matchMuteWords)({
                    mutedWords,
                    text: external.title + ' ' + external.description,
                    languages: [],
                    actor: embedAuthor
                });
                if (matches) return matches;
            }
        }
    }
}

},{"677601642d2e8284":"a8Anh","389d81fc76a12fff":"gRguA","d40fed58313a331f":"kyzAP","e6752ba7aabbf692":"lc66W","f17ac8ab5e453917":"2Bdqz"}],"kyzAP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.matchMuteWords = matchMuteWords;
exports.hasMutedWord = hasMutedWord;
const client_1 = require("7bff08206b74def9");
const REGEX = {
    LEADING_TRAILING_PUNCTUATION: /(?:^\p{P}+|\p{P}+$)/gu,
    ESCAPE: /[[\]{}()*+?.\\^$|\s]/g,
    SEPARATORS: /[/\-–—()[\]_]+/g,
    WORD_BOUNDARY: /[\s\n\t\r\f\v]+?/g
};
/**
 * List of 2-letter lang codes for languages that either don't use spaces, or
 * don't use spaces in a way conducive to word-based filtering.
 *
 * For these, we use a simple `String.includes` to check for a match.
 */ const LANGUAGE_EXCEPTIONS = [
    'ja',
    'zh',
    'ko',
    'th',
    'vi'
];
/**
 * Checks if the given text matches any of the muted words, returning an array
 * of matches. If no matches are found, returns `undefined`.
 */ function matchMuteWords({ mutedWords, text, facets, outlineTags, languages, actor }) {
    const exception = LANGUAGE_EXCEPTIONS.includes(languages?.[0] || '');
    const tags = [].concat(outlineTags || []).concat((facets || []).flatMap((facet)=>facet.features.filter(client_1.AppBskyRichtextFacet.isTag).map((tag)=>tag.tag))).map((t)=>t.toLowerCase());
    const matches = [];
    outer: for (const muteWord of mutedWords){
        const mutedWord = muteWord.value.toLowerCase();
        const postText = text.toLowerCase();
        // expired, ignore
        if (muteWord.expiresAt && muteWord.expiresAt < new Date().toISOString()) continue;
        if (muteWord.actorTarget === 'exclude-following' && Boolean(actor?.viewer?.following)) continue;
        // `content` applies to tags as well
        if (tags.includes(mutedWord)) {
            matches.push({
                word: muteWord,
                predicate: muteWord.value
            });
            continue;
        }
        // rest of the checks are for `content` only
        if (!muteWord.targets.includes('content')) continue;
        // single character or other exception, has to use includes
        if ((mutedWord.length === 1 || exception) && postText.includes(mutedWord)) {
            matches.push({
                word: muteWord,
                predicate: muteWord.value
            });
            continue;
        }
        // too long
        if (mutedWord.length > postText.length) continue;
        // exact match
        if (mutedWord === postText) {
            matches.push({
                word: muteWord,
                predicate: muteWord.value
            });
            continue;
        }
        // any muted phrase with space or punctuation
        if (/(?:\s|\p{P})+?/u.test(mutedWord) && postText.includes(mutedWord)) {
            matches.push({
                word: muteWord,
                predicate: muteWord.value
            });
            continue;
        }
        // check individual character groups
        const words = postText.split(REGEX.WORD_BOUNDARY);
        for (const word of words){
            if (word === mutedWord) {
                matches.push({
                    word: muteWord,
                    predicate: word
                });
                continue outer;
            }
            // compare word without leading/trailing punctuation, but allow internal
            // punctuation (such as `s@ssy`)
            const wordTrimmedPunctuation = word.replace(REGEX.LEADING_TRAILING_PUNCTUATION, '');
            if (mutedWord === wordTrimmedPunctuation) {
                matches.push({
                    word: muteWord,
                    predicate: word
                });
                continue outer;
            }
            if (mutedWord.length > wordTrimmedPunctuation.length) continue;
            if (/\p{P}+/u.test(wordTrimmedPunctuation)) {
                /**
                 * Exit case for any punctuation within the predicate that we _do_
                 * allow e.g. `and/or` should not match `Andor`.
                 */ if (/[/]+/.test(wordTrimmedPunctuation)) continue outer;
                const spacedWord = wordTrimmedPunctuation.replace(/\p{P}+/gu, ' ');
                if (spacedWord === mutedWord) {
                    matches.push({
                        word: muteWord,
                        predicate: word
                    });
                    continue outer;
                }
                const contiguousWord = spacedWord.replace(/\s/gu, '');
                if (contiguousWord === mutedWord) {
                    matches.push({
                        word: muteWord,
                        predicate: word
                    });
                    continue outer;
                }
                const wordParts = wordTrimmedPunctuation.split(/\p{P}+/u);
                for (const wordPart of wordParts)if (wordPart === mutedWord) {
                    matches.push({
                        word: muteWord,
                        predicate: word
                    });
                    continue outer;
                }
            }
        }
    }
    return matches.length ? matches : undefined;
}
/**
 * Checks if the given text matches any of the muted words, returning a boolean
 * if any matches are found.
 */ function hasMutedWord(params) {
    return !!matchMuteWords(params);
}

},{"7bff08206b74def9":"a8Anh"}],"fLPhD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.decideUserList = decideUserList;
const syntax_1 = require("45857818f41e31ae");
const decision_1 = require("97bc5dcedc22b94a");
const account_1 = require("50aaa300c57937dd");
const profile_1 = require("2fb680eb50f65e02");
function decideUserList(subject, opts) {
    const acc = new decision_1.ModerationDecision();
    const creator = // Note: ListViewBasic should not contain a creator field, but let's support it anyway
    'creator' in subject && isProfile(subject.creator) ? subject.creator : undefined;
    if (creator) {
        acc.setDid(creator.did);
        acc.setIsMe(creator.did === opts.userDid);
        if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
        return decision_1.ModerationDecision.merge(acc, (0, account_1.decideAccount)(creator, opts), (0, profile_1.decideProfile)(creator, opts));
    }
    const creatorDid = new syntax_1.AtUri(subject.uri).hostname;
    acc.setDid(creatorDid);
    acc.setIsMe(creatorDid === opts.userDid);
    if (subject.labels?.length) for (const label of subject.labels)acc.addLabel('content', label, opts);
    return acc;
}
function isProfile(v) {
    return v && typeof v === 'object' && 'did' in v;
}

},{"45857818f41e31ae":"dBffO","97bc5dcedc22b94a":"gRguA","50aaa300c57937dd":"lc66W","2fb680eb50f65e02":"2Bdqz"}],"6hYAt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isQuotedPost = isQuotedPost;
exports.isQuotedPostWithMedia = isQuotedPostWithMedia;
exports.interpretLabelValueDefinition = interpretLabelValueDefinition;
exports.interpretLabelValueDefinitions = interpretLabelValueDefinitions;
const client_1 = require("cee6cc546fc98f95");
const util_1 = require("3ff53bda106b0db");
function isQuotedPost(embed) {
    return Boolean(embed && client_1.AppBskyEmbedRecord.isView(embed));
}
function isQuotedPostWithMedia(embed) {
    return Boolean(embed && client_1.AppBskyEmbedRecordWithMedia.isView(embed));
}
function interpretLabelValueDefinition(def, definedBy) {
    const behaviors = {
        account: {},
        profile: {},
        content: {}
    };
    const alertOrInform = def.severity === 'alert' ? 'alert' : def.severity === 'inform' ? 'inform' : undefined;
    if (def.blurs === 'content') {
        // target=account, blurs=content
        behaviors.account.profileList = alertOrInform;
        behaviors.account.profileView = alertOrInform;
        behaviors.account.contentList = 'blur';
        behaviors.account.contentView = def.adultOnly ? 'blur' : alertOrInform;
        // target=profile, blurs=content
        behaviors.profile.profileList = alertOrInform;
        behaviors.profile.profileView = alertOrInform;
        // target=content, blurs=content
        behaviors.content.contentList = 'blur';
        behaviors.content.contentView = def.adultOnly ? 'blur' : alertOrInform;
    } else if (def.blurs === 'media') {
        // target=account, blurs=media
        behaviors.account.profileList = alertOrInform;
        behaviors.account.profileView = alertOrInform;
        behaviors.account.avatar = 'blur';
        behaviors.account.banner = 'blur';
        // target=profile, blurs=media
        behaviors.profile.profileList = alertOrInform;
        behaviors.profile.profileView = alertOrInform;
        behaviors.profile.avatar = 'blur';
        behaviors.profile.banner = 'blur';
        // target=content, blurs=media
        behaviors.content.contentMedia = 'blur';
    } else if (def.blurs === 'none') {
        // target=account, blurs=none
        behaviors.account.profileList = alertOrInform;
        behaviors.account.profileView = alertOrInform;
        behaviors.account.contentList = alertOrInform;
        behaviors.account.contentView = alertOrInform;
        // target=profile, blurs=none
        behaviors.profile.profileList = alertOrInform;
        behaviors.profile.profileView = alertOrInform;
        // target=content, blurs=none
        behaviors.content.contentList = alertOrInform;
        behaviors.content.contentView = alertOrInform;
    }
    let defaultSetting = 'warn';
    if (def.defaultSetting === 'hide' || def.defaultSetting === 'ignore') defaultSetting = def.defaultSetting;
    const flags = [
        'no-self'
    ];
    if (def.adultOnly) flags.push('adult');
    return {
        ...def,
        definedBy,
        configurable: true,
        defaultSetting,
        flags,
        behaviors
    };
}
function interpretLabelValueDefinitions(labelerView) {
    return (labelerView.policies?.labelValueDefinitions || []).filter((0, util_1.asPredicate)(client_1.ComAtprotoLabelDefs.validateLabelValueDefinition)).map((labelValDef)=>interpretLabelValueDefinition(labelValDef, labelerView.creator.did));
}

},{"cee6cc546fc98f95":"a8Anh","3ff53bda106b0db":"45ZSh"}],"1Zxkt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mock = void 0;
const FAKE_CID = 'bafyreiclp443lavogvhj3d2ob2cxbfuscni2k5jk7bebjzg7khl3esabwq';
exports.mock = {
    post ({ text, facets, reply, embed }) {
        return {
            $type: 'app.bsky.feed.post',
            text,
            facets,
            reply,
            embed,
            langs: [
                'en'
            ],
            createdAt: new Date().toISOString()
        };
    },
    postView ({ record, author, embed, replyCount, repostCount, likeCount, viewer, labels }) {
        return {
            $type: 'app.bsky.feed.defs#postView',
            uri: `at://${author.did}/app.bsky.feed.post/fake`,
            cid: FAKE_CID,
            author,
            record,
            embed,
            replyCount,
            repostCount,
            likeCount,
            indexedAt: new Date().toISOString(),
            viewer,
            labels
        };
    },
    embedRecordView ({ record, author, labels }) {
        return {
            $type: 'app.bsky.embed.record#view',
            record: {
                $type: 'app.bsky.embed.record#viewRecord',
                uri: `at://${author.did}/app.bsky.feed.post/fake`,
                cid: FAKE_CID,
                author,
                value: record,
                labels,
                indexedAt: new Date().toISOString()
            }
        };
    },
    profileViewBasic ({ handle, displayName, description, viewer, labels }) {
        return {
            did: `did:web:${handle}`,
            handle,
            displayName,
            // @ts-expect-error technically not in ProfileViewBasic but useful in some cases
            description,
            viewer,
            labels
        };
    },
    actorViewerState ({ muted, mutedByList, blockedBy, blocking, blockingByList, following, followedBy }) {
        return {
            muted,
            mutedByList,
            blockedBy,
            blocking,
            blockingByList,
            following,
            followedBy
        };
    },
    listViewBasic ({ name }) {
        return {
            uri: 'at://did:plc:fake/app.bsky.graph.list/fake',
            cid: FAKE_CID,
            name,
            purpose: 'app.bsky.graph.defs#modlist',
            indexedAt: new Date().toISOString()
        };
    },
    replyNotification ({ author, record, labels }) {
        return {
            uri: `at://${author.did}/app.bsky.feed.post/fake`,
            cid: FAKE_CID,
            author,
            reason: 'reply',
            reasonSubject: `at://${author.did}/app.bsky.feed.post/fake-parent`,
            record,
            isRead: false,
            indexedAt: new Date().toISOString(),
            labels
        };
    },
    followNotification ({ author, subjectDid, labels }) {
        return {
            uri: `at://${author.did}/app.bsky.graph.follow/fake`,
            cid: FAKE_CID,
            author,
            reason: 'follow',
            record: {
                $type: 'app.bsky.graph.follow',
                createdAt: new Date().toISOString(),
                subject: subjectDid
            },
            isRead: false,
            indexedAt: new Date().toISOString(),
            labels
        };
    },
    label ({ val, uri, src }) {
        return {
            src: src || 'did:plc:fake-labeler',
            uri,
            val,
            cts: new Date().toISOString()
        };
    }
};

},{}],"fw3SJ":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
        }
        __setModuleDefault(result, mod);
        return result;
    };
}();
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var _Agent_prefsLock;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Agent = void 0;
const await_lock_1 = __importDefault(require("5a9a60055ae04083"));
const common_web_1 = require("c3b81fbb82a22b26");
const syntax_1 = require("351b7c11438a71a");
const xrpc_1 = require("84981030a50b26fc");
const index_1 = require("23ca0c94172c3f13");
const lexicons_1 = require("47c4b656fac50690");
const const_1 = require("ed982957d446232e");
const moderation_1 = require("acb829161e9b06f8");
const labels_1 = require("8d7ce7599341a44b");
const predicate = __importStar(require("9dc2040f1b893077"));
const types_1 = require("a80f5ed9330f5d99");
const util_1 = require("2f51a971794a11da");
const FEED_VIEW_PREF_DEFAULTS = {
    hideReplies: false,
    hideRepliesByUnfollowed: true,
    hideRepliesByLikeCount: 0,
    hideReposts: false,
    hideQuotePosts: false
};
const THREAD_VIEW_PREF_DEFAULTS = {
    sort: 'hotness',
    prioritizeFollowedUsers: true
};
/**
 * An {@link Agent} is an {@link AtpBaseClient} with the following
 * additional features:
 * - AT Protocol labelers configuration utilities
 * - AT Protocol proxy configuration utilities
 * - Cloning utilities
 * - `app.bsky` syntactic sugar
 * - `com.atproto` syntactic sugar
 */ class Agent extends xrpc_1.XrpcClient {
    /**
     * Configures the Agent (or its sub classes) globally.
     */ static configure(opts) {
        if (opts.appLabelers) this.appLabelers = opts.appLabelers.map(types_1.asDid); // Validate & copy
    }
    /** @deprecated use `this` instead */ get xrpc() {
        return this;
    }
    constructor(options){
        const sessionManager = typeof options === 'object' && 'fetchHandler' in options ? options : {
            did: undefined,
            fetchHandler: (0, xrpc_1.buildFetchHandler)(options)
        };
        super((url, init)=>{
            const headers = new Headers(init?.headers);
            if (this.proxy && !headers.has('atproto-proxy')) headers.set('atproto-proxy', this.proxy);
            // Merge the labelers header of this particular request with the app &
            // instance labelers.
            headers.set('atproto-accept-labelers', [
                ...this.appLabelers.map((l)=>`${l};redact`),
                ...this.labelers,
                headers.get('atproto-accept-labelers')?.trim()
            ].filter(Boolean).join(', '));
            return this.sessionManager.fetchHandler(url, {
                ...init,
                headers
            });
        }, lexicons_1.schemas);
        //#endregion
        Object.defineProperty(this, "com", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new index_1.ComNS(this)
        });
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new index_1.AppNS(this)
        });
        Object.defineProperty(this, "chat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new index_1.ChatNS(this)
        });
        Object.defineProperty(this, "tools", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new index_1.ToolsNS(this)
        });
        Object.defineProperty(this, "sessionManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "labelers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        //#endregion
        //#region ATPROTO proxy configuration utilities
        Object.defineProperty(this, "proxy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        //#region "com.atproto" lexicon short hand methods
        /**
         * Upload a binary blob to the server
         */ Object.defineProperty(this, "uploadBlob", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data, opts)=>this.com.atproto.repo.uploadBlob(data, opts)
        });
        /**
         * Resolve a handle to a DID
         */ Object.defineProperty(this, "resolveHandle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.com.atproto.identity.resolveHandle(params, opts)
        });
        /**
         * Change the user's handle
         */ Object.defineProperty(this, "updateHandle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data, opts)=>this.com.atproto.identity.updateHandle(data, opts)
        });
        /**
         * Create a moderation report
         */ Object.defineProperty(this, "createModerationReport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data, opts)=>this.com.atproto.moderation.createReport(data, opts)
        });
        //#endregion
        //#region "app.bsky" lexicon short hand methods
        Object.defineProperty(this, "getTimeline", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getTimeline(params, opts)
        });
        Object.defineProperty(this, "getAuthorFeed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getAuthorFeed(params, opts)
        });
        Object.defineProperty(this, "getActorLikes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getActorLikes(params, opts)
        });
        Object.defineProperty(this, "getPostThread", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getPostThread(params, opts)
        });
        Object.defineProperty(this, "getPost", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params)=>this.app.bsky.feed.post.get(params)
        });
        Object.defineProperty(this, "getPosts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getPosts(params, opts)
        });
        Object.defineProperty(this, "getLikes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getLikes(params, opts)
        });
        Object.defineProperty(this, "getRepostedBy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.feed.getRepostedBy(params, opts)
        });
        Object.defineProperty(this, "getFollows", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.graph.getFollows(params, opts)
        });
        Object.defineProperty(this, "getFollowers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.graph.getFollowers(params, opts)
        });
        Object.defineProperty(this, "getProfile", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.actor.getProfile(params, opts)
        });
        Object.defineProperty(this, "getProfiles", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.actor.getProfiles(params, opts)
        });
        Object.defineProperty(this, "getSuggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.actor.getSuggestions(params, opts)
        });
        Object.defineProperty(this, "searchActors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.actor.searchActors(params, opts)
        });
        Object.defineProperty(this, "searchActorsTypeahead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.actor.searchActorsTypeahead(params, opts)
        });
        Object.defineProperty(this, "listNotifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.notification.listNotifications(params, opts)
        });
        Object.defineProperty(this, "countUnreadNotifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.notification.getUnreadCount(params, opts)
        });
        Object.defineProperty(this, "getLabelers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (params, opts)=>this.app.bsky.labeler.getServices(params, opts)
        });
        //- Private methods
        _Agent_prefsLock.set(this, new await_lock_1.default());
        this.sessionManager = sessionManager;
    }
    //#region Cloning utilities
    clone() {
        return this.copyInto(new Agent(this.sessionManager));
    }
    copyInto(inst) {
        inst.configureLabelers(this.labelers);
        inst.configureProxy(this.proxy ?? null);
        inst.clearHeaders();
        for (const [key, value] of this.headers)inst.setHeader(key, value);
        return inst;
    }
    withProxy(serviceType, did) {
        const inst = this.clone();
        inst.configureProxy(`${(0, types_1.asDid)(did)}#${serviceType}`);
        return inst;
    }
    //#endregion
    //#region ATPROTO labelers configuration utilities
    /**
     * The labelers statically configured on the class of the current instance.
     */ get appLabelers() {
        return this.constructor.appLabelers;
    }
    configureLabelers(labelerDids) {
        this.labelers = labelerDids.map(types_1.asDid); // Validate & copy
    }
    /** @deprecated use {@link configureLabelers} instead */ configureLabelersHeader(labelerDids) {
        // Filtering non-did values for backwards compatibility
        this.configureLabelers(labelerDids.filter(types_1.isDid));
    }
    configureProxy(value) {
        if (value === null) this.proxy = undefined;
        else this.proxy = (0, types_1.asAtprotoProxy)(value);
    }
    /** @deprecated use {@link configureProxy} instead */ configureProxyHeader(serviceType, did) {
        // Ignoring non-did values for backwards compatibility
        if ((0, types_1.isDid)(did)) this.configureProxy(`${did}#${serviceType}`);
    }
    //#endregion
    //#region Session management
    /**
     * Get the authenticated user's DID, if any.
     */ get did() {
        return this.sessionManager.did;
    }
    /** @deprecated Use {@link Agent.assertDid} instead */ get accountDid() {
        return this.assertDid;
    }
    /**
     * Get the authenticated user's DID, or throw an error if not authenticated.
     */ get assertDid() {
        this.assertAuthenticated();
        return this.did;
    }
    /**
     * Assert that the user is authenticated.
     */ assertAuthenticated() {
        if (!this.did) throw new Error('Not logged in');
    }
    //#endregion
    /** @deprecated use "this" instead */ get api() {
        return this;
    }
    async getLabelDefinitions(prefs) {
        // collect the labeler dids
        const dids = [
            ...this.appLabelers
        ];
        if (isBskyPrefs(prefs)) dids.push(...prefs.moderationPrefs.labelers.map((l)=>l.did));
        else if (isModPrefs(prefs)) dids.push(...prefs.labelers.map((l)=>l.did));
        else dids.push(...prefs);
        // fetch their definitions
        const labelers = await this.getLabelers({
            dids,
            detailed: true
        });
        // assemble a map of labeler dids to the interpreted label value definitions
        const labelDefs = {};
        if (labelers.data) for (const labeler of labelers.data.views)labelDefs[labeler.creator.did] = (0, moderation_1.interpretLabelValueDefinitions)(labeler);
        return labelDefs;
    }
    async post(record) {
        record.createdAt || (record.createdAt = new Date().toISOString());
        return this.app.bsky.feed.post.create({
            repo: this.accountDid
        }, record);
    }
    async deletePost(postUri) {
        this.assertAuthenticated();
        const postUrip = new syntax_1.AtUri(postUri);
        return this.app.bsky.feed.post.delete({
            repo: postUrip.hostname,
            rkey: postUrip.rkey
        });
    }
    async like(uri, cid, via) {
        return this.app.bsky.feed.like.create({
            repo: this.accountDid
        }, {
            subject: {
                uri,
                cid
            },
            createdAt: new Date().toISOString(),
            via
        });
    }
    async deleteLike(likeUri) {
        this.assertAuthenticated();
        const likeUrip = new syntax_1.AtUri(likeUri);
        return this.app.bsky.feed.like.delete({
            repo: likeUrip.hostname,
            rkey: likeUrip.rkey
        });
    }
    async repost(uri, cid, via) {
        return this.app.bsky.feed.repost.create({
            repo: this.accountDid
        }, {
            subject: {
                uri,
                cid
            },
            createdAt: new Date().toISOString(),
            via
        });
    }
    async deleteRepost(repostUri) {
        this.assertAuthenticated();
        const repostUrip = new syntax_1.AtUri(repostUri);
        return this.app.bsky.feed.repost.delete({
            repo: repostUrip.hostname,
            rkey: repostUrip.rkey
        });
    }
    async follow(subjectDid) {
        return this.app.bsky.graph.follow.create({
            repo: this.accountDid
        }, {
            subject: subjectDid,
            createdAt: new Date().toISOString()
        });
    }
    async deleteFollow(followUri) {
        this.assertAuthenticated();
        const followUrip = new syntax_1.AtUri(followUri);
        return this.app.bsky.graph.follow.delete({
            repo: followUrip.hostname,
            rkey: followUrip.rkey
        });
    }
    /**
     * @note: Using this method will reset the whole profile record if it
     * previously contained invalid values (wrt to the profile lexicon).
     */ async upsertProfile(updateFn) {
        const upsert = async ()=>{
            const repo = this.assertDid;
            const collection = 'app.bsky.actor.profile';
            const existing = await this.com.atproto.repo.getRecord({
                repo,
                collection,
                rkey: 'self'
            }).catch((_)=>undefined);
            const existingRecord = existing && predicate.isValidProfile(existing.data.value) ? existing.data.value : undefined;
            // run the update
            const updated = await updateFn(existingRecord);
            // validate the value returned by the update function
            const validation = index_1.AppBskyActorProfile.validateRecord({
                $type: collection,
                ...updated
            });
            if (!validation.success) throw validation.error;
            await this.com.atproto.repo.putRecord({
                repo,
                collection,
                rkey: 'self',
                record: validation.value,
                swapRecord: existing?.data.cid || null
            });
        };
        return (0, common_web_1.retry)(upsert, {
            maxRetries: 5,
            retryable: (e)=>e instanceof index_1.ComAtprotoRepoPutRecord.InvalidSwapError
        });
    }
    async mute(actor) {
        return this.app.bsky.graph.muteActor({
            actor
        });
    }
    async unmute(actor) {
        return this.app.bsky.graph.unmuteActor({
            actor
        });
    }
    async muteModList(uri) {
        return this.app.bsky.graph.muteActorList({
            list: uri
        });
    }
    async unmuteModList(uri) {
        return this.app.bsky.graph.unmuteActorList({
            list: uri
        });
    }
    async blockModList(uri) {
        return this.app.bsky.graph.listblock.create({
            repo: this.accountDid
        }, {
            subject: uri,
            createdAt: new Date().toISOString()
        });
    }
    async unblockModList(uri) {
        const repo = this.accountDid;
        const listInfo = await this.app.bsky.graph.getList({
            list: uri,
            limit: 1
        });
        const blocked = listInfo.data.list.viewer?.blocked;
        if (blocked) {
            const { rkey } = new syntax_1.AtUri(blocked);
            return this.app.bsky.graph.listblock.delete({
                repo,
                rkey
            });
        }
    }
    async updateSeenNotifications(seenAt = new Date().toISOString()) {
        return this.app.bsky.notification.updateSeen({
            seenAt
        });
    }
    async getPreferences() {
        const prefs = {
            feeds: {
                saved: undefined,
                pinned: undefined
            },
            // @ts-ignore populating below
            savedFeeds: undefined,
            feedViewPrefs: {
                home: {
                    ...FEED_VIEW_PREF_DEFAULTS
                }
            },
            threadViewPrefs: {
                ...THREAD_VIEW_PREF_DEFAULTS
            },
            moderationPrefs: {
                adultContentEnabled: false,
                labels: {
                    ...labels_1.DEFAULT_LABEL_SETTINGS
                },
                labelers: this.appLabelers.map((did)=>({
                        did,
                        labels: {}
                    })),
                mutedWords: [],
                hiddenPosts: []
            },
            birthDate: undefined,
            interests: {
                tags: []
            },
            bskyAppState: {
                queuedNudges: [],
                activeProgressGuide: undefined,
                nuxs: []
            },
            postInteractionSettings: {
                threadgateAllowRules: undefined,
                postgateEmbeddingRules: undefined
            },
            verificationPrefs: {
                hideBadges: false
            }
        };
        const res = await this.app.bsky.actor.getPreferences({});
        const labelPrefs = [];
        for (const pref of res.data.preferences){
            if (predicate.isValidAdultContentPref(pref)) // adult content preferences
            prefs.moderationPrefs.adultContentEnabled = pref.enabled;
            else if (predicate.isValidContentLabelPref(pref)) {
                // content label preference
                const adjustedPref = adjustLegacyContentLabelPref(pref);
                labelPrefs.push(adjustedPref);
            } else if (predicate.isValidLabelersPref(pref)) // labelers preferences
            prefs.moderationPrefs.labelers = this.appLabelers.map((did)=>({
                    did,
                    labels: {}
                })).concat(pref.labelers.map((labeler)=>({
                    ...labeler,
                    labels: {}
                })));
            else if (predicate.isValidSavedFeedsPrefV2(pref)) prefs.savedFeeds = pref.items;
            else if (predicate.isValidSavedFeedsPref(pref)) {
                // saved and pinned feeds
                prefs.feeds.saved = pref.saved;
                prefs.feeds.pinned = pref.pinned;
            } else if (predicate.isValidPersonalDetailsPref(pref)) // birth date (irl)
            {
                if (pref.birthDate) prefs.birthDate = new Date(pref.birthDate);
            } else if (predicate.isValidFeedViewPref(pref)) {
                // feed view preferences
                const { $type: _, feed, ...v } = pref;
                prefs.feedViewPrefs[feed] = {
                    ...FEED_VIEW_PREF_DEFAULTS,
                    ...v
                };
            } else if (predicate.isValidThreadViewPref(pref)) {
                // thread view preferences
                const { $type: _, ...v } = pref;
                prefs.threadViewPrefs = {
                    ...prefs.threadViewPrefs,
                    ...v
                };
            } else if (predicate.isValidInterestsPref(pref)) {
                const { $type: _, ...v } = pref;
                prefs.interests = {
                    ...prefs.interests,
                    ...v
                };
            } else if (predicate.isValidMutedWordsPref(pref)) {
                prefs.moderationPrefs.mutedWords = pref.items;
                if (prefs.moderationPrefs.mutedWords.length) prefs.moderationPrefs.mutedWords = prefs.moderationPrefs.mutedWords.map((word)=>{
                    word.actorTarget = word.actorTarget || 'all';
                    return word;
                });
            } else if (predicate.isValidHiddenPostsPref(pref)) prefs.moderationPrefs.hiddenPosts = pref.items;
            else if (predicate.isValidBskyAppStatePref(pref)) {
                prefs.bskyAppState.queuedNudges = pref.queuedNudges || [];
                prefs.bskyAppState.activeProgressGuide = pref.activeProgressGuide;
                prefs.bskyAppState.nuxs = pref.nuxs || [];
            } else if (predicate.isValidPostInteractionSettingsPref(pref)) {
                prefs.postInteractionSettings.threadgateAllowRules = pref.threadgateAllowRules;
                prefs.postInteractionSettings.postgateEmbeddingRules = pref.postgateEmbeddingRules;
            } else if (predicate.isValidVerificationPrefs(pref)) prefs.verificationPrefs = {
                hideBadges: pref.hideBadges
            };
        }
        /*
         * If `prefs.savedFeeds` is undefined, no `savedFeedsPrefV2` exists, which
         * means we want to try to migrate if needed.
         *
         * If v1 prefs exist, they will be migrated to v2.
         *
         * If no v1 prefs exist, the user is either new, or could be old and has
         * never edited their feeds.
         */ if (prefs.savedFeeds == null) {
            const { saved, pinned } = prefs.feeds;
            if (saved && pinned) {
                const uniqueMigratedSavedFeeds = new Map();
                // insert Following feed first
                uniqueMigratedSavedFeeds.set('timeline', {
                    id: common_web_1.TID.nextStr(),
                    type: 'timeline',
                    value: 'following',
                    pinned: true
                });
                // use pinned as source of truth for feed order
                for (const uri of pinned){
                    const type = (0, util_1.getSavedFeedType)(uri);
                    // only want supported types
                    if (type === 'unknown') continue;
                    uniqueMigratedSavedFeeds.set(uri, {
                        id: common_web_1.TID.nextStr(),
                        type,
                        value: uri,
                        pinned: true
                    });
                }
                for (const uri of saved)if (!uniqueMigratedSavedFeeds.has(uri)) {
                    const type = (0, util_1.getSavedFeedType)(uri);
                    // only want supported types
                    if (type === 'unknown') continue;
                    uniqueMigratedSavedFeeds.set(uri, {
                        id: common_web_1.TID.nextStr(),
                        type,
                        value: uri,
                        pinned: false
                    });
                }
                prefs.savedFeeds = Array.from(uniqueMigratedSavedFeeds.values());
            } else prefs.savedFeeds = [
                {
                    id: common_web_1.TID.nextStr(),
                    type: 'timeline',
                    value: 'following',
                    pinned: true
                }
            ];
            // save to user preferences so this migration doesn't re-occur
            await this.overwriteSavedFeeds(prefs.savedFeeds);
        }
        // apply the label prefs
        for (const pref of labelPrefs)if (pref.labelerDid) {
            const labeler = prefs.moderationPrefs.labelers.find((labeler)=>labeler.did === pref.labelerDid);
            if (!labeler) continue;
            labeler.labels[pref.label] = pref.visibility;
        } else prefs.moderationPrefs.labels[pref.label] = pref.visibility;
        prefs.moderationPrefs.labels = remapLegacyLabels(prefs.moderationPrefs.labels);
        // automatically configure the client
        this.configureLabelers(prefsArrayToLabelerDids(res.data.preferences));
        return prefs;
    }
    async overwriteSavedFeeds(savedFeeds) {
        savedFeeds.forEach(util_1.validateSavedFeed);
        const uniqueSavedFeeds = new Map();
        savedFeeds.forEach((feed)=>{
            // remove and re-insert to preserve order
            if (uniqueSavedFeeds.has(feed.id)) uniqueSavedFeeds.delete(feed.id);
            uniqueSavedFeeds.set(feed.id, feed);
        });
        return this.updateSavedFeedsV2Preferences(()=>Array.from(uniqueSavedFeeds.values()));
    }
    async updateSavedFeeds(savedFeedsToUpdate) {
        savedFeedsToUpdate.map(util_1.validateSavedFeed);
        return this.updateSavedFeedsV2Preferences((savedFeeds)=>{
            return savedFeeds.map((savedFeed)=>{
                const updatedVersion = savedFeedsToUpdate.find((updated)=>savedFeed.id === updated.id);
                if (updatedVersion) return {
                    ...savedFeed,
                    // only update pinned
                    pinned: updatedVersion.pinned
                };
                return savedFeed;
            });
        });
    }
    async addSavedFeeds(savedFeeds) {
        const toSave = savedFeeds.map((f)=>({
                ...f,
                id: common_web_1.TID.nextStr()
            }));
        toSave.forEach(util_1.validateSavedFeed);
        return this.updateSavedFeedsV2Preferences((savedFeeds)=>[
                ...savedFeeds,
                ...toSave
            ]);
    }
    async removeSavedFeeds(ids) {
        return this.updateSavedFeedsV2Preferences((savedFeeds)=>[
                ...savedFeeds.filter((feed)=>!ids.find((id)=>feed.id === id))
            ]);
    }
    /**
     * @deprecated use `overwriteSavedFeeds`
     */ async setSavedFeeds(saved, pinned) {
        return this.updateFeedPreferences(()=>({
                saved,
                pinned
            }));
    }
    /**
     * @deprecated use `addSavedFeeds`
     */ async addSavedFeed(v) {
        return this.updateFeedPreferences((saved, pinned)=>({
                saved: [
                    ...saved.filter((uri)=>uri !== v),
                    v
                ],
                pinned
            }));
    }
    /**
     * @deprecated use `removeSavedFeeds`
     */ async removeSavedFeed(v) {
        return this.updateFeedPreferences((saved, pinned)=>({
                saved: saved.filter((uri)=>uri !== v),
                pinned: pinned.filter((uri)=>uri !== v)
            }));
    }
    /**
     * @deprecated use `addSavedFeeds` or `updateSavedFeeds`
     */ async addPinnedFeed(v) {
        return this.updateFeedPreferences((saved, pinned)=>({
                saved: [
                    ...saved.filter((uri)=>uri !== v),
                    v
                ],
                pinned: [
                    ...pinned.filter((uri)=>uri !== v),
                    v
                ]
            }));
    }
    /**
     * @deprecated use `updateSavedFeeds` or `removeSavedFeeds`
     */ async removePinnedFeed(v) {
        return this.updateFeedPreferences((saved, pinned)=>({
                saved,
                pinned: pinned.filter((uri)=>uri !== v)
            }));
    }
    async setAdultContentEnabled(v) {
        await this.updatePreferences((prefs)=>{
            const adultContentPref = prefs.findLast(predicate.isValidAdultContentPref) || {
                $type: 'app.bsky.actor.defs#adultContentPref',
                enabled: v
            };
            adultContentPref.enabled = v;
            return prefs.filter((pref)=>!index_1.AppBskyActorDefs.isAdultContentPref(pref)).concat(adultContentPref);
        });
    }
    async setContentLabelPref(key, value, labelerDid) {
        if (labelerDid) (0, syntax_1.ensureValidDid)(labelerDid);
        await this.updatePreferences((prefs)=>{
            const labelPref = prefs.filter(predicate.isValidContentLabelPref).findLast((pref)=>pref.label === key && pref.labelerDid === labelerDid) || {
                $type: 'app.bsky.actor.defs#contentLabelPref',
                label: key,
                labelerDid,
                visibility: value
            };
            labelPref.visibility = value;
            let legacyLabelPref;
            if (index_1.AppBskyActorDefs.isContentLabelPref(labelPref)) // is global
            {
                if (!labelPref.labelerDid) {
                    const legacyLabelValue = {
                        'graphic-media': 'gore',
                        porn: 'nsfw',
                        sexual: 'suggestive',
                        // Protect against using toString, hasOwnProperty, etc. as a label:
                        __proto__: null
                    }[labelPref.label];
                    // if it's a legacy label, double-write the legacy label
                    if (legacyLabelValue) {
                        legacyLabelPref = prefs.filter(predicate.isValidContentLabelPref).findLast((pref)=>pref.label === legacyLabelValue && pref.labelerDid === undefined) || {
                            $type: 'app.bsky.actor.defs#contentLabelPref',
                            label: legacyLabelValue,
                            labelerDid: undefined,
                            visibility: value
                        };
                        legacyLabelPref.visibility = value;
                    }
                }
            }
            return prefs.filter((pref)=>!index_1.AppBskyActorDefs.isContentLabelPref(pref) || !(pref.label === key && pref.labelerDid === labelerDid)).concat(labelPref).filter((pref)=>{
                if (!legacyLabelPref) return true;
                return !index_1.AppBskyActorDefs.isContentLabelPref(pref) || !(pref.label === legacyLabelPref.label && pref.labelerDid === undefined);
            }).concat(legacyLabelPref ? [
                legacyLabelPref
            ] : []);
        });
    }
    async addLabeler(did) {
        const prefs = await this.updatePreferences((prefs)=>{
            const labelersPref = prefs.findLast(predicate.isValidLabelersPref) || {
                $type: 'app.bsky.actor.defs#labelersPref',
                labelers: []
            };
            if (!labelersPref.labelers.some((labeler)=>labeler.did === did)) labelersPref.labelers.push({
                did
            });
            return prefs.filter((pref)=>!index_1.AppBskyActorDefs.isLabelersPref(pref)).concat(labelersPref);
        });
        // automatically configure the client
        this.configureLabelers(prefsArrayToLabelerDids(prefs));
    }
    async removeLabeler(did) {
        const prefs = await this.updatePreferences((prefs)=>{
            const labelersPref = prefs.findLast(predicate.isValidLabelersPref) || {
                $type: 'app.bsky.actor.defs#labelersPref',
                labelers: []
            };
            labelersPref.labelers = labelersPref.labelers.filter((l)=>l.did !== did);
            return prefs.filter((pref)=>!index_1.AppBskyActorDefs.isLabelersPref(pref)).concat(labelersPref);
        });
        // automatically configure the client
        this.configureLabelers(prefsArrayToLabelerDids(prefs));
    }
    async setPersonalDetails({ birthDate }) {
        await this.updatePreferences((prefs)=>{
            const personalDetailsPref = prefs.findLast(predicate.isValidPersonalDetailsPref) || {
                $type: 'app.bsky.actor.defs#personalDetailsPref'
            };
            personalDetailsPref.birthDate = birthDate instanceof Date ? birthDate.toISOString() : birthDate;
            return prefs.filter((pref)=>!index_1.AppBskyActorDefs.isPersonalDetailsPref(pref)).concat(personalDetailsPref);
        });
    }
    async setFeedViewPrefs(feed, pref) {
        await this.updatePreferences((prefs)=>{
            const existing = prefs.filter(predicate.isValidFeedViewPref).findLast((pref)=>pref.feed === feed);
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isFeedViewPref(p) || p.feed !== feed).concat({
                ...existing,
                ...pref,
                $type: 'app.bsky.actor.defs#feedViewPref',
                feed
            });
        });
    }
    async setThreadViewPrefs(pref) {
        await this.updatePreferences((prefs)=>{
            const existing = prefs.findLast(predicate.isValidThreadViewPref);
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isThreadViewPref(p)).concat({
                ...existing,
                ...pref,
                $type: 'app.bsky.actor.defs#threadViewPref'
            });
        });
    }
    async setInterestsPref(pref) {
        await this.updatePreferences((prefs)=>{
            const existing = prefs.findLast(predicate.isValidInterestsPref);
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isInterestsPref(p)).concat({
                ...existing,
                ...pref,
                $type: 'app.bsky.actor.defs#interestsPref'
            });
        });
    }
    /**
     * Add a muted word to user preferences.
     */ async addMutedWord(mutedWord) {
        const sanitizedValue = (0, util_1.sanitizeMutedWordValue)(mutedWord.value);
        if (!sanitizedValue) return;
        await this.updatePreferences((prefs)=>{
            let mutedWordsPref = prefs.findLast(predicate.isValidMutedWordsPref);
            const newMutedWord = {
                id: common_web_1.TID.nextStr(),
                value: sanitizedValue,
                targets: mutedWord.targets || [],
                actorTarget: mutedWord.actorTarget || 'all',
                expiresAt: mutedWord.expiresAt || undefined
            };
            if (mutedWordsPref) {
                mutedWordsPref.items.push(newMutedWord);
                /**
                 * Migrate any old muted words that don't have an id
                 */ mutedWordsPref.items = migrateLegacyMutedWordsItems(mutedWordsPref.items);
            } else // if the pref doesn't exist, create it
            mutedWordsPref = {
                $type: 'app.bsky.actor.defs#mutedWordsPref',
                items: [
                    newMutedWord
                ]
            };
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isMutedWordsPref(p)).concat(mutedWordsPref);
        });
    }
    /**
     * Convenience method to add muted words to user preferences
     */ async addMutedWords(newMutedWords) {
        await Promise.all(newMutedWords.map((word)=>this.addMutedWord(word)));
    }
    /**
     * @deprecated use `addMutedWords` or `addMutedWord` instead
     */ async upsertMutedWords(mutedWords) {
        await this.addMutedWords(mutedWords);
    }
    /**
     * Update a muted word in user preferences.
     */ async updateMutedWord(mutedWord) {
        await this.updatePreferences((prefs)=>{
            const mutedWordsPref = prefs.findLast(predicate.isValidMutedWordsPref);
            if (mutedWordsPref) {
                mutedWordsPref.items = mutedWordsPref.items.map((existingItem)=>{
                    const match = matchMutedWord(existingItem, mutedWord);
                    if (match) {
                        const updated = {
                            ...existingItem,
                            ...mutedWord
                        };
                        return {
                            id: existingItem.id || common_web_1.TID.nextStr(),
                            value: (0, util_1.sanitizeMutedWordValue)(updated.value) || existingItem.value,
                            targets: updated.targets || [],
                            actorTarget: updated.actorTarget || 'all',
                            expiresAt: updated.expiresAt || undefined
                        };
                    } else return existingItem;
                });
                /**
                 * Migrate any old muted words that don't have an id
                 */ mutedWordsPref.items = migrateLegacyMutedWordsItems(mutedWordsPref.items);
                return prefs.filter((p)=>!index_1.AppBskyActorDefs.isMutedWordsPref(p)).concat(mutedWordsPref);
            }
            return prefs;
        });
    }
    /**
     * Remove a muted word from user preferences.
     */ async removeMutedWord(mutedWord) {
        await this.updatePreferences((prefs)=>{
            const mutedWordsPref = prefs.findLast(predicate.isValidMutedWordsPref);
            if (mutedWordsPref) {
                for(let i = 0; i < mutedWordsPref.items.length; i++){
                    const match = matchMutedWord(mutedWordsPref.items[i], mutedWord);
                    if (match) {
                        mutedWordsPref.items.splice(i, 1);
                        break;
                    }
                }
                /**
                 * Migrate any old muted words that don't have an id
                 */ mutedWordsPref.items = migrateLegacyMutedWordsItems(mutedWordsPref.items);
                return prefs.filter((p)=>!index_1.AppBskyActorDefs.isMutedWordsPref(p)).concat(mutedWordsPref);
            }
            return prefs;
        });
    }
    /**
     * Convenience method to remove muted words from user preferences
     */ async removeMutedWords(mutedWords) {
        await Promise.all(mutedWords.map((word)=>this.removeMutedWord(word)));
    }
    async hidePost(postUri) {
        await this.updateHiddenPost(postUri, 'hide');
    }
    async unhidePost(postUri) {
        await this.updateHiddenPost(postUri, 'unhide');
    }
    async bskyAppQueueNudges(nudges) {
        await this.updatePreferences((prefs)=>{
            const pref = prefs.findLast(predicate.isValidBskyAppStatePref) || {
                $type: 'app.bsky.actor.defs#bskyAppStatePref'
            };
            pref.queuedNudges = (pref.queuedNudges || []).concat(nudges);
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isBskyAppStatePref(p)).concat(pref);
        });
    }
    async bskyAppDismissNudges(nudges) {
        await this.updatePreferences((prefs)=>{
            const pref = prefs.findLast(predicate.isValidBskyAppStatePref) || {
                $type: 'app.bsky.actor.defs#bskyAppStatePref'
            };
            nudges = Array.isArray(nudges) ? nudges : [
                nudges
            ];
            pref.queuedNudges = (pref.queuedNudges || []).filter((nudge)=>!nudges.includes(nudge));
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isBskyAppStatePref(p)).concat(pref);
        });
    }
    async bskyAppSetActiveProgressGuide(guide) {
        if (guide) {
            const result = index_1.AppBskyActorDefs.validateBskyAppProgressGuide(guide);
            if (!result.success) throw result.error;
        }
        await this.updatePreferences((prefs)=>{
            const pref = prefs.findLast(predicate.isValidBskyAppStatePref) || {
                $type: 'app.bsky.actor.defs#bskyAppStatePref'
            };
            pref.activeProgressGuide = guide;
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isBskyAppStatePref(p)).concat(pref);
        });
    }
    /**
     * Insert or update a NUX in user prefs
     */ async bskyAppUpsertNux(nux) {
        (0, util_1.validateNux)(nux);
        await this.updatePreferences((prefs)=>{
            const pref = prefs.findLast(predicate.isValidBskyAppStatePref) || {
                $type: 'app.bsky.actor.defs#bskyAppStatePref'
            };
            pref.nuxs = pref.nuxs || [];
            const existing = pref.nuxs?.find((n)=>{
                return n.id === nux.id;
            });
            let next;
            if (existing) next = {
                id: existing.id,
                completed: nux.completed,
                data: nux.data,
                expiresAt: nux.expiresAt
            };
            else next = nux;
            // remove duplicates and append
            pref.nuxs = pref.nuxs.filter((n)=>n.id !== nux.id).concat(next);
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isBskyAppStatePref(p)).concat(pref);
        });
    }
    /**
     * Removes NUXs from user preferences.
     */ async bskyAppRemoveNuxs(ids) {
        await this.updatePreferences((prefs)=>{
            const pref = prefs.findLast(predicate.isValidBskyAppStatePref) || {
                $type: 'app.bsky.actor.defs#bskyAppStatePref'
            };
            pref.nuxs = (pref.nuxs || []).filter((nux)=>!ids.includes(nux.id));
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isBskyAppStatePref(p)).concat(pref);
        });
    }
    async setPostInteractionSettings(settings) {
        const result = index_1.AppBskyActorDefs.validatePostInteractionSettingsPref(settings);
        // Fool-proofing (should not be needed because of type safety)
        if (!result.success) throw result.error;
        await this.updatePreferences((prefs)=>{
            const pref = prefs.findLast(predicate.isValidPostInteractionSettingsPref) || {
                $type: 'app.bsky.actor.defs#postInteractionSettingsPref'
            };
            /**
             * Matches handling of `threadgate.allow` where `undefined` means "everyone"
             */ pref.threadgateAllowRules = settings.threadgateAllowRules;
            pref.postgateEmbeddingRules = settings.postgateEmbeddingRules;
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isPostInteractionSettingsPref(p)).concat(pref);
        });
    }
    async setVerificationPrefs(settings) {
        const result = index_1.AppBskyActorDefs.validateVerificationPrefs(settings);
        // Fool-proofing (should not be needed because of type safety)
        if (!result.success) throw result.error;
        await this.updatePreferences((prefs)=>{
            const pref = prefs.findLast(predicate.isValidVerificationPrefs) || {
                $type: 'app.bsky.actor.defs#verificationPrefs',
                hideBadges: false
            };
            pref.hideBadges = settings.hideBadges;
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isVerificationPrefs(p)).concat(pref);
        });
    }
    /**
     * This function updates the preferences of a user and allows for a callback function to be executed
     * before the update.
     * @param cb - cb is a callback function that takes in a single parameter of type
     * AppBskyActorDefs.Preferences and returns either a boolean or void. This callback function is used to
     * update the preferences of the user. The function is called with the current preferences as an
     * argument and if the callback returns false, the preferences are not updated.
     */ async updatePreferences(cb) {
        try {
            await __classPrivateFieldGet(this, _Agent_prefsLock, "f").acquireAsync();
            const res = await this.app.bsky.actor.getPreferences({});
            const newPrefs = cb(res.data.preferences);
            if (newPrefs === false) return res.data.preferences;
            await this.app.bsky.actor.putPreferences({
                preferences: newPrefs
            });
            return newPrefs;
        } finally{
            __classPrivateFieldGet(this, _Agent_prefsLock, "f").release();
        }
    }
    async updateHiddenPost(postUri, action) {
        await this.updatePreferences((prefs)=>{
            const pref = prefs.findLast(predicate.isValidHiddenPostsPref) || {
                $type: 'app.bsky.actor.defs#hiddenPostsPref',
                items: []
            };
            const hiddenItems = new Set(pref.items);
            if (action === 'hide') hiddenItems.add(postUri);
            else hiddenItems.delete(postUri);
            pref.items = [
                ...hiddenItems
            ];
            return prefs.filter((p)=>!index_1.AppBskyActorDefs.isHiddenPostsPref(p)).concat(pref);
        });
    }
    /**
     * A helper specifically for updating feed preferences
     */ async updateFeedPreferences(cb) {
        let res;
        await this.updatePreferences((prefs)=>{
            const feedsPref = prefs.findLast(predicate.isValidSavedFeedsPref) || {
                $type: 'app.bsky.actor.defs#savedFeedsPref',
                saved: [],
                pinned: []
            };
            res = cb(feedsPref.saved, feedsPref.pinned);
            feedsPref.saved = res.saved;
            feedsPref.pinned = res.pinned;
            return prefs.filter((pref)=>!index_1.AppBskyActorDefs.isSavedFeedsPref(pref)).concat(feedsPref);
        });
        return res;
    }
    async updateSavedFeedsV2Preferences(cb) {
        let maybeMutatedSavedFeeds = [];
        await this.updatePreferences((prefs)=>{
            const existingV2Pref = prefs.findLast(predicate.isValidSavedFeedsPrefV2) || {
                $type: 'app.bsky.actor.defs#savedFeedsPrefV2',
                items: []
            };
            const newSavedFeeds = cb(existingV2Pref.items);
            // enforce ordering: pinned first, then saved
            existingV2Pref.items = [
                ...newSavedFeeds
            ].sort((a, b)=>// @NOTE: preserve order of items with the same pinned status
                a.pinned === b.pinned ? 0 : a.pinned ? -1 : 1);
            // Store the return value
            maybeMutatedSavedFeeds = newSavedFeeds;
            let updatedPrefs = prefs.filter((pref)=>!index_1.AppBskyActorDefs.isSavedFeedsPrefV2(pref)).concat(existingV2Pref);
            /*
             * If there's a v2 pref present, it means this account was migrated from v1
             * to v2. During the transition period, we double write v2 prefs back to
             * v1, but NOT the other way around.
             */ let existingV1Pref = prefs.findLast(predicate.isValidSavedFeedsPref);
            if (existingV1Pref) {
                const { saved, pinned } = existingV1Pref;
                const v2Compat = (0, util_1.savedFeedsToUriArrays)(// v1 only supports feeds and lists
                existingV2Pref.items.filter((i)=>[
                        'feed',
                        'list'
                    ].includes(i.type)));
                existingV1Pref = {
                    ...existingV1Pref,
                    saved: Array.from(new Set([
                        ...saved,
                        ...v2Compat.saved
                    ])),
                    pinned: Array.from(new Set([
                        ...pinned,
                        ...v2Compat.pinned
                    ]))
                };
                updatedPrefs = updatedPrefs.filter((pref)=>!index_1.AppBskyActorDefs.isSavedFeedsPref(pref)).concat(existingV1Pref);
            }
            return updatedPrefs;
        });
        return maybeMutatedSavedFeeds;
    }
}
exports.Agent = Agent;
_Agent_prefsLock = new WeakMap();
//#region Static configuration
/**
 * The labelers to be used across all requests with the takedown capability
 */ Object.defineProperty(Agent, "appLabelers", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [
        const_1.BSKY_LABELER_DID
    ]
});
/**
 * Helper to transform the legacy content preferences.
 */ function adjustLegacyContentLabelPref(pref) {
    let visibility = pref.visibility;
    // adjust legacy values
    if (visibility === 'show') visibility = 'ignore';
    return {
        ...pref,
        visibility
    };
}
/**
 * Re-maps legacy labels to new labels on READ. Does not save these changes to
 * the user's preferences.
 */ function remapLegacyLabels(labels) {
    const _labels = {
        ...labels
    };
    const legacyToNewMap = {
        gore: 'graphic-media',
        nsfw: 'porn',
        suggestive: 'sexual'
    };
    for(const labelName in _labels){
        const newLabelName = legacyToNewMap[labelName];
        if (newLabelName) _labels[newLabelName] = _labels[labelName];
    }
    return _labels;
}
/**
 * A helper to get the currently enabled labelers from the full preferences array
 */ function prefsArrayToLabelerDids(prefs) {
    const labelersPref = prefs.findLast(predicate.isValidLabelersPref);
    let dids = [];
    if (labelersPref) dids = labelersPref.labelers.map((labeler)=>labeler.did);
    return dids;
}
function isBskyPrefs(v) {
    return v && typeof v === 'object' && 'moderationPrefs' in v && isModPrefs(v.moderationPrefs);
}
function isModPrefs(v) {
    return v && typeof v === 'object' && 'labelers' in v;
}
function migrateLegacyMutedWordsItems(items) {
    return items.map((item)=>({
            ...item,
            id: item.id || common_web_1.TID.nextStr()
        }));
}
function matchMutedWord(existingWord, newWord) {
    // id is undefined in legacy implementation
    const existingId = existingWord.id;
    // prefer matching based on id
    const matchById = existingId && existingId === newWord.id;
    // handle legacy case where id is not set
    const legacyMatchByValue = !existingId && existingWord.value === newWord.value;
    return matchById || legacyMatchByValue;
}

},{"5a9a60055ae04083":"6UJ2e","c3b81fbb82a22b26":"jDe1t","351b7c11438a71a":"dBffO","84981030a50b26fc":"3J4dg","23ca0c94172c3f13":"a8Anh","47c4b656fac50690":"4ClhN","ed982957d446232e":"8d2D9","acb829161e9b06f8":"4z6F1","8d7ce7599341a44b":"8B59F","9dc2040f1b893077":"cF77r","a80f5ed9330f5d99":"cODXL","2f51a971794a11da":"eeUEr"}],"6UJ2e":[function(require,module,exports,__globalThis) {
"use strict";
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _AwaitLock_acquired, _AwaitLock_waitingResolvers;
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * A mutex lock for coordination across async functions
 */ class AwaitLock {
    constructor(){
        _AwaitLock_acquired.set(this, false);
        _AwaitLock_waitingResolvers.set(this, new Set());
    }
    /**
     * Whether the lock is currently acquired or not. Accessing this property does not affect the
     * status of the lock.
     */ get acquired() {
        return __classPrivateFieldGet(this, _AwaitLock_acquired, "f");
    }
    /**
     * Acquires the lock, waiting if necessary for it to become free if it is already locked. The
     * returned promise is fulfilled once the lock is acquired.
     *
     * A timeout (in milliseconds) may be optionally provided. If the lock cannot be acquired before
     * the timeout elapses, the returned promise is rejected with an error. The behavior of invalid
     * timeout values depends on how `setTimeout` handles those values.
     *
     * After acquiring the lock, you **must** call `release` when you are done with it.
     */ acquireAsync({ timeout } = {}) {
        if (!__classPrivateFieldGet(this, _AwaitLock_acquired, "f")) {
            __classPrivateFieldSet(this, _AwaitLock_acquired, true, "f");
            return Promise.resolve();
        }
        if (timeout == null) return new Promise((resolve)=>{
            __classPrivateFieldGet(this, _AwaitLock_waitingResolvers, "f").add(resolve);
        });
        let resolver;
        let timer;
        return Promise.race([
            new Promise((resolve)=>{
                resolver = ()=>{
                    clearTimeout(timer);
                    resolve();
                };
                __classPrivateFieldGet(this, _AwaitLock_waitingResolvers, "f").add(resolver);
            }),
            new Promise((_, reject)=>{
                timer = setTimeout(()=>{
                    __classPrivateFieldGet(this, _AwaitLock_waitingResolvers, "f").delete(resolver);
                    reject(new Error(`Timed out waiting for lock`));
                }, timeout);
            })
        ]);
    }
    /**
     * Acquires the lock if it is free and otherwise returns immediately without waiting. Returns
     * `true` if the lock was free and is now acquired, and `false` otherwise.
     *
     * This method differs from calling `acquireAsync` with a zero-millisecond timeout in that it runs
     * synchronously without waiting for the JavaScript task queue.
     */ tryAcquire() {
        if (!__classPrivateFieldGet(this, _AwaitLock_acquired, "f")) {
            __classPrivateFieldSet(this, _AwaitLock_acquired, true, "f");
            return true;
        }
        return false;
    }
    /**
     * Releases the lock and gives it to the next waiting acquirer, if there is one. Each acquirer
     * must release the lock exactly once.
     */ release() {
        if (!__classPrivateFieldGet(this, _AwaitLock_acquired, "f")) throw new Error(`Cannot release an unacquired lock`);
        if (__classPrivateFieldGet(this, _AwaitLock_waitingResolvers, "f").size > 0) {
            // Sets preserve insertion order like a queue
            const [resolve] = __classPrivateFieldGet(this, _AwaitLock_waitingResolvers, "f");
            __classPrivateFieldGet(this, _AwaitLock_waitingResolvers, "f").delete(resolve);
            resolve();
        } else __classPrivateFieldSet(this, _AwaitLock_acquired, false, "f");
    }
}
exports.default = AwaitLock;
_AwaitLock_acquired = new WeakMap(), _AwaitLock_waitingResolvers = new WeakMap();

},{}],"cF77r":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isValidVerificationPrefs = exports.isValidThreadViewPref = exports.isValidSavedFeedsPrefV2 = exports.isValidSavedFeedsPref = exports.isValidPostInteractionSettingsPref = exports.isValidPersonalDetailsPref = exports.isValidMutedWordsPref = exports.isValidLabelersPref = exports.isValidInterestsPref = exports.isValidHiddenPostsPref = exports.isValidFeedViewPref = exports.isValidContentLabelPref = exports.isValidBskyAppStatePref = exports.isValidAdultContentPref = exports.isValidProfile = void 0;
const index_1 = require("aa4ecc66f04846c2");
const util_1 = require("bc806b38dcc7ff5d");
exports.isValidProfile = (0, util_1.asPredicate)(index_1.AppBskyActorProfile.validateRecord);
exports.isValidAdultContentPref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateAdultContentPref);
exports.isValidBskyAppStatePref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateBskyAppStatePref);
exports.isValidContentLabelPref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateContentLabelPref);
exports.isValidFeedViewPref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateFeedViewPref);
exports.isValidHiddenPostsPref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateHiddenPostsPref);
exports.isValidInterestsPref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateInterestsPref);
exports.isValidLabelersPref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateLabelersPref);
exports.isValidMutedWordsPref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateMutedWordsPref);
exports.isValidPersonalDetailsPref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validatePersonalDetailsPref);
exports.isValidPostInteractionSettingsPref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validatePostInteractionSettingsPref);
exports.isValidSavedFeedsPref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateSavedFeedsPref);
exports.isValidSavedFeedsPrefV2 = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateSavedFeedsPrefV2);
exports.isValidThreadViewPref = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateThreadViewPref);
exports.isValidVerificationPrefs = (0, util_1.asPredicate)(index_1.AppBskyActorDefs.validateVerificationPrefs);

},{"aa4ecc66f04846c2":"a8Anh","bc806b38dcc7ff5d":"45ZSh"}],"aIvB3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CredentialSession = exports.AtpAgent = void 0;
const common_web_1 = require("96ed7501ed2528f4");
const xrpc_1 = require("ad8314730d43cce9");
const agent_1 = require("768097a580e96e16");
const client_1 = require("2f7abfa9748257d7");
const lexicons_1 = require("dde7df7bfa9dfd37");
const ReadableStream = globalThis.ReadableStream;
/**
 * A wrapper around the {@link Agent} class that uses credential based session
 * management. This class also exposes most of the session management methods
 * directly.
 *
 * This class will be deprecated in the near future. Use {@link Agent} directly
 * with a {@link CredentialSession} instead:
 *
 *  ```ts
 *  const session = new CredentialSession({
 *    service: new URL('https://example.com'),
 *  })
 *
 *  const agent = new Agent(session)
 *  ```
 */ class AtpAgent extends agent_1.Agent {
    constructor(options){
        const sessionManager = options instanceof CredentialSession ? options : new CredentialSession(new URL(options.service), options.fetch, options.persistSession);
        super(sessionManager);
        Object.defineProperty(this, "sessionManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // This assignment is already being done in the super constructor, but we
        // need to do it here to make TypeScript happy.
        this.sessionManager = sessionManager;
        if (!(options instanceof CredentialSession) && options.headers) for (const [key, value] of options.headers)this.setHeader(key, value);
    }
    clone() {
        return this.copyInto(new AtpAgent(this.sessionManager));
    }
    get session() {
        return this.sessionManager.session;
    }
    get hasSession() {
        return this.sessionManager.hasSession;
    }
    get did() {
        return this.sessionManager.did;
    }
    get serviceUrl() {
        return this.sessionManager.serviceUrl;
    }
    get pdsUrl() {
        return this.sessionManager.pdsUrl;
    }
    get dispatchUrl() {
        return this.sessionManager.dispatchUrl;
    }
    /** @deprecated use {@link serviceUrl} instead */ get service() {
        return this.serviceUrl;
    }
    get persistSession() {
        throw new Error('Cannot set persistSession directly. "persistSession" is defined through the constructor and will be invoked automatically when session data changes.');
    }
    set persistSession(v) {
        throw new Error('Cannot set persistSession directly. "persistSession" must be defined in the constructor and can no longer be changed.');
    }
    /** @deprecated use {@link AtpAgent.serviceUrl} instead */ getServiceUrl() {
        return this.serviceUrl;
    }
    async resumeSession(session) {
        return this.sessionManager.resumeSession(session);
    }
    async createAccount(data, opts) {
        return this.sessionManager.createAccount(data, opts);
    }
    async login(opts) {
        return this.sessionManager.login(opts);
    }
    async createCustomJwtSession(opts) {
        return this.sessionManager.createCustomJwtSession(opts);
    }
    async logout() {
        return this.sessionManager.logout();
    }
}
exports.AtpAgent = AtpAgent;
/**
 * Credentials (username / password) based session manager. Instances of this
 * class will typically be used as the session manager for an {@link AtpAgent}.
 * They can also be used with an {@link XrpcClient}, if you want to use you
 * own Lexicons.
 */ class CredentialSession {
    constructor(serviceUrl, fetch = globalThis.fetch, persistSession){
        Object.defineProperty(this, "serviceUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: serviceUrl
        });
        Object.defineProperty(this, "fetch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: fetch
        });
        Object.defineProperty(this, "persistSession", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: persistSession
        });
        Object.defineProperty(this, "pdsUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // The PDS URL, driven by the did doc
        Object.defineProperty(this, "session", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "refreshSessionPromise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Private {@link ComAtprotoServerNS} used to perform session management API
         * calls on the service endpoint. Calls performed by this agent will not be
         * authenticated using the user's session to allow proper manual configuration
         * of the headers when performing session management operations.
         */ Object.defineProperty(this, "server", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new client_1.ComAtprotoServerNS(// Note that the use of the codegen "schemas" (to instantiate `this.api`),
            // as well as the use of `ComAtprotoServerNS` will cause this class to
            // reference (way) more code than it actually needs. It is not possible,
            // with the current state of the codegen, to generate a client that only
            // includes the methods that are actually used by this class. This is a
            // known limitation that should be addressed in a future version of the
            // codegen.
            new xrpc_1.XrpcClient((url, init)=>{
                return (0, this.fetch)(new URL(url, this.serviceUrl), init);
            }, lexicons_1.schemas))
        });
    }
    get did() {
        return this.session?.did;
    }
    get dispatchUrl() {
        return this.pdsUrl || this.serviceUrl;
    }
    get hasSession() {
        return !!this.session;
    }
    /**
     * Sets a WhatWG "fetch()" function to be used for making HTTP requests.
     */ setFetch(fetch = globalThis.fetch) {
        this.fetch = fetch;
    }
    async fetchHandler(url, init) {
        // wait for any active session-refreshes to finish
        await this.refreshSessionPromise;
        const initialUri = new URL(url, this.dispatchUrl);
        const initialReq = new Request(initialUri, init);
        const initialToken = this.session?.accessJwt;
        if (!initialToken || initialReq.headers.has('authorization')) return (0, this.fetch)(initialReq);
        initialReq.headers.set('authorization', `Bearer ${initialToken}`);
        const initialRes = await (0, this.fetch)(initialReq);
        if (!this.session?.refreshJwt) return initialRes;
        const isExpiredToken = await isErrorResponse(initialRes, [
            400
        ], [
            'ExpiredToken'
        ]);
        if (!isExpiredToken) return initialRes;
        try {
            await this.refreshSession();
        } catch  {
            return initialRes;
        }
        if (init?.signal?.aborted) return initialRes;
        // The stream was already consumed. We cannot retry the request. A solution
        // would be to tee() the input stream but that would bufferize the entire
        // stream in memory which can lead to memory starvation. Instead, we will
        // return the original response and let the calling code handle retries.
        if (ReadableStream && init?.body instanceof ReadableStream) return initialRes;
        // Return initial "ExpiredToken" response if the session was not refreshed.
        const updatedToken = this.session?.accessJwt;
        if (!updatedToken || updatedToken === initialToken) return initialRes;
        // Make sure the initial request is cancelled to avoid leaking resources
        // (NodeJS 👀): https://undici.nodejs.org/#/?id=garbage-collection
        await initialRes.body?.cancel();
        // We need to re-compute the URI in case the PDS endpoint has changed
        const updatedUri = new URL(url, this.dispatchUrl);
        const updatedReq = new Request(updatedUri, init);
        updatedReq.headers.set('authorization', `Bearer ${updatedToken}`);
        return await (0, this.fetch)(updatedReq);
    }
    /**
     * Create a new account and hydrate its session in this agent.
     */ async createAccount(data, opts) {
        try {
            const res = await this.server.createAccount(data, opts);
            this.session = {
                accessJwt: res.data.accessJwt,
                refreshJwt: res.data.refreshJwt,
                handle: res.data.handle,
                did: res.data.did,
                email: data.email,
                emailConfirmed: false,
                emailAuthFactor: false,
                active: true
            };
            this.persistSession?.('create', this.session);
            this._updateApiEndpoint(res.data.didDoc);
            return res;
        } catch (e) {
            this.session = undefined;
            this.persistSession?.('create-failed', undefined);
            throw e;
        }
    }
    /**
     * Start a new session with this agent.
     */ async login(opts) {
        try {
            const res = await this.server.createSession({
                identifier: opts.identifier,
                password: opts.password,
                authFactorToken: opts.authFactorToken,
                allowTakendown: opts.allowTakendown
            });
            this.session = {
                accessJwt: res.data.accessJwt,
                refreshJwt: res.data.refreshJwt,
                handle: res.data.handle,
                did: res.data.did,
                email: res.data.email,
                emailConfirmed: res.data.emailConfirmed,
                emailAuthFactor: res.data.emailAuthFactor,
                active: res.data.active ?? true,
                status: res.data.status
            };
            this._updateApiEndpoint(res.data.didDoc);
            this.persistSession?.('create', this.session);
            return res;
        } catch (e) {
            this.session = undefined;
            this.persistSession?.('create-failed', undefined);
            throw e;
        }
    }
    async createCustomJwtSession(opts) {
        try {
            const res = await this.server.createCustomJwtSession({
                verifier: opts.verifier,
                options: {
                    id_token: opts.idToken
                }
            });
            this.session = {
                accessJwt: res.data.accessJwt,
                refreshJwt: res.data.refreshJwt,
                handle: res.data.handle,
                did: res.data.did,
                email: undefined,
                emailConfirmed: undefined,
                emailAuthFactor: undefined,
                active: true,
                status: undefined,
                isNew: res.data.isNew
            };
            this._updateApiEndpoint(res.data.didDoc);
            this.persistSession?.('create', this.session);
            return res;
        } catch (e) {
            this.session = undefined;
            this.persistSession?.('create-failed', undefined);
            throw e;
        }
    }
    async logout() {
        if (this.session) try {
            await this.server.deleteSession(undefined, {
                headers: {
                    authorization: `Bearer ${this.session.refreshJwt}`
                }
            });
        } catch  {
        // Ignore errors
        } finally{
            this.session = undefined;
            this.persistSession?.('expired', undefined);
        }
    }
    /**
     * Resume a pre-existing session with this agent.
     */ async resumeSession(session) {
        this.session = session;
        try {
            const res = await this.server.getSession(undefined, {
                headers: {
                    authorization: `Bearer ${session.accessJwt}`
                }
            }).catch(async (err)=>{
                if (err instanceof xrpc_1.XRPCError && [
                    'ExpiredToken',
                    'InvalidToken'
                ].includes(err.error) && session.refreshJwt) try {
                    const res = await this.server.refreshSession(undefined, {
                        headers: {
                            authorization: `Bearer ${session.refreshJwt}`
                        }
                    });
                    session.accessJwt = res.data.accessJwt;
                    session.refreshJwt = res.data.refreshJwt;
                    return this.server.getSession(undefined, {
                        headers: {
                            authorization: `Bearer ${session.accessJwt}`
                        }
                    });
                } catch  {
                // Noop, we'll throw the original error
                }
                throw err;
            });
            if (res.data.did !== session.did) throw new xrpc_1.XRPCError(xrpc_1.ResponseType.InvalidRequest, 'Invalid session', 'InvalidDID');
            session.email = res.data.email;
            session.handle = res.data.handle;
            session.emailConfirmed = res.data.emailConfirmed;
            session.emailAuthFactor = res.data.emailAuthFactor;
            session.active = res.data.active ?? true;
            session.status = res.data.status;
            // protect against concurrent session updates
            if (this.session === session) {
                this._updateApiEndpoint(res.data.didDoc);
                this.persistSession?.('update', session);
            }
            return res;
        } catch (err) {
            // protect against concurrent session updates
            if (this.session === session) {
                if (err instanceof xrpc_1.XRPCError && [
                    'ExpiredToken',
                    'InvalidToken'
                ].includes(err.error)) {
                    this.session = undefined;
                    this.persistSession?.('expired', undefined);
                } else {
                    // Assume the problem is transient and the session can be reused later.
                    this.session = session;
                    this.persistSession?.('network-error', session);
                }
            }
            throw err;
        }
    }
    /**
     * Internal helper to refresh sessions
     * - Wraps the actual implementation in a promise-guard to ensure only
     *   one refresh is attempted at a time.
     */ async refreshSession() {
        return this.refreshSessionPromise || (this.refreshSessionPromise = this._refreshSessionInner().finally(()=>{
            this.refreshSessionPromise = undefined;
        }));
    }
    /**
     * Internal helper to refresh sessions (actual behavior)
     */ async _refreshSessionInner() {
        if (!this.session?.refreshJwt) return;
        try {
            const res = await this.server.refreshSession(undefined, {
                headers: {
                    authorization: `Bearer ${this.session.refreshJwt}`
                }
            });
            // succeeded, update the session
            this.session = {
                ...this.session,
                accessJwt: res.data.accessJwt,
                refreshJwt: res.data.refreshJwt,
                handle: res.data.handle,
                did: res.data.did
            };
            this._updateApiEndpoint(res.data.didDoc);
            this.persistSession?.('update', this.session);
        } catch (err) {
            if (err instanceof xrpc_1.XRPCError && err.error && [
                'ExpiredToken',
                'InvalidToken'
            ].includes(err.error)) {
                // failed due to a bad refresh token
                this.session = undefined;
                this.persistSession?.('expired', undefined);
            }
        // else: other failures should be ignored - the issue will
        // propagate in the _dispatch() second attempt to run
        // the request
        }
    }
    /**
     * Helper to update the pds endpoint dynamically.
     *
     * The session methods (create, resume, refresh) may respond with the user's
     * did document which contains the user's canonical PDS endpoint. That endpoint
     * may differ from the endpoint used to contact the server. We capture that
     * PDS endpoint and update the client to use that given endpoint for future
     * requests. (This helps ensure smooth migrations between PDSes, especially
     * when the PDSes are operated by a single org.)
     */ _updateApiEndpoint(didDoc) {
        if ((0, common_web_1.isValidDidDoc)(didDoc)) {
            const endpoint = (0, common_web_1.getPdsEndpoint)(didDoc);
            this.pdsUrl = endpoint ? new URL(endpoint) : undefined;
        } else // If the did doc is invalid, we clear the pdsUrl (should never happen)
        this.pdsUrl = undefined;
    }
}
exports.CredentialSession = CredentialSession;
function isErrorObject(v) {
    return xrpc_1.errorResponseBody.safeParse(v).success;
}
async function isErrorResponse(response, status, errorNames) {
    if (!status.includes(response.status)) return false;
    // Some engines (react-native 👀) don't expose a response.body property...
    // if (!response.body) return false
    try {
        const json = await peekJson(response, 10240);
        return isErrorObject(json) && errorNames.includes(json.error);
    } catch (err) {
        return false;
    }
}
async function peekJson(response, maxSize = Infinity) {
    if (extractType(response) !== 'application/json') throw new Error('Not JSON');
    if (extractLength(response) > maxSize) throw new Error('Response too large');
    return response.clone().json();
}
function extractLength({ headers }) {
    return headers.get('Content-Length') ? Number(headers.get('Content-Length')) : NaN;
}
function extractType({ headers }) {
    return headers.get('Content-Type')?.split(';')[0]?.trim();
}

},{"96ed7501ed2528f4":"jDe1t","ad8314730d43cce9":"3J4dg","768097a580e96e16":"fw3SJ","2f7abfa9748257d7":"a8Anh","dde7df7bfa9dfd37":"4ClhN"}],"9wJoT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BskyAgent = void 0;
const atp_agent_1 = require("e58e21ca5318a81a");
/** @deprecated use {@link AtpAgent} instead */ class BskyAgent extends atp_agent_1.AtpAgent {
    clone() {
        if (this.constructor === BskyAgent) {
            const agent = new BskyAgent(this.sessionManager);
            return this.copyInto(agent);
        }
        // sub-classes should override this method
        throw new TypeError('Cannot clone a subclass of BskyAgent');
    }
}
exports.BskyAgent = BskyAgent;

},{"e58e21ca5318a81a":"aIvB3"}],"6wNSF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQuery", ()=>useQuery);
// src/useQuery.ts
var _queryCore = require("@tanstack/query-core");
var _useBaseQueryJs = require("./useBaseQuery.js");
"use client";
function useQuery(options, queryClient) {
    return (0, _useBaseQueryJs.useBaseQuery)(options, (0, _queryCore.QueryObserver), queryClient);
}

},{"@tanstack/query-core":"9Ggij","./useBaseQuery.js":"f4jba","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"9Ggij":[function(require,module,exports,__globalThis) {
// src/queryObserver.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryObserver", ()=>QueryObserver);
var _focusManagerJs = require("./focusManager.js");
var _notifyManagerJs = require("./notifyManager.js");
var _queryJs = require("./query.js");
var _subscribableJs = require("./subscribable.js");
var _thenableJs = require("./thenable.js");
var _utilsJs = require("./utils.js");
var _timeoutManagerJs = require("./timeoutManager.js");
var QueryObserver = class extends (0, _subscribableJs.Subscribable) {
    constructor(client, options){
        super();
        this.options = options;
        this.#client = client;
        this.#selectError = null;
        this.#currentThenable = (0, _thenableJs.pendingThenable)();
        this.bindMethods();
        this.setOptions(options);
    }
    #client;
    #currentQuery = void 0;
    #currentQueryInitialState = void 0;
    #currentResult = void 0;
    #currentResultState;
    #currentResultOptions;
    #currentThenable;
    #selectError;
    #selectFn;
    #selectResult;
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    #lastQueryWithDefinedData;
    #staleTimeoutId;
    #refetchIntervalId;
    #currentRefetchInterval;
    #trackedProps = /* @__PURE__ */ new Set();
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.#currentQuery.addObserver(this);
            if (shouldFetchOnMount(this.#currentQuery, this.options)) this.#executeFetch();
            else this.updateResult();
            this.#updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#clearStaleTimeout();
        this.#clearRefetchInterval();
        this.#currentQuery.removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = this.#currentQuery;
        this.options = this.#client.defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, _utilsJs.resolveEnabled)(this.options.enabled, this.#currentQuery) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        this.#updateQuery();
        this.#currentQuery.setOptions(this.options);
        if (prevOptions._defaulted && !(0, _utilsJs.shallowEqualObjects)(this.options, prevOptions)) this.#client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.#currentQuery,
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && shouldFetchOptionally(this.#currentQuery, prevQuery, this.options, prevOptions)) this.#executeFetch();
        this.updateResult();
        if (mounted && (this.#currentQuery !== prevQuery || (0, _utilsJs.resolveEnabled)(this.options.enabled, this.#currentQuery) !== (0, _utilsJs.resolveEnabled)(prevOptions.enabled, this.#currentQuery) || (0, _utilsJs.resolveStaleTime)(this.options.staleTime, this.#currentQuery) !== (0, _utilsJs.resolveStaleTime)(prevOptions.staleTime, this.#currentQuery))) this.#updateStaleTimeout();
        const nextRefetchInterval = this.#computeRefetchInterval();
        if (mounted && (this.#currentQuery !== prevQuery || (0, _utilsJs.resolveEnabled)(this.options.enabled, this.#currentQuery) !== (0, _utilsJs.resolveEnabled)(prevOptions.enabled, this.#currentQuery) || nextRefetchInterval !== this.#currentRefetchInterval)) this.#updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.#client.getQueryCache().build(this.#client, options);
        const result = this.createResult(query, options);
        if (shouldAssignObserverCurrentProperties(this, result)) {
            this.#currentResult = result;
            this.#currentResultOptions = this.options;
            this.#currentResultState = this.#currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked?.(key);
                if (key === "promise") {
                    this.trackProp("data");
                    if (!this.options.experimental_prefetchInRender && this.#currentThenable.status === "pending") this.#currentThenable.reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                }
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        this.#trackedProps.add(key);
    }
    getCurrentQuery() {
        return this.#currentQuery;
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.#client.defaultQueryOptions(options);
        const query = this.#client.getQueryCache().build(this.#client, defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return this.#executeFetch({
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return this.#currentResult;
        });
    }
    #executeFetch(fetchOptions) {
        this.#updateQuery();
        let promise = this.#currentQuery.fetch(this.options, fetchOptions);
        if (!fetchOptions?.throwOnError) promise = promise.catch((0, _utilsJs.noop));
        return promise;
    }
    #updateStaleTimeout() {
        this.#clearStaleTimeout();
        const staleTime = (0, _utilsJs.resolveStaleTime)(this.options.staleTime, this.#currentQuery);
        if ((0, _utilsJs.isServer) || this.#currentResult.isStale || !(0, _utilsJs.isValidTimeout)(staleTime)) return;
        const time = (0, _utilsJs.timeUntilStale)(this.#currentResult.dataUpdatedAt, staleTime);
        const timeout = time + 1;
        this.#staleTimeoutId = (0, _timeoutManagerJs.timeoutManager).setTimeout(()=>{
            if (!this.#currentResult.isStale) this.updateResult();
        }, timeout);
    }
    #computeRefetchInterval() {
        return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.#currentQuery) : this.options.refetchInterval) ?? false;
    }
    #updateRefetchInterval(nextInterval) {
        this.#clearRefetchInterval();
        this.#currentRefetchInterval = nextInterval;
        if ((0, _utilsJs.isServer) || (0, _utilsJs.resolveEnabled)(this.options.enabled, this.#currentQuery) === false || !(0, _utilsJs.isValidTimeout)(this.#currentRefetchInterval) || this.#currentRefetchInterval === 0) return;
        this.#refetchIntervalId = (0, _timeoutManagerJs.timeoutManager).setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, _focusManagerJs.focusManager).isFocused()) this.#executeFetch();
        }, this.#currentRefetchInterval);
    }
    #updateTimers() {
        this.#updateStaleTimeout();
        this.#updateRefetchInterval(this.#computeRefetchInterval());
    }
    #clearStaleTimeout() {
        if (this.#staleTimeoutId) {
            (0, _timeoutManagerJs.timeoutManager).clearTimeout(this.#staleTimeoutId);
            this.#staleTimeoutId = void 0;
        }
    }
    #clearRefetchInterval() {
        if (this.#refetchIntervalId) {
            (0, _timeoutManagerJs.timeoutManager).clearInterval(this.#refetchIntervalId);
            this.#refetchIntervalId = void 0;
        }
    }
    createResult(query, options) {
        const prevQuery = this.#currentQuery;
        const prevOptions = this.options;
        const prevResult = this.#currentResult;
        const prevResultState = this.#currentResultState;
        const prevResultOptions = this.#currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.#currentQueryInitialState;
        const { state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, _queryJs.fetchState)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error, errorUpdatedAt, status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if (prevResult?.isPlaceholderData && options.placeholderData === prevResultOptions?.placeholderData) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(this.#lastQueryWithDefinedData?.state.data, this.#lastQueryWithDefinedData) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, _utilsJs.replaceData)(prevResult?.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === prevResultState?.data && options.select === this.#selectFn) data = this.#selectResult;
            else try {
                this.#selectFn = options.select;
                data = options.select(data);
                data = (0, _utilsJs.replaceData)(prevResult?.data, data, options);
                this.#selectResult = data;
                this.#selectError = null;
            } catch (selectError) {
                this.#selectError = selectError;
            }
        }
        if (this.#selectError) {
            error = this.#selectError;
            data = this.#selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status,
            fetchStatus: newState.fetchStatus,
            isPending,
            isSuccess: status === "success",
            isError,
            isInitialLoading: isLoading,
            isLoading,
            data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error,
            errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: isStale(query, options),
            refetch: this.refetch,
            promise: this.#currentThenable,
            isEnabled: (0, _utilsJs.resolveEnabled)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const hasResultData = nextResult.data !== void 0;
            const isErrorWithoutData = nextResult.status === "error" && !hasResultData;
            const finalizeThenableIfPossible = (thenable)=>{
                if (isErrorWithoutData) thenable.reject(nextResult.error);
                else if (hasResultData) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = this.#currentThenable = nextResult.promise = (0, _thenableJs.pendingThenable)();
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = this.#currentThenable;
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (isErrorWithoutData || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (!isErrorWithoutData || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = this.#currentResult;
        const nextResult = this.createResult(this.#currentQuery, this.options);
        this.#currentResultState = this.#currentQuery.state;
        this.#currentResultOptions = this.options;
        if (this.#currentResultState.data !== void 0) this.#lastQueryWithDefinedData = this.#currentQuery;
        if ((0, _utilsJs.shallowEqualObjects)(nextResult, prevResult)) return;
        this.#currentResult = nextResult;
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.#trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? this.#trackedProps);
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys(this.#currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.#currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        this.#notify({
            listeners: shouldNotifyListeners()
        });
    }
    #updateQuery() {
        const query = this.#client.getQueryCache().build(this.#client, this.options);
        if (query === this.#currentQuery) return;
        const prevQuery = this.#currentQuery;
        this.#currentQuery = query;
        this.#currentQueryInitialState = query.state;
        if (this.hasListeners()) {
            prevQuery?.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) this.#updateTimers();
    }
    #notify(notifyOptions) {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
            this.#client.getQueryCache().notify({
                query: this.#currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
};
function shouldLoadOnMount(query, options) {
    return (0, _utilsJs.resolveEnabled)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
    return shouldLoadOnMount(query, options) || query.state.data !== void 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
    if ((0, _utilsJs.resolveEnabled)(options.enabled, query) !== false && (0, _utilsJs.resolveStaleTime)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && isStale(query, options);
    }
    return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, _utilsJs.resolveEnabled)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
    return (0, _utilsJs.resolveEnabled)(options.enabled, query) !== false && query.isStaleByTime((0, _utilsJs.resolveStaleTime)(options.staleTime, query));
}
function shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, _utilsJs.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}

},{"./focusManager.js":"jcD1E","./notifyManager.js":"aC2BC","./query.js":"e11ao","./subscribable.js":"cneRW","./thenable.js":"c8p1T","./utils.js":"3hA14","./timeoutManager.js":"7ukjm","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"jcD1E":[function(require,module,exports,__globalThis) {
// src/focusManager.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManager", ()=>FocusManager);
parcelHelpers.export(exports, "focusManager", ()=>focusManager);
var _subscribableJs = require("./subscribable.js");
var _utilsJs = require("./utils.js");
var FocusManager = class extends (0, _subscribableJs.Subscribable) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (!(0, _utilsJs.isServer) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var focusManager = new FocusManager();

},{"./subscribable.js":"cneRW","./utils.js":"3hA14","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"cneRW":[function(require,module,exports,__globalThis) {
// src/subscribable.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscribable", ()=>Subscribable);
var Subscribable = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"3hA14":[function(require,module,exports,__globalThis) {
// src/utils.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addConsumeAwareSignal", ()=>addConsumeAwareSignal);
parcelHelpers.export(exports, "addToEnd", ()=>addToEnd);
parcelHelpers.export(exports, "addToStart", ()=>addToStart);
parcelHelpers.export(exports, "ensureQueryFn", ()=>ensureQueryFn);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "hashKey", ()=>hashKey);
parcelHelpers.export(exports, "hashQueryKeyByOptions", ()=>hashQueryKeyByOptions);
parcelHelpers.export(exports, "isPlainArray", ()=>isPlainArray);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isServer", ()=>isServer);
parcelHelpers.export(exports, "isValidTimeout", ()=>isValidTimeout);
parcelHelpers.export(exports, "keepPreviousData", ()=>keepPreviousData);
parcelHelpers.export(exports, "matchMutation", ()=>matchMutation);
parcelHelpers.export(exports, "matchQuery", ()=>matchQuery);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "partialMatchKey", ()=>partialMatchKey);
parcelHelpers.export(exports, "replaceData", ()=>replaceData);
parcelHelpers.export(exports, "replaceEqualDeep", ()=>replaceEqualDeep);
parcelHelpers.export(exports, "resolveEnabled", ()=>resolveEnabled);
parcelHelpers.export(exports, "resolveStaleTime", ()=>resolveStaleTime);
parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects);
parcelHelpers.export(exports, "shouldThrowError", ()=>shouldThrowError);
parcelHelpers.export(exports, "skipToken", ()=>skipToken);
parcelHelpers.export(exports, "sleep", ()=>sleep);
parcelHelpers.export(exports, "timeUntilStale", ()=>timeUntilStale);
var _timeoutManagerJs = require("./timeoutManager.js");
var isServer = typeof window === "undefined" || "Deno" in globalThis;
function noop() {}
function functionalUpdate(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function isValidTimeout(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function timeUntilStale(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function resolveStaleTime(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function resolveEnabled(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function matchQuery(filters, query) {
    const { type = "all", exact, fetchStatus, predicate, queryKey, stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) return false;
        } else if (!partialMatchKey(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function matchMutation(filters, mutation) {
    const { exact, status, predicate, mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if (hashKey(mutation.options.mutationKey) !== hashKey(mutationKey)) return false;
        } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function hashQueryKeyByOptions(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || hashKey;
    return hashFn(queryKey);
}
function hashKey(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>isPlainObject(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function partialMatchKey(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>partialMatchKey(a[key], b[key]));
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty;
function replaceEqualDeep(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = isPlainArray(a) && isPlainArray(b);
    if (!array && !(isPlainObject(a) && isPlainObject(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = replaceEqualDeep(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function shallowEqualObjects(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isPlainArray(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function sleep(timeout) {
    return new Promise((resolve)=>{
        (0, _timeoutManagerJs.timeoutManager).setTimeout(resolve, timeout);
    });
}
function replaceData(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return replaceEqualDeep(prevData, data);
    }
    return data;
}
function keepPreviousData(previousData) {
    return previousData;
}
function addToEnd(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function addToStart(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var skipToken = /* @__PURE__ */ Symbol();
function ensureQueryFn(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === skipToken) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function shouldThrowError(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
function addConsumeAwareSignal(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ??= getSignal();
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}

},{"./timeoutManager.js":"7ukjm","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"7ukjm":[function(require,module,exports,__globalThis) {
// src/timeoutManager.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutManager", ()=>TimeoutManager);
parcelHelpers.export(exports, "defaultTimeoutProvider", ()=>defaultTimeoutProvider);
parcelHelpers.export(exports, "systemSetTimeoutZero", ()=>systemSetTimeoutZero);
parcelHelpers.export(exports, "timeoutManager", ()=>timeoutManager);
var defaultTimeoutProvider = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var TimeoutManager = class {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support ReturnType<typeof setTimeout>, which is infeasible.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    #provider = defaultTimeoutProvider;
    #providerCalled = false;
    setTimeoutProvider(provider) {
        this.#provider = provider;
    }
    setTimeout(callback, delay) {
        return this.#provider.setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        this.#provider.clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return this.#provider.setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        this.#provider.clearInterval(intervalId);
    }
};
var timeoutManager = new TimeoutManager();
function systemSetTimeoutZero(callback) {
    setTimeout(callback, 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"aC2BC":[function(require,module,exports,__globalThis) {
// src/notifyManager.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNotifyManager", ()=>createNotifyManager);
parcelHelpers.export(exports, "defaultScheduler", ()=>defaultScheduler);
parcelHelpers.export(exports, "notifyManager", ()=>notifyManager);
var _timeoutManagerJs = require("./timeoutManager.js");
var defaultScheduler = (0, _timeoutManagerJs.systemSetTimeoutZero);
function createNotifyManager() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = defaultScheduler;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var notifyManager = createNotifyManager();

},{"./timeoutManager.js":"7ukjm","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"e11ao":[function(require,module,exports,__globalThis) {
// src/query.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Query", ()=>Query);
parcelHelpers.export(exports, "fetchState", ()=>fetchState);
var _utilsJs = require("./utils.js");
var _notifyManagerJs = require("./notifyManager.js");
var _retryerJs = require("./retryer.js");
var _removableJs = require("./removable.js");
var Query = class extends (0, _removableJs.Removable) {
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        return this.#retryer?.promise;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState(successState(defaultState.data, defaultState.dataUpdatedAt));
                this.#initialState = defaultState;
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, _utilsJs.replaceData)(this.state.data, newData, this.options);
        this.#dispatch({
            data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.#dispatch({
            type: "setState",
            state,
            setStateOptions
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, _utilsJs.noop)).catch((0, _utilsJs.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.#initialState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, _utilsJs.resolveEnabled)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, _utilsJs.skipToken) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, _utilsJs.resolveStaleTime)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, _utilsJs.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle" && // If the promise in the retryer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        this.#retryer?.status() !== "rejected") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, _utilsJs.ensureQueryFn)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: this.#client,
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: this.#client,
                state: this.state,
                fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        this.options.behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        this.#retryer = (0, _retryerJs.createRetryer)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, _retryerJs.CancelledError) && error.revert) this.setState({
                    ...this.#revertState,
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount,
                    error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        try {
            const data = await this.#retryer.start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            this.#cache.config.onSuccess?.(data, this);
            this.#cache.config.onSettled?.(data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, _retryerJs.CancelledError)) {
                if (error.silent) return this.#retryer.promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            this.#dispatch({
                type: "error",
                error
            });
            this.#cache.config.onError?.(error, this);
            this.#cache.config.onSettled?.(this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...fetchState(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    const newState = {
                        ...state,
                        ...successState(action.data, action.dataUpdatedAt),
                        dataUpdateCount: state.dataUpdateCount + 1,
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                    this.#revertState = action.manual ? newState : void 0;
                    return newState;
                case "error":
                    const error = action.error;
                    return {
                        ...state,
                        error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error",
                        // flag existing data as invalidated if we get a background error
                        // note that "no data" always means stale so we can set unconditionally here
                        isInvalidated: true
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action
            });
        });
    }
};
function fetchState(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, _retryerJs.canFetch)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function successState(data, dataUpdatedAt) {
    return {
        data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}

},{"./utils.js":"3hA14","./notifyManager.js":"aC2BC","./retryer.js":"eChHV","./removable.js":"legwp","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"eChHV":[function(require,module,exports,__globalThis) {
// src/retryer.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>CancelledError);
parcelHelpers.export(exports, "canFetch", ()=>canFetch);
parcelHelpers.export(exports, "createRetryer", ()=>createRetryer);
parcelHelpers.export(exports, "isCancelledError", ()=>isCancelledError);
var _focusManagerJs = require("./focusManager.js");
var _onlineManagerJs = require("./onlineManager.js");
var _thenableJs = require("./thenable.js");
var _utilsJs = require("./utils.js");
function defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function canFetch(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, _onlineManagerJs.onlineManager).isOnline() : true;
}
var CancelledError = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function isCancelledError(value) {
    return value instanceof CancelledError;
}
function createRetryer(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, _thenableJs.pendingThenable)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            const error = new CancelledError(cancelOptions);
            reject(error);
            config.onCancel?.(error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, _focusManagerJs.focusManager).isFocused() && (config.networkMode === "always" || (0, _onlineManagerJs.onlineManager).isOnline()) && config.canRun();
    const canStart = ()=>canFetch(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved()) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved()) return;
            const retry = config.retry ?? ((0, _utilsJs.isServer) ? 0 : 3);
            const retryDelay = config.retryDelay ?? defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, _utilsJs.sleep)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel,
        continue: ()=>{
            continueFn?.();
            return thenable;
        },
        cancelRetry,
        continueRetry,
        canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}

},{"./focusManager.js":"jcD1E","./onlineManager.js":"hc8g4","./thenable.js":"c8p1T","./utils.js":"3hA14","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"hc8g4":[function(require,module,exports,__globalThis) {
// src/onlineManager.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnlineManager", ()=>OnlineManager);
parcelHelpers.export(exports, "onlineManager", ()=>onlineManager);
var _subscribableJs = require("./subscribable.js");
var _utilsJs = require("./utils.js");
var OnlineManager = class extends (0, _subscribableJs.Subscribable) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (!(0, _utilsJs.isServer) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var onlineManager = new OnlineManager();

},{"./subscribable.js":"cneRW","./utils.js":"3hA14","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"c8p1T":[function(require,module,exports,__globalThis) {
// src/thenable.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pendingThenable", ()=>pendingThenable);
parcelHelpers.export(exports, "tryResolveSync", ()=>tryResolveSync);
var _utilsJs = require("./utils.js");
function pendingThenable() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason
        });
        reject(reason);
    };
    return thenable;
}
function tryResolveSync(promise) {
    let data;
    promise.then((result)=>{
        data = result;
        return result;
    }, (0, _utilsJs.noop))?.catch((0, _utilsJs.noop));
    if (data !== void 0) return {
        data
    };
    return void 0;
}

},{"./utils.js":"3hA14","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"legwp":[function(require,module,exports,__globalThis) {
// src/removable.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Removable", ()=>Removable);
var _timeoutManagerJs = require("./timeoutManager.js");
var _utilsJs = require("./utils.js");
var Removable = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, _utilsJs.isValidTimeout)(this.gcTime)) this.#gcTimeout = (0, _timeoutManagerJs.timeoutManager).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, _utilsJs.isServer) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout) {
            (0, _timeoutManagerJs.timeoutManager).clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};

},{"./timeoutManager.js":"7ukjm","./utils.js":"3hA14","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"f4jba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBaseQuery", ()=>useBaseQuery);
// src/useBaseQuery.ts
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _queryClientProviderJs = require("./QueryClientProvider.js");
var _queryErrorResetBoundaryJs = require("./QueryErrorResetBoundary.js");
var _errorBoundaryUtilsJs = require("./errorBoundaryUtils.js");
var _isRestoringProviderJs = require("./IsRestoringProvider.js");
var _suspenseJs = require("./suspense.js");
"use client";
function useBaseQuery(options, Observer, queryClient) {
    const isRestoring = (0, _isRestoringProviderJs.useIsRestoring)();
    const errorResetBoundary = (0, _queryErrorResetBoundaryJs.useQueryErrorResetBoundary)();
    const client = (0, _queryClientProviderJs.useQueryClient)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    client.getDefaultOptions().queries?._experimental_beforeQuery?.(defaultedOptions);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, _suspenseJs.ensureSuspenseTimers)(defaultedOptions);
    (0, _errorBoundaryUtilsJs.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary, query);
    (0, _errorBoundaryUtilsJs.useClearResetErrorBoundary)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = _react.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    _react.useSyncExternalStore(_react.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)) : (0, _queryCore.noop);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    _react.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, _suspenseJs.shouldSuspend)(defaultedOptions, result)) throw (0, _suspenseJs.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
    if ((0, _errorBoundaryUtilsJs.getHasError)({
        result,
        errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    client.getDefaultOptions().queries?._experimental_afterQuery?.(defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, _queryCore.isServer) && (0, _suspenseJs.willFetch)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, _suspenseJs.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        query?.promise;
        promise?.catch((0, _queryCore.noop)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

},{"react":"4i8qR","@tanstack/query-core":[["isServer","3hA14"],["noop","3hA14"],["notifyManager","aC2BC"]],"./QueryClientProvider.js":"ixWwS","./QueryErrorResetBoundary.js":"cPiRd","./errorBoundaryUtils.js":"khHeJ","./IsRestoringProvider.js":"tipww","./suspense.js":"KDpwe","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"ixWwS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClientContext", ()=>QueryClientContext);
parcelHelpers.export(exports, "QueryClientProvider", ()=>QueryClientProvider);
parcelHelpers.export(exports, "useQueryClient", ()=>useQueryClient);
// src/QueryClientProvider.tsx
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var QueryClientContext = _react.createContext(void 0);
var useQueryClient = (queryClient)=>{
    const client = _react.useContext(QueryClientContext);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var QueryClientProvider = ({ client, children })=>{
    _react.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(QueryClientContext.Provider, {
        value: client,
        children
    });
};

},{"react":"4i8qR","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"cPiRd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>QueryErrorResetBoundary);
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>useQueryErrorResetBoundary);
// src/QueryErrorResetBoundary.tsx
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var QueryErrorResetBoundaryContext = _react.createContext(createValue());
var useQueryErrorResetBoundary = ()=>_react.useContext(QueryErrorResetBoundaryContext);
var QueryErrorResetBoundary = ({ children })=>{
    const [value] = _react.useState(()=>createValue());
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(QueryErrorResetBoundaryContext.Provider, {
        value,
        children: typeof children === "function" ? children(value) : children
    });
};

},{"react":"4i8qR","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"khHeJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensurePreventErrorBoundaryRetry", ()=>ensurePreventErrorBoundaryRetry);
parcelHelpers.export(exports, "getHasError", ()=>getHasError);
parcelHelpers.export(exports, "useClearResetErrorBoundary", ()=>useClearResetErrorBoundary);
// src/errorBoundaryUtils.ts
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
"use client";
var ensurePreventErrorBoundaryRetry = (options, errorResetBoundary, query)=>{
    const throwOnError = query?.state.error && typeof options.throwOnError === "function" ? (0, _queryCore.shouldThrowError)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || options.experimental_prefetchInRender || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var useClearResetErrorBoundary = (errorResetBoundary)=>{
    _react.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var getHasError = ({ result, errorResetBoundary, throwOnError, query, suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, _queryCore.shouldThrowError)(throwOnError, [
        result.error,
        query
    ]));
};

},{"react":"4i8qR","@tanstack/query-core":"3hA14","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"tipww":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsRestoringProvider", ()=>IsRestoringProvider);
parcelHelpers.export(exports, "useIsRestoring", ()=>useIsRestoring);
// src/IsRestoringProvider.ts
var _react = require("react");
"use client";
var IsRestoringContext = _react.createContext(false);
var useIsRestoring = ()=>_react.useContext(IsRestoringContext);
var IsRestoringProvider = IsRestoringContext.Provider;

},{"react":"4i8qR","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"KDpwe":[function(require,module,exports,__globalThis) {
// src/suspense.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultThrowOnError", ()=>defaultThrowOnError);
parcelHelpers.export(exports, "ensureSuspenseTimers", ()=>ensureSuspenseTimers);
parcelHelpers.export(exports, "fetchOptimistic", ()=>fetchOptimistic);
parcelHelpers.export(exports, "shouldSuspend", ()=>shouldSuspend);
parcelHelpers.export(exports, "willFetch", ()=>willFetch);
var defaultThrowOnError = (_error, query)=>query.state.data === void 0;
var ensureSuspenseTimers = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var willFetch = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var shouldSuspend = (defaultedOptions, result)=>defaultedOptions?.suspense && result.isPending;
var fetchOptimistic = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"1W5BW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Comment", ()=>Comment);
var _jsxRuntime = require("react/jsx-runtime");
var _api = require("@bluesky-social/api");
var _bluesky = require("../../lib/bluesky");
var _icon = require("../Icon");
function Comment({ comment, depth }) {
    const author = comment.post.author;
    const postId = comment.post.uri.split("/").pop();
    const postUrl = `https://bsky.app/profile/${author.handle}/post/${postId}`;
    const postDate = _bluesky.getPostDate(comment.post.record);
    const replies = (comment.replies ?? []).filter((0, _api.AppBskyFeedDefs).isThreadViewPost);
    const likeCount = comment.post.likeCount ?? 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-col gap-2 min-w-0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                href: postUrl,
                target: "_blank",
                rel: "noreferrer noopener",
                className: "flex gap-3 rounded-lg p-2 hover:bg-slate-200 dark:hover:bg-slate-800 active:bg-slate-200 dark:active:bg-slate-800 transition-colors min-w-0",
                children: [
                    author.avatar ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: author.avatar,
                        alt: `${author.handle} avatar`,
                        className: "w-10 h-10 rounded-full shrink-0"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "w-10 h-10 rounded-full bg-slate-300 dark:bg-slate-600 shrink-0"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex flex-col gap-1 min-w-0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex flex-col md:flex-row gap-x-2 items-baseline text-sm overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "font-semibold truncate max-w-full",
                                        children: author.displayName ?? author.handle
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "text-slate-500 dark:text-slate-400 truncate max-w-full",
                                        children: [
                                            "@",
                                            author.handle
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "text-sm whitespace-pre-wrap break-words",
                                children: _bluesky.getPostText(comment.post.record)
                            }),
                            postDate && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "text-sm text-slate-500 dark:text-slate-400 flex flex-row flex-wrap items-center gap-x-1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icon.Heart, {
                                        className: "size-5 pb-0.5"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: likeCount
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "\xb7"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: postDate.toLocaleTimeString("en-US", {
                                            hour: "numeric",
                                            minute: "2-digit"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "\xb7"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: postDate.toLocaleDateString("en-US", {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            depth >= 5 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                className: "text-sm font-bold pl-3 text-slate-900 dark:text-sky-500",
                href: postUrl,
                children: "View more replies..."
            }),
            replies.length > 0 && depth < 5 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex-col gap-2 pl-6 border-l-2 border-slate-300 dark:border-slate-700",
                children: replies.map((reply)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Comment, {
                        comment: reply,
                        depth: depth + 1
                    }, reply.post.uri))
            })
        ]
    });
}

},{"react/jsx-runtime":"fjRB4","@bluesky-social/api":"4a5dq","../../lib/bluesky":"kP1JS","../Icon":"9esDg","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"1WlVG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CommentCTA", ()=>CommentCTA);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("../Icon");
function CommentCTA({ bskyPostId, identifier = "micahcantor.bsky.social" }) {
    const postUrl = `https://bsky.app/profile/${identifier}/post/${bskyPostId}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: postUrl,
        target: "_blank",
        rel: "noreferrer noopener",
        className: "block p-4 rounded-lg bg-sky-100 dark:bg-sky-950 hover:bg-sky-200 dark:hover:bg-sky-900 active:bg-sky-200 dark:active:bg-sky-900 transition-colors",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "flex items-center gap-3",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-8 h-8 rounded shrink-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icon.Bluesky, {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "text-slate-800 dark:text-slate-300",
                    children: "Join the conversation by replying on Bluesky..."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "w-5 h-5 shrink-0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icon.RightArrow, {})
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"fjRB4","../Icon":"9esDg","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"gArlo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CommentControl", ()=>CommentControl);
var _jsxRuntime = require("react/jsx-runtime");
var _reactPopover = require("@radix-ui/react-popover");
var _reactRadioGroup = require("@radix-ui/react-radio-group");
var _iconBox = require("../IconBox");
var _icon = require("../Icon");
"use client";
function CommentControl({ sort, onSortChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactPopover.Root, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactPopover.Trigger, {
                asChild: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconBox.IconBox), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icon.SlidersVertical, {
                            className: "size-6"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactPopover.Portal, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactPopover.Content, {
                    className: "bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md py-3 p-4 shadow-md",
                    sideOffset: 5,
                    align: "end",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "text-sm font-medium text-slate-700 dark:text-slate-300 mb-2",
                            children: "Sort by"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactRadioGroup.Root, {
                            value: sort,
                            onValueChange: (value)=>onSortChange(value),
                            className: "flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(RadioItem, {
                                    value: "top",
                                    label: "Top comments first"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(RadioItem, {
                                    value: "newest",
                                    label: "Newest comments first"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(RadioItem, {
                                    value: "oldest",
                                    label: "Oldest comments first"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function RadioItem({ value, label }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactRadioGroup.Item, {
                value: value,
                id: value,
                className: "w-4 h-4 rounded-full border border-slate-300 dark:border-slate-600 data-[state=checked]:border-slate-500 dark:data-[state=checked]:border-slate-400 bg-white dark:bg-slate-700",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactRadioGroup.Indicator, {
                    className: "flex items-center justify-center w-full h-full relative after:content-[''] after:block after:w-2 after:h-2 after:rounded-full after:bg-slate-600 dark:after:bg-slate-300"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: value,
                className: "text-sm text-slate-600 dark:text-slate-400 cursor-pointer",
                children: label
            })
        ]
    });
}

},{"react/jsx-runtime":"fjRB4","@radix-ui/react-popover":"la4Vt","@radix-ui/react-radio-group":"9hoRk","../IconBox":"iRimy","../Icon":"9esDg","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"la4Vt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Anchor", ()=>Anchor2);
parcelHelpers.export(exports, "Arrow", ()=>Arrow2);
parcelHelpers.export(exports, "Close", ()=>Close);
parcelHelpers.export(exports, "Content", ()=>Content2);
parcelHelpers.export(exports, "Popover", ()=>Popover);
parcelHelpers.export(exports, "PopoverAnchor", ()=>PopoverAnchor);
parcelHelpers.export(exports, "PopoverArrow", ()=>PopoverArrow);
parcelHelpers.export(exports, "PopoverClose", ()=>PopoverClose);
parcelHelpers.export(exports, "PopoverContent", ()=>PopoverContent);
parcelHelpers.export(exports, "PopoverPortal", ()=>PopoverPortal);
parcelHelpers.export(exports, "PopoverTrigger", ()=>PopoverTrigger);
parcelHelpers.export(exports, "Portal", ()=>Portal);
parcelHelpers.export(exports, "Root", ()=>Root2);
parcelHelpers.export(exports, "Trigger", ()=>Trigger);
parcelHelpers.export(exports, "createPopoverScope", ()=>createPopoverScope);
// src/popover.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactDismissableLayer = require("@radix-ui/react-dismissable-layer");
var _reactFocusGuards = require("@radix-ui/react-focus-guards");
var _reactFocusScope = require("@radix-ui/react-focus-scope");
var _reactId = require("@radix-ui/react-id");
var _reactPopper = require("@radix-ui/react-popper");
var _reactPortal = require("@radix-ui/react-portal");
var _reactPresence = require("@radix-ui/react-presence");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactSlot = require("@radix-ui/react-slot");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _ariaHidden = require("aria-hidden");
var _reactRemoveScroll = require("react-remove-scroll");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var POPOVER_NAME = "Popover";
var [createPopoverContext, createPopoverScope] = (0, _reactContext.createContextScope)(POPOVER_NAME, [
    (0, _reactPopper.createPopperScope)
]);
var usePopperScope = (0, _reactPopper.createPopperScope)();
var [PopoverProvider, usePopoverContext] = createPopoverContext(POPOVER_NAME);
var Popover = (props)=>{
    const { __scopePopover, children, open: openProp, defaultOpen, onOpenChange, modal = false } = props;
    const popperScope = usePopperScope(__scopePopover);
    const triggerRef = _react.useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = _react.useState(false);
    const [open, setOpen] = (0, _reactUseControllableState.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: POPOVER_NAME
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Root, {
        ...popperScope,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopoverProvider, {
            scope: __scopePopover,
            contentId: (0, _reactId.useId)(),
            triggerRef,
            open,
            onOpenChange: setOpen,
            onOpenToggle: _react.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
                setOpen
            ]),
            hasCustomAnchor,
            onCustomAnchorAdd: _react.useCallback(()=>setHasCustomAnchor(true), []),
            onCustomAnchorRemove: _react.useCallback(()=>setHasCustomAnchor(false), []),
            modal,
            children
        })
    });
};
Popover.displayName = POPOVER_NAME;
var ANCHOR_NAME = "PopoverAnchor";
var PopoverAnchor = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopover, ...anchorProps } = props;
    const context = usePopoverContext(ANCHOR_NAME, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    const { onCustomAnchorAdd, onCustomAnchorRemove } = context;
    _react.useEffect(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Anchor, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
PopoverAnchor.displayName = ANCHOR_NAME;
var TRIGGER_NAME = "PopoverTrigger";
var PopoverTrigger = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopover, ...triggerProps } = props;
    const context = usePopoverContext(TRIGGER_NAME, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    const composedTriggerRef = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.triggerRef);
    const trigger = /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, _primitive.composeEventHandlers)(props.onClick, context.onOpenToggle)
    });
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Anchor, {
        asChild: true,
        ...popperScope,
        children: trigger
    });
});
PopoverTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME = "PopoverPortal";
var [PortalProvider, usePortalContext] = createPopoverContext(PORTAL_NAME, {
    forceMount: void 0
});
var PopoverPortal = (props)=>{
    const { __scopePopover, forceMount, children, container } = props;
    const context = usePopoverContext(PORTAL_NAME, __scopePopover);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(PortalProvider, {
        scope: __scopePopover,
        forceMount,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPortal.Portal), {
                asChild: true,
                container,
                children
            })
        })
    });
};
PopoverPortal.displayName = PORTAL_NAME;
var CONTENT_NAME = "PopoverContent";
var PopoverContent = _react.forwardRef((props, forwardedRef)=>{
    const portalContext = usePortalContext(CONTENT_NAME, props.__scopePopover);
    const { forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = usePopoverContext(CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopoverContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopoverContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
PopoverContent.displayName = CONTENT_NAME;
var Slot = (0, _reactSlot.createSlot)("PopoverContent.RemoveScroll");
var PopoverContentModal = _react.forwardRef((props, forwardedRef)=>{
    const context = usePopoverContext(CONTENT_NAME, props.__scopePopover);
    const contentRef = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, contentRef);
    const isRightClickOutsideRef = _react.useRef(false);
    _react.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, _ariaHidden.hideOthers)(content);
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactRemoveScroll.RemoveScroll), {
        as: Slot,
        allowPinchZoom: true,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopoverContentImpl, {
            ...props,
            ref: composedRefs,
            trapFocus: context.open,
            disableOutsidePointerEvents: true,
            onCloseAutoFocus: (0, _primitive.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
                event.preventDefault();
                if (!isRightClickOutsideRef.current) context.triggerRef.current?.focus();
            }),
            onPointerDownOutside: (0, _primitive.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
                const originalEvent = event.detail.originalEvent;
                const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
                const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
                isRightClickOutsideRef.current = isRightClick;
            }, {
                checkForDefaultPrevented: false
            }),
            onFocusOutside: (0, _primitive.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault(), {
                checkForDefaultPrevented: false
            })
        })
    });
});
var PopoverContentNonModal = _react.forwardRef((props, forwardedRef)=>{
    const context = usePopoverContext(CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = _react.useRef(false);
    const hasPointerDownOutsideRef = _react.useRef(false);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopoverContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var PopoverContentImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopover, trapFocus, onOpenAutoFocus, onCloseAutoFocus, disableOutsidePointerEvents, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, ...contentProps } = props;
    const context = usePopoverContext(CONTENT_NAME, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    (0, _reactFocusGuards.useFocusGuards)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactFocusScope.FocusScope), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactDismissableLayer.DismissableLayer), {
            asChild: true,
            disableOutsidePointerEvents,
            onInteractOutside,
            onEscapeKeyDown,
            onPointerDownOutside,
            onFocusOutside,
            onDismiss: ()=>context.onOpenChange(false),
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Content, {
                "data-state": getState(context.open),
                role: "dialog",
                id: context.contentId,
                ...popperScope,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...contentProps.style,
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
            })
        })
    });
});
var CLOSE_NAME = "PopoverClose";
var PopoverClose = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopover, ...closeProps } = props;
    const context = usePopoverContext(CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, _primitive.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    });
});
PopoverClose.displayName = CLOSE_NAME;
var ARROW_NAME = "PopoverArrow";
var PopoverArrow = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopover, ...arrowProps } = props;
    const popperScope = usePopperScope(__scopePopover);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactPopper.Arrow, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
PopoverArrow.displayName = ARROW_NAME;
function getState(open) {
    return open ? "open" : "closed";
}
var Root2 = Popover;
var Anchor2 = PopoverAnchor;
var Trigger = PopoverTrigger;
var Portal = PopoverPortal;
var Content2 = PopoverContent;
var Close = PopoverClose;
var Arrow2 = PopoverArrow;

},{"react":"4i8qR","@radix-ui/primitive":"8ExnN","@radix-ui/react-compose-refs":"8uudx","@radix-ui/react-context":"4XnVE","@radix-ui/react-dismissable-layer":"iRrzx","@radix-ui/react-focus-guards":"1Phlk","@radix-ui/react-focus-scope":"9osAj","@radix-ui/react-id":"2u585","@radix-ui/react-popper":"4O3UC","@radix-ui/react-portal":"8Vtez","@radix-ui/react-presence":"i8eJ5","@radix-ui/react-primitive":"hqWvk","@radix-ui/react-slot":"assO6","@radix-ui/react-use-controllable-state":"h0Ybr","aria-hidden":"7Kmcb","react-remove-scroll":[["RemoveScroll","c3zlx","default"]],"react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"8ExnN":[function(require,module,exports,__globalThis) {
// src/primitive.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
parcelHelpers.export(exports, "composeEventHandlers", ()=>composeEventHandlers);
parcelHelpers.export(exports, "getActiveElement", ()=>getActiveElement);
parcelHelpers.export(exports, "getOwnerDocument", ()=>getOwnerDocument);
parcelHelpers.export(exports, "getOwnerWindow", ()=>getOwnerWindow);
parcelHelpers.export(exports, "isFrame", ()=>isFrame);
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function getOwnerWindow(element) {
    if (!canUseDOM) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function getOwnerDocument(element) {
    if (!canUseDOM) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function getActiveElement(node, activeDescendant = false) {
    const { activeElement } = getOwnerDocument(node);
    if (!activeElement?.nodeName) return null;
    if (isFrame(activeElement) && activeElement.contentDocument) return getActiveElement(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = getOwnerDocument(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function isFrame(element) {
    return element.tagName === "IFRAME";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"8uudx":[function(require,module,exports,__globalThis) {
// packages/react/compose-refs/src/compose-refs.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeRefs", ()=>composeRefs);
parcelHelpers.export(exports, "useComposedRefs", ()=>useComposedRefs);
var _react = require("react");
function setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function composeRefs(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else setRef(refs[i], null);
            }
        };
    };
}
function useComposedRefs(...refs) {
    return _react.useCallback(composeRefs(...refs), refs);
}

},{"react":"4i8qR","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"4XnVE":[function(require,module,exports,__globalThis) {
// packages/react/context/src/create-context.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContext", ()=>createContext2);
parcelHelpers.export(exports, "createContextScope", ()=>createContextScope);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function createContext2(rootComponentName, defaultContext) {
    const Context = _react.createContext(defaultContext);
    const Provider = (props)=>{
        const { children, ...context } = props;
        const value = _react.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Context.Provider, {
            value,
            children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = _react.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function createContextScope(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = _react.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope, children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = _react.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Context.Provider, {
                value,
                children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = _react.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return _react.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return _react.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return _react.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}

},{"react":"4i8qR","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"iRrzx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Branch", ()=>Branch);
parcelHelpers.export(exports, "DismissableLayer", ()=>DismissableLayer);
parcelHelpers.export(exports, "DismissableLayerBranch", ()=>DismissableLayerBranch);
parcelHelpers.export(exports, "Root", ()=>Root);
// src/dismissable-layer.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
var _reactUseEscapeKeydown = require("@radix-ui/react-use-escape-keydown");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var DISMISSABLE_LAYER_NAME = "DismissableLayer";
var CONTEXT_UPDATE = "dismissableLayer.update";
var POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var originalBodyPointerEvents;
var DismissableLayerContext = _react.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var DismissableLayer = _react.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents = false, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, onDismiss, ...layerProps } = props;
    const context = _react.useContext(DismissableLayerContext);
    const [node, setNode] = _react.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = _react.useState({});
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, _reactUseEscapeKeydown.useEscapeKeydown)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    _react.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    _react.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    _react.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener(CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, _primitive.composeEventHandlers)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, _primitive.composeEventHandlers)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, _primitive.composeEventHandlers)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
DismissableLayer.displayName = DISMISSABLE_LAYER_NAME;
var BRANCH_NAME = "DismissableLayerBranch";
var DismissableLayerBranch = _react.forwardRef((props, forwardedRef)=>{
    const context = _react.useContext(DismissableLayerContext);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    _react.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        ...props,
        ref: composedRefs
    });
});
DismissableLayerBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, _reactUseCallbackRef.useCallbackRef)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = _react.useRef(false);
    const handleClickRef = _react.useRef(()=>{});
    _react.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    handleAndDispatchCustomEvent(POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, _reactUseCallbackRef.useCallbackRef)(onFocusOutside);
    const isFocusInsideReactTreeRef = _react.useRef(false);
    _react.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function dispatchUpdate() {
    const event = new CustomEvent(CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, _reactPrimitive.dispatchDiscreteCustomEvent)(target, event);
    else target.dispatchEvent(event);
}
var Root = DismissableLayer;
var Branch = DismissableLayerBranch;

},{"react":"4i8qR","@radix-ui/primitive":"8ExnN","@radix-ui/react-primitive":"hqWvk","@radix-ui/react-compose-refs":"8uudx","@radix-ui/react-use-callback-ref":"4hioM","@radix-ui/react-use-escape-keydown":"3DMBj","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"hqWvk":[function(require,module,exports,__globalThis) {
// src/primitive.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Primitive", ()=>Primitive);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "dispatchDiscreteCustomEvent", ()=>dispatchDiscreteCustomEvent);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactSlot = require("@radix-ui/react-slot");
var _jsxRuntime = require("react/jsx-runtime");
var NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var Primitive = NODES.reduce((primitive, node)=>{
    const Slot = (0, _reactSlot.createSlot)(`Primitive.${node}`);
    const Node = _react.forwardRef((props, forwardedRef)=>{
        const { asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function dispatchDiscreteCustomEvent(target, event) {
    if (target) _reactDom.flushSync(()=>target.dispatchEvent(event));
}
var Root = Primitive;

},{"react":"4i8qR","react-dom":"jcHde","@radix-ui/react-slot":"assO6","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"assO6":[function(require,module,exports,__globalThis) {
// src/slot.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Root", ()=>Slot);
parcelHelpers.export(exports, "Slot", ()=>Slot);
parcelHelpers.export(exports, "Slottable", ()=>Slottable);
parcelHelpers.export(exports, "createSlot", ()=>createSlot);
parcelHelpers.export(exports, "createSlottable", ()=>createSlottable);
var _react = require("react");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _jsxRuntime = require("react/jsx-runtime");
// @__NO_SIDE_EFFECTS__
function createSlot(ownerName) {
    const SlotClone = /* @__PURE__ */ createSlotClone(ownerName);
    const Slot2 = _react.forwardRef((props, forwardedRef)=>{
        const { children, ...slotProps } = props;
        const childrenArray = _react.Children.toArray(children);
        const slottable = childrenArray.find(isSlottable);
        if (slottable) {
            const newElement = slottable.props.children;
            const newChildren = childrenArray.map((child)=>{
                if (child === slottable) {
                    if (_react.Children.count(newElement) > 1) return _react.Children.only(null);
                    return _react.isValidElement(newElement) ? newElement.props.children : null;
                } else return child;
            });
            return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SlotClone, {
                ...slotProps,
                ref: forwardedRef,
                children: _react.isValidElement(newElement) ? _react.cloneElement(newElement, void 0, newChildren) : null
            });
        }
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children
        });
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var Slot = /* @__PURE__ */ createSlot("Slot");
// @__NO_SIDE_EFFECTS__
function createSlotClone(ownerName) {
    const SlotClone = _react.forwardRef((props, forwardedRef)=>{
        const { children, ...slotProps } = props;
        if (_react.isValidElement(children)) {
            const childrenRef = getElementRef(children);
            const props2 = mergeProps(slotProps, children.props);
            if (children.type !== _react.Fragment) props2.ref = forwardedRef ? (0, _reactComposeRefs.composeRefs)(forwardedRef, childrenRef) : childrenRef;
            return _react.cloneElement(children, props2);
        }
        return _react.Children.count(children) > 1 ? _react.Children.only(null) : null;
    });
    SlotClone.displayName = `${ownerName}.SlotClone`;
    return SlotClone;
}
var SLOTTABLE_IDENTIFIER = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function createSlottable(ownerName) {
    const Slottable2 = ({ children })=>{
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children
        });
    };
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var Slottable = /* @__PURE__ */ createSlottable("Slottable");
function isSlottable(child) {
    return _react.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === SLOTTABLE_IDENTIFIER;
}
function mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}

},{"react":"4i8qR","@radix-ui/react-compose-refs":"8uudx","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"4hioM":[function(require,module,exports,__globalThis) {
// packages/react/use-callback-ref/src/use-callback-ref.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallbackRef", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef(callback) {
    const callbackRef = _react.useRef(callback);
    _react.useEffect(()=>{
        callbackRef.current = callback;
    });
    return _react.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}

},{"react":"4i8qR","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"3DMBj":[function(require,module,exports,__globalThis) {
// packages/react/use-escape-keydown/src/use-escape-keydown.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEscapeKeydown", ()=>useEscapeKeydown);
var _react = require("react");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
function useEscapeKeydown(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, _reactUseCallbackRef.useCallbackRef)(onEscapeKeyDownProp);
    _react.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}

},{"react":"4i8qR","@radix-ui/react-use-callback-ref":"4hioM","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"1Phlk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusGuards", ()=>FocusGuards);
parcelHelpers.export(exports, "Root", ()=>FocusGuards);
parcelHelpers.export(exports, "useFocusGuards", ()=>useFocusGuards);
// src/focus-guards.tsx
var _react = require("react");
"use client";
var count = 0;
function FocusGuards(props) {
    useFocusGuards();
    return props.children;
}
function useFocusGuards() {
    _react.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? createFocusGuard());
        count++;
        return ()=>{
            if (count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            count--;
        };
    }, []);
}
function createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}

},{"react":"4i8qR","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"9osAj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusScope", ()=>FocusScope);
parcelHelpers.export(exports, "Root", ()=>Root);
// src/focus-scope.tsx
var _react = require("react");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var FOCUS_SCOPE_NAME = "FocusScope";
var FocusScope = _react.forwardRef((props, forwardedRef)=>{
    const { loop = false, trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = _react.useState(null);
    const onMountAutoFocus = (0, _reactUseCallbackRef.useCallbackRef)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, _reactUseCallbackRef.useCallbackRef)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node)=>setContainer(node));
    const focusScope = _react.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    _react.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    _react.useEffect(()=>{
        if (container) {
            focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
                container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    focusFirst(removeLinks(getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) focus(container);
                }
            }
            return ()=>{
                container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
                    container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = _react.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst(candidates, { select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        focus(candidate, {
            select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function getTabbableEdges(container) {
    const candidates = getTabbableCandidates(container);
    const first = findVisible(candidates, container);
    const last = findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function findVisible(elements, container) {
    for (const element of elements){
        if (!isHidden(element, {
            upTo: container
        })) return element;
    }
}
function isHidden(node, { upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function focus(element, { select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && isSelectableInput(element) && select) element.select();
    }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var Root = FocusScope;

},{"react":"4i8qR","@radix-ui/react-compose-refs":"8uudx","@radix-ui/react-primitive":"hqWvk","@radix-ui/react-use-callback-ref":"4hioM","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"2u585":[function(require,module,exports,__globalThis) {
// packages/react/id/src/id.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", ()=>useId);
var _react = require("react");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var useReactId = _react[" useId ".trim().toString()] || (()=>void 0);
var count = 0;
function useId(deterministicId) {
    const [id, setId] = _react.useState(useReactId());
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String(count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}

},{"react":"4i8qR","@radix-ui/react-use-layout-effect":"FQtyW","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"FQtyW":[function(require,module,exports,__globalThis) {
// packages/react/use-layout-effect/src/use-layout-effect.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutEffect", ()=>useLayoutEffect2);
var _react = require("react");
var useLayoutEffect2 = globalThis?.document ? _react.useLayoutEffect : ()=>{};

},{"react":"4i8qR","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"4O3UC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALIGN_OPTIONS", ()=>ALIGN_OPTIONS);
parcelHelpers.export(exports, "Anchor", ()=>Anchor);
parcelHelpers.export(exports, "Arrow", ()=>Arrow);
parcelHelpers.export(exports, "Content", ()=>Content);
parcelHelpers.export(exports, "Popper", ()=>Popper);
parcelHelpers.export(exports, "PopperAnchor", ()=>PopperAnchor);
parcelHelpers.export(exports, "PopperArrow", ()=>PopperArrow);
parcelHelpers.export(exports, "PopperContent", ()=>PopperContent);
parcelHelpers.export(exports, "Root", ()=>Root2);
parcelHelpers.export(exports, "SIDE_OPTIONS", ()=>SIDE_OPTIONS);
parcelHelpers.export(exports, "createPopperScope", ()=>createPopperScope);
// src/popper.tsx
var _react = require("react");
var _reactDom = require("@floating-ui/react-dom");
var _reactArrow = require("@radix-ui/react-arrow");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _reactUseSize = require("@radix-ui/react-use-size");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var SIDE_OPTIONS = [
    "top",
    "right",
    "bottom",
    "left"
];
var ALIGN_OPTIONS = [
    "start",
    "center",
    "end"
];
var POPPER_NAME = "Popper";
var [createPopperContext, createPopperScope] = (0, _reactContext.createContextScope)(POPPER_NAME);
var [PopperProvider, usePopperContext] = createPopperContext(POPPER_NAME);
var Popper = (props)=>{
    const { __scopePopper, children } = props;
    const [anchor, setAnchor] = _react.useState(null);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopperProvider, {
        scope: __scopePopper,
        anchor,
        onAnchorChange: setAnchor,
        children
    });
};
Popper.displayName = POPPER_NAME;
var ANCHOR_NAME = "PopperAnchor";
var PopperAnchor = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopper, virtualRef, ...anchorProps } = props;
    const context = usePopperContext(ANCHOR_NAME, __scopePopper);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const anchorRef = _react.useRef(null);
    _react.useEffect(()=>{
        const previousAnchor = anchorRef.current;
        anchorRef.current = virtualRef?.current || ref.current;
        if (previousAnchor !== anchorRef.current) context.onAnchorChange(anchorRef.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
PopperAnchor.displayName = ANCHOR_NAME;
var CONTENT_NAME = "PopperContent";
var [PopperContentProvider, useContentContext] = createPopperContext(CONTENT_NAME);
var PopperContent = _react.forwardRef((props, forwardedRef)=>{
    const { __scopePopper, side = "bottom", sideOffset = 0, align = "center", alignOffset = 0, arrowPadding = 0, avoidCollisions = true, collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky = "partial", hideWhenDetached = false, updatePositionStrategy = "optimized", onPlaced, ...contentProps } = props;
    const context = usePopperContext(CONTENT_NAME, __scopePopper);
    const [content, setContent] = _react.useState(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = _react.useState(null);
    const arrowSize = (0, _reactUseSize.useSize)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter(isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs, floatingStyles, placement, isPositioned, middlewareData } = (0, _reactDom.useFloating)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, _reactDom.autoUpdate)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, _reactDom.offset)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, _reactDom.shift)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, _reactDom.limitShift)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, _reactDom.flip)({
                ...detectOverflowOptions
            }),
            (0, _reactDom.size)({
                ...detectOverflowOptions,
                apply: ({ elements, rects, availableWidth, availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, _reactDom.arrow)({
                element: arrow,
                padding: arrowPadding
            }),
            transformOrigin({
                arrowWidth,
                arrowHeight
            }),
            hideWhenDetached && (0, _reactDom.hide)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, _reactUseCallbackRef.useCallbackRef)(onPlaced);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = _react.useState();
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(PopperContentProvider, {
            scope: __scopePopper,
            placedSide,
            onArrowChange: setArrow,
            arrowX,
            arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
PopperContent.displayName = CONTENT_NAME;
var ARROW_NAME = "PopperArrow";
var OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var PopperArrow = _react.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper, ...arrowProps } = props;
    const contentContext = useContentContext(ARROW_NAME, __scopePopper);
    const baseSide = OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactArrow.Root, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
PopperArrow.displayName = ARROW_NAME;
function isNotNull(value) {
    return value !== null;
}
var transformOrigin = (options)=>({
        name: "transformOrigin",
        options,
        fn (data) {
            const { placement, rects, middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x,
                    y
                }
            };
        }
    });
function getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var Root2 = Popper;
var Anchor = PopperAnchor;
var Content = PopperContent;
var Arrow = PopperArrow;

},{"react":"4i8qR","@floating-ui/react-dom":[["arrow","f2K26"],["flip","f2K26"],["hide","f2K26"],["limitShift","f2K26"],["offset","f2K26"],["shift","f2K26"],["size","f2K26"],["useFloating","f2K26"],["autoUpdate","15q84"]],"@radix-ui/react-arrow":"edftC","@radix-ui/react-compose-refs":"8uudx","@radix-ui/react-context":"4XnVE","@radix-ui/react-primitive":"hqWvk","@radix-ui/react-use-callback-ref":"4hioM","@radix-ui/react-use-layout-effect":"FQtyW","@radix-ui/react-use-size":"bx8xe","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"f2K26":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoUpdate", ()=>(0, _dom.autoUpdate));
parcelHelpers.export(exports, "computePosition", ()=>(0, _dom.computePosition));
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _dom.detectOverflow));
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "platform", ()=>(0, _dom.platform));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
parcelHelpers.export(exports, "useFloating", ()=>useFloating);
var _dom = require("@floating-ui/dom");
var _react = require("react");
var _reactDom = require("react-dom");
var isClient = typeof document !== 'undefined';
var noop = function noop() {};
var index = isClient ? (0, _react.useLayoutEffect) : noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
    const dpr = getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
    const ref = _react.useRef(value);
    index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function useFloating(options) {
    if (options === void 0) options = {};
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform = true, whileElementsMounted, open } = options;
    const [data, setData] = _react.useState({
        x: 0,
        y: 0,
        strategy,
        placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = _react.useState(middleware);
    if (!deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = _react.useState(null);
    const [_floating, _setFloating] = _react.useState(null);
    const setReference = _react.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = _react.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = _react.useRef(null);
    const floatingRef = _react.useRef(null);
    const dataRef = _react.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = useLatestRef(whileElementsMounted);
    const platformRef = useLatestRef(platform);
    const openRef = useLatestRef(open);
    const update = _react.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement,
            strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, _dom.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                _reactDom.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = _react.useRef(false);
    index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = _react.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference,
            setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = _react.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = _react.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = roundByDPR(elements.floating, data.x);
        const y = roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return _react.useMemo(()=>({
            ...data,
            update,
            refs,
            elements,
            floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options,
        fn (state) {
            const { element, padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, _dom.arrow)({
                    element: element.current,
                    padding
                }).fn(state);
                return {};
            }
            if (element) return (0, _dom.arrow)({
                element,
                padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (options, deps)=>({
        ...(0, _dom.offset)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (options, deps)=>({
        ...(0, _dom.shift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (options, deps)=>({
        ...(0, _dom.limitShift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (options, deps)=>({
        ...(0, _dom.flip)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (options, deps)=>({
        ...(0, _dom.size)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (options, deps)=>({
        ...(0, _dom.autoPlacement)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (options, deps)=>({
        ...(0, _dom.hide)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (options, deps)=>({
        ...(0, _dom.inline)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options, deps)=>({
        ...arrow$1(options),
        options: [
            options,
            deps
        ]
    });

},{"@floating-ui/dom":"15q84","react":"4i8qR","react-dom":"jcHde","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"15q84":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "platform", ()=>platform);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
    const leftScroll = (0, _dom.getNodeScroll)(element).scrollLeft;
    if (!rect) return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x,
        y
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if ((0, _dom.isHTMLElement)(offsetParent)) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = (0, _dom.getDocumentElement)(element);
    const scroll = (0, _dom.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === 'rtl') x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width,
        height,
        x,
        y
    };
}
const absoluteOrFixed = /*#__PURE__*/ new Set([
    'absolute',
    'fixed'
]);
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, _utils.max)(rect.top, accRect.top);
        accRect.right = (0, _utils.min)(rect.right, accRect.right);
        accRect.bottom = (0, _utils.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _utils.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, _dom.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        let svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === 'rtl';
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
function rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left, top, width, height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === 'function', layoutShift = typeof IntersectionObserver === 'function', animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...(0, _dom.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, _core.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

},{"@floating-ui/core":"6GaAw","@floating-ui/utils":"lTY5q","@floating-ui/utils/dom":"8jZjY","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"6GaAw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name, fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = 'clippingAncestors', rootBoundary = 'viewport', elementContext = 'floating', altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === 'floating' ? {
        x,
        y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements,
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: 'arrow',
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = 'bestFit', fallbackAxisSideDirection = 'none', flipAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, _utils.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, _utils.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options,
        async fn (state) {
            const { rects } = state;
            const { strategy = 'referenceHidden', ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top,
                            bottom,
                            left,
                            right,
                            width,
                            height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === 'left';
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top,
                        bottom,
                        left,
                        right,
                        width,
                        height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === 'y';
    const mainAxisMulti = originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options,
        async fn (state) {
            const { x, y, placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            }, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, _utils.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = originSides.has((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === 'y';
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, _utils.max)(overflow.left, 0);
                const xMax = (0, _utils.max)(overflow.right, 0);
                const yMin = (0, _utils.max)(overflow.top, 0);
                const yMax = (0, _utils.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth,
                availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@floating-ui/utils":"lTY5q","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"lTY5q":[function(require,module,exports,__globalThis) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
const sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const alignments = [
    'start',
    'end'
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
    return placement.split('-')[0];
}
function getAlignment(placement) {
    return placement.split('-')[1];
}
function getOppositeAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
    return axis === 'y' ? 'height' : 'width';
}
const yAxisSides = /*#__PURE__*/ new Set([
    'top',
    'bottom'
]);
function getSideAxis(placement) {
    return yAxisSides.has(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>oppositeAlignmentMap[alignment]);
}
const lrPlacement = [
    'left',
    'right'
];
const rlPlacement = [
    'right',
    'left'
];
const tbPlacement = [
    'top',
    'bottom'
];
const btPlacement = [
    'bottom',
    'top'
];
function getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rlPlacement : lrPlacement;
            return isStart ? lrPlacement : rlPlacement;
        case 'left':
        case 'right':
            return isStart ? tbPlacement : btPlacement;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== 'number' ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    const { x, y, width, height } = rect;
    return {
        width,
        height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x,
        y
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"8jZjY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getFrameElement", ()=>getFrameElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isTopLayer", ()=>isTopLayer);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function hasWindow() {
    return typeof window !== 'undefined';
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    if (!hasWindow()) return false;
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
const invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    'inline',
    'contents'
]);
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !invalidOverflowDisplayValues.has(display);
}
const tableElements = /*#__PURE__*/ new Set([
    'table',
    'td',
    'th'
]);
function isTableElement(element) {
    return tableElements.has(getNodeName(element));
}
const topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function isTopLayer(element) {
    return topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const transformProperties = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective'
];
const willChangeValues = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective',
    'filter'
];
const containValues = [
    'paint',
    'layout',
    'strict',
    'content'
];
function isContainingBlock(elementOrCss) {
    const webkit = isWebKit();
    const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return transformProperties.some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || willChangeValues.some((value)=>(css.willChange || '').includes(value)) || containValues.some((value)=>(css.contain || '').includes(value));
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
const lastTraversableNodeNames = /*#__PURE__*/ new Set([
    'html',
    'body',
    '#document'
]);
function isLastTraversableNode(node) {
    return lastTraversableNodeNames.has(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) {
        const frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    }
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"edftC":[function(require,module,exports,__globalThis) {
// src/arrow.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Arrow", ()=>Arrow);
parcelHelpers.export(exports, "Root", ()=>Root);
var _react = require("react");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _jsxRuntime = require("react/jsx-runtime");
var NAME = "Arrow";
var Arrow = _react.forwardRef((props, forwardedRef)=>{
    const { children, width = 10, height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width,
        height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, _jsxRuntime.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
Arrow.displayName = NAME;
var Root = Arrow;

},{"react":"4i8qR","@radix-ui/react-primitive":"hqWvk","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"bx8xe":[function(require,module,exports,__globalThis) {
// packages/react/use-size/src/use-size.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSize", ()=>useSize);
var _react = require("react");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
function useSize(element) {
    const [size, setSize] = _react.useState(void 0);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width,
                    height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}

},{"react":"4i8qR","@radix-ui/react-use-layout-effect":"FQtyW","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"8Vtez":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>Portal);
parcelHelpers.export(exports, "Root", ()=>Root);
// src/portal.tsx
var _react = require("react");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var PORTAL_NAME = "Portal";
var Portal = _react.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = _react.useState(false);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, _reactDomDefault.default).createPortal(/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
Portal.displayName = PORTAL_NAME;
var Root = Portal;

},{"react":"4i8qR","react-dom":"jcHde","@radix-ui/react-primitive":"hqWvk","@radix-ui/react-use-layout-effect":"FQtyW","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"i8eJ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Presence", ()=>Presence);
parcelHelpers.export(exports, "Root", ()=>Root);
// src/presence.tsx
var _react = require("react");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
"use client";
function useStateMachine(initialState, machine) {
    return _react.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var Presence = (props)=>{
    const { present, children } = props;
    const presence = usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : _react.Children.only(children);
    const ref = (0, _reactComposeRefs.useComposedRefs)(presence.ref, getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? _react.cloneElement(child, {
        ref
    }) : null;
};
Presence.displayName = "Presence";
function usePresence(present) {
    const [node, setNode] = _react.useState();
    const stylesRef = _react.useRef(null);
    const prevPresentRef = _react.useRef(present);
    const prevAnimationNameRef = _react.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    _react.useEffect(()=>{
        const currentAnimationName = getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: _react.useCallback((node2)=>{
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function getAnimationName(styles) {
    return styles?.animationName || "none";
}
function getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var Root = Presence;

},{"react":"4i8qR","@radix-ui/react-compose-refs":"8uudx","@radix-ui/react-use-layout-effect":"FQtyW","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"h0Ybr":[function(require,module,exports,__globalThis) {
// src/use-controllable-state.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useControllableState", ()=>useControllableState);
parcelHelpers.export(exports, "useControllableStateReducer", ()=>useControllableStateReducer);
var _react = require("react");
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _reactUseEffectEvent = require("@radix-ui/react-use-effect-event");
var useInsertionEffect = _react[" useInsertionEffect ".trim().toString()] || (0, _reactUseLayoutEffect.useLayoutEffect);
function useControllableState({ prop, defaultProp, onChange = ()=>{}, caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = useUncontrolledState({
        defaultProp,
        onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = _react.useRef(prop !== void 0);
        _react.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = _react.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function useUncontrolledState({ defaultProp, onChange }) {
    const [value, setValue] = _react.useState(defaultProp);
    const prevValueRef = _react.useRef(value);
    const onChangeRef = _react.useRef(onChange);
    useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    _react.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function isFunction(value) {
    return typeof value === "function";
}
var SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function useControllableStateReducer(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp, onChange: onChangeProp, caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, _reactUseEffectEvent.useEffectEvent)(onChangeProp);
    {
        const isControlledRef = _react.useRef(controlledState !== void 0);
        _react.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = _react.useReducer((state2, action)=>{
        if (action.type === SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = _react.useRef(uncontrolledState);
    _react.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        onChange,
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = _react.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    _react.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}

},{"react":"4i8qR","@radix-ui/react-use-layout-effect":"FQtyW","@radix-ui/react-use-effect-event":"2Mg4P","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"2Mg4P":[function(require,module,exports,__globalThis) {
// src/use-effect-event.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEffectEvent", ()=>useEffectEvent);
var _reactUseLayoutEffect = require("@radix-ui/react-use-layout-effect");
var _react = require("react");
var useReactEffectEvent = _react[" useEffectEvent ".trim().toString()];
var useReactInsertionEffect = _react[" useInsertionEffect ".trim().toString()];
function useEffectEvent(callback) {
    if (typeof useReactEffectEvent === "function") return useReactEffectEvent(callback);
    const ref = _react.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof useReactInsertionEffect === "function") useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, _reactUseLayoutEffect.useLayoutEffect)(()=>{
        ref.current = callback;
    });
    return _react.useMemo(()=>(...args)=>ref.current?.(...args), []);
}

},{"@radix-ui/react-use-layout-effect":"FQtyW","react":"4i8qR","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"7Kmcb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hideOthers", ()=>hideOthers);
parcelHelpers.export(exports, "inertOthers", ()=>inertOthers);
parcelHelpers.export(exports, "supportsInert", ()=>supportsInert);
parcelHelpers.export(exports, "suppressOthers", ()=>suppressOthers);
var getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!markerMap[markerName]) markerMap[markerName] = new WeakMap();
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = (counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var inertOthers = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var supportsInert = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var suppressOthers = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"c3zlx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _react = require("react");
var _ui = require("./UI");
var _sidecar = require("./sidecar");
var _sidecarDefault = parcelHelpers.interopDefault(_sidecar);
var ReactRemoveScroll = _react.forwardRef(function(props, ref) {
    return _react.createElement((0, _ui.RemoveScroll), (0, _tslib.__assign)({}, props, {
        ref: ref,
        sideCar: (0, _sidecarDefault.default)
    }));
});
ReactRemoveScroll.classNames = (0, _ui.RemoveScroll).classNames;
exports.default = ReactRemoveScroll;

},{"tslib":"3NQhA","react":"4i8qR","./UI":"8MnXW","./sidecar":"aWS7y","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"3NQhA":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", ()=>__rewriteRelativeImportExtension);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __esDecorate,
    __runInitializers,
    __propKey,
    __setFunctionName,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources,
    __rewriteRelativeImportExtension
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"8MnXW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveScroll", ()=>RemoveScroll);
var _tslib = require("tslib");
var _react = require("react");
var _constants = require("react-remove-scroll-bar/constants");
var _useCallbackRef = require("use-callback-ref");
var _medium = require("./medium");
var nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var RemoveScroll = _react.forwardRef(function(props, parentRef) {
    var ref = _react.useRef(null);
    var _a = _react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, _tslib.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, _useCallbackRef.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), callbacks);
    return _react.createElement(_react.Fragment, null, enabled && _react.createElement(SideCar, {
        sideCar: (0, _medium.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? _react.cloneElement(_react.Children.only(children), (0, _tslib.__assign)((0, _tslib.__assign)({}, containerProps), {
        ref: containerRef
    })) : _react.createElement(Container, (0, _tslib.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
RemoveScroll.classNames = {
    fullWidth: (0, _constants.fullWidthClassName),
    zeroRight: (0, _constants.zeroRightClassName)
};

},{"tslib":"3NQhA","react":"4i8qR","react-remove-scroll-bar/constants":"jdLjs","use-callback-ref":"6Ulwn","./medium":"CyUxK","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"jdLjs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zeroRightClassName", ()=>zeroRightClassName);
parcelHelpers.export(exports, "fullWidthClassName", ()=>fullWidthClassName);
parcelHelpers.export(exports, "noScrollbarsClassName", ()=>noScrollbarsClassName);
parcelHelpers.export(exports, "removedBarSizeVariable", ()=>removedBarSizeVariable);
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"6Ulwn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */ parcelHelpers.export(exports, "useMergeRefs", ()=>useMergeRefs);
var _react = require("react");
var _assignRef = require("./assignRef");
var _useRef = require("./useRef");
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
var currentValues = new WeakMap();
function useMergeRefs(refs, defaultValue) {
    var callbackRef = (0, _useRef.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, _assignRef.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect(function() {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, current_1);
            });
        }
        currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

},{"react":"4i8qR","./assignRef":"5AStu","./useRef":"659wk","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"5AStu":[function(require,module,exports,__globalThis) {
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignRef", ()=>assignRef);
function assignRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"659wk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */ parcelHelpers.export(exports, "useCallbackRef", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef(initialValue, callback) {
    var ref = (0, _react.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

},{"react":"4i8qR","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"CyUxK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "effectCar", ()=>effectCar);
var _useSidecar = require("use-sidecar");
var effectCar = (0, _useSidecar.createSidecarMedium)();

},{"use-sidecar":"1IHHN","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"1IHHN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMedium", ()=>createMedium);
// eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "createSidecarMedium", ()=>createSidecarMedium);
var _tslib = require("tslib");
function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
    if (options === void 0) options = {};
    var medium = innerCreateMedium(null);
    medium.options = (0, _tslib.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

},{"tslib":"3NQhA","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"aWS7y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useSidecar = require("use-sidecar");
var _sideEffect = require("./SideEffect");
var _medium = require("./medium");
exports.default = (0, _useSidecar.exportSidecar)((0, _medium.effectCar), (0, _sideEffect.RemoveScrollSideCar));

},{"use-sidecar":"iY1gn","./SideEffect":"ed7Iv","./medium":"CyUxK","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"iY1gn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exportSidecar", ()=>exportSidecar);
var _tslib = require("tslib");
var _react = require("react");
var SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, _tslib.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return _react.createElement(Target, (0, _tslib.__assign)({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

},{"tslib":"3NQhA","react":"4i8qR","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"ed7Iv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTouchXY", ()=>getTouchXY);
parcelHelpers.export(exports, "getDeltaXY", ()=>getDeltaXY);
parcelHelpers.export(exports, "RemoveScrollSideCar", ()=>RemoveScrollSideCar);
var _tslib = require("tslib");
var _react = require("react");
var _reactRemoveScrollBar = require("react-remove-scroll-bar");
var _reactStyleSingleton = require("react-style-singleton");
var _aggresiveCapture = require("./aggresiveCapture");
var _handleScroll = require("./handleScroll");
var getTouchXY = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var getDeltaXY = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = _react.useRef([]);
    var touchStartRef = _react.useRef([
        0,
        0
    ]);
    var activeAxis = _react.useRef();
    var id = _react.useState(idCounter++)[0];
    var Style = _react.useState((0, _reactStyleSingleton.styleSingleton))[0];
    var lastProps = _react.useRef(props);
    _react.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    _react.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, _tslib.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = _react.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, _handleScroll.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, _handleScroll.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, _handleScroll.handleScroll)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = _react.useCallback(function(_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = _react.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = _react.useCallback(function(event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = _react.useCallback(function(event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = _react.useCallback(function(event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    _react.useEffect(function() {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, _aggresiveCapture.nonPassive));
        document.addEventListener('touchmove', shouldPrevent, (0, _aggresiveCapture.nonPassive));
        document.addEventListener('touchstart', scrollTouchStart, (0, _aggresiveCapture.nonPassive));
        return function() {
            lockStack = lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, _aggresiveCapture.nonPassive));
            document.removeEventListener('touchmove', shouldPrevent, (0, _aggresiveCapture.nonPassive));
            document.removeEventListener('touchstart', scrollTouchStart, (0, _aggresiveCapture.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return _react.createElement(_react.Fragment, null, inert ? _react.createElement(Style, {
        styles: generateStyle(id)
    }) : null, removeScrollBar ? _react.createElement((0, _reactRemoveScrollBar.RemoveScrollBar), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

},{"tslib":"3NQhA","react":"4i8qR","react-remove-scroll-bar":"lUF7S","react-style-singleton":"4vEBD","./aggresiveCapture":"jh42T","./handleScroll":"9uiLM","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"lUF7S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveScrollBar", ()=>(0, _component.RemoveScrollBar));
parcelHelpers.export(exports, "zeroRightClassName", ()=>(0, _constants.zeroRightClassName));
parcelHelpers.export(exports, "fullWidthClassName", ()=>(0, _constants.fullWidthClassName));
parcelHelpers.export(exports, "noScrollbarsClassName", ()=>(0, _constants.noScrollbarsClassName));
parcelHelpers.export(exports, "removedBarSizeVariable", ()=>(0, _constants.removedBarSizeVariable));
parcelHelpers.export(exports, "getGapWidth", ()=>(0, _utils.getGapWidth));
var _component = require("./component");
var _constants = require("./constants");
var _utils = require("./utils");

},{"./component":"f4thp","./constants":"jdLjs","./utils":"4AbX3","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"f4thp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lockAttribute", ()=>lockAttribute);
parcelHelpers.export(exports, "useLockAttribute", ()=>useLockAttribute);
parcelHelpers.export(exports, "RemoveScrollBar", ()=>RemoveScrollBar);
var _react = require("react");
var _reactStyleSingleton = require("react-style-singleton");
var _constants = require("./constants");
var _utils = require("./utils");
var Style = (0, _reactStyleSingleton.styleSingleton)();
var lockAttribute = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, _constants.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, _constants.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.zeroRightClassName), " .").concat((0, _constants.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.fullWidthClassName), " .").concat((0, _constants.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat((0, _constants.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute(lockAttribute) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function() {
    _react.useEffect(function() {
        document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute(lockAttribute);
            else document.body.setAttribute(lockAttribute, newCounter.toString());
        };
    }, []);
};
var RemoveScrollBar = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    useLockAttribute();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = _react.useMemo(function() {
        return (0, _utils.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return _react.createElement(Style, {
        styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};

},{"react":"4i8qR","react-style-singleton":"4vEBD","./constants":"jdLjs","./utils":"4AbX3","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"4vEBD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleSingleton", ()=>(0, _component.styleSingleton));
parcelHelpers.export(exports, "stylesheetSingleton", ()=>(0, _singleton.stylesheetSingleton));
parcelHelpers.export(exports, "styleHookSingleton", ()=>(0, _hook.styleHookSingleton));
var _component = require("./component");
var _singleton = require("./singleton");
var _hook = require("./hook");

},{"./component":"8QSn1","./singleton":"3yJDT","./hook":"kUTM3","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"8QSn1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleSingleton", ()=>styleSingleton);
var _hook = require("./hook");
var styleSingleton = function() {
    var useStyle = (0, _hook.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

},{"./hook":"kUTM3","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"kUTM3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleHookSingleton", ()=>styleHookSingleton);
var _react = require("react");
var _singleton = require("./singleton");
var styleHookSingleton = function() {
    var sheet = (0, _singleton.stylesheetSingleton)();
    return function(styles, isDynamic) {
        _react.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

},{"react":"4i8qR","./singleton":"3yJDT","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"3yJDT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stylesheetSingleton", ()=>stylesheetSingleton);
var _getNonce = require("get-nonce");
function makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, _getNonce.getNonce)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = makeStyleTag()) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

},{"get-nonce":"76P26","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"76P26":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setNonce", ()=>setNonce);
parcelHelpers.export(exports, "getNonce", ()=>getNonce);
var currentNonce;
var setNonce = function(nonce) {
    currentNonce = nonce;
};
var getNonce = function() {
    if (currentNonce) return currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"4AbX3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zeroGap", ()=>zeroGap);
parcelHelpers.export(exports, "getGapWidth", ()=>getGapWidth);
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        parse(left),
        parse(top),
        parse(right)
    ];
};
var getGapWidth = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return zeroGap;
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"jh42T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nonPassive", ()=>nonPassive);
var passiveSupported = false;
if (typeof window !== 'undefined') try {
    var options = Object.defineProperty({}, 'passive', {
        get: function() {
            passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', options, options);
    // @ts-ignore
    window.removeEventListener('test', options, options);
} catch (err) {
    passiveSupported = false;
}
var nonPassive = passiveSupported ? {
    passive: false
} : false;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"9uiLM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "locationCouldBeScrolled", ()=>locationCouldBeScrolled);
parcelHelpers.export(exports, "handleScroll", ()=>handleScroll);
var alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function(node) {
    return elementCanBeScrolled(node, 'overflowY');
};
var elementCouldBeHScrolled = function(node) {
    return elementCanBeScrolled(node, 'overflowX');
};
var locationCouldBeScrolled = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function(axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"9hoRk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Indicator", ()=>Indicator);
parcelHelpers.export(exports, "Item", ()=>Item2);
parcelHelpers.export(exports, "RadioGroup", ()=>RadioGroup);
parcelHelpers.export(exports, "RadioGroupIndicator", ()=>RadioGroupIndicator);
parcelHelpers.export(exports, "RadioGroupItem", ()=>RadioGroupItem);
parcelHelpers.export(exports, "Root", ()=>Root2);
parcelHelpers.export(exports, "createRadioGroupScope", ()=>createRadioGroupScope);
// src/radio-group.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactRovingFocus = require("@radix-ui/react-roving-focus");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactDirection = require("@radix-ui/react-direction");
var _reactUseSize = require("@radix-ui/react-use-size");
var _reactUsePrevious = require("@radix-ui/react-use-previous");
var _reactPresence = require("@radix-ui/react-presence");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var RADIO_NAME = "Radio";
var [createRadioContext, createRadioScope] = (0, _reactContext.createContextScope)(RADIO_NAME);
var [RadioProvider, useRadioContext] = createRadioContext(RADIO_NAME);
var Radio = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeRadio, name, checked = false, required, disabled, value = "on", onCheck, form, ...radioProps } = props;
    const [button, setButton] = _react.useState(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = _react.useRef(false);
    const isFormControl = button ? form || !!button.closest("form") : true;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(RadioProvider, {
        scope: __scopeRadio,
        checked,
        disabled,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).button, {
                type: "button",
                role: "radio",
                "aria-checked": checked,
                "data-state": getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled,
                value,
                ...radioProps,
                ref: composedRefs,
                onClick: (0, _primitive.composeEventHandlers)(props.onClick, (event)=>{
                    if (!checked) onCheck?.();
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, _jsxRuntime.jsx)(RadioBubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name,
                value,
                checked,
                required,
                disabled,
                form,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
Radio.displayName = RADIO_NAME;
var INDICATOR_NAME = "RadioIndicator";
var RadioIndicator = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeRadio, forceMount, ...indicatorProps } = props;
    const context = useRadioContext(INDICATOR_NAME, __scopeRadio);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPresence.Presence), {
        present: forceMount || context.checked,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).span, {
            "data-state": getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef
        })
    });
});
RadioIndicator.displayName = INDICATOR_NAME;
var BUBBLE_INPUT_NAME = "RadioBubbleInput";
var RadioBubbleInput = _react.forwardRef(({ __scopeRadio, control, checked, bubbles = true, ...props }, forwardedRef)=>{
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(ref, forwardedRef);
    const prevChecked = (0, _reactUsePrevious.usePrevious)(checked);
    const controlSize = (0, _reactUseSize.useSize)(control);
    _react.useEffect(()=>{
        const input = ref.current;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).input, {
        type: "radio",
        "aria-hidden": true,
        defaultChecked: checked,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
});
RadioBubbleInput.displayName = BUBBLE_INPUT_NAME;
function getState(checked) {
    return checked ? "checked" : "unchecked";
}
var ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
var RADIO_GROUP_NAME = "RadioGroup";
var [createRadioGroupContext, createRadioGroupScope] = (0, _reactContext.createContextScope)(RADIO_GROUP_NAME, [
    (0, _reactRovingFocus.createRovingFocusGroupScope),
    createRadioScope
]);
var useRovingFocusGroupScope = (0, _reactRovingFocus.createRovingFocusGroupScope)();
var useRadioScope = createRadioScope();
var [RadioGroupProvider, useRadioGroupContext] = createRadioGroupContext(RADIO_GROUP_NAME);
var RadioGroup = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup, name, defaultValue, value: valueProp, required = false, disabled = false, orientation, dir, loop = true, onValueChange, ...groupProps } = props;
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeRadioGroup);
    const direction = (0, _reactDirection.useDirection)(dir);
    const [value, setValue] = (0, _reactUseControllableState.useControllableState)({
        prop: valueProp,
        defaultProp: defaultValue ?? null,
        onChange: onValueChange,
        caller: RADIO_GROUP_NAME
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(RadioGroupProvider, {
        scope: __scopeRadioGroup,
        name,
        required,
        disabled,
        value,
        onValueChange: setValue,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactRovingFocus.Root, {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation,
            dir: direction,
            loop,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
                role: "radiogroup",
                "aria-required": required,
                "aria-orientation": orientation,
                "data-disabled": disabled ? "" : void 0,
                dir: direction,
                ...groupProps,
                ref: forwardedRef
            })
        })
    });
});
RadioGroup.displayName = RADIO_GROUP_NAME;
var ITEM_NAME = "RadioGroupItem";
var RadioGroupItem = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup, disabled, ...itemProps } = props;
    const context = useRadioGroupContext(ITEM_NAME, __scopeRadioGroup);
    const isDisabled = context.disabled || disabled;
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeRadioGroup);
    const radioScope = useRadioScope(__scopeRadioGroup);
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const checked = context.value === itemProps.value;
    const isArrowKeyPressedRef = _react.useRef(false);
    _react.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
        };
        const handleKeyUp = ()=>isArrowKeyPressedRef.current = false;
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_reactRovingFocus.Item, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !isDisabled,
        active: checked,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Radio, {
            disabled: isDisabled,
            required: context.required,
            checked,
            ...radioScope,
            ...itemProps,
            name: context.name,
            ref: composedRefs,
            onCheck: ()=>context.onValueChange(itemProps.value),
            onKeyDown: (0, _primitive.composeEventHandlers)((event)=>{
                if (event.key === "Enter") event.preventDefault();
            }),
            onFocus: (0, _primitive.composeEventHandlers)(itemProps.onFocus, ()=>{
                if (isArrowKeyPressedRef.current) ref.current?.click();
            })
        })
    });
});
RadioGroupItem.displayName = ITEM_NAME;
var INDICATOR_NAME2 = "RadioGroupIndicator";
var RadioGroupIndicator = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup, ...indicatorProps } = props;
    const radioScope = useRadioScope(__scopeRadioGroup);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(RadioIndicator, {
        ...radioScope,
        ...indicatorProps,
        ref: forwardedRef
    });
});
RadioGroupIndicator.displayName = INDICATOR_NAME2;
var Root2 = RadioGroup;
var Item2 = RadioGroupItem;
var Indicator = RadioGroupIndicator;

},{"react":"4i8qR","@radix-ui/primitive":"8ExnN","@radix-ui/react-compose-refs":"8uudx","@radix-ui/react-context":"4XnVE","@radix-ui/react-primitive":"hqWvk","@radix-ui/react-roving-focus":"cu0zG","@radix-ui/react-use-controllable-state":"h0Ybr","@radix-ui/react-direction":"d8jZB","@radix-ui/react-use-size":"bx8xe","@radix-ui/react-use-previous":"2we6D","@radix-ui/react-presence":"i8eJ5","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"cu0zG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "RovingFocusGroup", ()=>RovingFocusGroup);
parcelHelpers.export(exports, "RovingFocusGroupItem", ()=>RovingFocusGroupItem);
parcelHelpers.export(exports, "createRovingFocusGroupScope", ()=>createRovingFocusGroupScope);
// src/roving-focus-group.tsx
var _react = require("react");
var _primitive = require("@radix-ui/primitive");
var _reactCollection = require("@radix-ui/react-collection");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactContext = require("@radix-ui/react-context");
var _reactId = require("@radix-ui/react-id");
var _reactPrimitive = require("@radix-ui/react-primitive");
var _reactUseCallbackRef = require("@radix-ui/react-use-callback-ref");
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _reactDirection = require("@radix-ui/react-direction");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var GROUP_NAME = "RovingFocusGroup";
var [Collection, useCollection, createCollectionScope] = (0, _reactCollection.createCollection)(GROUP_NAME);
var [createRovingFocusGroupContext, createRovingFocusGroupScope] = (0, _reactContext.createContextScope)(GROUP_NAME, [
    createCollectionScope
]);
var [RovingFocusProvider, useRovingFocusContext] = createRovingFocusGroupContext(GROUP_NAME);
var RovingFocusGroup = _react.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
RovingFocusGroup.displayName = GROUP_NAME;
var RovingFocusGroupImpl = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup, orientation, loop = false, dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId, onCurrentTabStopIdChange, onEntryFocus, preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = _react.useRef(null);
    const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
    const direction = (0, _reactDirection.useDirection)(dir);
    const [currentTabStopId, setCurrentTabStopId] = (0, _reactUseControllableState.useControllableState)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId ?? null,
        onChange: onCurrentTabStopIdChange,
        caller: GROUP_NAME
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = _react.useState(false);
    const handleEntryFocus = (0, _reactUseCallbackRef.useCallbackRef)(onEntryFocus);
    const getItems = useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = _react.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = _react.useState(0);
    _react.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener(ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener(ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation,
        dir: direction,
        loop,
        currentTabStopId,
        onItemFocus: _react.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: _react.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: _react.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: _react.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, _primitive.composeEventHandlers)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, _primitive.composeEventHandlers)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent(ENTRY_FOCUS, EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, _primitive.composeEventHandlers)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var ITEM_NAME = "RovingFocusGroupItem";
var RovingFocusGroupItem = _react.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup, focusable = true, active = false, tabStopId, children, ...itemProps } = props;
    const autoId = (0, _reactId.useId)();
    const id = tabStopId || autoId;
    const context = useRovingFocusContext(ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd, onFocusableItemRemove, currentTabStopId } = context;
    _react.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id,
        focusable,
        active,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactPrimitive.Primitive).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, _primitive.composeEventHandlers)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, _primitive.composeEventHandlers)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, _primitive.composeEventHandlers)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>focusFirst(candidateNodes));
                }
            }),
            children: typeof children === "function" ? children({
                isCurrentTabStop,
                hasTabStop: currentTabStopId != null
            }) : children
        })
    });
});
RovingFocusGroupItem.displayName = ITEM_NAME;
var MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function getFocusIntent(event, orientation, dir) {
    const key = getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return MAP_KEY_TO_FOCUS_INTENT[key];
}
function focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var Root = RovingFocusGroup;
var Item = RovingFocusGroupItem;

},{"react":"4i8qR","@radix-ui/primitive":"8ExnN","@radix-ui/react-collection":"diLUk","@radix-ui/react-compose-refs":"8uudx","@radix-ui/react-context":"4XnVE","@radix-ui/react-id":"2u585","@radix-ui/react-primitive":"hqWvk","@radix-ui/react-use-callback-ref":"4hioM","@radix-ui/react-use-controllable-state":"h0Ybr","@radix-ui/react-direction":"d8jZB","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"diLUk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCollection", ()=>createCollection);
parcelHelpers.export(exports, "unstable_createCollection", ()=>createCollection2);
// src/collection-legacy.tsx
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactContext = require("@radix-ui/react-context");
var _reactComposeRefs = require("@radix-ui/react-compose-refs");
var _reactSlot = require("@radix-ui/react-slot");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function createCollection(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, _reactContext.createContextScope)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope, children } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const itemMap = (0, _reactDefault.default).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionProviderImpl, {
            scope,
            itemMap,
            collectionRef: ref,
            children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, _reactSlot.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, _reactSlot.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children, ...itemData } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, _reactDefault.default).useEffect(()=>{
            context.itemMap.set(ref, {
                ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, _reactDefault.default).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
// src/ordered-dictionary.ts
var __instanciated = /* @__PURE__ */ new WeakMap();
var OrderedDict = class _OrderedDict extends Map {
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        __instanciated.set(this, true);
    }
    set(key, value) {
        if (__instanciated.get(this)) {
            if (this.has(key)) this.#keys[this.#keys.indexOf(key)] = key;
            else this.#keys.push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = this.#keys.length;
        const relativeIndex = toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...this.#keys
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue ?? this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue ?? this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
function toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
function toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
function createCollection2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, _reactContext.createContextScope)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new OrderedDict(),
        setItemMap: ()=>void 0
    });
    const CollectionProvider = ({ state, ...props })=>{
        return state ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionProviderImpl, {
            ...props,
            state
        }) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionInit, {
            ...props
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = (props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionProviderImpl, {
            ...props,
            state
        });
    };
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = (props)=>{
        const { scope, children, state } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const [collectionElement, setCollectionElement] = (0, _reactDefault.default).useState(null);
        const composeRefs = (0, _reactComposeRefs.useComposedRefs)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        (0, _reactDefault.default).useEffect(()=>{
            if (!collectionElement) return;
            const observer = getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionContextProvider, {
            scope,
            itemMap,
            setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement,
            children
        });
    };
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, _reactSlot.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, _reactSlot.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, _reactDefault.default).forwardRef((props, forwardedRef)=>{
        const { scope, children, ...itemData } = props;
        const ref = (0, _reactDefault.default).useRef(null);
        const [element, setElement] = (0, _reactDefault.default).useState(null);
        const composedRefs = (0, _reactComposeRefs.useComposedRefs)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap } = context;
        const itemDataRef = (0, _reactDefault.default).useRef(itemData);
        if (!shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        (0, _reactDefault.default).useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, {
                        ...itemData2,
                        element
                    });
                    return map.toSorted(sortByDocumentPosition);
                }
                return map.set(element, {
                    ...itemData2,
                    element
                }).toSorted(sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return (0, _reactDefault.default).useState(new OrderedDict());
    }
    function useCollection(scope) {
        const { itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    const functions = {
        createCollectionScope,
        useCollection,
        useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
function getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}

},{"react":"4i8qR","@radix-ui/react-context":"4XnVE","@radix-ui/react-compose-refs":"8uudx","@radix-ui/react-slot":"assO6","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"d8jZB":[function(require,module,exports,__globalThis) {
// packages/react/direction/src/direction.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectionProvider", ()=>DirectionProvider);
parcelHelpers.export(exports, "Provider", ()=>Provider);
parcelHelpers.export(exports, "useDirection", ()=>useDirection);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var DirectionContext = _react.createContext(void 0);
var DirectionProvider = (props)=>{
    const { dir, children } = props;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(DirectionContext.Provider, {
        value: dir,
        children
    });
};
function useDirection(localDir) {
    const globalDir = _react.useContext(DirectionContext);
    return localDir || globalDir || "ltr";
}
var Provider = DirectionProvider;

},{"react":"4i8qR","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"2we6D":[function(require,module,exports,__globalThis) {
// packages/react/use-previous/src/use-previous.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePrevious", ()=>usePrevious);
var _react = require("react");
function usePrevious(value) {
    const ref = _react.useRef({
        value,
        previous: value
    });
    return _react.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}

},{"react":"4i8qR","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"ecYTI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryProvider", ()=>QueryProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _reactQuery = require("@tanstack/react-query");
"use client";
const blueskyQueryClient = new (0, _reactQuery.QueryClient)();
function QueryProvider({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactQuery.QueryClientProvider), {
        client: blueskyQueryClient,
        children: children
    });
}

},{"react/jsx-runtime":"fjRB4","@tanstack/react-query":[["QueryClient","7EmnY"],["QueryClientProvider","ixWwS"]],"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"7EmnY":[function(require,module,exports,__globalThis) {
// src/index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HydrationBoundary", ()=>(0, _hydrationBoundaryJs.HydrationBoundary));
parcelHelpers.export(exports, "IsRestoringProvider", ()=>(0, _isRestoringProviderJs.IsRestoringProvider));
parcelHelpers.export(exports, "QueryClientContext", ()=>(0, _queryClientProviderJs.QueryClientContext));
parcelHelpers.export(exports, "QueryClientProvider", ()=>(0, _queryClientProviderJs.QueryClientProvider));
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryJs.QueryErrorResetBoundary));
parcelHelpers.export(exports, "infiniteQueryOptions", ()=>(0, _infiniteQueryOptionsJs.infiniteQueryOptions));
parcelHelpers.export(exports, "mutationOptions", ()=>(0, _mutationOptionsJs.mutationOptions));
parcelHelpers.export(exports, "queryOptions", ()=>(0, _queryOptionsJs.queryOptions));
parcelHelpers.export(exports, "useInfiniteQuery", ()=>(0, _useInfiniteQueryJs.useInfiniteQuery));
parcelHelpers.export(exports, "useIsFetching", ()=>(0, _useIsFetchingJs.useIsFetching));
parcelHelpers.export(exports, "useIsMutating", ()=>(0, _useMutationStateJs.useIsMutating));
parcelHelpers.export(exports, "useIsRestoring", ()=>(0, _isRestoringProviderJs.useIsRestoring));
parcelHelpers.export(exports, "useMutation", ()=>(0, _useMutationJs.useMutation));
parcelHelpers.export(exports, "useMutationState", ()=>(0, _useMutationStateJs.useMutationState));
parcelHelpers.export(exports, "usePrefetchInfiniteQuery", ()=>(0, _usePrefetchInfiniteQueryJs.usePrefetchInfiniteQuery));
parcelHelpers.export(exports, "usePrefetchQuery", ()=>(0, _usePrefetchQueryJs.usePrefetchQuery));
parcelHelpers.export(exports, "useQueries", ()=>(0, _useQueriesJs.useQueries));
parcelHelpers.export(exports, "useQuery", ()=>(0, _useQueryJs.useQuery));
parcelHelpers.export(exports, "useQueryClient", ()=>(0, _queryClientProviderJs.useQueryClient));
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryJs.useQueryErrorResetBoundary));
parcelHelpers.export(exports, "useSuspenseInfiniteQuery", ()=>(0, _useSuspenseInfiniteQueryJs.useSuspenseInfiniteQuery));
parcelHelpers.export(exports, "useSuspenseQueries", ()=>(0, _useSuspenseQueriesJs.useSuspenseQueries));
parcelHelpers.export(exports, "useSuspenseQuery", ()=>(0, _useSuspenseQueryJs.useSuspenseQuery));
var _queryCore = require("@tanstack/query-core");
parcelHelpers.exportAll(_queryCore, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _useQueriesJs = require("./useQueries.js");
var _useQueryJs = require("./useQuery.js");
var _useSuspenseQueryJs = require("./useSuspenseQuery.js");
var _useSuspenseInfiniteQueryJs = require("./useSuspenseInfiniteQuery.js");
var _useSuspenseQueriesJs = require("./useSuspenseQueries.js");
var _usePrefetchQueryJs = require("./usePrefetchQuery.js");
var _usePrefetchInfiniteQueryJs = require("./usePrefetchInfiniteQuery.js");
var _queryOptionsJs = require("./queryOptions.js");
var _infiniteQueryOptionsJs = require("./infiniteQueryOptions.js");
var _queryClientProviderJs = require("./QueryClientProvider.js");
var _hydrationBoundaryJs = require("./HydrationBoundary.js");
var _queryErrorResetBoundaryJs = require("./QueryErrorResetBoundary.js");
var _useIsFetchingJs = require("./useIsFetching.js");
var _useMutationStateJs = require("./useMutationState.js");
var _useMutationJs = require("./useMutation.js");
var _mutationOptionsJs = require("./mutationOptions.js");
var _useInfiniteQueryJs = require("./useInfiniteQuery.js");
var _isRestoringProviderJs = require("./IsRestoringProvider.js");

},{"@tanstack/query-core":"avdW0","./types.js":"1vHCP","./useQueries.js":false,"./useQuery.js":"6wNSF","./useSuspenseQuery.js":false,"./useSuspenseInfiniteQuery.js":false,"./useSuspenseQueries.js":false,"./usePrefetchQuery.js":false,"./usePrefetchInfiniteQuery.js":false,"./queryOptions.js":false,"./infiniteQueryOptions.js":false,"./QueryClientProvider.js":"ixWwS","./HydrationBoundary.js":false,"./QueryErrorResetBoundary.js":false,"./useIsFetching.js":false,"./useMutationState.js":false,"./useMutation.js":false,"./mutationOptions.js":false,"./useInfiniteQuery.js":false,"./IsRestoringProvider.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"avdW0":[function(require,module,exports,__globalThis) {
// src/queryClient.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClient", ()=>QueryClient);
var _utilsJs = require("./utils.js");
var _queryCacheJs = require("./queryCache.js");
var _mutationCacheJs = require("./mutationCache.js");
var _focusManagerJs = require("./focusManager.js");
var _onlineManagerJs = require("./onlineManager.js");
var _notifyManagerJs = require("./notifyManager.js");
var _infiniteQueryBehaviorJs = require("./infiniteQueryBehavior.js");
var QueryClient = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, _queryCacheJs.QueryCache)();
        this.#mutationCache = config.mutationCache || new (0, _mutationCacheJs.MutationCache)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, _focusManagerJs.focusManager).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, _onlineManagerJs.onlineManager).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = this.#queryCache.build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, _utilsJs.resolveStaleTime)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey, state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey
        });
        const query = this.#queryCache.get(defaultedOptions.queryHash);
        const prevData = query?.state.data;
        const data = (0, _utilsJs.functionalUpdate)(updater, prevData);
        if (data === void 0) return void 0;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, _notifyManagerJs.notifyManager).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        return (0, _notifyManagerJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, _notifyManagerJs.notifyManager).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    invalidateQueries(filters, options = {}) {
        return (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters?.refetchType === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: filters?.refetchType ?? filters?.type ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, _notifyManagerJs.notifyManager).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, _utilsJs.noop));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, _utilsJs.noop));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime((0, _utilsJs.resolveStaleTime)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, _infiniteQueryBehaviorJs.infiniteQueryBehavior)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, _infiniteQueryBehaviorJs.infiniteQueryBehavior)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, _onlineManagerJs.onlineManager).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return this.#queryCache;
    }
    getMutationCache() {
        return this.#mutationCache;
    }
    getDefaultOptions() {
        return this.#defaultOptions;
    }
    setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, _utilsJs.hashKey)(queryKey), {
            queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, _utilsJs.partialMatchKey)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, _utilsJs.hashKey)(mutationKey), {
            mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, _utilsJs.partialMatchKey)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, _utilsJs.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, _utilsJs.skipToken)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};

},{"./utils.js":"3hA14","./queryCache.js":"jJ1kw","./mutationCache.js":"glewm","./focusManager.js":"jcD1E","./onlineManager.js":"hc8g4","./notifyManager.js":"aC2BC","./infiniteQueryBehavior.js":"aVXU7","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"jJ1kw":[function(require,module,exports,__globalThis) {
// src/queryCache.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryCache", ()=>QueryCache);
var _utilsJs = require("./utils.js");
var _queryJs = require("./query.js");
var _notifyManagerJs = require("./notifyManager.js");
var _subscribableJs = require("./subscribable.js");
var QueryCache = class extends (0, _subscribableJs.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, _utilsJs.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, _queryJs.Query)({
                client,
                queryKey,
                queryHash,
                options: client.defaultQueryOptions(options),
                state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query
            });
        }
    }
    clear() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, _utilsJs.matchQuery)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, _utilsJs.matchQuery)(filters, query)) : queries;
    }
    notify(event) {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};

},{"./utils.js":"3hA14","./query.js":"e11ao","./notifyManager.js":"aC2BC","./subscribable.js":"cneRW","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"glewm":[function(require,module,exports,__globalThis) {
// src/mutationCache.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationCache", ()=>MutationCache);
var _notifyManagerJs = require("./notifyManager.js");
var _mutationJs = require("./mutation.js");
var _utilsJs = require("./utils.js");
var _subscribableJs = require("./subscribable.js");
var MutationCache = class extends (0, _subscribableJs.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    #mutations;
    #scopes;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, _mutationJs.Mutation)({
            client,
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.#mutations.add(mutation);
        const scope = scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation
        });
    }
    remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation
        });
    }
    canRun(mutation) {
        const scope = scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = this.#scopes.get(scope);
            const firstPendingMutation = mutationsWithSameScope?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused);
            return foundMutation?.continue() ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.#mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation
                });
            });
            this.#mutations.clear();
            this.#scopes.clear();
        });
    }
    getAll() {
        return Array.from(this.#mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, _utilsJs.matchMutation)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, _utilsJs.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, _notifyManagerJs.notifyManager).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, _utilsJs.noop)))));
    }
};
function scopeFor(mutation) {
    return mutation.options.scope?.id;
}

},{"./notifyManager.js":"aC2BC","./mutation.js":"dNh4d","./utils.js":"3hA14","./subscribable.js":"cneRW","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"dNh4d":[function(require,module,exports,__globalThis) {
// src/mutation.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutation", ()=>Mutation);
parcelHelpers.export(exports, "getDefaultState", ()=>getDefaultState);
var _notifyManagerJs = require("./notifyManager.js");
var _removableJs = require("./removable.js");
var _retryerJs = require("./retryer.js");
var Mutation = class extends (0, _removableJs.Removable) {
    #client;
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.#client = config.client;
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || getDefaultState();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        const onContinue = ()=>{
            this.#dispatch({
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: this.#client,
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        this.#retryer = (0, _retryerJs.createRetryer)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount,
                    error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (restored) onContinue();
            else {
                this.#dispatch({
                    type: "pending",
                    variables,
                    isPaused
                });
                if (this.#mutationCache.config.onMutate) await this.#mutationCache.config.onMutate(variables, this, mutationFnContext);
                const context = await this.options.onMutate?.(variables, mutationFnContext);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context,
                    variables,
                    isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this, mutationFnContext);
            await this.options.onSuccess?.(data, variables, this.state.context, mutationFnContext);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this, mutationFnContext);
            await this.options.onSettled?.(data, null, variables, this.state.context, mutationFnContext);
            this.#dispatch({
                type: "success",
                data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onError?.(error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            try {
                await this.options.onSettled?.(void 0, error, variables, this.state.context, mutationFnContext);
            } catch (e) {
                Promise.reject(e);
            }
            this.#dispatch({
                type: "error",
                error
            });
            throw error;
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action
            });
        });
    }
};
function getDefaultState() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}

},{"./notifyManager.js":"aC2BC","./removable.js":"legwp","./retryer.js":"eChHV","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"aVXU7":[function(require,module,exports,__globalThis) {
// src/infiniteQueryBehavior.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasNextPage", ()=>hasNextPage);
parcelHelpers.export(exports, "hasPreviousPage", ()=>hasPreviousPage);
parcelHelpers.export(exports, "infiniteQueryBehavior", ()=>infiniteQueryBehavior);
var _utilsJs = require("./utils.js");
function infiniteQueryBehavior(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, _utilsJs.addConsumeAwareSignal)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, _utilsJs.ensureQueryFn)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages } = context.options;
                    const addTo = previous ? (0, _utilsJs.addToStart) : (0, _utilsJs.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? getPreviousPageParam : getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function getNextPageParam(options, { pages, pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function getPreviousPageParam(options, { pages, pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
function hasNextPage(options, data) {
    if (!data) return false;
    return getNextPageParam(options, data) != null;
}
function hasPreviousPage(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return getPreviousPageParam(options, data) != null;
}

},{"./utils.js":"3hA14","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"1vHCP":[function(require,module,exports,__globalThis) {

},{}]},[], null, "parcelRequireb92d", {})

//# sourceMappingURL=about-that-reader-trick.231411eb.js.map
